export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AccountNumber: { input: any; output: any }
  BigInt: { input: any; output: any }
  Byte: { input: any; output: any }
  CountryCode: { input: any; output: any }
  CountryName: { input: any; output: any }
  Cuid: { input: any; output: any }
  Cuid2: { input: any; output: any }
  Currency: { input: any; output: any }
  DID: { input: any; output: any }
  Date: { input: any; output: any }
  DateTime: { input: any; output: any }
  DateTimeISO: { input: any; output: any }
  DeweyDecimal: { input: any; output: any }
  Duration: { input: any; output: any }
  EmailAddress: { input: any; output: any }
  GUID: { input: any; output: any }
  GeoJSON: { input: any; output: any }
  HSL: { input: any; output: any }
  HSLA: { input: any; output: any }
  HexColorCode: { input: any; output: any }
  Hexadecimal: { input: any; output: any }
  IBAN: { input: any; output: any }
  IP: { input: any; output: any }
  IPCPatent: { input: any; output: any }
  IPv4: { input: any; output: any }
  IPv6: { input: any; output: any }
  ISBN: { input: any; output: any }
  ISO8601Duration: { input: any; output: any }
  JSON: { input: any; output: any }
  JSONObject: { input: any; output: any }
  JWT: { input: any; output: any }
  LCCSubclass: { input: any; output: any }
  Latitude: { input: any; output: any }
  LocalDate: { input: any; output: any }
  LocalDateTime: { input: any; output: any }
  LocalEndTime: { input: any; output: any }
  LocalTime: { input: any; output: any }
  Locale: { input: any; output: any }
  Long: { input: any; output: any }
  Longitude: { input: any; output: any }
  MAC: { input: any; output: any }
  NegativeFloat: { input: any; output: any }
  NegativeInt: { input: any; output: any }
  NonEmptyString: { input: any; output: any }
  NonNegativeFloat: { input: any; output: any }
  NonNegativeInt: { input: any; output: any }
  NonPositiveFloat: { input: any; output: any }
  NonPositiveInt: { input: any; output: any }
  ObjectID: { input: any; output: any }
  PhoneNumber: { input: any; output: any }
  Port: { input: any; output: any }
  PositiveFloat: { input: any; output: any }
  PositiveInt: { input: any; output: any }
  PostalCode: { input: any; output: any }
  RGB: { input: any; output: any }
  RGBA: { input: any; output: any }
  RoutingNumber: { input: any; output: any }
  SESSN: { input: any; output: any }
  SafeInt: { input: any; output: any }
  SemVer: { input: any; output: any }
  Time: { input: any; output: any }
  TimeZone: { input: any; output: any }
  Timestamp: { input: any; output: any }
  ULID: { input: any; output: any }
  URL: { input: any; output: any }
  USCurrency: { input: any; output: any }
  UUID: { input: any; output: any }
  UnsignedFloat: { input: any; output: any }
  UnsignedInt: { input: any; output: any }
  UtcOffset: { input: any; output: any }
  Void: { input: any; output: any }
}

/** A profile within the current user's account, returned by currentAccountProfiles */
export type AccountMemberProfile = {
  __typename?: 'AccountMemberProfile'
  /** The account owner uid */
  accountOwnerUid?: Maybe<Scalars['ID']['output']>
  /** The account owner uuid */
  accountOwnerUuid?: Maybe<Scalars['ID']['output']>
  /** External ID for referencing user billing information */
  billingAccountId?: Maybe<Scalars['String']['output']>
  /** Additional external Number for referencing user billing information */
  billingAccountNumber?: Maybe<Scalars['String']['output']>
  /** Users birthday */
  birthday?: Maybe<Scalars['String']['output']>
  /** Source service from which user was created */
  creationSource?: Maybe<Scalars['String']['output']>
  /** Display name (firstName or username fallback) */
  displayName?: Maybe<Scalars['String']['output']>
  /** The user email */
  email?: Maybe<Scalars['String']['output']>
  /** Indicates email registered in both Gaia and an external system */
  emailRegisteredExternally?: Maybe<Scalars['Boolean']['output']>
  /** First name of the user */
  firstName?: Maybe<Scalars['String']['output']>
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']['output']>
  /** Profile picture URLs matching REST portal endpoint format */
  profilePicture?: Maybe<ProfilePictureUrls>
  /** The status of the user */
  status?: Maybe<Scalars['String']['output']>
  /** The legacy user id */
  uid: Scalars['ID']['output']
  /** UUID for referencing the UserAccount */
  userAccountId?: Maybe<Scalars['ID']['output']>
  /** Federated identity — Brooklyn resolves avatar on this */
  userInfo?: Maybe<UserInfoPublic>
  /** Public username */
  username?: Maybe<Scalars['String']['output']>
  /** The user UUID */
  uuid?: Maybe<Scalars['ID']['output']>
}

export type AdjacentCenter = {
  __typename?: 'AdjacentCenter'
  adjacencyType: Scalars['String']['output']
  centerId: Scalars['Int']['output']
  centerName: Scalars['String']['output']
  sharedContentCount: Scalars['Int']['output']
}

/** Agent Enhancements Hub artifact row (enhancement suggestions and related notes). */
export type AgentEnhancementsHub = {
  __typename?: 'AgentEnhancementsHub'
  agentType: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByUid?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  noteText: Scalars['String']['output']
  payloadJson?: Maybe<Scalars['JSON']['output']>
  recordType: Scalars['String']['output']
  /** Slack display name of the person who logged the suggestion (when available). */
  requestedByName?: Maybe<Scalars['String']['output']>
  slackChannelId?: Maybe<Scalars['String']['output']>
  slackPermalink?: Maybe<Scalars['String']['output']>
  slackThreadTs?: Maybe<Scalars['String']['output']>
  slackUserId?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  updatedByUid?: Maybe<Scalars['Int']['output']>
  userQuery?: Maybe<Scalars['String']['output']>
}

export type AgentEnhancementsHubCreateInput = {
  agentType?: InputMaybe<Scalars['String']['input']>
  noteText: Scalars['String']['input']
  payloadJson?: InputMaybe<Scalars['JSON']['input']>
  recordType: Scalars['String']['input']
  requestedByName?: InputMaybe<Scalars['String']['input']>
  slackChannelId?: InputMaybe<Scalars['String']['input']>
  slackPermalink?: InputMaybe<Scalars['String']['input']>
  slackThreadTs?: InputMaybe<Scalars['String']['input']>
  slackUserId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  userQuery?: InputMaybe<Scalars['String']['input']>
}

export type AgentEnhancementsHubCreateResponse = {
  __typename?: 'AgentEnhancementsHubCreateResponse'
  record: AgentEnhancementsHub
}

export type AgentEnhancementsHubListResponse = {
  __typename?: 'AgentEnhancementsHubListResponse'
  count: Scalars['Int']['output']
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  records: Array<AgentEnhancementsHub>
}

export type AgentEnhancementsHubResolveEnhancementInput = {
  id: Scalars['ID']['input']
  implementationNotes?: InputMaybe<Scalars['String']['input']>
  implementedInVersion?: InputMaybe<Scalars['String']['input']>
  /** Post in the original Slack thread when channel/thread ids exist (default true). */
  notifySlack?: InputMaybe<Scalars['Boolean']['input']>
}

export type AgentEnhancementsHubUpdateInput = {
  id: Scalars['ID']['input']
  noteText?: InputMaybe<Scalars['String']['input']>
  payloadJson?: InputMaybe<Scalars['JSON']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  userQuery?: InputMaybe<Scalars['String']['input']>
}

export type AgentEnhancementsHubUpdateResponse = {
  __typename?: 'AgentEnhancementsHubUpdateResponse'
  record: AgentEnhancementsHub
}

/** Page path and catalog identity for a cited contentLink card. No nested Content federation. */
export type AiGuideChatContentLink = {
  __typename?: 'AiGuideChatContentLink'
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  path?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Document card on the dark AI Guide chat façade (no nested Content federation). */
export type AiGuideChatDocument = {
  __typename?: 'AiGuideChatDocument'
  /** Citation id from the search hit. Omitted on legacy rows that have none. */
  componentId?: Maybe<Scalars['String']['output']>
  /** Allow-listed renderer. This slice emits only contentLink, and only when the card has a content link. */
  componentType?: Maybe<Scalars['String']['output']>
  contentId: Scalars['Int']['output']
  contentLink?: Maybe<AiGuideChatContentLink>
  contentType: Scalars['String']['output']
  /** Catalog id behind the card. Live Oracle and GotS subscriptions in the pinned web commit do not select this. History pair reads do. Map it when present; it is not a live-subscription requirement. */
  documentsId?: Maybe<Scalars['String']['output']>
  /** Page path. Same value as contentLink.path when both are set. */
  path?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Structured error on a chat stream or mutation payload. */
export type AiGuideChatErrorInfo = {
  __typename?: 'AiGuideChatErrorInfo'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

/** Subscription events for aiGuideChat. Event order: start ids, optional statusLabels, chunks/docs, one isFinal. */
export type AiGuideChatEvent = {
  __typename?: 'AiGuideChatEvent'
  /** Persona channel (default or architect), or the stored kind (horoscope, oracle_cards, or tarot) on a workflow turn. A reject after the session loads echoes that stored kind only when the caller owns the row. */
  chatChannel?: Maybe<Scalars['String']['output']>
  chatSessionId?: Maybe<Scalars['ID']['output']>
  documents?: Maybe<Array<AiGuideChatDocument>>
  error?: Maybe<Scalars['String']['output']>
  errorInfo?: Maybe<Array<AiGuideChatErrorInfo>>
  isFinal: Scalars['Boolean']['output']
  messagePairId?: Maybe<Scalars['ID']['output']>
  sessionTitle?: Maybe<Scalars['String']['output']>
  /** User-facing loading phrases (not kit searching/generating). 0–1× before first text/docs when selected. */
  statusLabels?: Maybe<Array<Scalars['String']['output']>>
  success: Scalars['Boolean']['output']
  textChunk?: Maybe<Scalars['String']['output']>
}

export type AiGuideChatInput = {
  /** Omit, null, or empty to infer the persona from personalityId (`2` → default, `1` → architect). Exact horoscope, oracle_cards, and tarot are workflow kinds, not persona channels. member_onboarding and any other string, including a different case, stay unsupported. A persona value that disagrees with personalityId fails closed. */
  chatChannel?: InputMaybe<Scalars['String']['input']>
  /** Continue an existing session. Omit to start a new one. */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  /** The user's message. */
  message: Scalars['String']['input']
  /** Optional stable pair id for retries. Omit to mint a new id returned on the payload. */
  messagePairId?: InputMaybe<Scalars['ID']['input']>
  /** text or voice. Accepted this slice; unused until voice differs from text. */
  mode?: InputMaybe<Scalars['String']['input']>
  /** Legacy compatibility only (`1` Architect+ → channel architect, `2` Sage → channel default). Required until a versioned client drops it. */
  personalityId: Scalars['ID']['input']
  /** Client timezone. Accepted this slice; unused until a channel needs it. */
  timezone?: InputMaybe<Scalars['String']['input']>
}

/** Non-stream mutation payload (Postman / non-subscription clients). */
export type AiGuideChatPayload = {
  __typename?: 'AiGuideChatPayload'
  /** Persona channel (default or architect), or the stored kind (horoscope, oracle_cards, or tarot) on a workflow turn. A reject after the session loads echoes that stored kind only when the caller owns the row. */
  chatChannel?: Maybe<Scalars['String']['output']>
  chatSessionId?: Maybe<Scalars['ID']['output']>
  documents?: Maybe<Array<AiGuideChatDocument>>
  error?: Maybe<Scalars['String']['output']>
  errorInfo?: Maybe<Array<AiGuideChatErrorInfo>>
  messagePairId?: Maybe<Scalars['ID']['output']>
  sessionTitle?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  text?: Maybe<Scalars['String']['output']>
}

export type AlchemizePlaylistInput = {
  /** Content language (affects retrieval and metadata language) */
  language?: InputMaybe<Scalars['String']['input']>
  /** Maximum number of videos to return (default 10, max 15) */
  maxVideos?: InputMaybe<Scalars['Int']['input']>
  /** Free-text prompt describing the desired playlist */
  prompt: Scalars['String']['input']
  /** Target total playlist duration in minutes (optional — LLM will aim for this) */
  targetDurationMinutes?: InputMaybe<Scalars['Int']['input']>
}

export type AlchemizePlaylistResult = {
  __typename?: 'AlchemizePlaylistResult'
  /** Whether the playlist contains practice content (yoga/meditation/fitness) vs non-practice */
  isPractice: Scalars['Boolean']['output']
  /** Editorial narrative describing the playlist (1-2 sentences) */
  narrative?: Maybe<Scalars['String']['output']>
  /** Suggested playlist name (3-8 words, auto-populates name field) */
  suggestedName?: Maybe<Scalars['String']['output']>
  /** Sum of all video durations in seconds */
  totalDurationSeconds: Scalars['Int']['output']
  /** Ordered list of videos forming the playlist */
  videos: Array<AlchemizePlaylistVideo>
}

export type AlchemizePlaylistVideo = {
  __typename?: 'AlchemizePlaylistVideo'
  centers?: Maybe<Array<Scalars['String']['output']>>
  /** Federated Content entity for full resolution (avoid querying nested fields — use flat fields above instead) */
  content?: Maybe<Content>
  /** Content business key (shared across translations) */
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  durationSeconds?: Maybe<Scalars['Int']['output']>
  episodeNumber?: Maybe<Scalars['Int']['output']>
  focus?: Maybe<Scalars['String']['output']>
  genres?: Maybe<Array<Scalars['String']['output']>>
  /** Database primary key — required for Content federation */
  id: Scalars['ID']['output']
  instructor?: Maybe<Scalars['String']['output']>
  level?: Maybe<Scalars['String']['output']>
  path?: Maybe<Scalars['String']['output']>
  seasonNumber?: Maybe<Scalars['Int']['output']>
  seriesTitle?: Maybe<Scalars['String']['output']>
  shortDescription?: Maybe<Scalars['String']['output']>
  style?: Maybe<Scalars['String']['output']>
  thumbnailUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Ambassador lead */
export type AmbassadorLead = {
  __typename?: 'AmbassadorLead'
  /** The ambassador ID */
  ambassadorId?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The ambassador email */
  email: Scalars['String']['output']
  /** When this ambassador lead expires */
  expiresAt: Scalars['DateTime']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** When the postback was sent */
  postbackSentAt?: Maybe<Scalars['DateTime']['output']>
  /** Ambassador ID before Everflow migration */
  preMigrationAmbassadorId?: Maybe<Scalars['Int']['output']>
  /** The ambassador referral ID */
  referralId?: Maybe<Scalars['String']['output']>
  /** The ambassador referral source */
  referralSource?: Maybe<Scalars['String']['output']>
  /** The ambassador referral source ID */
  referralSourceId?: Maybe<Scalars['Int']['output']>
  /** The ambassador tracking data */
  trackingData: Scalars['JSON']['output']
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The associated user info uuid */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The ambassador UTM campaign */
  utmCampaign?: Maybe<Scalars['String']['output']>
  /** The ambassador UTM medium */
  utmMedium?: Maybe<Scalars['String']['output']>
  /** The ambassador UTM source */
  utmSource?: Maybe<Scalars['String']['output']>
  /** The uuid value */
  uuid: Scalars['ID']['output']
}

/** Ambassador lead where created at input type */
export type AmbassadorLeadWhereCreatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ambassador lead where id input type */
export type AmbassadorLeadWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ambassador lead where updated at input type */
export type AmbassadorLeadWhereUpdatedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ambassador lead count response */
export type AmbassadorLeadsCountResponse = {
  __typename?: 'AmbassadorLeadsCountResponse'
  /** The number of rows */
  count: Scalars['Int']['output']
}

/** Ambassador lead list response */
export type AmbassadorLeadsListResponse = {
  __typename?: 'AmbassadorLeadsListResponse'
  /** A list of Ambassador lead */
  ambassadorLeads: Array<AmbassadorLead>
}

export type AmbassadorLeadsS3Input = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>
  /** The primary identifier for the file */
  fileName: Scalars['ID']['input']
}

/** Ambassador lead upload file response */
export type AmbassadorLeadsUploadFileToS3Response = {
  __typename?: 'AmbassadorLeadsUploadFileToS3Response'
  /** Total ambassador leads rows processed */
  ambassadorLeadsProcessed: Scalars['Int']['output']
  /** The max ambassador lead id processed */
  maxAmbassadorLeadIdProcessed: Scalars['Int']['output']
}

/** Ambassador lead where conditions to filter rows */
export type AmbassadorLeadsWhereInput = {
  /** The created at field where clause */
  createdAt?: InputMaybe<AmbassadorLeadWhereCreatedAtInput>
  /** The id field where clause */
  id?: InputMaybe<AmbassadorLeadWhereIdInput>
  /** The updated at field where clause */
  updatedAt?: InputMaybe<AmbassadorLeadWhereUpdatedAtInput>
}

/** API key for machine-to-machine access; maps to a user, roles, and OAuth/API scopes. */
export type ApiKey = {
  __typename?: 'ApiKey'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  enabled: Scalars['Boolean']['output']
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  keyPrefix: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  roleIds: Array<Scalars['Int']['output']>
  scope?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ApiKeyListResponse = {
  __typename?: 'ApiKeyListResponse'
  apiKeys?: Maybe<Array<Maybe<ApiKey>>>
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
}

export type ApiKeyListWhereEnabledInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

export type ApiKeyListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type ApiKeyListWhereInput = {
  enabled?: InputMaybe<ApiKeyListWhereEnabledInput>
  id?: InputMaybe<ApiKeyListWhereIdInput>
  userInfoUuid?: InputMaybe<ApiKeyListWhereUserInfoUuidInput>
}

export type ApiKeyListWhereUserInfoUuidInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Result of create or revoke API key mutations */
export type ApiKeyMutationResponse = {
  __typename?: 'ApiKeyMutationResponse'
  apiKey?: Maybe<ApiKey>
  /** Only set on create — the secret key string shown once */
  plainTextKey?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AppError = {
  __typename?: 'AppError'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type Asset = {
  __typename?: 'Asset'
  /** The asset providers directly linked to this asset */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>
  /** The content asset reference directly linked to this asset */
  contentAssetReference?: Maybe<ContentAssetReference>
  /** Get course item progress for this asset (if it is an asset in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The optional duration of the asset in seconds for assets that have a duration e.g. videos */
  duration?: Maybe<Scalars['Int']['output']>
  /** The hash of the file to allow checking of assets changes without loading the file */
  fileHash?: Maybe<Scalars['String']['output']>
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>
  /** The height of the asset in pixels for assets that have a height */
  height?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * The image linked to the asset (if this asset is associated with an Image record).
   * NOTE: Assets are preferred over Images. This field exists for backward compatibility with the Image type.
   * Use contentAssetReference to access the deterministic relationship to content instead.
   */
  image?: Maybe<Image>
  /** The optional language of asset that was used to create all of the translations (NULL if the file has no language) */
  language?: Maybe<Scalars['String']['output']>
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The URL for the provider when proxing the asset for internal usage (do not use this in an application) */
  providerSourceRenderUrl?: Maybe<Scalars['String']['output']>
  /** The provider to render the asset */
  renderProvider?: Maybe<AssetProviders>
  /**
   * The URL to retrieve and display the asset in an application.
   * This is the most efficient way to get the actual asset file - make an HTTP GET request to this URL.
   * Supports query parameters for dynamic transformations (w, h, fm, q, auto, upscale, cs, genFill).
   * For text tracks, accessing this URL directly via REST is preferred over GraphQL if you only need raw data.
   */
  renderUrl?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The public identifier for this record to be used with external api calls */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The width of the asset in pixels for assets that have a width */
  width?: Maybe<Scalars['Int']['output']>
}

/**
 * Asset represents a file (image, video, document, text track, etc.) that can be associated with content.
 *
 * Conceptually, assets are the actual files stored in cloud storage (AWS S3, ImgIX, Brightcove, etc.)
 * that are referenced by content. Assets can include:
 * - Images (thumbnails, posters, artwork)
 * - Video files
 * - Text tracks (subtitles, closed captions, chapters)
 * - Documents (PDFs, etc.)
 *
 * ASSET vs IMAGE PREFERENCE:
 * Assets are PREFERRED over Images for accessing content-related files. Assets have a deterministic
 * relationship to content through ContentAssetReference, which provides a clear, predictable way to
 * associate files with content. Images exist for backward compatibility but have a non-deterministic
 * relationship to content through ImageContentRelationship, making them less reliable for programmatic access.
 * Always prefer using Assets (via contentAssetReferences) over Images when possible.
 *
 * Important Usage Notes:
 * - To get the actual asset file, use the renderUrl field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve asset data, as it leverages CDN caching and direct
 *   file access rather than going through GraphQL.
 *
 * - The renderUrl supports query parameters for dynamic image transformations:
 *   - w: width (1-7680 pixels)
 *   - h: height (1-4320 pixels)
 *   - fm: format (e.g., "jpg", "png", "webp")
 *   - q: quality (1-100)
 *   - auto: auto optimization
 *   - upscale: allow upscaling (boolean)
 *   - cs: color space (e.g., "strip", "srgb")
 *   - genFill: generate fill for missing image margins (boolean)
 *
 *   Example: renderUrl + "?w=800&h=600&fm=webp&q=85" to get a WebP image at 800x600 with 85% quality.
 *
 * - For text tracks (subtitles, closed captions): If you only need the raw VTT file data, it is
 *   more efficient to access the renderUrl directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata or relationships, but for raw file content,
 *   direct URL access is preferred.
 */
export type AssetCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Asset delete input */
export type AssetDeleteInput = {
  /** The public identifier of the asset to delete */
  uuid: Scalars['ID']['input']
}

/** Asset filter input */
export type AssetFilterInput = {
  /** The asset language */
  language?: InputMaybe<Scalars['String']['input']>
}

/** Asset */
export type AssetProvider = {
  __typename?: 'AssetProvider'
  /** The asset linked to this asset provider */
  asset?: Maybe<Asset>
  /** The the asset linked to this provider */
  assetsId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<AssetProviders>
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The url to render this specific provider asset (in an application it is preferred to use the asset render url) */
  renderUrl?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** AssetProvider where id input */
export type AssetProviderWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** AssetProvider where input */
export type AssetProviderWhereInput = {
  /** AssetProvider where id clause */
  id?: InputMaybe<AssetProviderWhereIdInput>
}

/** Asset providers */
export enum AssetProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The Brightcove assets service */
  BrightcoveImages = 'BRIGHTCOVE_IMAGES',
  /** The ImgIX assets service */
  Imgix = 'IMGIX',
}

/** AssetProviders list response */
export type AssetProvidersListResponse = {
  __typename?: 'AssetProvidersListResponse'
  /** A list of assetProviders */
  assetProviders?: Maybe<Array<Maybe<AssetProvider>>>
}

/** Asset where id input */
export type AssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Asset where input */
export type AssetWhereInput = {
  /** Asset where id clause */
  id?: InputMaybe<AssetWhereIdInput>
  /** Asset where language clause */
  language?: InputMaybe<AssetWhereLanguageInput>
  /** Asset where mimeTypes clause */
  mimeType?: InputMaybe<AssetWhereMimeTypeInput>
  /** Asset where uuid clause */
  uuid?: InputMaybe<AssetWhereUuidInput>
}

/** Asset where language input */
export type AssetWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type AssetWhereMimeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Asset where uuid input */
export type AssetWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Assets list response */
export type AssetsListResponse = {
  __typename?: 'AssetsListResponse'
  /** A list of assets */
  assets?: Maybe<Array<Maybe<Asset>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Result of attaching Brightcove CMS captions to existing Gaia clips for playlist videos */
export type AttachClipCaptionsFromBrightcovePlaylistResponse = {
  __typename?: 'AttachClipCaptionsFromBrightcovePlaylistResponse'
  /** Non-fatal caption/text-track issues (does not increment failureCount) */
  captionWarnings: Array<ClipImportCaptionWarning>
  errors: Array<ClipImportError>
  /** Per-video failures (Brightcove fetch, etc.; matches errors length) */
  failureCount: Scalars['Int']['output']
  /** Playlist videos where an ms_clip existed and caption import ran */
  processedCount: Scalars['Int']['output']
  /** Skips: no Gaia clip for Brightcove video id */
  skipped: Array<ClipImportSkippedRow>
  /** Playlist videos with no Gaia clip for that Brightcove id */
  skippedCount: Scalars['Int']['output']
}

/** Result of attaching Brightcove CMS posters to existing Gaia clips for playlist videos */
export type AttachClipPostersFromBrightcovePlaylistResponse = {
  __typename?: 'AttachClipPostersFromBrightcovePlaylistResponse'
  errors: Array<ClipImportError>
  /** Per-video failures (Brightcove fetch, etc.; matches errors length) */
  failureCount: Scalars['Int']['output']
  /** Non-fatal poster/image issues (does not increment failureCount) */
  imageWarnings: Array<ClipImportImageWarning>
  /** Playlist videos where an ms_clip existed and poster import ran */
  processedCount: Scalars['Int']['output']
  /** Skips: no Gaia clip for Brightcove video id */
  skipped: Array<ClipImportSkippedRow>
  /** Playlist videos with no Gaia clip for that Brightcove id */
  skippedCount: Scalars['Int']['output']
}

/** Audit Category Type */
export enum AuditCategoryType {
  /** Ambassador */
  Ambassador = 'ambassador',
  /** Billing */
  Billing = 'billing',
  /** User */
  User = 'user',
}

/** Audit Field Name */
export enum AuditFieldName {
  AccountOwnerChange = 'ACCOUNT_OWNER_CHANGE',
  AnonymizeUser = 'ANONYMIZE_USER',
  Active = 'Active',
  BusinessName = 'BusinessName',
  Cancel = 'CANCEL',
  Chargeback = 'CHARGEBACK',
  Comp = 'COMP',
  CurrencyChange = 'CURRENCY_CHANGE',
  ContactEmail = 'ContactEmail',
  ContactName = 'ContactName',
  Created = 'Created',
  EmailChange = 'EMAIL_CHANGE',
  EntitlementAdded = 'ENTITLEMENT_ADDED',
  EntitlementChange = 'ENTITLEMENT_CHANGE',
  EntitlementRemoved = 'ENTITLEMENT_REMOVED',
  EverflowAffiliateId = 'EverflowAffiliateId',
  GiftPurchase = 'GIFT_PURCHASE',
  GiftRedemption = 'GIFT_REDEMPTION',
  Hold = 'HOLD',
  LeadExpirationOverrideDays = 'LeadExpirationOverrideDays',
  NameChangeFirst = 'NAME_CHANGE_FIRST',
  NameChangeLast = 'NAME_CHANGE_LAST',
  PasswordChange = 'PASSWORD_CHANGE',
  PlanChange = 'PLAN_CHANGE',
  PostalCodeChange = 'POSTAL_CODE_CHANGE',
  PostalCodeCleanup = 'POSTAL_CODE_CLEANUP',
  ProfileAdd = 'PROFILE_ADD',
  ProfileDelete = 'PROFILE_DELETE',
  Parent = 'Parent',
  PayoutCurrency = 'PayoutCurrency',
  Processed = 'Processed',
  Reactivation = 'REACTIVATION',
  Refund = 'REFUND',
  RefundCancel = 'REFUND_CANCEL',
  RefundDowngrade = 'REFUND_DOWNGRADE',
  RemovePaymentMethods = 'REMOVE_PAYMENT_METHODS',
  Resume = 'RESUME',
  Relationship = 'Relationship',
  RelationshipOwner = 'RelationshipOwner',
  ResidenceCountry = 'ResidenceCountry',
  Ripple1Percentage = 'Ripple1Percentage',
  Ripple2Percentage = 'Ripple2Percentage',
  Signup = 'SIGNUP',
  StatusChange = 'STATUS_CHANGE',
  StartedAt = 'StartedAt',
  UpdateBillingAddress = 'UPDATE_BILLING_ADDRESS',
  UpdatePaymentMethod = 'UPDATE_PAYMENT_METHOD',
  UsernameChange = 'USERNAME_CHANGE',
  UserSubscriptionImport = 'USER_SUBSCRIPTION_IMPORT',
}

/** Auth role */
export type AuthRole = {
  __typename?: 'AuthRole'
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: Maybe<Scalars['Int']['output']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description of the role */
  description?: Maybe<Scalars['String']['output']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: Maybe<Scalars['Int']['output']>
  /** The name of the role */
  name: Scalars['String']['output']
  /** The primary key */
  role: Scalars['ID']['output']
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user roles associated with this record */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
}

/** Auth role */
export type AuthRoleUserRolesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Input type for creating a new auth role */
export type AuthRoleCreateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The description of the role */
  description?: InputMaybe<Scalars['String']['input']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']['input']>
  /** The name of the role */
  name: Scalars['String']['input']
  /** The primary key (optional) */
  role?: InputMaybe<Scalars['ID']['input']>
}

/** Input type for deleting an existing auth role */
export type AuthRoleDeleteInput = {
  /** The primary key of the auth role to delete */
  role: Scalars['ID']['input']
}

/** Auth role list response */
export type AuthRoleListResponse = {
  __typename?: 'AuthRoleListResponse'
  /** A list of userInfo reference */
  authRoles?: Maybe<Array<Maybe<AuthRole>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Auth role where conditions to filter rows */
export type AuthRoleListWhereInput = {
  /** The name field where clause */
  name?: InputMaybe<AuthRoleListWhereNameInput>
  /** The role field where clause */
  role?: InputMaybe<AuthRoleListWhereRoleInput>
}

/** Auth role name where input type */
export type AuthRoleListWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Auth role id where input type */
export type AuthRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Response object containing a boolean property of success and the created/deleted auth role */
export type AuthRoleMutationResponse = {
  __typename?: 'AuthRoleMutationResponse'
  /** The created or deleted auth role */
  authRole?: Maybe<AuthRole>
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean']['output']
}

/** Input type for updating an existing auth role */
export type AuthRoleUpdateInput = {
  /** The time in milliseconds where expired authentication will still be considered valid and renewed for users with this role, null is infinity (optional) */
  authenticationExpiredValidMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The time in milliseconds where authentication should expire for users with this role, null is infinity (optional) */
  authenticationExpiresMilliseconds?: InputMaybe<Scalars['Int']['input']>
  /** The description of the role (optional) */
  description?: InputMaybe<Scalars['String']['input']>
  /** The maximum allowed failed login attempt for users with this role, null is infinity (optional) */
  maxFailedLoginAttempts?: InputMaybe<Scalars['Int']['input']>
  /** The name of the role */
  name?: InputMaybe<Scalars['String']['input']>
  /** The primary key of the auth role to update */
  role: Scalars['ID']['input']
}

/** Registered OAuth scope (gaia:resource:action) */
export type AuthScope = {
  __typename?: 'AuthScope'
  /** Created at */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Description */
  description?: Maybe<Scalars['String']['output']>
  /** Primary key */
  id: Scalars['ID']['output']
  /** Scope token */
  name: Scalars['String']['output']
  /** Updated at */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Result of checking scope strings against OIDC built-ins and the auth_scope registry (same rules as OAuth2 authorize/token). */
export type AuthScopeCheckResponse = {
  __typename?: 'AuthScopeCheckResponse'
  /** Invalid tokens in first-seen order; duplicates appear once. */
  invalidScopes: Array<Scalars['String']['output']>
  /** True when every parsed token is valid (no invalid scopes). */
  success: Scalars['Boolean']['output']
  /** Valid tokens in first-seen order (OIDC built-in or registered gaia: name); duplicates appear once. */
  validScopes: Array<Scalars['String']['output']>
}

export type AuthScopeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type AuthScopeDeleteInput = {
  id: Scalars['ID']['input']
}

export type AuthScopeListResponse = {
  __typename?: 'AuthScopeListResponse'
  authScopes?: Maybe<Array<Maybe<AuthScope>>>
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
}

export type AuthScopeListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  lt?: InputMaybe<Scalars['ID']['input']>
  lte?: InputMaybe<Scalars['ID']['input']>
}

export type AuthScopeListWhereInput = {
  id?: InputMaybe<AuthScopeListWhereIdInput>
  name?: InputMaybe<AuthScopeListWhereNameInput>
}

export type AuthScopeListWhereNameInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AuthScopeMutationResponse = {
  __typename?: 'AuthScopeMutationResponse'
  authScope?: Maybe<AuthScope>
  success: Scalars['Boolean']['output']
}

export type AuthScopeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

/** Payload aligned with GET /v1/authentication/check `payload` (uid, roles, JWT scope tokens, …). */
export type AuthenticationCheckPayload = {
  __typename?: 'AuthenticationCheckPayload'
  audience?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  authType?: Maybe<Scalars['String']['output']>
  authenticationGroupId: Scalars['Int']['output']
  clientAttributes: Array<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  grantType?: Maybe<Scalars['String']['output']>
  issuer?: Maybe<Scalars['String']['output']>
  jti?: Maybe<Scalars['String']['output']>
  jwt?: Maybe<Scalars['String']['output']>
  privateKeyId?: Maybe<Scalars['String']['output']>
  roles: Array<Scalars['Int']['output']>
  scopes: Array<Scalars['String']['output']>
  sub?: Maybe<Scalars['String']['output']>
  subscriptions: Array<Scalars['Int']['output']>
  uid: Scalars['Int']['output']
  userAccountAuthenticationGroupId: Scalars['Int']['output']
  userAccountId: Scalars['String']['output']
  uuid: Scalars['String']['output']
}

/** Response from requesting a banner image upload */
export type BannerImageUploadRequest = {
  __typename?: 'BannerImageUploadRequest'
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output']
  /** UUID for the pending image */
  imageUuid: Scalars['ID']['output']
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String']['output']
}

/** Response from confirming a banner image upload */
export type BannerImageUploadResponse = {
  __typename?: 'BannerImageUploadResponse'
  /** The banner image URL */
  bannerImage?: Maybe<ProfileBannerImage>
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean']['output']
}

/** Billing Account */
export type BillingAccount = {
  __typename?: 'BillingAccount'
  /** Whether this account has been closed */
  accountClosed?: Maybe<Scalars['Boolean']['output']>
  /** Billing Provider associated with this Billing Account */
  billingProvider?: Maybe<BillingProvider>
  /** The billing provider ID of the billing account */
  billingProviderId?: Maybe<Scalars['Int']['output']>
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: Maybe<Scalars['Date']['output']>
  /** The country for the billing account */
  country?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The currency for the billing account */
  currency?: Maybe<Scalars['String']['output']>
  /** The id of the billing account */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: Maybe<Scalars['Boolean']['output']>
  /** The postal code for the billing account */
  postalCode?: Maybe<Scalars['String']['output']>
  /** Whether this is the primary billing account for the user */
  primaryAccount?: Maybe<Scalars['Boolean']['output']>
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: Maybe<Scalars['String']['output']>
  /** The billing provider's account ID for the billing account */
  providerAccountId?: Maybe<Scalars['String']['output']>
  /** The state for the billing account */
  state?: Maybe<Scalars['String']['output']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: Maybe<Scalars['String']['output']>
  /** When the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User associated with this Billing Account */
  userInfo?: Maybe<UserInfo>
  /** The User UUID of the billing account */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The UUID of the billing account */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Account create input type */
export type BillingAccountCreateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider ID of the billing account */
  billingProviderId: Scalars['Int']['input']
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']['input']>
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']['input']>
  /** The currency for the billing account */
  currency: Scalars['String']['input']
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']['input']>
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']['input']>
  /** Whether this is the primary billing account for the user */
  primaryAccount: Scalars['Boolean']['input']
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']['input']>
  /** The billing provider's account ID for the billing account */
  providerAccountId: Scalars['String']['input']
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']['input']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** The User UUID of the billing account */
  userInfoUuid: Scalars['ID']['input']
  /** The UUID of the billing account */
  uuid?: InputMaybe<Scalars['ID']['input']>
}

/** Billing Account list response */
export type BillingAccountListResponse = {
  __typename?: 'BillingAccountListResponse'
  /** A list of billing account reference */
  billingAccounts?: Maybe<Array<Maybe<BillingAccount>>>
}

/** Billing Account list where Boolean input type */
export type BillingAccountListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Account list where Date input type */
export type BillingAccountListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Account list where ID input type */
export type BillingAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Account list where input type */
export type BillingAccountListWhereInput = {
  /** The billing account accountClosed field where clause */
  accountClosed?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingAccountListWhereIntInput>
  /** The billing account cancelOfferAcceptedDate field where clause */
  cancelOfferAcceptedDate?: InputMaybe<BillingAccountListWhereDateInput>
  /** The billing account country field where clause */
  country?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account createdAt field where clause */
  createdAt?: InputMaybe<BillingAccountListWhereDateInput>
  /** The billing account currency field where clause */
  currency?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account id field where clause */
  id?: InputMaybe<BillingAccountListWhereIdInput>
  /** The billing account initialAuthSuccess field where clause */
  initialAuthSuccess?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account postalCode field where clause */
  postalCode?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account primaryAccount field where clause */
  primaryAccount?: InputMaybe<BillingAccountListWhereBooleanInput>
  /** The billing account providerAccountAltId field where clause */
  providerAccountAltId?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account providerAccountId field where clause */
  providerAccountId?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account state field where clause */
  state?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<BillingAccountListWhereStringInput>
  /** The billing account uuid field where clause */
  uuid?: InputMaybe<BillingAccountListWhereStringInput>
}

/** Billing Account list where Int input type */
export type BillingAccountListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Account list where String input type */
export type BillingAccountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Account update input type */
export type BillingAccountUpdateInput = {
  /** Whether this account has been closed */
  accountClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider ID of the billing account */
  billingProviderId?: InputMaybe<Scalars['Int']['input']>
  /** The date the user accepted the cancel offer */
  cancelOfferAcceptedDate?: InputMaybe<Scalars['Date']['input']>
  /** The country for the billing account */
  country?: InputMaybe<Scalars['String']['input']>
  /** The currency for the billing account */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing account */
  id: Scalars['ID']['input']
  /** Whether the initial authorization was successful */
  initialAuthSuccess?: InputMaybe<Scalars['Boolean']['input']>
  /** The postal code for the billing account */
  postalCode?: InputMaybe<Scalars['String']['input']>
  /** Whether this is the primary billing account for the user */
  primaryAccount?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing provider's account alternate ID for the billing account (Zuora only) */
  providerAccountAltId?: InputMaybe<Scalars['String']['input']>
  /** The billing provider's account ID for the billing account */
  providerAccountId?: InputMaybe<Scalars['String']['input']>
  /** The state for the billing account */
  state?: InputMaybe<Scalars['String']['input']>
  /** The tax jurisdiction code for the billing account (Avalara PCode) */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** The User UUID of the billing account */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

export type BillingCheckoutAttributionMetricsResponse = {
  __typename?: 'BillingCheckoutAttributionMetricsResponse'
  paramNames: Array<Scalars['String']['output']>
  rows: Array<Maybe<BillingCheckoutAttributionMetricsRow>>
}

export type BillingCheckoutAttributionMetricsRow = {
  __typename?: 'BillingCheckoutAttributionMetricsRow'
  abandonedCheckoutCount: Scalars['Int']['output']
  checkoutCount: Scalars['Int']['output']
  distinctUserCount: Scalars['Int']['output']
  paramName: Scalars['String']['output']
  paramValue: Scalars['String']['output']
  successfulCheckoutCount: Scalars['Int']['output']
}

export type BillingCheckoutAttributionMetricsWhereInput = {
  /** Days after SIGNUP txn_date to look for paid RENEWAL (default TRIAL_TO_PAID_DEFAULT_WINDOW_DAYS) */
  conversionWindowDays?: InputMaybe<Scalars['Int']['input']>
  /** Inclusive start of checkout created_at window */
  createdAtFrom: Scalars['DateTime']['input']
  /** Exclusive end of checkout created_at window */
  createdAtTo: Scalars['DateTime']['input']
  /** Allowlisted groupBy name. Keep in sync with TRIAL_TO_PAID_GROUP_BY_NAMES. */
  groupBy: CheckoutAttributionMetricsGroupBy
  /** Optional restriction of grouped param values */
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>
}

/**
 * Checkout request row (GraphQL type name aligned with BILLING_CHECKOUT_REQUEST_EVENT).
 * Marketing-safe subset; does not expose attribution_tracking JSON or payment tokens.
 */
export type BillingCheckoutRequest = {
  __typename?: 'BillingCheckoutRequest'
  /** Allowlisted tracking params stored for this checkout. */
  attributionParams?: Maybe<Array<Maybe<BillingCheckoutRequestAttributionParam>>>
  /** When attribution params were last written by the worker */
  attributionParamsProcessedAt?: Maybe<Scalars['DateTime']['output']>
  /** Bounded skip/parse outcome when params were not stored. Keep in sync with CHECKOUT_ATTRIBUTION_SKIP_REASONS. */
  attributionParamsSkipReason?: Maybe<CheckoutAttributionSkipReason>
  /** Checkout country */
  country: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Checkout currency */
  currency?: Maybe<Scalars['String']['output']>
  /** Discount code */
  discountCode?: Maybe<Scalars['String']['output']>
  /** Whether checkout processing finished */
  done: Scalars['Boolean']['output']
  /** Email opt-in flag */
  emailOptIn?: Maybe<Scalars['Boolean']['output']>
  /** Primary identifier */
  id: Scalars['ID']['output']
  /** Country inferred from IP */
  ipCountry: Scalars['String']['output']
  /** Currency inferred from IP */
  ipCurrency: Scalars['String']['output']
  /** Product rate plan id */
  planId: Scalars['String']['output']
  /** Plan SKU */
  planSku?: Maybe<Scalars['String']['output']>
  /** Promo code */
  promoCode?: Maybe<Scalars['String']['output']>
  /** Whether the checkout completed successfully */
  success?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Owner user (association stub: uuid) */
  userInfo?: Maybe<UserInfo>
  /** UserInfo.uuid of the checkout owner */
  userInfoUuid: Scalars['ID']['output']
  /** Request UUID */
  uuid: Scalars['ID']['output']
}

/** Normalized marketing tracking name/value from a checkout request `attribution_tracking` query string. */
export type BillingCheckoutRequestAttributionParam = {
  __typename?: 'BillingCheckoutRequestAttributionParam'
  /** Parent checkout (association stub: id) */
  billingCheckoutRequest?: Maybe<BillingCheckoutRequest>
  /** Parent checkout request id */
  billingCheckoutRequestId: Scalars['ID']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Allowlisted tracking parameter name (MicrosoftClickId stored as msclkid) */
  name: Scalars['String']['output']
  /** Parser attempt that produced this pair */
  parseOutcome: CheckoutAttributionParseOutcome
  /** Value before scalar decode */
  rawValue: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Checkout owner (association stub: uuid) */
  userInfo?: Maybe<UserInfo>
  /** Stable GraphQL id */
  uuid: Scalars['ID']['output']
  /** Normalized scalar value */
  value: Scalars['String']['output']
}

export type BillingCheckoutRequestAttributionParamCreateInput = {
  /** Parent checkout request id */
  billingCheckoutRequestId: Scalars['ID']['input']
  /** Allowlisted tracking parameter name */
  name: Scalars['String']['input']
  /** Parser attempt that produced this pair */
  parseOutcome?: InputMaybe<CheckoutAttributionParseOutcome>
  /** Value before scalar decode */
  rawValue?: InputMaybe<Scalars['String']['input']>
  /** Normalized scalar value */
  value: Scalars['String']['input']
}

export type BillingCheckoutRequestAttributionParamDeleteInput = {
  /** Stable GraphQL id of the param row to delete */
  uuid: Scalars['ID']['input']
}

export type BillingCheckoutRequestAttributionParamListResponse = {
  __typename?: 'BillingCheckoutRequestAttributionParamListResponse'
  /** Total matching rows (when requested) */
  count?: Maybe<Scalars['Int']['output']>
  /** Page size used for the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** Page offset used for the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** Matching param rows for this page */
  params?: Maybe<Array<Maybe<BillingCheckoutRequestAttributionParam>>>
}

export type BillingCheckoutRequestAttributionParamListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingCheckoutRequestAttributionParamListWhereInput = {
  /** Filter by parent checkout request id */
  billingCheckoutRequestId?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereIdInput>
  /** Filter by allowlisted param name */
  name?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereNameInput>
  /** Filter by checkout owner UserInfo.uuid */
  userInfoUuid?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereUuidInput>
  /** Filter by param uuid */
  uuid?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereUuidInput>
  /** Filter by normalized value */
  value?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereValueInput>
}

export type BillingCheckoutRequestAttributionParamListWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type BillingCheckoutRequestAttributionParamListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingCheckoutRequestAttributionParamListWhereValueInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type BillingCheckoutRequestAttributionParamMutationResponse = {
  __typename?: 'BillingCheckoutRequestAttributionParamMutationResponse'
  param?: Maybe<BillingCheckoutRequestAttributionParam>
  success: Scalars['Boolean']['output']
}

export type BillingCheckoutRequestAttributionParamUpdateInput = {
  /** Value before scalar decode */
  rawValue?: InputMaybe<Scalars['String']['input']>
  /** Stable GraphQL id of the param row */
  uuid: Scalars['ID']['input']
  /** Normalized scalar value */
  value?: InputMaybe<Scalars['String']['input']>
}

export type BillingCheckoutRequestListResponse = {
  __typename?: 'BillingCheckoutRequestListResponse'
  /** Total matching rows (when requested) */
  count?: Maybe<Scalars['Int']['output']>
  /** Page size used for the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** Page offset used for the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** Matching checkout rows for this page */
  requests?: Maybe<Array<Maybe<BillingCheckoutRequest>>>
}

export type BillingCheckoutRequestListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

export type BillingCheckoutRequestListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type BillingCheckoutRequestListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingCheckoutRequestListWhereInput = {
  /** The attribution skip reason field where clause */
  attributionParamsSkipReason?: InputMaybe<BillingCheckoutRequestListWhereSkipReasonInput>
  /** The checkout country field where clause */
  country?: InputMaybe<BillingCheckoutRequestListWhereStringInput>
  /** The checkout createdAt field where clause */
  createdAt?: InputMaybe<BillingCheckoutRequestListWhereDateInput>
  /** The checkout currency field where clause */
  currency?: InputMaybe<BillingCheckoutRequestListWhereStringInput>
  /** The checkout done field where clause */
  done?: InputMaybe<BillingCheckoutRequestListWhereBooleanInput>
  /** The checkout id field where clause */
  id?: InputMaybe<BillingCheckoutRequestListWhereIdInput>
  /** The checkout planId field where clause */
  planId?: InputMaybe<BillingCheckoutRequestListWhereStringInput>
  /** The checkout planSku field where clause */
  planSku?: InputMaybe<BillingCheckoutRequestListWhereStringInput>
  /** The checkout success field where clause */
  success?: InputMaybe<BillingCheckoutRequestListWhereBooleanInput>
  /** The checkout owner UserInfo.uuid where clause */
  userInfoUuid?: InputMaybe<BillingCheckoutRequestListWhereUuidInput>
  /** The checkout uuid field where clause */
  uuid?: InputMaybe<BillingCheckoutRequestListWhereUuidInput>
}

export type BillingCheckoutRequestListWhereSkipReasonInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<CheckoutAttributionSkipReason>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<CheckoutAttributionSkipReason>>>
}

export type BillingCheckoutRequestListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type BillingCheckoutRequestListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingCheckoutTrialToPaidMetricsResponse = {
  __typename?: 'BillingCheckoutTrialToPaidMetricsResponse'
  rows: Array<Maybe<BillingCheckoutTrialToPaidMetricsRow>>
}

/**
 * Trial-to-paid funnel for successful checkouts only.
 *
 * Conversion is computed at read time from `events`:
 * - SIGNUP is the start event only (`is_trial_period` true/false). SIGNUP is never a paid event.
 * - Paid is always the first RENEWAL with amount > 0 and `is_trial_period = false`
 *   within `conversionWindowDays` (default 30) of that SIGNUP `txn_date`.
 *
 * Bucket meanings: see enum CheckoutTrialToPaidBucket.
 */
export type BillingCheckoutTrialToPaidMetricsRow = {
  __typename?: 'BillingCheckoutTrialToPaidMetricsRow'
  /** Successful attributed checkouts in the group */
  checkoutCount: Scalars['Int']['output']
  currency?: Maybe<Scalars['String']['output']>
  /** Non-trial SIGNUP + paid RENEWAL in window (CheckoutTrialToPaidBucket.direct_paid) */
  directPaidCount: Scalars['Int']['output']
  distinctUserCount: Scalars['Int']['output']
  /** Sum of first paid RENEWAL amounts for trial_to_paid and direct_paid */
  firstPaidAmountSum: Scalars['Float']['output']
  paramName: Scalars['String']['output']
  paramValue: Scalars['String']['output']
  rebillAmountSum: Scalars['Float']['output']
  rebillCount: Scalars['Int']['output']
  refundAmountSum: Scalars['Float']['output']
  refundCount: Scalars['Int']['output']
  /** Trial SIGNUP, window still open, no paid RENEWAL (CheckoutTrialToPaidBucket.still_in_trial) */
  stillInTrialCount: Scalars['Int']['output']
  /** Trial SIGNUP, window closed, no paid RENEWAL (CheckoutTrialToPaidBucket.trial_expired_without_paid) */
  trialExpiredWithoutPaidCount: Scalars['Int']['output']
  /** Checkouts whose first SIGNUP has is_trial_period = true (trial_to_paid / still_in_trial / trial_expired_without_paid) */
  trialStartCount: Scalars['Int']['output']
  /** Trial SIGNUP + paid RENEWAL in window (CheckoutTrialToPaidBucket.trial_to_paid) */
  trialToPaidCount: Scalars['Int']['output']
}

/** Billing discount */
export type BillingDiscount = {
  __typename?: 'BillingDiscount'
  /** Whether the discount is allowed for plan changes */
  allowedForPlanChange: Scalars['Boolean']['output']
  /** The amount discount (currency code to amount) */
  amountDiscount?: Maybe<Scalars['JSON']['output']>
  /** The global redemption cap for the discount */
  availableCount?: Maybe<Scalars['Int']['output']>
  /** The number of billing cycles the discount applied to (including trial segment) */
  billingCycles?: Maybe<Scalars['Int']['output']>
  /** Parent bulk create batch id when this discount was created via createBulkBillingDiscount */
  billingDiscountBulkId?: Maybe<Scalars['ID']['output']>
  /** The discount code */
  code: Scalars['String']['output']
  /** Defines the countries the discount is limited to (could be an inclusion or exclusion list) */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The countries operator - whether the countries list is an inclusion or exclusion list */
  countriesOperator?: Maybe<InNotInOperator>
  /** The creation date */
  createdAt: Scalars['DateTime']['output']
  /** Defines the currencies the discount is limited to (could be an inclusion or exclusion list) */
  currencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The currencies operator - whether the currencies list is an inclusion or exclusion list */
  currenciesOperator?: Maybe<InNotInOperator>
  /** Human-readable description for admins */
  description?: Maybe<Scalars['String']['output']>
  /** Defines the ecommerce SKUs the discount is limited to via the plan SKU. THe plan must be tied to a bonus in this list (could be an inclusion or exclusion list) */
  ecommerceSkus?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The ecommerce SKUs operator - whether the ecommerce SKUs list is an inclusion or exclusion list */
  ecommerceSkusOperator?: Maybe<InNotInOperator>
  /** Whether the discount is enabled */
  enabled: Scalars['Boolean']['output']
  /** When the discount becomes unavailable (optional) */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** True when this discount was created from a gift card conversion */
  giftCardConversion: Scalars['Boolean']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Defines the languages the discount is limited to (could be an inclusion or exclusion list) */
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The languages operator - whether the languages list is an inclusion or exclusion list */
  languagesOperator?: Maybe<InNotInOperator>
  /** Lifetime value threshold in USD */
  lifetimeValue?: Maybe<Scalars['Float']['output']>
  /** The operator used to compare user lifetime value with lifetimeValue */
  lifetimeValueOperator?: Maybe<PlanEligibilityNumericOperator>
  /** Defines the minimum plan recurring price per currency (ISO 4217 code to amount) */
  minimumPrice?: Maybe<Scalars['JSON']['output']>
  /** Minimum plan trial segment price per currency (ISO 4217 code to amount) */
  minimumTrialSegmentPrice?: Maybe<Scalars['JSON']['output']>
  /** The percentage discount */
  percentageDiscount?: Maybe<Scalars['Float']['output']>
  /** Defines the plan categories the discount is limited to (could be an inclusion or exclusion list) */
  planCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan categories operator - whether the plan categories list is an inclusion or exclusion list */
  planCategoriesOperator?: Maybe<InNotInOperator>
  /** When set, discount applies only to plans whose billing product belongs to this platform */
  platform?: Maybe<ProductPlatform>
  /** The number of redemptions for the discount */
  redemptionCount: Scalars['Int']['output']
  /** The number of redemptions per user */
  redemptionsPerUser: Scalars['Int']['output']
  /** An optional number of months to limit the user redemption count to */
  redemptionsPerUserMonths?: Maybe<Scalars['Int']['output']>
  /** Defines the SKUs the discount is limited to (could be an inclusion or exclusion list) */
  skus?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The SKUs operator - whether the SKUs list is an inclusion or exclusion list */
  skusOperator?: Maybe<InNotInOperator>
  /** When the discount becomes available (optional) */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The discount matches when the user's tenure satisfies this rule */
  tenure?: Maybe<Scalars['Int']['output']>
  /** The operator used to compare user tenure with tenure */
  tenureOperator?: Maybe<PlanEligibilityNumericOperator>
  /** When set, only these user_info.uid values may redeem the discount (other eligibility rules still apply) */
  uids?: Maybe<Array<Maybe<Scalars['BigInt']['output']>>>
  /** The update date */
  updatedAt: Scalars['DateTime']['output']
}

/** A bulk create batch of billing discount codes */
export type BillingDiscountBulk = {
  __typename?: 'BillingDiscountBulk'
  /** Length of each generated discount code */
  codeLength: Scalars['Int']['output']
  /** Discount codes created in this batch */
  codes: Array<Scalars['String']['output']>
  /** The creation date */
  createdAt: Scalars['DateTime']['output']
  /** Human-readable batch label for admins */
  description?: Maybe<Scalars['String']['output']>
  /** Billing discounts created in this batch */
  discounts: Array<BillingDiscount>
  /** Number of discount codes created */
  discountsCreated: Scalars['Int']['output']
  /** Any errors that occurred during bulk creation */
  errors?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Number of discount codes requested */
  quantity: Scalars['Int']['output']
  /** Whether all discount codes were created successfully */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The update date */
  updatedAt: Scalars['DateTime']['output']
  /** Stable external UUID for the bulk create batch */
  uuid: Scalars['ID']['output']
}

/** Discount eligibility check error */
export enum BillingDiscountEligibilityErrorCode {
  /** Country mismatch */
  CountryMismatch = 'COUNTRY_MISMATCH',
  /** Currency mismatch */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** Discount disabled */
  DiscountDisabled = 'DISCOUNT_DISABLED',
  /** Discount exhausted */
  DiscountExhausted = 'DISCOUNT_EXHAUSTED',
  /** Discount inactive */
  DiscountInactive = 'DISCOUNT_INACTIVE',
  /** Discount not found */
  DiscountNotFound = 'DISCOUNT_NOT_FOUND',
  /** Ecommerce SKU mismatch */
  EcommerceSkuMismatch = 'ECOMMERCE_SKU_MISMATCH',
  /** Language mismatch */
  LanguageMismatch = 'LANGUAGE_MISMATCH',
  /** User lifetime value does not satisfy the discount restriction */
  LifetimeValueMismatch = 'LIFETIME_VALUE_MISMATCH',
  /** Plan category mismatch */
  PlanCategoryMismatch = 'PLAN_CATEGORY_MISMATCH',
  /** Plan change not allowed */
  PlanChangeNotAllowed = 'PLAN_CHANGE_NOT_ALLOWED',
  /** Plan not found */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** Plan recurring price is below the discount minimum for this currency */
  PlanPriceMinimumNotMet = 'PLAN_PRICE_MINIMUM_NOT_MET',
  /** Plan pricing row not found for request currency */
  PlanPricingNotFound = 'PLAN_PRICING_NOT_FOUND',
  /** Plan trial segment price is below the discount minimum for this currency */
  PlanTrialSegmentPriceMinimumNotMet = 'PLAN_TRIAL_SEGMENT_PRICE_MINIMUM_NOT_MET',
  /** Plan billing product platform does not match discount platform restriction */
  PlatformMismatch = 'PLATFORM_MISMATCH',
  /** Redemption limit exceeded */
  RedemptionLimitExceeded = 'REDEMPTION_LIMIT_EXCEEDED',
  /** SKU mismatch */
  SkuMismatch = 'SKU_MISMATCH',
  /** User tenure does not satisfy the discount restriction */
  TenureMismatch = 'TENURE_MISMATCH',
  /** Signed-in user is not in the discount uid allow list */
  UidMismatch = 'UID_MISMATCH',
  /** User required */
  UserRequired = 'USER_REQUIRED',
}

/** Result of a discount eligibility check */
export type BillingDiscountEligibilityResult = {
  __typename?: 'BillingDiscountEligibilityResult'
  /** The discount that was checked */
  discount?: Maybe<BillingDiscount>
  /** The discounted pricing */
  discountedPricing?: Maybe<BillingProviderProductPricingDiscounted>
  /** Whether the discount is eligible */
  eligible: Scalars['Boolean']['output']
  /** Error code if the discount is not eligible */
  errorCode?: Maybe<BillingDiscountEligibilityErrorCode>
}

/** Billing discount list response */
export type BillingDiscountListResponse = {
  __typename?: 'BillingDiscountListResponse'
  /** A list of billing discounts */
  billingDiscounts?: Maybe<Array<Maybe<BillingDiscount>>>
}

/** Billing discount list where Boolean input type */
export type BillingDiscountListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing discount list where ID input type */
export type BillingDiscountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing discount list where input type */
export type BillingDiscountListWhereInput = {
  /** The billing discount active field where clause */
  active?: InputMaybe<BillingDiscountListWhereBooleanInput>
  /** The billing discount code field where clause */
  code?: InputMaybe<BillingDiscountListWhereStringInput>
  /** The billing discount enabled field where clause */
  enabled?: InputMaybe<BillingDiscountListWhereBooleanInput>
  /** The billing discount id field where clause */
  id?: InputMaybe<BillingDiscountListWhereIdInput>
  /** The billing discount sku field where clause */
  sku?: InputMaybe<BillingDiscountListWhereStringInput>
}

/** Billing discount list where String input type */
export type BillingDiscountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** A single redemption of a billing discount */
export type BillingDiscountRedemption = {
  __typename?: 'BillingDiscountRedemption'
  /** Whether the discount was used at signup (checkout) or plan change */
  action: BillingDiscountRedemptionAction
  /** The billing discount this redemption applies to */
  billingDiscountId: Scalars['ID']['output']
  /** Row creation time */
  createdAt: Scalars['DateTime']['output']
  /** Primary key */
  id: Scalars['ID']['output']
  /** When the discount was recorded as redeemed */
  redeemedAt: Scalars['DateTime']['output']
  /** Plan SKU at redemption time */
  sku: Scalars['String']['output']
  /** User id (user_info.uid) */
  uid: Scalars['BigInt']['output']
  /** Row update time */
  updatedAt: Scalars['DateTime']['output']
}

/** Whether a billing discount redemption was at signup or plan change */
export enum BillingDiscountRedemptionAction {
  /** Signup / checkout */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange',
}

/**
 * Billing events are payment events sent from individual payment providers (Google Play, Apple App Store,
 * PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur. These are the raw, unprocessed events that
 * represent the complete payment history for a user.
 *
 * These events are used to:
 * 1. Create and update user entitlements (access rights) when payments are successful
 * 2. Track payment history and subscription status
 * 3. Calculate financial metrics (aggregated in billingEventsOverview)
 * 4. Handle subscription renewals, cancellations, refunds, and plan changes
 * 5. Determine user payment state and subscription status
 *
 * Event Flow:
 * - Payment provider sends webhook/notification → BillingEvent created
 * - Event processing → UserEntitlement created/updated based on event type
 * - Event aggregation → billingEventsOverview calculated for financial reporting
 *
 * Understanding Payment State from Events:
 * To determine a user's current payment state, examine the most recent events (ordered by txnDate DESC):
 *
 * 1. Active Subscription:
 *    - Look for recent "payment" or "renewal" events with paymentStatus="completed"
 *    - Check paidThroughDate: if in the future, user has paid access
 *    - Check endDate: if in the future or null, subscription is active
 *    - Check expiresDate: if in the future, subscription hasn't expired
 *
 * 2. Payment Issues:
 *    - paymentStatus="failed" or "pending" indicates payment problems
 *    - errorCode field contains details about payment failures
 *    - Check if paidThroughDate is in the past (access may be suspended)
 *
 * 3. Subscription Status:
 *    - "cancellation" event: Subscription cancelled (check cancelReason)
 *    - "refund" event: Payment was refunded (may affect entitlements)
 *    - "plan_change" event: User upgraded/downgraded subscription
 *    - "trial_start"/"trial_end": Trial period tracking (isTrialPeriod=true)
 *
 * 4. Payment Method State:
 *    - paymentMethod indicates how user pays (credit_card, paypal, google_wallet, etc.)
 *    - paymentType indicates payment structure (subscription, one_time, trial)
 *    - scheduledPaymentDate shows when next payment is expected
 *
 * 5. Access Period:
 *    - startDate: When access period begins
 *    - endDate: When access period ends (null = no expiration)
 *    - paidThroughDate: Date through which user has paid (key indicator of active access)
 *
 * Common transaction types (txnType):
 * - "payment": Successful payment (one-time or initial subscription payment)
 * - "renewal": Subscription renewal (recurring payment)
 * - "cancellation": Subscription cancelled (may still have access until endDate/paidThroughDate)
 * - "refund": Payment refunded (may revoke entitlements)
 * - "plan_change": Subscription plan changed (upgrade/downgrade)
 * - "trial_start": Trial period started
 * - "trial_end": Trial period ended
 * - "hold": Subscription paused (temporary suspension)
 * - "sync_billing": Billing synchronization event (for app store subscriptions)
 *
 * The source field identifies the payment provider (e.g., "google", "apple", "paypal", "amazon", "adyen", "zuora").
 * Events are linked to users via the uid field, which corresponds to UserInfo.uid.
 *
 * IMPORTANT: To get the complete payment picture, query all events for a user and analyze the sequence.
 * The most recent event with paymentStatus="completed" and a future paidThroughDate typically indicates
 * active payment status. However, always check for subsequent cancellation or refund events that may
 * have changed the state.
 */
export type BillingEvent = {
  __typename?: 'BillingEvent'
  /**
   * Whether this event has been processed for account history. Used to track
   * which events have been included in historical calculations.
   */
  accountHistoryProcessed?: Maybe<Scalars['Boolean']['output']>
  /** The payment amount (in the specified currency) */
  amount?: Maybe<Scalars['Float']['output']>
  /** Reason for cancellation (if this is a cancellation event) */
  cancellationReason?: Maybe<Scalars['String']['output']>
  /** When the row was created in the database */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The currency code for the payment amount (e.g., USD, EUR, GBP) */
  currency?: Maybe<Scalars['String']['output']>
  /**
   * The end date for the subscription or access period. When the user's access ends.
   * If null, the subscription has no expiration. Compare with current date to determine
   * if access is still valid. This is a key field for determining active subscription status.
   */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * Error code if the payment failed or had issues. Contains provider-specific error codes
   * when paymentStatus is "failed" or "pending". Use this along with providerComments
   * to understand why a payment failed and what action might be needed.
   *
   * Common scenarios:
   * - Payment method declined (insufficient funds, expired card, etc.)
   * - Provider-specific errors (network issues, account problems, etc.)
   * - Validation errors (invalid payment details)
   *
   * If errorCode is set, the payment did not complete successfully and entitlements
   * should not be granted based on this event.
   */
  errorCode?: Maybe<Scalars['String']['output']>
  /**
   * The date when the subscription or access expires. Similar to endDate but may
   * represent a different expiration concept depending on the provider. Check both
   * endDate and expiresDate to fully understand access expiration.
   *
   * If expiresDate is in the future, the subscription hasn't expired yet.
   * If in the past, the subscription has expired and may need renewal.
   */
  expiresDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * Whether this transaction is part of a trial period. If true, this is a trial
   * payment and the user may not have been charged (or charged a reduced amount).
   * Trial periods typically convert to paid subscriptions after trial_end events.
   *
   * Use this field along with txnType="trial_start" or "trial_end" to track trial
   * status and understand when trial converts to paid subscription.
   */
  isTrialPeriod?: Maybe<Scalars['Boolean']['output']>
  /** Linkshare affiliate identifier (for affiliate tracking) */
  linkshareAffiliate?: Maybe<Scalars['String']['output']>
  /** The date when the Linkshare affiliate was recorded */
  linkshareDate?: Maybe<Scalars['DateTime']['output']>
  /** The amount that will be billed next (for recurring subscriptions) */
  nextBillAmount?: Maybe<Scalars['Float']['output']>
  /**
   * The date through which the user has paid (subscription paid through date).
   * This is CRITICAL for determining payment state:
   * - If paidThroughDate is in the future: User has paid access until that date
   * - If paidThroughDate is in the past: User's paid access has expired
   * - If null: May indicate one-time payment or trial (check paymentType)
   *
   * This date is typically set when a payment is successful and determines when
   * entitlements should be active. Always check this field along with paymentStatus
   * to understand current payment state.
   */
  paidThroughDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The parent transaction ID. For subscription renewals or related transactions,
   * this links to the original transaction.
   */
  parentTxnId?: Maybe<Scalars['String']['output']>
  /**
   * The payment method (e.g., "credit_card", "paypal", "google_wallet", "apple_pay", "amazon_pay").
   * Identifies how the user pays. Useful for understanding payment provider relationships
   * and troubleshooting payment issues specific to payment methods.
   */
  paymentMethod?: Maybe<Scalars['String']['output']>
  /**
   * The payment status (e.g., "completed", "pending", "failed", "refunded", "voided").
   * CRITICAL field for understanding payment state:
   * - "completed": Payment successful, entitlements should be granted
   * - "pending": Payment processing, entitlements may be delayed
   * - "failed": Payment failed, no entitlements granted, check errorCode
   * - "refunded": Payment was refunded, entitlements may be revoked
   * - "voided": Payment was voided/cancelled before completion
   *
   * Always check this field to determine if the payment was actually successful.
   * Only events with paymentStatus="completed" should result in active entitlements.
   */
  paymentStatus?: Maybe<Scalars['String']['output']>
  /**
   * The payment type (e.g., "subscription", "one_time", "trial").
   * - "subscription": Recurring payment (expect renewals)
   * - "one_time": Single payment (no automatic renewals)
   * - "trial": Trial period payment (may convert to subscription)
   *
   * Use this to understand the payment structure and predict future events.
   */
  paymentType?: Maybe<Scalars['String']['output']>
  /** The plan ID associated with this transaction (system identifier) */
  planId?: Maybe<Scalars['String']['output']>
  /** The plan name associated with this transaction (human-readable) */
  planName?: Maybe<Scalars['String']['output']>
  /**
   * Plan segment data stored as JSON. Contains information about the plan segments,
   * pricing tiers, or product variations.
   */
  planSegmentData?: Maybe<Scalars['JSON']['output']>
  /**
   * The date and time when this event was processed by the system. Indicates when
   * the event was received and stored, which may differ from txnDate (when the
   * transaction actually occurred at the provider). Useful for debugging event
   * processing delays and understanding event timeline.
   */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** Comments or notes from the payment provider */
  providerComments?: Maybe<Scalars['String']['output']>
  /**
   * Raw provider data stored as JSON. Contains the complete response from the payment provider,
   * including provider-specific fields and metadata.
   */
  providerData?: Maybe<Scalars['JSON']['output']>
  /** The subscription ID in the payment provider's system (for recurring subscriptions) */
  providerSubscriptionId?: Maybe<Scalars['String']['output']>
  /** The user ID in the payment provider's system */
  providerUserId?: Maybe<Scalars['String']['output']>
  /** Referral channels (how the user was referred) */
  referralChannels?: Maybe<Scalars['String']['output']>
  /** Referral source (where the user came from) */
  referralSource?: Maybe<Scalars['String']['output']>
  /**
   * Referral source data stored as JSON. Contains detailed referral information
   * and tracking parameters.
   */
  referralSourceJsonb?: Maybe<Scalars['JSON']['output']>
  /**
   * The scheduled date for the next payment (for recurring subscriptions).
   * Indicates when the next billing cycle will occur. Useful for understanding
   * subscription renewal timeline and predicting future payment state.
   */
  scheduledPaymentDate?: Maybe<Scalars['DateTime']['output']>
  /** The country code where the user signed up */
  signupCountry?: Maybe<Scalars['String']['output']>
  /**
   * The payment provider source (e.g., "google", "apple", "paypal", "amazon", "adyen").
   * Identifies which payment system sent this event.
   */
  source?: Maybe<Scalars['String']['output']>
  /**
   * When SSOT backfill processed this event (set by events-billing-ssot-backfill worker).
   * Null means the event has not been backfilled yet.
   */
  ssotProcessedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * Skip reason when SSOT backfill marked the event without writing billing_* rows
   * (e.g. missing_product, missing_signup, missing_current_plan, unsupported_txn, source_excluded). Null on successful write.
   */
  ssotSkipReason?: Maybe<Scalars['String']['output']>
  /**
   * The start date for the subscription or access period. When the user's access begins.
   * Compare with current date to determine if access period has started.
   */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The tax amount for this transaction */
  taxAmount?: Maybe<Scalars['Float']['output']>
  /** The date and time when the transaction occurred */
  txnDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The transaction ID from the payment provider. Unique identifier for this transaction
   * in the provider's system.
   */
  txnId?: Maybe<Scalars['String']['output']>
  /**
   * The transaction type (e.g., "payment", "renewal", "cancellation", "refund", "plan_change",
   * "trial_start", "trial_end"). Describes what kind of event this is.
   */
  txnType?: Maybe<Scalars['String']['output']>
  /** The user uid (legacy identifier) linking this event to UserInfo */
  uid?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated in the database */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * The user associated with this event. Links to UserInfo via the uid field.
   * This is the user who made the payment or whose subscription was affected.
   *
   * To understand a user's complete payment state:
   * 1. Query all billingEvents for this user (ordered by txnDate DESC)
   * 2. Filter by source if user has multiple payment providers
   * 3. Check the most recent events with paymentStatus="completed"
   * 4. Examine paidThroughDate to determine if access is currently active
   * 5. Look for cancellation or refund events that may have changed state
   * 6. Check scheduledPaymentDate to predict future payment state
   * 7. Review errorCode and paymentStatus for any payment issues
   *
   * The sequence of events tells the story of the user's payment journey:
   * - Initial payment → Renewals → Plan changes → Cancellations → Refunds
   * Each event represents a state change in the user's payment relationship.
   */
  userInfo?: Maybe<UserInfo>
  /**
   * User referral data stored as JSON. Contains information about user referrals
   * and referral program participation.
   */
  userReferralJsonb?: Maybe<Scalars['JSON']['output']>
  /** The event UUID (unique identifier for this specific event) */
  uuid?: Maybe<Scalars['ID']['output']>
}

export type BillingEventCountResponse = {
  __typename?: 'BillingEventCountResponse'
  /** The count of rows */
  count: Scalars['Int']['output']
}

/** EventCreateInput */
export type BillingEventCreateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']['input']>
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']['input']>
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']['input']>
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The parent transaction Id for event */
  parentTxnId: Scalars['String']['input']
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']['input']>
  /** The plan id for event */
  planId: Scalars['String']['input']
  /** The plan name for event */
  planName: Scalars['String']['input']
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']['input']>
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']['input']>
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']['input']>
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']['input']>
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']['input']>
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']['input']>
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']['input']>
  /** The source for event */
  source: Scalars['String']['input']
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** The transaction date for event */
  txnDate: Scalars['DateTime']['input']
  /** The transaction Id for event */
  txnId: Scalars['String']['input']
  /** The transaction type for event */
  txnType: Scalars['String']['input']
  /** The user uid for event */
  uid: Scalars['ID']['input']
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing event policy list response */
export type BillingEventListResponse = {
  __typename?: 'BillingEventListResponse'
  /** A list of user accounts */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Event id type where input type */
export type BillingEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Event where conditions to filter rows */
export type BillingEventListWhereInput = {
  /**
   * Keep only events whose 2nd-party provider receipt row exists (true) or is missing (false).
   * `events` has no foreign key to the receipt tables; this is a computed join on the
   * transaction-id columns the normalizers write:
   *   itunes: events.parent_txn_id = apple_receipts.provider_parent_txn_id
   *   google: events.parent_txn_id = google_receipts.provider_purchase_token
   *   amazon: events.parent_txn_id = amazon_receipts.provider_receipt_id
   *   roku:   events.txn_id        = roku_signup.txn_id
   * Only itunes/google/amazon/roku events can satisfy `true` (other sources have no receipt
   * table, so they always fail `true` and pass `false`). Omit to disable the check.
   */
  hasReceipt?: InputMaybe<Scalars['Boolean']['input']>
  /** The id field where clause */
  id?: InputMaybe<BillingEventListWhereIdInput>
  /** The signupCountry field where clause */
  signupCountry?: InputMaybe<BillingEventListWhereSignupCountryInput>
  /** The source field where clause */
  source?: InputMaybe<BillingEventListWhereSourceInput>
  /** The ssotProcessedAt field where clause */
  ssotProcessedAt?: InputMaybe<BillingEventListWhereSsotProcessedAtInput>
  /** The ssotSkipReason field where clause */
  ssotSkipReason?: InputMaybe<BillingEventListWhereSsotSkipReasonInput>
  /** The txnType field where clause */
  txnType?: InputMaybe<BillingEventListWhereTxnTypeInput>
  /** The uid field where clause */
  uid?: InputMaybe<BillingEventListWhereUidInput>
}

/** Event signup country where input type */
export type BillingEventListWhereSignupCountryInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event source where input type */
export type BillingEventListWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** SSOT processed-at where input type */
export type BillingEventListWhereSsotProcessedAtInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** SSOT skip reason where input type */
export type BillingEventListWhereSsotSkipReasonInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event transaction where input type */
export type BillingEventListWhereTxnTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Event uid type where input type */
export type BillingEventListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** EventUpdateInput */
export type BillingEventUpdateInput = {
  /** The account history processed date for event */
  accountHistoryProcessed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment amount for event */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The cancellation reason for event */
  cancellationReason?: InputMaybe<Scalars['String']['input']>
  /** The payment currency for event */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The end date for event */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The error code for event */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The expires date for event */
  expiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** The is trial period flag for event */
  isTrialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  /** The linkshare affiliate for event */
  linkshareAffiliate?: InputMaybe<Scalars['String']['input']>
  /** The linkshare share date for event */
  linkshareDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The next bill amount for event */
  nextBillAmount?: InputMaybe<Scalars['Float']['input']>
  /** The paid through date for event */
  paidThroughDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The parent transaction Id for event */
  parentTxnId?: InputMaybe<Scalars['String']['input']>
  /** The payment method for event */
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  /** The payment status for event */
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  /** The payment type for event */
  paymentType?: InputMaybe<Scalars['String']['input']>
  /** The plan id for event */
  planId?: InputMaybe<Scalars['String']['input']>
  /** The plan name for event */
  planName?: InputMaybe<Scalars['String']['input']>
  /** The plan segment data response for event */
  planSegmentData?: InputMaybe<Scalars['JSON']['input']>
  /** The processed date for event */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider comments for event */
  providerComments?: InputMaybe<Scalars['String']['input']>
  /** The provider data response for event */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The provider subscription Id for event */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The provider user Id for event */
  providerUserId?: InputMaybe<Scalars['String']['input']>
  /** The referral channels for event */
  referralChannels?: InputMaybe<Scalars['String']['input']>
  /** The referral source for event */
  referralSource?: InputMaybe<Scalars['String']['input']>
  /** The referral source data for event */
  referralSourceJsonb?: InputMaybe<Scalars['JSON']['input']>
  /** The scheduled payment date for event */
  scheduledPaymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The signup country for event */
  signupCountry?: InputMaybe<Scalars['String']['input']>
  /** The source for event */
  source?: InputMaybe<Scalars['String']['input']>
  /** The start date for event */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The tax amount for event */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** The transaction date for event */
  txnDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The transaction Id for event */
  txnId?: InputMaybe<Scalars['String']['input']>
  /** The transaction type for event */
  txnType?: InputMaybe<Scalars['String']['input']>
  /** The user uid for event */
  uid?: InputMaybe<Scalars['ID']['input']>
  /** The user referral data for event */
  userReferralJsonb?: InputMaybe<Scalars['JSON']['input']>
}

/**
 * Billing events overview provides aggregated financial metrics for a user's payment history.
 * This is calculated from all BillingEvent records for the user and provides a summary view
 * of their financial relationship with the platform.
 *
 * The overview reads the stored billing_events_overview row. That row is written when
 * a billing event is recorded. A uid with no stored row is zeros and USD.
 *
 * The overview aggregates individual billing events to calculate:
 * - Profit metrics (gross, net, tax)
 * - Loss totals (refunds, chargebacks, etc.)
 * - Currency information
 *
 * IMPORTANT: All payment amounts are in the user's currency. If multiple currencies are present,
 * the aggregate totals may not be valid for direct comparison.
 *
 * This overview is useful for:
 * - Understanding a user's lifetime value
 * - Calculating revenue metrics
 * - Financial reporting and analysis
 * - Customer support inquiries about payment history
 *
 * The profit and loss calculations use specific transaction types (defined in eventProfitTxnTypes
 * and eventLossTxnTypes) to categorize events appropriately.
 */
export type BillingEventsOverview = {
  __typename?: 'BillingEventsOverview'
  /**
   * The currencies for all of the payment events. This is an array of all unique currency codes
   * found in the user's billing events.
   *
   * WARNING: If there is more than one currency, the aggregate totals (profit, loss, etc.) are not
   * valid for direct comparison as they mix different currencies. Always check the currencies array
   * before using aggregate totals.
   */
  currencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The event transaction types used to filter loss events. These are the txnType values
   * from BillingEvent that are considered losses (e.g., "refund", "chargeback").
   */
  eventLossTxnTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The event transaction types used to filter profit events. These are the txnType values
   * from BillingEvent that are considered profit-generating (e.g., "payment", "renewal").
   */
  eventProfitTxnTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The loss total: total of all loss events (refunds, chargebacks, cancellations, etc.).
   * This represents money returned to customers or lost due to failed transactions.
   */
  lossTotal?: Maybe<Scalars['Float']['output']>
  /**
   * The profit: final profit calculation after deducting cost of goods sold, tax, and losses.
   * This is the net profit after all deductions and losses are accounted for.
   */
  profit?: Maybe<Scalars['Float']['output']>
  /**
   * The profit gross: profit without deducting any costs. This is the raw revenue
   * from all profitable transactions before any deductions.
   */
  profitGross?: Maybe<Scalars['Float']['output']>
  /**
   * The profit net: profit after deducting cost of goods sold, with only tax deducted.
   * This represents the net profit from profitable transactions.
   */
  profitNet?: Maybe<Scalars['Float']['output']>
  /**
   * The profit tax: total tax collected for all profitable events. This is the sum
   * of tax amounts from all profit-generating transactions.
   */
  profitTax?: Maybe<Scalars['Float']['output']>
  /** The user uid linking this overview to UserInfo */
  uid?: Maybe<Scalars['ID']['output']>
}

/** Billing Invoice */
export type BillingInvoice = {
  __typename?: 'BillingInvoice'
  /** The balance of the billing invoice */
  balance?: Maybe<Scalars['Float']['output']>
  /** Billing One Time Purchase associated with this Billing Invoice */
  billingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** The billing one time purchase ID of the billing invoice */
  billingOneTimePurchaseId?: Maybe<Scalars['ID']['output']>
  /** The billing provider product ID of the billing invoice */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Subscription Plan associated with this Billing Invoice */
  billingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** The billing subscription ID of the billing invoice */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The due date of the billing invoice */
  dueDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing invoice */
  id?: Maybe<Scalars['ID']['output']>
  /** The period end of the billing invoice */
  periodEnd?: Maybe<Scalars['DateTime']['output']>
  /** The period start of the billing invoice */
  periodStart?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider invoice ID of the billing invoice */
  providerInvoiceId?: Maybe<Scalars['String']['output']>
  /** The quantity of the billing invoice */
  quantity?: Maybe<Scalars['Int']['output']>
  /** The tax amount of the billing invoice */
  taxAmount?: Maybe<Scalars['Float']['output']>
  /** The tax amount of the billing invoice */
  taxJurisdictionCode?: Maybe<Scalars['String']['output']>
  /** The total amount of the billing invoice */
  totalAmount?: Maybe<Scalars['Float']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing invoice */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The balance of the billing invoice */
  writtenOff?: Maybe<Scalars['Boolean']['output']>
}

/** Create input for Billing Invoice */
export type BillingInvoiceCreateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']['input']>
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId: Scalars['ID']['input']
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** Due date of the billing invoice */
  dueDate: Scalars['DateTime']['input']
  /** Period ends of the billing invoice */
  periodEnd: Scalars['DateTime']['input']
  /** Period starts of the billing invoice */
  periodStart: Scalars['DateTime']['input']
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The quantity of the billing invoice */
  quantity: Scalars['Int']['input']
  /** Tax amount of the billing invoice */
  taxAmount: Scalars['Float']['input']
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** Total amount of the billing invoice */
  totalAmount: Scalars['Float']['input']
  /** Whether the invoice was written off */
  writtenOff: Scalars['Boolean']['input']
}

/** Billing Invoice list response */
export type BillingInvoiceListResponse = {
  __typename?: 'BillingInvoiceListResponse'
  billingInvoices?: Maybe<Array<Maybe<BillingInvoice>>>
}

/** Billing Invoice boolean where input type */
export type BillingInvoiceListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Invoice list where Date input type */
export type BillingInvoiceListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Invoice float where input type */
export type BillingInvoiceListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Invoice list id where input type */
export type BillingInvoiceListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Invoice list where input type */
export type BillingInvoiceListWhereInput = {
  /** The billingInvoice balance field where clause */
  balance?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice billingOneTimePurchaseId field where clause */
  billingOneTimePurchaseId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice billingSubscriptionPlanId field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice createdAt field where clause */
  createdAt?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice dueDate field where clause */
  dueDate?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice id field where clause */
  id?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice periodEnd field where clause */
  periodEnd?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice periodStart field where clause */
  periodStart?: InputMaybe<BillingInvoiceListWhereDateInput>
  /** The billingInvoice providerInvoiceId field where clause */
  providerInvoiceId?: InputMaybe<BillingInvoiceListWhereIdInput>
  /** The billingInvoice quantity field where clause */
  quantity?: InputMaybe<BillingInvoiceListWhereIntInput>
  /** The billingInvoice taxAmount field where clause */
  taxAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice taxJurisdictionCode field where clause */
  taxJurisdictionCode?: InputMaybe<BillingInvoiceListWhereStringInput>
  /** The billingInvoice totalAmount field where clause */
  totalAmount?: InputMaybe<BillingInvoiceListWhereFloatInput>
  /** The billingInvoice uuid field where clause */
  uuid?: InputMaybe<BillingInvoiceListWhereStringInput>
  /** The billingInvoice writtenOff field where clause */
  writtenOff?: InputMaybe<BillingInvoiceListWhereBooleanInput>
}

/** Billing Invoice integer where input type */
export type BillingInvoiceListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Invoice string where input type */
export type BillingInvoiceListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Invoice */
export type BillingInvoiceUpdateInput = {
  /** Balance of the billing invoice */
  balance?: InputMaybe<Scalars['Float']['input']>
  /** The billing one time purchase Id of the billing invoice */
  billingOneTimePurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product Id of the billing invoice */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billing subscription plan Id of the billing invoice */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** Due date of the billing invoice */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing payment */
  id: Scalars['ID']['input']
  /** Period ends of the billing invoice */
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Period starts of the billing invoice */
  periodStart?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider invoice Id of the billing invoice */
  providerInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The quantity of the billing invoice */
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** Tax amount of the billing invoice */
  taxAmount?: InputMaybe<Scalars['Float']['input']>
  /** Tax Jurisdiction code of the billing invoice */
  taxJurisdictionCode?: InputMaybe<Scalars['String']['input']>
  /** Total amount of the billing invoice */
  totalAmount?: InputMaybe<Scalars['Float']['input']>
  /** Whether the invoice was written off */
  writtenOff?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing One Time Purchase */
export type BillingOneTimePurchase = {
  __typename?: 'BillingOneTimePurchase'
  /** When the Billing one time Purchase end date */
  accessEndDate?: Maybe<Scalars['DateTime']['output']>
  /** When the Billing one time Purchase was started */
  accessStartDate?: Maybe<Scalars['DateTime']['output']>
  /** The Billing Account Id of the Billing one time Purchase */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The gift bulk purchase Id of the Billing one time Purchase */
  giftBulkPurchaseId?: Maybe<Scalars['ID']['output']>
  /** The gift Id of the Billing one time Purchase */
  giftId?: Maybe<Scalars['ID']['output']>
  /** The id of the Billing one time Purchase */
  id?: Maybe<Scalars['ID']['output']>
  /** The billing provider order ID of the Billing one time Purchase */
  providerOrderId?: Maybe<Scalars['ID']['output']>
  /** When the Billing one time Purchase was purchase */
  purchaseDate?: Maybe<Scalars['DateTime']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the Billing one time Purchase */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing One Time Purchase */
export type BillingOneTimePurchaseCreateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId: Scalars['ID']['input']
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']['input']>
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate: Scalars['DateTime']['input']
}

/** Billing One Time Purchase list response */
export type BillingOneTimePurchaseListResponse = {
  __typename?: 'BillingOneTimePurchaseListResponse'
  billingOneTimePurchases?: Maybe<Array<Maybe<BillingOneTimePurchase>>>
}

/** Billing One Time Purchase list where Date input type */
export type BillingOneTimePurchaseListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing One Time Purchase list id where input type */
export type BillingOneTimePurchaseListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing One Time Purchase list where input type */
export type BillingOneTimePurchaseListWhereInput = {
  /** The billingOneTimePurchase accessEndDate field where clause */
  accessEndDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase accessStartDate field where clause */
  accessStartDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase createdAt field where clause */
  createdAt?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase giftBulkPurchaseId field where clause */
  giftBulkPurchaseId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase giftId field where clause */
  giftId?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase id field where clause */
  id?: InputMaybe<BillingOneTimePurchaseListWhereIdInput>
  /** The billingOneTimePurchase providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>
  /** The billingOneTimePurchase purchaseDate field where clause */
  purchaseDate?: InputMaybe<BillingOneTimePurchaseListWhereDateInput>
  /** The billingOneTimePurchase uuid field where clause */
  uuid?: InputMaybe<BillingOneTimePurchaseListWhereStringInput>
}

/** Billing One Time Purchase string where input type */
export type BillingOneTimePurchaseListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing One Time Purchase */
export type BillingOneTimePurchaseUpdateInput = {
  /** The effective accessEndDate of the Billing one time Purchase */
  accessEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The effective accessStartDate of the Billing one time Purchase */
  accessStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing billingAccountId of the Billing one time Purchase */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftBulkPurchaseId of the Billing one time Purchase */
  giftBulkPurchaseId?: InputMaybe<Scalars['ID']['input']>
  /** The billing giftId of the Billing one time Purchase */
  giftId?: InputMaybe<Scalars['ID']['input']>
  /** The id of the Billing one time Purchase */
  id: Scalars['ID']['input']
  /** The provider providerOrderId of the Billing one time Purchase */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** The effective purchaseDate of the Billing one time Purchase */
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Billing Payment */
export type BillingPayment = {
  __typename?: 'BillingPayment'
  /** The payment amount */
  amount?: Maybe<Scalars['Float']['output']>
  /** Billing Invoice associated with this Billing Payment */
  billingInvoice?: Maybe<BillingInvoice>
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: Maybe<Scalars['ID']['output']>
  /** Billing Payment Method associated with this Billing Payment */
  billingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** ID of billing payment method */
  billingPaymentMethodId?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The payment currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The payment gateway error */
  gatewayError?: Maybe<Scalars['String']['output']>
  /** The id of the billing payment */
  id?: Maybe<Scalars['ID']['output']>
  /** The payment date */
  paymentDate?: Maybe<Scalars['DateTime']['output']>
  /** Provider payment id */
  providerPaymentId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing payment */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Payment */
export type BillingPaymentCreateInput = {
  /** The payment amount */
  amount: Scalars['Float']['input']
  /** The billing invoice ID of the billing payment */
  billingInvoiceId: Scalars['ID']['input']
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  /** The payment currency */
  currency: Scalars['String']['input']
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** Date of payment date */
  paymentDate: Scalars['DateTime']['input']
  /** The provider payment ID of the billing payment */
  providerPaymentId: Scalars['String']['input']
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment list response */
export type BillingPaymentListResponse = {
  __typename?: 'BillingPaymentListResponse'
  billingPayments?: Maybe<Array<Maybe<BillingPayment>>>
}

/** Billing Payment boolean where input type */
export type BillingPaymentListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment list where Date input type */
export type BillingPaymentListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Payment float where input type */
export type BillingPaymentListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Payment list id where input type */
export type BillingPaymentListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Payment list where input type */
export type BillingPaymentListWhereInput = {
  /** The billingPayment billingInvoiceId field where clause */
  billingInvoiceId?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment billingPaymentMethodId field where clause */
  billingPaymentMethodId?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment createdAt field where clause */
  createdAt?: InputMaybe<BillingPaymentListWhereDateInput>
  /** The billingPayment currency field where clause */
  currency?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment gatewayError field where clause */
  gatewayError?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment id field where clause */
  id?: InputMaybe<BillingPaymentListWhereIdInput>
  /** The billingPayment paymentDate field where clause */
  paymentDate?: InputMaybe<BillingPaymentListWhereDateInput>
  /** The billingPayment provider payment Id field where clause */
  providerPaymentId?: InputMaybe<BillingPaymentListWhereStringInput>
  /** The billingPayment success field where clause */
  success?: InputMaybe<BillingPaymentListWhereBooleanInput>
  /** The billingPayment amount field where clause */
  type?: InputMaybe<BillingPaymentListWhereFloatInput>
  /** The billingPayment uuid field where clause */
  uuid?: InputMaybe<BillingPaymentListWhereStringInput>
}

/** Billing Payment string where input type */
export type BillingPaymentListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Payment Method */
export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod'
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: Maybe<Scalars['String']['output']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: Maybe<Scalars['String']['output']>
  /** Billing Account associated with this Billing Payment Method */
  billingAccount?: Maybe<BillingAccount>
  /** The billing account ID of the billing payment method */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  /** First digits of the payment card (BIN) */
  bin?: Maybe<Scalars['String']['output']>
  /** The credit card summary (last 4 digits) */
  cardSummary?: Maybe<Scalars['String']['output']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Card funding source (e.g. CREDIT, DEBIT) */
  fundingSource?: Maybe<Scalars['String']['output']>
  /** The payment gateway name */
  gatewayName?: Maybe<Scalars['String']['output']>
  /** The id of the billing payment method */
  id?: Maybe<Scalars['ID']['output']>
  /** The PayPal Agreement ID */
  paypalAgreementId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: Maybe<Scalars['Boolean']['output']>
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: Maybe<Scalars['String']['output']>
  /** Whether the payment method has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** The payment method type */
  type?: Maybe<PaymentMethodType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing payment method */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Payment Method */
export type BillingPaymentMethodCreateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']['input']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']['input']>
  /** The billing account ID of the billing payment method */
  billingAccountId: Scalars['ID']['input']
  /** First digits of the payment card (BIN) */
  bin?: InputMaybe<Scalars['String']['input']>
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']['input']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']['input']>
  /** Card funding source (e.g. CREDIT, DEBIT) */
  fundingSource?: InputMaybe<Scalars['String']['input']>
  /** The payment gateway name */
  gatewayName: Scalars['String']['input']
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod: Scalars['Boolean']['input']
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId: Scalars['String']['input']
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment method type */
  type: PaymentMethodType
}

/** Billing Payment Method list response */
export type BillingPaymentMethodListResponse = {
  __typename?: 'BillingPaymentMethodListResponse'
  /** A list of billingProviderProductPricing reference */
  billingPaymentMethods?: Maybe<Array<Maybe<BillingPaymentMethod>>>
}

/** Billing Payment Method boolean where input type */
export type BillingPaymentMethodListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Payment Method list id where input type */
export type BillingPaymentMethodListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Payment Method list where input type */
export type BillingPaymentMethodListWhereInput = {
  /** The billingPaymentMethod adyenRecurringDetailReference field where clause */
  adyenRecurringDetailReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod adyenShopperReference field where clause */
  adyenShopperReference?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod billingAccountId field where clause */
  billingAccountId?: InputMaybe<BillingPaymentMethodListWhereIdInput>
  /** The billingPaymentMethod bin field where clause */
  bin?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod cardSummary field where clause */
  cardSummary?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod cardType field where clause */
  cardType?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod fundingSource field where clause */
  fundingSource?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod gatewayName field where clause */
  gatewayName?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod id field where clause */
  id?: InputMaybe<BillingPaymentMethodListWhereIdInput>
  /** The billingPaymentMethod paypalAgreementId field where clause */
  paypalAgreementId?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod primaryPaymentMethod field where clause */
  primaryPaymentMethod?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>
  /** The billingPaymentMethod providerPaymentMethodId field where clause */
  providerPaymentMethodId?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod removed field where clause */
  removed?: InputMaybe<BillingPaymentMethodListWhereBooleanInput>
  /** The billingPaymentMethod type field where clause */
  type?: InputMaybe<BillingPaymentMethodListWhereStringInput>
  /** The billingPaymentMethod uuid field where clause */
  uuid?: InputMaybe<BillingPaymentMethodListWhereStringInput>
}

/** Billing Payment Method string where input type */
export type BillingPaymentMethodListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Payment Method */
export type BillingPaymentMethodUpdateInput = {
  /** The Adyen Recurring Detail Reference */
  adyenRecurringDetailReference?: InputMaybe<Scalars['String']['input']>
  /** The Adyen Shopper Reference */
  adyenShopperReference?: InputMaybe<Scalars['String']['input']>
  /** The billing account ID of the billing payment method */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** First digits of the payment card (BIN) */
  bin?: InputMaybe<Scalars['String']['input']>
  /** The credit card summary (last 4 digits) */
  cardSummary?: InputMaybe<Scalars['String']['input']>
  /** The credit card type (Visa, MasterCard, etc) */
  cardType?: InputMaybe<Scalars['String']['input']>
  /** Card funding source (e.g. CREDIT, DEBIT) */
  fundingSource?: InputMaybe<Scalars['String']['input']>
  /** The payment gateway name */
  gatewayName?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing payment method */
  id: Scalars['ID']['input']
  /** The PayPal Agreement ID */
  paypalAgreementId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method is the primary payment method for the account */
  primaryPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>
  /** ID of payment method in source system (zuora only) */
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment method has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The payment method type */
  type?: InputMaybe<PaymentMethodType>
}

/** Update input for Billing Payment */
export type BillingPaymentUpdateInput = {
  /** The payment amount */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The billing invoice ID of the billing payment */
  billingInvoiceId?: InputMaybe<Scalars['ID']['input']>
  /** The billing payment method ID of the billing payment */
  billingPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  /** The payment currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing payment */
  id: Scalars['ID']['input']
  /** Date of payment date */
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The provider payment ID of the billing payment */
  providerPaymentId?: InputMaybe<Scalars['String']['input']>
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Plan Grid */
export type BillingPlanGrid = {
  __typename?: 'BillingPlanGrid'
  /** The best value plan ID in the plan grid for the user */
  bestValueBillingProviderProductId?: Maybe<Scalars['Int']['output']>
  /** The plan grid matches if the user's current or next billing product ID is in this list */
  billingProductIdIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing product ID is not in this list */
  billingProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing provider product ID is in this list */
  billingProviderProductIdIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The plan grid matches if the user's current or next billing provider product ID is not in this list */
  billingProviderProductIdNotIn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The ordered list of user specific billing provider products in the plan grid */
  billingProviderProducts: Array<BillingProviderProduct>
  /** The plan grid matches if the user's country is in this list */
  countryIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's country is not in this list */
  countryNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The plan grid matches if the user's currency is in this list */
  currencyIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's currency is not in this list */
  currencyNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean']['output']
  /** The plan grid matches if the user's device type is in this list */
  deviceTypeIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's device type is not in this list */
  deviceTypeNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean']['output']
  /** The end date of the billing plan grid */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The best value plan ID in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int']['output']
  /** The second plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: Maybe<Scalars['Int']['output']>
  /** The third plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: Maybe<Scalars['Int']['output']>
  /** The fourth plan ID in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: Maybe<Scalars['Int']['output']>
  /** The id of the billing plan grid */
  id: Scalars['ID']['output']
  /** The plan grid matches if the user's language is in this list */
  languageIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches if the user's language is not in this list */
  languageNotIn?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The plan grid matches when the user's lifetime value satisfies this rule */
  lifetimeValue?: Maybe<Scalars['Float']['output']>
  /** The operator used to compare user lifetime value with lifetimeValue */
  lifetimeValueOperator?: Maybe<PlanEligibilityNumericOperator>
  /** The best value plan ID in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int']['output']
  /** The second plan ID in the plan grid for new members */
  newMemberBillingProviderProductId2?: Maybe<Scalars['Int']['output']>
  /** The third plan ID in the plan grid for new members */
  newMemberBillingProviderProductId3?: Maybe<Scalars['Int']['output']>
  /** The first plan ID in the plan grid for new members */
  newMemberBillingProviderProductId4?: Maybe<Scalars['Int']['output']>
  /** The page the billing plan grid belongs to */
  page: Scalars['String']['output']
  /** The priority of the plan grid */
  priority: Scalars['Int']['output']
  /** The start date of the billing plan grid */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The plan grid matches when the user's tenure satisfies this rule */
  tenure?: Maybe<Scalars['Int']['output']>
  /** The operator used to compare user tenure with tenure */
  tenureOperator?: Maybe<PlanEligibilityNumericOperator>
  /** When the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** The variant name of the billing plan grid */
  variantName?: Maybe<Scalars['String']['output']>
}

/** Billing Plan Grid list response */
export type BillingPlanGridListResponse = {
  __typename?: 'BillingPlanGridListResponse'
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>
}

/** Billing Plan Grid list boolean where input type */
export type BillingPlanGridListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Plan Grid list where Date input type */
export type BillingPlanGridListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Plan Grid list device type where input type */
export type BillingPlanGridListWhereDeviceTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<PlanGridDeviceType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<PlanGridDeviceType>>>
}

/** Billing Plan Grid list float where input type */
export type BillingPlanGridListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Plan Grid list id where input type */
export type BillingPlanGridListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Plan Grid list ID list where input type */
export type BillingPlanGridListWhereIdListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Plan Grid list where input type */
export type BillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<BillingPlanGridListWhereIdListInput>
  /** The filter for the billing plan grid country in */
  countryIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid country not in */
  countryNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid currency in */
  currencyIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid currency not in */
  currencyNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid default page grid */
  defaultPageGrid?: InputMaybe<BillingPlanGridListWhereBooleanInput>
  /** The filter for the billing plan grid enabled */
  enabled?: InputMaybe<BillingPlanGridListWhereBooleanInput>
  /** The filter for the billing plan grid end date */
  endDate?: InputMaybe<BillingPlanGridListWhereDateInput>
  /** The filter for the billing plan grid id */
  id?: InputMaybe<BillingPlanGridListWhereIdInput>
  /** The filter for the billing plan grid language in */
  languageIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid language not in */
  languageNotIn?: InputMaybe<BillingPlanGridListWhereStringListInput>
  /** The filter for the billing plan grid lifetime value */
  lifetimeValue?: InputMaybe<BillingPlanGridListWhereFloatInput>
  /** The filter for the billing plan grid lifetime value operator */
  lifetimeValueOperator?: InputMaybe<BillingPlanGridListWhereNumericOperatorInput>
  /** The filter for the billing plan grid page */
  page?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>
  /** The filter for the billing plan grid priority */
  priority?: InputMaybe<BillingPlanGridListWhereIntInput>
  /** The filter for the billing plan grid start date */
  startDate?: InputMaybe<BillingPlanGridListWhereDateInput>
  /** The filter for the billing plan grid tenure */
  tenure?: InputMaybe<BillingPlanGridListWhereIntInput>
  /** The filter for the billing plan grid tenure operator */
  tenureOperator?: InputMaybe<BillingPlanGridListWhereNumericOperatorInput>
  /** The filter for the billing plan grid variant name */
  variantName?: InputMaybe<BillingPlanGridListWhereStringInOrEqListInput>
}

/** Billing Plan Grid list int where input type */
export type BillingPlanGridListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Plan eligibility numeric operator where input type */
export type BillingPlanGridListWhereNumericOperatorInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<PlanEligibilityNumericOperator>
}

/** Billing Plan Grid list string list where eq input type */
export type BillingPlanGridListWhereStringEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
}

/** Billing Plan Grid list string list where in or eq input type */
export type BillingPlanGridListWhereStringInOrEqListInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Plan Grid list string list where in input type */
export type BillingPlanGridListWhereStringListInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Product */
export type BillingProduct = {
  __typename?: 'BillingProduct'
  /** Billing Provider Products associated with this Billing Product */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** The content set id of the billing product */
  contentSetId?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing product */
  id?: Maybe<Scalars['ID']['output']>
  /** The name of the billing product */
  name?: Maybe<Scalars['String']['output']>
  /** The platform of the billing product */
  platform?: Maybe<ProductPlatform>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing product */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Product Change Log */
export type BillingProductChangeLog = {
  __typename?: 'BillingProductChangeLog'
  /** The type of change */
  changeType: ProductChangeLogType
  /** When the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The billing discount code when the entity is Discount */
  discountCode?: Maybe<Scalars['String']['output']>
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /** The entity that was changed */
  entityName: Scalars['String']['output']
  /** The id of the billing product */
  id: Scalars['ID']['output']
  /** The new values of the row */
  newValues?: Maybe<Scalars['JSON']['output']>
  /** The plan grid page of the changed entity */
  planGridPage?: Maybe<Scalars['String']['output']>
  /** The plan grid variant of the changed entity */
  planGridVariant?: Maybe<Scalars['String']['output']>
  /** The previous values of the row */
  previousValues?: Maybe<Scalars['JSON']['output']>
  /** The pricing currency of the changed entity */
  pricingCurrency?: Maybe<Scalars['String']['output']>
  /** The product of the changed entity */
  productName?: Maybe<Scalars['String']['output']>
  /** The provider of the changed entity */
  providerName?: Maybe<Scalars['String']['output']>
  /** The sku of the changed entity */
  sku?: Maybe<Scalars['String']['output']>
  /** The text key of the changed entity */
  textKey?: Maybe<Scalars['String']['output']>
  /** The text language of the changed entity */
  textLanguage?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** UUID of the user who made the change */
  userInfoUuid: Scalars['ID']['output']
  /** The username of the user who made the change */
  username: Scalars['String']['output']
}

/** Billing Product Change Log input type */
export type BillingProductChangeLogInput = {
  /** The type of change */
  changeType: ProductChangeLogType
  /** The billing discount code when the entity is Discount */
  discountCode?: InputMaybe<Scalars['String']['input']>
  /** The ecommerce sku of the changed entity */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** The entity that was changed */
  entityName: ProductChangeLogEntityName
  /** The new values of the row */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The plan grid page of the changed entity */
  planGridPage?: InputMaybe<Scalars['String']['input']>
  /** The plan grid variant of the changed entity */
  planGridVariant?: InputMaybe<Scalars['String']['input']>
  /** The previous values of the row */
  previousValues?: InputMaybe<Scalars['JSON']['input']>
  /** The pricing currency of the changed entity */
  pricingCurrency?: InputMaybe<Scalars['String']['input']>
  /** The product of the changed entity */
  productName?: InputMaybe<Scalars['String']['input']>
  /** The provider of the changed entity */
  providerName?: InputMaybe<Scalars['String']['input']>
  /** The sku of the changed entity */
  sku?: InputMaybe<Scalars['String']['input']>
  /** The text key of the changed entity */
  textKey?: InputMaybe<Scalars['String']['input']>
  /** The text language of the changed entity */
  textLanguage?: InputMaybe<Scalars['String']['input']>
}

export type BillingProductChangeLogListResponse = {
  __typename?: 'BillingProductChangeLogListResponse'
  /** A list of billingProductChangeLog reference */
  billingProductChangeLogs?: Maybe<Array<Maybe<BillingProductChangeLog>>>
}

/** Billing Product Change Log list where Date input type */
export type BillingProductChangeLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Product Change Log list id where input type */
export type BillingProductChangeLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type BillingProductChangeLogListWhereInput = {
  /** The billingProduct type field where clause */
  changeType?: InputMaybe<BillingProductChangeLogWhereChangeTypeInput>
  /** The billingProduct createdAt field where clause */
  createdAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>
  /** The billingProduct discountCode field where clause */
  discountCode?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct entityName field where clause */
  entityName?: InputMaybe<BillingProductChangeLogWhereEntityNameInput>
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductChangeLogListWhereIdInput>
  /** The billingProduct planGridPage field where clause */
  planGridPage?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct planGridVariant field where clause */
  planGridVariant?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct pricingCurrency field where clause */
  pricingCurrency?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct productName field where clause */
  productName?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct providerName field where clause */
  providerName?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct sku field where clause */
  sku?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct textKey field where clause */
  textKey?: InputMaybe<BillingProductChangeLogWhereStringInput>
  /** The billingProduct textLanguage field where clause */
  textLanguage?: InputMaybe<BillingProductChangeLogWhereLanguageInput>
  /** The billingProduct updatedAt field where clause */
  updatedAt?: InputMaybe<BillingProductChangeLogListWhereDateInput>
  /** The billingProduct uuid field where clause */
  userInfoUuid?: InputMaybe<BillingProductChangeLogListWhereIdInput>
}

/** Billing Product Change Log User */
export type BillingProductChangeLogUser = {
  __typename?: 'BillingProductChangeLogUser'
  /** The username of the user */
  username: Scalars['String']['output']
  /** The UUID of the user */
  uuid: Scalars['ID']['output']
}

export type BillingProductChangeLogUserListResponse = {
  __typename?: 'BillingProductChangeLogUserListResponse'
  /** A list of unique users who made changes */
  users?: Maybe<Array<Maybe<BillingProductChangeLogUser>>>
}

/** BillingProduct Change Log change type where input type */
export type BillingProductChangeLogWhereChangeTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogType>>>
}

/** Billing Product Change Log entity name where input type */
export type BillingProductChangeLogWhereEntityNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductChangeLogEntityName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductChangeLogEntityName>>>
}

/** BillingProduct Change Log language where input type */
export type BillingProductChangeLogWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Product Change Log string where input type */
export type BillingProductChangeLogWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Product list response */
export type BillingProductListResponse = {
  __typename?: 'BillingProductListResponse'
  /** A list of billingProducts */
  billingProducts?: Maybe<Array<Maybe<BillingProduct>>>
}

/** Billing Product list id where input type */
export type BillingProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Product list where input type */
export type BillingProductListWhereInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProduct id field where clause */
  id?: InputMaybe<BillingProductListWhereIdInput>
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProductWhereStringInput>
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>
  /** The billingProduct uuid field where clause */
  uuid?: InputMaybe<BillingProductListWhereIdInput>
}

/** Billing Product boolean where input type */
export type BillingProductWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Product int where input type */
export type BillingProductWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Product platform where input type */
export type BillingProductWherePlatformInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProductPlatform>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProductPlatform>>>
}

/** Billing Product string where input type */
export type BillingProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider */
export type BillingProvider = {
  __typename?: 'BillingProvider'
  /** Billing Provider Products associated with this Billing Provider */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing provider */
  id?: Maybe<Scalars['ID']['output']>
  /** The name of the billing provider */
  name?: Maybe<BillingProviderName>
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Currency */
export type BillingProviderCurrency = {
  __typename?: 'BillingProviderCurrency'
  /** Billing Provider associated with this Billing Provider Currency */
  billingProvider?: Maybe<BillingProvider>
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: Maybe<Scalars['String']['output']>
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Billing Provider Currency UUID */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Currency Input */
export type BillingProviderCurrencyInput = {
  /** Billing Provider ID */
  billingProviderId: Scalars['ID']['input']
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2: Scalars['String']['input']
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3: Scalars['String']['input']
  /** The billing provider currency */
  currency: Scalars['String']['input']
}

/** Billing Provider Currency list billingProvider input type */
export type BillingProviderCurrencyListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderCurrencyWhereStringInput>
}

/** Billing Provider Currency list response */
export type BillingProviderCurrencyListResponse = {
  __typename?: 'BillingProviderCurrencyListResponse'
  /** A list of billingProviderCurrency */
  billingProviderCurrency?: Maybe<Array<Maybe<BillingProviderCurrency>>>
}

/** Billing Provider Currency list ID where input type */
export type BillingProviderCurrencyListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Currency list where input type */
export type BillingProviderCurrencyListWhereInput = {
  /** The billingProviderCurrency billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderCurrencyListWhereIdInput>
  /** The billingProviderCurrency countryCodeISO2 field where clause */
  countryCodeISO2?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency countryCodeISO3 field where clause */
  countryCodeISO3?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency currency field where clause */
  currency?: InputMaybe<BillingProviderCurrencyWhereStringInput>
  /** The billingProviderCurrency id field where clause */
  id?: InputMaybe<BillingProviderCurrencyListWhereIdInput>
}

/** Billing Provider Currency Update Input */
export type BillingProviderCurrencyUpdateInput = {
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** Provider Currency countryCodeISO2 */
  countryCodeISO2?: InputMaybe<Scalars['String']['input']>
  /** Provider Currency countryCodeISO3 */
  countryCodeISO3?: InputMaybe<Scalars['String']['input']>
  /** The billing provider currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderCurrency id */
  id: Scalars['ID']['input']
}

/** Billing Product int where input type */
export type BillingProviderCurrencyWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Provider Currency string where input type */
export type BillingProviderCurrencyWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider list response */
export type BillingProviderListResponse = {
  __typename?: 'BillingProviderListResponse'
  /** A list of billingProviders */
  billingProviders?: Maybe<Array<Maybe<BillingProvider>>>
}

/** Billing Product list id where input type */
export type BillingProviderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Product list where input type */
export type BillingProviderListWhereInput = {
  /** The billingProvider id field where clause */
  id?: InputMaybe<BillingProviderListWhereIdInput>
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereStringInput>
  /** The billingProvider subscriptionManagement field where clause */
  subscriptionManagement?: InputMaybe<BillingProviderWhereBooleanInput>
  /** The billingProvider uuid field where clause */
  uuid?: InputMaybe<BillingProviderListWhereIdInput>
}

/** Billing Provider Name */
export enum BillingProviderName {
  /** Amazon */
  Amazon = 'amazon',
  /** Google Play */
  Google = 'google',
  /** iTunes */
  Itunes = 'itunes',
  /** My Yoga Online PayPal */
  MyoPaypal = 'myo_paypal',
  /** PayPal */
  Paypal = 'paypal',
  /** Roku */
  Roku = 'roku',
  /** Zuora */
  Zuora = 'zuora',
}

/** Billing Provider Product */
export type BillingProviderProduct = {
  __typename?: 'BillingProviderProduct'
  /** Whether the plan can be changed */
  allowChangePlan?: Maybe<Scalars['Boolean']['output']>
  /** Billing Plan Grids associated with this Billing Provider Product */
  billingPlanGrids?: Maybe<Array<Maybe<BillingPlanGrid>>>
  /** Billing Product associated with this Billing Provider Product */
  billingProduct?: Maybe<BillingProduct>
  /** Billing Product ID */
  billingProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Provider associated with this Billing Provider Product */
  billingProvider?: Maybe<BillingProvider>
  /** Billing Provider ID */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** Plan eligibility rules associated with this Billing Provider Product */
  billingProviderProductEligibilities?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>
  /** Billing Provider Product Pricing array associated with this Billing Provider Product */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
  /** Billing Provider Product Text array associated with this Billing Provider Product */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>
  /** Whether checkout is enabled for this provider product */
  checkoutEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: Maybe<Scalars['DateTime']['output']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: Maybe<Scalars['DateTime']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Whether the logged in user's current plan matches this product (plan level) */
  currentSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']['output']>
  /** Whether the logged in user's current plan matches this provider product (specific plan) */
  currentSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']['output']>
  /** Default Oracle personality from Oracle API for this billing provider product */
  defaultOraclePersonality?: Maybe<OraclePersonality>
  /** Default Oracle personality ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: Maybe<Scalars['Int']['output']>
  /** Provider Product description */
  description?: Maybe<Scalars['String']['output']>
  /** Discount eligibility and discounted pricing for a code on this plan (signed-in user) */
  discount?: Maybe<BillingDiscountEligibilityResult>
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  eligibility?: Maybe<BillingProviderProductEligibilityResult>
  /** Whether the user is eligible for this plan */
  eligible?: Maybe<Scalars['Boolean']['output']>
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the logged in user's next plan matches this product (plan level) */
  nextSubscriptionPlanMatchesProduct?: Maybe<Scalars['Boolean']['output']>
  /** Whether the logged in user's next plan matches this provider product (specific plan) */
  nextSubscriptionPlanMatchesProviderProduct?: Maybe<Scalars['Boolean']['output']>
  /** Optional internal notes for this billing provider product */
  notes?: Maybe<Scalars['String']['output']>
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: Maybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: Maybe<Scalars['String']['output']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: Maybe<Scalars['String']['output']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: Maybe<Scalars['ID']['output']>
  /** Provider Product sku */
  sku?: Maybe<Scalars['String']['output']>
  /** Whether this plan is taxed */
  taxable?: Maybe<Scalars['Boolean']['output']>
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: Maybe<Scalars['Int']['output']>
  /** Term type range */
  termType?: Maybe<ProviderProductTermType>
  /** Provider Product trial length - null denotes no trial */
  trialLength?: Maybe<Scalars['Int']['output']>
  /** Provider Product trial term range */
  trialTermType?: Maybe<ProviderProductTermType>
  /** Provider Product type */
  type?: Maybe<ProviderProductType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Billing Provider Product UUID */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Product */
export type BillingProviderProductBillingPlanGridsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['String']['input']>
}

/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductPricesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>
}

/** Billing Provider Product */
export type BillingProviderProductBillingProviderProductTextArgs = {
  currency?: InputMaybe<Scalars['String']['input']>
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  language?: InputMaybe<ProviderProductLanguage>
  skipReplacement?: InputMaybe<Scalars['Boolean']['input']>
  subscriptionPricingReplacementType?: InputMaybe<SubscriptionPricingReplacementType>
}

/** Billing Provider Product */
export type BillingProviderProductDiscountArgs = {
  consumeGiftCard?: InputMaybe<Scalars['Boolean']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountCode: Scalars['String']['input']
  language: ProviderProductLanguage
  page: PlanEligibilityPage
}

/** Billing Provider Product */
export type BillingProviderProductEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product */
export type BillingProviderProductEligibilityArgs = {
  country?: InputMaybe<Scalars['String']['input']>
  earlyConversion?: InputMaybe<Scalars['Boolean']['input']>
  page: PlanEligibilityPage
}

/** Billing Provider Product */
export type BillingProviderProductEligibleArgs = {
  country?: InputMaybe<Scalars['String']['input']>
  earlyConversion?: InputMaybe<Scalars['Boolean']['input']>
  page: PlanEligibilityPage
}

/** Billing Provider Product Delete By Id Input */
export type BillingProviderProductDeleteByIdInput = {
  /** The id to delete */
  id: Scalars['ID']['input']
}

/** Billing Provider Product Eligibility rule */
export type BillingProviderProductEligibility = {
  __typename?: 'BillingProviderProductEligibility'
  /** Billing Provider Product this rule belongs to */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** Billing Provider Product this rule applies to */
  billingProviderProductId: Scalars['ID']['output']
  /** Country ISO codes for Country rule type (required with countryOperator) */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether request country must be in or not in countries (Country rule type) */
  countryOperator?: Maybe<PlanEligibilityCountryOperator>
  /** When the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Ecommerce SKUs (SKU rule type) */
  ecommerceSkus?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Whether the rule is enabled */
  enabled: Scalars['Boolean']['output']
  /** Rule end timestamp */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier */
  id: Scalars['ID']['output']
  /** Lifetime value in USD (LifetimeValue rule type) */
  lifetimeValue?: Maybe<Scalars['Float']['output']>
  /** Lifetime value operator (LifetimeValue rule type) */
  lifetimeValueOperator?: Maybe<PlanEligibilityNumericOperator>
  /** Max purchases (MaxPurchases rule type) */
  maxPurchases?: Maybe<Scalars['Int']['output']>
  /** Months since last purchase (MonthsSinceLastPurchase rule type). Rule passes when user has no purchases or at least this many months since last purchase. */
  monthsSinceLastPurchase?: Maybe<Scalars['Int']['output']>
  /** Plan categories from billing_product.name (PlanCategory rule type) */
  planCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Plan SKUs (SKU rule type) */
  planSkus?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Rule type */
  ruleType: PlanEligibilityRuleType
  /** Scope: Checkout, PlanChange, or All */
  scope: PlanEligibilityScope
  /** SKU check type (SKU rule type) */
  skuCheckType?: Maybe<SkuCheckType>
  /** SKU operator AND/OR (SKU rule type when both ecommerce and plan SKUs present) */
  skuOperator?: Maybe<SkuOperator>
  /** Rule start timestamp */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** Tenure in days (Tenure rule type) */
  tenure?: Maybe<Scalars['Int']['output']>
  /** Tenure operator (Tenure rule type) */
  tenureOperator?: Maybe<PlanEligibilityNumericOperator>
  /** When the row was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** Result of deleting a plan eligibility rule */
export type BillingProviderProductEligibilityDeleteResponse = {
  __typename?: 'BillingProviderProductEligibilityDeleteResponse'
  /** Whether the delete succeeded */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Plan eligibility error code */
export enum BillingProviderProductEligibilityErrorCode {
  /** User has active subscription entitlements (checkout does not allow active entitlements) */
  ActiveEntitlements = 'ACTIVE_ENTITLEMENTS',
  /** Subscription is active (checkout does not allow active subscription) */
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  /** Free trial not allowed (user already has had a subscription) */
  FreeTrialNotAllowed = 'FREE_TRIAL_NOT_ALLOWED',
  /** Subscription is not active (plan change requires active subscription) */
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  /** Plan change not allowed for this plan */
  PlanChangeNotAllowed = 'PLAN_CHANGE_NOT_ALLOWED',
  /** Plan disabled */
  PlanDisabled = 'PLAN_DISABLED',
  /** The given plan was not found */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** One or more rules failed */
  RulesFailed = 'RULES_FAILED',
  /** Subscription is required to determine eligibility but no subscription present */
  SubscriptionNotFound = 'SUBSCRIPTION_NOT_FOUND',
  /** Subscription is paused (prevents plan change) */
  SubscriptionPaused = 'SUBSCRIPTION_PAUSED',
  /** Subscription is past paid-through date but not cancelled (suspended) */
  SubscriptionSuspended = 'SUBSCRIPTION_SUSPENDED',
  /** User already has this plan */
  UserAlreadyHasPlan = 'USER_ALREADY_HAS_PLAN',
  /** User is required to determine eligibility but no user present */
  UserRequired = 'USER_REQUIRED',
}

/** Plan eligibility failure type */
export enum BillingProviderProductEligibilityFailureType {
  /** Base criteria */
  BaseCriteria = 'BaseCriteria',
  /** Rules */
  Rules = 'Rules',
}

/** Billing Provider Product Eligibility list response */
export type BillingProviderProductEligibilityListResponse = {
  __typename?: 'BillingProviderProductEligibilityListResponse'
  billingProviderProductEligibilities?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>
}

/** Eligibility list where Boolean input (eq) */
export type BillingProviderProductEligibilityListWhereBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Eligibility list where ID input (eq / in) */
export type BillingProviderProductEligibilityListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Where input for eligibility list */
export type BillingProviderProductEligibilityListWhereInput = {
  /** Filter by billing provider product id */
  billingProviderProductId?: InputMaybe<BillingProviderProductEligibilityListWhereIdInput>
  /** Filter by enabled */
  enabled?: InputMaybe<BillingProviderProductEligibilityListWhereBooleanInput>
  /** Filter by rule type */
  ruleType?: InputMaybe<BillingProviderProductEligibilityListWhereRuleTypeInput>
  /** Filter by scope */
  scope?: InputMaybe<BillingProviderProductEligibilityListWhereScopeInput>
  /** Filter by sku */
  sku?: InputMaybe<BillingProviderProductEligibilityListWhereStringInput>
}

/** Eligibility list where rule type input (eq / in) */
export type BillingProviderProductEligibilityListWhereRuleTypeInput = {
  eq?: InputMaybe<PlanEligibilityRuleType>
  in?: InputMaybe<Array<InputMaybe<PlanEligibilityRuleType>>>
}

/** Eligibility list where scope input (eq / in) */
export type BillingProviderProductEligibilityListWhereScopeInput = {
  eq?: InputMaybe<PlanEligibilityScope>
  in?: InputMaybe<Array<InputMaybe<PlanEligibilityScope>>>
}

/** Eligibility list where String input (eq / in) */
export type BillingProviderProductEligibilityListWhereStringInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Result of checking plan eligibility for a given plan and page */
export type BillingProviderProductEligibilityResult = {
  __typename?: 'BillingProviderProductEligibilityResult'
  /** Whether the user/guest is eligible for the plan on the given page */
  eligible: Scalars['Boolean']['output']
  /** The error code */
  errorCode?: Maybe<BillingProviderProductEligibilityErrorCode>
  /** The failure type */
  failureType?: Maybe<BillingProviderProductEligibilityFailureType>
  /** Failed rules in the eligibility check */
  failures?: Maybe<Array<Maybe<BillingProviderProductEligibility>>>
}

/** Billing Provider Product Input */
export type BillingProviderProductInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']['input']>
  /** Billing Product ID */
  billingProductId: Scalars['ID']['input']
  /** Billing Provider ID */
  billingProviderId: Scalars['ID']['input']
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']['input']>
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product description */
  description: Scalars['String']['input']
  /** Enabled */
  enabled: Scalars['Boolean']['input']
  /** Optional internal notes for this billing provider product */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']['input']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']['input']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']['input']>
  /** Provider Product sku */
  sku: Scalars['String']['input']
  /** Whether this plan is taxed */
  taxable: Scalars['Boolean']['input']
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength: Scalars['Int']['input']
  /** Term type range */
  termType: ProviderProductTermType
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>
  /** Provider Product type */
  type: ProviderProductType
}

/** Billing Product input type */
export type BillingProviderProductListBillingProductInput = {
  /** The billingProduct contentSetId field where clause */
  contentSetId?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProduct name field where clause */
  name?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProduct platform field where clause */
  platform?: InputMaybe<BillingProductWherePlatformInput>
}

/** Billing Provider Product list billingProvider input type */
export type BillingProviderProductListBillingProviderInput = {
  /** The billingProvider name field where clause */
  name?: InputMaybe<BillingProviderWhereNameInput>
}

/** Billing Provider Product list response */
export type BillingProviderProductListResponse = {
  __typename?: 'BillingProviderProductListResponse'
  /** A list of billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
}

/** Billing Provider Product list ID where input type */
export type BillingProviderProductListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product list where input type */
export type BillingProviderProductListWhereInput = {
  /** The billingProviderProduct billingProductId field where clause */
  billingProductId?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct billingProviderId field where clause */
  billingProviderId?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct checkoutEnabled field where clause */
  checkoutEnabled?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct enabled field where clause */
  enabled?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct id field where clause */
  id?: InputMaybe<BillingProviderProductListWhereIdInput>
  /** The billingProviderProduct primaryStakeholder field where clause */
  primaryStakeholder?: InputMaybe<BillingProviderProductListWhereStakeholderInput>
  /** The billingProviderProduct providerFirstSegmentId (zuora rate plan ID) field where clause */
  providerFirstSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct providerSecondSegmentId field where clause */
  providerSecondSegmentId?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct sku field where clause */
  sku?: InputMaybe<BillingProviderProductWhereStringInput>
  /** The billingProviderProduct taxable field where clause */
  taxable?: InputMaybe<BillingProductWhereBooleanInput>
  /** The billingProviderProduct termLength field where clause */
  termLength?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProviderProduct term type field where clause */
  termType?: InputMaybe<BillingProviderProductWhereTermTypeInput>
  /** The billingProviderProduct trialLength field where clause */
  trialLength?: InputMaybe<BillingProductWhereIntInput>
  /** The billingProviderProduct trial term type field where clause */
  trialTermType?: InputMaybe<BillingProviderProductWhereTermTypeInput>
  /** The billingProviderProduct type field where clause */
  type?: InputMaybe<BillingProviderProductWhereTypeInput>
}

/** Billing Provider Product list primary stakeholder where input type */
export type BillingProviderProductListWhereStakeholderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductPrimaryStakeholder>>>
}

/** Billing Provider Product Pricing Input */
export type BillingProviderProductPriceInput = {
  /** The billingProviderProductPrice currency */
  currency: Scalars['String']['input']
  /** The billingProviderProductPrice price */
  price: Scalars['Float']['input']
  /** The billingProviderProductPrice trialSegmentPrice */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricing = {
  __typename?: 'BillingProviderProductPricing'
  /** Billing Provider Product associated with this Billing Provider Product Pricing */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The billing provider product pricing currency symbol */
  currencySymbol?: Maybe<Scalars['String']['output']>
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']['output']>
  /** System A marketing conversion value (3-month list proxy; not cash/LTV) */
  marketingValue?: Maybe<Scalars['Float']['output']>
  /** Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  percentSavings?: Maybe<Scalars['Int']['output']>
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']['output']>
  /** The billing provider product pricing formatted price */
  priceFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product pricing price per month equivalent */
  pricePerMonth?: Maybe<Scalars['Float']['output']>
  /** The billing provider product pricing formatted price per month equivalent */
  pricePerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product price per week equivalent */
  pricePerWeek?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted price per week equivalent */
  pricePerWeekFormatted?: Maybe<Scalars['String']['output']>
  /** Trial Segment Percent Savings - If savings comparison ID is defined on the billingProviderProduct */
  trialPercentSavings?: Maybe<Scalars['Int']['output']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted trial segment price */
  trialSegmentPriceFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product trial segment price per month equivalent */
  trialSegmentPricePerMonth?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted trial segment price per month equivalent */
  trialSegmentPricePerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** The billing provider product trial segment price per week equivalent */
  trialSegmentPricePerWeek?: Maybe<Scalars['Float']['output']>
  /** The billing provider product formatted trial segment price per week equivalent */
  trialSegmentPricePerWeekFormatted?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingPricePerWeekFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing type */
export type BillingProviderProductPricingTrialSegmentPricePerWeekFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Create a billingProviderProductPricing input type */
export type BillingProviderProductPricingCreateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId: Scalars['ID']['input']
  /** The billing provider product pricing currency */
  currency: Scalars['String']['input']
  /** The billing provider product pricing price */
  price: Scalars['Float']['input']
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing Delete response */
export type BillingProviderProductPricingDeleteResponse = {
  __typename?: 'BillingProviderProductPricingDeleteResponse'
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscounted = {
  __typename?: 'BillingProviderProductPricingDiscounted'
  /** The currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The currency symbol */
  currencySymbol?: Maybe<Scalars['String']['output']>
  /** The recurring price 1 - discount bill cycle definition can create two recurring prices */
  recurringPrice1?: Maybe<Scalars['Float']['output']>
  /** Whether the recurring price 1 is discounted */
  recurringPrice1Discounted?: Maybe<Scalars['Boolean']['output']>
  /** Formatted first recurring segment price */
  recurringPrice1Formatted?: Maybe<Scalars['String']['output']>
  /** First recurring segment price per month equivalent */
  recurringPrice1PerMonth?: Maybe<Scalars['Float']['output']>
  /** Formatted first recurring segment price per month equivalent */
  recurringPrice1PerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** The recurring price 2 (if applicable) - discount bill cycle definition can create two recurring prices */
  recurringPrice2?: Maybe<Scalars['Float']['output']>
  /** Whether the recurring price 2 is discounted */
  recurringPrice2Discounted?: Maybe<Scalars['Boolean']['output']>
  /** Formatted second recurring segment price */
  recurringPrice2Formatted?: Maybe<Scalars['String']['output']>
  /** Second recurring segment price per month equivalent */
  recurringPrice2PerMonth?: Maybe<Scalars['Float']['output']>
  /** Formatted second recurring segment price per month equivalent */
  recurringPrice2PerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** The length of the recurring term 1 */
  recurringTermLength1?: Maybe<Scalars['Int']['output']>
  /** The length of the recurring term 2 (if applicable) */
  recurringTermLength2?: Maybe<Scalars['Int']['output']>
  /** The type of the recurring term 1 */
  recurringTermType1?: Maybe<ProviderProductTermType>
  /** The type of the recurring term 2 (if applicable) */
  recurringTermType2?: Maybe<ProviderProductTermType>
  /** The trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']['output']>
  /** Whether the trial segment price is discounted */
  trialSegmentPriceDiscounted?: Maybe<Scalars['Boolean']['output']>
  /** Formatted trial segment price */
  trialSegmentPriceFormatted?: Maybe<Scalars['String']['output']>
  /** Trial segment price per month equivalent */
  trialSegmentPricePerMonth?: Maybe<Scalars['Float']['output']>
  /** Formatted trial segment price per month equivalent */
  trialSegmentPricePerMonthFormatted?: Maybe<Scalars['String']['output']>
  /** The trial term length */
  trialTermLength?: Maybe<Scalars['Int']['output']>
  /** The trial term type */
  trialTermType?: Maybe<ProviderProductTermType>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice1FormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice1PerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice2FormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedRecurringPrice2PerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedTrialSegmentPriceFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing provider product pricing discounted */
export type BillingProviderProductPricingDiscountedTrialSegmentPricePerMonthFormattedArgs = {
  includeCurrencyISO?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<ProviderProductLanguage>
}

/** Billing Provider Product Pricing list response */
export type BillingProviderProductPricingListResponse = {
  __typename?: 'BillingProviderProductPricingListResponse'
  /** A list of billingProviderProductPricing reference */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
}

/** Billing Provider Product Pricing list id where input type */
export type BillingProviderProductPricingListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product Pricing list where input type */
export type BillingProviderProductPricingListWhereInput = {
  /** The billingProviderProductPricing billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
  /** The billingProviderProductPricing currency field where clause */
  currency?: InputMaybe<BillingProviderProductPricingWhereStringInput>
  /** The billingProviderProductPricing id field where clause */
  id?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
  /** The billingProviderProductPricing uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductPricingListWhereIdInput>
}

/** Update a billingProviderProductPricing input type */
export type BillingProviderProductPricingUpdateInput = {
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider product pricing currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing provider product pricing */
  id: Scalars['ID']['input']
  /** The billing provider product pricing price */
  price?: InputMaybe<Scalars['Float']['input']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Provider Product Pricing string where input type */
export type BillingProviderProductPricingWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product Text */
export type BillingProviderProductText = {
  __typename?: 'BillingProviderProductText'
  /** Billing Provider Product associated with this Billing Provider Product Text */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The billing provider product id of the billing provider product text */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: Maybe<Scalars['ID']['output']>
  /** Ecommerce SKU Mapping (Bonus) associated with this Billing Provider Product Text */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /** Ecommerce SKU Mapping Bonus Eligibilities (Bonus Campaigns) associated with this Billing Provider Product Text */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** Whether the text is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The id of the billing provider product text */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']['output']>
  /** Key */
  key?: Maybe<Scalars['String']['output']>
  /** Language */
  language?: Maybe<Scalars['String']['output']>
  /** Billing Provider Product used as the source for price parameter replacement */
  parameterBillingProviderProduct?: Maybe<BillingProviderProduct>
  /** Billing Provider Product used as the source for price parameter replacement */
  parameterBillingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** String replacement parameters */
  parameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product text */
  uuid?: Maybe<Scalars['ID']['output']>
  /** Value */
  value?: Maybe<Scalars['String']['output']>
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']['output']>
}

/** Billing Provider Product Text */
export type BillingProviderProductTextEcommerceSkuMappingBonusEligibilitiesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product Text Create Input */
export type BillingProviderProductTextCreateInput = {
  /** The billingProviderProductText billingProviderProductId */
  billingProviderProductId: Scalars['ID']['input']
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText enabled */
  enabled: Scalars['Boolean']['input']
  /** The billingProviderProductText isValueProp */
  isValueProp: Scalars['Boolean']['input']
  /** The billingProviderProductText key */
  key: Scalars['String']['input']
  /** The billingProviderProductText language */
  language: ProviderProductLanguage
  /** Billing Provider Product used as the source for price parameter replacement */
  parameterBillingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>
  /** The billingProviderProductText value */
  value: Scalars['String']['input']
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text Delete response */
export type BillingProviderProductTextDeleteResponse = {
  __typename?: 'BillingProviderProductTextDeleteResponse'
  /** The success status of the delete operation */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Billing Provider Product Text Input */
export type BillingProviderProductTextInput = {
  /** The billingProviderProductText ecommerce sku (Indicates this is a value prop that relates to a bonus) */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** Whether the billingProviderProductText is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this text is a value prop */
  isValueProp?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText key */
  key: Scalars['String']['input']
  /** The billingProviderProductText language */
  language: ProviderProductLanguage
  /** Billing Provider Product used as the source for price parameter replacement */
  parameterBillingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billingProviderProductText value */
  value: Scalars['String']['input']
  /** The billingProviderProductText value prop order */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text list response */
export type BillingProviderProductTextListResponse = {
  __typename?: 'BillingProviderProductTextListResponse'
  /** A list of billingProviderProductText */
  billingProviderProductText?: Maybe<Array<Maybe<BillingProviderProductText>>>
}

/** Billing Provider Product Text list id where input type */
export type BillingProviderProductTextListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextListWhereInput = {
  /** The billingProviderProductText billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText billingProviderProduct sku field where clause */
  billingProviderProductSku?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText enabled field where clause */
  enabled?: InputMaybe<BillingProviderProductTextWhereBooleanInput>
  /** The billingProviderProductText id field where clause */
  id?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText isValueProp field where clause */
  isValueProp?: InputMaybe<BillingProviderProductTextWhereBooleanInput>
  /** The billingProviderProductText key field where clause */
  key?: InputMaybe<BillingProviderProductTextWhereStringInput>
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>
  /** The billingProviderProductText uuid field where clause */
  uuid?: InputMaybe<BillingProviderProductTextListWhereIdInput>
  /** The billingProviderProductText valuePropOrder field where clause */
  valuePropOrder?: InputMaybe<BillingProviderProductTextListWhereIntInput>
}

/** Billing Provider Product Text list int where input type */
export type BillingProviderProductTextListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Billing Provider Product Text Parameters */
export enum BillingProviderProductTextParameters {
  /** Percent savings of the billing provider product over another billing provider product (Monthly) */
  PercentSavings = 'percentSavings',
  /** Primary price of the billing provider product */
  Price = 'price',
  /** Primary price per month equivalent of the billing provider product */
  PricePerMonth = 'pricePerMonth',
  /** Primary price per week equivalent of the billing provider product */
  PricePerWeek = 'pricePerWeek',
  /** Trial segment percent savings of the billing provider product over another billing provider product (Monthly) */
  TrialPercentSavings = 'trialPercentSavings',
  /** Trial segment price of the billing provider product */
  TrialSegmentPrice = 'trialSegmentPrice',
  /** Trial segment price per month equivalent of the billing provider product */
  TrialSegmentPricePerMonth = 'trialSegmentPricePerMonth',
  /** Trial segment price per week equivalent of the billing provider product */
  TrialSegmentPricePerWeek = 'trialSegmentPricePerWeek',
}

/** Input for billingProviderProductText translation */
export type BillingProviderProductTextTranslateInput = {
  /** The billingProviderProduct to base translation on */
  billingProviderProduct?: InputMaybe<BillingProviderProductTextTranslateProviderProductInput>
  /** The billingProviderProductText to translate */
  billingProviderProductText?: InputMaybe<BillingProviderProductTextTranslateProviderProductTextInput>
  /** Whether to check for existing translations (default: true) */
  checkForExistingTranslations?: InputMaybe<Scalars['Boolean']['input']>
  /** The languages to translate to */
  languages?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
  /** String replacement parameters (if providing text) */
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Text to translate (not in the database) */
  text?: InputMaybe<Scalars['String']['input']>
}

/** Input for translation of all text for a billingProviderProduct */
export type BillingProviderProductTextTranslateProviderProductInput = {
  /** The billingProviderProduct ID */
  id?: InputMaybe<Scalars['Int']['input']>
  /** The billingProviderProduct SKU */
  sku?: InputMaybe<Scalars['String']['input']>
}

/** Input for translation of a billingProviderProductText */
export type BillingProviderProductTextTranslateProviderProductTextInput = {
  /** The billingProviderProductText ID */
  id?: InputMaybe<Scalars['Int']['input']>
  /** The billingProviderProduct key */
  key?: InputMaybe<Scalars['String']['input']>
}

/** Response for billingProviderProductText translation */
export type BillingProviderProductTextTranslateResponse = {
  __typename?: 'BillingProviderProductTextTranslateResponse'
  /** The translations */
  translations: Array<Maybe<BillingProviderProductTextTranslation>>
}

/** Translation for billingProviderProductText */
export type BillingProviderProductTextTranslation = {
  __typename?: 'BillingProviderProductTextTranslation'
  /** Whether the translation was retrieved from the database */
  fromDatabase?: Maybe<Scalars['Boolean']['output']>
  /** The input billingProviderProductText ID */
  id?: Maybe<Scalars['Int']['output']>
  /** The key of the billingProviderProductText */
  key?: Maybe<Scalars['String']['output']>
  /** The language of the translation */
  language: ProviderProductLanguage
  /** The translated text */
  value: Scalars['String']['output']
}

/** Input for billingProviderProductText translation options */
export type BillingProviderProductTextTranslationOptionsInput = {
  /** Additional context to help the translation */
  additionalContext?: InputMaybe<Scalars['String']['input']>
  /** The level of formality to use in the translation */
  formality?: InputMaybe<TranslationFormality>
  /** Whether to preserve the original formatting */
  preserveFormatting?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether to split the text into sentences */
  splitSentences?: InputMaybe<Scalars['Boolean']['input']>
  /** The translation model to use */
  translationModel?: InputMaybe<TranslationModel>
}

/** Billing Provider Product Text Update Input */
export type BillingProviderProductTextUpdateInput = {
  /** The billingProviderProductText ecommerceSku */
  ecommerceSku?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText id */
  id: Scalars['ID']['input']
  /** The billingProviderProductText isValueProp */
  isValueProp?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProductText key */
  key?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderProductText language */
  language?: InputMaybe<ProviderProductLanguage>
  /** Billing Provider Product used as the source for price parameter replacement */
  parameterBillingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billingProviderProductText parameters */
  parameters?: InputMaybe<Array<InputMaybe<BillingProviderProductTextParameters>>>
  /** The billingProviderProductText value */
  value?: InputMaybe<Scalars['String']['input']>
  /** The billingProviderProductText valuePropOrder */
  valuePropOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Billing Provider Product Text Verify Error */
export type BillingProviderProductTextVerifyError = {
  __typename?: 'BillingProviderProductTextVerifyError'
  /** The error type of the billing provider product text verification */
  errorType?: Maybe<Scalars['String']['output']>
  /** The text of the string from the file */
  fileString?: Maybe<Scalars['String']['output']>
  /** Whether the text is a value proposition */
  isValueProp?: Maybe<Scalars['Boolean']['output']>
  /** The key of the billing provider product text */
  key?: Maybe<Scalars['String']['output']>
  /** The language of the billing provider product text */
  language?: Maybe<Scalars['String']['output']>
  /** The parameter related to the error */
  param?: Maybe<Scalars['String']['output']>
  /** The text of the string from the database */
  rawDbString?: Maybe<Scalars['String']['output']>
  /** The text of the string from the database with parameters replaced */
  replacedDbString?: Maybe<Scalars['String']['output']>
  /** The sku the billing provider product text belongs to */
  sku?: Maybe<Scalars['String']['output']>
  /** The order of the value proposition */
  valuePropOrder?: Maybe<Scalars['Int']['output']>
}

/** Billing Provider Product Text list where input type */
export type BillingProviderProductTextVerifyWhereInput = {
  /** The billingProviderProductText language field where clause */
  language?: InputMaybe<BillingProviderProductTextWhereLanguageInput>
  /** The billingProviderProductText sku field where clause */
  sku?: InputMaybe<BillingProviderProductTextWhereStringInput>
}

/** Billing Provider Product Text boolean where input type */
export type BillingProviderProductTextWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Provider Product Text language where input type */
export type BillingProviderProductTextWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductLanguage>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductLanguage>>>
}

/** Billing Provider Product Text string where input type */
export type BillingProviderProductTextWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product Update Input */
export type BillingProviderProductUpdateInput = {
  /** Whether the plan can be changed */
  allowChangePlan?: InputMaybe<Scalars['Boolean']['input']>
  /** Billing Product ID */
  billingProductId?: InputMaybe<Scalars['ID']['input']>
  /** Billing Provider ID */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** Date when checkout is disabled for this product */
  checkoutEnabledEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** Date when checkout is enabled for this product */
  checkoutEnabledStart?: InputMaybe<Scalars['DateTime']['input']>
  /** Default AI persona ID from Oracle API for this billing provider product */
  defaultOraclePersonalityId?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product description */
  description?: InputMaybe<Scalars['String']['input']>
  /** Enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billingProviderProduct id */
  id: Scalars['ID']['input']
  /** Optional internal notes for this billing provider product */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Primary stakeholder of the billing provider product */
  primaryStakeholder?: InputMaybe<ProviderProductPrimaryStakeholder>
  /** ID of main product in source system (zuora only) */
  providerFirstSegmentId?: InputMaybe<Scalars['String']['input']>
  /** ID of recurring product in source system (zuora only).  Only populated for trial plans. */
  providerSecondSegmentId?: InputMaybe<Scalars['String']['input']>
  /** Savings Comparison Billing Provider Product ID */
  savingsComparisonId?: InputMaybe<Scalars['ID']['input']>
  /** Whether this plan is taxed */
  taxable?: InputMaybe<Scalars['Boolean']['input']>
  /** Provider Product term length - null denotes lifetime access (courses) */
  termLength?: InputMaybe<Scalars['Int']['input']>
  /** Term type range */
  termType?: InputMaybe<ProviderProductTermType>
  /** Provider Product trial length - null denotes no trial */
  trialLength?: InputMaybe<Scalars['Int']['input']>
  /** Provider Product trial term range */
  trialTermType?: InputMaybe<ProviderProductTermType>
  /** Provider Product type */
  type?: InputMaybe<ProviderProductType>
}

/** Billing Provider Product string where input type */
export type BillingProviderProductWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product where term type input type */
export type BillingProviderProductWhereTermTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductTermType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductTermType>>>
}

/** Billing Provider Product where type input type */
export type BillingProviderProductWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<ProviderProductType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<ProviderProductType>>>
}

/** Billing Provider boolean where input type */
export type BillingProviderWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Provider Product Name where input type */
export type BillingProviderWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>
}

/** Billing Product string where input type */
export type BillingProviderWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<BillingProviderName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<BillingProviderName>>>
}

/** Billing Refund */
export type BillingRefund = {
  __typename?: 'BillingRefund'
  /** The refund amount */
  amount?: Maybe<Scalars['Float']['output']>
  /** The billing refund ID of the billing refund */
  billingPaymentId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The refund gateway error */
  gatewayError?: Maybe<Scalars['String']['output']>
  /** The id of the billing refund */
  id?: Maybe<Scalars['ID']['output']>
  /** ID of provider refund */
  providerRefundId?: Maybe<Scalars['String']['output']>
  /** When the refund was processed */
  refundDate?: Maybe<Scalars['DateTime']['output']>
  /** Whether the refund has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing refund */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Refund */
export type BillingRefundCreateInput = {
  /** The refund amount */
  amount: Scalars['Float']['input']
  /** The billing payment ID of the billing refund */
  billingPaymentId: Scalars['ID']['input']
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The provider refund ID of the billing refund */
  providerRefundId: Scalars['String']['input']
  /** Date of refund date */
  refundDate: Scalars['DateTime']['input']
  /** Whether the payment has been success */
  success: Scalars['Boolean']['input']
}

/** Billing Refund list response */
export type BillingRefundListResponse = {
  __typename?: 'BillingRefundListResponse'
  billingRefunds?: Maybe<Array<Maybe<BillingRefund>>>
}

/** Billing Refund boolean where input type */
export type BillingRefundListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Refund list where Date input type */
export type BillingRefundListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Refund float where input type */
export type BillingRefundListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Refund list id where input type */
export type BillingRefundListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Refund list where input type */
export type BillingRefundListWhereInput = {
  /** The billingRefund amount field where clause */
  amount?: InputMaybe<BillingRefundListWhereFloatInput>
  /** The billingRefund billingPaymentId field where clause */
  billingPaymentId?: InputMaybe<BillingRefundListWhereIdInput>
  /** The billingRefund createdAt field where clause */
  createdAt?: InputMaybe<BillingRefundListWhereDateInput>
  /** The billingRefund gatewayError field where clause */
  gatewayError?: InputMaybe<BillingRefundListWhereStringInput>
  /** The billingRefund id field where clause */
  id?: InputMaybe<BillingRefundListWhereIdInput>
  /** The billingRefund providerRefundId field where clause */
  providerRefundId?: InputMaybe<BillingRefundListWhereStringInput>
  /** The billingRefund refundDate field where clause */
  refundDate?: InputMaybe<BillingRefundListWhereDateInput>
  /** The billingRefund success field where clause */
  success?: InputMaybe<BillingRefundListWhereBooleanInput>
  /** The billingRefund uuid field where clause */
  uuid?: InputMaybe<BillingRefundListWhereStringInput>
}

/** Billing Refund string where input type */
export type BillingRefundListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Refund */
export type BillingRefundUpdateInput = {
  /** The refund amount */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** The billing payment ID of the billing refund */
  billingPaymentId?: InputMaybe<Scalars['ID']['input']>
  /** The gateway error of payment */
  gatewayError?: InputMaybe<Scalars['String']['input']>
  /** The id of the billing refund */
  id: Scalars['ID']['input']
  /** The provider refund ID of the billing refund */
  providerRefundId?: InputMaybe<Scalars['String']['input']>
  /** Date of refund date */
  refundDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Whether the payment has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing subscriptions */
export type BillingSubscription = {
  __typename?: 'BillingSubscription'
  /** The billing account ID of subscription */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  /** The billing provider ID of subscription */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** The cancelDate of subscription */
  cancelDate?: Maybe<Scalars['DateTime']['output']>
  /** The cancelReason of subscription */
  cancelReason?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The endDate of subscription */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The latamPricing of subscription */
  latamPricing?: Maybe<Scalars['Boolean']['output']>
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: Maybe<Scalars['Float']['output']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: Maybe<Scalars['DateTime']['output']>
  /** The paidThroughDate of subscription */
  paidThroughDate?: Maybe<Scalars['DateTime']['output']>
  /** The pauseDate of subscription */
  pauseDate?: Maybe<Scalars['DateTime']['output']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: Maybe<SubscriptionPriceOverrideReason>
  /** The provider subscription id */
  providerSubscriptionId?: Maybe<Scalars['String']['output']>
  /** The resumeDate of subscription */
  resumeDate?: Maybe<Scalars['DateTime']['output']>
  /** The startDate of subscription */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The status of subscription */
  status?: Maybe<SubscriptionStatus>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing subscription uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription */
export type BillingSubscriptionCreateInput = {
  /** The billing account ID of subscription */
  billingAccountId: Scalars['ID']['input']
  /** The billing provider ID of subscription */
  billingProviderId: Scalars['ID']['input']
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']['input']>
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The latamPricing of subscription */
  latamPricing: Scalars['Boolean']['input']
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']['input']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime']['input']
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>
  /** The provider subscription ID of subscription */
  providerSubscriptionId: Scalars['String']['input']
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The startDate of subscription */
  startDate: Scalars['DateTime']['input']
  /** The status of subscription */
  status: SubscriptionStatus
}

/** Billing subscription policy list response */
export type BillingSubscriptionListResponse = {
  __typename?: 'BillingSubscriptionListResponse'
  /** A list of user accounts */
  billingSubscriptions?: Maybe<Array<Maybe<BillingSubscription>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Billing subscription id type where input type */
export type BillingSubscriptionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing subscription policy where conditions to filter rows */
export type BillingSubscriptionListWhereInput = {
  /** The billingAccountId: field where clause */
  billingAccountId?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The billingProviderId: field where clause */
  billingProviderId?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionListWhereIdInput>
  /** The providerSubscriptionId: field where clause */
  providerSubscriptionId?: InputMaybe<BillingSubscriptionWhereStringInput>
  /** The billing subscription status: field where clause */
  status?: InputMaybe<BillingSubscriptionOrderListWhereStatusInput>
}

/** Billing Subscription Order */
export type BillingSubscriptionOrder = {
  __typename?: 'BillingSubscriptionOrder'
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription order was effective date */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing subscription order */
  id?: Maybe<Scalars['ID']['output']>
  /** Order request of billing subscription order */
  orderRequest?: Maybe<Scalars['JSON']['output']>
  /** Order response of billing subscription order */
  orderResponse?: Maybe<Scalars['JSON']['output']>
  /** The provider order Id */
  providerOrderId?: Maybe<Scalars['String']['output']>
  /** Whether the billing subscription order has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** Whether the billing subscription order has been success */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The billing subscription order type */
  type?: Maybe<SubscriptionOrderType>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing subscription order */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Order */
export type BillingSubscriptionOrderCreateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId: Scalars['ID']['input']
  /** The effective date of the billing subscription order */
  effectiveDate: Scalars['DateTime']['input']
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']['input']>
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']['input']>
  /** The provider order Id of the billing subscription order */
  providerOrderId: Scalars['String']['input']
  /** Whether the billing subscription order has been removed */
  removed: Scalars['Boolean']['input']
  /** Whether the billing subscription order has been success */
  success: Scalars['Boolean']['input']
  /** The type of the billing subscription order */
  type: SubscriptionOrderType
}

/** Billing Subscription Order list response */
export type BillingSubscriptionOrderListResponse = {
  __typename?: 'BillingSubscriptionOrderListResponse'
  billingSubscriptionOrders?: Maybe<Array<Maybe<BillingSubscriptionOrder>>>
}

/** Billing Subscription Order boolean where input type */
export type BillingSubscriptionOrderListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Subscription Order list where Date input type */
export type BillingSubscriptionOrderListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Subscription Order list id where input type */
export type BillingSubscriptionOrderListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Subscription Order list where input type */
export type BillingSubscriptionOrderListWhereInput = {
  /** The billingSubscriptionOrder billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>
  /** The billingSubscriptionOrder createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>
  /** The billingSubscriptionOrder effectiveDate field where clause */
  effectiveDate?: InputMaybe<BillingSubscriptionOrderListWhereDateInput>
  /** The billingSubscriptionOrder id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderListWhereIdInput>
  /** The billingSubscriptionOrder providerOrderId field where clause */
  providerOrderId?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>
  /** The billingSubscriptionOrder removed field where clause */
  removed?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>
  /** The billingSubscriptionOrder success field where clause */
  success?: InputMaybe<BillingSubscriptionOrderListWhereBooleanInput>
  /** The billingSubscriptionOrder type field where clause */
  type?: InputMaybe<BillingSubscriptionOrderListWhereTypeInput>
  /** The billingSubscriptionOrder uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderListWhereStringInput>
}

/** Billing Subscription status where input type */
export type BillingSubscriptionOrderListWhereStatusInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionStatus>>>
}

/** Billing Subscription Order string where input type */
export type BillingSubscriptionOrderListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Billing Provider Product where type input type */
export type BillingSubscriptionOrderListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<SubscriptionOrderType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderType>>>
}

/** Billing subscriptions */
export type BillingSubscriptionOrderPlan = {
  __typename?: 'BillingSubscriptionOrderPlan'
  /** The action of subscription */
  action?: Maybe<SubscriptionOrderPlanAction>
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: Maybe<Scalars['ID']['output']>
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The newValues of billing subscription order plan */
  newValues?: Maybe<Scalars['JSON']['output']>
  /** The oldValues of billing subscription order plan */
  oldValues?: Maybe<Scalars['JSON']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing subscription order plan uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanCreateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId: Scalars['ID']['input']
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId: Scalars['ID']['input']
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing subscription policy list response */
export type BillingSubscriptionOrderPlanListResponse = {
  __typename?: 'BillingSubscriptionOrderPlanListResponse'
  /** A list of user accounts */
  billingSubscriptionOrderPlans?: Maybe<Array<Maybe<BillingSubscriptionOrderPlan>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Billing subscription order plan status where input type */
export type BillingSubscriptionOrderPlanListWhereActionInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<SubscriptionOrderPlanAction>>>
}

/** Billing subscription subscription order plan id type where input type */
export type BillingSubscriptionOrderPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing subscription order plan policy where conditions to filter rows */
export type BillingSubscriptionOrderPlanListWhereInput = {
  /** The billing subscription status: field where clause */
  action?: InputMaybe<BillingSubscriptionOrderPlanListWhereActionInput>
  /** The billingAccountId: field where clause */
  billingSubscriptionOrderId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The billingSubscriptionPlanId: field where clause */
  billingSubscriptionPlanId?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<BillingSubscriptionOrderPlanListWhereIdInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionOrderPlanWhereStringInput>
}

/** Create input for Billing Subscription Order Plan */
export type BillingSubscriptionOrderPlanUpdateInput = {
  /** The action of subscription */
  action: SubscriptionOrderPlanAction
  /** The billingSubscriptionOrderId of subscription order plan */
  billingSubscriptionOrderId?: InputMaybe<Scalars['ID']['input']>
  /** The billingSubscriptionPlanId of subscription order plan */
  billingSubscriptionPlanId?: InputMaybe<Scalars['ID']['input']>
  /** The ID of subscription order plan */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The newValues of billing subscription order plan */
  newValues?: InputMaybe<Scalars['JSON']['input']>
  /** The oldValues of billing subscription order plan */
  oldValues?: InputMaybe<Scalars['JSON']['input']>
}

/** Billing subscription order plan string where input type */
export type BillingSubscriptionOrderPlanWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Subscription Order */
export type BillingSubscriptionOrderUpdateInput = {
  /** The billing subscription ID of the billing subscription order */
  billingSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  /** The effective date of the billing subscription order */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing subscription order */
  id: Scalars['ID']['input']
  /** The order request of the billing subscription order */
  orderRequest?: InputMaybe<Scalars['JSON']['input']>
  /** The order response of the billing subscription order */
  orderResponse?: InputMaybe<Scalars['JSON']['input']>
  /** The provider order Id of the billing subscription order */
  providerOrderId?: InputMaybe<Scalars['String']['input']>
  /** Whether the billing subscription order has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether the billing subscription order has been success */
  success?: InputMaybe<Scalars['Boolean']['input']>
  /** The type of the billing subscription order */
  type?: InputMaybe<SubscriptionOrderType>
}

/** Billing Subscription Plan */
export type BillingSubscriptionPlan = {
  __typename?: 'BillingSubscriptionPlan'
  /** The billing provider product ID of the billing subscription plan */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** The billing subscription ID of the billing subscription plan */
  billingSubscriptionId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription plan ends */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the billing subscription plan */
  id?: Maybe<Scalars['ID']['output']>
  /** When the billing subscription plan trial ends date */
  priceOverride?: Maybe<Scalars['Float']['output']>
  /** Whether the billing subscription plan has been removed */
  removed?: Maybe<Scalars['Boolean']['output']>
  /** When the billing subscription plan starts */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** When the billing subscription plan trial ends date */
  trialEndDate?: Maybe<Scalars['DateTime']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing subscription plan */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for Billing Subscription Plan */
export type BillingSubscriptionPlanCreateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId: Scalars['ID']['input']
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId: Scalars['ID']['input']
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']['input']>
  /** Whether the billing subscription plan has been removed */
  removed: Scalars['Boolean']['input']
  /** The start date of the billing subscription plan */
  startDate: Scalars['DateTime']['input']
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Billing Subscription Plan list response */
export type BillingSubscriptionPlanListResponse = {
  __typename?: 'BillingSubscriptionPlanListResponse'
  billingSubscriptionPlans?: Maybe<Array<Maybe<BillingSubscriptionPlan>>>
}

/** Billing Subscription Plan boolean where input type */
export type BillingSubscriptionPlanListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Billing Subscription Plan list where Date input type */
export type BillingSubscriptionPlanListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Billing Invoice float where input type */
export type BillingSubscriptionPlanListWhereFloatInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
}

/** Billing Subscription Plan list id where input type */
export type BillingSubscriptionPlanListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Billing Subscription Plan list where input type */
export type BillingSubscriptionPlanListWhereInput = {
  /** The billingSubscriptionPlan billingProviderProductId field where clause */
  billingProviderProductId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan billingSubscriptionId field where clause */
  billingSubscriptionId?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan createdAt field where clause */
  createdAt?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan endDate field where clause */
  endDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan id field where clause */
  id?: InputMaybe<BillingSubscriptionPlanListWhereIdInput>
  /** The billingSubscriptionPlan priceOverride field where clause */
  priceOverride?: InputMaybe<BillingSubscriptionPlanListWhereFloatInput>
  /** The billingSubscriptionPlan removed field where clause */
  removed?: InputMaybe<BillingSubscriptionPlanListWhereBooleanInput>
  /** The billingSubscriptionPlan startDate field where clause */
  startDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan trialEndDate field where clause */
  trialEndDate?: InputMaybe<BillingSubscriptionPlanListWhereDateInput>
  /** The billingSubscriptionPlan uuid field where clause */
  uuid?: InputMaybe<BillingSubscriptionPlanListWhereStringInput>
}

/** Billing Subscription Plan string where input type */
export type BillingSubscriptionPlanListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Update input for Billing Subscription Plan */
export type BillingSubscriptionPlanUpdateInput = {
  /** The billingProviderProductId of the billing subscription plan */
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  /** The billingSubscriptionId of the billing subscription plan */
  billingSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  /** The end date of the billing subscription plan */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The id of the billing subscription plan */
  id: Scalars['ID']['input']
  /** The price override of the billing subscription plan */
  priceOverride?: InputMaybe<Scalars['Float']['input']>
  /** Whether the billing subscription plan has been removed */
  removed?: InputMaybe<Scalars['Boolean']['input']>
  /** The start date of the billing subscription plan */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The trial end date of the billing subscription plan */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Update input for Billing Subscription */
export type BillingSubscriptionUpdateInput = {
  /** The billing account ID of subscription */
  billingAccountId?: InputMaybe<Scalars['ID']['input']>
  /** The billing provider ID of subscription */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** The cancelDate of subscription */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The cancelReason of subscription */
  cancelReason?: InputMaybe<Scalars['String']['input']>
  /** The endDate of subscription */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing ID of subscription */
  id: Scalars['ID']['input']
  /** The latamPricing of subscription */
  latamPricing?: InputMaybe<Scalars['Boolean']['input']>
  /** The nextInvoiceAmount of subscription */
  nextInvoiceAmount?: InputMaybe<Scalars['DateTime']['input']>
  /** The nextInvoiceDate of subscription */
  nextInvoiceDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The paidThroughDate of subscription */
  paidThroughDate: Scalars['DateTime']['input']
  /** The pauseDate of subscription */
  pauseDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The priceOverrideReason of subscription */
  priceOverrideReason?: InputMaybe<SubscriptionPriceOverrideReason>
  /** The provider subscription ID of subscription */
  providerSubscriptionId?: InputMaybe<Scalars['String']['input']>
  /** The resumeDate of subscription */
  resumeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The startDate of subscription */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The status of subscription */
  status?: InputMaybe<SubscriptionStatus>
}

/** Billing subscription string where input type */
export type BillingSubscriptionWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type BrazeCampaign = {
  __typename?: 'BrazeCampaign'
  archived?: Maybe<Scalars['Boolean']['output']>
  brazeCreatedAt?: Maybe<Scalars['DateTime']['output']>
  brazeUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  channels?: Maybe<Scalars['JSON']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  draft?: Maybe<Scalars['Boolean']['output']>
  enabled?: Maybe<Scalars['Boolean']['output']>
  externalCampaignId: Scalars['String']['output']
  externalWorkspaceId: Scalars['String']['output']
  firstSent?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isApiCampaign?: Maybe<Scalars['Boolean']['output']>
  lastEdited?: Maybe<Scalars['DateTime']['output']>
  lastSent?: Maybe<Scalars['DateTime']['output']>
  name?: Maybe<Scalars['String']['output']>
  scheduleType?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  tags?: Maybe<Scalars['JSON']['output']>
  teams?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workspaceId?: Maybe<Scalars['ID']['output']>
}

/** Daily Braze campaign engagement metrics. Attributed fields are reconciliation-only. */
export type BrazeCampaignEngagementDay = {
  __typename?: 'BrazeCampaignEngagementDay'
  /** Braze-attributed conversions (reconciliation only; Zuora is source of truth). */
  attributedConversions: Scalars['Float']['output']
  attributedConversionsBySendTime: Scalars['Float']['output']
  attributedRevenue: Scalars['Float']['output']
  bounces: Scalars['Float']['output']
  campaignId?: Maybe<Scalars['ID']['output']>
  channel: Scalars['String']['output']
  clickRate?: Maybe<Scalars['Float']['output']>
  clickToOpenRate?: Maybe<Scalars['Float']['output']>
  clicks: Scalars['Float']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  deliveries: Scalars['Float']['output']
  entries: Scalars['Float']['output']
  externalCampaignId: Scalars['String']['output']
  externalWorkspaceId: Scalars['String']['output']
  id: Scalars['ID']['output']
  metricDate: Scalars['String']['output']
  metricsPayload?: Maybe<Scalars['JSON']['output']>
  openRate?: Maybe<Scalars['Float']['output']>
  opens: Scalars['Float']['output']
  sends: Scalars['Float']['output']
  spamReports: Scalars['Float']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  uniqueClicks: Scalars['Float']['output']
  uniqueOpens: Scalars['Float']['output']
  uniqueRecipients: Scalars['Float']['output']
  unsubscribes: Scalars['Float']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type BrazeCampaignEngagementDayListResponse = {
  __typename?: 'BrazeCampaignEngagementDayListResponse'
  brazeCampaignEngagementDays: Array<BrazeCampaignEngagementDay>
  total: Scalars['Int']['output']
}

export type BrazeCampaignListResponse = {
  __typename?: 'BrazeCampaignListResponse'
  brazeCampaigns: Array<BrazeCampaign>
  total: Scalars['Int']['output']
}

/** Exported Braze user profile fields for admin user-detail (users/export/ids) */
export type BrazeUserProfileAttributesResult = {
  __typename?: 'BrazeUserProfileAttributesResult'
  /** Requested Braze field keys and values (snake_case keys as returned by Braze) */
  attributes: Scalars['JSON']['output']
  /** Braze internal user id when returned by export */
  brazeId?: Maybe<Scalars['String']['output']>
  /** UTC timestamp when export completed (ISO 8601) */
  loadedAt: Scalars['String']['output']
  /** Member user_info uuid (Braze external_id) */
  uuid: Scalars['ID']['output']
}

export type BrazeWorkspace = {
  __typename?: 'BrazeWorkspace'
  configLabel?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalWorkspaceId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BrazeWorkspaceListResponse = {
  __typename?: 'BrazeWorkspaceListResponse'
  brazeWorkspaces: Array<BrazeWorkspace>
  total: Scalars['Int']['output']
}

/** Oracle AI: Bridge entity (teacher or center) connecting previous and current search domains */
export type BridgeEntityInput = {
  /** Graph entity ID */
  entityId: Scalars['String']['input']
  /** Entity display name */
  name: Scalars['String']['input']
}

/** Brightcove input for media */
export type BrightcoveInput = {
  /** Lemonade content id */
  contentId: Scalars['String']['input']
  /** Created date */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Additional data */
  data?: InputMaybe<Scalars['String']['input']>
  /** Duration in seconds */
  duration?: InputMaybe<Scalars['Int']['input']>
  /** Hash value */
  hash?: InputMaybe<Scalars['String']['input']>
  /** Height in pixels */
  height?: InputMaybe<Scalars['Int']['input']>
  /** Language code */
  lang?: InputMaybe<Scalars['String']['input']>
  /** Last update date */
  lastUpdate?: InputMaybe<Scalars['DateTime']['input']>
  /** Rendition count */
  renditionCount?: InputMaybe<Scalars['Int']['input']>
  /** Updated date */
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Video ID */
  videoId: Scalars['String']['input']
  /** Width in pixels */
  width?: InputMaybe<Scalars['Int']['input']>
  /** Work status */
  workStatus?: InputMaybe<Scalars['String']['input']>
  /** Work status changed date */
  workStatusChanged?: InputMaybe<Scalars['DateTime']['input']>
}

/** Bulk discount list response */
export type BulkDiscountListResponse = {
  __typename?: 'BulkDiscountListResponse'
  /** A list of bulk discount create batches */
  bulkDiscounts?: Maybe<Array<Maybe<BillingDiscountBulk>>>
}

/** Bulk discount list where ID input type */
export type BulkDiscountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Bulk discount list where input type */
export type BulkDiscountListWhereInput = {
  /** The bulk discount description field where clause */
  description?: InputMaybe<BulkDiscountListWhereStringInput>
  /** The bulk discount id field where clause */
  id?: InputMaybe<BulkDiscountListWhereIdInput>
  /** The bulk discount quantity field where clause */
  quantity?: InputMaybe<BulkDiscountListWhereIntInput>
  /** The bulk discount uuid field where clause */
  uuid?: InputMaybe<BulkDiscountListWhereIdInput>
}

/** Bulk discount list where Int input type */
export type BulkDiscountListWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Bulk discount list where String input type */
export type BulkDiscountListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Oracle AI: Channel prompt block */
export type ChannelPromptBlock = {
  __typename?: 'ChannelPromptBlock'
  blockKey?: Maybe<Scalars['String']['output']>
  blockOrder: Scalars['Int']['output']
  blockText: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Input for channel prompt block */
export type ChannelPromptBlockInput = {
  blockKey?: InputMaybe<Scalars['String']['input']>
  blockOrder: Scalars['Int']['input']
  blockText: Scalars['String']['input']
  enabled?: Scalars['Boolean']['input']
}

/** Oracle AI: Channel prompt section */
export type ChannelPromptSection = {
  __typename?: 'ChannelPromptSection'
  blocks: Array<ChannelPromptBlock>
  createdAt: Scalars['DateTime']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  instruction: Scalars['String']['output']
  sectionKey: Scalars['String']['output']
  sectionOrder: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Input for channel prompt section */
export type ChannelPromptSectionInput = {
  blocks?: Array<ChannelPromptBlockInput>
  enabled?: Scalars['Boolean']['input']
  instruction: Scalars['String']['input']
  sectionKey: Scalars['String']['input']
  sectionOrder: Scalars['Int']['input']
}

/** Oracle AI: Channel prompt set */
export type ChannelPromptSet = {
  __typename?: 'ChannelPromptSet'
  channel: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  sections: Array<ChannelPromptSection>
  status: ChannelPromptStatus
  updatedAt: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
}

/** Oracle AI: Input for creating channel prompt set */
export type ChannelPromptSetCreateInput = {
  channel: Scalars['String']['input']
  sections: Array<ChannelPromptSectionInput>
  status?: ChannelPromptStatus
  version?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Response for channel prompt set delete mutation */
export type ChannelPromptSetDeleteResponse = {
  __typename?: 'ChannelPromptSetDeleteResponse'
  deleted?: Maybe<Scalars['Boolean']['output']>
  errors: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Channel prompt set list response */
export type ChannelPromptSetListResponse = {
  __typename?: 'ChannelPromptSetListResponse'
  channelPromptSets: Array<ChannelPromptSet>
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

/** Oracle AI: Response for channel prompt set mutations */
export type ChannelPromptSetMutationResponse = {
  __typename?: 'ChannelPromptSetMutationResponse'
  channelPromptSet?: Maybe<ChannelPromptSet>
  errors: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for replacing channel prompt set sections */
export type ChannelPromptSetReplaceSectionsInput = {
  id: Scalars['ID']['input']
  sections: Array<ChannelPromptSectionInput>
}

/** Oracle AI: Input for updating channel prompt set status */
export type ChannelPromptSetStatusInput = {
  id: Scalars['ID']['input']
  status: ChannelPromptStatus
}

export enum ChannelPromptStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

/**
 * Allowlisted `groupBy` names for checkout attribution and trial-to-paid metrics.
 * Keep in sync with TRIAL_TO_PAID_GROUP_BY_NAMES.
 */
export enum CheckoutAttributionMetricsGroupBy {
  Fbclid = 'fbclid',
  Gclid = 'gclid',
  Msclkid = 'msclkid',
  Ttclid = 'ttclid',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmMedium = 'utm_medium',
  UtmPlatcamp = 'utm_platcamp',
  UtmSource = 'utm_source',
  UtmTerm = 'utm_term',
}

/** Parser attempt that produced a stored param row. Keep in sync with CHECKOUT_ATTRIBUTION_PARSE_OUTCOMES. */
export enum CheckoutAttributionParseOutcome {
  ParseDoubleDecode = 'PARSE_DOUBLE_DECODE',
  ParseEmpty = 'PARSE_EMPTY',
  ParseJsonObject = 'PARSE_JSON_OBJECT',
  ParseMalformedPercent = 'PARSE_MALFORMED_PERCENT',
  ParseOk = 'PARSE_OK',
  ParsePlusSpace = 'PARSE_PLUS_SPACE',
  ParseRejected = 'PARSE_REJECTED',
  ParseRepairedHtml = 'PARSE_REPAIRED_HTML',
  ParseSingleDecode = 'PARSE_SINGLE_DECODE',
  ParseStrippedUrl = 'PARSE_STRIPPED_URL',
}

/**
 * Skip/parse outcome on the parent checkout when param rows were not stored.
 * Keep in sync with CHECKOUT_ATTRIBUTION_SKIP_REASONS.
 */
export enum CheckoutAttributionSkipReason {
  ParseEmpty = 'PARSE_EMPTY',
  ParseError = 'PARSE_ERROR',
  ParseRejected = 'PARSE_REJECTED',
}

/**
 * Trial-to-paid funnel bucket for one successful attributed checkout.
 * Keep in sync with CHECKOUT_TRIAL_TO_PAID_BUCKETS in constants.ts.
 *
 * SIGNUP is the start event only (`is_trial_period`). Paid is always the first
 * in-window RENEWAL with amount > 0 and `is_trial_period = false`.
 */
export enum CheckoutTrialToPaidBucket {
  /** Non-trial SIGNUP + paid RENEWAL within the conversion window */
  DirectPaid = 'direct_paid',
  /** Non-trial SIGNUP; checkout counted, no paid RENEWAL yet */
  NonTrialAwaitingRenewal = 'non_trial_awaiting_renewal',
  /** Trial SIGNUP, no paid RENEWAL yet, conversion window still open */
  StillInTrial = 'still_in_trial',
  /** Trial SIGNUP, conversion window closed, no paid RENEWAL */
  TrialExpiredWithoutPaid = 'trial_expired_without_paid',
  /** Trial SIGNUP + paid RENEWAL within the conversion window */
  TrialToPaid = 'trial_to_paid',
}

/** One circleInviteSearch result. Deliberately uuid-only on the wire — the numeric uid is private and must NEVER be exposed. How much of this is populated depends on the CALLER's role, not on what they asked for */
export type CircleInviteCandidate = {
  __typename?: 'CircleInviteCandidate'
  /** Profile display name, else auth display name, else username */
  displayName?: Maybe<Scalars['String']['output']>
  /** Account email. ALWAYS null for a non-admin caller — it is populated only for site admins and admins of the searched feed, who need it for identity confirmation */
  email?: Maybe<Scalars['String']['output']>
  /** False when the account has no user_profiles row (inviteToCircle auto-seeds one). Always true for a non-admin caller, whose search only ever sees community profiles */
  hasProfile: Scalars['Boolean']['output']
  /** Public user uuid — pass to inviteToCircle(userUuid:) */
  uuid: Scalars['ID']['output']
}

/** Connection for circle invite candidates */
export type CircleInviteCandidateConnection = {
  __typename?: 'CircleInviteCandidateConnection'
  /** Candidate edges */
  edges: Array<CircleInviteCandidateEdge>
  /** Pagination info */
  pageInfo: PageInfo
}

/** Edge for a circle invite candidate. The cursor encodes only the PUBLIC sort key (display name, uuid) — never the numeric uid, which this whole surface keeps off the wire — and is scoped to the search that minted it, so replaying it against a different feed, searchType or query is refused rather than silently skipping results */
export type CircleInviteCandidateEdge = {
  __typename?: 'CircleInviteCandidateEdge'
  /** Cursor for pagination */
  cursor: Scalars['String']['output']
  /** The candidate */
  node: CircleInviteCandidate
}

/** How circleInviteSearch matches the term. The caller chooses — there is no automatic widening, so an EXACT search that finds nobody returns nobody rather than quietly falling back to a partial one */
export enum CircleInviteMatchType {
  /** The term must equal the whole value. Case-INSENSITIVE, and LIKE metacharacters in the term are escaped, so 'exact' means the whole string rather than byte-identical */
  Exact = 'EXACT',
  /** The term may appear anywhere in the value — substring for names, the auth API's fuzzy `*Like` search for email and username. The default: a type-ahead picker is unusable without it */
  Partial = 'PARTIAL',
}

/** Which account field circleInviteSearch matches on. The caller names the field — the term is never sniffed for an '@' — so a name that happens to contain '@' still searches names, and an email search never leaks into name matching */
export enum CircleInviteSearchType {
  /** Account email. ADMIN ONLY: a non-admin caller is refused */
  Email = 'EMAIL',
  /** Community profile display name. For an admin caller this is the display name at ANY visibility, UNION the auth account name (the union is what makes profile-less accounts findable by name); for a non-admin caller (a plain member or feed moderator) it is PUBLIC profiles only. The only type available without admin */
  Name = 'NAME',
  /** Account username. ADMIN ONLY: a non-admin caller is refused */
  Username = 'USERNAME',
}

export type ClientSignal = {
  __typename?: 'ClientSignal'
  /** Optional JSON payload with signal-specific data */
  payload?: Maybe<Scalars['JSON']['output']>
  /** Signal type (e.g. 'workflow.completed') */
  type: Scalars['String']['output']
}

/** One row from Brightcove CMS for playlist preview */
export type ClipBrightcovePlaylistVideoRow = {
  __typename?: 'ClipBrightcovePlaylistVideoRow'
  brightcoveVideoId: Scalars['String']['output']
  /** Gaia content.content_id of the existing clip; null when existsInGaia is false */
  clipContentId?: Maybe<Scalars['Int']['output']>
  /** Gaia content.id of the existing clip (Admin detail link); null when existsInGaia is false */
  clipId?: Maybe<Scalars['ID']['output']>
  /** Parent Brightcove video id when CMS marks a clip (clip_source_video_id or clip_source); null if absent */
  clipSourceVideoId?: Maybe<Scalars['String']['output']>
  /** Clip length in seconds from CMS video duration (milliseconds), Math.floor(ms/1000); null if absent or invalid */
  durationSeconds?: Maybe<Scalars['Int']['output']>
  /** True when Gaia already has an ms_clip media_asset for this Brightcove video id */
  existsInGaia: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  referenceId?: Maybe<Scalars['String']['output']>
}

/** Paginated Brightcove CMS playlist preview (AP-19127 chunking) */
export type ClipBrightcovePlaylistVideosResponse = {
  __typename?: 'ClipBrightcovePlaylistVideosResponse'
  /** Total video_ids on the Brightcove playlist (not limited by offset/limit) */
  totalCount: Scalars['Int']['output']
  /** CMS rows for the requested slice */
  videos: Array<ClipBrightcovePlaylistVideoRow>
}

/** Input for creating a vertical clip from a parent video */
export type ClipCreateInput = {
  /** Optional clip length in seconds (stored on ms_clip media_assets.duration); playlist import sets from CMS duration ms via floor(ms/1000) */
  duration?: InputMaybe<Scalars['Int']['input']>
  /** The language of this clip (e.g. en, es) */
  language: Scalars['String']['input']
  /** The provider key of the parent video's media stream (ms media asset, alternative to parentTitleGroupId) */
  parentProviderKey?: InputMaybe<Scalars['String']['input']>
  /** The titleGroupId of the parent video this clip was extracted from (alternative: parentProviderKey) */
  parentTitleGroupId?: InputMaybe<Scalars['String']['input']>
  /** Optional URL path; omit and use generatePath to auto-generate */
  path?: InputMaybe<Scalars['String']['input']>
  /** The provider key for the clip stream (ms_clip media asset) */
  providerKey: Scalars['String']['input']
  /** Whether to publish the clip immediately (defaults to false) */
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** Timestamp segments from Brightcove segments_time (stored in content_providers metadata) */
  segmentsTime?: InputMaybe<Scalars['JSON']['input']>
  /** The clip's display title */
  title: Scalars['String']['input']
  /** Virality score from Brightcove AI Content Multiplier (stored in content_providers metadata) */
  viralityScore?: InputMaybe<Scalars['Float']['input']>
}

/** Return type for clipCreate */
export type ClipCreateResponse = {
  __typename?: 'ClipCreateResponse'
  /** The newly created clip content row */
  content?: Maybe<Content>
  /** Whether the clip was created successfully */
  success: Scalars['Boolean']['output']
}

/** Non-fatal caption/text-track issue during playlist import (clip row may still succeed) */
export type ClipImportCaptionWarning = {
  __typename?: 'ClipImportCaptionWarning'
  brightcoveVideoId: Scalars['String']['output']
  message: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** One failed clip row from a playlist import */
export type ClipImportError = {
  __typename?: 'ClipImportError'
  /** Brightcove video id */
  brightcoveVideoId: Scalars['String']['output']
  /** Human-readable failure reason */
  message: Scalars['String']['output']
  /** Video name from Brightcove when available */
  title?: Maybe<Scalars['String']['output']>
}

/** Result of importing clips from a Brightcove playlist */
export type ClipImportFromBrightcovePlaylistResponse = {
  __typename?: 'ClipImportFromBrightcovePlaylistResponse'
  /** Caption import issues when importTextTracks is true (does not increment failureCount) */
  captionWarnings: Array<ClipImportCaptionWarning>
  /** Per-video failures (validation, Brightcove fetch, etc.) */
  errors: Array<ClipImportError>
  /** Number of clips that failed (matches errors length) */
  failureCount: Scalars['Int']['output']
  /** Poster (d6-poster-9x16) import issues (does not increment failureCount) */
  imageWarnings: Array<ClipImportImageWarning>
  /** Per-video skips (already imported) */
  skipped: Array<ClipImportSkippedRow>
  /** Rows skipped because a clip already exists for that Brightcove video id */
  skippedCount: Scalars['Int']['output']
  /** Number of clips created successfully */
  successCount: Scalars['Int']['output']
}

/** Partial-success result from one social manifest chunk. */
export type ClipImportFromSocialManifestResponse = {
  __typename?: 'ClipImportFromSocialManifestResponse'
  failureCount: Scalars['Int']['output']
  pendingCount: Scalars['Int']['output']
  rows: Array<ClipSocialImportRowResult>
  skippedCount: Scalars['Int']['output']
  successCount: Scalars['Int']['output']
}

/** Non-fatal poster/image issue during playlist import (clip row may still succeed) */
export type ClipImportImageWarning = {
  __typename?: 'ClipImportImageWarning'
  brightcoveVideoId: Scalars['String']['output']
  message: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** When Brightcove has neither clip_source_video_id nor clip_source for the clip, supply exactly one parent field for that playlist video id. */
export type ClipImportPerVideoParentInput = {
  brightcoveVideoId: Scalars['String']['input']
  parentProviderKey?: InputMaybe<Scalars['String']['input']>
  parentTitleGroupId?: InputMaybe<Scalars['String']['input']>
}

/** Shared defaults for playlist import (language / publish). Parent is resolved per video from Brightcove clip_source_video_id, clip_source (AI clips), or perVideoParentOverrides. */
export type ClipImportSharedDefaultsInput = {
  /** The language of each imported clip (e.g. en, es) */
  language: Scalars['String']['input']
  /** Whether to publish each clip immediately */
  published?: InputMaybe<Scalars['Boolean']['input']>
}

/** Playlist row skipped during import (e.g. clip already exists for Brightcove id) */
export type ClipImportSkippedRow = {
  __typename?: 'ClipImportSkippedRow'
  brightcoveVideoId: Scalars['String']['output']
  reason: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** Pin a specific clip as the first result when eligible; does not filter the rest of the feed */
export type ClipListFirstWhereInput = {
  /** Match clip by content id (exact) */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Match clip by stored content.path (exact, e.g. /short-videos/my-clip) */
  path?: InputMaybe<Scalars['String']['input']>
}

/** clipList page of vertical clips, plus optional recommId for personalized swipe pagination */
export type ClipListResponse = {
  __typename?: 'ClipListResponse'
  /** A list of clip content */
  content?: Maybe<Array<Maybe<Content>>>
  /** Number of content rows returned */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows (always 0 for clipList) */
  offset?: Maybe<Scalars['Int']['output']>
  /** Present when sortOrder is PERSONALIZE and personalization succeeded. Pass back as clipList(recommId:) to fetch the next non-repeating swipe batch. Null when RANDOM or when personalization fell back to random. */
  recommId?: Maybe<Scalars['String']['output']>
}

/** How clipList ranks the feed */
export enum ClipListSortOrder {
  /** Personalized ranking for continuous swipe consumption; falls back to RANDOM if personalization is unavailable */
  Personalize = 'PERSONALIZE',
  /** Random eligible published vertical clips (default) */
  Random = 'RANDOM',
}

/** Result for one social manifest row. */
export type ClipSocialImportRowResult = {
  __typename?: 'ClipSocialImportRowResult'
  brightcoveVideoId?: Maybe<Scalars['String']['output']>
  driveFileId: Scalars['String']['output']
  message: Scalars['String']['output']
  status: ClipSocialImportRowStatus
  title: Scalars['String']['output']
}

export enum ClipSocialImportRowStatus {
  Created = 'CREATED',
  Error = 'ERROR',
  Pending = 'PENDING',
  PendingTitle = 'PENDING_TITLE',
  Skipped = 'SKIPPED',
}

/** Preview state for one social manifest row. */
export type ClipSocialManifestPreviewRow = {
  __typename?: 'ClipSocialManifestPreviewRow'
  brightcoveVideoId?: Maybe<Scalars['String']['output']>
  driveFileId: Scalars['String']['output']
  existsInGaia: Scalars['Boolean']['output']
  ingestReady: Scalars['Boolean']['output']
  masterUrl: Scalars['String']['output']
  message?: Maybe<Scalars['String']['output']>
  parentExists: Scalars['Boolean']['output']
  parentTitleGroupId: Scalars['String']['output']
  title: Scalars['String']['output']
}

/** One pre-staged social clip master from the Final List. */
export type ClipSocialManifestRowInput = {
  /** Stable Google Drive file id; also used as the Brightcove reference_id */
  driveFileId: Scalars['String']['input']
  /** Brightcove-readable s3:// or HTTPS master URL */
  masterUrl: Scalars['String']['input']
  /** Full Gaia parent title group id, e.g. 128766-video */
  parentTitleGroupId: Scalars['String']['input']
  /** Brightcove CMS name (Drive filename without extension); Gaia title is derived from the parent title and optional V* suffix */
  title: Scalars['String']['input']
}

/** Byte size the browser uploaded. Complete confirms it with HeadObject. */
export type ClipSocialStageCompleteItemInput = {
  byteSize: Scalars['Int']['input']
  driveFileId: Scalars['String']['input']
  fileName: Scalars['String']['input']
}

export type ClipSocialStageCompleteResponse = {
  __typename?: 'ClipSocialStageCompleteResponse'
  rows: Array<ClipSocialStageRow>
}

/** One Final List CSV row parsed in Admin. Column names are mapped by the client. */
export type ClipSocialStageCsvRowInput = {
  fileLink: Scalars['String']['input']
  fileName: Scalars['String']['input']
  premiumContentContentId: Scalars['String']['input']
  premiumContentMediaId?: InputMaybe<Scalars['String']['input']>
  premiumContentMmId?: InputMaybe<Scalars['String']['input']>
}

/** An MP4 the operator selected in the browser, matched to a CSV row by Drive id and file name. */
export type ClipSocialStageLocalFileInput = {
  byteSize: Scalars['Int']['input']
  driveFileId: Scalars['String']['input']
  fileName: Scalars['String']['input']
}

export type ClipSocialStagePrepareInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  localFiles: Array<ClipSocialStageLocalFileInput>
  rows: Array<ClipSocialStageCsvRowInput>
}

export type ClipSocialStagePrepareResponse = {
  __typename?: 'ClipSocialStagePrepareResponse'
  appliedLimit?: Maybe<Scalars['Int']['output']>
  dryRun: Scalars['Boolean']['output']
  rows: Array<ClipSocialStageRow>
  totalCsvRows: Scalars['Int']['output']
  validationErrors: Array<ClipSocialStageValidationError>
}

export type ClipSocialStageRow = {
  __typename?: 'ClipSocialStageRow'
  driveFileId: Scalars['String']['output']
  fileName: Scalars['String']['output']
  masterUrl: Scalars['String']['output']
  parentTitleGroupId: Scalars['String']['output']
  s3Key: Scalars['String']['output']
  stageMessage: Scalars['String']['output']
  stageStatus: ClipSocialStageStatus
  uploadExpiresAt?: Maybe<Scalars['DateTime']['output']>
  uploadUrl?: Maybe<Scalars['String']['output']>
}

/** Admin staging result for one Final List row (AP-19489). */
export enum ClipSocialStageStatus {
  DryRun = 'DRY_RUN',
  Error = 'ERROR',
  PendingUpload = 'PENDING_UPLOAD',
  Skipped = 'SKIPPED',
  Staged = 'STAGED',
}

export type ClipSocialStageValidationError = {
  __typename?: 'ClipSocialStageValidationError'
  fileName?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  rowIndex: Scalars['Int']['output']
}

/** Comment type */
export type Comment = {
  __typename?: 'Comment'
  /** The network-wide allowed reaction list. Comments have no feed, so the per-feed allow-list does not apply. A hint for the picker, not a write-time restriction. */
  allowedReactions: Array<Scalars['String']['output']>
  /** The body of the comment */
  comment?: Maybe<Scalars['String']['output']>
  /** The parent comment if this is a reply */
  commentParent?: Maybe<Comment>
  /** The child comments if this is a parent comment */
  commentsChildren?: Maybe<Array<Maybe<Comment>>>
  /** The content linked to this comment */
  content?: Maybe<Array<Maybe<Content>>>
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The type of the content */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The depth type of the comment */
  depthType?: Maybe<CommentDepthType>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * Whether the author deleted this comment.
   *
   * A deleted comment is a **tombstone**, not a missing row: it keeps its place in the thread and
   * keeps its replies, because replies are an adjacency list on `pid` and a client rebuilds a thread
   * by walking down from the root. Removing it would silently take every reply beneath it — other
   * members' replies. So `comment` and `subject` come back empty, `userInfo` and `userProfile` come
   * back null, and reactions are gone.
   *
   * Render it as deleted and offer no actions on it. Do NOT treat it as absent.
   */
  isDeleted: Scalars['Boolean']['output']
  /** The parent comment id if this comment is a reply */
  pid?: Maybe<Scalars['Int']['output']>
  /** Aggregated reactions, one entry per emoji that has at least one reaction. Empty until someone reacts — nothing ever renders a zero. */
  reactions: Array<CommentReactionSummary>
  /** Total count of all reactions across every emoji */
  reactionsCount: Scalars['Int']['output']
  /**
   * How many **direct** replies this comment has (CO-680).
   *
   * ⚠️ Direct children, not the whole subtree. A deeper reply is counted by its own parent, so a
   * root advertises only the replies reachable from its own row — the same meaning the replies
   * view then renders.
   *
   * Carries the same visibility predicate as the rows: a member's own held reply counts for them
   * and for nobody else. Zero is the normal value and renders no row at all.
   *
   * Exists so a comments list can show "N replies" without fetching the replies themselves.
   */
  repliesCount: Scalars['Int']['output']
  /**
   * The id of the thread root — null on a root comment, mirroring pid.
   *
   * pid says who a comment answers; this says which conversation it belongs to. Filtering on it
   * returns a whole reply tree of any depth in one query, so a client never fans out per level.
   */
  rootId?: Maybe<Scalars['Int']['output']>
  /** The status of the comment i.e. approved or not approved */
  status?: Maybe<CommentStatus>
  /** The subject (title) of the comment */
  subject?: Maybe<Scalars['String']['output']>
  /** The id of the user or null if anonymous */
  uid?: Maybe<Scalars['Int']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info linked to this comment (public fields only — no self/admin restriction) */
  userInfo?: Maybe<UserInfoPublic>
  /** Author's community profile (Brooklyn-local, no cross-service call). Null if user has no profile. */
  userProfile?: Maybe<UserProfile>
}

/** Comment type */
export type CommentCommentsChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** Content filter for comments */
export type CommentContentFilter = {
  /** The id of the content */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The type of the content */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** When true the content must be published */
  published?: InputMaybe<Scalars['Boolean']['input']>
}

export type CommentCreateInput = {
  /** The comment body text */
  comment: Scalars['String']['input']
  /** The content ID being commented on */
  contentId: Scalars['Int']['input']
  /**
   * Members this comment @mentions, resolved by the CLIENT (CO-655).
   *
   * ⚠️ The server never parses the body for mentions, and must not start. `UserProfile` has no
   * handle — only `displayName`, which is free text, may contain spaces, and can change. A mention
   * recovered from text would therefore break the moment a member renamed themselves, and could
   * resolve two similarly-named members to whichever matched first.
   *
   * So the client holds the uuid from whatever surface produced the mention (the reply target, or a
   * picker) and sends it here; the body text is display only. This mirrors Circles' post
   * `metadata.mentions`, which is the proven shape.
   *
   * Unknown or non-member uuids are dropped rather than erroring — a mention is a courtesy, not a
   * precondition for posting.
   */
  mentions?: InputMaybe<Array<CommentMentionInput>>
  /** Parent comment ID for replies (0 or omit for root comments) */
  pid?: InputMaybe<Scalars['Int']['input']>
  /** The subject/title (optional) */
  subject?: InputMaybe<Scalars['String']['input']>
}

/** The depth type of the comment */
export enum CommentDepthType {
  /** The comment is a reply */
  Reply = 'REPLY',
  /** The comment is a root comment */
  Root = 'ROOT',
}

/** One member a comment @mentions */
export type CommentMentionInput = {
  /** The mentioned member's profile uuid. Never the numeric uid — this comes from a client. */
  uuid: Scalars['ID']['input']
}

export type CommentMutationResponse = {
  __typename?: 'CommentMutationResponse'
  /** The created or updated comment */
  comment?: Maybe<Comment>
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output']
}

/** Aggregated reaction data for a single emoji */
export type CommentReactionSummary = {
  __typename?: 'CommentReactionSummary'
  /** Number of members who reacted with this emoji */
  count: Scalars['Int']['output']
  /** Whether the requesting member has reacted with this emoji */
  reacted: Scalars['Boolean']['output']
  /** The reaction emoji or custom key (e.g. '❤️' or 'gaia_earth') */
  reaction: Scalars['String']['output']
}

/** Comment status enum */
export enum CommentStatus {
  /** The comment was flagged by automated moderation and is awaiting human review — visible only to its author */
  AiFlagged = 'AI_FLAGGED',
  /** The comment was rejected by automated moderation, and was never live — visible only to its author */
  AiRejected = 'AI_REJECTED',
  /** The comment was flagged for re-review after publication */
  NeedsReview = 'NEEDS_REVIEW',
  /** The comment was created and has never been reviewed — visible only to its author */
  PendingReview = 'PENDING_REVIEW',
  /** The comment is published and visible to everyone */
  Published = 'PUBLISHED',
  /** The comment was reviewed and denied, and was never live — visible only to its author */
  Rejected = 'REJECTED',
  /** The comment is not published — legacy backlog, or taken down after having been live */
  Unpublished = 'UNPUBLISHED',
}

export type CommentUpdateInput = {
  /** Updated comment body */
  comment: Scalars['String']['input']
  /** The comment ID to update */
  id: Scalars['ID']['input']
  /** Updated subject (optional) */
  subject?: InputMaybe<Scalars['String']['input']>
}

/** Comment where id input type */
export type CommentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Comment where conditions to filter rows */
export type CommentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<CommentWhereIdInput>
  /** The parent id field where clause */
  pid?: InputMaybe<CommentWhereIdInput>
  /** The thread root field where clause — fetches a whole reply tree in one query */
  rootId?: InputMaybe<CommentWhereIdInput>
  /** The status field where clause */
  status?: InputMaybe<CommentWhereIdInput>
  /** The uid field where clause */
  uid?: InputMaybe<CommentWhereUidInput>
}

/** Comment where uid input type */
export type CommentWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Comment list response */
export type CommentsListResponse = {
  __typename?: 'CommentsListResponse'
  /** A list of comments */
  comments?: Maybe<Array<Maybe<Comment>>>
  /** The total number of comments matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Community event type */
export type CommunityEvent = {
  __typename?: 'CommunityEvent'
  /** Number of registered attendees */
  attendeeCount: Scalars['Int']['output']
  /** Maximum number of attendees (null = unlimited) */
  capacity?: Maybe<Scalars['Int']['output']>
  /** The event description */
  content: Scalars['String']['output']
  /** When the event was created */
  createdAt: Scalars['DateTime']['output']
  /** Current viewer's RSVP status */
  currentUserRsvp: RegistrationStatus
  /** When the event ends */
  endTime: Scalars['DateTime']['output']
  /** The feed ID this event belongs to */
  feedId: Scalars['ID']['output']
  /** The unique identifier for the event */
  id: Scalars['ID']['output']
  /** Event locations (virtual and/or physical) */
  locations: Array<CommunityEventLocation>
  /** Reminder notification settings */
  reminderSettings?: Maybe<CommunityEventReminderSettings>
  /** When the event starts */
  startTime: Scalars['DateTime']['output']
  /** Event status */
  status: CommunityEventStatus
  /** IANA timezone (e.g., 'America/Denver', 'UTC') */
  timeZone: Scalars['String']['output']
  /** The event title */
  title: Scalars['String']['output']
  /** When the event was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Shareable URL for this event */
  url?: Maybe<Scalars['String']['output']>
}

/** Paginated events connection */
export type CommunityEventConnection = {
  __typename?: 'CommunityEventConnection'
  /** Event edges */
  edges: Array<CommunityEventEdge>
  /** Pagination info */
  pageInfo: PageInfo
}

export type CommunityEventEdge = {
  __typename?: 'CommunityEventEdge'
  cursor: Scalars['String']['output']
  node: CommunityEvent
}

/** Event location (virtual or physical) */
export type CommunityEventLocation = {
  __typename?: 'CommunityEventLocation'
  /** Formatted address for physical locations */
  address?: Maybe<Scalars['String']['output']>
  /** Display name for physical locations */
  displayName?: Maybe<Scalars['String']['output']>
  /** Latitude coordinate (-90 to 90) */
  latitude?: Maybe<Scalars['Float']['output']>
  /** Longitude coordinate (-180 to 180) */
  longitude?: Maybe<Scalars['Float']['output']>
  /** Virtual meeting provider (e.g., 'Zoom', 'Google Meet') */
  provider?: Maybe<Scalars['String']['output']>
  /** Location type */
  type: EventLocationType
  /** URL for virtual events (e.g., Zoom link) */
  url?: Maybe<Scalars['String']['output']>
}

/** Input for event location */
export type CommunityEventLocationInput = {
  /** Formatted address */
  address?: InputMaybe<Scalars['String']['input']>
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Latitude (-90 to 90) */
  latitude?: InputMaybe<Scalars['Float']['input']>
  /** Longitude (-180 to 180) */
  longitude?: InputMaybe<Scalars['Float']['input']>
  /** Google Places ID */
  placeId?: InputMaybe<Scalars['String']['input']>
  /** Provider name (e.g., 'Zoom', 'Google Meet') */
  provider?: InputMaybe<Scalars['String']['input']>
  /** Location type */
  type: EventLocationType
  /** Meeting URL (required for VIRTUAL type) */
  url?: InputMaybe<Scalars['String']['input']>
}

/** Event registration summary */
export type CommunityEventRegistrationSummary = {
  __typename?: 'CommunityEventRegistrationSummary'
  /** The event */
  event: CommunityEvent
  /** When registered (null if not registered) */
  registeredAt?: Maybe<Scalars['DateTime']['output']>
  /** Current registration status */
  status: RegistrationStatus
}

/** Event reminder settings */
export type CommunityEventReminderSettings = {
  __typename?: 'CommunityEventReminderSettings'
  /** Whether reminders are enabled */
  enabled: Scalars['Boolean']['output']
  /** Minutes before event to send reminder (null = default) */
  remindBeforeMinutes?: Maybe<Scalars['Int']['output']>
}

/** Input for reminder settings */
export type CommunityEventReminderSettingsInput = {
  /** Enable reminders */
  enabled: Scalars['Boolean']['input']
  /** Minutes before event (null = default, e.g., 60) */
  remindBeforeMinutes?: InputMaybe<Scalars['Int']['input']>
}

export enum CommunityEventStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

/** Community feed type */
export type CommunityFeed = {
  __typename?: 'CommunityFeed'
  /** Feed banner/cover image URL */
  bannerUrl?: Maybe<Scalars['String']['output']>
  /** When the feed was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Custom reactions available in this feed */
  customReactions: Array<CustomReaction>
  /** The description of the feed */
  description?: Maybe<Scalars['String']['output']>
  /** Feed type: topic, circle, or null for general feeds */
  feedType?: Maybe<Scalars['String']['output']>
  /** The unique identifier for the feed */
  id: Scalars['ID']['output']
  /** Feed profile image URL */
  imageUrl?: Maybe<Scalars['String']['output']>
  /**
   * Whether the feed is invite-only
   * @deprecated Use visibility field instead
   */
  inviteOnly?: Maybe<Scalars['Boolean']['output']>
  /** Whether the current authenticated user is a member of this feed */
  isMember: Scalars['Boolean']['output']
  /** Whether the current authenticated user is a moderator of this feed */
  isModerator: Scalars['Boolean']['output']
  /** Whether the feed's chat is open: circles open at the configured member threshold (Sage-exempt count incl. host); non-circle feeds are always open */
  isOpen: Scalars['Boolean']['output']
  /**
   * Whether the feed is private
   * @deprecated Use visibility field instead
   */
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  /** Circle capacity from the pool config (countable members incl. host, excl. Sage); null for non-circle feeds */
  maxMembers?: Maybe<Scalars['Int']['output']>
  /** The number of members in the feed */
  memberCount?: Maybe<Scalars['Int']['output']>
  /** The display name of the feed */
  name?: Maybe<Scalars['String']['output']>
  /** Posts pinned to the top of this feed */
  pinnedPosts: Array<CommunityPost>
  /** Number of top-level posts (discussions) in this feed */
  postCount?: Maybe<Scalars['Int']['output']>
  /** Feed value / Page Manager path (e.g. 'topics/ancient-teachings' or 'ancient-teachings') */
  slug?: Maybe<Scalars['String']['output']>
  /** Content ID of the linked center/topic (null if not a topic feed) */
  topicContentId?: Maybe<Scalars['Int']['output']>
  /** Number of messages from other members created after the viewer's read position. A viewer who has never read the feed counts every other member's message as unread; 0 when unauthenticated. */
  unreadCount?: Maybe<Scalars['Int']['output']>
  /** Number of unread messages mentioning the viewer — the mention subset of unreadCount (0 if none, or when unauthenticated). */
  unreadMentionCount?: Maybe<Scalars['Int']['output']>
  /** When the feed was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The viewer's read position in this feed — the message time they have read up to; drives the NEW MESSAGES divider and unread counts (null = never read). Not the activity/presence timestamp; see CommunityFeedMemberEdge.lastReadAt. */
  viewerLastReadAt?: Maybe<Scalars['DateTime']['output']>
  /** Feed visibility level (PUBLIC or PRIVATE) */
  visibility?: Maybe<FeedVisibility>
}

/** Connection type for paginated CommunityFeed results */
export type CommunityFeedConnection = {
  __typename?: 'CommunityFeedConnection'
  /** List of feed edges */
  edges: Array<CommunityFeedEdge>
  /** Pagination information */
  pageInfo: PageInfo
}

/** Edge type for CommunityFeed pagination */
export type CommunityFeedEdge = {
  __typename?: 'CommunityFeedEdge'
  /** Cursor for this feed */
  cursor: Scalars['String']['output']
  /** The feed node */
  node: CommunityFeed
}

/** Connection for community feed members */
export type CommunityFeedMemberConnection = {
  __typename?: 'CommunityFeedMemberConnection'
  /** Member edges */
  edges: Array<CommunityFeedMemberEdge>
  /** Pagination info */
  pageInfo: PageInfo
}

/** Edge for community feed member — wraps UserProfile with feed-membership fields */
export type CommunityFeedMemberEdge = {
  __typename?: 'CommunityFeedMemberEdge'
  /** 1-based most-active rank within a CIRCLE's roster (weighted contribution), served only to viewers guaranteed a complete roster: the circle's own members and site admins passing includePrivate. Null in every other case. */
  activityRank?: Maybe<Scalars['Int']['output']>
  /** Cursor for pagination */
  cursor: Scalars['String']['output']
  /** When this member was last active in the feed — presence signal, bumped on every read or post (null = never). Not their read position; see CommunityFeed.viewerLastReadAt. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>
  /** The member's user profile */
  node: UserProfile
  /** Top-level published messages this member authored in this feed (includes shares — shareCount is a subset). On PRIVATE feeds all four stat fields resolve to 0 for viewers outside the membership wall. */
  postCount: Scalars['Int']['output']
  /** Reactions this member has GIVEN on this feed's published posts (giving measures contribution; received reactions measure popularity; 0 outside a PRIVATE feed's membership wall) */
  reactionCount: Scalars['Int']['output']
  /** Published thread replies (comments) this member authored in this feed (0 outside a PRIVATE feed's membership wall) */
  replyCount: Scalars['Int']['output']
  /** Member role in the feed */
  role?: Maybe<Scalars['String']['output']>
  /** Subset of postCount whose content contains an own-origin Gaia share URL (rendered as a share card in chat; 0 outside a PRIVATE feed's membership wall) */
  shareCount: Scalars['Int']['output']
}

/** Community leaderboard entry */
export type CommunityLeaderboardEntry = {
  __typename?: 'CommunityLeaderboardEntry'
  /** Number of comments on posts */
  commentCount: Scalars['Int']['output']
  /** Number of events attended */
  eventCount: Scalars['Int']['output']
  /** Number of posts */
  postCount: Scalars['Int']['output']
  /** Rank position */
  rank: Scalars['Int']['output']
  /** Number of reactions received */
  reactionCount: Scalars['Int']['output']
  /** Total score */
  score: Scalars['Int']['output']
  /** The user */
  user: UserProfile
}

/** Community moderation report */
export type CommunityModerationReport = {
  __typename?: 'CommunityModerationReport'
  /** The content that was flagged (post or comment) */
  contentId: Scalars['ID']['output']
  /** The content type (POST or COMMENT) */
  contentType: Scalars['String']['output']
  /** When the report was created */
  createdAt: Scalars['DateTime']['output']
  /** The unique identifier */
  id: Scalars['ID']['output']
  /** Reason for flagging */
  reason?: Maybe<Scalars['String']['output']>
  /** The user who flagged the content */
  reporter?: Maybe<UserProfile>
  /** When the report was resolved */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>
  /** Who resolved the report */
  resolvedBy?: Maybe<UserProfile>
  /** Current moderation status */
  status: ModerationStatus
}

/** Connection type for paginated CommunityModerationReport results */
export type CommunityModerationReportConnection = {
  __typename?: 'CommunityModerationReportConnection'
  /** List of report edges */
  edges: Array<CommunityModerationReportEdge>
  /** Pagination information */
  pageInfo: PageInfo
}

/** Edge type for CommunityModerationReport pagination */
export type CommunityModerationReportEdge = {
  __typename?: 'CommunityModerationReportEdge'
  /** Cursor for this edge */
  cursor: Scalars['String']['output']
  /** The report node */
  node: CommunityModerationReport
}

/** Community post type (includes both top-level posts and comments/replies) */
export type CommunityPost = {
  __typename?: 'CommunityPost'
  /** List of allowed reaction emojis for this post's feed */
  allowedReactions: Array<Scalars['String']['output']>
  /** The author of the post */
  author?: Maybe<UserProfile>
  /** The post content */
  content?: Maybe<Scalars['String']['output']>
  /** When the post was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The feed ID this post belongs to */
  feedId?: Maybe<Scalars['ID']['output']>
  /** The unique identifier for the post */
  id: Scalars['ID']['output']
  /** Whether this post is pinned to its feed */
  isPinned: Scalars['Boolean']['output']
  /** Structured payload: mentions ([{ uuid, displayName }] — public profile UUIDs) and rich-card data under card. Null for plain messages. */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** Author UID of the parent post (null for top-level posts). Used by AI service for reply-to-user detection. */
  parentAuthorUid?: Maybe<Scalars['ID']['output']>
  /** The parent post ID for threading (null for top-level posts, non-null for comments) */
  parentId?: Maybe<Scalars['ID']['output']>
  /** When the post was pinned (null if not pinned) */
  pinnedAt?: Maybe<Scalars['DateTime']['output']>
  /** Aggregated reaction summary for inline display */
  reactions: Array<PostReactionSummary>
  /** Total count of all reactions */
  reactionsCount: Scalars['Int']['output']
  /** Total count of replies/comments to this post */
  repliesCount: Scalars['Int']['output']
  /** The root post ID for deep threading (null for top-level posts) */
  rootPostId?: Maybe<Scalars['ID']['output']>
  /** The post status */
  status?: Maybe<Scalars['String']['output']>
  /** The post title (null for comments) */
  title?: Maybe<Scalars['String']['output']>
  /** When the post was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Connection type for paginated CommunityPost results */
export type CommunityPostConnection = {
  __typename?: 'CommunityPostConnection'
  /** List of post edges */
  edges: Array<CommunityPostEdge>
  /** Pagination information */
  pageInfo: PageInfo
}

/** Edge type for CommunityPost pagination */
export type CommunityPostEdge = {
  __typename?: 'CommunityPostEdge'
  /** Cursor for this post */
  cursor: Scalars['String']['output']
  /** The post node */
  node: CommunityPost
}

/** Sort order for community post listing */
export enum CommunityPostOrderBy {
  /** Sort by creation date (default) */
  CreatedAt = 'CREATED_AT',
  /** Sort by most recent engagement (reply or reaction) */
  LastActivityAt = 'LAST_ACTIVITY_AT',
  /** Sort by total reaction count (likes + custom reactions) */
  ReactionsCount = 'REACTIONS_COUNT',
  /** Sort by reply/comment count */
  RepliesCount = 'REPLIES_COUNT',
  /** Sort by trending score (engagement weighted by recency) */
  Trending = 'TRENDING',
}

/** Community reaction type */
export type CommunityReaction = {
  __typename?: 'CommunityReaction'
  /** The author of the reaction */
  author?: Maybe<UserProfile>
  /** When the reaction was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The unique identifier for the reaction */
  id: Scalars['ID']['output']
  /** The post ID this reaction belongs to */
  postId: Scalars['ID']['output']
  /** The reaction emoji */
  reaction: Scalars['String']['output']
}

export enum CompanionRole {
  Mid = 'MID',
  Post = 'POST',
  Pre = 'PRE',
}

/** Consume discount input */
export type ConsumeDiscountInput = {
  /** Whether the discount was used at signup or on plan change */
  action: BillingDiscountRedemptionAction
  /** Discount code */
  discountCode: Scalars['String']['input']
  /** When the discount was redeemed; defaults to the current time if omitted */
  redeemedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Plan SKU for this redemption */
  sku: Scalars['String']['input']
  /** User id (user_info.uid) */
  uid: Scalars['BigInt']['input']
}

/** Input for consuming a token-consumption check. A check without that flag is rejected. */
export type ConsumeRateLimitTokenInput = {
  /** Action that issued the token. A different action is rejected. */
  action: Scalars['String']['input']
  /** Consumption key. Defaults to default. Each key listed on the action config can be used once. An empty list allows default only. */
  consumptionKey?: InputMaybe<Scalars['String']['input']>
  /** FingerprintJS visitor id. Must match the check when that check used token consumption. */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** Token uuid from a passing check */
  token: Scalars['ID']['input']
  /** User id. Must match the check when that check used token consumption. Omit for an anonymous check. */
  uid?: InputMaybe<Scalars['Int']['input']>
}

/** Result of consumeRateLimitToken. The token is consumed whether or not rateLimit.enabled is on. */
export type ConsumeRateLimitTokenResult = {
  __typename?: 'ConsumeRateLimitTokenResult'
  /** False. Consumption is not skipped when rateLimit.enabled is off. */
  bypassed: Scalars['Boolean']['output']
  /** The request after the consumption key was stored. */
  request?: Maybe<RateLimitRequest>
}

/** Content entity from federated content service */
export type Content = {
  __typename?: 'Content'
  /** Anonymous description data for this content row (1:1 by content.id); null when no row exists */
  anon?: Maybe<ContentAnon>
  /** The assets description */
  assetsDescription?: Maybe<Scalars['String']['output']>
  /** The assets label */
  assetsLabel?: Maybe<Scalars['String']['output']>
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: Maybe<Scalars['String']['output']>
  /** The cast in the video */
  cast?: Maybe<Scalars['String']['output']>
  /** The content analytic linked to this content */
  contentAnalytic?: Maybe<ContentAnalytic>
  /**
   * Deterministic static file links (images, PDFs, worksheets). Preferred over `imageContentRelationships`.
   * Type strings: lib/services/assets/content-reference-types.ts. Resolve files via `asset.renderUrl`.
   */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>
  /** Clip Contents linked to this content (typically a video) via the clip-vert content reference */
  contentClips?: Maybe<Array<Maybe<Content>>>
  /** All courses that contain this content (for videos via course modules) */
  contentCourses?: Maybe<Array<Maybe<Content>>>
  /** The content document linked to this content */
  contentDocument?: Maybe<ContentDocument>
  /** Content linked to this content as an episode which have a default order of seasonNumber and then episodeNumber */
  contentEpisodes?: Maybe<Array<Maybe<Content>>>
  /** Content featured for this content */
  contentFeatured?: Maybe<ContentFeatured>
  /** The content filter set to display for this content */
  contentFilterSet?: Maybe<ContentFilterSet>
  /**
   * The content group identifier (NOT the primary key - do not confuse with id).
   * Also known as D6 nid. All translations of the same content share the same contentId.
   *
   * IMPORTANT: contentId is NOT useful without contentType. Always use contentId + contentType together
   * (and optionally language) to uniquely identify content. Use contentId + contentType + language to
   * uniquely identify a specific language version.
   *
   * NOTE: id is the primary key and is preferred for direct lookups. contentId + contentType is used for grouping translations.
   */
  contentId?: Maybe<Scalars['Int']['output']>
  /**
   * The content policy linked to this content that controls access, sharing, and availability.
   * Use contentPolicy.accessCheck to determine if the current user can access this content.
   */
  contentPolicy?: Maybe<ContentPolicy>
  /**
   * A reference to the content policy that controls access, sharing, and availability rules for this content.
   * The content policy determines which users can access the content based on subscriptions, countries,
   * client attributes, and other access control rules.
   */
  contentPolicyPolicyId?: Maybe<Scalars['Int']['output']>
  /** The content provider linked to this content */
  contentProvider?: Maybe<ContentProvider>
  /** The content references linked both to and from this content */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references link from this content */
  contentReferencesFrom?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references linked to this content */
  contentReferencesTo?: Maybe<Array<Maybe<ContentReference>>>
  /**
   * Content related to this content which defaults to video.
   * When using this query consider using @defer or multiple GraphQL queries
   * in an application for performance
   */
  contentRelated?: Maybe<Array<Maybe<Content>>>
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: Maybe<Scalars['Boolean']['output']>
  /** Content linked to this content as a series */
  contentSeries?: Maybe<Array<Maybe<Content>>>
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: Maybe<Scalars['String']['output']>
  /** The parent video Content for a clip (content_type=clip), resolved via the clip-vert content reference */
  contentVideo?: Maybe<Content>
  /** The copyright date as text */
  copyright?: Maybe<Scalars['String']['output']>
  /** Get course item progress for this content (if it is a video in a course) */
  courseItemProgress?: Maybe<UserStateProgressCourseItem>
  /** Get course module progress for this content (if it is a course module) */
  courseModuleProgress?: Maybe<UserStateProgressCourseModule>
  /** Get course progress for this content (if it is a course) */
  courseProgress?: Maybe<UserStateProgressCourse>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: Maybe<Scalars['String']['output']>
  /** the call to action label */
  ctaLabel?: Maybe<Scalars['String']['output']>
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: Maybe<Scalars['String']['output']>
  /** The url to purchase the product */
  ctaProductUrl?: Maybe<Scalars['String']['output']>
  /** The day number */
  dayNumber?: Maybe<Scalars['Int']['output']>
  /** The description in the given language */
  description?: Maybe<Scalars['String']['output']>
  /** The format of the long description (null = plain text) */
  descriptionFormat?: Maybe<Scalars['String']['output']>
  /** The directions description */
  directionsDescription?: Maybe<Scalars['String']['output']>
  /** The directions label */
  directionsLabel?: Maybe<Scalars['String']['output']>
  /** The name of the directory of the video */
  director?: Maybe<Scalars['String']['output']>
  /** The display type to be used in UI rendering */
  displayType?: Maybe<Scalars['String']['output']>
  /** The series season episode number */
  episodeNumber?: Maybe<Scalars['Int']['output']>
  /** Get a count of all episodes linked to this content */
  episodesCount?: Maybe<Scalars['Int']['output']>
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: Maybe<Scalars['Boolean']['output']>
  /** If true the content is family friendly */
  familyFriendly?: Maybe<Scalars['Boolean']['output']>
  /**
   * Playable feature media (full-length video). Resolves via `feature_media_id` → `media` → `media_assets`.
   * For HLS/DASH streams use `mediaAssets(mediaReferenceType: "ms")`. Not the same as static `assets` or `contentAssetReferences`.
   * Media roles: lib/services/content/media-types.ts. Reference types: lib/services/media-assets/reference-types.ts
   */
  featureMedia?: Maybe<Media>
  /** The foreign key to the media table to the feature media */
  featureMediaId?: Maybe<Scalars['ID']['output']>
  /** Optional filter type to include this content as a filter option */
  filterType?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this content record */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * Legacy image links (non-deterministic). Prefer `contentAssetReferences` for programmatic access.
   * Match provenance via `contentMatchReason`. Type strings overlap lib/services/images/types.js.
   */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>
  /** The name of the instructor in the video */
  instructor?: Maybe<Scalars['String']['output']>
  /** When true the content is considered new by published at or created at */
  isNew?: Maybe<Scalars['Boolean']['output']>
  /** The language of this content */
  language?: Maybe<Scalars['String']['output']>
  /** The language of this content in full text e.g. English */
  languageFullText?: Maybe<Scalars['String']['output']>
  /** The path part of a url which matches this content. Return path as relative or full URL. */
  path?: Maybe<Scalars['String']['output']>
  /** The path redirect by source linked to this content by path */
  pathRedirectBySource?: Maybe<PathRedirect>
  /** PM people list */
  peopleListId?: Maybe<Scalars['String']['output']>
  /** The requesting user playlist items for this content */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
  /** Preview media (trailer/teaser). Same path as `featureMedia` but via `preview_media_id`. */
  previewMedia?: Maybe<Media>
  /** The foreign key to the media table to the preview media */
  previewMediaId?: Maybe<Scalars['ID']['output']>
  /** The last unpublished date, kept after unpublishedAt is cleared on republish */
  previouslyUnpublishedAt?: Maybe<Scalars['DateTime']['output']>
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: Maybe<Scalars['String']['output']>
  /** The name of producer of the video */
  producer?: Maybe<Scalars['String']['output']>
  /** The product type identifier in UI rendering */
  productType?: Maybe<Scalars['String']['output']>
  /** The production status */
  productionStatus?: Maybe<Scalars['String']['output']>
  /**
   * Published state of the content. IMPORTANT: Content that is not published (published=false) should NEVER be accessible to end users.
   *
   * Published State Meanings:
   * - published=false: Content is NOT published and should NEVER be accessible. This content is hidden from all public access.
   * - published=true + publishedAtDate is in the future: Content is published but NOT YET playable. It can be discovered in search/browse but cannot be played until publishedAtDate is reached.
   * - published=true + publishedAtDate is now or in the past: Content is published AND playable (PUBLISHED_NOW state). This is the only state where content can be fully accessed and played.
   *
   * Use publishedState filter (PUBLISHED_NOW) to get only playable content, or published=true to get all discoverable content (including future-dated).
   */
  published?: Maybe<Scalars['Boolean']['output']>
  /**
   * The date and time when the content becomes playable. Used in combination with published field:
   * - If published=true and publishedAtDate is in the future: Content is discoverable but not playable
   * - If published=true and publishedAtDate is now or in the past: Content is playable (PUBLISHED_NOW)
   * - If published=false: Content is not accessible regardless of publishedAtDate
   */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** When performing a search query the relevance score */
  queryRelevanceScore?: Maybe<Scalars['Float']['output']>
  /**
   * Content↔content taxonomy links (episode→series, video→tag). Type strings from lib/services/content-reference-types/constants.ts.
   * Not the same as `contentAssetReferences` (content↔file).
   */
  references?: Maybe<Array<Maybe<ContentReference>>>
  /** The content references linked from this content which are considered tags useful in an apps when displaying tags */
  referencesByTypeTag?: Maybe<Array<Maybe<ContentReference>>>
  /**
   * Chunk-level document embeddings for this content (direct or feature media): vectors + `documentText` for semantic retrieval and RAG.
   *
   * Pass **`query`** to rank chunks by cosine similarity; omit it to list related chunks without query scoring. Pair with `ContentRelatedDocumentEmbeddings.summarizationText` for an on-the-fly narrative, or use `documentAbstractList` for offline pooled vectors over chunks (`sumEmbedding` / `averageEmbedding`).
   */
  relatedDocumentEmbeddings?: Maybe<ContentRelatedDocumentEmbeddings>
  /** The series season number */
  seasonNumber?: Maybe<Scalars['Int']['output']>
  /** Get a count of all seasons linked to this content */
  seasonsCount?: Maybe<Scalars['Int']['output']>
  /** The SEO canonical url */
  seoCanonicalUrl?: Maybe<Scalars['String']['output']>
  /** The SEO short description in the given language */
  seoDescription?: Maybe<Scalars['String']['output']>
  /** The SEO keywords in the given language */
  seoKeywords?: Maybe<Scalars['String']['output']>
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: Maybe<Scalars['Boolean']['output']>
  /** The SEO no index attribute */
  seoRobotsNoIndex?: Maybe<Scalars['Boolean']['output']>
  /** The SEO title of this video in the given language */
  seoTitle?: Maybe<Scalars['String']['output']>
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: Maybe<Scalars['String']['output']>
  /** The short description in the given language */
  shortDescription?: Maybe<Scalars['String']['output']>
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: Maybe<Scalars['String']['output']>
  /** The studio where the video was filmed */
  studio?: Maybe<Scalars['String']['output']>
  /** The content sub type used by apps for rendering (not useful in other contexts) */
  subType?: Maybe<Scalars['String']['output']>
  /** The third party description in the given language */
  thirdPartyDescription?: Maybe<Scalars['String']['output']>
  /** The title of this video in the given language */
  title?: Maybe<Scalars['String']['output']>
  /**
   * A human-readable identifier that groups all translations of the same content together.
   * Format: "{contentId}-{contentType}" (e.g., "123-video").
   * All language versions of the same content share the same titleGroupId.
   * Use this field to query for all translations of a piece of content or to group content by title.
   */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /**
   * A human-readable identifier that uniquely identifies a specific language version of content.
   * Format: "{contentId}-{contentType}-{language}" (e.g., "123-video-en").
   * This is globally unique across all content - each language version has a unique titleId.
   *
   * NOTE: contentId is PREFERRED over titleId for querying and programmatic access.
   * Use contentId + contentType + language instead when possible.
   */
  titleId?: Maybe<Scalars['String']['output']>
  /** The date the content was unpublished (when published was changed from true to false). Cleared when that language is published again. */
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The requesting user latest vote for this content */
  vote?: Maybe<Vote>
  /** The weight when ordering in lists */
  weight?: Maybe<Scalars['Int']['output']>
  /** The name of the video */
  writer?: Maybe<Scalars['String']['output']>
}

/** Content entity from federated content service */
export type ContentContentAssetReferencesArgs = {
  contentAssetReferences?: InputMaybe<Array<InputMaybe<ContentAssetReferenceFilterInput>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentClipsArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentCoursesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentEpisodesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentReferencesFromArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentReferencesToArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentRelatedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<ContentRelatedType>
}

/** Content entity from federated content service */
export type ContentContentSeriesArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentContentVideoArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentCourseItemProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Content entity from federated content service */
export type ContentCourseModuleProgressArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Content entity from federated content service */
export type ContentDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** Content entity from federated content service */
export type ContentEpisodesCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  seasonNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content entity from federated content service */
export type ContentImageContentRelationshipsArgs = {
  imageContentRelationships?: InputMaybe<
    Array<InputMaybe<ContentImageContentRelationshipsFilterInput>>
  >
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentPathArgs = {
  format?: InputMaybe<ContentPathFormat>
}

/** Content entity from federated content service */
export type ContentReferencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typesByTypeTag?: InputMaybe<Scalars['Boolean']['input']>
}

/** Content entity from federated content service */
export type ContentRelatedDocumentEmbeddingsArgs = {
  embeddingConfigKey?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

/** Content entity from federated content service */
export type ContentSeasonsCountArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content entity from federated content service */
export type ContentShortDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** AI-assessed learner level from summary validator (score, level, reasoning). */
export type ContentAiLearnerLevel = {
  __typename?: 'ContentAILearnerLevel'
  /** Validator-assigned learner level (e.g. beginner, intermediate). */
  level?: Maybe<Scalars['String']['output']>
  /** Validator reasoning for the assigned level. */
  reasoning?: Maybe<Scalars['String']['output']>
  /** Validator score for the learner level. */
  score?: Maybe<Scalars['Int']['output']>
}

/** Look up AI metadata by either mediaId (feature media id) or contentId; language is required. */
export type ContentAiMetadataInput = {
  /** Content identifier (use when you have the content id). */
  contentId?: InputMaybe<Scalars['ID']['input']>
  /** Language/locale for the metadata (e.g. en, es). */
  language: Scalars['String']['input']
  /** Feature media identifier (use when you have the media id). */
  mediaId?: InputMaybe<Scalars['ID']['input']>
}

/** Content analytic */
export type ContentAnalytic = {
  __typename?: 'ContentAnalytic'
  /** The total number of comments for this content */
  commentsCountTotal?: Maybe<Scalars['Int']['output']>
  /** The content linked to this content analytic */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content id for the content this analytics row */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content type for the content this analytics row */
  contentType?: Maybe<Scalars['String']['output']>
  /** One day video play count for the content */
  count1Day?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for the content */
  count3Day?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for German content */
  count3dDe?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for English content */
  count3dEn?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for Spanish content */
  count3dEs?: Maybe<Scalars['Int']['output']>
  /** Three day video play count for French content */
  count3dFr?: Maybe<Scalars['Int']['output']>
  /** seven day video play count for the content */
  count7Day?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for German content */
  count7dDe?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for English content */
  count7dEn?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for Spanish content */
  count7dEs?: Maybe<Scalars['Int']['output']>
  /** Seven day video play count for French content */
  count7dFr?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for German content */
  countShares7dDe?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for English content */
  countShares7dEn?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for Spanish content */
  countShares7dEs?: Maybe<Scalars['Int']['output']>
  /** 7 day share count for French content */
  countShares7dFr?: Maybe<Scalars['Int']['output']>
  /** rolling 7 day share count for German content */
  countSharesDailyDe?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for English content */
  countSharesDailyEn?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for Spanish content */
  countSharesDailyEs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** rolling 7 day share count for French content */
  countSharesDailyFr?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** forever video play count for the content */
  countTotal?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** daily counts for all languages (plus combined 'all') */
  languageCounts?: Maybe<Scalars['JSON']['output']>
  /** Stable key for FE i18n; null when ratio is below the lowest band or there are no votes */
  thumbPopularityMappingId?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The total number of votes for this content */
  votesCountTotal?: Maybe<Scalars['Int']['output']>
  /** The total number of up votes for this content */
  votesUpCountTotal?: Maybe<Scalars['Int']['output']>
}

/** Content analytic where id input type */
export type ContentAnalyticWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content analytic where conditions to filter rows */
export type ContentAnalyticWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentAnalyticWhereIdInput>
  /** The title group id field where clause */
  titleGroupId?: InputMaybe<ContentAnalyticWhereTitleGroupIdInput>
}

/** Content analytic where title group id input type */
export type ContentAnalyticWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content analytic list response */
export type ContentAnalyticsListResponse = {
  __typename?: 'ContentAnalyticsListResponse'
  /** A list of Content analytic */
  contentAnalytics?: Maybe<Array<Maybe<ContentAnalytic>>>
}

/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnon = {
  __typename?: 'ContentAnon'
  /** The Content row primary key (Content.id) this anon row belongs to. Not the content group id (Content.contentId). */
  contentId?: Maybe<Scalars['ID']['output']>
  /** The description (optional format and truncate as on Content.description) */
  description?: Maybe<Scalars['String']['output']>
  /** The format of the long description (null = plain text) */
  descriptionFormat?: Maybe<Scalars['String']['output']>
  /** FAQ entries for GEO (JSON array of question/answer objects) */
  faqs?: Maybe<Scalars['JSON']['output']>
  /** The short description (optional format and truncate as on Content.shortDescription) */
  shortDescription?: Maybe<Scalars['String']['output']>
  /** The format of the short description (null = plain text) */
  shortDescriptionFormat?: Maybe<Scalars['String']['output']>
}

/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnonDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** Anonymous description data for a content row (1:1 with Content by content.id) */
export type ContentAnonShortDescriptionArgs = {
  format?: InputMaybe<ContentTextFormat>
  truncate?: InputMaybe<Scalars['Int']['input']>
}

/** Input for creating content anon (1:1 with Content by content.id) */
export type ContentAnonCreateInput = {
  /** Content row primary key (Content.id) this anon row belongs to */
  contentId: Scalars['ID']['input']
  /** Description (long) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Format of description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** FAQ entries (JSON array of question/answer objects) */
  faqs?: InputMaybe<Scalars['JSON']['input']>
  /** Short description */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  /** Format of short description (null = plain text); same values as ContentTextFormat stored value */
  shortDescriptionFormat?: InputMaybe<Scalars['String']['input']>
}

/** Response for contentAnon create mutation */
export type ContentAnonCreateResponse = {
  __typename?: 'ContentAnonCreateResponse'
  /** The created content anon */
  contentAnon?: Maybe<ContentAnon>
}

/** Input for deleting content anon by content id */
export type ContentAnonDeleteInput = {
  /** Content row primary key (Content.id) */
  contentId: Scalars['ID']['input']
}

/** Response for contentAnon delete mutation */
export type ContentAnonDeleteResponse = {
  __typename?: 'ContentAnonDeleteResponse'
  /** The deleted content anon */
  contentAnon?: Maybe<ContentAnon>
}

/** Input for updating content anon by content id */
export type ContentAnonUpdateInput = {
  /** Content row primary key (Content.id) */
  contentId: Scalars['ID']['input']
  /** Description (long) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Format of description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** FAQ entries (JSON array of question/answer objects) */
  faqs?: InputMaybe<Scalars['JSON']['input']>
  /** Short description */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  /** Format of short description (null = plain text) */
  shortDescriptionFormat?: InputMaybe<Scalars['String']['input']>
}

/** Response for contentAnon update mutation */
export type ContentAnonUpdateResponse = {
  __typename?: 'ContentAnonUpdateResponse'
  /** The updated content anon */
  contentAnon?: Maybe<ContentAnon>
}

/**
 * Deterministic link between content and a static file (`assets` row).
 * Unique on `content_title_group_id` + type + `assets_id`. Preferred over legacy `ImageContentRelationship`.
 * Type strings: lib/services/assets/content-reference-types.ts. Resolve files via `asset.renderUrl`.
 */
export type ContentAssetReference = {
  __typename?: 'ContentAssetReference'
  /** The asset linked to the content asset reference */
  asset?: Maybe<Asset>
  /** The asset id foreign key */
  assetsId?: Maybe<Scalars['ID']['output']>
  /** The content list linked to the content asset reference */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content asset reference type directly linked to this content asset reference */
  contentAssetReferenceType?: Maybe<ContentAssetReferenceType>
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * Deterministic link between content and a static file (`assets` row).
 * Unique on `content_title_group_id` + type + `assets_id`. Preferred over legacy `ImageContentRelationship`.
 * Type strings: lib/services/assets/content-reference-types.ts. Resolve files via `asset.renderUrl`.
 */
export type ContentAssetReferenceAssetArgs = {
  filter?: InputMaybe<AssetFilterInput>
}

/**
 * Deterministic link between content and a static file (`assets` row).
 * Unique on `content_title_group_id` + type + `assets_id`. Preferred over legacy `ImageContentRelationship`.
 * Type strings: lib/services/assets/content-reference-types.ts. Resolve files via `asset.renderUrl`.
 */
export type ContentAssetReferenceContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
}

/** Input type for creating a new content asset reference */
export type ContentAssetReferenceCreateInput = {
  /** The assets_id of the asset */
  assetsId: Scalars['ID']['input']
  /** The content_asset_reference_types_id of the content asset reference type */
  contentAssetReferenceTypesId: Scalars['ID']['input']
  /** The content_title_group_id of the content title group */
  contentTitleGroupId: Scalars['ID']['input']
  /** The primary key (optional) */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Input type for deleting an existing content asset reference */
export type ContentAssetReferenceDeleteInput = {
  /** The primary key of the content asset reference to delete */
  id: Scalars['ID']['input']
}

export type ContentAssetReferenceFilterInput = {
  /** The content asset reference types id foreign key */
  contentAssetReferenceTypesId?: InputMaybe<Scalars['ID']['input']>
  /** The content contentTitleGroupId foreign key */
  contentTitleGroupId?: InputMaybe<Scalars['String']['input']>
  /** The content asset reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Response object containing a boolean property of success and the created/deleted content asset reference */
export type ContentAssetReferenceMutationResponse = {
  __typename?: 'ContentAssetReferenceMutationResponse'
  /** The created or deleted content asset reference */
  contentAssetReference?: Maybe<ContentAssetReference>
  /** A boolean property of success indicating whether the operation was successful */
  success: Scalars['Boolean']['output']
}

/**
 * Catalog row for a content↔file reference type (`content_asset_reference_types.type`).
 * Seed values match strings in lib/services/assets/content-reference-types.ts.
 */
export type ContentAssetReferenceType = {
  __typename?: 'ContentAssetReferenceType'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The content asset reference type */
  type?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** ContentAssetReferenceType where id input */
export type ContentAssetReferenceTypeWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** ContentAssetReferenceType where input */
export type ContentAssetReferenceTypeWhereInput = {
  /** ContentAssetReferenceType where id clause */
  id?: InputMaybe<ContentAssetReferenceTypeWhereIdInput>
}

/** ContentAssetReferenceTypes list response */
export type ContentAssetReferenceTypesListResponse = {
  __typename?: 'ContentAssetReferenceTypesListResponse'
  /** A list of assets */
  contentAssetReferenceTypes?: Maybe<Array<Maybe<ContentAssetReferenceType>>>
}

/** ContentAssetReference where id input */
export type ContentAssetReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** ContentAssetReference where input */
export type ContentAssetReferenceWhereInput = {
  /** ContentAssetReference where id clause */
  id?: InputMaybe<ContentAssetReferenceWhereIdInput>
}

/** ContentAssetReferences list response */
export type ContentAssetReferencesListResponse = {
  __typename?: 'ContentAssetReferencesListResponse'
  /** A list of assets */
  contentAssetReferences?: Maybe<Array<Maybe<ContentAssetReference>>>
}

/** Content content provider filter input */
export type ContentContentProviderFilterInput = {
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content content references from filter input */
export type ContentContentReferencesFromFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Content content references to filter input */
export type ContentContentReferencesToFilterInput = {
  /** The content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content reference type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Return type for content create */
export type ContentCreateResponse = {
  __typename?: 'ContentCreateResponse'
  /** The newly created content */
  content?: Maybe<Content>
  /** True when a new language row was inserted (false when empty fields were filled on an existing row) */
  created?: Maybe<Scalars['Boolean']['output']>
  /** Translatable field names filled on an existing language row (empty when creating or when nothing was empty) */
  filledFields?: Maybe<Array<Scalars['String']['output']>>
}

/**
 * **`content_documents` join row:** pairs one **`Content`** (`contentId`) with one **`documents`** row (`documentsId`). This is the **primary** way a catalog title becomes “the document” for chunk indexing when the pipeline is content-driven: the worker builds **`document_embeddings`** from that title’s text (and related media), and **`Document.documentContent`** / the **`Document.content`** list resolve through this link.
 *
 * **Contrast with `media_asset_documents`:** If the document is instead linked **only** to a **`MediaAsset`**, there is no `content_documents` row; **`Document.documentContent`** is `null` while **`Document.content`** may still list titles discovered via **`featureMediaId`**. See **`Document`** type docs for resolver precedence between content-linked and media-linked paths.
 *
 * **Embeddings / abstract:** Chunks remain on **`Document.documentEmbeddings`**; whole-title synopsis and pooled chunk vectors are on **`Document.documentAbstract`** / **`documentAbstractList`** (`document_abstracts`).
 */
export type ContentDocument = {
  __typename?: 'ContentDocument'
  /** The **`Content`** row for this join (catalog metadata: title, episode, path, etc.). */
  content?: Maybe<Content>
  /** `Content` primary key participating in this link. */
  contentId?: Maybe<Scalars['ID']['output']>
  /** Join row creation time. */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The **`Document`** row used for embeddings and worker processing for this title. */
  document?: Maybe<Document>
  /** `documents.id` participating in this link. */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** Join row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content featured */
export type ContentFeatured = {
  __typename?: 'ContentFeatured'
  /** The featured content */
  content?: Maybe<Content>
  /** The featured type indicating the user's progress: first (no progress), next (in progress), last (final video to watch), continue (resume watching), latest (all complete, active production) */
  featuredType?: Maybe<Scalars['String']['output']>
}

/** Content filter */
export type ContentFilter = {
  __typename?: 'ContentFilter'
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filter set linked to this content filter */
  contentFilterSet?: Maybe<ContentFilterSet>
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The filter set to which this filter belongs */
  filterSet?: Maybe<Scalars['String']['output']>
  /** The filter type to which this filter belongs */
  filterType?: Maybe<Scalars['String']['output']>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content filter */
export type ContentFilterContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/**
 * The content filter for associated content.
 *
 * IMPORTANT: Published state filtering:
 * - published=true: Returns content that is discoverable (may include future-dated content that's not yet playable)
 * - published=false: Should NEVER be used in production queries - unpublished content should never be accessible
 * - publishedState=PUBLISHED_NOW: Returns only playable content (published=true AND publishedAtDate is now or in past)
 * - publishedState=PUBLISHED: Returns all discoverable content (published=true, regardless of publishedAtDate)
 *
 * For playable content, always use publishedState=PUBLISHED_NOW or ensure published=true AND publishedAtDate is in the past.
 */
export type ContentFilterInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content language */
  language?: InputMaybe<Scalars['String']['input']>
  /**
   * The content published state (does not consider published at date - see publishedState for date-aware filtering).
   * WARNING: published=false should NEVER be accessible to end users. Use publishedState filter instead.
   */
  published?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Alias for various content published states that considers both published flag and publishedAtDate.
   * Use PUBLISHED_NOW to get only playable content, or PUBLISHED to get all discoverable content (including future-dated).
   */
  publishedState?: InputMaybe<ContentFilterPublishedState>
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
}

/** Content filter list response */
export type ContentFilterListResponse = {
  __typename?: 'ContentFilterListResponse'
  /** A list of content reference */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>
}

/**
 * Content filter types for various content published states.
 *
 * Published State Meanings:
 * - PUBLISHED: Content where published=true (regardless of publishedAtDate). This includes:
 *   * Content that is discoverable but not yet playable (publishedAtDate in future)
 *   * Content that is playable (publishedAtDate is now or in past)
 *   Use this to get all discoverable content, including future-dated content.
 *
 * - PUBLISHED_NOW: Content where published=true AND publishedAtDate is now or in the past.
 *   This is the ONLY state where content is playable. Use this filter to get only content
 *   that can actually be played by users.
 *
 * IMPORTANT: Content with published=false should NEVER be accessible, regardless of publishedAtDate.
 */
export enum ContentFilterPublishedState {
  /**
   * The content published is true (does not consider published at date).
   * Includes both playable content and future-dated discoverable content.
   */
  Published = 'PUBLISHED',
  /**
   * The content published is true and published at date is now or in the past.
   * This is the ONLY state where content is playable. Use this to filter for content
   * that users can actually access and play.
   */
  PublishedNow = 'PUBLISHED_NOW',
}

/** Content filter set */
export type ContentFilterSet = {
  __typename?: 'ContentFilterSet'
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filters in this content filter set */
  contentFilters?: Maybe<Array<Maybe<ContentFilter>>>
  /** The content_id field on the content table */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content_type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** A list of content_filter types in display order from left to right */
  filterTypeOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The filter set to which this filter belongs */
  name?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content filter set */
export type ContentFilterSetContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter set list response */
export type ContentFilterSetListResponse = {
  __typename?: 'ContentFilterSetListResponse'
  /** A list of content reference */
  contentFilterSets?: Maybe<Array<Maybe<ContentFilterSet>>>
}

/** Content path redirect type where input type */
export type ContentFilterSetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content filter set where conditions to filter rows */
export type ContentFilterSetWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentFilterSetWhereIdInput>
  /** The name field where clause */
  name?: InputMaybe<ContentFilterSetWhereNameInput>
}

/** Content filter set filter type where input type */
export type ContentFilterSetWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter filter set where input type */
export type ContentFilterWhereFilterSetInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter filter type where input type */
export type ContentFilterWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content path redirect type where input type */
export type ContentFilterWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content filter where conditions to filter rows */
export type ContentFilterWhereInput = {
  /** The filterSet field where clause */
  filterSet?: InputMaybe<ContentFilterWhereFilterSetInput>
  /** The filterSet field where clause */
  filterType?: InputMaybe<ContentFilterWhereFilterTypeInput>
  /** The id field where clause */
  id?: InputMaybe<ContentFilterWhereIdInput>
}

/** The content filter for associated imageContentRelationships */
export type ContentImageContentRelationshipsFilterInput = {
  /** The image content relationship language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The image content relationship type */
  type?: InputMaybe<Scalars['String']['input']>
}

/** Single piece of content as input */
export type ContentInput = {
  /** The assets description */
  assetsDescription?: InputMaybe<Scalars['String']['input']>
  /** The assets label */
  assetsLabel?: InputMaybe<Scalars['String']['input']>
  /** Bundle for a tag, (d6 vocabulary vid) */
  bundle?: InputMaybe<Scalars['String']['input']>
  /** The cast in the video */
  cast?: InputMaybe<Scalars['String']['input']>
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** A reference to the content policy */
  contentPolicyPolicyId?: InputMaybe<Scalars['Int']['input']>
  /** When true the content will be visible in content search */
  contentSearchNoIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** The content type which can be expanded in the future i.e. video or series */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The copyright date as text */
  copyright?: InputMaybe<Scalars['String']['input']>
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** the deeplink path on the gaia app where the promoted item lives */
  ctaDeeplinkPath?: InputMaybe<Scalars['String']['input']>
  /** the call to action label */
  ctaLabel?: InputMaybe<Scalars['String']['input']>
  /** the path on the gaia web app where the promoted item lives */
  ctaPath?: InputMaybe<Scalars['String']['input']>
  /** The URL to purchase the product */
  ctaProductUrl?: InputMaybe<Scalars['String']['input']>
  /** The day number */
  dayNumber?: InputMaybe<Scalars['Int']['input']>
  /** The description in the given language */
  description?: InputMaybe<Scalars['String']['input']>
  /** The format of the long description (null = plain text) */
  descriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** The directions description */
  directionsDescription?: InputMaybe<Scalars['String']['input']>
  /** The directions label */
  directionsLabel?: InputMaybe<Scalars['String']['input']>
  /** The name of the directory of the video */
  director?: InputMaybe<Scalars['String']['input']>
  /** The display type to be used in UI rendering */
  displayType?: InputMaybe<Scalars['String']['input']>
  /** The series season episode number */
  episodeNumber?: InputMaybe<Scalars['Int']['input']>
  /** When true the content will be excluded from recommendations */
  excludeFromRecommendations?: InputMaybe<Scalars['Boolean']['input']>
  /** If true the content is family friendly */
  familyFriendly?: InputMaybe<Scalars['Boolean']['input']>
  /** The foreign key to the media table to the feature media */
  featureMediaId?: InputMaybe<Scalars['ID']['input']>
  /** Optional filter type to include this content as a filter option */
  filterType?: InputMaybe<Scalars['String']['input']>
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The name of the instructor in the video */
  instructor?: InputMaybe<Scalars['String']['input']>
  /** The language of this content */
  language?: InputMaybe<Scalars['String']['input']>
  /** The path part of a url which matches this content */
  path?: InputMaybe<Scalars['String']['input']>
  /** PM people list */
  peopleListId?: InputMaybe<Scalars['String']['input']>
  /** The foreign key to the media table to the preview media */
  previewMediaId?: InputMaybe<Scalars['ID']['input']>
  /** The language of content that was used to create all of the translations */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>
  /** The name of producer of the video */
  producer?: InputMaybe<Scalars['String']['input']>
  /** The product type identifier in UI rendering */
  productType?: InputMaybe<Scalars['String']['input']>
  /** The production status */
  productionStatus?: InputMaybe<Scalars['String']['input']>
  /** True if the video is published */
  published?: InputMaybe<Scalars['Boolean']['input']>
  /** The date the content was published to allow sorting by language */
  publishedAtDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The series season number */
  seasonNumber?: InputMaybe<Scalars['Int']['input']>
  /** The SEO canonical url */
  seoCanonicalUrl?: InputMaybe<Scalars['String']['input']>
  /** The SEO short description in the given language */
  seoDescription?: InputMaybe<Scalars['String']['input']>
  /** The SEO keywords in the given language */
  seoKeywords?: InputMaybe<Scalars['String']['input']>
  /** The SEO no follow attribute */
  seoRobotsNoFollow?: InputMaybe<Scalars['Boolean']['input']>
  /** The SEO no index attribute */
  seoRobotsNoIndex?: InputMaybe<Scalars['Boolean']['input']>
  /** The SEO title of this video in the given language */
  seoTitle?: InputMaybe<Scalars['String']['input']>
  /** The share URL for this content, constructed based on content policy shareAllowed setting */
  shareUrl?: InputMaybe<Scalars['String']['input']>
  /** The short description in the given language */
  shortDescription?: InputMaybe<Scalars['String']['input']>
  /** The format of the long description (null = plain text) */
  shortDescriptionFormat?: InputMaybe<Scalars['String']['input']>
  /** The studio where the video was filmed */
  studio?: InputMaybe<Scalars['String']['input']>
  /** The third party description in the given language */
  thirdPartyDescription?: InputMaybe<Scalars['String']['input']>
  /** The title of this video in the given language */
  title?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is unique for all content */
  titleId?: InputMaybe<Scalars['String']['input']>
  /** The date the content was unpublished */
  unpublishedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The date the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The weight when ordering in lists */
  weight?: InputMaybe<Scalars['Int']['input']>
  /** The name of the video */
  writer?: InputMaybe<Scalars['String']['input']>
}

/** Content link payload for component rendering. */
export type ContentLinkDocument = {
  __typename?: 'ContentLinkDocument'
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  path: Scalars['String']['output']
  title: Scalars['String']['output']
}

/** Content list criteria */
export type ContentListCriteria = {
  __typename?: 'ContentListCriteria'
  /** The content linked to this content list criteria */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content filter set linked to this content list criteria */
  contentFilterSet?: Maybe<ContentFilterSet>
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** How content list should be filtered by the content set */
  criteria?: Maybe<ContentListCriteriaCriteria>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The language for to match for the criteria */
  language?: Maybe<Scalars['String']['output']>
  /** When true, tag listing pages may offer Recombee personalized sort */
  recombeeEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Recombee scenario base name (platform suffix applied at runtime) */
  recombeeScenario?: Maybe<Scalars['String']['output']>
  /** How should the content be sorted */
  sort?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content list criteria */
export type ContentListCriteriaContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** One content list criteria row as input */
export type ContentListCriteriaCreateInput = {
  /** The content content id i.e. all translations of this content share the same content.content_id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** When the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** How content list should be filtered by the content set */
  criteria?: InputMaybe<ContentListCriteriaCriteriaInput>
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The language for to match for the criteria */
  language?: InputMaybe<Scalars['String']['input']>
  /** When true, tag listing pages may offer Recombee personalized sort */
  recombeeEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Recombee scenario base name (platform suffix applied at runtime) */
  recombeeScenario?: InputMaybe<Scalars['String']['input']>
  /** How should the content be sorted */
  sort?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is identifies the content in a title group e.g. content.titleGroupId */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
  /** A human readable id that is unique for all content e.g. content.titleId */
  titleId?: InputMaybe<Scalars['String']['input']>
  /** When the row was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Content list criteria criteria to be applied to content when filtering */
export type ContentListCriteriaCriteria = {
  __typename?: 'ContentListCriteriaCriteria'
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: Maybe<Array<Maybe<ContentListCriteriaCriteriaItem>>>
}

/** One Content list criteria criteria */
export type ContentListCriteriaCriteriaInput = {
  /** Criteria to apply when there are no content filters are specified with the content filter set */
  all?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>
  /** Criteria to apply when any content filters are specified with the content filter set */
  filtered?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>
}

/** Content list criteria criteria item to be applied to content when filtering */
export type ContentListCriteriaCriteriaItem = {
  __typename?: 'ContentListCriteriaCriteriaItem'
  /** The content content type i.e. video, series, etc. */
  contentType?: Maybe<Scalars['String']['output']>
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: Maybe<Scalars['String']['output']>
}

/** One content list criteria criteria item */
export type ContentListCriteriaCriteriaItemInput = {
  /** The content content type i.e. video, series, etc. */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content product type i.e. episode, segment, single, etc. */
  productType?: InputMaybe<Scalars['String']['input']>
}

/** One content list criteria row as input */
export type ContentListCriteriaDeleteInput = {
  /** The primary key for this record */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Content list criteria list response */
export type ContentListCriteriaListResponse = {
  __typename?: 'ContentListCriteriaListResponse'
  /** A list of content list criteria */
  contentListCriteria?: Maybe<Array<Maybe<ContentListCriteria>>>
}

/** Mutation response for a content list mutation */
export type ContentListCriteriaMutationResponse = {
  __typename?: 'ContentListCriteriaMutationResponse'
  /** The content list criteria that was mutated */
  contentListCriteria?: Maybe<ContentListCriteria>
}

/** Content list criteria id where input type */
export type ContentListCriteriaWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content list criteria where conditions to filter rows */
export type ContentListCriteriaWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentListCriteriaWhereIdInput>
  /** The id field where clause */
  titleGroupId?: InputMaybe<ContentListCriteriaWhereTitleGroupIdInput>
}

/** Content list criteria title group id where input type */
export type ContentListCriteriaWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content list response */
export type ContentListResponse = {
  __typename?: 'ContentListResponse'
  /** A list of content */
  content?: Maybe<Array<Maybe<Content>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** Debug information from the resolver */
  debug?: Maybe<Scalars['JSON']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Get a overview text of the content list */
  overview?: Maybe<DocumentAnswer>
}

/** Content list response */
export type ContentListResponseOverviewArgs = {
  context?: InputMaybe<ContentOverviewContext>
  format?: InputMaybe<ContentTextFormat>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type ContentNotFilterInput = {
  /** The content id to exclude */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content type to exclude */
  contentType?: InputMaybe<Scalars['String']['input']>
}

/** The type of summarization to perform which determines the text summarization style */
export enum ContentOverviewContext {
  /** The default summarization style */
  Default = 'DEFAULT',
  /** The summarization style for a user search query */
  UserSearchQuery = 'USER_SEARCH_QUERY',
}

/** Format for the content path: relative path only or full URL including domain */
export enum ContentPathFormat {
  /** The full URL including domain (e.g. servers.webapp + path) */
  Full = 'FULL',
  /** The path segment only (e.g. video/slug). Default. */
  Relative = 'RELATIVE',
}

/** A playlist entry in a content-to-playlist mapping */
export type ContentPlaylistEntry = {
  __typename?: 'ContentPlaylistEntry'
  /** Total number of items in the playlist */
  itemCount?: Maybe<Scalars['Int']['output']>
  /** The playlist UUID */
  playlistId: Scalars['ID']['output']
  /** The playlist name */
  playlistName?: Maybe<Scalars['String']['output']>
}

/** Mapping of a content item to the playlists that contain it */
export type ContentPlaylistMapping = {
  __typename?: 'ContentPlaylistMapping'
  /** The content ID */
  contentId: Scalars['Int']['output']
  /** Playlists containing this content (public/anonymous only, excludes system playlists) */
  playlists: Array<ContentPlaylistEntry>
}

/**
 * Content policy defines comprehensive access control, sharing permissions, and availability rules for content.
 *
 * Content policies are the central mechanism for controlling who can access content and under what conditions.
 * Each content item is linked to a content policy via the contentPolicyPolicyId field.
 *
 * ACCESS CONTROL RULES (evaluated in order of precedence):
 *
 * 1. User Role Access (HIGHEST PRECEDENCE):
 *    - If userRoleAllowed is true, the user has access regardless of all other rules
 *    - Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE bypass all other restrictions
 *    - This takes precedence over subscriptions, countries, and all other checks
 *
 * 2. Country/Geographic Restrictions:
 *    - availability field controls geographic access:
 *      * Worldwide: Content available everywhere
 *      * Only In: Content only available in countries list
 *      * Blocked: Content blocked in countries list
 *    - countryAllowed indicates if user's country (from authentication or request) is allowed
 *    - Uses user's authenticated country if available, otherwise falls back to request country
 *
 * 3. Client Attributes:
 *    - availabilityClientAttributes controls client-based restrictions:
 *      * No restrictions: All clients can access
 *      * Only with: Only clients with attributes in clientAttributes list can access
 *      * Blocked with: Clients with attributes in clientAttributes list are blocked
 *    - clientAttributesAllowed indicates if user's client attributes are allowed
 *
 * 4. Subscription Plans:
 *    - optionIds contains the list of subscription plan IDs that allow access
 *    - subscriptionsAllowed indicates if user's active subscriptions match any allowed plan
 *    - Users must have at least one matching subscription to access (unless content is free)
 *
 * 5. Ecommerce Entitlements:
 *    - ecommercePurchaseAllowed indicates if user has purchased this specific content
 *    - Can be used for pay-per-view or one-time purchase content
 *
 * 6. Free Content:
 *    - isFreeAllowed indicates if content is free (no subscription required)
 *    - Free content is accessible to all users (subject to country/client restrictions)
 *
 * FINAL ACCESS DECISION:
 * - allowed: True when user has access based on ALL applicable rules
 * - allowedWithEntitlementsMatch: True when ecommercePurchaseAllowed OR subscriptionsAllowed is true
 * - User role access (userRoleAllowed) takes precedence over all other checks
 *
 * SHARING:
 * - shareAllowed: Whether the content can be shared via shareUrl
 * - Controls if content can be shared on social media or via direct links
 *
 * Use the accessCheck field to evaluate access for the current request. The check considers all rules
 * and returns detailed information about which checks passed or failed.
 *
 * AUTHENTICATION-BASED CONTENT FILTERING:
 * When querying content with applyContentPolicy=true, the following authentication properties are used
 * to automatically filter content based on content policy rules:
 *
 * 1. authentication.country (or request country if not authenticated):
 *    - Matched against policy.availability and policy.countries
 *    - Filters out content not available in user's country
 *    - Used to enforce geographic restrictions
 *
 * 2. authentication.clientAttributes:
 *    - Matched against policy.availabilityClientAttributes and policy.clientAttributes
 *    - Filters content based on client device/platform restrictions
 *    - Used to restrict content to specific client types
 *
 * 3. authentication.subscriptions:
 *    - Matched against policy.optionIds
 *    - Filters content to only show what user's subscription allows
 *    - Free content (optionIds includes 0) is shown to all users
 *
 * 4. authentication.roles:
 *    - Checked for special privileges (EDITOR, SITE_ADMIN, etc.)
 *    - Users with privileged roles bypass all other restrictions
 *    - Used to allow staff/admin access to all content
 *
 * These authentication properties are automatically extracted from the request and applied when
 * applyContentPolicy=true is used in content queries (contentList, contentSeries, contentEpisodes, etc.).
 */
export type ContentPolicy = {
  __typename?: 'ContentPolicy'
  /** Access check for the current request against this content policy */
  accessCheck?: Maybe<ContentPolicyAccessCheck>
  /** Content policy availability of countries such as worldwide, only in or blocked */
  availability?: Maybe<Scalars['Int']['output']>
  /** Content policy availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: Maybe<Scalars['Int']['output']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The content associated with this content policy */
  content?: Maybe<Array<Maybe<Content>>>
  /** The countries to apply in combination with availability ordered ASC */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Name of the policy group */
  name?: Maybe<Scalars['String']['output']>
  /** The subscriptions which are allowed for this content policy ordered ASC */
  optionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The id for this content policy group */
  policyId?: Maybe<Scalars['ID']['output']>
  /** True if this content policy allows sharing */
  shareAllowed?: Maybe<Scalars['Boolean']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * Access check results for the current request against a content policy.
 *
 * This type provides detailed information about whether a user can access content based on
 * the content policy rules. Use this to determine access, display appropriate UI, and
 * understand why access was granted or denied.
 *
 * EVALUATION ORDER (precedence matters):
 * 1. userRoleAllowed (HIGHEST) - If true, user has access regardless of all other checks
 * 2. countryAllowed - Geographic restrictions
 * 3. clientAttributesAllowed - Client-based restrictions
 * 4. subscriptionsAllowed - Subscription plan matching
 * 5. ecommercePurchaseAllowed - One-time purchase entitlements
 * 6. isFreeAllowed - Free content access
 *
 * FINAL DECISION:
 * - allowed: True when user passes ALL applicable checks (or userRoleAllowed is true)
 * - allowedWithEntitlementsMatch: True when user has either subscription OR purchase entitlement
 */
export type ContentPolicyAccessCheck = {
  __typename?: 'ContentPolicyAccessCheck'
  /**
   * True when the request is allowed access by the content policy checks applied using all rules.
   * This is the primary field to check for access. If true, the user can access the content.
   * If false, check the individual allowed fields to understand which restriction applies.
   *
   * NOTE: userRoleAllowed=true will make this true regardless of other checks.
   */
  allowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when either ecommercePurchaseAllowed OR subscriptionsAllowed is true.
   * Useful for determining if user has any form of entitlement (subscription or purchase).
   */
  allowedWithEntitlementsMatch?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's client attributes match the content policy requirements.
   * Based on availabilityClientAttributes and clientAttributes fields in the policy.
   */
  clientAttributesAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's country is allowed by the content policy.
   * Uses authenticated country if available, otherwise request country.
   * Based on availability and countries fields in the policy.
   */
  countryAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user has purchased this specific content via ecommerce.
   * Used for pay-per-view or one-time purchase content.
   */
  ecommercePurchaseAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the content policy indicates the content is free (no subscription required).
   * Free content is accessible to all users (subject to country/client restrictions).
   */
  isFreeAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's active subscriptions match any of the allowed subscription plans.
   * Based on optionIds field in the policy. User must have at least one matching subscription.
   */
  subscriptionsAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the user's role allows access to the policy.
   * THIS TAKES PRECEDENCE OVER ALL OTHER CHECKS.
   * If true, the user has access regardless of subscriptions, countries, or other restrictions.
   * Roles like EDITOR, SITE_ADMIN, CUSTOMER_SERVICE typically have this privilege.
   */
  userRoleAllowed?: Maybe<Scalars['Boolean']['output']>
  /**
   * The values used for the access check evaluation.
   * Contains the actual country, subscriptions, client attributes, and roles that were evaluated.
   */
  values?: Maybe<ContentPolicyAccessCheckValues>
}

/**
 * Access check values to evaluate rules.
 *
 * These values come from the request authentication and are used to evaluate content policy access.
 * The authentication properties are automatically extracted from the request and used to filter content
 * when applyContentPolicy is true on content queries.
 *
 * AUTHENTICATION PROPERTIES USED FOR FILTERING:
 * - country: User's country code (from authentication, falls back to request country if not authenticated)
 * - clientAttributes: Array of client attributes (e.g., device type, platform) from authentication
 * - subscriptions: Array of subscription plan IDs the user is subscribed to
 * - roles: Array of user role IDs (e.g., EDITOR, SITE_ADMIN) that may bypass restrictions
 *
 * These properties are used to match against content policy rules:
 * - country is matched against policy.availability and policy.countries
 * - clientAttributes are matched against policy.availabilityClientAttributes and policy.clientAttributes
 * - subscriptions are matched against policy.optionIds
 * - roles are checked for special access privileges
 */
export type ContentPolicyAccessCheckValues = {
  __typename?: 'ContentPolicyAccessCheckValues'
  /**
   * The user authentication client attributes (takes precedence for clientAttributesAllowed check).
   * Used to filter content based on client-based restrictions in the content policy.
   */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * The user authentication country (takes precedence for countryAllowed check).
   * Used to filter content based on geographic restrictions in the content policy.
   * Falls back to requestCountry if not available from authentication.
   */
  country?: Maybe<Scalars['String']['output']>
  /**
   * The request country used if user authentication country is undefined.
   * Used as a fallback when determining geographic access restrictions.
   */
  requestCountry?: Maybe<Scalars['String']['output']>
  /**
   * The user authentication roles (takes precedence for userRoleAllowed check).
   * Used to determine if user has special access privileges that bypass other restrictions.
   */
  roles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /**
   * The user authentication subscriptions (takes precedence for subscriptionsAllowed check).
   * Used to filter content based on subscription plan requirements in the content policy.
   */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

/** Content policy list response */
export type ContentPolicyListResponse = {
  __typename?: 'ContentPolicyListResponse'
  /** A list of content reference */
  contentPolicies?: Maybe<Array<Maybe<ContentPolicy>>>
  /** Total number of rows of content policies found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content content id where input type */
export type ContentPolicyWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content id where input type */
export type ContentPolicyWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content policy where conditions to filter rows */
export type ContentPolicyWhereInput = {
  /** The id field where clause */
  policyId?: InputMaybe<ContentPolicyWherePolicyIdInput>
}

/** Content content policy type where input type */
export type ContentPolicyWherePolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider */
export type ContentProvider = {
  __typename?: 'ContentProvider'
  /** The content associated with this content provider */
  content?: Maybe<Content>
  /** The id for this content provider content.id */
  contentId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** The content provider */
  provider?: Maybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: Maybe<Scalars['String']['output']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: Maybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content provider */
export type ContentProviderContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content provider create */
export type ContentProviderCreateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']['input']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content delete provider delete by content id */
export type ContentProviderDeleteByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
}

/** Content provider providers */
export enum ContentProviderHashType {
  /** MD5 */
  Md5 = 'MD5',
}

/** Content provider list response */
export type ContentProviderListResponse = {
  __typename?: 'ContentProviderListResponse'
  /** A list of content reference */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>
}

/** Content provider mutation response */
export type ContentProviderMutationResponse = {
  __typename?: 'ContentProviderMutationResponse'
  /** The content provider which was mutated */
  contentProvider?: Maybe<ContentProvider>
}

/** Content provider providers */
export enum ContentProviderProviders {
  /** Brightcove AI Content Multiplier clip metadata */
  BrightcoveAiContentMultiplier = 'BRIGHTCOVE_AI_CONTENT_MULTIPLIER',
  /** Gaia Bonus */
  GaiaBonus = 'GAIA_BONUS',
  /** Gaia Worpress */
  GaiaWordpress = 'GAIA_WORDPRESS',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** Yoga International */
  YogaInternational = 'YOGA_INTERNATIONAL',
}

/** Content delete provider update by content id */
export type ContentProviderUpdateByContentIdInput = {
  /** The id for this content provider */
  contentId?: InputMaybe<Scalars['ID']['input']>
  /** Metadata specifically for the content provider, generally data that does not fit the content model, but is used by the provider the mutation will full replace the current value if defined */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The content provider */
  provider?: InputMaybe<ContentProviderProviders>
  /** The provider hash value of the data on the provider */
  providerHash?: InputMaybe<Scalars['String']['input']>
  /** The provider hash algorithm used to produce the hash value */
  providerHashType?: InputMaybe<ContentProviderHashType>
  /** The content provider key for this content */
  providerKey?: InputMaybe<Scalars['String']['input']>
}

/** Content provider where conditions to filter rows */
export type ContentProviderWhereInput = {
  /** The content id field where clause */
  contentId?: InputMaybe<ContentProvidersWhereContentIdInput>
  /** Metadata JSON input */
  metadata?: InputMaybe<ContentProvidersWhereMetadataInput>
  /** The provider field where clause */
  provider?: InputMaybe<ContentProvidersWhereProviderInput>
  /** The provider key field where clause */
  providerKey?: InputMaybe<ContentProvidersWhereProviderKeyInput>
}

/** Content id where input type */
export type ContentProvidersWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider where input type */
export type ContentProvidersWhereMetadataInput = {
  /** Does the field contain the values */
  contains?: InputMaybe<Scalars['JSON']['input']>
}

/** Content provider where input type */
export type ContentProvidersWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content provider where input type */
export type ContentProvidersWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference */
export type ContentReference = {
  __typename?: 'ContentReference'
  /** The content linked from this content reference */
  contentFrom?: Maybe<Array<Maybe<Content>>>
  /** The content reference type */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** A foreign key to the content_reference_types which defines the relationship between the parent and the child content */
  contentReferenceTypesId?: Maybe<Scalars['ID']['output']>
  /** The content linked to this content reference */
  contentTo?: Maybe<Array<Maybe<Content>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The content_id field on the content table where the reference originates */
  fromContentContentId?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference originates */
  fromContentContentType?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group for the from content */
  fromTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The label for this content reference in the requested language (only applicable to course-module-practice and course-module-other types) */
  label?: Maybe<Scalars['String']['output']>
  /** The field to sort by */
  sortKey?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference points */
  toContentContentId?: Maybe<Scalars['Int']['output']>
  /** The content_type field on the content table where the reference points */
  toContentContentType?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group for the to content */
  toTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content reference */
export type ContentReferenceContentFromArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference */
export type ContentReferenceContentToArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference */
export type ContentReferenceLabelArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content references allowed row */
export type ContentReferenceAllowed = {
  __typename?: 'ContentReferenceAllowed'
  /** The content id field on the content table */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content reference type associated with this row */
  contentReferenceType?: Maybe<ContentReferenceType>
  /** The content reference types id field on the content table where the reference points */
  contentReferenceTypesId?: Maybe<Scalars['Int']['output']>
  /** The content type field on the content table */
  contentType?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
}

/** Single content reference as create input */
export type ContentReferenceCreateInput = {
  /** The from_content_content_id field */
  fromContentContentId: Scalars['Int']['input']
  /** The from_content_content_type field */
  fromContentContentType: Scalars['String']['input']
  /** The field to sort by */
  sortKey?: InputMaybe<Scalars['Int']['input']>
  /** The to_content_content_id field */
  toContentContentId: Scalars['Int']['input']
  /** The to_content_content_type field */
  toContentContentType: Scalars['String']['input']
  /** The content_reference_types.type field */
  type: Scalars['String']['input']
}

/** Return type for content reference create many. */
export type ContentReferenceCreateManyResponse = {
  __typename?: 'ContentReferenceCreateManyResponse'
  /** The content references that were updated */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
}

/** Return type for content reference create. */
export type ContentReferenceCreateResponse = {
  __typename?: 'ContentReferenceCreateResponse'
  /** The content reference that was updated */
  contentReference?: Maybe<ContentReference>
}

/** Single content reference as delete input */
export type ContentReferenceDeleteInput = {
  /** The id of the content reference to delete */
  id: Scalars['ID']['input']
}

/** Return type for content reference delete. */
export type ContentReferenceDeleteResponse = {
  __typename?: 'ContentReferenceDeleteResponse'
  /** The content reference that was deleted */
  contentReference?: Maybe<ContentReference>
}

/** Content reference type */
export type ContentReferenceType = {
  __typename?: 'ContentReferenceType'
  /** The date and time the record was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The type of the reference between the content */
  type?: Maybe<Scalars['String']['output']>
  /** The date and time the record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Content reference types list response */
export type ContentReferenceTypesListResponse = {
  __typename?: 'ContentReferenceTypesListResponse'
  /** A list of content reference types */
  contentReferenceTypes?: Maybe<Array<Maybe<ContentReferenceType>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content reference where input type */
export type ContentReferenceTypesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference types where conditions to filter rows */
export type ContentReferenceTypesWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceTypesWhereIdInput>
}

/** Content reference where fromContentContentId input type */
export type ContentReferenceWhereFromContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content reference where fromContentContentType input type */
export type ContentReferenceWhereFromContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where fromTitleGroupId input type */
export type ContentReferenceWhereFromTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where id input type */
export type ContentReferenceWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content reference where toContentContentId input type */
export type ContentReferenceWhereToContentContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content reference where toContentContentType input type */
export type ContentReferenceWhereToContentContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content reference where toTitleGroupId input type */
export type ContentReferenceWhereToTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content list response */
export type ContentReferencesAllowedResponse = {
  __typename?: 'ContentReferencesAllowedResponse'
  /** A list of content reference */
  contentReferencesAllowed?: Maybe<Array<Maybe<ContentReferenceAllowed>>>
}

export type ContentReferencesAllowedWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content references allowed where input */
export type ContentReferencesAllowedWhereInput = {
  /** Filter rows by id */
  id?: InputMaybe<ContentReferencesAllowedWhereIdInput>
}

/** Content reference list response */
export type ContentReferencesListResponse = {
  __typename?: 'ContentReferencesListResponse'
  /** A list of content reference */
  contentReferences?: Maybe<Array<Maybe<ContentReference>>>
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content reference where conditions to filter rows */
export type ContentReferencesWhereInput = {
  /** The fromContentContentId field where clause */
  fromContentContentId?: InputMaybe<ContentReferenceWhereFromContentContentIdInput>
  /** The fromContentContentType field where clause */
  fromContentContentType?: InputMaybe<ContentReferenceWhereFromContentContentTypeInput>
  /** The fromTitleGroupId field where clause */
  fromTitleGroupId?: InputMaybe<ContentReferenceWhereFromTitleGroupIdInput>
  /** The id field where clause */
  id?: InputMaybe<ContentReferenceWhereIdInput>
  /** The toContentId field where clause */
  toContentContentId?: InputMaybe<ContentReferenceWhereToContentContentIdInput>
  /** The toContentType field where clause */
  toContentContentType?: InputMaybe<ContentReferenceWhereToContentContentTypeInput>
  /** The toTitleGroupId field where clause */
  toTitleGroupId?: InputMaybe<ContentReferenceWhereToTitleGroupIdInput>
}

/**
 * Embeddings tied to this content (direct link or feature media): chunk-level `documentText` plus vectors for retrieval.
 *
 * **When to use this shape:** Semantic search over passages, RAG with citations, or generating a **fresh** overview via `summarizationText` (on-demand LLM over the loaded chunks—not the same as title-level pooled vectors from `documentAbstractList` / `document_abstracts`, which hold offline sums/averages of chunk embeddings).
 *
 * **Typical flow:** Load `documentEmbeddings` (optionally with `query` to rank by relevance), then optionally request `summarizationText` for a condensed narrative of those chunks.
 */
export type ContentRelatedDocumentEmbeddings = {
  __typename?: 'ContentRelatedDocumentEmbeddings'
  /** Chunk-level rows: text spans, embedding vectors, optional cue timing (`positionStart`/`positionEnd`), and metadata for provenance. Use for quoting sources, similarity search, or feeding `summarizationText`. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /**
   * On-demand LLM summary of the `documentEmbeddings` returned alongside it (map–reduce style over chunk text). Requires server `googleGenAiApiKey` for the summarization model.
   *
   * **Contrast:** For a **persisted**, worker-built synopsis and embedding per **document**, query `documentAbstractList` (`document_abstracts`) instead of this on-demand field.
   */
  summarizationText?: Maybe<Scalars['String']['output']>
}

/** Content related type */
export enum ContentRelatedType {
  /** Content that is linked using content references types for similar */
  References = 'REFERENCES',
  /** Content that is similar across mutliple data points */
  Similar = 'SIMILAR',
}

/** Precise content identity for contentRepublish (contentId + contentType pair) */
export type ContentRepublishContentInput = {
  /** Business content id (not the row primary key) */
  contentId: Scalars['Int']['input']
  /** Content type e.g. video, series */
  contentType: Scalars['String']['input']
}

/** Result of contentRepublish */
export type ContentRepublishResponse = {
  __typename?: 'ContentRepublishResponse'
  /** True when no events were published */
  dryRun: Scalars['Boolean']['output']
  /** Number of content rows matching where */
  matchCount: Scalars['Int']['output']
  /** Number of content_update events published (0 when dryRun) */
  publishedEventCount: Scalars['Int']['output']
}

/** Content type where for contentRepublish */
export type ContentRepublishWhereContentTypeInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Date range where for contentRepublish */
export type ContentRepublishWhereDateInput = {
  gt?: InputMaybe<Scalars['DateTime']['input']>
  gte?: InputMaybe<Scalars['DateTime']['input']>
  lt?: InputMaybe<Scalars['DateTime']['input']>
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Row primary key where for contentRepublish */
export type ContentRepublishWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  lt?: InputMaybe<Scalars['ID']['input']>
  lte?: InputMaybe<Scalars['ID']['input']>
}

/**
 * Where clause for contentRepublish. Require at least one filter.
 * Use `content` for precise (contentId, contentType) pairs (mixed types OK).
 * Use flat fields for generic ranges (type, dates, language, published, id, titleGroupId).
 */
export type ContentRepublishWhereInput = {
  /** Precise items as (contentId, contentType) pairs — REST republish parity */
  content?: InputMaybe<Array<ContentRepublishContentInput>>
  /** Filter by content type (generic slice, not paired with contentId) */
  contentType?: InputMaybe<ContentRepublishWhereContentTypeInput>
  /** Filter by createdAt */
  createdAt?: InputMaybe<ContentRepublishWhereDateInput>
  /** Filter by content row primary key */
  id?: InputMaybe<ContentRepublishWhereIdInput>
  /** Filter by language; omit for all languages */
  language?: InputMaybe<ContentRepublishWhereLanguageInput>
  /** Filter by published flag; omit for both published and unpublished */
  published?: InputMaybe<ContentRepublishWherePublishedInput>
  /** Filter by publishedAtDate */
  publishedAtDate?: InputMaybe<ContentRepublishWhereDateInput>
  /** Filter by title group id ({contentId}-{contentType}) */
  titleGroupId?: InputMaybe<ContentRepublishWhereTitleGroupIdInput>
  /** Filter by updatedAt */
  updatedAt?: InputMaybe<ContentRepublishWhereDateInput>
}

/** Language where for contentRepublish */
export type ContentRepublishWhereLanguageInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Published where for contentRepublish */
export type ContentRepublishWherePublishedInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** titleGroupId where for contentRepublish */
export type ContentRepublishWhereTitleGroupIdInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Get the GraphQL Types  */
export type ContentSearch = {
  __typename?: 'ContentSearch'
  /** D6 nid also the content group id i.e. all translations of this content share the same content_id */
  contentId?: Maybe<Scalars['Int']['output']>
  /** type of content (i.e. series, video, etc.) */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description fuzzy search text */
  fuzzyDesc?: Maybe<Scalars['String']['output']>
  /** The words fuzzy search text */
  fuzzyWords?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The language associated with the search content */
  language?: Maybe<Scalars['String']['output']>
  /** The metaphone text to search for this content ID (typically used for names) */
  metaphoneText?: Maybe<Scalars['String']['output']>
  /** The (non-metaphone) text to search for this content ID, weighted by search params */
  searchText?: Maybe<Scalars['String']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The title of this video in the given language with NO accented chars */
  titleUnaccented?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Natural-language search sub-pipeline legs for `contentList` (omit or empty = run all). */
export enum ContentSearchLeg {
  /** PostgreSQL full-text hits used to bump ranks for rows already in the merged result set. */
  Fts = 'FTS',
  /** Fuzzy SQL match on content fields for broader lexical recall. */
  Fuzzy = 'FUZZY',
  /** Fuzzy match on titles only (small capped set of title variants). */
  FuzzyTitle = 'FUZZY_TITLE',
  /** Chunk-level embedding similarity over document embeddings (semantic transcript-like match). */
  Nls = 'NLS',
  /** Embedding similarity over document abstracts / summaries. */
  Summary = 'SUMMARY',
  /** Case-insensitive exact match on the unaccented title (high-precision direct hits). */
  Title = 'TITLE',
}

/** Media asset response */
export type ContentSearchListResponse = {
  __typename?: 'ContentSearchListResponse'
  /** A list of media */
  contentSearch?: Maybe<Array<Maybe<ContentSearch>>>
}

/** GraphQL content server where input  */
export type ContentSearchWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where conditions to filter rows */
export type ContentSearchWhereInput = {
  id?: InputMaybe<ContentSearchWhereIdInput>
}

/** User entitlment */
export type ContentSet = {
  __typename?: 'ContentSet'
  /** The content set id */
  contentSetId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When true this is the default content set */
  defaultContentSet?: Maybe<Scalars['Boolean']['output']>
  /** Description of this content set */
  description?: Maybe<Scalars['String']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** User info policy list response */
export type ContentSetListResponse = {
  __typename?: 'ContentSetListResponse'
  /** A list of userInfo reference */
  contentSets?: Maybe<Array<Maybe<ContentSet>>>
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Content set id where input type */
export type ContentSetListWhereContentSetIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content set id where input type */
export type ContentSetListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User info policy where conditions to filter rows */
export type ContentSetListWhereInput = {
  /** The conten set id field where clause */
  contentSetId?: InputMaybe<ContentSetListWhereContentSetIdInput>
  /** The id field where clause */
  id?: InputMaybe<ContentSetListWhereIdInput>
}

/** Content text format options */
export enum ContentTextFormat {
  /** Format the text as HTML */
  Html = 'HTML',
  /** Format the text as markdown */
  Markdown = 'MARKDOWN',
  /** Format the text as plain text */
  PlainText = 'PLAIN_TEXT',
}

/** Return type for content update */
export type ContentUpdateResponse = {
  __typename?: 'ContentUpdateResponse'
  /** The content that was updated */
  content?: Maybe<Content>
}

/** Content bundle where input type */
export type ContentWhereBundleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content content id where input type */
export type ContentWhereContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content Policy Policy Id where input type */
export type ContentWhereContentPolicyPolicyIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is one of the values equal to the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Content content type where input type */
export type ContentWhereContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content filter type where input type */
export type ContentWhereFilterTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']['input']>
}

/** Content id where input type */
export type ContentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Content where conditions to filter rows */
export type ContentWhereInput = {
  /** The content bundle */
  bundle?: InputMaybe<ContentWhereBundleInput>
  /** The content content id field where clause */
  contentId?: InputMaybe<ContentWhereContentIdInput>
  /** The Content Policy Policy Id of the content */
  contentPolicyPolicyId?: InputMaybe<ContentWhereContentPolicyPolicyIdInput>
  /** The content content type field where clause */
  contentType?: InputMaybe<ContentWhereContentTypeInput>
  /** The content filter type(s) using 'like' */
  filterType?: InputMaybe<ContentWhereFilterTypeInput>
  /** The id field where clause */
  id?: InputMaybe<ContentWhereIdInput>
  /** The requested language of the content */
  language?: InputMaybe<ContentWhereLanguageInput>
  /** The content path */
  path?: InputMaybe<ContentWherePathInput>
  /** The content product type field where clause (e.g. single, episode). Do not combine with listCriteria. */
  productType?: InputMaybe<ContentWhereProductTypeInput>
  /** The content is published */
  published?: InputMaybe<ContentWherePublishedInput>
  /** The date the content was published */
  publishedAtDate?: InputMaybe<ContentWherePublishedAtDateInput>
  /**
   * A query to filter content using search, use this with queryType to determine the type of search.
   * Search will consider the request authentication properties (country, clientAttributes, subscriptions)
   * to determine which content is available based on the content policy,
   * but does not filter based on the entire content policy which requires the applyContentPolicy flag to be true.
   */
  query?: InputMaybe<Scalars['String']['input']>
  /** Which search type to perform on the query. */
  queryType?: InputMaybe<ContentWhereQueryType>
  /** The content title */
  title?: InputMaybe<ContentWhereTitleInput>
  /** The content title group id field where clause */
  titleGroupId?: InputMaybe<ContentWhereTitleGroupIdInput>
  /** The date the content was last updated */
  updatedAt?: InputMaybe<ContentWhereUpdatedAtInput>
}

/** Content content language where input type */
export type ContentWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content content path where input type */
export type ContentWherePathInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content product type where input type */
export type ContentWhereProductTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ContentWherePublishedAtDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

export type ContentWherePublishedInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** The type of search to perform with the query */
export enum ContentWhereQueryType {
  /**
   * Run a full text search query
   * @deprecated Removed from contentList; use NATURAL_LANGUAGE_SEARCH. Sending this value returns a validation error.
   */
  FullTextSearch = 'FULL_TEXT_SEARCH',
  /** Run a natural language search query */
  NaturalLanguageSearch = 'NATURAL_LANGUAGE_SEARCH',
  /** Get recommended content for a user */
  RecommendedContent = 'RECOMMENDED_CONTENT',
}

/** Content content title group id where input type */
export type ContentWhereTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Content title where input type */
export type ContentWhereTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']['input']>
}

/** Content updated at where input type */
export type ContentWhereUpdatedAtInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Continue-watching first tile plus recommended videos for a configured tag */
export type ContinueWatchingTaggedRecs = {
  __typename?: 'ContinueWatchingTaggedRecs'
  /** Continue-watching rail */
  continueWatching: ContinueWatchingTaggedRecsContinueWatching
  /** Recommended rail for the configured tag */
  recommended: ContinueWatchingTaggedRecsRecommended
}

/** Continue-watching tiles for continueWatchingTaggedRecs */
export type ContinueWatchingTaggedRecsContinueWatching = {
  __typename?: 'ContinueWatchingTaggedRecsContinueWatching'
  /** Continue-watching content */
  content: Array<Maybe<Content>>
}

/** Continue-watching tiles for continueWatchingTaggedRecs */
export type ContinueWatchingTaggedRecsContinueWatchingContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Recommended tiles for continueWatchingTaggedRecs */
export type ContinueWatchingTaggedRecsRecommended = {
  __typename?: 'ContinueWatchingTaggedRecsRecommended'
  /** Up to three recommended videos for the configured tag */
  content: Array<Maybe<Content>>
  /** Recombee recommendation id for attribution, or null when recs are unavailable */
  recommId?: Maybe<Scalars['String']['output']>
}

/** Recommended tiles for continueWatchingTaggedRecs */
export type ContinueWatchingTaggedRecsRecommendedContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ConversationSearchResponse = {
  __typename?: 'ConversationSearchResponse'
  conversations: Array<ConversationSearchResult>
  totalConversations: Scalars['Int']['output']
}

export type ConversationSearchResult = {
  __typename?: 'ConversationSearchResult'
  conversationId: Scalars['ID']['output']
  conversationTitle: Scalars['String']['output']
  highlightedTitle?: Maybe<Scalars['String']['output']>
  matchCount: Scalars['Int']['output']
  matchedMessages: Array<MessagePairSearchResult>
}

export type CreateApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  name: Scalars['String']['input']
  roleIds: Array<Scalars['Int']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  /** Target user (UUID). Omitted = current user. Admins may set any user. */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** Create billing discount input */
export type CreateBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount code */
  code?: InputMaybe<Scalars['String']['input']>
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>
  /** Human-readable description for admins */
  description?: InputMaybe<Scalars['String']['input']>
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>
  /** Lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The discount lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>
  /** When set, discount applies only to plans whose billing product belongs to this platform */
  platform?: InputMaybe<ProductPlatform>
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The discount tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The discount tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>
}

/** Create input for Billing Plan Grid */
export type CreateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid: Scalars['Boolean']['input']
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether the billing plan grid is enabled */
  enabled: Scalars['Boolean']['input']
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1: Scalars['Int']['input']
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The billing plan grid lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1: Scalars['Int']['input']
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid page */
  page: Scalars['String']['input']
  /** The billing plan grid priority */
  priority: Scalars['Int']['input']
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing plan grid tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating an eligibility rule */
export type CreateBillingProviderProductEligibilityInput = {
  billingProviderProductId: Scalars['ID']['input']
  /** Required when ruleType is Country */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Required when ruleType is Country */
  countryOperator?: InputMaybe<PlanEligibilityCountryOperator>
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  maxPurchases?: InputMaybe<Scalars['Int']['input']>
  monthsSinceLastPurchase?: InputMaybe<Scalars['Int']['input']>
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  planSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ruleType: PlanEligibilityRuleType
  scope: PlanEligibilityScope
  skuCheckType?: InputMaybe<SkuCheckType>
  skuOperator?: InputMaybe<SkuOperator>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  tenure?: InputMaybe<Scalars['Int']['input']>
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
}

/** Create many unique billing discount codes with the same rules */
export type CreateBulkBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']['input']>
  /** Length of each generated discount code (4-32); defaults to 8 */
  codeLength?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>
  /** Human-readable description for admins (applied to the bulk batch and each discount) */
  description?: InputMaybe<Scalars['String']['input']>
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>
  /** Lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The discount lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>
  /** When set, discount applies only to plans whose billing product belongs to this platform */
  platform?: InputMaybe<ProductPlatform>
  /** Number of unique discount codes to create (1-10000) */
  quantity: Scalars['Int']['input']
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The discount tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The discount tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>
}

/** Input for creating a new event */
export type CreateCommunityEventInput = {
  /** Maximum attendees (null = unlimited) */
  capacity?: InputMaybe<Scalars['Int']['input']>
  /** Event description */
  content: Scalars['String']['input']
  /** Event end date and time */
  endTime: Scalars['DateTime']['input']
  /** Event locations */
  locations?: InputMaybe<Array<CommunityEventLocationInput>>
  /** Reminder settings */
  reminderSettings?: InputMaybe<CommunityEventReminderSettingsInput>
  /** Event start date and time */
  startTime: Scalars['DateTime']['input']
  /** Initial status (defaults to PUBLISHED) */
  status?: InputMaybe<CommunityEventStatus>
  /** IANA timezone */
  timeZone: Scalars['String']['input']
  /** Event title */
  title: Scalars['String']['input']
}

/** Input for creating a custom emoji */
export type CreateCustomEmojiInput = {
  /** Base64-encoded image file */
  fileData: Scalars['String']['input']
  /** The unique key for the emoji (alphanumeric, hyphens, underscores only) */
  key: Scalars['String']['input']
  /** MIME type of the image (e.g., 'image/png') */
  mimeType: Scalars['String']['input']
  /** The display name of the emoji */
  name: Scalars['String']['input']
}

/** Create the config for one action. A second row for the same action is rejected. */
export type CreateRateLimitActionConfigInput = {
  /** Action this config applies to, such as LOGIN */
  action: Scalars['String']['input']
  /** Deny when the Fingerprint event bot field is bad */
  badBot?: InputMaybe<Scalars['Boolean']['input']>
  /** Deny when the Fingerprint event tampering field is true */
  browserTampering?: InputMaybe<Scalars['Boolean']['input']>
  /** Store checks for this action without denying them */
  bypass?: InputMaybe<Scalars['Boolean']['input']>
  /** Keys that may consume a token once each. Empty allows the default key only. */
  consumptionKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Deny when the Fingerprint event ip_blocklist email_spam or attack_source is true */
  ipBlocklist?: InputMaybe<Scalars['Boolean']['input']>
  /** When true, checks for this action must pass tokenConsumption. Defaults to false. */
  tokenConsumption?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for a new allow or block override. An allow override with no uid, fingerprint, or IP is a key allow: callers pass its uuid in x-rate-limit-key. A block may match a user agent instead of uid, fingerprint, or IP. */
export type CreateRateLimitOverrideInput = {
  /** Action this row applies to. Omit to match every action. */
  action?: InputMaybe<Scalars['String']['input']>
  /** Required for a block row to match clientIp */
  blockIp?: InputMaybe<Scalars['Boolean']['input']>
  /** Client IP this row matches */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** Optional note for why this row exists */
  description?: InputMaybe<Scalars['String']['input']>
  /** Defaults to true */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the override ends. Required when startAt is set. */
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  /** FingerprintJS visitor id this row matches */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** allow or block */
  overrideType: RateLimitOverrideType
  /** When the override starts. Set with endAt, or omit both. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  /** User id this row matches */
  uid?: InputMaybe<Scalars['Int']['input']>
  /** User-Agent this block matches. Exact after trim, capped at 1024 characters. Blank is stored as null. Only valid on a block. Omit action to match every action. */
  userAgent?: InputMaybe<Scalars['String']['input']>
}

/** Input for a rate-limit check. Uid counts the authenticated caller unless input uid is set. IP is the request client IP unless clientIp is set. */
export type CreateRateLimitRequestInput = {
  /** Action to evaluate, such as LOGIN */
  action: Scalars['String']['input']
  /** Allow override uuid. Falls back to the x-rate-limit-key header. A matching enabled allow override skips uid, IP, fingerprint, and block checks. */
  allowKey?: InputMaybe<Scalars['String']['input']>
  /** Client IP to count. When set, this is stored instead of the request client IP. */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** FingerprintJS visitor id. Falls back to the x-fingerprint-id header. */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** FingerprintJS event request id. Falls back to the x-fingerprint-request-id header. */
  requestId?: InputMaybe<Scalars['String']['input']>
  /** When true, return an active unconsumed token for this action and fingerprint or uid instead of minting another. Requires fingerprintId or uid. */
  tokenConsumption?: InputMaybe<Scalars['Boolean']['input']>
  /** User id to count. When set, this is the request uid and authUid is the authenticated caller. Omit to count the authenticated caller. */
  uid?: InputMaybe<Scalars['Int']['input']>
}

/** Input for a new rate-limit rule */
export type CreateRateLimitRuleInput = {
  /** Action this rule applies to, such as LOGIN */
  action: Scalars['String']['input']
  /** count or distinct. Defaults to count. */
  aggregate?: InputMaybe<RateLimitAggregate>
  /** When true, that block override has no action and matches every action. Defaults to false. */
  blockAllActionsOnFailure?: InputMaybe<Scalars['Boolean']['input']>
  /** When set, a failed check writes a block override that lasts this many minutes */
  blockMinutesOnFailure?: InputMaybe<Scalars['Int']['input']>
  /** Action whose history this rule counts. Omit to count this rule's action. */
  countAction?: InputMaybe<Scalars['String']['input']>
  /** request counts checks. action counts completed work. both counts both. */
  countSource: RateLimitCountSource
  /** uid, ip, or fingerprint. Omit to apply the limit to each present identity. */
  dimension?: InputMaybe<RateLimitDimension>
  /** ip or uid. Required when aggregate is distinct. */
  distinctDimension?: InputMaybe<RateLimitDistinctDimension>
  /** Defaults to true */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** dimension or fingerprint_or_uid. Defaults to dimension. */
  historyMatch?: InputMaybe<RateLimitHistoryMatch>
  /** Maximum count inside the window, including the current attempt. 0 denies every attempt. */
  limit: Scalars['Int']['input']
  /** total, success, or failure */
  outcome: RateLimitOutcome
  /** When true, a failed check writes a block with no start and no end. Cannot be combined with blockMinutesOnFailure. */
  permanentBlockOnFailure?: InputMaybe<Scalars['Boolean']['input']>
  /** Minutes, Hours, or Days */
  timeUnit: RateLimitTimeUnit
  /** Window length. Must be greater than 0. */
  timeValue: Scalars['Int']['input']
}

/** A custom emoji for use in the community */
export type CustomEmoji = {
  __typename?: 'CustomEmoji'
  /** Whether the emoji is active and available for use */
  active: Scalars['Boolean']['output']
  /** When the emoji was created */
  createdAt: Scalars['DateTime']['output']
  /** The unique ID of the custom emoji */
  id: Scalars['ID']['output']
  /** The unique key/identifier for the emoji (e.g., 'love', 'fire') */
  key: Scalars['String']['output']
  /** The display name of the emoji */
  name: Scalars['String']['output']
  /** URL to access the emoji image */
  url: Scalars['String']['output']
}

/** Custom reaction configuration (admin-configured, feed-wide) */
export type CustomReaction = {
  __typename?: 'CustomReaction'
  /** Active color (hex code) */
  activeColor?: Maybe<Scalars['String']['output']>
  /** Icon URL when active/selected */
  activeIconUrl?: Maybe<Scalars['String']['output']>
  /** Default color (hex code) */
  color?: Maybe<Scalars['String']['output']>
  /** Icon URL (default state) */
  iconUrl: Scalars['String']['output']
  /** Unique key for this custom reaction (e.g., 'gaia_earth') */
  key: Scalars['String']['output']
  /** Display name (e.g., 'Gaia Earth') */
  name: Scalars['String']['output']
}

/** Response from deleting a banner image */
export type DeleteBannerImageResponse = {
  __typename?: 'DeleteBannerImageResponse'
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** Delete input for Billing Plan Grid */
export type DeleteBillingPlanGridInput = {
  /** The billing plan grid id */
  id: Scalars['ID']['input']
}

/** Delete response for Billing Plan Grid */
export type DeleteBillingPlanGridResponse = {
  __typename?: 'DeleteBillingPlanGridResponse'
  /** Whether the delete was successful */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Response from deleting a playlist cover photo */
export type DeletePlaylistCoverPhotoResponse = {
  __typename?: 'DeletePlaylistCoverPhotoResponse'
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** Response from deleting a profile picture */
export type DeleteProfilePictureResponse = {
  __typename?: 'DeleteProfilePictureResponse'
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** Deleted Billing Provider Product Pricing type */
export type DeletedBillingProviderProductPricing = {
  __typename?: 'DeletedBillingProviderProductPricing'
  /** The billing provider product id of the billing provider product pricing */
  billingProviderProductId?: Maybe<Scalars['ID']['output']>
  /** Billing Provider Product SKU */
  billingProviderProductSku?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The billing provider product pricing currency */
  currency?: Maybe<Scalars['String']['output']>
  /** The id of the billing provider product pricing */
  id?: Maybe<Scalars['ID']['output']>
  /** The billing provider product pricing price */
  price?: Maybe<Scalars['Float']['output']>
  /** The billing provider product trial segment price */
  trialSegmentPrice?: Maybe<Scalars['Float']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The UUID of the billing provider product pricing */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Name value pair for demographic data */
export type DemographicsNameValuePair = {
  __typename?: 'DemographicsNameValuePair'
  /** The name of the demographic field */
  name?: Maybe<Scalars['String']['output']>
  /** The value of the demographic field */
  value?: Maybe<Scalars['String']['output']>
}

/** Demographics response containing email and data */
export type DemographicsResponse = {
  __typename?: 'DemographicsResponse'
  /** The demographic data as name/value pairs */
  data?: Maybe<Array<Maybe<DemographicsNameValuePair>>>
  /** The email address that was queried */
  email?: Maybe<Scalars['String']['output']>
}

/** Discount code object */
export type DiscountCode = {
  __typename?: 'DiscountCode'
  /** The discount code string */
  code?: Maybe<Scalars['String']['output']>
  /** The end date of the discount code */
  endsAt?: Maybe<Scalars['DateTime']['output']>
  /** The discount code ID from Shopify */
  id?: Maybe<Scalars['ID']['output']>
  /** The start date of the discount code */
  startsAt?: Maybe<Scalars['DateTime']['output']>
  /** The discount code title */
  title?: Maybe<Scalars['String']['output']>
}

/** Discount code create input */
export type DiscountCodeCreateInput = {
  /** The amount off for the discount code */
  amountOff: Scalars['Float']['input']
  /** The discount code */
  code: Scalars['String']['input']
  /** The end date of the discount code */
  endsAt: Scalars['DateTime']['input']
  /** The minimum subtotal for the discount code */
  minimumSubtotal: Scalars['Float']['input']
  /** The start date of the discount code */
  startsAt: Scalars['DateTime']['input']
}

/** Discount code create response */
export type DiscountCodeCreateResponse = {
  __typename?: 'DiscountCodeCreateResponse'
  /** The created discount code */
  discountCode?: Maybe<DiscountCode>
  /** Error message if the mutation failed */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Divination collection (deck, rune set, etc.) */
export type DivinationCollection = {
  __typename?: 'DivinationCollection'
  backImageUrl?: Maybe<Scalars['String']['output']>
  collectionKey: Scalars['String']['output']
  id: Scalars['ID']['output']
  locale?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<Scalars['JSON']['output']>
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

/** Collection metadata with all objects for a divination feature. */
export type DivinationCollectionObjects = {
  __typename?: 'DivinationCollectionObjects'
  collection: DivinationCollection
  objects: Array<DivinationObject>
}

/** Bundled divination feature state for oracle cards, tarot, and horoscope. */
export type DivinationFeatureStates = {
  __typename?: 'DivinationFeatureStates'
  horoscopeState: HoroscopeFeatureState
  oracleState: OracleCardsFeatureState
  tarotState: TarotFeatureState
}

/** Divination object (card, rune, etc.) */
export type DivinationObject = {
  __typename?: 'DivinationObject'
  collectionId: Scalars['ID']['output']
  /** Localized display name. Follows the query language (en, es, fr, de). */
  displayName: Scalars['String']['output']
  family?: Maybe<Scalars['String']['output']>
  frontImageUrl?: Maybe<Scalars['String']['output']>
  iconImageUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** Localized insight copy. Follows the query language (en, es, fr, de). Empty when the object has no insight. */
  insight: Scalars['String']['output']
  /** Localized invite copy. Follows the query language (en, es, fr, de). Empty when the object has no invite. */
  invite: Scalars['String']['output']
  metadata?: Maybe<Scalars['JSON']['output']>
  objectKey: Scalars['String']['output']
  rank?: Maybe<Scalars['Int']['output']>
  semanticClass?: Maybe<Scalars['String']['output']>
}

/** Poster grid URL and context for divination pull history (not a live reading pull). */
export type DivinationPullHistoryDocument = {
  __typename?: 'DivinationPullHistoryDocument'
  /** Resolved deck / collection key (same rules as starting a reading). */
  collectionKey?: Maybe<Scalars['String']['output']>
  /** Media path type segment (e.g. tarot, oracle) for poster URL. */
  mediaTypeSegment?: Maybe<Scalars['String']['output']>
  /** GET URL for /api/media/images/poster/... with optional reveal= and size= (small|medium|large) query params. */
  posterUrl: Scalars['String']['output']
  /** Backend reading type: tarot or oracle_cards. */
  sourceReadingType: Scalars['String']['output']
  /** Number of distinct pulled card image keys in this history list. */
  uniqueCardCount: Scalars['Int']['output']
}

/** Snapshot of the latest tarot reading in an oracle chat session. Designed for external channel integrations such as Braze email Connected Content. */
export type DivinationReading = {
  __typename?: 'DivinationReading'
  /** The cards pulled for the reading */
  cards: Array<DivinationReadingCard>
  /** ISO 8601 timestamp for when the reading was generated */
  createdAt?: Maybe<Scalars['String']['output']>
  /** The full interpretation text generated for the reading */
  interpretation?: Maybe<Scalars['String']['output']>
  /** The question the reading addressed */
  question?: Maybe<Scalars['String']['output']>
}

/** A single card pulled in a divination reading */
export type DivinationReadingCard = {
  __typename?: 'DivinationReadingCard'
  /** Human-readable localized card name */
  displayName?: Maybe<Scalars['String']['output']>
  /** Public CDN URL for the card front image (ai-service media proxy; served unauthenticated) */
  frontImageUrl?: Maybe<Scalars['String']['output']>
  /** Stable card key, e.g. the_moon */
  key?: Maybe<Scalars['String']['output']>
  /** 1-based position of the card within the pull */
  position?: Maybe<Scalars['Int']['output']>
  /** Whether the card was drawn reversed */
  reversed?: Maybe<Scalars['Boolean']['output']>
}

/** Oracle AI: Which divination reading stream to use when listing unique pulled card image keys (tarot vs oracle cards). */
export enum DivinationUniqueDrawReadingType {
  Oracle = 'ORACLE',
  Tarot = 'TAROT',
}

/**
 * **`documents` row:** hub for **chunk-level** vectors (`document_embeddings`), **optional explicit** links to catalog `Content` / `MediaAsset` via join tables, and **optional** offline whole-title text + vector in **`document_abstracts`**.
 *
 * **Content vs media — how fields differ (resolver behavior):**
 * - **Join tables:** `content_documents` links one **primary** `Content` (`contentId` ↔ `documentsId`). `media_asset_documents` links one **primary** `MediaAsset` (`mediaAssetsId` ↔ `documentsId`). A document may have either, both, or neither; list vs singular fields use **different precedence** (below).
 * - **`documentContent` / `documentMediaAsset` (singular):** Each reads **only** its join table. `documentContent` → `Content` from `content_documents` if the row exists, else `null`. `documentMediaAsset` → `MediaAsset` from `media_asset_documents` if the row exists, else `null`. They do **not** infer the other side from feature media alone.
 * - **`content` (list):** If `content_documents` exists → that linked `Content`. Else if only `media_asset_documents` exists → every `Content` whose **`featureMediaId`** equals the linked media asset’s **`mediaId`**. Else → `[]`.
 * - **`mediaAssets` (list):** If `media_asset_documents` exists → that linked `MediaAsset` only. Else if `content_documents` exists → the **feature** `MediaAsset` for that `Content` when `featureMediaId` is set. Else → `[]`.
 *
 * **Chunks vs abstract (`document_embeddings` vs `document_abstracts`):**
 * - **`documentEmbeddings`:** Many **`DocumentEmbedding`** rows — **chunked** text, **one vector per chunk**, **`metadata`** provenance. For **passages**, RAG, captions; not a single title summary.
 * - **Whole-title synopsis:** **`document_abstracts`** holds at most **one** **`DocumentAbstract`** per document — **`summaryText`**, **`summaryEmbedding`**, **`sumEmbedding`**, **`averageEmbedding`**. Resolve **`documentAbstract`** on **`Document`** (same **`documentAbstractList`** loader family as **`documentAbstractList`** query), or list/filter via **`documentAbstractList`**.
 *
 * **Related:** Title-scoped search often uses **`Content.relatedDocumentEmbeddings`**. For a one-paragraph synopsis use **`documentAbstract`** or **`documentAbstractList`**; for “which passage answers this?” use chunks / **`documentEmbeddings`**.
 */
export type Document = {
  __typename?: 'Document'
  /** **Expanded** `Content` list (see type doc): `content_documents` first; else content rows tied via linked media **`mediaId`** / **`featureMediaId`**. Not the same as **`documentContent`** (join-table–only). */
  content?: Maybe<Array<Maybe<Content>>>
  /** Row creation time. */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** At most **one** row from **`document_abstracts`**: LLM **`summaryText`**, **`summaryEmbedding`**, and pooled **`sumEmbedding`** / **`averageEmbedding`**. Loaded via the same **`documentAbstractList`** data loader keyed by this document’s **`id`** (`documentsId`). **`null`** until the worker has produced an abstract. */
  documentAbstract?: Maybe<DocumentAbstract>
  /** **Direct** link: `Content` from **`content_documents`**, or `null` if none. Does not resolve media-first documents (use **`content`**). */
  documentContent?: Maybe<Content>
  /** All **`document_embeddings`** chunk rows for this document: **`documentText`** + per-chunk **`embedding`**, optional **`queryRelevance`** when fetched with a query vector, and **`metadata`** (including **`documentSource`** for content vs media provenance). Optional `documentEmbeddings` argument filters by JSON **`metadata`**. For the offline title synopsis + pooled vectors, use **`documentAbstract`** (or **`documentAbstractList`**). For ranked, content-scoped retrieval prefer **`Content.relatedDocumentEmbeddings`**. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** **Direct** link: `MediaAsset` from **`media_asset_documents`**, or `null` if none. Does not resolve content-only documents (use **`mediaAssets`**). */
  documentMediaAsset?: Maybe<MediaAsset>
  /** Target chunk size when source text was split into `document_embeddings` rows. */
  embeddingChunks?: Maybe<Scalars['Int']['output']>
  /** Overlap between consecutive chunks (per worker configuration). */
  embeddingChunksOverlap?: Maybe<Scalars['Int']['output']>
  /** Content hash of source material last used when chunk embeddings were successfully written (worker bookkeeping). */
  embeddingDocumentHash?: Maybe<Scalars['String']['output']>
  /** Embedding model id stored on the document (e.g. text-embedding-ada-002); aligns with `embedding_config` for chunk indexing. */
  embeddingModel?: Maybe<Scalars['String']['output']>
  /** Primary key (`documents.id`); referenced as `documentsId` on `document_embeddings` and `document_abstracts`. */
  id?: Maybe<Scalars['ID']['output']>
  /** **Expanded** `MediaAsset` list (see type doc): `media_asset_documents` first; else feature media from linked content. Not the same as **`documentMediaAsset`** (join-table–only). */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** Row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * **`documents` row:** hub for **chunk-level** vectors (`document_embeddings`), **optional explicit** links to catalog `Content` / `MediaAsset` via join tables, and **optional** offline whole-title text + vector in **`document_abstracts`**.
 *
 * **Content vs media — how fields differ (resolver behavior):**
 * - **Join tables:** `content_documents` links one **primary** `Content` (`contentId` ↔ `documentsId`). `media_asset_documents` links one **primary** `MediaAsset` (`mediaAssetsId` ↔ `documentsId`). A document may have either, both, or neither; list vs singular fields use **different precedence** (below).
 * - **`documentContent` / `documentMediaAsset` (singular):** Each reads **only** its join table. `documentContent` → `Content` from `content_documents` if the row exists, else `null`. `documentMediaAsset` → `MediaAsset` from `media_asset_documents` if the row exists, else `null`. They do **not** infer the other side from feature media alone.
 * - **`content` (list):** If `content_documents` exists → that linked `Content`. Else if only `media_asset_documents` exists → every `Content` whose **`featureMediaId`** equals the linked media asset’s **`mediaId`**. Else → `[]`.
 * - **`mediaAssets` (list):** If `media_asset_documents` exists → that linked `MediaAsset` only. Else if `content_documents` exists → the **feature** `MediaAsset` for that `Content` when `featureMediaId` is set. Else → `[]`.
 *
 * **Chunks vs abstract (`document_embeddings` vs `document_abstracts`):**
 * - **`documentEmbeddings`:** Many **`DocumentEmbedding`** rows — **chunked** text, **one vector per chunk**, **`metadata`** provenance. For **passages**, RAG, captions; not a single title summary.
 * - **Whole-title synopsis:** **`document_abstracts`** holds at most **one** **`DocumentAbstract`** per document — **`summaryText`**, **`summaryEmbedding`**, **`sumEmbedding`**, **`averageEmbedding`**. Resolve **`documentAbstract`** on **`Document`** (same **`documentAbstractList`** loader family as **`documentAbstractList`** query), or list/filter via **`documentAbstractList`**.
 *
 * **Related:** Title-scoped search often uses **`Content.relatedDocumentEmbeddings`**. For a one-paragraph synopsis use **`documentAbstract`** or **`documentAbstractList`**; for “which passage answers this?” use chunks / **`documentEmbeddings`**.
 */
export type DocumentDocumentEmbeddingsArgs = {
  documentEmbeddings?: InputMaybe<Array<InputMaybe<DocumentEmbeddingFilterInput>>>
}

/**
 * **`document_abstracts`:** exactly **one row per `documents` row** — primary key **`documents_id`** (FK to **`documents.id`**). Populated by the **documents worker** using the same **rebuild → promote** pattern as other embedding tables (`document_abstracts_rebuild` → swap to live **`document_abstracts`**).
 *
 * **`summary_text` / `summary_embedding`:** The worker loads all **`document_embeddings`** rows for that document, builds text from chunk **`documentText`**, and runs **map-reduce summarization** (batched “map” over large concatenated text with configurable chunk size/overlap, then “reduce” into one synopsis). The synopsis is embedded into **`summary_embedding`** for cosine search.
 *
 * **`sum_embedding` / `average_embedding`:** Computed in the same worker pass as the summary: element-wise sum and per-dimension mean over all chunk **`embedding`** rows for this **`documents_id`** (offline pooled vectors for title-level similarity).
 *
 * **Relationship to chunks:** **`DocumentEmbedding`** rows are passage-level; this type is **one** offline title-level synopsis + **one** summary vector, plus **pooled** sum/average chunk vectors for title-level similarity without the LLM synopsis.
 *
 * **API:** Use **`documentAbstractList`** (Knex-backed loaders + optional text **`query`** for cosine-ranked results via `documentQueryEmbedding`), or **`Document.documentAbstract`** (batched via **`documentAbstractList`** loader by **`documentsId`**).
 */
export type DocumentAbstract = {
  __typename?: 'DocumentAbstract'
  /** Per-dimension average of chunk embeddings for this document. */
  averageEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** When this row was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Parent **`Document`** (same id as **`documentsId`**). */
  document?: Maybe<Document>
  /** Primary key: `documents_id` = `documents.id` (one abstract per document). */
  documentsId: Scalars['ID']['output']
  /** Element-wise sum of all chunk **`document_embeddings.embedding`** vectors for this document. */
  sumEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** Embedding of **`summaryText`** (`summary_embedding`); ranked against a search string via **`query`** on **`documentAbstractList`** (same embedding config family as this column). */
  summaryEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** LLM synopsis produced by the worker from aggregated **`document_embeddings`** text (map-reduce; not raw chunk concatenation in the DB). */
  summaryText?: Maybe<Scalars['String']['output']>
  /** When **`summary_text`** / **`summary_embedding`** were last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Document abstract list response */
export type DocumentAbstractListResponse = {
  __typename?: 'DocumentAbstractListResponse'
  /** Total number of rows matching filters (computed when the selection set requests `count`) */
  count?: Maybe<Scalars['Int']['output']>
  /** Rows from `document_abstracts` matching the query */
  documentAbstracts?: Maybe<Array<Maybe<DocumentAbstract>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Document abstract timestamp where input */
export type DocumentAbstractWhereDateTimeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Document abstract primary key / documents id where input */
export type DocumentAbstractWhereDocumentsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Document abstract where conditions to filter rows (`document_abstracts`) */
export type DocumentAbstractWhereInput = {
  /** Filter by `created_at` */
  createdAt?: InputMaybe<DocumentAbstractWhereDateTimeInput>
  /** Filter by `documents_id` (same as `Document.id`) */
  documentsId?: InputMaybe<DocumentAbstractWhereDocumentsIdInput>
  /** Filter by `summary_text` */
  summaryText?: InputMaybe<DocumentAbstractWhereSummaryTextInput>
  /** Filter by `updated_at` */
  updatedAt?: InputMaybe<DocumentAbstractWhereDateTimeInput>
}

/** Document abstract summary text where input */
export type DocumentAbstractWhereSummaryTextInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Is the value a substring of the field */
  like?: InputMaybe<Scalars['String']['input']>
  /** Is the value not equal to the field */
  ne?: InputMaybe<Scalars['String']['input']>
}

/** The output from an LLM chain */
export type DocumentAnswer = {
  __typename?: 'DocumentAnswer'
  /** The answer text */
  text?: Maybe<Scalars['String']['output']>
}

/** Document call chain response */
export type DocumentCallChainResponse = {
  __typename?: 'DocumentCallChainResponse'
  /** The answer for this chain step */
  answer?: Maybe<DocumentAnswer>
  /** A list of document embeddings returned from the search query in this chain step */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
}

/** A chain to call against the supplied templates and search results */
export type DocumentCallChainStepInput = {
  /** The chain to run */
  chain?: InputMaybe<DocumentChain>
  /** The context to load and use in the chain step */
  contextSource?: InputMaybe<DocumentContextSource>
  /** The llm to use in the chain */
  llm?: InputMaybe<DocumentLlm>
  /** The step search options */
  search?: InputMaybe<DocumentCallChainStepSearchInput>
  /** The llm temperature where higher is more creative (0.9) and lower is less creative (0.0) only used when chain is DocumentChain.PROMPT */
  temperature?: InputMaybe<Scalars['Float']['input']>
  /** The call prompt template only used when chain is DocumentChain.PROMPT */
  template?: InputMaybe<Scalars['String']['input']>
}

/** Document call chain step search input to filter search results */
export type DocumentCallChainStepSearchInput = {
  /** `embedding_config.key` for query embedding model (must match document embeddings store) */
  embeddingConfigKey?: InputMaybe<Scalars['String']['input']>
  /** The limit to the number of rows */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Metadata to match document embedding using a contains operator */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** The offset for the rows */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** The search query */
  query?: InputMaybe<Scalars['String']['input']>
  /** The where conditions to filter search rows */
  where?: InputMaybe<DocumentCallPromptChainStepSearchWhere>
}

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhere = {
  /** Filter based on query relevance values */
  queryRelevance?: InputMaybe<DocumentCallPromptChainStepSearchWhereQueryRelevanceInput>
}

/** GraphQL document chain where input */
export type DocumentCallPromptChainStepSearchWhereQueryRelevanceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Float']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Float']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Float']['input']>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['Float']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Float']['input']>
}

/** The available chains */
export enum DocumentChain {
  /** Run a LLM prompt */
  Prompt = 'PROMPT',
  /** Run Q&A using a query */
  RetrievalQa = 'RETRIEVAL_QA',
  /** Run Q&A using multi query generate from the query */
  RetrievalQaMultiQuery = 'RETRIEVAL_QA_MULTI_QUERY',
  /** Run a summarization */
  Summarization = 'SUMMARIZATION',
}

/** The source for the context e.g. the content data media assets data or the document embedding text */
export enum DocumentContextSource {
  /** The source document content */
  Content = 'CONTENT',
  /** The document embedding text */
  DocumentText = 'DOCUMENT_TEXT',
  /** The document embedding text and any metadata which can be loaded for the relationship */
  DocumentTextAndMetadata = 'DOCUMENT_TEXT_AND_METADATA',
  /** The source document media asset provider e.g. the entire text track (closed caption) */
  MediaAssetProvider = 'MEDIA_ASSET_PROVIDER',
}

/**
 * A single **chunk** of indexed text (and its vector) for a document: the atomic unit for semantic search, RAG citations, and transcript/caption-aligned lookups. Rows live in **`document_embeddings`** and are siblings under the same **`Document`** as other chunks.
 *
 * **Versus `document_abstracts`:** Chunks carry **passage** text (`documentText`) and **per-chunk** vectors. **`DocumentAbstract`** rows (`document_abstracts`) hold **one** LLM **summary** and **one** **`summaryEmbedding`** per document — use chunks for evidence spans; use **`Query.documentAbstractList`** for a compact overview or title-level vector similarity.
 *
 * **MCP / tool selection:** Use **`documentText` + `embedding`** for passage retrieval; use **`metadata.documentSource`** to explain provenance (content vs media asset vs related rows); use **`positionStart`/`positionEnd`/`positionUnit`** when the source is time-based (e.g. captions). **`queryRelevance`** appears when the parent query embedded a user question (e.g. `Content.relatedDocumentEmbeddings(query: ...)`). For title-level pooled vectors and the offline LLM synopsis, query **`documentAbstractList`** (e.g. `where: { documentsId: { eq: … } }`).
 */
export type DocumentEmbedding = {
  __typename?: 'DocumentEmbedding'
  /** Row creation time. */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Parent **`Document`** (`documents.id` = `documentsId`): holds chunking settings and join-table links to **`Content`** / **`MediaAsset`**. From **`Document`**, **`documentEmbeddings`** lists all chunks including this row; the separate **`document_abstracts`** summary + **`summaryEmbedding`** are exposed via **`documentAbstractList`**, not on **`Document`**. */
  document?: Maybe<Document>
  /** Ordinal chunk index within the parent document (ordering of text segments after splitting). */
  documentNumber?: Maybe<Scalars['Int']['output']>
  /** Resolved content row for the primary source content in metadata, when present. */
  documentSourceContent?: Maybe<Content>
  /** Featured content linked as context for this chunk (e.g. hero episode), when encoded in metadata. */
  documentSourceContentFeatured?: Maybe<Content>
  /** Series-level featured content for this chunk when encoded in metadata. */
  documentSourceContentFeaturedSeries?: Maybe<Content>
  /** Resolved media asset when this chunk came from a media-backed source in metadata. */
  documentSourceMediaAsset?: Maybe<MediaAsset>
  /** Raw passage text embedded in `embedding`. Use for display, quoting, and LLM context; this is not the offline whole-title pooled vectors on `document_abstracts` (see `documentAbstractList`). */
  documentText?: Maybe<Scalars['String']['output']>
  /** Parent document id in the `documents` table; pairs with `documentNumber` as the composite key. */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** Dense vector for this chunk’s `documentText`, comparable via cosine similarity to query embeddings. Dimensions follow the active `embedding_config` for `document_embeddings`. */
  embedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** BCP-47 style language code for this chunk row (partitions indexes and aggregates). */
  language?: Maybe<Scalars['String']['output']>
  /** Structured provenance and linkage: source content/media, related content rows, and language. Use to filter or explain *why* a chunk matched—not a substitute for title-level pooled vectors or per-document summaries from `documentAbstractList` (`document_abstracts`). */
  metadata?: Maybe<DocumentEmbeddingMetadata>
  /** End of source span when applicable (e.g. WebVTT cue), expressed in `positionUnit`. */
  positionEnd?: Maybe<Scalars['Float']['output']>
  /** Start of source span when applicable (e.g. WebVTT cue), expressed in `positionUnit`. */
  positionStart?: Maybe<Scalars['Float']['output']>
  /** Unit for `positionStart`/`positionEnd` (e.g. `seconds` for timed captions). */
  positionUnit?: Maybe<Scalars['String']['output']>
  /** Relevance score when this row was retrieved with a query embedding (higher = closer match). Omitted or null when no query was used. */
  queryRelevance?: Maybe<Scalars['Float']['output']>
  /** Additional related content rows linked through metadata `relatedContent`. */
  relatedContent?: Maybe<Array<Maybe<Content>>>
  /** Additional related media assets linked through metadata `relatedMediaAssets`. */
  relatedMediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** Nearest chunks by cosine similarity in vector space—useful for "more like this passage" exploration. Prefer query-based retrieval on `Content.relatedDocumentEmbeddings` when you have a natural-language question. */
  similarDocumentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** Row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * A single **chunk** of indexed text (and its vector) for a document: the atomic unit for semantic search, RAG citations, and transcript/caption-aligned lookups. Rows live in **`document_embeddings`** and are siblings under the same **`Document`** as other chunks.
 *
 * **Versus `document_abstracts`:** Chunks carry **passage** text (`documentText`) and **per-chunk** vectors. **`DocumentAbstract`** rows (`document_abstracts`) hold **one** LLM **summary** and **one** **`summaryEmbedding`** per document — use chunks for evidence spans; use **`Query.documentAbstractList`** for a compact overview or title-level vector similarity.
 *
 * **MCP / tool selection:** Use **`documentText` + `embedding`** for passage retrieval; use **`metadata.documentSource`** to explain provenance (content vs media asset vs related rows); use **`positionStart`/`positionEnd`/`positionUnit`** when the source is time-based (e.g. captions). **`queryRelevance`** appears when the parent query embedded a user question (e.g. `Content.relatedDocumentEmbeddings(query: ...)`). For title-level pooled vectors and the offline LLM synopsis, query **`documentAbstractList`** (e.g. `where: { documentsId: { eq: … } }`).
 */
export type DocumentEmbeddingSimilarDocumentEmbeddingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Document embedding filtering */
export type DocumentEmbeddingFilterInput = {
  /** Document embedding filtering */
  metadata?: InputMaybe<Scalars['JSON']['input']>
}

/** JSON-backed provenance for a chunk: which content/media rows produced it, optional related links, and language. Filterable via `documentEmbeddingsList(where: { metadata: ... })` for operators; use resolved `documentSource*` fields on `DocumentEmbedding` for navigation in GraphQL. */
export type DocumentEmbeddingMetadata = {
  __typename?: 'DocumentEmbeddingMetadata'
  /** Structured source pointers (content, media, related tables) for this chunk. */
  documentSource?: Maybe<DocumentEmbeddingMetadataDocumentSource>
  /** Language hint stored in metadata (may align with the row’s `language`). */
  language?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSource = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSource'
  /** The column in the datastore */
  column?: Maybe<Scalars['String']['output']>
  /** The content which the document embedding was created from */
  content?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The content that is the feature media for this document embedding */
  contentFeatured?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The content of type series that is the feature media for this document embedding */
  contentFeaturedSeries?: Maybe<DocumentEmbeddingMetadataDocumentSourceContent>
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The content which the document embedding was created from */
  mediaAsset?: Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>
  /** Related datastore data */
  related?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceRelated>>>
  /** Related content */
  relatedContent?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceContent>>>
  /** Related media assets */
  relatedMediaAssets?: Maybe<Array<Maybe<DocumentEmbeddingMetadataDocumentSourceMediaAsset>>>
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source content */
export type DocumentEmbeddingMetadataDocumentSourceContent = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceContent'
  /** The content content id */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content content type */
  contentType?: Maybe<Scalars['String']['output']>
  /** The content day number */
  dayNumber?: Maybe<Scalars['String']['output']>
  /** The content episode number */
  episodeNumber?: Maybe<Scalars['String']['output']>
  /** The content id */
  id?: Maybe<Scalars['ID']['output']>
  /** The content language */
  language?: Maybe<Scalars['String']['output']>
  /** The content path */
  path?: Maybe<Scalars['String']['output']>
  /** The content published at date */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** The content season number */
  seasonNumber?: Maybe<Scalars['String']['output']>
  /** The content title group id */
  titleGroupId?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source content input */
export type DocumentEmbeddingMetadataDocumentSourceContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['String']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The content day number */
  dayNumber?: InputMaybe<Scalars['String']['input']>
  /** The content episode number */
  episodeNumber?: InputMaybe<Scalars['String']['input']>
  /** The content id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The content language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The content path */
  path?: InputMaybe<Scalars['String']['input']>
  /** The content published at date */
  publishedAtDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The content season number */
  seasonNumber?: InputMaybe<Scalars['String']['input']>
  /** The content title group id */
  titleGroupId?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceDatastore {
  Database = 'DATABASE',
}

/** Document embedding row metadata document source data */
export type DocumentEmbeddingMetadataDocumentSourceInput = {
  /** The content which the document embedding was created from */
  content?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>
  /** The content which the document embedding was created from */
  mediaAsset?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>
  /** Related */
  related?: InputMaybe<Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceRelatedInput>>>
  /** Related content */
  relatedContent?: InputMaybe<
    Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceContentInput>>
  >
  /** Related media assets */
  relatedMediaAssets?: InputMaybe<
    Array<InputMaybe<DocumentEmbeddingMetadataDocumentSourceMediaAssetInput>>
  >
}

/** Document embedding row metadata document source media asset */
export type DocumentEmbeddingMetadataDocumentSourceMediaAsset = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceMediaAsset'
  /** The media asset duration */
  duation?: Maybe<Scalars['String']['output']>
  /** The media asset id */
  id?: Maybe<Scalars['ID']['output']>
  /** The media asset language */
  language?: Maybe<Scalars['String']['output']>
  /** The media id id */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The media reference type for this media asset */
  mediaReferenceType?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source media asset input */
export type DocumentEmbeddingMetadataDocumentSourceMediaAssetInput = {
  /** The media asset duration */
  duation?: InputMaybe<Scalars['String']['input']>
  /** The media asset id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The media asset language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The media id id */
  mediaId?: InputMaybe<Scalars['ID']['input']>
  /** The media reference type for this media asset */
  mediaReferenceType?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source related */
export type DocumentEmbeddingMetadataDocumentSourceRelated = {
  __typename?: 'DocumentEmbeddingMetadataDocumentSourceRelated'
  /** The column in the datastore */
  column?: Maybe<Scalars['String']['output']>
  /** The datastore */
  datastore?: Maybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The table name in the datastore */
  table?: Maybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: Maybe<Scalars['String']['output']>
}

/** Document embedding row metadata document source related input */
export type DocumentEmbeddingMetadataDocumentSourceRelatedInput = {
  /** The column in the datastore */
  column?: InputMaybe<Scalars['String']['input']>
  /** The datastore */
  datastore?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceDatastore>
  /** The table name in the datastore */
  table?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceTable>
  /** The column value in the datastore */
  value?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding row metadata document source datastore */
export enum DocumentEmbeddingMetadataDocumentSourceTable {
  Content = 'CONTENT',
  Media = 'MEDIA',
  MediaAssets = 'MEDIA_ASSETS',
}

/** Document embedding row metadata input */
export type DocumentEmbeddingMetadataInput = {
  /** The document source for the metadata */
  documentSource?: InputMaybe<DocumentEmbeddingMetadataDocumentSourceInput>
  /** The document embedding text language */
  language?: InputMaybe<Scalars['String']['input']>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereDocumentsIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The document emebdding where input */
export type DocumentEmbeddingWhereInput = {
  /** The document number field where clause */
  documentNumber?: InputMaybe<DocumentEmbeddingWhereDocumentNumberInput>
  /** The documents id field where clause */
  documentsId?: InputMaybe<DocumentEmbeddingWhereDocumentsIdInput>
  /** The document embedding language */
  language?: InputMaybe<DocumentEmbeddingWhereLanguageInput>
  /** The metadata field where clause */
  metadata?: InputMaybe<DocumentEmbeddingWhereMetadataInput>
}

/** Document embedding where id input */
export type DocumentEmbeddingWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value in the list of values */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** GraphQL document embedding metadata where input */
export type DocumentEmbeddingWhereMetadataInput = {
  /** The field contains the value */
  contains?: InputMaybe<DocumentEmbeddingMetadataInput>
}

/** Paged list of chunk rows from `document_embeddings` for admin-style filtering (metadata, language, ids)—not the same as relevance-ranked `Content.relatedDocumentEmbeddings`. */
export type DocumentEmbeddingsListResponse = {
  __typename?: 'DocumentEmbeddingsListResponse'
  /** Total rows matching `where` (uses a slower COUNT when requested). */
  count?: Maybe<Scalars['Int']['output']>
  /** Matching chunk rows. */
  documentEmbeddings?: Maybe<Array<Maybe<DocumentEmbedding>>>
  /** Limit applied to this response. */
  limit?: Maybe<Scalars['Int']['output']>
  /** Offset applied to this response. */
  offset?: Maybe<Scalars['Int']['output']>
}

/** The available LLMs for use in a chain */
export enum DocumentLlm {
  /** The OpenAI LLM */
  Openai = 'OPENAI',
}

/** Document multi query response */
export type DocumentMultiQueryResponse = {
  __typename?: 'DocumentMultiQueryResponse'
  /** Alternative queries to the provide query */
  query?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** An emedding generate using a query */
export type DocumentQueryEmbeddingResponse = {
  __typename?: 'DocumentQueryEmbeddingResponse'
  queryEmbedding?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
}

/** GraphQL document chain where input */
export type DocumentWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The document where input */
export type DocumentWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<DocumentWhereIdInput>
}

/** Documents list response */
export type DocumentsListResponse = {
  __typename?: 'DocumentsListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** Documents */
  documents?: Maybe<Array<Maybe<Document>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Documents worker reset response */
export type DocumentsWorkerResetResponse = {
  __typename?: 'DocumentsWorkerResetResponse'
  /** Will be true if reset was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The worker that was reset */
  worker?: Maybe<Worker>
}

/** One of the five dreamscapes chosen during a finished capture */
export type DreamCandidate = {
  __typename?: 'DreamCandidate'
  /** True for the last pick, the image shown before the member saves one */
  default: Scalars['Boolean']['output']
  /** The dreamscape and its renditions */
  dreamscape: Dreamscape
}

/** Finished Dreamcatcher capture. The route is Dreamcatcher. */
export type DreamCreateInput = {
  /** Client-generated id for this dream. Validated as a UUID. */
  clientDreamId: Scalars['ID']['input']
  /** Emotion keys for this dream */
  emotions: Array<Scalars['String']['input']>
  /** Member UI language. Omitted means en. Allowed values are en, de, es, and fr. */
  language?: InputMaybe<Scalars['String']['input']>
  /** Played rounds in the order they were shown. Exactly five picks are required. */
  rounds: Array<DreamscapeRoundInput>
  /** Optional dream text */
  text?: InputMaybe<Scalars['String']['input']>
}

/** One event from a dream interpretation stream */
export type DreamInterpretationEvent = {
  __typename?: 'DreamInterpretationEvent'
  /** moderation_refused, not_found, or unavailable */
  errorCode?: Maybe<Scalars['String']['output']>
  /** True on the last event */
  isFinal: Scalars['Boolean']['output']
  /** False when errorCode is set */
  success: Scalars['Boolean']['output']
  /** Markdown from this event. Empty on the final event after chunks, and on an error. */
  textChunk?: Maybe<Scalars['String']['output']>
}

/** A dream that already exists. text replaces the stored dream text only while no analysis is saved. */
export type DreamInterpretationInput = {
  /** Backend id from dreamCreate */
  dreamId: Scalars['ID']['input']
  /** Replacement dream text. Ignored once an analysis is saved. */
  text?: InputMaybe<Scalars['String']['input']>
}

/** The joined interpretation for an HTTP client */
export type DreamInterpretationPayload = {
  __typename?: 'DreamInterpretationPayload'
  /** moderation_refused, not_found, or unavailable */
  errorCode?: Maybe<Scalars['String']['output']>
  /** False when errorCode is set */
  success: Scalars['Boolean']['output']
  /** Joined markdown. Null when success is false. */
  text?: Maybe<Scalars['String']['output']>
}

/** Next dreamscape pair. Index 0 is Top and index 1 is Bottom. */
export type DreamNextImagePair = {
  __typename?: 'DreamNextImagePair'
  /** Dreamscapes in display order. Index 0 is Top and index 1 is Bottom. */
  dreamscapes: Array<Dreamscape>
}

/** Request for the next dreamscape pair */
export type DreamNextImagePairInput = {
  /** Client-generated id for this dream. Validated as a UUID. */
  clientDreamId: Scalars['ID']['input']
  /** Emotion keys for this dream */
  emotions: Array<Scalars['String']['input']>
  /** Prior rounds in the order they were shown */
  rounds: Array<DreamscapeRoundInput>
}

/** A stored Dreamcatcher capture */
export type DreamRecord = {
  __typename?: 'DreamRecord'
  /** Picked dreamscapes in pick order */
  candidates: Array<DreamCandidate>
  /** Client-generated id for this dream */
  clientDreamId: Scalars['ID']['output']
  /** Backend id for this dream. Distinct from clientDreamId. */
  id: Scalars['ID']['output']
}

/** A dreamscape and its renditions */
export type Dreamscape = {
  __typename?: 'Dreamscape'
  /** Stable dreamscape id */
  id: Scalars['ID']['output']
  /** Sized images for this dreamscape */
  renditions: Array<DreamscapeRendition>
}

/** One sized image of a dreamscape. Slots are square (1:1), threeByFour (3:4), and fourByThree (4:3). Fixture dreamscapes report the target slot size and one URL. Catalog dreamscapes report the measured JPEG size. A thumbnail slot is included when that file has been imported. */
export type DreamscapeRendition = {
  __typename?: 'DreamscapeRendition'
  /** Pixel height reported for this slot */
  height: Scalars['Int']['output']
  /** Rendition slot name */
  slot: Scalars['String']['output']
  /** Image URL for this slot */
  url: Scalars['String']['output']
  /** Pixel width reported for this slot */
  width: Scalars['Int']['output']
}

/** One completed comparison of two dreamscapes */
export type DreamscapeRoundInput = {
  /** Whether the member picked a dreamscape or neither */
  outcome: DreamscapeRoundOutcome
  /** Dreamscape the member picked when outcome is PICKED */
  pickedDreamscapeId?: InputMaybe<Scalars['ID']['input']>
  /** Dreamscape ids that were shown, Top then Bottom */
  shownDreamscapeIds: Array<Scalars['ID']['input']>
}

/** Whether the member picked a shown dreamscape or neither */
export enum DreamscapeRoundOutcome {
  Neither = 'NEITHER',
  Picked = 'PICKED',
}

/** A single block in a dynamic page layout */
export type DynamicLayoutBlock = {
  __typename?: 'DynamicLayoutBlock'
  /** Block-specific props as JSON */
  props?: Maybe<Scalars['JSON']['output']>
  /** Block type from the registry (e.g. 'for-you-hero', 'topic-section') */
  type: Scalars['String']['output']
}

/** Response from the dynamicLayout query */
export type DynamicLayoutResponse = {
  __typename?: 'DynamicLayoutResponse'
  /** Ordered list of blocks to render */
  blocks: Array<DynamicLayoutBlock>
  /** Unique ID for analytics attribution */
  layoutId: Scalars['ID']['output']
  /** How this layout was produced: 'llm', 'cache', 'default' */
  source: Scalars['String']['output']
  /** Schema version */
  version: Scalars['Int']['output']
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMapping = {
  __typename?: 'EcommerceSkuMapping'
  /** The content provider that represents the ecommerce sku primary language. It contains the content data for the sku itself. */
  contentProvider?: Maybe<ContentProvider>
  /** The contentProviderKey that maps to the content provider table record that represents this sku */
  contentProviderKey?: Maybe<Scalars['String']['output']>
  /** The content providers that represent the ecommerce sku across all languages. */
  contentProviders?: Maybe<Array<Maybe<ContentProvider>>>
  /** The content relating to the contentTitleGroupIds. Episodes may be nested in series. Empty when contentTitleGroupIds is empty. */
  contentRelated?: Maybe<Array<Maybe<Content>>>
  /** Subscription length in seconds from the start date */
  contentSetDurationSeconds?: Maybe<Scalars['Int']['output']>
  /** Subscription end date cap. When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: Maybe<Scalars['DateTime']['output']>
  /** Content set id for subscription access */
  contentSetId?: Maybe<Scalars['Int']['output']>
  /** Subscription start date */
  contentSetStartDate?: Maybe<Scalars['DateTime']['output']>
  /** Title group ids for alacarte content access. Empty array when this SKU grants subscription access only. */
  contentTitleGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Optional German description for this SKU mapping */
  descriptionDe?: Maybe<Scalars['String']['output']>
  /** Optional English description for this SKU mapping */
  descriptionEn?: Maybe<Scalars['String']['output']>
  /** Optional Spanish description for this SKU mapping */
  descriptionEs?: Maybe<Scalars['String']['output']>
  /** Optional French description for this SKU mapping */
  descriptionFr?: Maybe<Scalars['String']['output']>
  /** Optional German display name for this SKU mapping */
  displayNameDe?: Maybe<Scalars['String']['output']>
  /** Optional English display name for this SKU mapping */
  displayNameEn?: Maybe<Scalars['String']['output']>
  /** Optional Spanish display name for this SKU mapping */
  displayNameEs?: Maybe<Scalars['String']['output']>
  /** Optional French display name for this SKU mapping */
  displayNameFr?: Maybe<Scalars['String']['output']>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. Default is false. */
  doNotEntitle?: Maybe<Scalars['Boolean']['output']>
  /** The unique sku for the given provider */
  ecommerceSku?: Maybe<Scalars['ID']['output']>
  /** The ecommerce sku mapping bonus eligibilities related to this item */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** Whether this SKU mapping is enabled and available for use. Default is true. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Entitlement duration in seconds for alacarte content (content set 222) */
  entitlementDurationSeconds?: Maybe<Scalars['Int']['output']>
  /** Optional admin notes for this SKU mapping */
  notes?: Maybe<Scalars['String']['output']>
  /** The ecommerce provider */
  provider?: Maybe<Scalars['ID']['output']>
  /** The title of the variant */
  title?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingContentRelatedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Ecommerce Sku Mapping */
export type EcommerceSkuMappingEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'EcommerceSkuMappingBonusEligibilitiesListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilities?: Maybe<Array<Maybe<EcommerceSkuMappingBonusEligibility>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Ecommerce Sku input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where End Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput = {
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where conditions to filter rows */
export type EcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The ecommerceSku bonus eligibilities field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEcommerceSkuInput>
  endDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereEndDateInput>
  languages?: InputMaybe<EcommerceSkuMappingBonusEligibilityWhereLanguagesInput>
  planSku?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput>
  provider?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereProviderInput>
  retainOnPlanChange?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput>
  startDate?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput>
}

/** Ecommerce Sku Mapping Bonus Eligibility where PlanSku input type */
export type EcommerceSkuMappingBonusEligibilitiesWherePlanSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Provider input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Retain On Plan Change input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereRetainOnPlanChangeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Start Date input type */
export type EcommerceSkuMappingBonusEligibilitiesWhereStartDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibility = {
  __typename?: 'EcommerceSkuMappingBonusEligibility'
  /** The BillingProviderProduct that bestows this ecommerce sku */
  billingProviderProduct?: Maybe<BillingProviderProduct>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The description of the eligibility */
  description?: Maybe<Scalars['String']['output']>
  /** The ecommerce sku */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /** The ecommerce sku mapping for this record */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /** The end date when eligibility ends */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the ecommerce sku mapping bonus eligibility */
  id?: Maybe<Scalars['ID']['output']>
  /** A list of languages for this item */
  languages: Array<Language>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: Maybe<Scalars['String']['output']>
  /** An optional coupon code or gift card expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: Maybe<Scalars['DateTime']['output']>
  /** The plan sku that bestows this ecommerce sku */
  planSku?: Maybe<Scalars['String']['output']>
  /** The ecommerce provider */
  provider?: Maybe<Scalars['String']['output']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: Maybe<Scalars['Boolean']['output']>
  /** The start date when eligibility begins */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The users who have this eligibility */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<
    Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>
  >
}

/** Ecommerce SKU Mapping Bonus Eligibility */
export type EcommerceSkuMappingBonusEligibilityUserEcommerceSkuMappingBonusEligibilitiesArgs = {
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility create */
export type EcommerceSkuMappingBonusEligibilityCreateInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce Sku */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** A list of languages for this item */
  languages: Array<Language>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']['input']>
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']['input']>
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce Sku Provider */
  provider?: InputMaybe<Scalars['String']['input']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** Start Date */
  startDate: Scalars['DateTime']['input']
}

/** Ecommerce Sku Mapping Bonus Eligibility delete */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdInput = {
  /** id required to delete */
  id: Scalars['ID']['input']
}

/** Ecommerce Sku Mapping Bonus Eligibility update */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>
  /** End Date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** id required to update */
  id: Scalars['ID']['input']
  /** A list of languages for this item */
  languages?: InputMaybe<Array<Language>>
  /** An optional coupon code or gift card code to grant for marketplace */
  marketplaceCouponCode?: InputMaybe<Scalars['String']['input']>
  /** An optional coupon code or gift card code expiration to grant for marketplace */
  marketplaceCouponCodeExpiration?: InputMaybe<Scalars['DateTime']['input']>
  /** Plan Sku */
  planSku?: InputMaybe<Scalars['String']['input']>
  /** Whether to retain the bonus eligibilities when the user changes plan */
  retainOnPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** Start Date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Ecommerce Sku Mapping Bonus Eligibility where Language Ids input type */
export type EcommerceSkuMappingBonusEligibilityWhereLanguagesInput = {
  /** Includes any of the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Input for creating a GAIA_BONUS ecommerce SKU mapping (ecommerceSkuMappingCreate). Each SKU must grant at least one entitlement target unless doNotEntitle is true: alacarte content (non-empty contentTitleGroupIds), subscription access (contentSetId with timing fields), or both. Purchasers always receive content set 222; admins may attach additional content later and retroactively grant other content sets. Subscription-only example: contentTitleGroupIds: [], contentSetId, and contentSetDurationSeconds and/or contentSetEndDate. */
export type EcommerceSkuMappingCreateInput = {
  /** The contentProviderKey that maps to the content provider table record that represents this sku - this is immutable once created and will populate with a uuid if left out */
  contentProviderKey?: InputMaybe<Scalars['String']['input']>
  /** Subscription length in seconds from the start date. Required on create when contentSetId is set unless contentSetEndDate is provided. */
  contentSetDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Subscription end date cap. Required on create when contentSetId is set unless contentSetDurationSeconds is provided. When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Content set id for subscription access. Required for subscription-only SKUs (use with contentTitleGroupIds: []). When set, contentSetDurationSeconds and/or contentSetEndDate is required unless doNotEntitle is true. */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** Optional subscription start date. Defaults to grant time when omitted. */
  contentSetStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Required. Title group ids for alacarte video/content access. Pass [] for subscription-only SKUs. Content set 222 is always granted on purchase or bonus grant. Pass one or more ids for alacarte-only or combined alacarte + subscription SKUs. */
  contentTitleGroupIds: Array<InputMaybe<Scalars['String']['input']>>
  /** Optional German description for this SKU mapping */
  descriptionDe?: InputMaybe<Scalars['String']['input']>
  /** Optional English description for this SKU mapping */
  descriptionEn?: InputMaybe<Scalars['String']['input']>
  /** Optional Spanish description for this SKU mapping */
  descriptionEs?: InputMaybe<Scalars['String']['input']>
  /** Optional French description for this SKU mapping */
  descriptionFr?: InputMaybe<Scalars['String']['input']>
  /** Optional German display name for this SKU mapping */
  displayNameDe?: InputMaybe<Scalars['String']['input']>
  /** Optional English display name for this SKU mapping */
  displayNameEn?: InputMaybe<Scalars['String']['input']>
  /** Optional Spanish display name for this SKU mapping */
  displayNameEs?: InputMaybe<Scalars['String']['input']>
  /** Optional French display name for this SKU mapping */
  displayNameFr?: InputMaybe<Scalars['String']['input']>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']['input']>
  /** Ecommerce Sku */
  ecommerceSku: Scalars['String']['input']
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional entitlement duration in seconds for content set 222 */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** The languages of the content that represents this sku. If not provided, the primary language will be used. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Optional admin notes for this SKU mapping */
  notes?: InputMaybe<Scalars['String']['input']>
  /** The primaryLanguage of the content that represents this sku - this is immutable once created */
  primaryLanguage: Scalars['String']['input']
  /** Ecommerce Sku Provider */
  provider: Scalars['String']['input']
  /** The title of the ecommerce sku */
  title: Scalars['String']['input']
}

/** Input for updating a GAIA_BONUS ecommerce SKU mapping (ecommerceSkuMappingUpdateByProviderAndEcommerceSku). Omitted fields are unchanged. After the update, the mapping must still grant at least one entitlement target unless doNotEntitle is true. To make a SKU subscription-only, set contentTitleGroupIds: [] and provide contentSetId with subscription timing fields. */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput = {
  /** Subscription length in seconds from the start date */
  contentSetDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Subscription end date cap (must be after contentSetStartDate when both are set). When both duration and end date are set, the earlier of the two limits the entitlement. */
  contentSetEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Content set id for subscription access. When set, contentSetDurationSeconds and/or contentSetEndDate is required on the resulting mapping unless doNotEntitle is true. */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** Optional subscription start date */
  contentSetStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Title group ids for alacarte content access. Pass [] to remove alacarte access (requires contentSetId on the resulting mapping unless doNotEntitle is true). */
  contentTitleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Optional German description for this SKU mapping */
  descriptionDe?: InputMaybe<Scalars['String']['input']>
  /** Optional English description for this SKU mapping */
  descriptionEn?: InputMaybe<Scalars['String']['input']>
  /** Optional Spanish description for this SKU mapping */
  descriptionEs?: InputMaybe<Scalars['String']['input']>
  /** Optional French description for this SKU mapping */
  descriptionFr?: InputMaybe<Scalars['String']['input']>
  /** Optional German display name for this SKU mapping */
  displayNameDe?: InputMaybe<Scalars['String']['input']>
  /** Optional English display name for this SKU mapping */
  displayNameEn?: InputMaybe<Scalars['String']['input']>
  /** Optional Spanish display name for this SKU mapping */
  displayNameEs?: InputMaybe<Scalars['String']['input']>
  /** Optional French display name for this SKU mapping */
  displayNameFr?: InputMaybe<Scalars['String']['input']>
  /** Whether to not entitle this sku to users. For example, if the sku is a tshirt, we do not want to entitle it to users. */
  doNotEntitle?: InputMaybe<Scalars['Boolean']['input']>
  /** Ecommerce Sku required to update */
  ecommerceSku: Scalars['String']['input']
  /** Whether this SKU mapping is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Entitlement duration in seconds for alacarte content (content set 222). Used when contentTitleGroupIds is non-empty. */
  entitlementDurationSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Additional languages of the content that represents this sku. If languages already exist but are not provided, they will not be removed. */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Optional admin notes for this SKU mapping */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce Sku Provider required to update */
  provider: Scalars['String']['input']
  /** The title of the ecommerce sku */
  title?: InputMaybe<Scalars['String']['input']>
}

/** Ecommerce Sku Mappings list response */
export type EcommerceSkuMappingsListResponse = {
  __typename?: 'EcommerceSkuMappingsListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  ecommerceSkuMappings?: Maybe<Array<Maybe<EcommerceSkuMapping>>>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Ecommerce Sku Mapping where Content Title Group Ids input type */
export type EcommerceSkuMappingsWhereContentTitleGroupIdsInput = {
  /** Are the values in the field */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping where Do Not Entitle input type */
export type EcommerceSkuMappingsWhereDoNotEntitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mapping where Ecommerce Sku input type */
export type EcommerceSkuMappingsWhereEcommerceSkuInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Ecommerce Sku Mapping where Enabled input type */
export type EcommerceSkuMappingsWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Ecommerce Sku Mappings where conditions to filter rows */
export type EcommerceSkuMappingsWhereInput = {
  contentTitleGroupIds?: InputMaybe<EcommerceSkuMappingsWhereContentTitleGroupIdsInput>
  doNotEntitle?: InputMaybe<EcommerceSkuMappingsWhereDoNotEntitleInput>
  /** The ecommerceSku field where clause */
  ecommerceSku?: InputMaybe<EcommerceSkuMappingsWhereEcommerceSkuInput>
  enabled?: InputMaybe<EcommerceSkuMappingsWhereEnabledInput>
  provider?: InputMaybe<EcommerceSkuMappingsWhereProviderInput>
}

/** Ecommerce Sku Mapping where Provider input type */
export type EcommerceSkuMappingsWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Effective targeting for an ad after campaign/ad-group override rules */
export type EffectiveMarketingAdTargeting = {
  __typename?: 'EffectiveMarketingAdTargeting'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dimension: Scalars['String']['output']
  externalAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  isNegative: Scalars['Boolean']['output']
  normalizedValue?: Maybe<Scalars['String']['output']>
  ownerExternalId: Scalars['String']['output']
  ownerId?: Maybe<Scalars['ID']['output']>
  ownerLevel: Scalars['String']['output']
  platform: Scalars['String']['output']
  providerValue: Scalars['String']['output']
  sourceLevel: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Embedding parameters aligned with a target database table (key = Sequelize tableName) */
export type EmbeddingConfig = {
  __typename?: 'EmbeddingConfig'
  /** Created at */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Provider embedding model identifier */
  embeddingModel: Scalars['String']['output']
  /** Primary key */
  id: Scalars['ID']['output']
  /** Target table name this configuration applies to */
  key: Scalars['String']['output']
  /** Embedding API provider */
  provider: EmbeddingProvider
  /** Updated at */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Vector column dimension count (e.g. for pgvector) */
  vectorDimensions: Scalars['Int']['output']
}

/** Create a new embedding configuration row */
export type EmbeddingConfigCreateInput = {
  embeddingModel: Scalars['String']['input']
  /** Target Sequelize table name (unique) */
  key: Scalars['String']['input']
  provider: EmbeddingProvider
  vectorDimensions: Scalars['Int']['input']
}

/** Result of embedding_config create, update, or delete mutations */
export type EmbeddingConfigMutationPayload = {
  __typename?: 'EmbeddingConfigMutationPayload'
  /** The affected row (null when success is false, e.g. not found) */
  embeddingConfig?: Maybe<EmbeddingConfig>
  /** Whether the mutation completed successfully */
  success: Scalars['Boolean']['output']
}

/** Update an existing embedding configuration row */
export type EmbeddingConfigUpdateInput = {
  embeddingModel?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  key?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<EmbeddingProvider>
  vectorDimensions?: InputMaybe<Scalars['Int']['input']>
}

/** Where clause for embedding_config.embedding_model */
export type EmbeddingConfigWhereEmbeddingModelInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Where clause for embedding_config.id */
export type EmbeddingConfigWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Where clause for embedding_config.key */
export type EmbeddingConfigWhereKeyInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Where clause for embedding_config.provider (DB values: openai, google) */
export type EmbeddingConfigWhereProviderInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Where clause for embedding_config.vector_dimensions */
export type EmbeddingConfigWhereVectorDimensionsInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** List response for embedding configuration rows */
export type EmbeddingConfigsListResponse = {
  __typename?: 'EmbeddingConfigsListResponse'
  /** Total row count (only when requested in the query) */
  count?: Maybe<Scalars['Int']['output']>
  /** Matching rows */
  embeddingConfigs?: Maybe<Array<Maybe<EmbeddingConfig>>>
  /** Limit applied */
  limit?: Maybe<Scalars['Int']['output']>
  /** Offset applied */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Filter for embeddingConfigsList */
export type EmbeddingConfigsWhereInput = {
  embeddingModel?: InputMaybe<EmbeddingConfigWhereEmbeddingModelInput>
  id?: InputMaybe<EmbeddingConfigWhereIdInput>
  key?: InputMaybe<EmbeddingConfigWhereKeyInput>
  provider?: InputMaybe<EmbeddingConfigWhereProviderInput>
  vectorDimensions?: InputMaybe<EmbeddingConfigWhereVectorDimensionsInput>
}

/** Vendor that supplies text embeddings */
export enum EmbeddingProvider {
  Google = 'GOOGLE',
  Openai = 'OPENAI',
}

export type EntityRecognitionResult = {
  __typename?: 'EntityRecognitionResult'
  adjacency: Array<AdjacentCenter>
  entities: Array<RecognizedEntity>
  intentSignal: IntentSignal
}

/** Event-specific data fields */
export type EventDataInput = {
  /** Date after trial start (e.g. for SubscriptionSignup) */
  afterTrialStartDate?: InputMaybe<Scalars['String']['input']>
  /** AI chat experience name (e.g. ai_guide_on_the_side) */
  aiChatExperienceName?: InputMaybe<Scalars['String']['input']>
  /** Concept moment label (AI video guide toast) */
  aiConceptMomentLabel?: InputMaybe<Scalars['String']['input']>
  /** Concept moment start time in seconds (AI video guide toast) */
  aiConceptMomentStartSeconds?: InputMaybe<Scalars['Int']['input']>
  /** AI surface context (Layer 2) */
  aiContext?: InputMaybe<Scalars['String']['input']>
  /** Whether AI Discover search had results */
  aiDiscoverHadResults?: InputMaybe<Scalars['Boolean']['input']>
  /** AI Discover playlist UUID */
  aiDiscoverPlaylistId?: InputMaybe<Scalars['String']['input']>
  /** AI Discover refinement text length (privacy-safe metric) */
  aiDiscoverRefinementLength?: InputMaybe<Scalars['Int']['input']>
  /** AI Discover refinement word count (privacy-safe metric) */
  aiDiscoverRefinementWordCount?: InputMaybe<Scalars['Int']['input']>
  /** AI Discover search result count */
  aiDiscoverResultCount?: InputMaybe<Scalars['Int']['input']>
  /** AI Discover search state */
  aiDiscoverSearchState?: InputMaybe<Scalars['String']['input']>
  /** Enriched document info payload */
  aiEnrichedDocumentInfo?: InputMaybe<Scalars['String']['input']>
  /** Enriched document type (e.g. tarot, oracle) */
  aiEnrichedDocumentType?: InputMaybe<Scalars['String']['input']>
  /** Free-text AI error details from API or network failures */
  aiErrorDetails?: InputMaybe<Scalars['String']['input']>
  /** Message pair ID linking user message to AI response */
  aiMessagePairId?: InputMaybe<Scalars['String']['input']>
  /** How the user submitted a message (e.g. keyboard, click) */
  aiMessageSubmissionMethod?: InputMaybe<Scalars['String']['input']>
  /** AI moderation categories (comma-separated or JSON) */
  aiModerationCategories?: InputMaybe<Scalars['String']['input']>
  /** AI moderation severity level */
  aiModerationSeverity?: InputMaybe<Scalars['String']['input']>
  /** How the AI module was closed (e.g. dismiss, navigate) */
  aiModuleCloseMethod?: InputMaybe<Scalars['String']['input']>
  /** Whether AI module open was the initial open in session */
  aiModuleOpenIsInitial?: InputMaybe<Scalars['Boolean']['input']>
  /** AI persona identifier */
  aiPersona?: InputMaybe<Scalars['String']['input']>
  /** Content ID currently playing in AI video guide */
  aiPlayingContentId?: InputMaybe<Scalars['String']['input']>
  /** Feature media ID currently playing in AI video guide */
  aiPlayingFeatureMediaId?: InputMaybe<Scalars['String']['input']>
  /** AI module session duration in milliseconds */
  aiSessionDurationMs?: InputMaybe<Scalars['Int']['input']>
  /** AI session identifier (required for AI events) */
  aiSessionId?: InputMaybe<Scalars['String']['input']>
  /** Collated test assignments (optional, may be JSON string) */
  allTestsCollated?: InputMaybe<Scalars['String']['input']>
  /** Application name (required for some events). Valid values validated via Joi: android, android-app, ios-app, web-app, roku-app, wordpress-app, lovable-app, tvos-app, androidtv-app, firetv-app, ai-app, samsung-tv-app, lg-tv-app, vizio-tv-app. */
  appName?: InputMaybe<Scalars['String']['input']>
  /** Application version (required for some events) */
  appVersion?: InputMaybe<Scalars['String']['input']>
  /** User reached 5min threshold */
  at5Minutes?: InputMaybe<Scalars['Boolean']['input']>
  /** User at end (e.g. watch time > duration-15s or position >= 90%) */
  atEnd?: InputMaybe<Scalars['Boolean']['input']>
  /** User reached 25% engaged threshold */
  atEngaged?: InputMaybe<Scalars['Boolean']['input']>
  /** User reached 2min interested threshold */
  atInterested?: InputMaybe<Scalars['Boolean']['input']>
  /** User reached 15s qualified threshold */
  atQualified?: InputMaybe<Scalars['Boolean']['input']>
  /** Attempt number (e.g. for PaymentRecovered) */
  attemptNumber?: InputMaybe<Scalars['Int']['input']>
  /** Billing amount from Zuora settlement (preferred over price on purchase events) */
  billingAmount?: InputMaybe<Scalars['Float']['input']>
  /** Billing cycle days remaining (e.g. for CancelFlowStarted) */
  billingCycleDaysRemaining?: InputMaybe<Scalars['Int']['input']>
  /** Cancel reason (e.g. for CancelReasonSelected, CancelSaveOfferShown) */
  cancelReason?: InputMaybe<Scalars['String']['input']>
  /** Cart reactivation date (Braze profile cart_reactivation_date) */
  cartReactivationDate?: InputMaybe<Scalars['String']['input']>
  /** Cart start date (Braze profile cart_start_date) */
  cartStartDate?: InputMaybe<Scalars['String']['input']>
  /** Whether the browser already sent a GA4 purchase event */
  clientSentPurchase?: InputMaybe<Scalars['Boolean']['input']>
  /** Number of complimentary days (e.g. for SubscriptionComped) */
  compedDays?: InputMaybe<Scalars['Int']['input']>
  /** Content (video) ID */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Array of content IDs for view content events */
  contentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Content name for view content events */
  contentName?: InputMaybe<Scalars['String']['input']>
  /** Content identifier for detail page clicks */
  contentTitleGroupId?: InputMaybe<Scalars['String']['input']>
  /** Content type for view content events */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** Conversation ID (UUID) */
  conversationId?: InputMaybe<Scalars['String']['input']>
  /** Conversation title */
  conversationTitle?: InputMaybe<Scalars['String']['input']>
  /** Country (e.g. for UserLead) */
  country?: InputMaybe<Scalars['String']['input']>
  /** Acquisition or signup source tag (Braze profile creation_source) */
  creationSource?: InputMaybe<Scalars['String']['input']>
  /** Currency code (e.g., 'USD', 'EUR') */
  currency?: InputMaybe<Scalars['String']['input']>
  /** Date of birth in YYYY-MM-DD format (e.g. for UserAttributesUpdate) */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  /** Days since failure (e.g. for SubscriptionSuspended) */
  daysSinceFailure?: InputMaybe<Scalars['Float']['input']>
  /** Days since lapsed (e.g. for SubscriptionReactivated) */
  daysSinceLapsed?: InputMaybe<Scalars['Float']['input']>
  /** Days to recovery (e.g. for PaymentRecovered) */
  daysToRecovery?: InputMaybe<Scalars['Int']['input']>
  /** Total media duration in seconds */
  duration?: InputMaybe<Scalars['Int']['input']>
  /** Effective date (e.g. for PlanChanged) */
  effectiveDate?: InputMaybe<Scalars['String']['input']>
  /** Email address for lead events */
  email?: InputMaybe<Scalars['String']['input']>
  /** Braze email_subscribe: unsubscribed | subscribed | opted-in (validated by Joi) */
  emailSubscribe?: InputMaybe<Scalars['String']['input']>
  /** Entitled flag (Braze profile entitled) */
  entitled?: InputMaybe<Scalars['Boolean']['input']>
  /** Error type */
  errorType?: InputMaybe<Scalars['String']['input']>
  /** Event number in sequence */
  eventNumber?: InputMaybe<Scalars['Int']['input']>
  /** Everflow affiliate transaction ID (Braze profile everflow_transaction_id) */
  everflowTransactionId?: InputMaybe<Scalars['String']['input']>
  /** External identifier */
  externalId?: InputMaybe<Scalars['String']['input']>
  /** Failure reason (e.g. for PaymentFailed) */
  failureReason?: InputMaybe<Scalars['String']['input']>
  /** Facebook click ID */
  fbc?: InputMaybe<Scalars['String']['input']>
  /** Facebook browser ID */
  fbp?: InputMaybe<Scalars['String']['input']>
  /** Feedback type (e.g. refresh, copy) */
  feedbackType?: InputMaybe<Scalars['String']['input']>
  /** First name (e.g. for UserStartedCart) */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Form name (e.g. for UserLead) */
  formName?: InputMaybe<Scalars['String']['input']>
  /** GA4 client id (e.g. x.y from _ga cookie) */
  gaClientId?: InputMaybe<Scalars['String']['input']>
  /** GA4 session id from _ga_<MEASUREMENT_ID> cookie */
  gaSessionId?: InputMaybe<Scalars['String']['input']>
  /** GA4 session number (optional) */
  gaSessionNumber?: InputMaybe<Scalars['String']['input']>
  /** Gaia product SKU */
  gaiaProductSku?: InputMaybe<Scalars['String']['input']>
  /** Google Ads app click ID (gbraid). Mutually exclusive with gclid and wbraid for uploads. */
  gbraid?: InputMaybe<Scalars['String']['input']>
  /** Google Ads click ID (gclid). At most one of gclid, wbraid, gbraid should be set per event. */
  gclid?: InputMaybe<Scalars['String']['input']>
  /** Recipient email for gift subscription (e.g. for GiftSubscriptionPurchased). Optional. */
  giftSubscriptionPurchasedForEmail?: InputMaybe<Scalars['String']['input']>
  /** Guest phase identifier (required for some events) */
  guestPhase?: InputMaybe<Scalars['Boolean']['input']>
  /** Content Highlights CTA action */
  highlightAction?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights clip count in session */
  highlightClipCount?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights clip end time in seconds */
  highlightClipEndSec?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights active clip index (0-based) */
  highlightClipIndex?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights clip start time in seconds */
  highlightClipStartSec?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights continuous playback (advanced option) */
  highlightContinuousPlayback?: InputMaybe<Scalars['Boolean']['input']>
  /** Content Highlights curation mode (e.g. BEST_MATCHES) */
  highlightCurationMode?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights duration preset (e.g. 15min) */
  highlightDurationPreset?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights clip end path (overlay, auto_advance) */
  highlightEndedVia?: InputMaybe<Scalars['String']['input']>
  /** Whether Content Highlights search returned clips */
  highlightHadResults?: InputMaybe<Scalars['Boolean']['input']>
  /** Content Highlights transcript search language (e.g. EN) */
  highlightLanguage?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights maxResults sent to transcriptChunkSearch */
  highlightMaxResults?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights nav action (edit_search, new_highlights) */
  highlightNavAction?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights one span per video (advanced option) */
  highlightOneSpanPerVideo?: InputMaybe<Scalars['Boolean']['input']>
  /** Content Highlights session open source (recent_list, deep_link) */
  highlightOpenSource?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights advanced option changed */
  highlightOption?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights advanced option value */
  highlightOptionValue?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights search prompt length (privacy-safe) */
  highlightPromptLength?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights search prompt word count (privacy-safe) */
  highlightPromptWordCount?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights search result clip count */
  highlightResultCount?: InputMaybe<Scalars['Int']['input']>
  /** Content Highlights search outcome (success, no_results, error) */
  highlightSearchState?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights clip selection method (manual, auto_advance, initial) */
  highlightSelectionMethod?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights saved session UUID */
  highlightSessionId?: InputMaybe<Scalars['String']['input']>
  /** Content Highlights page view (landing, results) */
  highlightView?: InputMaybe<Scalars['String']['input']>
  /** Hold end (Braze hold_end_date, ISO 8601); preferred over resumeDate for GraphQL callers */
  holdEndDate?: InputMaybe<Scalars['String']['input']>
  /** Hold start (Braze hold_start_date, ISO 8601); preferred over pauseDate for GraphQL callers */
  holdStartDate?: InputMaybe<Scalars['String']['input']>
  /** In member base flag (Braze profile in_member_base) */
  inMemberBase?: InputMaybe<Scalars['Boolean']['input']>
  /** Input method (e.g. Text, Speech, Toggle) */
  inputMethod?: InputMaybe<Scalars['String']['input']>
  /** Impact click id (im_ref query param) for Impact.com conversion attribution. */
  irclickid?: InputMaybe<Scalars['String']['input']>
  /** Whether plan change is downgrade (e.g. for PlanChanged) */
  isDowngrade?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether content is featured (optional) */
  isFeaturedMedia?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether subscription is trial (e.g. for SubscriptionSignup) */
  isTrial?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether plan change is upgrade (e.g. for PlanChanged) */
  isUpgrade?: InputMaybe<Scalars['Boolean']['input']>
  /** Last name (e.g. for UserStartedCart) */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Precomputed marketing value for ad platforms (optional; server derives when absent) */
  marketingValue?: InputMaybe<Scalars['Float']['input']>
  /** Media ID */
  mediaId?: InputMaybe<Scalars['String']['input']>
  /** Media language (optional) */
  mediaLanguage?: InputMaybe<Scalars['String']['input']>
  /** User membership status (required for some events) */
  membershipStatus?: InputMaybe<Scalars['String']['input']>
  /** Message length in characters (e.g. for ai_message_received) */
  messageLength?: InputMaybe<Scalars['Int']['input']>
  /** Microsoft Advertising Click ID (msclkid) for Bing offline conversion attribution. */
  msclkid?: InputMaybe<Scalars['String']['input']>
  /** Next bill amount (Braze profile next_bill_amount) */
  nextBillAmount?: InputMaybe<Scalars['Float']['input']>
  /** Offer type (e.g. for CancelSaveOfferShown) */
  offerType?: InputMaybe<Scalars['String']['input']>
  /** Offer value (e.g. for CancelSaveOfferShown) */
  offerValue?: InputMaybe<Scalars['String']['input']>
  /** Order identifier for purchase events */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Page location identifier (optional) */
  pageLocation?: InputMaybe<Scalars['String']['input']>
  /** Paid-through date string (Braze profile paid_through_date) */
  paidThroughDate?: InputMaybe<Scalars['String']['input']>
  /** Parent series ID */
  parentSeriesId?: InputMaybe<Scalars['String']['input']>
  /** Parent series name (e.g. for recommendation events) */
  parentSeriesName?: InputMaybe<Scalars['String']['input']>
  /** Billing pause start (alias for hold_start_date; ISO 8601) */
  pauseDate?: InputMaybe<Scalars['String']['input']>
  /** Payment provider identifier (e.g. stripe, paypal) */
  paymentProvider?: InputMaybe<Scalars['String']['input']>
  /** Phone number (validated and standardized to E.164 via libphonenumber-js) */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** Plan display name (Braze profile plan_name) */
  planName?: InputMaybe<Scalars['String']['input']>
  /** Plan period label (Braze profile plan_period) */
  planPeriod?: InputMaybe<Scalars['String']['input']>
  /** Playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** Playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
  /** Play position in seconds */
  position?: InputMaybe<Scalars['Int']['input']>
  /** Price amount for purchase events */
  price?: InputMaybe<Scalars['Float']['input']>
  /** Prospect content id (Braze profile prospect_content_id) */
  prospectContentId?: InputMaybe<Scalars['String']['input']>
  /** Content rating (0: Dislike, 1: Like, 2: Love) */
  rating?: InputMaybe<Scalars['Int']['input']>
  /** Recommendation ID for Recombee events */
  recommId?: InputMaybe<Scalars['String']['input']>
  /** Response type (e.g. text) */
  responseType?: InputMaybe<Scalars['String']['input']>
  /** Scheduled resume (alias for hold_end_date; ISO 8601) */
  resumeDate?: InputMaybe<Scalars['String']['input']>
  /** Retention Period (1M, 3M, 6M, 12M, etc) */
  retentionPeriod?: InputMaybe<Scalars['String']['input']>
  /** Row name identifier (optional) */
  rowName?: InputMaybe<Scalars['String']['input']>
  /** Row placement identifier (optional) */
  rowPlacement?: InputMaybe<Scalars['Int']['input']>
  /** Search query text (e.g. for SearchPerformed) */
  searchQuery?: InputMaybe<Scalars['String']['input']>
  /** Acquisition or prospect behavior segment (Braze profile segment_acq) */
  segmentAcq?: InputMaybe<Scalars['String']['input']>
  /** Source (e.g. for SubscriptionReactivated) */
  source?: InputMaybe<Scalars['String']['input']>
  /** Subscription tier */
  subscriptionTier?: InputMaybe<Scalars['String']['input']>
  /** Suspension reason (e.g. for SubscriptionSuspended) */
  suspensionReason?: InputMaybe<Scalars['String']['input']>
  /** Tile position number (optional) */
  tileNumber?: InputMaybe<Scalars['Int']['input']>
  /** Topic identifier (e.g. for TopicClicked) */
  topicId?: InputMaybe<Scalars['String']['input']>
  /** Topic name (e.g. for TopicClicked) */
  topicName?: InputMaybe<Scalars['String']['input']>
  /** Total time watched in seconds */
  totalTimeWatched?: InputMaybe<Scalars['Int']['input']>
  /** Whether a trial period applies (e.g. for SubscriptionSignup) */
  trialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  /** TikTok Click ID (ttclid) for TikTok Events API offline conversion attribution. */
  ttclid?: InputMaybe<Scalars['String']['input']>
  /** TikTok Cookie ID (ttp) for TikTok Events API attribution. */
  ttp?: InputMaybe<Scalars['String']['input']>
  /** UI element identifier (optional) */
  uiElement?: InputMaybe<Scalars['String']['input']>
  /** UI location identifier (optional) */
  uiLocation?: InputMaybe<Scalars['String']['input']>
  /** Billing status label (Braze profile user_billing_status) */
  userBillingStatus?: InputMaybe<Scalars['String']['input']>
  /** User test assignment (optional) */
  userInTest?: InputMaybe<Scalars['Boolean']['input']>
  /** User language preference (required for some events); synced to Braze profile registration_language when present */
  userLanguage?: InputMaybe<Scalars['String']['input']>
  /** Lifetime Value - total amount paid over the lifetime of the user */
  userLifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** Attribution utm_campaign (Braze profile utm_campaign) */
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  /** Attribution utm_medium (Braze profile utm_medium) */
  utmMedium?: InputMaybe<Scalars['String']['input']>
  /** Raw attribution querystring (Braze profile utm_parameters) */
  utmParameters?: InputMaybe<Scalars['String']['input']>
  /** Attribution utm_platcamp (Braze profile utm_platcamp) */
  utmPlatcamp?: InputMaybe<Scalars['String']['input']>
  /** Attribution utm_rainbow (Braze profile utm_rainbow) */
  utmRainbow?: InputMaybe<Scalars['String']['input']>
  /** Attribution utm_source (Braze profile utm_source) */
  utmSource?: InputMaybe<Scalars['String']['input']>
  /** Player/device type (e.g. device_type from player stats) */
  vaPlayerName?: InputMaybe<Scalars['String']['input']>
  /** Video analytics session ID (e.g. user history row uuid) */
  vaSessionId?: InputMaybe<Scalars['String']['input']>
  /** Google Ads web-to-app click ID (wbraid). Mutually exclusive with gclid and gbraid for uploads. */
  wbraid?: InputMaybe<Scalars['String']['input']>
  /** Winback status */
  winback?: InputMaybe<Scalars['Boolean']['input']>
}

/** Filters for listing events */
export type EventListFilterInput = {
  /** End time range */
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>
  /** Only past events (endTime < now) */
  pastOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Start time range */
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>
  /** Event status filter */
  status?: InputMaybe<CommunityEventStatus>
  /** Only upcoming events (startTime > now) */
  upcomingOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export enum EventLocationType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL',
}

/** Event log input */
export type EventLogInput = {
  /** Action source (e.g., 'website') */
  actionSource?: InputMaybe<Scalars['String']['input']>
  /** Event-specific data with typed fields */
  data?: InputMaybe<EventDataInput>
  /** Optional event ID for tracking and deduplication (auto-generated if not provided) */
  eventId?: InputMaybe<Scalars['String']['input']>
  /** The event name */
  eventName: EventName
  /** Source URL where the event originated (optional, derived from referer if not provided) */
  eventSourceUrl?: InputMaybe<Scalars['String']['input']>
  /** Event timestamp (optional, defaults to now) */
  eventTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Optional test ID for testing environments */
  testId?: InputMaybe<Scalars['String']['input']>
}

/** Event log response */
export type EventLogResponse = {
  __typename?: 'EventLogResponse'
  /** Response message */
  message?: Maybe<Scalars['String']['output']>
  /** Whether the event was logged successfully */
  success: Scalars['Boolean']['output']
}

/** Event name for user interaction events (used by Facebook, Recombee, or Braze) */
export enum EventName {
  /** User cancels from the AI cancel modal */
  AiCancelModalCancelClicked = 'AiCancelModalCancelClicked',
  /** User engages with the AI cancel modal */
  AiCancelModalEngaged = 'AiCancelModalEngaged',
  /** User views the AI cancel modal */
  AiCancelModalViewed = 'AiCancelModalViewed',
  /** User deletes an AI conversation */
  AiConversationDeleted = 'AiConversationDeleted',
  /** User favorites an AI conversation */
  AiConversationFavorited = 'AiConversationFavorited',
  /** User updates an AI conversation name */
  AiConversationNameUpdated = 'AiConversationNameUpdated',
  /** User clicks on a conversation in sidebar */
  AiConversationOpened = 'AiConversationOpened',
  /** Fires when the user makes the first post of a session on a previously exiting thread from the full page experience */
  AiConversationResumed = 'AiConversationResumed',
  /** User clicks New Conversation button, submits text in the empty state of chat home, selects a pre prompt from AI home, submits text from the MH module, or selects a pre prompt from MH module */
  AiConversationStarted = 'AiConversationStarted',
  /** User unfavorites an AI conversation */
  AiConversationUnfavorited = 'AiConversationUnfavorited',
  /** User follows a playlist from AI Discover */
  AiDiscoverPlaylistFollowed = 'AiDiscoverPlaylistFollowed',
  /** User refines an AI Discover search */
  AiDiscoverRefined = 'AiDiscoverRefined',
  /** User completes an AI Discover search */
  AiDiscoverSearchCompleted = 'AiDiscoverSearchCompleted',
  /** User clicks a video from AI Discover */
  AiDiscoverVideoClicked = 'AiDiscoverVideoClicked',
  /** User views AI Discover tab */
  AiDiscoverViewed = 'AiDiscoverViewed',
  /** AI returns an enriched document (e.g. tarot/oracle) */
  AiEnrichedDocumentReceived = 'AiEnrichedDocumentReceived',
  /** AI returns an error response */
  AiErrorResponse = 'AiErrorResponse',
  /** User enters an AI experience surface */
  AiExperienceEntered = 'AiExperienceEntered',
  /** User exits an AI experience surface */
  AiExperienceExited = 'AiExperienceExited',
  /** User copies an AI message */
  AiMessageCopied = 'AiMessageCopied',
  /** AI message send or receive failed */
  AiMessageFailure = 'AiMessageFailure',
  /** User clicks thumbs up or down on an AI message */
  AiMessageFeedback = 'AiMessageFeedback',
  /** AI returns a message */
  AiMessageReceived = 'AiMessageReceived',
  /** User regenerates an AI message */
  AiMessageRegenerated = 'AiMessageRegenerated',
  /** User types a message to AI from empty screen, in existing conversation, in MH module, selects a pre prompt from empty AI home or MH module, or is in voice mode and sends something that the AI responds to */
  AiMessageSent = 'AiMessageSent',
  /** User shares an AI message */
  AiMessageShared = 'AiMessageShared',
  /** AI moderation violation detected */
  AiModerationViolation = 'AiModerationViolation',
  /** User clicks on AI Member Home module item */
  AiModuleClicked = 'AiModuleClicked',
  /** User dismisses AI Video Player module */
  AiModuleClosed = 'AiModuleClosed',
  /** User populates AI Video Player module */
  AiModuleOpened = 'AiModuleOpened',
  /** The AI module becomes visible in the users viewport */
  AiModuleViewed = 'AiModuleViewed',
  /** User clicks on AI navigation item */
  AiNavigationClicked = 'AiNavigationClicked',
  /** User views AI chat home page */
  AiPageViewChatHome = 'AiPageViewChatHome',
  /** User selects an AI persona */
  AiPersonaSelected = 'AiPersonaSelected',
  /** User is rate limited in AI chat */
  AiRateLimited = 'AiRateLimited',
  /** User clicks an AI recommendation */
  AiRecommendationClicked = 'AiRecommendationClicked',
  /** User receives an AI recommendation */
  AiRecommendationReceived = 'AiRecommendationReceived',
  /** User views an AI recommendation */
  AiRecommendationViewed = 'AiRecommendationViewed',
  /** User uses speech-to-text in AI chat */
  AiSpeechToText = 'AiSpeechToText',
  /** User submits unrecognized input in AI chat */
  AiUnrecognizedInput = 'AiUnrecognizedInput',
  /** User disables AI Video Guide in the Settings page */
  AiVideoguideDisabled = 'AiVideoguideDisabled',
  /** User enables AI Video Guide in the Settings page */
  AiVideoguideEnabled = 'AiVideoguideEnabled',
  /** User connected via AirPlay */
  AirplayConnected = 'AirplayConnected',
  /** User experienced an app error */
  AppErrorExperienced = 'AppErrorExperienced',
  /** Member clicks Cancel Plan / Manage Subscription */
  CancelFlowStarted = 'CancelFlowStarted',
  /** Member accepts pause or hold option in cancel flow */
  CancelPauseAccepted = 'CancelPauseAccepted',
  /** Member declines pause or hold option in cancel flow */
  CancelPauseDeclined = 'CancelPauseDeclined',
  /** Pause / hold option shown */
  CancelPauseShown = 'CancelPauseShown',
  /** Member selects reason in Step 1 of flow */
  CancelReasonSelected = 'CancelReasonSelected',
  /** Member accepts save offer in cancel flow */
  CancelSaveOfferAccepted = 'CancelSaveOfferAccepted',
  /** Member declines save offer in cancel flow */
  CancelSaveOfferDeclined = 'CancelSaveOfferDeclined',
  /** Save offer is displayed to member in Step 3 */
  CancelSaveOfferShown = 'CancelSaveOfferShown',
  /** User connected via Chromecast */
  ChromecastConnected = 'ChromecastConnected',
  /** User clicks a concept moment toast in AI video guide */
  ConceptMomentToastClicked = 'ConceptMomentToastClicked',
  /** User dismisses a concept moment toast in AI video guide */
  ConceptMomentToastDismissed = 'ConceptMomentToastDismissed',
  /** Concept moment toast shown in AI video guide */
  ConceptMomentToastShown = 'ConceptMomentToastShown',
  /** User clicks a Content Highlights clip CTA (overlay or detail panel) */
  ContentHighlightsClipActionClicked = 'ContentHighlightsClipActionClicked',
  /** Content Highlights clip reached end bound */
  ContentHighlightsClipEnded = 'ContentHighlightsClipEnded',
  /** User selects a Content Highlights clip in the rail */
  ContentHighlightsClipSelected = 'ContentHighlightsClipSelected',
  /** Content Highlights clip begins playing */
  ContentHighlightsClipStarted = 'ContentHighlightsClipStarted',
  /** User clicks Edit search or New highlights on Content Highlights */
  ContentHighlightsNavActionClicked = 'ContentHighlightsNavActionClicked',
  /** User changes Content Highlights advanced options */
  ContentHighlightsOptionsChanged = 'ContentHighlightsOptionsChanged',
  /** User views the Content Highlights page */
  ContentHighlightsPageViewed = 'ContentHighlightsPageViewed',
  /** Anonymous Highlights sampler: visitor tapped a seed-question chip */
  ContentHighlightsSamplerChipTapped = 'ContentHighlightsSamplerChipTapped',
  /** Anonymous Highlights sampler: clip-window playback started */
  ContentHighlightsSamplerClipStarted = 'ContentHighlightsSamplerClipStarted',
  /** Anonymous Highlights sampler: visitor clicked a locked teaser */
  ContentHighlightsSamplerTeaserLocked = 'ContentHighlightsSamplerTeaserLocked',
  /** Content Highlights transcript search completed */
  ContentHighlightsSearchCompleted = 'ContentHighlightsSearchCompleted',
  /** User submits a Content Highlights transcript search */
  ContentHighlightsSearchSubmitted = 'ContentHighlightsSearchSubmitted',
  /** User deletes a saved Content Highlights session */
  ContentHighlightsSessionDeleted = 'ContentHighlightsSessionDeleted',
  /** User opens a saved Content Highlights session */
  ContentHighlightsSessionOpened = 'ContentHighlightsSessionOpened',
  /** User clicks the Thumbs Up or Thumbs Down button */
  ContentRated = 'ContentRated',
  /** User viewed content (e.g. marketing site page with content id, type, and title). SNS uses snake_case content_viewed (e.g. Braze). Meta still receives standard ViewContent. */
  ContentViewed = 'ContentViewed',
  /** User clicks the Video or Series Title in Spotlight on the Member Home page, clicks the Title or Thumbnail on a Tile, clicks Video or Series Title in Jumbotron on Series | Episode Detail page, or clicks a Video Title in the Episode List, Related Tab, Recommended Next Video Tile, Just Finished Video, Notifications Menu, or Notifications page */
  DetailPageClicked = 'DetailPageClicked',
  /** User deleted a download */
  DownloadDeleted = 'DownloadDeleted',
  /** User purchases a gift subscription (use giftSubscriptionPurchasedForEmail for recipient) */
  GiftSubscriptionPurchased = 'GiftSubscriptionPurchased',
  /** Recipient redeems a gift subscription */
  GiftSubscriptionRedeemed = 'GiftSubscriptionRedeemed',
  /** User clicked an in-app message */
  InAppMessageClicked = 'InAppMessageClicked',
  /** User hits button to download a video to their device */
  OfflineDownloadStarted = 'OfflineDownloadStarted',
  /** User completed onboarding */
  OnboardingCompleted = 'OnboardingCompleted',
  /** User started onboarding */
  OnboardingStarted = 'OnboardingStarted',
  /** User views a page */
  PageViewed = 'PageViewed',
  /** Renewal charge fails (card decline, expired, etc.) */
  PaymentFailed = 'PaymentFailed',
  /** Failed payment subsequently succeeds */
  PaymentRecovered = 'PaymentRecovered',
  /** Member changes subscription plan (upgrade or downgrade) */
  PlanChanged = 'PlanChanged',
  /** User clicks Play button from Spotlight, Tile, Detail page, Video Player, Watch Later | Favorites | Watch History, Custom Playlist, Topic page, All Series page, Recently Added page, Films & Docs page, Recipes page, Yoga & Meditation page, All Yoga | All Meditations page, Person page, Programs | Lifestyle | Pilates & More, Search page, Episode List, Related tab, Recommended Next Tile on Video End Screen, or Video Autoplay on the Recommended Next Tile. User clicks Watch Now button in Jumbotron, for a Video in the Notifications Menu, or for a Video in the Notifications List page */
  PlayClick = 'PlayClick',
  /** User created a playlist */
  PlaylistCreated = 'PlaylistCreated',
  /** User deleted a playlist */
  PlaylistDeleted = 'PlaylistDeleted',
  /** Fires when API request to add a video or series to a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and checks a Checkbox for a Playlist */
  PlaylistItemAdded = 'PlaylistItemAdded',
  /** Fires when API request to remove a video or series from a playlist is fired. User clicks Add to Playlist button from Spotlight, Tile, Detail Page or Video Player and unchecks a Checkbox for the Playlist the video is in. User selects any Playlist on the My Library page, clicks the Edit button, clicks the Red X Button on any number of Tiles, then clicks Done */
  PlaylistItemRemoved = 'PlaylistItemRemoved',
  /** User shared a playlist */
  PlaylistShared = 'PlaylistShared',
  /** User played a preview (requires mediaLanguage, mediaId, contentTitleGroupId) */
  PreviewPlayed = 'PreviewPlayed',
  /** Refund has been completed */
  RefundCompleted = 'RefundCompleted',
  /** Member or system requests a refund */
  RefundRequested = 'RefundRequested',
  /** User loads a Row on Member Home page or clicks an Arrow button for a Row on Member Home page */
  RowImpression = 'RowImpression',
  /** User performs a search (e.g. in-app search) */
  SearchPerformed = 'SearchPerformed',
  /** User follows a series (notification subscription) */
  SeriesFollowed = 'SeriesFollowed',
  /** User unfollows a series (notification subscription) */
  SeriesUnfollowed = 'SeriesUnfollowed',
  /** User initiated a share */
  ShareInitiated = 'ShareInitiated',
  /** Member cancels subscription */
  SubscriptionCanceled = 'SubscriptionCanceled',
  /** Subscription is comped (complimentary) */
  SubscriptionComped = 'SubscriptionComped',
  /** Member pauses or holds subscription */
  SubscriptionPaused = 'SubscriptionPaused',
  /** Suspended or cancelled member reactivates */
  SubscriptionReactivated = 'SubscriptionReactivated',
  /** Subscription renews at end of billing period */
  SubscriptionRenewed = 'SubscriptionRenewed',
  /** Member resumes before the pause starts or ends a pause early */
  SubscriptionResumed = 'SubscriptionResumed',
  /** User signs up for a new subscription */
  SubscriptionSignup = 'SubscriptionSignup',
  /** Account moves to suspended state (payment failure grace period expired) */
  SubscriptionSuspended = 'SubscriptionSuspended',
  /** User follows a term/topic (notification subscription) */
  TermFollowed = 'TermFollowed',
  /** User unfollows a term/topic (notification subscription) */
  TermUnfollowed = 'TermUnfollowed',
  /** User clicks a sub or super topic on the browse All Topics page or clicks a Topic or Sub-topic from Topics Page */
  TopicClicked = 'TopicClicked',
  /** Updates one or more user profile attributes in downstream systems (e.g. Braze) */
  UserAttributesUpdate = 'UserAttributesUpdate',
  /** User Became Member */
  UserBecameMember = 'UserBecameMember',
  /** User posted a comment on content */
  UserComment = 'UserComment',
  /** Member converts from trial to paid or first recurring paid invoice (server-side); Meta maps to Convert_to_Paid */
  UserConvertedToPaid = 'UserConvertedToPaid',
  /** User changes their currency preference */
  UserCurrencyChanged = 'UserCurrencyChanged',
  /** User initiates checkout (e.g. See Plans button on Plan Selection page) */
  UserInitiatedCheckout = 'UserInitiatedCheckout',
  /** New prospect lead captured */
  UserLead = 'UserLead',
  /** User enters Credit Card / Paypal and clicks the Start Membership button on Payment page */
  UserPurchase = 'UserPurchase',
  /** User purchases a plan directly to paid */
  UserPurchasedDirectToPaid = 'UserPurchasedDirectToPaid',
  /** User purchased a free trial; Facebook displays as Free Trial Start - Purchase */
  UserPurchasedFreeTrial = 'UserPurchasedFreeTrial',
  /** User enters name, email, password and clicks Continue button on Account Creation page */
  UserRegistered = 'UserRegistered',
  /** User retained event */
  UserRetained = 'UserRetained',
  /** User began the cart process */
  UserStartedCart = 'UserStartedCart',
  /** Video analytics: user reached 5min threshold */
  Video5MinutesView = 'Video5MinutesView',
  /** Video buffering occurred */
  VideoBufferingEvent = 'VideoBufferingEvent',
  /** Video analytics: user reached end (e.g. watch time > duration-15s or position >= 90%) */
  VideoEndView = 'VideoEndView',
  /** Video analytics: video plays for 25% of the total duration. */
  VideoEngagedView = 'VideoEngagedView',
  /** Video analytics: user reached 2min interested threshold */
  VideoInterestedView = 'VideoInterestedView',
  /** User opened the video player (requires mediaLanguage, mediaId, contentTitleGroupId) */
  VideoPlayerOpened = 'VideoPlayerOpened',
  /** Video analytics: user reached 15s qualified threshold */
  VideoQualifiedView = 'VideoQualifiedView',
}

/** Feed image type enum */
export enum FeedImageType {
  /** Banner/cover image */
  Banner = 'banner',
  /** Profile/avatar image */
  Profile = 'profile',
}

/** Result of feed image upload */
export type FeedImageUploadResult = {
  __typename?: 'FeedImageUploadResult'
  /** The feed ID */
  feedId: Scalars['ID']['output']
  /** The image type */
  imageType: FeedImageType
  /** The URL to render the image */
  url: Scalars['String']['output']
}

/** Feed role type enum */
export enum FeedRoleType {
  /** Admin role with full permissions */
  Admin = 'ADMIN',
  /** Member role with standard permissions */
  Member = 'MEMBER',
}

/** Feed visibility level */
export enum FeedVisibility {
  /** Private feed - visible only to members, admin adds members */
  Private = 'PRIVATE',
  /** Public feed - visible to all, anyone can join */
  Public = 'PUBLIC',
}

/** Field-level visibility */
export enum FieldVisibility {
  Private = 'private',
  Public = 'public',
}

/** Response for flagWatchedVideo mutation */
export type FlagWatchedVideoResponse = {
  __typename?: 'FlagWatchedVideoResponse'
  /** Whether the mutation succeeded */
  success: Scalars['Boolean']['output']
}

/** A foreign exchange rate between two currencies */
export type ForexRate = {
  __typename?: 'ForexRate'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The destination currency */
  destinationCurrency: Scalars['String']['output']
  /** The exchange rate */
  exchangeRate: Scalars['Float']['output']
  /** The primary key for this record */
  id?: Maybe<Scalars['Int']['output']>
  /** The source currency */
  sourceCurrency: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Input for a currency pair lookup */
export type ForexRatePairInput = {
  /** The destination currency */
  destinationCurrency: Scalars['String']['input']
  /** The source currency */
  sourceCurrency: Scalars['String']['input']
}

/** Remaining balance on a Shopify gift card */
export type GiftCardBalance = {
  __typename?: 'GiftCardBalance'
  /** Amount as a decimal string (Shopify MoneyV2) */
  amount: Scalars['String']['output']
  /** ISO 4217 currency code */
  currencyCode: Scalars['String']['output']
}

/** Result of consuming the full balance of a Shopify gift card by code */
export type GiftCardConsumePayload = {
  __typename?: 'GiftCardConsumePayload'
  /** Amount debited as a decimal string; null when lookup or debit failed before consumption */
  amountConsumed?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Result of debiting a Shopify gift card */
export type GiftCardDebitPayload = {
  __typename?: 'GiftCardDebitPayload'
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Shopify gift card resolved by code (Admin API) */
export type GiftCardDetails = {
  __typename?: 'GiftCardDetails'
  balance: GiftCardBalance
  /** Whether the card can be used */
  enabled: Scalars['Boolean']['output']
  /** Shopify GiftCard GID */
  giftCardId: Scalars['ID']['output']
}

/** Oracle AI: Co-watch signal from knowledge graph */
export type GraphCowatchInput = {
  /** Catalog entity ID */
  entityId: Scalars['String']['input']
  /** Co-watched content title */
  name: Scalars['String']['input']
  /** Number of co-viewers */
  weight: Scalars['Float']['input']
}

/** Direction of edge traversal */
export enum GraphDirection {
  /** Both directions (UNION of outbound + inbound) */
  Both = 'BOTH',
  /** Inbound edges (to_node_id = start) */
  Inbound = 'INBOUND',
  /** Outbound edges (from_node_id = start) */
  Outbound = 'OUTBOUND',
}

/** An edge connecting two nodes with its neighbor */
export type GraphEdge = {
  __typename?: 'GraphEdge'
  /** Edge type (IN_CENTER, TAUGHT_BY, ALSO_WATCHED, etc.) */
  edgeType: Scalars['String']['output']
  /** The node on the other end of this edge */
  node: GraphNode
  /** Edge weight (count, score, etc. — null for unweighted edges) */
  weight?: Maybe<Scalars['Float']['output']>
}

/** Adjacent center discovered via shared content overlap. */
export type GraphEnrichAdjacentCenter = {
  __typename?: 'GraphEnrichAdjacentCenter'
  name: Scalars['String']['output']
  sharedContentCount: Scalars['Int']['output']
}

/** Co-watched content item with viewer overlap weight. */
export type GraphEnrichCowatchItem = {
  __typename?: 'GraphEnrichCowatchItem'
  contentId: Scalars['Int']['output']
  title?: Maybe<Scalars['String']['output']>
  weight: Scalars['Int']['output']
}

/** Named graph entity with ID for deep linking. */
export type GraphEnrichEntity = {
  __typename?: 'GraphEnrichEntity'
  entityId: Scalars['Int']['output']
  name: Scalars['String']['output']
}

/** Person entity with relationship role and ID. */
export type GraphEnrichPerson = {
  __typename?: 'GraphEnrichPerson'
  entityId: Scalars['Int']['output']
  name: Scalars['String']['output']
  role: Scalars['String']['output']
}

/** Rich graph context for a content item. Used by enrich mode (Mode 2). */
export type GraphEnrichResult = {
  __typename?: 'GraphEnrichResult'
  adjacentCenters: Array<GraphEnrichAdjacentCenter>
  centers: Array<GraphEnrichEntity>
  contentId: Scalars['Int']['output']
  cowatch: Array<GraphEnrichCowatchItem>
  focuses: Array<Scalars['String']['output']>
  genres: Array<Scalars['String']['output']>
  levels: Array<Scalars['String']['output']>
  path?: Maybe<Scalars['String']['output']>
  series?: Maybe<GraphEnrichSeriesInfo>
  styles: Array<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  teachers: Array<GraphEnrichPerson>
  title?: Maybe<Scalars['String']['output']>
  topics: Array<Scalars['String']['output']>
  userContext?: Maybe<GraphEnrichUserContext>
}

/** Series membership with episode ordering. */
export type GraphEnrichSeriesInfo = {
  __typename?: 'GraphEnrichSeriesInfo'
  entityId: Scalars['Int']['output']
  episodeOrder?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
}

/** User-specific context overlay for personalized responses. */
export type GraphEnrichUserContext = {
  __typename?: 'GraphEnrichUserContext'
  isTopCenter: Scalars['Boolean']['output']
  isTopTeacher: Scalars['Boolean']['output']
}

/** Oracle AI: Graph entity reference with name and catalog ID */
export type GraphEntityInput = {
  /** Catalog entity ID */
  entityId: Scalars['String']['input']
  /** Entity display name */
  name: Scalars['String']['input']
}

/** Entity type in the knowledge graph — matches content_type from content table */
export enum GraphEntityType {
  AdminCategory = 'admin_category',
  Article = 'article',
  ArticleCenter = 'article_center',
  BonusPackage = 'bonus_package',
  Category = 'category',
  Center = 'center',
  Clip = 'clip',
  ContentDocument = 'content_document',
  Course = 'course',
  CourseModule = 'course_module',
  Document = 'document',
  Duration = 'duration',
  Faq = 'faq',
  Focus = 'focus',
  Genre = 'genre',
  Guide = 'guide',
  GuideDay = 'guide_day',
  Level = 'level',
  MarketingCenter = 'marketing_center',
  Media = 'media',
  OnboardingChoices = 'onboarding_choices',
  Origin = 'origin',
  Person = 'person',
  Playlist = 'playlist',
  PlaylistDocument = 'playlist_document',
  Product = 'product',
  Promotion = 'promotion',
  RainbowCategory = 'rainbow_category',
  Segment = 'segment',
  Series = 'series',
  Service = 'service',
  Style = 'style',
  Tag = 'tag',
  Topic = 'topic',
  TopicCenter = 'topic_center',
  TranscriptDocument = 'transcript_document',
  User = 'user',
  Video = 'video',
  YiArticleTopic = 'yi_article_topic',
  YiConsumptionType = 'yi_consumption_type',
  YiContentType = 'yi_content_type',
  YiCourse = 'yi_course',
  YiCourseModule = 'yi_course_module',
  YiCourseModuleGroup = 'yi_course_module_group',
  YiCourseModuleType = 'yi_course_module_type',
  YiCourseSalesPage = 'yi_course_sales_page',
  YiHomepageHeroContent = 'yi_homepage_hero_content',
  YiMembershipPromo = 'yi_membership_promo',
  YiPracticeType = 'yi_practice_type',
  YiSeries = 'yi_series',
  YiTag = 'yi_tag',
  YiTagGroup = 'yi_tag_group',
}

/** Paginated response for single-hop neighbor traversal */
export type GraphNeighborResponse = {
  __typename?: 'GraphNeighborResponse'
  /** Edges matching the traversal criteria */
  edges: Array<GraphEdge>
  /** Total count of matching edges (before limit/offset) */
  totalCount: Scalars['Int']['output']
}

/** A node in the knowledge graph */
export type GraphNode = {
  __typename?: 'GraphNode'
  /** Business entity ID (content_id, uid, playlist uuid, etc.) */
  entityId: Scalars['String']['output']
  /** Entity type (content, series, person, tag, playlist, user) */
  entityType: GraphEntityType
  /** Internal graph node ID */
  id: Scalars['ID']['output']
  /** Human-readable name */
  name?: Maybe<Scalars['String']['output']>
  /** Arbitrary properties (JSONB) */
  properties?: Maybe<Scalars['JSON']['output']>
}

/** A terminal node from a two-hop path with aggregated weight */
export type GraphPathNode = {
  __typename?: 'GraphPathNode'
  /** The terminal node */
  node: GraphNode
  /** Number of distinct intermediate nodes */
  pathCount: Scalars['Int']['output']
  /** Aggregated weight across all paths reaching this node */
  pathWeight: Scalars['Float']['output']
}

/** Response for two-hop path traversal */
export type GraphPathResponse = {
  __typename?: 'GraphPathResponse'
  /** Terminal nodes reachable via the two-hop path */
  nodes: Array<GraphPathNode>
  /** Total distinct terminal nodes (before limit) */
  totalCount: Scalars['Int']['output']
}

/** Person with their relationship role to the content (e.g. TAUGHT_BY, DIRECTED_BY). */
export type GraphSearchPerson = {
  __typename?: 'GraphSearchPerson'
  name: Scalars['String']['output']
  role: Scalars['String']['output']
}

/**
 * Graph-powered content search result for agent tools (GraphRAG).
 * Includes graph context (centers, teachers, series, metadata) for rich display.
 */
export type GraphSearchResult = {
  __typename?: 'GraphSearchResult'
  centers: Array<Scalars['String']['output']>
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  cowatchTitle?: Maybe<Scalars['String']['output']>
  focuses: Array<Scalars['String']['output']>
  genres: Array<Scalars['String']['output']>
  levels: Array<Scalars['String']['output']>
  path?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  seriesTitle?: Maybe<Scalars['String']['output']>
  styles: Array<Scalars['String']['output']>
  teachers: Array<GraphSearchPerson>
  title?: Maybe<Scalars['String']['output']>
  topics: Array<Scalars['String']['output']>
}

/** Oracle AI: Graph series entity with episode weight */
export type GraphSeriesEntityInput = {
  /** Catalog entity ID */
  entityId: Scalars['String']['input']
  /** Series display name */
  name: Scalars['String']['input']
  /** Episode weight (season*1000+episode) */
  weight?: InputMaybe<Scalars['Float']['input']>
}

/** Horoscope document payload for component rendering. */
export type HoroscopeCardDocument = {
  __typename?: 'HoroscopeCardDocument'
  /** Resolve the back image URL for the referenced collection. Localized art follows the chat request language (en, es, fr, de). */
  backImageUrl?: Maybe<Scalars['String']['output']>
  collectionId?: Maybe<Scalars['ID']['output']>
  collectionKey?: Maybe<Scalars['String']['output']>
  horoscopeText: Scalars['String']['output']
  isFallbackGenerated?: Maybe<Scalars['Boolean']['output']>
  localDate: Scalars['String']['output']
  objects: Array<OracleDocumentObject>
  provider?: Maybe<Scalars['String']['output']>
  pullId: Scalars['ID']['output']
  pulledAt?: Maybe<Scalars['String']['output']>
  readingId: Scalars['ID']['output']
  zodiacSign: Scalars['String']['output']
}

/** Horoscope state for daily-sign exposure UI decisions. */
export type HoroscopeFeatureState = {
  __typename?: 'HoroscopeFeatureState'
  chatSessionId?: Maybe<Scalars['ID']['output']>
  dailySignExposure: Scalars['JSON']['output']
  defaultSign?: Maybe<Scalars['String']['output']>
  hasSession: Scalars['Boolean']['output']
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
  lastUsedSessionId?: Maybe<Scalars['ID']['output']>
}

/**
 * Image represents an image file that can be associated with content.
 *
 * IMPORTANT: Assets are PREFERRED over Images for accessing content-related images.
 * - Assets have a deterministic relationship to content through ContentAssetReference, providing
 *   a clear, predictable way to associate files with content.
 * - Images have a non-deterministic relationship to content through ImageContentRelationship,
 *   making them unsuitable for programmatic access where consistency is required.
 *
 * Images will continue to be supported for backward compatibility, but Assets should always
 * be preferred when possible. Use contentAssetReferences on Content to access images via Assets
 * instead of using imageContentRelationships.
 *
 * The Image type may link to an Asset via the asset field, but this relationship is non-deterministic.
 */
export type Image = {
  __typename?: 'Image'
  /**
   * The asset associated with this image (if one exists).
   * NOTE: Assets are preferred over Images. Assets have a deterministic relationship to content, while Images have a non-deterministic relationship.
   * Use Assets via contentAssetReferences on Content instead.
   */
  asset?: Maybe<Asset>
  /** The asset associated with this image */
  assetsId?: Maybe<Scalars['Int']['output']>
  /** Image Content Relationship primay key */
  contentRelationshipId?: Maybe<Scalars['ID']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** How this raster was produced: copy, imgix-upscale, or imgix-gen-fill */
  derivationMethod?: Maybe<Scalars['String']['output']>
  /** Imgix fill-gen-seed for imgix-gen-fill rasters */
  derivationSeed?: Maybe<Scalars['Int']['output']>
  /** Source image this derived raster was generated from */
  derivedFrom?: Maybe<Image>
  /** Source image this derived raster was generated from */
  derivedFromImageId?: Maybe<Scalars['ID']['output']>
  /** Catalog slot type this derived raster was placed into */
  derivedFromSlotType?: Maybe<Scalars['String']['output']>
  /** The file extension */
  fileExtension?: Maybe<Scalars['String']['output']>
  /** The file size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>
  /** The key for the image on the file system */
  fileSystemKey?: Maybe<Scalars['String']['output']>
  /** The hash of the image file */
  hash?: Maybe<Scalars['String']['output']>
  /** The height of the image in pixels */
  height?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** Image content relationship linked to this image */
  imageContentRelationship?: Maybe<ImageContentRelationship>
  /** The file mime type */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original file name that was uploaded for this image */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The provider of this image */
  provider?: Maybe<Scalars['String']['output']>
  /** The key used to access this image using the provider interface */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The render provider e.g. the render url which is returned to the apps */
  renderUrlProvider?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The image render url to be used when displaying an image */
  url?: Maybe<Scalars['String']['output']>
  /** The width of the image in pixels */
  width?: Maybe<Scalars['String']['output']>
}

/**
 * Legacy non-deterministic link between content and an `Image` row.
 * Prefer `Content.contentAssetReferences` for programmatic access. See lib/services/content/README.md.
 * Type strings overlap lib/services/images/types.js and lib/services/assets/content-reference-types.ts.
 */
export type ImageContentRelationship = {
  __typename?: 'ImageContentRelationship'
  /**
   * Why this row was matched to content (non-deterministic). Values: DEFAULT, FILENAME_SEARCH, PROVIDED, DIRECT.
   * See lib/services/image-content-relationships/content-match-reasons.ts
   */
  contentMatchReason?: Maybe<Scalars['String']['output']>
  /** The content title_group_id column linking from this image relationship to content */
  contentTitleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The Drupal 6 Content Type which is combined with d6Id for Drupal look ups */
  d6ContentType?: Maybe<Scalars['String']['output']>
  /** The Drupal 6 Id which is combined with d6ContentType for Drupal look ups */
  d6Id?: Maybe<Scalars['Int']['output']>
  /** Slot fill classification: ORIGINAL, LEGACY_DISPLAY_FILL, or DERIVED. */
  fillProvenance?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The image linked from this image content relationship */
  image?: Maybe<Image>
  /** The this is the default image for the content i.e. the source image */
  isSource?: Maybe<Scalars['Boolean']['output']>
  /** The language this image is meant to statisfy in the relationship */
  language?: Maybe<Scalars['String']['output']>
  /** The type of relationship between the image and content */
  type?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Image content relationship by content input */
export type ImageContentRelationshipByContentInput = {
  /** The content content id */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** The content content type */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The image content relationship types */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where contentTitleGroupId input */
export type ImageContentRelationshipWhereContentTitleGroupIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where d6ContentType input */
export type ImageContentRelationshipWhereD6ContentTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Image content relationship where d6Id input */
export type ImageContentRelationshipWhereD6IdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Is the value less than the field */
  let?: InputMaybe<Scalars['Int']['input']>
}

/** Image content relationship where id input */
export type ImageContentRelationshipWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship where input */
export type ImageContentRelationshipWhereInput = {
  /** Image content relationship where content title group id clause */
  contentTitleGroupId?: InputMaybe<ImageContentRelationshipWhereContentTitleGroupIdInput>
  /** Image content relationship where d6 id clause */
  d6ContentType?: InputMaybe<ImageContentRelationshipWhereD6ContentTypeInput>
  /** Image content relationship where d6 id clause */
  d6Id?: InputMaybe<ImageContentRelationshipWhereD6IdInput>
  /** Image content relationship where id clause */
  id?: InputMaybe<ImageContentRelationshipWhereIdInput>
  /** Image content relationship where language clause */
  language?: InputMaybe<ImageContentRelationshipWhereLanguageInput>
  /** Image content relationship where type clause */
  type?: InputMaybe<ImageContentRelationshipWhereTypeInput>
}

/** Image content relationship where language input */
export type ImageContentRelationshipWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship where type input */
export type ImageContentRelationshipWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image content relationship response */
export type ImageContentRelationshipsListResponse = {
  __typename?: 'ImageContentRelationshipsListResponse'
  /** A list of image content relationships */
  imageContentRelationships?: Maybe<Array<Maybe<ImageContentRelationship>>>
}

/** Image providers */
export enum ImageProviders {
  /** AWS S3 */
  AwsS3 = 'AWS_S3',
  /** The imgIX image service */
  Imgix = 'IMGIX',
}

/** Image where id input */
export type ImageWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Image where input */
export type ImageWhereInput = {
  /** Image where id clause */
  id?: InputMaybe<ImageWhereIdInput>
}

/** Images list response */
export type ImagesListResponse = {
  __typename?: 'ImagesListResponse'
  /** A list of images */
  images?: Maybe<Array<Maybe<Image>>>
}

/** A credit-card authorization to store for an imported check */
export type ImportRateLimitActionInput = {
  /** Client IP */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** When the authorization was created */
  createdAt: Scalars['DateTime']['input']
  /** Error text when success is false */
  failureReason?: InputMaybe<Scalars['String']['input']>
  /** FingerprintJS visitor id */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** Velocity check uuid the authorization belongs to */
  requestUuid: Scalars['ID']['input']
  /** Whether the authorization succeeded */
  success: Scalars['Boolean']['input']
  /** User id. Used when userInfoUuid is omitted or does not resolve. */
  uid?: InputMaybe<Scalars['Int']['input']>
  /** User uuid. Resolved to uid when the user exists. */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** An allow or block row to store for one action. The same sourceUuid and action are skipped on a later call. */
export type ImportRateLimitOverrideInput = {
  /** Action this row applies to */
  action: Scalars['String']['input']
  /** Required for a block row to match clientIp. Defaults to true for a block that has an IP. */
  blockIp?: InputMaybe<Scalars['Boolean']['input']>
  /** Client IP */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** When the Brooklyn row was created. Omit for the current time. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Defaults to true */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** FingerprintJS visitor id */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** allow or block */
  overrideType: RateLimitOverrideType
  /** Brooklyn allow or block uuid */
  sourceUuid: Scalars['ID']['input']
  /** User id. Used when userInfoUuid is omitted or does not resolve. */
  uid?: InputMaybe<Scalars['Int']['input']>
  /** User uuid. Resolved to uid when the user exists. */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** A velocity check to store without running rules */
export type ImportRateLimitRequestInput = {
  /** ADD_PAYMENT_METHOD or YI_ADD_PAYMENT_METHOD */
  action: Scalars['String']['input']
  /** Client IP */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** Consumption key to timestamp. Omitted leaves the map empty. */
  consumedAt?: InputMaybe<Scalars['JSON']['input']>
  /** When the check was created */
  createdAt: Scalars['DateTime']['input']
  /** FingerprintJS visitor id */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** Whether the check passed */
  success: Scalars['Boolean']['input']
  /** Whether the check required token consumption */
  tokenConsumption: Scalars['Boolean']['input']
  /** User id. Used when userInfoUuid is omitted or does not resolve. */
  uid?: InputMaybe<Scalars['Int']['input']>
  /** User uuid. Resolved to uid when the user exists. */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
  /** Velocity check uuid. This stays the token. */
  uuid: Scalars['ID']['input']
}

/** In or not-in list match */
export enum InNotInOperator {
  /** In list */
  In = 'IN',
  /** Not in list */
  NotIn = 'NOT_IN',
}

export type IntentSignal = {
  __typename?: 'IntentSignal'
  classification: Scalars['String']['output']
  reason: Scalars['String']['output']
  requiresLlm: Scalars['Boolean']['output']
}

export type InterestTopicOption = {
  __typename?: 'InterestTopicOption'
  /** Stable interest topic identifier */
  key: Scalars['String']['output']
  /** Display label for the topic */
  label: Scalars['String']['output']
}

export type InterestingAnswers = {
  __typename?: 'InterestingAnswers'
  /** Have you had an alien encounter? */
  alienEncounter?: Maybe<Scalars['Boolean']['output']>
  /** Do you think we're alone in the universe? */
  aloneInUniverse?: Maybe<Scalars['Boolean']['output']>
  /** If a spacecraft landed in front of you, would you approach it? */
  approachSpacecraft?: Maybe<Scalars['Boolean']['output']>
  /** Do you think deja vu is a clue or a glitch? (true=yes) */
  dejaVuBelief?: Maybe<Scalars['Boolean']['output']>
  /** Would you describe yourself as intuitive? */
  isIntuitive?: Maybe<Scalars['Boolean']['output']>
}

export enum Language {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
}

export enum LeaderboardTimeWindow {
  AllTime = 'ALL_TIME',
  Month = 'MONTH',
  Week = 'WEEK',
}

/** Live Access session row (event or track schedule); mirrors REST spotlight session objects */
export type LiveAccessSpotlightSessionSummary = {
  __typename?: 'LiveAccessSpotlightSessionSummary'
  allowAnon?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  /** Session end (ISO 8601 or as returned by REST) */
  endDate?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isFree?: Maybe<Scalars['Boolean']['output']>
  isLiveStream?: Maybe<Scalars['Boolean']['output']>
  linkUrl?: Maybe<Scalars['String']['output']>
  localeLongDay?: Maybe<Scalars['String']['output']>
  localeShortDay?: Maybe<Scalars['String']['output']>
  sessionTime?: Maybe<Scalars['String']['output']>
  speakerName?: Maybe<Scalars['String']['output']>
  /** Session start (ISO 8601 or as returned by REST) */
  startDate?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Platform-specific English rewording with its own locale values */
export type LocalizationAlternateString = {
  __typename?: 'LocalizationAlternateString'
  /** Platform this alternate applies to */
  platform: LocalizationPlatform
  /** English source for this platform */
  string: Scalars['String']['output']
  /** Locale values for this alternate */
  translations: LocalizationLocaleValues
}

/** Platform-specific English rewording input */
export type LocalizationAlternateStringInput = {
  /** Platform this alternate applies to */
  platform: LocalizationPlatform
  /** English source for this platform */
  string?: InputMaybe<Scalars['String']['input']>
  /** Locale values for this alternate */
  translations?: InputMaybe<LocalizationLocaleValuesInput>
}

/** Primary locale values for a localization string */
export type LocalizationLocaleValues = {
  __typename?: 'LocalizationLocaleValues'
  /** German translation */
  de: Scalars['String']['output']
  /** Spanish translation */
  es: Scalars['String']['output']
  /** French translation */
  fr: Scalars['String']['output']
}

/** Primary locale values input */
export type LocalizationLocaleValuesInput = {
  /** German translation */
  de?: InputMaybe<Scalars['String']['input']>
  /** Spanish translation */
  es?: InputMaybe<Scalars['String']['input']>
  /** French translation */
  fr?: InputMaybe<Scalars['String']['input']>
}

/** Client platform that a localization string or alternate targets */
export enum LocalizationPlatform {
  /** Android resource catalog */
  Android = 'android',
  /** iOS resource catalog */
  Ios = 'ios',
  /** Web i18n catalog */
  Web = 'web',
}

/** A localization string row for the admin translation hub */
export type LocalizationString = {
  __typename?: 'LocalizationString'
  /** Username snapshot of the creator */
  addedBy: Scalars['String']['output']
  /** User id of the creator */
  addedByUid: Scalars['Int']['output']
  /** Platform-specific English rewordings with their own locale values */
  alternateStrings: Array<LocalizationAlternateString>
  /** Android resource keys; empty means the string does not ship to Android */
  androidKeys: Array<Scalars['String']['output']>
  /** Freeform disambiguation when the same English string is used in more than one sense */
  context: Scalars['String']['output']
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** iOS resource keys; empty means the string does not ship to iOS */
  iosKeys: Array<Scalars['String']['output']>
  /** Grouping label for related strings (feature, release, etc.) */
  jobName: Scalars['String']['output']
  /** Whether an editor flagged this row for review */
  needsReview: Scalars['Boolean']['output']
  /** Pickup priority */
  priority: LocalizationStringPriority
  /** Derived completeness */
  status: LocalizationStringStatus
  /** English source string */
  string: Scalars['String']['output']
  /** Username snapshot of the translator who completed the row */
  translatedBy: Scalars['String']['output']
  /** User id of the translator who completed the row */
  translatedByUid?: Maybe<Scalars['Int']['output']>
  /** Primary locale values */
  translations: LocalizationLocaleValues
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Web i18n keys; empty means the string does not ship to Web */
  webKeys: Array<Scalars['String']['output']>
}

/** Localization string create input */
export type LocalizationStringCreateInput = {
  /** Platform-specific English rewordings */
  alternateStrings?: InputMaybe<Array<LocalizationAlternateStringInput>>
  /** Android resource keys */
  androidKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Freeform disambiguation when the same English string is used in more than one sense */
  context?: InputMaybe<Scalars['String']['input']>
  /** When true, generate de/es/fr via DeepL after create */
  generateTranslations?: InputMaybe<Scalars['Boolean']['input']>
  /** iOS resource keys */
  iosKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Grouping label for related strings */
  jobName: Scalars['String']['input']
  /** Pickup priority */
  priority?: InputMaybe<LocalizationStringPriority>
  /** English source string */
  string: Scalars['String']['input']
  /** Web i18n keys */
  webKeys?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Localization string create response */
export type LocalizationStringCreateResponse = {
  __typename?: 'LocalizationStringCreateResponse'
  /** DeepL generation error; null when generation was skipped or succeeded */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** The created localization string */
  localizationString: LocalizationString
  /** Whether the creation was successful */
  success: Scalars['Boolean']['output']
}

/** Localization string delete response */
export type LocalizationStringDeleteResponse = {
  __typename?: 'LocalizationStringDeleteResponse'
  /** The deleted localization string */
  localizationString: LocalizationString
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** Localization string list response */
export type LocalizationStringListResponse = {
  __typename?: 'LocalizationStringListResponse'
  /** Total number of rows matching the query */
  count: Scalars['Int']['output']
  /** The limit applied to the rows */
  limit: Scalars['Int']['output']
  /** A list of localization strings */
  localizationStrings: Array<LocalizationString>
  /** The offset applied to the rows */
  offset: Scalars['Int']['output']
}

/** Pickup priority for a localization string */
export enum LocalizationStringPriority {
  /** High pickup priority */
  High = 'high',
  /** Low pickup priority */
  Low = 'low',
  /** Default pickup priority */
  Medium = 'medium',
}

/** Derived completeness of a localization string */
export enum LocalizationStringStatus {
  /** Primary and every alternate have all locale values filled */
  Complete = 'complete',
  /** Primary and alternate locale values are not all filled */
  Open = 'open',
}

/** Localization string update input */
export type LocalizationStringUpdateInput = {
  /** Platform-specific English rewordings */
  alternateStrings?: InputMaybe<Array<LocalizationAlternateStringInput>>
  /** Android resource keys */
  androidKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Freeform disambiguation when the same English string is used in more than one sense */
  context?: InputMaybe<Scalars['String']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** iOS resource keys */
  iosKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Grouping label for related strings */
  jobName?: InputMaybe<Scalars['String']['input']>
  /** Whether an editor flagged this row for review */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>
  /** Pickup priority */
  priority?: InputMaybe<LocalizationStringPriority>
  /** English source string */
  string?: InputMaybe<Scalars['String']['input']>
  /** Primary locale values */
  translations?: InputMaybe<LocalizationLocaleValuesInput>
  /** Web i18n keys */
  webKeys?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Localization string update response */
export type LocalizationStringUpdateResponse = {
  __typename?: 'LocalizationStringUpdateResponse'
  /** The updated localization string */
  localizationString: LocalizationString
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
}

/** Localization string where context input */
export type LocalizationStringWhereContextInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
}

/** Localization string where id input */
export type LocalizationStringWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Localization string where conditions to filter rows */
export type LocalizationStringWhereInput = {
  /** The context field where clause */
  context?: InputMaybe<LocalizationStringWhereContextInput>
  /** The id field where clause */
  id?: InputMaybe<LocalizationStringWhereIdInput>
  /** The job name field where clause */
  jobName?: InputMaybe<LocalizationStringWhereJobNameInput>
  /** Match any android, iOS, or web catalog key */
  key?: InputMaybe<LocalizationStringWhereKeyInput>
  /** The needs review field where clause */
  needsReview?: InputMaybe<LocalizationStringWhereNeedsReviewInput>
  /** The status field where clause */
  status?: InputMaybe<LocalizationStringWhereStatusInput>
  /** The English source string where clause */
  string?: InputMaybe<LocalizationStringWhereStringInput>
}

/** Localization string where job name input */
export type LocalizationStringWhereJobNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
}

/** Localization string where catalog key input */
export type LocalizationStringWhereKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Localization string where needs review input */
export type LocalizationStringWhereNeedsReviewInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Localization string where status input */
export type LocalizationStringWhereStatusInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<LocalizationStringStatus>
}

/** Localization string where source string input */
export type LocalizationStringWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** The input for a login / renew cookie argument */
export type LoginRenewCookieInput = {
  /** The domain for the cookie where it is valid */
  domain?: InputMaybe<Scalars['String']['input']>
  /** When true include cookie information the the token data that is returned */
  include?: InputMaybe<Scalars['Boolean']['input']>
  /** When true the cookie is considered secure */
  secure?: InputMaybe<Scalars['Boolean']['input']>
  /** When true call express cookie function to send the cookie header */
  send?: InputMaybe<Scalars['Boolean']['input']>
}

export type LoginRenewResponse = {
  __typename?: 'LoginRenewResponse'
  /** The current user authentication group, authentication tokens with values less than the current value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** The client attributes for the authentication token */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The codes for the login result */
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The user country based on the request */
  country?: Maybe<Scalars['String']['output']>
  /** The user display name */
  displayName?: Maybe<Scalars['String']['output']>
  /** The user email address */
  email?: Maybe<Scalars['String']['output']>
  /** The date when the token expires */
  idExpires?: Maybe<Scalars['DateTime']['output']>
  /**
   * Legacy HMAC token for API requests; no longer issued (always empty). Use jwt instead.
   * @deprecated Legacy idToken removed; field retained empty for backward compatibility
   */
  idToken?: Maybe<Scalars['String']['output']>
  /** A JWT token to use in authentication requests */
  jwt?: Maybe<Scalars['ID']['output']>
  /** The user languages */
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The date of the last billing event which can be used to by an application to determine if new billing data should be fetched */
  lastBillingEvent?: Maybe<Scalars['DateTime']['output']>
  /** The messages for the login result */
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** A list of user roles ids */
  roleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The google subscription status */
  subscriptionStatus?: Maybe<Scalars['String']['output']>
  /** A list of user subcription ids */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** When true login was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The user uid */
  uid?: Maybe<Scalars['ID']['output']>
  /** The current user account authentication group, authentication tokens with values less than the current value are invalid */
  userAccountAuthenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** The user account id */
  userAccountId?: Maybe<Scalars['ID']['output']>
  /** The user username */
  username?: Maybe<Scalars['String']['output']>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

export type MarketingAd = {
  __typename?: 'MarketingAd'
  adGroupId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  effectiveTargeting: Array<EffectiveMarketingAdTargeting>
  externalAccountId: Scalars['String']['output']
  externalCampaignId?: Maybe<Scalars['String']['output']>
  externalGroupId: Scalars['String']['output']
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Marketing ad platform account (ingested from external APIs) */
export type MarketingAdAccount = {
  __typename?: 'MarketingAdAccount'
  configLabel?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  currency?: Maybe<Scalars['String']['output']>
  externalAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  timezone?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingAdAccountListResponse = {
  __typename?: 'MarketingAdAccountListResponse'
  accounts: Array<MarketingAdAccount>
  total: Scalars['Int']['output']
}

export type MarketingAdCreateInput = {
  accountExternalId: Scalars['String']['input']
  adGroupName?: InputMaybe<Scalars['String']['input']>
  adText?: InputMaybe<Scalars['String']['input']>
  callToAction?: InputMaybe<Scalars['String']['input']>
  callToActionType?: InputMaybe<Scalars['String']['input']>
  campaignName?: InputMaybe<Scalars['String']['input']>
  creativeId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<Scalars['String']['input']>>
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId: Scalars['String']['input']
  facebookPageId?: InputMaybe<Scalars['String']['input']>
  finalUrls?: InputMaybe<Array<Scalars['String']['input']>>
  headline?: InputMaybe<Scalars['String']['input']>
  headlines?: InputMaybe<Array<Scalars['String']['input']>>
  identityId?: InputMaybe<Scalars['String']['input']>
  identityType?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  marketingCampaignId?: InputMaybe<Scalars['ID']['input']>
  mediaSource?: InputMaybe<MarketingCreativeMediaSourceInput>
  message?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pinId?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
  videoId?: InputMaybe<Scalars['String']['input']>
}

export type MarketingAdGroup = {
  __typename?: 'MarketingAdGroup'
  ads: Array<MarketingAd>
  campaignId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalAccountId: Scalars['String']['output']
  externalCampaignId: Scalars['String']['output']
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  targeting: Array<MarketingAdTargeting>
  targetingSyncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingAdGroupAdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type MarketingAdGroupTargetingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type MarketingAdGroupCreateInput = {
  accountExternalId: Scalars['String']['input']
  /** Meta click-through attribution window in days: 0, 1, or 7. */
  attributionClickDays?: InputMaybe<Scalars['Int']['input']>
  /** Meta view-through attribution window in days: 0, 1, or 7. */
  attributionViewDays?: InputMaybe<Scalars['Int']['input']>
  bidAmountMicros?: InputMaybe<Scalars['Float']['input']>
  bidStrategy?: InputMaybe<Scalars['String']['input']>
  billingEvent?: InputMaybe<Scalars['String']['input']>
  budgetMicros?: InputMaybe<Scalars['Float']['input']>
  countries?: InputMaybe<Array<Scalars['String']['input']>>
  customEventType?: InputMaybe<Scalars['String']['input']>
  /** Meta destination_type, for example WEBSITE or ON_AD. */
  destinationType?: InputMaybe<Scalars['String']['input']>
  externalCampaignId: Scalars['String']['input']
  name: Scalars['String']['input']
  optimizationGoal?: InputMaybe<Scalars['String']['input']>
  pixelId?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type MarketingAdGroupListResponse = {
  __typename?: 'MarketingAdGroupListResponse'
  adGroups: Array<MarketingAdGroup>
  total: Scalars['Int']['output']
}

export type MarketingAdListResponse = {
  __typename?: 'MarketingAdListResponse'
  ads: Array<MarketingAd>
  total: Scalars['Int']['output']
}

/** Ingested country/language targeting row for a campaign or ad group owner */
export type MarketingAdTargeting = {
  __typename?: 'MarketingAdTargeting'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dimension: Scalars['String']['output']
  externalAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  isNegative: Scalars['Boolean']['output']
  normalizedValue?: Maybe<Scalars['String']['output']>
  ownerExternalId: Scalars['String']['output']
  ownerId?: Maybe<Scalars['ID']['output']>
  ownerLevel: Scalars['String']['output']
  platform: Scalars['String']['output']
  providerValue: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingAdTargetingIngestTickInput = {
  /** Targeting worker name (e.g. marketing-meta-targeting-ingest) */
  workerName: Scalars['String']['input']
}

export type MarketingAdTargetingIngestTickResponse = {
  __typename?: 'MarketingAdTargetingIngestTickResponse'
  hasMore?: Maybe<Scalars['Boolean']['output']>
  rowsWritten?: Maybe<Scalars['Int']['output']>
  success: Scalars['Boolean']['output']
  workerName: Scalars['String']['output']
}

export type MarketingAdTargetingListResponse = {
  __typename?: 'MarketingAdTargetingListResponse'
  targeting: Array<MarketingAdTargeting>
  total: Scalars['Int']['output']
}

/** Provider catalog row mapping platform identifiers to ISO/BCP47 values */
export type MarketingAdTargetingReference = {
  __typename?: 'MarketingAdTargetingReference'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dimension: Scalars['String']['output']
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  normalizedValue?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  providerMetadata?: Maybe<Scalars['JSON']['output']>
  providerValue: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  targetType?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingAdTargetingReferenceListResponse = {
  __typename?: 'MarketingAdTargetingReferenceListResponse'
  references: Array<MarketingAdTargetingReference>
  total: Scalars['Int']['output']
}

export type MarketingAdUpdateUtmInput = {
  accountExternalId: Scalars['String']['input']
  adGroupName?: InputMaybe<Scalars['String']['input']>
  adName?: InputMaybe<Scalars['String']['input']>
  campaignName?: InputMaybe<Scalars['String']['input']>
  externalId: Scalars['String']['input']
  finalUrls?: InputMaybe<Array<Scalars['String']['input']>>
  platform: Scalars['String']['input']
  urlCustomParameters?: InputMaybe<Array<Scalars['JSON']['input']>>
}

export enum MarketingAgentConfirmDecision {
  No = 'NO',
  Yes = 'YES',
}

export type MarketingAgentConfirmInput = {
  decision: MarketingAgentConfirmDecision
  sessionId: Scalars['String']['input']
}

export type MarketingAgentConfirmResult = {
  __typename?: 'MarketingAgentConfirmResult'
  cleared: Scalars['Boolean']['output']
  pendingMutation?: Maybe<MarketingAgentPendingMutation>
  resultText?: Maybe<Scalars['String']['output']>
  sessionId: Scalars['String']['output']
}

export type MarketingAgentMessage = {
  __typename?: 'MarketingAgentMessage'
  role: Scalars['String']['output']
  text: Scalars['String']['output']
}

export type MarketingAgentPendingMutation = {
  __typename?: 'MarketingAgentPendingMutation'
  proposedAt: Scalars['String']['output']
  summary: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

export type MarketingAgentScoreInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  labels?: InputMaybe<Array<Scalars['String']['input']>>
  score: Scalars['String']['input']
  sessionId: Scalars['String']['input']
}

export type MarketingAgentScoreResult = {
  __typename?: 'MarketingAgentScoreResult'
  accepted: Scalars['Boolean']['output']
}

export type MarketingAgentSession = {
  __typename?: 'MarketingAgentSession'
  activePacks: Array<Scalars['String']['output']>
  lastText?: Maybe<Scalars['String']['output']>
  messages: Array<MarketingAgentMessage>
  pendingMutation?: Maybe<MarketingAgentPendingMutation>
  sessionId: Scalars['String']['output']
}

export type MarketingAgentTurnInput = {
  message: Scalars['String']['input']
  sessionId: Scalars['String']['input']
}

export type MarketingAgentTurnResult = {
  __typename?: 'MarketingAgentTurnResult'
  activePacks: Array<Scalars['String']['output']>
  pendingMutation?: Maybe<MarketingAgentPendingMutation>
  sessionId: Scalars['String']['output']
  status: Scalars['String']['output']
  text: Scalars['String']['output']
}

export enum MarketingAirCreativeListAction {
  Assets = 'ASSETS',
  Boards = 'BOARDS',
  CustomFields = 'CUSTOM_FIELDS',
  Tags = 'TAGS',
}

export type MarketingAirCreativeListInput = {
  action?: InputMaybe<MarketingAirCreativeListAction>
  cursor?: InputMaybe<Scalars['String']['input']>
  includeNestedAssets?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  parentBoardId?: InputMaybe<Scalars['String']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
}

export enum MarketingAirCreativeMutateAction {
  AddTag = 'ADD_TAG',
  AddToBoard = 'ADD_TO_BOARD',
  CreateBoard = 'CREATE_BOARD',
  CreateImport = 'CREATE_IMPORT',
  SetCustomField = 'SET_CUSTOM_FIELD',
  UpdateAsset = 'UPDATE_ASSET',
}

export type MarketingAirCreativeMutateInput = {
  action: MarketingAirCreativeMutateAction
  assetId?: InputMaybe<Scalars['String']['input']>
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>
  boardId?: InputMaybe<Scalars['String']['input']>
  customFieldId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  parentBoardId?: InputMaybe<Scalars['String']['input']>
  sourceUrl?: InputMaybe<Scalars['String']['input']>
  tagId?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
  versionId?: InputMaybe<Scalars['String']['input']>
}

export enum MarketingAirCreativePublishDestination {
  BrooklynAsset = 'BROOKLYN_ASSET',
  LandingPageCreate = 'LANDING_PAGE_CREATE',
  MessagingContent = 'MESSAGING_CONTENT',
  MetaAd = 'META_AD',
}

export type MarketingAirCreativePublishInput = {
  airAssetId: Scalars['String']['input']
  airVersionId?: InputMaybe<Scalars['String']['input']>
  destination: MarketingAirCreativePublishDestination
  destinationArgs?: InputMaybe<Scalars['JSON']['input']>
}

export type MarketingAnalyticsInput = {
  aspect?: InputMaybe<Scalars['String']['input']>
  browser?: InputMaybe<Scalars['String']['input']>
  channelGroup?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  deviceCategory?: InputMaybe<Scalars['String']['input']>
  dimension?: InputMaybe<Scalars['String']['input']>
  dimensions?: InputMaybe<Array<Scalars['String']['input']>>
  endDate?: InputMaybe<Scalars['String']['input']>
  eventName?: InputMaybe<Scalars['String']['input']>
  externalPropertyId?: InputMaybe<Scalars['String']['input']>
  landingPage?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  metrics?: InputMaybe<Array<Scalars['String']['input']>>
  offset?: InputMaybe<Scalars['Int']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  queryContains?: InputMaybe<Scalars['String']['input']>
  queryEquals?: InputMaybe<Scalars['String']['input']>
  reportKind?: InputMaybe<Scalars['String']['input']>
  reportType?: InputMaybe<Scalars['String']['input']>
  sessionCampaign?: InputMaybe<Scalars['String']['input']>
  sessionMedium?: InputMaybe<Scalars['String']['input']>
  sessionSource?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type MarketingAnalyticsReportTaskInput = {
  action: Scalars['String']['input']
  dimensions?: InputMaybe<Array<Scalars['String']['input']>>
  endDate?: InputMaybe<Scalars['String']['input']>
  eventName?: InputMaybe<Scalars['String']['input']>
  landingPage?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  metrics?: InputMaybe<Array<Scalars['String']['input']>>
  offset?: InputMaybe<Scalars['Int']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  reportType?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  taskName?: InputMaybe<Scalars['String']['input']>
}

export type MarketingAnalyticsReportTaskResult = {
  __typename?: 'MarketingAnalyticsReportTaskResult'
  action?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  error?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  hasMore?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  reportType?: Maybe<Scalars['String']['output']>
  rowCount?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Scalars['JSON']['output']>>
  source?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  taskName?: Maybe<Scalars['String']['output']>
}

export type MarketingAnalyticsResult = {
  __typename?: 'MarketingAnalyticsResult'
  aspect?: Maybe<Scalars['String']['output']>
  error?: Maybe<Scalars['String']['output']>
  expectedThroughDate?: Maybe<Scalars['String']['output']>
  hasMore?: Maybe<Scalars['Boolean']['output']>
  isBehindExpected?: Maybe<Scalars['Boolean']['output']>
  lagDaysBehindExpected?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextOffset?: Maybe<Scalars['Int']['output']>
  note?: Maybe<Scalars['String']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  periodEnd?: Maybe<Scalars['String']['output']>
  periodStart?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  reportKind?: Maybe<Scalars['String']['output']>
  reportType?: Maybe<Scalars['String']['output']>
  rowCount?: Maybe<Scalars['Int']['output']>
  rows: Array<Scalars['JSON']['output']>
  source?: Maybe<Scalars['String']['output']>
  table?: Maybe<Scalars['String']['output']>
  total?: Maybe<Scalars['Int']['output']>
  warehouseMaxMetricDate?: Maybe<Scalars['String']['output']>
}

export type MarketingAnalyticsThresholdInput = {
  browser?: InputMaybe<Scalars['String']['input']>
  channelGroup?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  deviceCategory?: InputMaybe<Scalars['String']['input']>
  dimensions?: InputMaybe<Array<Scalars['String']['input']>>
  endDate?: InputMaybe<Scalars['String']['input']>
  eventName?: InputMaybe<Scalars['String']['input']>
  externalPropertyId?: InputMaybe<Scalars['String']['input']>
  landingPage?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  metric: Scalars['String']['input']
  metrics?: InputMaybe<Array<Scalars['String']['input']>>
  operator: Scalars['String']['input']
  propertyId?: InputMaybe<Scalars['String']['input']>
  reportType?: InputMaybe<Scalars['String']['input']>
  sessionCampaign?: InputMaybe<Scalars['String']['input']>
  sessionMedium?: InputMaybe<Scalars['String']['input']>
  sessionSource?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  threshold: Scalars['Float']['input']
}

export type MarketingAnalyticsThresholdResult = {
  __typename?: 'MarketingAnalyticsThresholdResult'
  actual?: Maybe<Scalars['Float']['output']>
  error?: Maybe<Scalars['String']['output']>
  metric?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  operator?: Maybe<Scalars['String']['output']>
  periodEnd?: Maybe<Scalars['String']['output']>
  periodStart?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  reportType?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  threshold?: Maybe<Scalars['Float']['output']>
  triggered?: Maybe<Scalars['Boolean']['output']>
}

/** Marketing campaign (ingested from external APIs) */
export type MarketingCampaign = {
  __typename?: 'MarketingCampaign'
  accountId?: Maybe<Scalars['ID']['output']>
  adGroups: Array<MarketingAdGroup>
  channelType?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  externalAccountId: Scalars['String']['output']
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  startDate?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  targeting: Array<MarketingAdTargeting>
  targetingSyncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Marketing campaign (ingested from external APIs) */
export type MarketingCampaignAdGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Marketing campaign (ingested from external APIs) */
export type MarketingCampaignTargetingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type MarketingCampaignAsset = {
  __typename?: 'MarketingCampaignAsset'
  assetId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  marketingCampaignId: Scalars['ID']['output']
  role: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingCampaignAssetCreateInput = {
  assetId: Scalars['Int']['input']
  marketingCampaignId: Scalars['ID']['input']
  role?: InputMaybe<Scalars['String']['input']>
}

export type MarketingCampaignAssetCreateResponse = {
  __typename?: 'MarketingCampaignAssetCreateResponse'
  campaignAsset: MarketingCampaignAsset
  created: Scalars['Boolean']['output']
  success: Scalars['Boolean']['output']
}

export type MarketingCampaignAssetListResponse = {
  __typename?: 'MarketingCampaignAssetListResponse'
  campaignAssets: Array<MarketingCampaignAsset>
  total: Scalars['Int']['output']
}

export type MarketingCampaignCreateInput = {
  accountExternalId: Scalars['String']['input']
  budgetMicros?: InputMaybe<Scalars['Float']['input']>
  channelType?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  objective?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type MarketingCampaignListResponse = {
  __typename?: 'MarketingCampaignListResponse'
  campaigns: Array<MarketingCampaign>
  total: Scalars['Int']['output']
}

export type MarketingCampaignPerformance = {
  __typename?: 'MarketingCampaignPerformance'
  adGroupName?: Maybe<Scalars['String']['output']>
  campaignId: Scalars['ID']['output']
  campaignName?: Maybe<Scalars['String']['output']>
  clicks: Scalars['String']['output']
  conversions: Scalars['Float']['output']
  impressions: Scalars['String']['output']
  level?: Maybe<Scalars['String']['output']>
  metricDate: Scalars['String']['output']
  spendMicros: Scalars['String']['output']
}

export type MarketingCampaignPerformanceInput = {
  aspect?: InputMaybe<Scalars['String']['input']>
  campaignId?: InputMaybe<Scalars['ID']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nameContains?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  parentNameContains?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  reportKind?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type MarketingCampaignPerformanceResponse = {
  __typename?: 'MarketingCampaignPerformanceResponse'
  aspect?: Maybe<Scalars['String']['output']>
  page: MarketingPage
  reportKind?: Maybe<Scalars['String']['output']>
  rows: Array<MarketingCampaignPerformance>
  total: Scalars['Int']['output']
  totals: MarketingCampaignPerformanceTotals
  totalsByCampaign: Array<MarketingCampaignPerformanceTotals>
  totalsByPlatform: Array<MarketingCampaignPerformanceTotals>
}

export type MarketingCampaignPerformanceTotals = {
  __typename?: 'MarketingCampaignPerformanceTotals'
  adGroupName?: Maybe<Scalars['String']['output']>
  campaignId?: Maybe<Scalars['ID']['output']>
  campaignName?: Maybe<Scalars['String']['output']>
  clicks: Scalars['String']['output']
  conversions: Scalars['Float']['output']
  cpaUsd?: Maybe<Scalars['Float']['output']>
  cpcUsd?: Maybe<Scalars['Float']['output']>
  cpmUsd?: Maybe<Scalars['Float']['output']>
  dayCount?: Maybe<Scalars['Int']['output']>
  impressions: Scalars['String']['output']
  level?: Maybe<Scalars['String']['output']>
  platform?: Maybe<Scalars['String']['output']>
  spendMicros: Scalars['String']['output']
  spendUsd: Scalars['Float']['output']
  weeklyRunRateUsd?: Maybe<Scalars['Float']['output']>
}

export type MarketingCampaignSearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  query: Scalars['String']['input']
}

export type MarketingCampaignSearchResponse = {
  __typename?: 'MarketingCampaignSearchResponse'
  page: MarketingPage
  rows: Array<MarketingCampaign>
  total: Scalars['Int']['output']
}

export type MarketingCampaignUpdateInput = {
  accountExternalId?: InputMaybe<Scalars['String']['input']>
  bidStrategy?: InputMaybe<Scalars['String']['input']>
  budgetMicros?: InputMaybe<Scalars['Float']['input']>
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId?: InputMaybe<Scalars['String']['input']>
  externalId: Scalars['String']['input']
  field: Scalars['String']['input']
  level: Scalars['String']['input']
  maxCpcBidCeilingMicros?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
  targetCpaMicros?: InputMaybe<Scalars['Float']['input']>
}

export type MarketingConversionOperatorScripts = {
  __typename?: 'MarketingConversionOperatorScripts'
  flagLadderCheck: Scalars['String']['output']
  mpPing: Scalars['String']['output']
  nrHealthCheck: Scalars['String']['output']
}

export type MarketingConversionPipelineFlags = {
  __typename?: 'MarketingConversionPipelineFlags'
  ga4HealthCheckEnabled: Scalars['Boolean']['output']
  ga4MeasurementProtocol: Scalars['Boolean']['output']
  persistConversions: Scalars['Boolean']['output']
}

export type MarketingConversionPipelineHealth = {
  __typename?: 'MarketingConversionPipelineHealth'
  flags: MarketingConversionPipelineFlags
  ga4MeasurementProtocol: MarketingGa4MeasurementProtocol
  mpConnectivity?: Maybe<MarketingMpConnectivity>
  note: Scalars['String']['output']
  nrEventsToWatch: Array<Scalars['String']['output']>
  operatorScripts: MarketingConversionOperatorScripts
  resources: Array<Scalars['String']['output']>
}

export type MarketingConversionValueInput = {
  billingAmount?: InputMaybe<Scalars['Float']['input']>
  costs?: InputMaybe<Array<Scalars['Float']['input']>>
  gaiaProductSku?: InputMaybe<Scalars['String']['input']>
  isTrial?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  subscriptionTier?: InputMaybe<Scalars['String']['input']>
  trialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MarketingConversionValueInputs = {
  __typename?: 'MarketingConversionValueInputs'
  billingAmount?: Maybe<Scalars['Float']['output']>
  costs?: Maybe<Array<Scalars['Float']['output']>>
  gaiaProductSku?: Maybe<Scalars['String']['output']>
  isTrial?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Float']['output']>
  subscriptionTier?: Maybe<Scalars['String']['output']>
  trialPeriod?: Maybe<Scalars['Boolean']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type MarketingConversionValueResult = {
  __typename?: 'MarketingConversionValueResult'
  inputs: MarketingConversionValueInputs
  marketingValueUsd?: Maybe<Scalars['Float']['output']>
  note: Scalars['String']['output']
}

/**
 * Marketing creative generation job (image, video, or ad copy).
 * Generated media and copy live on `assetId` — this type never carries bytes.
 */
export type MarketingCreativeGenerationJob = {
  __typename?: 'MarketingCreativeGenerationJob'
  assetId?: Maybe<Scalars['Int']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  error?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  marketingCampaignId?: Maybe<Scalars['ID']['output']>
  modality: Scalars['String']['output']
  model?: Maybe<Scalars['String']['output']>
  progressMessage?: Maybe<Scalars['String']['output']>
  progressPercent?: Maybe<Scalars['Int']['output']>
  progressStage?: Maybe<Scalars['String']['output']>
  prompt: Scalars['String']['output']
  provider: Scalars['String']['output']
  providerOperationName?: Maybe<Scalars['String']['output']>
  requestJson?: Maybe<Scalars['JSON']['output']>
  resultJson?: Maybe<Scalars['JSON']['output']>
  sessionId?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  userId?: Maybe<Scalars['ID']['output']>
}

export type MarketingCreativeGenerationJobDeleteInput = {
  id: Scalars['ID']['input']
}

export type MarketingCreativeGenerationJobListResponse = {
  __typename?: 'MarketingCreativeGenerationJobListResponse'
  jobs: Array<MarketingCreativeGenerationJob>
  total: Scalars['Int']['output']
}

export enum MarketingCreativeGenerationJobModality {
  Copy = 'copy',
  Image = 'image',
  Video = 'video',
}

export type MarketingCreativeGenerationJobStartInput = {
  marketingCampaignId?: InputMaybe<Scalars['ID']['input']>
  modality: MarketingCreativeGenerationJobModality
  model?: InputMaybe<Scalars['String']['input']>
  /** Persist generated output as a public Gaia asset when the queued job completes. */
  persistAsset?: InputMaybe<Scalars['Boolean']['input']>
  prompt: Scalars['String']['input']
  requestJson?: InputMaybe<Scalars['JSON']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type MarketingCreativeMediaSourceInput = {
  airAssetId?: InputMaybe<Scalars['String']['input']>
  assetId?: InputMaybe<Scalars['Int']['input']>
  fileId?: InputMaybe<Scalars['String']['input']>
  jobId?: InputMaybe<Scalars['String']['input']>
  kind: MarketingCreativeMediaSourceKind
  s3Key?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  versionId?: InputMaybe<Scalars['String']['input']>
}

export enum MarketingCreativeMediaSourceKind {
  AgentTmp = 'AGENT_TMP',
  Air = 'AIR',
  CreativeJob = 'CREATIVE_JOB',
  ExternalUrl = 'EXTERNAL_URL',
  GaiaAsset = 'GAIA_ASSET',
  SlackFile = 'SLACK_FILE',
}

export type MarketingCreativeVendorError = {
  __typename?: 'MarketingCreativeVendorError'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type MarketingCreativeVendorResponse = {
  __typename?: 'MarketingCreativeVendorResponse'
  errors: Array<MarketingCreativeVendorError>
  result?: Maybe<Scalars['JSON']['output']>
  status: Scalars['String']['output']
}

export type MarketingGa4MeasurementProtocol = {
  __typename?: 'MarketingGa4MeasurementProtocol'
  enableMeasurementProtocol: Scalars['Boolean']['output']
  hasApiSecret: Scalars['Boolean']['output']
  healthCheckEnabled: Scalars['Boolean']['output']
  measurementId?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
}

/** Reset marketing ingest worker phase cursors (SITE_ADMIN) */
export type MarketingIngestionPhaseResetInput = {
  /** ISO date YYYY-MM-DD for metrics phases; required when phaseName ends with _metrics */
  cursorDate?: InputMaybe<Scalars['String']['input']>
  /** Optional phase name to reset; omit to reset all phases */
  phaseName?: InputMaybe<Scalars['String']['input']>
  /** Worker name (e.g. marketing-meta-ingest) */
  workerName: Scalars['String']['input']
}

export type MarketingIngestionPhaseResetResponse = {
  __typename?: 'MarketingIngestionPhaseResetResponse'
  success: Scalars['Boolean']['output']
  workerName: Scalars['String']['output']
}

export type MarketingKeyword = {
  __typename?: 'MarketingKeyword'
  adGroupId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalAccountId: Scalars['String']['output']
  externalCampaignId: Scalars['String']['output']
  externalGroupId: Scalars['String']['output']
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  keywordText?: Maybe<Scalars['String']['output']>
  matchType?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingKeywordCreateInput = {
  accountExternalId: Scalars['String']['input']
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId: Scalars['String']['input']
  keywords: Array<MarketingKeywordCreateRowInput>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type MarketingKeywordCreateRowInput = {
  matchType: MarketingKeywordMatchType
  text: Scalars['String']['input']
}

export type MarketingKeywordListInput = {
  accountExternalId: Scalars['String']['input']
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  matchType?: InputMaybe<MarketingKeywordMatchType>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform: Scalars['String']['input']
  source?: InputMaybe<MarketingKeywordSource>
  status?: InputMaybe<Scalars['String']['input']>
  textContains?: InputMaybe<Scalars['String']['input']>
}

export type MarketingKeywordListResponse = {
  __typename?: 'MarketingKeywordListResponse'
  /** Legacy field kept for existing warehouse list clients; always the same rows as `rows`. */
  keywords: Array<MarketingKeyword>
  page?: Maybe<MarketingPage>
  rows: Array<MarketingKeyword>
  source?: Maybe<Scalars['String']['output']>
  total: Scalars['Int']['output']
}

export enum MarketingKeywordMatchType {
  Broad = 'BROAD',
  Exact = 'EXACT',
  Phrase = 'PHRASE',
}

export enum MarketingKeywordSource {
  Api = 'API',
  Warehouse = 'WAREHOUSE',
}

export enum MarketingKeywordUpdateField {
  MatchType = 'MATCH_TYPE',
  Status = 'STATUS',
}

export type MarketingKeywordUpdateInput = {
  accountExternalId: Scalars['String']['input']
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId: Scalars['String']['input']
  externalId: Scalars['String']['input']
  field: MarketingKeywordUpdateField
  matchType?: InputMaybe<MarketingKeywordMatchType>
  platform: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export enum MarketingLandingPageGetAction {
  DesignPack = 'DESIGN_PACK',
  List = 'LIST',
  Page = 'PAGE',
}

export type MarketingLandingPageGetInput = {
  action: MarketingLandingPageGetAction
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  postId?: InputMaybe<Scalars['Int']['input']>
  postType?: InputMaybe<Scalars['String']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export enum MarketingLandingPageMutateAction {
  Create = 'CREATE',
  Preview = 'PREVIEW',
  Publish = 'PUBLISH',
  Trash = 'TRASH',
  Update = 'UPDATE',
}

export type MarketingLandingPageMutateInput = {
  action: MarketingLandingPageMutateAction
  payload?: InputMaybe<Scalars['JSON']['input']>
  postId?: InputMaybe<Scalars['Int']['input']>
  postType?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MarketingMemberDaySnapshot = {
  __typename?: 'MarketingMemberDaySnapshot'
  activeMemberCount: Scalars['String']['output']
  approxTrialMemberCount: Scalars['String']['output']
  byLanguage?: Maybe<Scalars['JSON']['output']>
  computedAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  snapshotDate: Scalars['String']['output']
  snapshotSource: Scalars['String']['output']
  trialByLanguage?: Maybe<Scalars['JSON']['output']>
  trialMemberCount: Scalars['String']['output']
}

export type MarketingMemberDaySnapshotListInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type MarketingMemberDaySnapshotListResult = {
  __typename?: 'MarketingMemberDaySnapshotListResult'
  hasMore: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  nextOffset?: Maybe<Scalars['Int']['output']>
  offset: Scalars['Int']['output']
  rows: Array<MarketingMemberDaySnapshot>
  total: Scalars['Int']['output']
}

export type MarketingMemberPaymentProfileResult = {
  __typename?: 'MarketingMemberPaymentProfileResult'
  error?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  profile?: Maybe<Scalars['JSON']['output']>
  uid: Scalars['Int']['output']
}

export type MarketingMessagingAccount = {
  __typename?: 'MarketingMessagingAccount'
  configLabel?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalWorkspaceId: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  source: Scalars['String']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingMessagingAccountListResponse = {
  __typename?: 'MarketingMessagingAccountListResponse'
  marketingMessagingAccounts: Array<MarketingMessagingAccount>
  total: Scalars['Int']['output']
}

export type MarketingMessagingCampaign = {
  __typename?: 'MarketingMessagingCampaign'
  archived?: Maybe<Scalars['Boolean']['output']>
  channels?: Maybe<Scalars['JSON']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  draft?: Maybe<Scalars['Boolean']['output']>
  enabled?: Maybe<Scalars['Boolean']['output']>
  externalCampaignId: Scalars['String']['output']
  externalWorkspaceId: Scalars['String']['output']
  firstSent?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isApiCampaign?: Maybe<Scalars['Boolean']['output']>
  lastEdited?: Maybe<Scalars['DateTime']['output']>
  lastSent?: Maybe<Scalars['DateTime']['output']>
  name?: Maybe<Scalars['String']['output']>
  scheduleType?: Maybe<Scalars['String']['output']>
  source: Scalars['String']['output']
  sourceCreatedAt?: Maybe<Scalars['DateTime']['output']>
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  tags?: Maybe<Scalars['JSON']['output']>
  teams?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workspaceId?: Maybe<Scalars['ID']['output']>
}

/** Daily owned-channel campaign engagement metrics. Attributed fields are reconciliation-only. */
export type MarketingMessagingCampaignEngagementDay = {
  __typename?: 'MarketingMessagingCampaignEngagementDay'
  /** Vendor-attributed conversions (reconciliation only; Zuora is source of truth). */
  attributedConversions: Scalars['Float']['output']
  attributedConversionsBySendTime: Scalars['Float']['output']
  attributedRevenue: Scalars['Float']['output']
  bounces: Scalars['Float']['output']
  campaignId?: Maybe<Scalars['ID']['output']>
  channel: Scalars['String']['output']
  clickRate?: Maybe<Scalars['Float']['output']>
  clickToOpenRate?: Maybe<Scalars['Float']['output']>
  clicks: Scalars['Float']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  deliveries: Scalars['Float']['output']
  entries: Scalars['Float']['output']
  externalCampaignId: Scalars['String']['output']
  externalWorkspaceId: Scalars['String']['output']
  id: Scalars['ID']['output']
  metricDate: Scalars['String']['output']
  metricsPayload?: Maybe<Scalars['JSON']['output']>
  openRate?: Maybe<Scalars['Float']['output']>
  opens: Scalars['Float']['output']
  sends: Scalars['Float']['output']
  source: Scalars['String']['output']
  spamReports: Scalars['Float']['output']
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  uniqueClicks: Scalars['Float']['output']
  uniqueOpens: Scalars['Float']['output']
  uniqueRecipients: Scalars['Float']['output']
  unsubscribes: Scalars['Float']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type MarketingMessagingCampaignEngagementDayListResponse = {
  __typename?: 'MarketingMessagingCampaignEngagementDayListResponse'
  marketingMessagingCampaignEngagementDays: Array<MarketingMessagingCampaignEngagementDay>
  total: Scalars['Int']['output']
}

export type MarketingMessagingCampaignGetResponse = {
  __typename?: 'MarketingMessagingCampaignGetResponse'
  campaign?: Maybe<MarketingMessagingLiveCampaign>
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  platform: Scalars['String']['output']
  source: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type MarketingMessagingCampaignListResponse = {
  __typename?: 'MarketingMessagingCampaignListResponse'
  campaigns?: Maybe<Array<MarketingMessagingLiveCampaign>>
  channel?: Maybe<Scalars['String']['output']>
  hasMore?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  marketingMessagingCampaigns: Array<MarketingMessagingCampaign>
  offset?: Maybe<Scalars['Int']['output']>
  platform?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  total: Scalars['Int']['output']
}

export type MarketingMessagingCampaignPerformanceListResponse = {
  __typename?: 'MarketingMessagingCampaignPerformanceListResponse'
  aspect?: Maybe<Scalars['String']['output']>
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  expectedThroughDate?: Maybe<Scalars['String']['output']>
  isBehindExpected?: Maybe<Scalars['Boolean']['output']>
  lagDaysBehindExpected?: Maybe<Scalars['Int']['output']>
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  platform: Scalars['String']['output']
  reportKind?: Maybe<Scalars['String']['output']>
  rows: Array<MarketingMessagingCampaignPerformanceRow>
  source: Scalars['String']['output']
  status: Scalars['String']['output']
  total: Scalars['Int']['output']
  warehouseMaxMetricDate?: Maybe<Scalars['String']['output']>
}

export type MarketingMessagingCampaignPerformanceRow = {
  __typename?: 'MarketingMessagingCampaignPerformanceRow'
  campaignName?: Maybe<Scalars['String']['output']>
  channel: Scalars['String']['output']
  clickRate?: Maybe<Scalars['Float']['output']>
  deliveries: Scalars['Float']['output']
  entityType: Scalars['String']['output']
  externalCampaignId?: Maybe<Scalars['String']['output']>
  externalCanvasId?: Maybe<Scalars['String']['output']>
  metricDate: Scalars['String']['output']
  sends: Scalars['Float']['output']
  source: Scalars['String']['output']
  tags?: Maybe<Scalars['JSON']['output']>
  uniqueClicks: Scalars['Float']['output']
  uniqueOpens: Scalars['Float']['output']
}

export type MarketingMessagingCampaignUpsertInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  channel: Scalars['String']['input']
  emailId?: InputMaybe<Scalars['String']['input']>
  fromEmail?: InputMaybe<Scalars['String']['input']>
  fromName?: InputMaybe<Scalars['String']['input']>
  htmlSource?: InputMaybe<Scalars['String']['input']>
  mode: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
  textSource?: InputMaybe<Scalars['String']['input']>
}

export type MarketingMessagingContentUpsertInput = {
  channel: Scalars['String']['input']
  content?: InputMaybe<Scalars['String']['input']>
  contentBlockId?: InputMaybe<Scalars['String']['input']>
  emailId?: InputMaybe<Scalars['String']['input']>
  htmlSource?: InputMaybe<Scalars['String']['input']>
  kind: Scalars['String']['input']
  mode?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  sectionId?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  textSource?: InputMaybe<Scalars['String']['input']>
}

export type MarketingMessagingContentUpsertResponse = {
  __typename?: 'MarketingMessagingContentUpsertResponse'
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  externalId?: Maybe<Scalars['String']['output']>
  kind: Scalars['String']['output']
  platform: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type MarketingMessagingError = {
  __typename?: 'MarketingMessagingError'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type MarketingMessagingLiveCampaign = {
  __typename?: 'MarketingMessagingLiveCampaign'
  channels?: Maybe<Scalars['JSON']['output']>
  externalId: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  raw?: Maybe<Scalars['JSON']['output']>
}

export type MarketingMessagingLiveTemplate = {
  __typename?: 'MarketingMessagingLiveTemplate'
  externalId: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  raw?: Maybe<Scalars['JSON']['output']>
}

export type MarketingMessagingTemplateGetResponse = {
  __typename?: 'MarketingMessagingTemplateGetResponse'
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  platform: Scalars['String']['output']
  source: Scalars['String']['output']
  status: Scalars['String']['output']
  template?: Maybe<MarketingMessagingLiveTemplate>
}

export type MarketingMessagingTemplateListResponse = {
  __typename?: 'MarketingMessagingTemplateListResponse'
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  hasMore: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  platform: Scalars['String']['output']
  source: Scalars['String']['output']
  status: Scalars['String']['output']
  templates: Array<MarketingMessagingLiveTemplate>
  total: Scalars['Int']['output']
}

export type MarketingMessagingTemplateUpsertInput = {
  body?: InputMaybe<Scalars['String']['input']>
  channel: Scalars['String']['input']
  emailTemplateId?: InputMaybe<Scalars['String']['input']>
  mode: Scalars['String']['input']
  platform: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
  templateName?: InputMaybe<Scalars['String']['input']>
}

export type MarketingMessagingTriggerSendInput = {
  campaignId: Scalars['String']['input']
  channel: Scalars['String']['input']
  platform: Scalars['String']['input']
  uids: Array<Scalars['Int']['input']>
}

export type MarketingMessagingTriggerSendResponse = {
  __typename?: 'MarketingMessagingTriggerSendResponse'
  campaignId: Scalars['String']['output']
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  platform: Scalars['String']['output']
  recipientCount: Scalars['Int']['output']
  sentRecipientCount: Scalars['Int']['output']
  status: Scalars['String']['output']
}

export type MarketingMessagingUpsertResponse = {
  __typename?: 'MarketingMessagingUpsertResponse'
  channel: Scalars['String']['output']
  errors: Array<MarketingMessagingError>
  externalId?: Maybe<Scalars['String']['output']>
  platform: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type MarketingMetricDay = {
  __typename?: 'MarketingMetricDay'
  campaign?: Maybe<MarketingCampaign>
  clicks: Scalars['String']['output']
  conversions: Scalars['Float']['output']
  conversionsValue: Scalars['Float']['output']
  costMicros: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  impressions: Scalars['String']['output']
  level: Scalars['String']['output']
  metricDate: Scalars['String']['output']
  platform: Scalars['String']['output']
  resourceExternalId: Scalars['String']['output']
  resourceId?: Maybe<Scalars['ID']['output']>
  syncedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingMetricDayListResponse = {
  __typename?: 'MarketingMetricDayListResponse'
  metricDays: Array<MarketingMetricDay>
  total: Scalars['Int']['output']
}

export type MarketingMpConnectivity = {
  __typename?: 'MarketingMpConnectivity'
  httpStatus?: Maybe<Scalars['Int']['output']>
  ok?: Maybe<Scalars['Boolean']['output']>
  skipReason?: Maybe<Scalars['String']['output']>
  validationMessages?: Maybe<Array<Scalars['String']['output']>>
}

/** Operator recommendation decision stored in the Performance Hub. */
export type MarketingOperatorRecommendation = {
  __typename?: 'MarketingOperatorRecommendation'
  chartKey: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByUid?: Maybe<Scalars['Int']['output']>
  dashboardKey: Scalars['String']['output']
  id: Scalars['ID']['output']
  metricDate: Scalars['String']['output']
  noteText: Scalars['String']['output']
  recordType: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  updatedByUid?: Maybe<Scalars['Int']['output']>
}

export type MarketingOperatorRecommendationListResponse = {
  __typename?: 'MarketingOperatorRecommendationListResponse'
  count: Scalars['Int']['output']
  limit?: Maybe<Scalars['Int']['output']>
  offset: Scalars['Int']['output']
  recommendations: Array<MarketingOperatorRecommendation>
}

export type MarketingPage = {
  __typename?: 'MarketingPage'
  hasMore: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

export type MarketingPaidMutationResponse = {
  __typename?: 'MarketingPaidMutationResponse'
  error?: Maybe<Scalars['String']['output']>
  partialResult?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Scalars['JSON']['output']>
  success: Scalars['Boolean']['output']
}

export type MarketingPaidStructureListInput = {
  accountExternalId?: InputMaybe<Scalars['String']['input']>
  externalCampaignId?: InputMaybe<Scalars['String']['input']>
  externalGroupId?: InputMaybe<Scalars['String']['input']>
  externalId?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nameContains?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<MarketingPaidStructureSource>
}

export enum MarketingPaidStructureSource {
  Api = 'API',
  Warehouse = 'WAREHOUSE',
}

export type MarketingPulse = {
  __typename?: 'MarketingPulse'
  asOfDate: Scalars['String']['output']
  email: MarketingPulseEmail
  executive: MarketingPulseExecutive
  ingestHealth: MarketingPulseIngestHealth
  organic: MarketingPulseOrganic
  paid: MarketingPulsePaid
  timezone: Scalars['String']['output']
  trustNotes: Array<Scalars['String']['output']>
  window: MarketingPulseWindow
}

export type MarketingPulseEmail = {
  __typename?: 'MarketingPulseEmail'
  sends: Scalars['Float']['output']
  uniqueClicks: Scalars['Float']['output']
}

export type MarketingPulseExecutive = {
  __typename?: 'MarketingPulseExecutive'
  cpaDeltaPct?: Maybe<Scalars['Float']['output']>
  cpaUsd?: Maybe<Scalars['Float']['output']>
  directPaidSignups?: Maybe<Scalars['Float']['output']>
  metricDate?: Maybe<Scalars['String']['output']>
  totalSignups?: Maybe<Scalars['Float']['output']>
  totalSignupsDelta?: Maybe<Scalars['Float']['output']>
}

export type MarketingPulseFreshness = {
  __typename?: 'MarketingPulseFreshness'
  expectedThroughDate?: Maybe<Scalars['String']['output']>
  isBehindExpected: Scalars['Boolean']['output']
  lagDaysBehindExpected?: Maybe<Scalars['Int']['output']>
  warehouseMaxMetricDate?: Maybe<Scalars['String']['output']>
}

export type MarketingPulseIngestHealth = {
  __typename?: 'MarketingPulseIngestHealth'
  brazePhase?: Maybe<Scalars['String']['output']>
  brazeWorkerUpdatedAt?: Maybe<Scalars['String']['output']>
  paidWarehouseLagDays?: Maybe<Scalars['Int']['output']>
}

export type MarketingPulseOrganic = {
  __typename?: 'MarketingPulseOrganic'
  sessions?: Maybe<Scalars['Float']['output']>
}

export type MarketingPulsePaid = {
  __typename?: 'MarketingPulsePaid'
  byPlatform: Array<MarketingPulsePlatformSpend>
  clicks: Scalars['Float']['output']
  conversions: Scalars['Float']['output']
  freshness: MarketingPulseFreshness
  impressions: Scalars['Float']['output']
  spendMicros: Scalars['Float']['output']
  spendUsd: Scalars['Float']['output']
  weeklyRunRateUsd?: Maybe<Scalars['Float']['output']>
}

export type MarketingPulsePlatformSpend = {
  __typename?: 'MarketingPulsePlatformSpend'
  platform: Scalars['String']['output']
  spendMicros: Scalars['Float']['output']
  spendUsd: Scalars['Float']['output']
}

export type MarketingPulseWindow = {
  __typename?: 'MarketingPulseWindow'
  dayCount: Scalars['Int']['output']
  endDate: Scalars['String']['output']
  startDate: Scalars['String']['output']
}

export type MarketingReport = {
  __typename?: 'MarketingReport'
  comparisonWindowEnd?: Maybe<Scalars['DateTime']['output']>
  comparisonWindowStart?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  currency: Scalars['String']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: MarketingReportKind
  payloadJson?: Maybe<Scalars['JSON']['output']>
  reportDate: Scalars['DateTime']['output']
  s3Key?: Maybe<Scalars['String']['output']>
  slackChannelId?: Maybe<Scalars['String']['output']>
  slackParentTs?: Maybe<Scalars['String']['output']>
  slackPostedAt?: Maybe<Scalars['DateTime']['output']>
  slackThreadTs?: Maybe<Scalars['String']['output']>
  status: MarketingReportStatus
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  windowEnd?: Maybe<Scalars['DateTime']['output']>
  windowStart?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingReportCancelInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  kinds?: InputMaybe<Array<MarketingReportKind>>
  reportDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type MarketingReportCreateInput = {
  archiveToS3?: InputMaybe<Scalars['Boolean']['input']>
  comparisonWindowEnd?: InputMaybe<Scalars['DateTime']['input']>
  comparisonWindowStart?: InputMaybe<Scalars['DateTime']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  kind: MarketingReportKind
  payloadJson?: InputMaybe<Scalars['JSON']['input']>
  reportDate: Scalars['DateTime']['input']
  slackChannelId?: InputMaybe<Scalars['String']['input']>
  slackParentTs?: InputMaybe<Scalars['String']['input']>
  slackThreadTs?: InputMaybe<Scalars['String']['input']>
  status: MarketingReportStatus
  windowEnd?: InputMaybe<Scalars['DateTime']['input']>
  windowStart?: InputMaybe<Scalars['DateTime']['input']>
}

export type MarketingReportDeleteInput = {
  id: Scalars['ID']['input']
}

export type MarketingReportExclusion = {
  __typename?: 'MarketingReportExclusion'
  action: MarketingReportExclusionAction
  aspect: MarketingReportExclusionAspect
  campaignExternalId?: Maybe<Scalars['String']['output']>
  campaignName?: Maybe<Scalars['String']['output']>
  channel?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  landingPage?: Maybe<Scalars['String']['output']>
  messagingSource?: Maybe<Scalars['String']['output']>
  nameContains?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  platform?: Maybe<Scalars['String']['output']>
  reportKind: MarketingReportExclusionReportKind
  sessionCampaign?: Maybe<Scalars['String']['output']>
  sessionDefaultChannelGroup?: Maybe<Scalars['String']['output']>
  sessionMedium?: Maybe<Scalars['String']['output']>
  sessionSource?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Scalars['String']['output']>
  targetKind: MarketingReportExclusionTargetKind
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Marketing report include/exclude rule for Slack reporting and warehouse tools. */
export enum MarketingReportExclusionAction {
  Exclude = 'exclude',
  Include = 'include',
}

export enum MarketingReportExclusionAspect {
  MemberReengagement = 'member_reengagement',
  Overall = 'overall',
  ProspectAcquisition = 'prospect_acquisition',
}

export type MarketingReportExclusionCreateInput = {
  action: MarketingReportExclusionAction
  aspect: MarketingReportExclusionAspect
  campaignExternalId?: InputMaybe<Scalars['String']['input']>
  campaignName?: InputMaybe<Scalars['String']['input']>
  channel?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  landingPage?: InputMaybe<Scalars['String']['input']>
  messagingSource?: InputMaybe<Scalars['String']['input']>
  nameContains?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  reportKind: MarketingReportExclusionReportKind
  sessionCampaign?: InputMaybe<Scalars['String']['input']>
  sessionDefaultChannelGroup?: InputMaybe<Scalars['String']['input']>
  sessionMedium?: InputMaybe<Scalars['String']['input']>
  sessionSource?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  targetKind: MarketingReportExclusionTargetKind
}

export type MarketingReportExclusionDeleteInput = {
  id: Scalars['ID']['input']
}

export type MarketingReportExclusionListResponse = {
  __typename?: 'MarketingReportExclusionListResponse'
  count: Scalars['Int']['output']
  exclusions: Array<MarketingReportExclusion>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
}

export enum MarketingReportExclusionReportKind {
  DailyDigest = 'daily_digest',
  Email = 'email',
  Organic = 'organic',
  Paid = 'paid',
}

export enum MarketingReportExclusionTargetKind {
  AdCampaign = 'ad_campaign',
  Messaging = 'messaging',
  OrganicLandingPage = 'organic_landing_page',
  OrganicTraffic = 'organic_traffic',
}

export type MarketingReportExclusionUpdateInput = {
  action?: InputMaybe<MarketingReportExclusionAction>
  aspect?: InputMaybe<MarketingReportExclusionAspect>
  campaignExternalId?: InputMaybe<Scalars['String']['input']>
  campaignName?: InputMaybe<Scalars['String']['input']>
  channel?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  landingPage?: InputMaybe<Scalars['String']['input']>
  messagingSource?: InputMaybe<Scalars['String']['input']>
  nameContains?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  reportKind?: InputMaybe<MarketingReportExclusionReportKind>
  sessionCampaign?: InputMaybe<Scalars['String']['input']>
  sessionDefaultChannelGroup?: InputMaybe<Scalars['String']['input']>
  sessionMedium?: InputMaybe<Scalars['String']['input']>
  sessionSource?: InputMaybe<Scalars['String']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
  targetKind?: InputMaybe<MarketingReportExclusionTargetKind>
}

export type MarketingReportExplanation = {
  __typename?: 'MarketingReportExplanation'
  howItWorks: Scalars['String']['output']
  latestDigest?: Maybe<MarketingReportStatusSummary>
  methodology: Scalars['String']['output']
}

/**
 * Marketing report row (daily digest or section: organic, paid, email).
 * Money in payloadJson uses integer micros (1e6 = 1 USD), never float dollars.
 * Report dates are Denver-calendar midnight instants (DateTime).
 */
export enum MarketingReportKind {
  DailyDigest = 'daily_digest',
  Email = 'email',
  Organic = 'organic',
  Paid = 'paid',
}

export type MarketingReportListResponse = {
  __typename?: 'MarketingReportListResponse'
  count: Scalars['Int']['output']
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  reports: Array<MarketingReport>
}

export type MarketingReportRunInput = {
  kinds: Array<MarketingReportKind>
  mode?: InputMaybe<Scalars['String']['input']>
  reportDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type MarketingReportRunResponse = {
  __typename?: 'MarketingReportRunResponse'
  note: Scalars['String']['output']
  reports: Array<MarketingReport>
}

export enum MarketingReportStatus {
  Canceled = 'canceled',
  Complete = 'complete',
  Degraded = 'degraded',
  Failed = 'failed',
  Running = 'running',
  Skipped = 'skipped',
}

export type MarketingReportStatusSummary = {
  __typename?: 'MarketingReportStatusSummary'
  errorMessage?: Maybe<Scalars['String']['output']>
  headline?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: MarketingReportKind
  reportDate: Scalars['String']['output']
  s3Key?: Maybe<Scalars['String']['output']>
  slackParentTs?: Maybe<Scalars['String']['output']>
  status: MarketingReportStatus
}

export type MarketingReportUpdateInput = {
  archiveToS3?: InputMaybe<Scalars['Boolean']['input']>
  errorMessage?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  payloadJson?: InputMaybe<Scalars['JSON']['input']>
  slackChannelId?: InputMaybe<Scalars['String']['input']>
  slackParentTs?: InputMaybe<Scalars['String']['input']>
  slackThreadTs?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<MarketingReportStatus>
}

/**
 * Marketing research job (Motion MCP insights, inspo, brand, workspace).
 * Kind is domain language; MCP tool names stay in the provider adapter.
 */
export type MarketingResearchJob = {
  __typename?: 'MarketingResearchJob'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  error?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: Scalars['String']['output']
  progressMessage?: Maybe<Scalars['String']['output']>
  progressPercent?: Maybe<Scalars['Int']['output']>
  provider: Scalars['String']['output']
  providerRequestId?: Maybe<Scalars['String']['output']>
  requestJson?: Maybe<Scalars['JSON']['output']>
  resultJson?: Maybe<Scalars['JSON']['output']>
  sessionId?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarketingResearchJobDeleteInput = {
  id: Scalars['ID']['input']
}

export enum MarketingResearchJobKind {
  BrandContext = 'brand_context',
  CreativeDetail = 'creative_detail',
  CreativeInsights = 'creative_insights',
  InspoCreatives = 'inspo_creatives',
  WorkspaceContext = 'workspace_context',
}

export type MarketingResearchJobListResponse = {
  __typename?: 'MarketingResearchJobListResponse'
  count: Scalars['Int']['output']
  jobs: Array<MarketingResearchJob>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
}

export type MarketingResearchJobStartInput = {
  kind: MarketingResearchJobKind
  requestJson?: InputMaybe<Scalars['JSON']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
}

export type MarketingTrackingTemplateUpdateInput = {
  accountExternalId: Scalars['String']['input']
  campaignExternalIds?: InputMaybe<Array<Scalars['String']['input']>>
  platform: Scalars['String']['input']
}

export type MarketingTranslateContentInput = {
  contentType?: InputMaybe<MarketingTranslationContentType>
  context?: InputMaybe<Scalars['String']['input']>
  sourceLang?: InputMaybe<Scalars['String']['input']>
  targetLang: Scalars['String']['input']
  text: Array<Scalars['String']['input']>
  useGaiaGlossary?: InputMaybe<Scalars['Boolean']['input']>
}

export enum MarketingTranslationContentType {
  Html = 'HTML',
  Plain = 'PLAIN',
}

export enum MatchSourceType {
  Agent = 'AGENT',
  User = 'USER',
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type Media = {
  __typename?: 'Media'
  /** Media aspect ratio */
  aspectRatio?: Maybe<Scalars['String']['output']>
  /** Media colorspace value */
  colorspace?: Maybe<Scalars['String']['output']>
  /** All of the content where this media appears as the feature */
  contentFeatured?: Maybe<Array<Maybe<Content>>>
  /** A fully qualified string identifier for the media (not content.contentId) */
  contentId?: Maybe<Scalars['String']['output']>
  /** The content policy linked to this media */
  contentPolicy?: Maybe<ContentPolicy>
  /** All of the content where this media appears as the preview */
  contentPreview?: Maybe<Array<Maybe<Content>>>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Playable duration in seconds: `ms` asset when present, otherwise `ms_clip` (vertical clips) */
  duration?: Maybe<Scalars['Int']['output']>
  /** Filename of input media file */
  filename?: Maybe<Scalars['String']['output']>
  /** Media framerate */
  framerate?: Maybe<Scalars['Int']['output']>
  /** True when this media is Gaia original (no linked media asset original_file_name contains _LC_) */
  isGaiaOriginal: Scalars['Boolean']['output']
  /** A flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** A list of linked media assets */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
  /** Video playback data for the media asset of type media stream (ms) */
  mediaAssetsVideoPlayback?: Maybe<Array<Maybe<MediaAssetVideoPlayback>>>
  /** The primary key */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** Media maestro ID */
  mediaMaestroTitleCode?: Maybe<Scalars['String']['output']>
  /** Media motion type */
  motionType?: Maybe<Scalars['String']['output']>
  /** viewing policy which can yield arrays of country codes allowed/denied */
  policyId?: Maybe<Scalars['Int']['output']>
  /** Media type */
  subtype?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Media use (feature/trailer) */
  use?: Maybe<Scalars['Int']['output']>
  /** The user media position for the current position on this media */
  userMediaPosition?: Maybe<UserMediaPosition>
  /** Size of Video (1080, 720, etc.) */
  videoSize?: Maybe<Scalars['Int']['output']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentFeaturedArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaContentPreviewArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>
  mediaAssets?: InputMaybe<Array<InputMaybe<MediaMediaAssetsInput>>>
}

/**
 * Media represents playable media content (video/audio streams) and associated metadata.
 *
 * Media is linked to Content and contains the actual playable streams and text tracks.
 * To get the actual media files (streams, subtitles, etc.), use the mediaAssets field to get
 * MediaAsset objects, then access their url fields via HTTP requests for the most efficient access.
 */
export type MediaMediaAssetsVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  languageMatchType?: InputMaybe<MediaMediaAssetsLanguageMatchType>
}

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - MEDIA_STREAM_CLIP: Playable clip streams (e.g. vertical short-form)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAsset = {
  __typename?: 'MediaAsset'
  /**
   * AI-authored metadata for this media asset, resolved by the AI service.
   * Returns null when no metadata is available.
   */
  aiMetadata?: Maybe<MediaAssetAiMetadata>
  /** The content policy linked to this media asset by the media */
  contentPolicy?: Maybe<ContentPolicy>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** An optional duration */
  duration?: Maybe<Scalars['Int']['output']>
  /** An optional height */
  height?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The status of ingest for the provider asset */
  ingestStatus?: Maybe<Scalars['String']['output']>
  /** The language of asset that was used to create all of the translations */
  language?: Maybe<Scalars['String']['output']>
  /** The media associated with this media asset */
  media?: Maybe<Media>
  /** The media asset document linked to this media asset */
  mediaAssetDocument?: Maybe<MediaAssetDocument>
  /** The media id on the media table */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** A string that describes the relationship between the asset and media e.g. cc */
  mediaReferenceType?: Maybe<Scalars['String']['output']>
  /** The mime type of the asset */
  mimeType?: Maybe<Scalars['String']['output']>
  /** The original name of the file for the asset */
  originalFileName?: Maybe<Scalars['String']['output']>
  /** The provider where the asset is stored e.g. AWS_S3 */
  provider?: Maybe<Scalars['String']['output']>
  /**
   * The media assets provider specific data (e.g., parsed VTT data).
   * This field provides structured access to parsed content like VTT cues for text tracks.
   * If you only need raw file data, use the url field with direct HTTP access instead.
   */
  providerData?: Maybe<MediaAssetProviderData>
  /** The unique key for the asset on providers system e.g. on S3 it would be file key or it might be a url for an external provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** The when true the media asset is publically available */
  published?: Maybe<Scalars['Boolean']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * The URL to retrieve the media asset file.
   * This is the most efficient way to get the actual media asset - make an HTTP GET request to this URL.
   * For text tracks (subtitles, closed captions, chapters), accessing this URL directly via REST
   * is preferred over GraphQL if you only need the raw VTT file data.
   */
  url?: Maybe<Scalars['String']['output']>
  /** The public primary identifier for this record */
  uuid?: Maybe<Scalars['String']['output']>
  /** Video playback data for media streams */
  videoPlayback?: Maybe<MediaAssetVideoPlayback>
  /** An optional width */
  width?: Maybe<Scalars['Int']['output']>
}

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - MEDIA_STREAM_CLIP: Playable clip streams (e.g. vertical short-form)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAssetAiMetadataArgs = {
  language?: InputMaybe<Scalars['String']['input']>
}

/**
 * Media asset represents a file associated with media (video streams, subtitles, closed captions, chapters).
 *
 * Media assets are the actual files that make up playable media content:
 * - MEDIA_STREAM: Playable video/audio streams (HLS, DASH)
 * - MEDIA_STREAM_CLIP: Playable clip streams (e.g. vertical short-form)
 * - CLOSED_CAPTION: Closed caption text tracks (VTT format)
 * - SUBTITLE: Subtitle text tracks (VTT format)
 * - CHAPTER: Chapter marker text tracks (VTT format)
 *
 * Important Usage Notes:
 * - To get the actual media asset file, use the url field and make an HTTP GET request to that URL.
 *   This is the most efficient way to retrieve media asset data, as it leverages CDN caching and
 *   direct file access rather than going through GraphQL.
 *
 * - For text tracks (subtitles, closed captions, chapters): If you only need the raw VTT file data,
 *   it is more efficient to access the url directly via REST/HTTP rather than using GraphQL.
 *   GraphQL is better when you need parsed metadata (via providerData) or relationships, but for
 * raw file content, direct URL access is preferred.
 */
export type MediaAssetVideoPlaybackArgs = {
  deliveryRule?: InputMaybe<MediaAssetVideoPlaybackDeliverRule>
  hlsVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** AI-authored metadata for a media asset resolved by the AI service. */
export type MediaAssetAiMetadata = {
  __typename?: 'MediaAssetAiMetadata'
  /** Language/locale for the metadata payload. */
  language: Scalars['String']['output']
  /** AI-assessed learner level from summary validator (level, reasoning, score). */
  learnerLevel?: Maybe<ContentAiLearnerLevel>
  /** Parent media identifier. */
  mediaId: Scalars['ID']['output']
  /** AI-generated summary text, or null when unavailable. */
  summary?: Maybe<Scalars['String']['output']>
  /** Pre-processed transcript text, or null when unavailable. */
  transcript?: Maybe<Scalars['String']['output']>
}

/**
 * **`media_asset_documents` join row:** pairs one **`MediaAsset`** (`mediaAssetsId`) with one **`documents`** row (`documentsId`). This is the **primary** link when indexing is driven from a concrete media asset (e.g. captions/transcripts) without a **`content_documents`** row first.
 *
 * **Resolver interaction:** When this row exists, **`Document.documentMediaAsset`** and **`Document.mediaAssets`** resolve to this asset; **`Document.documentContent`** is `null` unless a separate **`content_documents`** row also exists. **`Document.content`** may still list **`Content`** rows whose **`featureMediaId`** matches the linked media’s **`mediaId`**. See **`Document`** for full precedence between content-linked and media-linked paths.
 *
 * **Embeddings:** Chunk rows on **`Document.documentEmbeddings`** carry **`metadata`** pointing back to source content/media; offline title-level summary + vector live in **`document_abstracts`** and are read via **`documentAbstractList`**.
 */
export type MediaAssetDocument = {
  __typename?: 'MediaAssetDocument'
  /** Join row creation time. */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The **`Document`** row used for embeddings and worker processing for this asset. */
  document?: Maybe<Document>
  /** `documents.id` participating in this link. */
  documentsId?: Maybe<Scalars['ID']['output']>
  /** The **`MediaAsset`** row (tracks, duration, language, etc.) for this join. */
  mediaAsset?: Maybe<MediaAsset>
  /** `MediaAsset` primary key participating in this link. */
  mediaAssetsId?: Maybe<Scalars['ID']['output']>
  /** Join row last update time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Media asset response */
export type MediaAssetListResponse = {
  __typename?: 'MediaAssetListResponse'
  /** A list of media */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>
}

export enum MediaAssetMediaReferenceTypes {
  /** The asset represents a chapter marker */
  Chapter = 'CHAPTER',
  /** The asset represents a closed caption */
  ClosedCaption = 'CLOSED_CAPTION',
  /** The asset represents a playable media stream i.e. hls */
  MediaStream = 'MEDIA_STREAM',
  /** The asset represents a playable clip stream (e.g. vertical short-form) */
  MediaStreamClip = 'MEDIA_STREAM_CLIP',
  /** The asset represents a subtitle */
  Subtitle = 'SUBTITLE',
}

export type MediaAssetMezzanineDownload = {
  __typename?: 'MediaAssetMezzanineDownload'
  downloadUrl: Scalars['String']['output']
  downloadUrlExpiresAt: Scalars['DateTime']['output']
  fileName?: Maybe<Scalars['String']['output']>
  mediaAssetId: Scalars['ID']['output']
  s3Uri?: Maybe<Scalars['String']['output']>
}

export type MediaAssetMezzanineRaw = {
  __typename?: 'MediaAssetMezzanineRaw'
  availability: MezzanineRawAvailability
  fileName?: Maybe<Scalars['String']['output']>
  restoreExpiresAt?: Maybe<Scalars['DateTime']['output']>
  restoreReadyAt?: Maybe<Scalars['DateTime']['output']>
  restoreRequestedAt?: Maybe<Scalars['DateTime']['output']>
  restoreStatus?: Maybe<MezzanineRestoreStatus>
  s3Uri?: Maybe<Scalars['String']['output']>
}

/** The provider specific data for the media asset e.g. parsed VTT data */
export type MediaAssetProviderData = {
  __typename?: 'MediaAssetProviderData'
  /** The provider data as text if supported */
  text?: Maybe<Scalars['String']['output']>
  /** Parsed vtt data */
  vtt?: Maybe<MediaAssetProviderDataVtt>
}

/** Parsed vtt data */
export type MediaAssetProviderDataVtt = {
  __typename?: 'MediaAssetProviderDataVtt'
  /** The parsed VTT data cues */
  cues?: Maybe<Array<Maybe<MediaAssetProviderDataVttQues>>>
}

/** The parsed VTT data cues */
export type MediaAssetProviderDataVttQues = {
  __typename?: 'MediaAssetProviderDataVttQues'
  alignment?: Maybe<Scalars['String']['output']>
  direction?: Maybe<Scalars['String']['output']>
  endTime?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  lineAlign?: Maybe<Scalars['String']['output']>
  linePosition?: Maybe<Scalars['String']['output']>
  pauseOnExit?: Maybe<Scalars['String']['output']>
  positionAlign?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['String']['output']>
  snapToLines?: Maybe<Scalars['String']['output']>
  startTime?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  textPosition?: Maybe<Scalars['String']['output']>
}

/** The video playback information for media assets of type media stream */
export type MediaAssetVideoPlayback = {
  __typename?: 'MediaAssetVideoPlayback'
  /** The provider DASH url */
  dashUrl?: Maybe<Scalars['String']['output']>
  /** The provider HLS url */
  hlsUrl?: Maybe<Scalars['String']['output']>
  /** The HLS stream version */
  hlsVersion?: Maybe<Scalars['String']['output']>
  /** The media asset id */
  id?: Maybe<Scalars['ID']['output']>
  /** The media asset language */
  language?: Maybe<Scalars['String']['output']>
  /** The preview HLS url */
  previewHlsUrl?: Maybe<Scalars['String']['output']>
  /** The video thumbnail url */
  thumbnailUrl?: Maybe<Scalars['String']['output']>
}

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackDeliverRule {
  /** Apply the byte range delivery rule */
  ByteRange = 'BYTE_RANGE',
}

/** The video playback delivery rules */
export enum MediaAssetVideoPlaybackHlsVersions {
  /** HLS version 3 */
  V3 = 'v3',
  /** HLS version 4 */
  V4 = 'v4',
  /** HLS version 7 */
  V7 = 'v7',
}

/** The where clause for a media asset id field */
export type MediaAssetWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Media asset where input */
export type MediaAssetWhereInput = {
  /** Media asset where id clause */
  id?: InputMaybe<MediaAssetWhereIdInput>
  /** Media asset where mediaId clause */
  mediaId?: InputMaybe<MediaAssetWhereMediaIdInput>
  /** Media asset where mediaReferenceType clause */
  mediaReferenceType?: InputMaybe<MediaAssetWhereMediaReferenceTypenput>
}

/** The where clause for a media asset id field */
export type MediaAssetWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The where clause for a media asset media reference type field */
export type MediaAssetWhereMediaReferenceTypenput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Return type for media create */
export type MediaCreateResponse = {
  __typename?: 'MediaCreateResponse'
  /** The newly created media */
  media?: Maybe<Media>
}

/** Media input for create/update operations */
export type MediaInput = {
  /** Media aspect ratio */
  aspectRatio?: InputMaybe<Scalars['String']['input']>
  /** Brightcove data array (optional) */
  brightcove?: InputMaybe<Array<InputMaybe<BrightcoveInput>>>
  /** Media colorspace value */
  colorspace?: InputMaybe<Scalars['String']['input']>
  /** A fully qualified string identifier for the media (required) */
  contentId: Scalars['String']['input']
  /** Filename of input media file */
  filename?: InputMaybe<Scalars['String']['input']>
  /** Media framerate */
  framerate?: InputMaybe<Scalars['Int']['input']>
  /** A flag indicating the media has been published */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key (optional for create, auto-generated if not provided) */
  mediaId?: InputMaybe<Scalars['ID']['input']>
  /** Media maestro ID */
  mediaMaestroTitleCode?: InputMaybe<Scalars['String']['input']>
  /** Media motion type */
  motionType?: InputMaybe<Scalars['String']['input']>
  /** viewing policy which can yield arrays of country codes allowed/denied */
  policyId?: InputMaybe<Scalars['Int']['input']>
  /** Media type */
  subtype?: InputMaybe<Scalars['String']['input']>
  /** Media use (feature/trailer) */
  use?: InputMaybe<Scalars['Int']['input']>
  /** Size of Video (1080, 720, etc.) */
  videoSize?: InputMaybe<Scalars['Int']['input']>
}

/** Media asset response */
export type MediaListResponse = {
  __typename?: 'MediaListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** A list of media */
  media?: Maybe<Array<Maybe<Media>>>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Media filter for media assets */
export type MediaMediaAssetsInput = {
  /** The media asset language */
  language?: InputMaybe<Scalars['String']['input']>
  /** The media asset media reference type */
  mediaReferenceType?: InputMaybe<Scalars['String']['input']>
}

/** The media media assets association language match type */
export enum MediaMediaAssetsLanguageMatchType {
  /** Match any of the languages */
  Any = 'ANY',
}

/** Precise (contentId, contentType) pair for mediaPreviewStartUpdate */
export type MediaPreviewStartContentInput = {
  /** Business content id */
  contentId: Scalars['Int']['input']
  /** Content type e.g. video, series */
  contentType: Scalars['String']['input']
}

/** A Brightcove video that failed to update */
export type MediaPreviewStartError = {
  __typename?: 'MediaPreviewStartError'
  brightcoveVideoId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type MediaPreviewStartResponse = {
  __typename?: 'MediaPreviewStartResponse'
  dryRun: Scalars['Boolean']['output']
  /** One entry per failed video, also logged */
  errors: Array<MediaPreviewStartError>
  failureCount: Scalars['Int']['output']
  /** When limit is set, true if more distinct videos remain after this chunk */
  hasMore: Scalars['Boolean']['output']
  /** Last provider_key processed in this chunk; pass as brightcoveVideoId.gt for the next call */
  lastVideoId?: Maybe<Scalars['String']['output']>
  /** Joined rows matching where before video dedupe */
  matchCount: Scalars['Int']['output']
  successCount: Scalars['Int']['output']
  /** Distinct Brightcove videos remaining at or after the cursor */
  videoCount: Scalars['Int']['output']
}

/** Brightcove video id (media_assets.provider_key) where for mediaPreviewStartUpdate */
export type MediaPreviewStartWhereBrightcoveVideoIdInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  /** Keyset cursor: provider_key strictly greater than this value (varchar string order) */
  gt?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/**
 * Where clause for mediaPreviewStartUpdate. Require at least one filter.
 * Flat fields are ANDed; use content for OR-grouped (contentId, contentType) pairs.
 */
export type MediaPreviewStartWhereInput = {
  brightcoveVideoId?: InputMaybe<MediaPreviewStartWhereBrightcoveVideoIdInput>
  content?: InputMaybe<Array<MediaPreviewStartContentInput>>
  mediaId?: InputMaybe<MediaPreviewStartWhereMediaIdInput>
  titleGroupId?: InputMaybe<MediaPreviewStartWhereTitleGroupIdInput>
}

/** feature media id (media.media_id) where for mediaPreviewStartUpdate */
export type MediaPreviewStartWhereMediaIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** titleGroupId where for mediaPreviewStartUpdate */
export type MediaPreviewStartWhereTitleGroupIdInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** The where conditions to filter rows */
export type MediaWhereInput = {
  /** The media content id (not content.id or content.content_id) */
  contentId?: InputMaybe<MediaWhereMediaContentIdInput>
  /** The media id */
  mediaId?: InputMaybe<MediaWhereMediaIdInput>
  /** Media maestro title code (MMID) — staff only */
  mediaMaestroTitleCode?: InputMaybe<MediaWhereMediaMaestroTitleCodeInput>
  /** media_assets.provider filter — staff only */
  provider?: InputMaybe<MediaWhereProviderInput>
  /** Exact media_assets.provider_key (e.g. Brightcove video id) — staff only */
  providerKey?: InputMaybe<MediaWhereProviderKeyInput>
  /** Media use (preview=1, feature=2) — staff only */
  use?: InputMaybe<MediaWhereUseInput>
}

/** The where clause for a media content id field */
export type MediaWhereMediaContentIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where clause for a media id field */
export type MediaWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** The where clause for media maestro title code (MMID) */
export type MediaWhereMediaMaestroTitleCodeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<Scalars['String']['input']>>
}

/**
 * Filter media by media_assets.provider (asset-level, not a column on media).
 * Common values: BRIGHTCOVE_DYNAMIC_DELIVERY, BRIGHTCOVE_YOGA_INTERNATIONAL, AWS_S3
 * (see media-assets providers). Positive filters match media that have such an asset;
 * negative filters exclude media that have any matching provider asset.
 */
export type MediaWhereProviderInput = {
  /** Media has an asset with this provider */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Media has an asset with one of these providers */
  in?: InputMaybe<Array<Scalars['String']['input']>>
  /** Media has no asset with this provider */
  ne?: InputMaybe<Scalars['String']['input']>
  /** Media has no asset with any of these providers */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
}

/**
 * Exact match on media_assets.provider_key for any asset
 * (typically a Brightcove video id).
 */
export type MediaWhereProviderKeyInput = {
  /** Exact provider key (e.g. Brightcove video id) */
  eq: Scalars['String']['input']
}

/** The where clause for media use (preview=1, feature=2) */
export type MediaWhereUseInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
}

export type MessagePairSearchResult = {
  __typename?: 'MessagePairSearchResult'
  createdAt: Scalars['DateTime']['output']
  matchSource: MatchSourceType
  messageIndexInConversation: Scalars['Int']['output']
  messagePairId: Scalars['ID']['output']
  searchRank: Scalars['Float']['output']
  snippet: Scalars['String']['output']
}

export enum MezzanineRawAvailability {
  Available = 'AVAILABLE',
  GlacierNeedsRestore = 'GLACIER_NEEDS_RESTORE',
  GlacierRestoring = 'GLACIER_RESTORING',
  NotFound = 'NOT_FOUND',
  UnsupportedProvider = 'UNSUPPORTED_PROVIDER',
}

export enum MezzanineRestoreStatus {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  PendingRestore = 'PENDING_RESTORE',
  Ready = 'READY',
}

export enum ModerationAction {
  Approve = 'APPROVE',
  BanUser = 'BAN_USER',
  Reject = 'REJECT',
  Remove = 'REMOVE',
}

export enum ModerationCategory {
  Harassment = 'HARASSMENT',
  Hate = 'HATE',
  Illicit = 'ILLICIT',
  MedicalAdvice = 'MEDICAL_ADVICE',
  None = 'NONE',
  SelfHarm = 'SELF_HARM',
  Sexual = 'SEXUAL',
  SexualMinors = 'SEXUAL_MINORS',
  Spam = 'SPAM',
  Threat = 'THREAT',
  Violence = 'VIOLENCE',
}

/** One applicable LLM verdict paired with the first human decision (published / rejected / unpublished) that answered it on the same text, where the two disagree. */
export type ModerationOverride = {
  __typename?: 'ModerationOverride'
  /** The moderator — federated UserInfoPublic, resolved by the gateway. */
  actor?: Maybe<UserInfoPublic>
  actorUid?: Maybe<Scalars['Int']['output']>
  /** NONE when the classifier cleared it. */
  aiCategory: ModerationCategory
  aiDecidedAt: Scalars['DateTime']['output']
  /** The AI verdict's ledger event id. */
  aiEventId: Scalars['ID']['output']
  aiReason?: Maybe<Scalars['String']['output']>
  aiStatus: CommentStatus
  aiTopScore?: Maybe<Scalars['Float']['output']>
  authorUid: Scalars['Int']['output']
  comment?: Maybe<Comment>
  decidedAt: Scalars['DateTime']['output']
  direction: ModerationOverrideDirection
  /** APPROVE, REJECT or SET_STATUS (the ledger event_json.action). */
  humanAction?: Maybe<Scalars['String']['output']>
  humanStatus: CommentStatus
  /** Unique per row: the human decision's ledger event id. */
  id: Scalars['ID']['output']
  itemId: Scalars['ID']['output']
  surface: ModerationSurface
  /** True when the comment's current text differs from the revision both the AI verdict and the human decision were made on (edited or deleted since) — the text shown is not what was judged. */
  textChanged: Scalars['Boolean']['output']
}

export type ModerationOverrideConnection = {
  __typename?: 'ModerationOverrideConnection'
  /** Always over the whole window — unaffected by direction / category. */
  facets: Array<ModerationOverrideFacet>
  items: Array<ModerationOverride>
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** Which way the human disagreed with the AI verdict. */
export enum ModerationOverrideDirection {
  /** The AI published it and a human later rejected or unpublished it — the AI under-flagged. */
  Missed = 'MISSED',
  /** The AI held it (AI_FLAGGED) and a human published it — the AI over-flagged. */
  Overturned = 'OVERTURNED',
}

/** Per-category calibration counts for applicable LLM verdicts issued in the window. */
export type ModerationOverrideFacet = {
  __typename?: 'ModerationOverrideFacet'
  category: ModerationCategory
  /** Verdicts that held the comment (AI_FLAGGED). */
  flagged: Scalars['Int']['output']
  /** Auto-published verdicts a human later rejected or unpublished (an observed count, not a false-negative rate). */
  missed: Scalars['Int']['output']
  /** Held verdicts a human then published. */
  overturned: Scalars['Int']['output']
  /** Held verdicts a human then rejected or unpublished. */
  upheld: Scalars['Int']['output']
}

export type ModerationQueueConnection = {
  __typename?: 'ModerationQueueConnection'
  items: Array<ModerationQueueItem>
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/**
 * A comment on the moderation surface. `source` is the latest LLM / USER_REPORT ledger row (why the
 * comment is in the queue). The AI fields always come from the latest APPLICABLE LLM verdict, so a
 * member report never hides the AI verdict and a stale classification never masks the one that
 * applied. `category` is NONE when that verdict scored every category 0, and null only when there
 * is no applicable verdict; a published comment may carry a low-score named category.
 */
export type ModerationQueueItem = {
  __typename?: 'ModerationQueueItem'
  authorUid: Scalars['Int']['output']
  category?: Maybe<ModerationCategory>
  comment?: Maybe<Comment>
  createdAt: Scalars['DateTime']['output']
  itemId: Scalars['ID']['output']
  reason?: Maybe<Scalars['String']['output']>
  scores: Array<ModerationScore>
  /** Why it is in the queue — null for comments with no ledger row (e.g. old items browsed by status) */
  source?: Maybe<ModerationSource>
  surface: ModerationSurface
  topScore?: Maybe<Scalars['Float']['output']>
  /** True when the comment's text changed after the latest applicable AI verdict (the verdict describes an earlier revision). Null without a verdict. */
  verdictStale?: Maybe<Scalars['Boolean']['output']>
}

export enum ModerationResolveAction {
  Approve = 'APPROVE',
  Reject = 'REJECT',
}

/** A single harm-category score from the classifier (raw model score, not calibrated confidence). */
export type ModerationScore = {
  __typename?: 'ModerationScore'
  category: ModerationCategory
  score: Scalars['Float']['output']
}

export enum ModerationSource {
  Llm = 'LLM',
  UserReport = 'USER_REPORT',
}

export enum ModerationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
}

export enum ModerationSurface {
  Comment = 'COMMENT',
}

/** Oracle AI: Root mutation operations */
export type Mutation = {
  __typename?: 'Mutation'
  _empty?: Maybe<Scalars['String']['output']>
  /** Add a member to a community feed (admin only) */
  addCommunityFeedMember?: Maybe<CommunityFeed>
  agentEnhancementsHubCreate: AgentEnhancementsHubCreateResponse
  agentEnhancementsHubResolveEnhancement: AgentEnhancementsHubUpdateResponse
  agentEnhancementsHubUpdate: AgentEnhancementsHubUpdateResponse
  /** Dark AI Guide chat mutation (Postman / non-stream). Same auth and channel policy as the subscription. */
  aiGuideChat?: Maybe<AiGuideChatPayload>
  ambassadorLeadsUploadNdJsonToS3: AmbassadorLeadsUploadFileToS3Response
  /** Hard-delete an asset by uuid */
  assetDelete?: Maybe<Asset>
  /** Assign a user as a moderator of a feed (admin only) */
  assignFeedModerator?: Maybe<Scalars['Boolean']['output']>
  /** Join the pre-seeded circle for a rainbow category (capacity-enforced; circles are PRIVATE so this is the only member entry point) */
  assignToCircle: CommunityFeed
  /** Fetch playlist from Brightcove CMS and attach WebVTT captions to existing Gaia clips only (does not create clips) */
  attachClipCaptionsFromBrightcovePlaylist?: Maybe<AttachClipCaptionsFromBrightcovePlaylistResponse>
  /** Fetch playlist from Brightcove CMS and attach d6-poster-9x16 to existing Gaia clips only (does not create clips; skips when art already exists) */
  attachClipPostersFromBrightcovePlaylist?: Maybe<AttachClipPostersFromBrightcovePlaylistResponse>
  /** Creates a new auth role */
  authRoleCreate: AuthRoleMutationResponse
  /** Deletes an existing auth role */
  authRoleDelete: AuthRoleMutationResponse
  /** Updates an existing auth role */
  authRoleUpdate: AuthRoleMutationResponse
  authScopeCreate: AuthScopeMutationResponse
  authScopeDelete: AuthScopeMutationResponse
  authScopeUpdate: AuthScopeMutationResponse
  /** Insert a stored attribution param row. */
  billingCheckoutRequestAttributionParamCreate: BillingCheckoutRequestAttributionParamMutationResponse
  /** Delete a stored attribution param row. */
  billingCheckoutRequestAttributionParamDelete: BillingCheckoutRequestAttributionParamMutationResponse
  /** Update value/rawValue on an existing param row. */
  billingCheckoutRequestAttributionParamUpdate: BillingCheckoutRequestAttributionParamMutationResponse
  /** Create a billing events */
  billingCreateEvent?: Maybe<BillingEvent>
  /** Update a billing events */
  billingUpdateEvent?: Maybe<BillingEvent>
  /** Cancel RSVP to an event */
  cancelRsvpToCommunityEvent?: Maybe<CommunityEventRegistrationSummary>
  /** Oracle AI: Create a channel prompt set */
  channelPromptSetCreate: ChannelPromptSetMutationResponse
  /** Oracle AI: Delete channel prompt set */
  channelPromptSetDelete: ChannelPromptSetDeleteResponse
  /** Oracle AI: Replace sections for a channel prompt set */
  channelPromptSetReplaceSections: ChannelPromptSetMutationResponse
  /** Oracle AI: Update channel prompt set status */
  channelPromptSetUpdateStatus: ChannelPromptSetMutationResponse
  /** Create a vertical clip with ms_clip media, clip-vert reference to parent, and optional AI multiplier metadata */
  clipCreate?: Maybe<ClipCreateResponse>
  /** Import clips from a Brightcove CMS playlist. Parent Gaia video per row: Brightcove clip_source_video_id or clip_source as ms stream provider key, else perVideoParentOverrides entry. */
  clipImportFromBrightcovePlaylist?: Maybe<ClipImportFromBrightcovePlaylistResponse>
  /**
   * Create/reuse Brightcove videos for pre-staged social masters, start/poll Dynamic Ingest,
   * automatically apply a Brightcove Metadata Optimizer title, then create an unpublished Gaia
   * ms_clip with a title-generated path. Copies the Brightcove CMS 9:16 poster onto the clip as
   * d6-poster-9x16 (same helper as playlist import).
   * Safe to rerun while rows are pending; reruns also attach a missing poster on SKIPPED clips.
   */
  clipImportFromSocialManifest: ClipImportFromSocialManifestResponse
  /** Confirm browser PUTs with HeadObject. Matching size is STAGED; a size mismatch is ERROR. */
  clipSocialStageComplete: ClipSocialStageCompleteResponse
  /**
   * Check gtvmezz for Final List rows and return presigned PUT URLs for objects that are not
   * already staged. Does not accept MP4 bytes. Same roles as clipImportFromSocialManifest.
   */
  clipSocialStagePrepare: ClipSocialStagePrepareResponse
  /** Create a new comment on content */
  commentCreate: CommentMutationResponse
  /**
   * Delete your own comment, as a tombstone.
   *
   * Author-only — not a moderation tool, and not reachable for anyone else's comment. Permitted
   * whatever the comment's current status, including a held or rejected one: the author is the only
   * member who can see those, and refusing would leave them unable to retract something nobody else
   * can read.
   *
   * Idempotent. Deleting an already-deleted comment reports `success: false` and changes nothing, so
   * a double tap cannot decrement the video's comment total twice.
   *
   * The row survives with its content cleared — see `Comment.isDeleted` for why.
   */
  commentDelete: CommentMutationResponse
  /** React to a comment with a unicode emoji or a Gaia custom emoji key. Idempotent — reacting twice with the same emoji is a no-op, and a member may hold several different reactions on one comment. */
  commentReactionCreate: CommentMutationResponse
  /** Remove one of your reactions from a comment. Idempotent — removing a reaction you never added is a no-op, and your other reactions on that comment are untouched. */
  commentReactionDelete: CommentMutationResponse
  /** Report a comment for review */
  commentReport: CommentMutationResponse
  /** Edit an existing comment (must be own comment) */
  commentUpdate: CommentMutationResponse
  /** Confirm a banner image upload after the client PUTs the image */
  confirmBannerImageUpload: BannerImageUploadResponse
  /** Confirm a playlist cover photo upload after the client PUTs the image */
  confirmPlaylistCoverPhotoUpload: PlaylistCoverPhotoUploadResponse
  /** Confirm a profile picture upload after the client PUTs the image */
  confirmProfilePictureUpload: ProfilePictureUploadResponse
  /** Record a discount redemption for a user (admin). Persists a billing_discount_redemption row. */
  consumeDiscount: BillingDiscountRedemption
  /** Consume a token so the same consumption key cannot be used again. Writes the consumption even when rateLimit.enabled is off. The token must still be inside rateLimit.consumptionTimeToLiveMinutes. */
  consumeRateLimitToken: ConsumeRateLimitTokenResult
  /** Create a content anon row for the given content (Content.id). Fails if one already exists. */
  contentAnonCreate?: Maybe<ContentAnonCreateResponse>
  /** Delete the content anon row for the given content (Content.id). EDITOR cannot delete; EDITOR_PLUS and above only. */
  contentAnonDelete?: Maybe<ContentAnonDeleteResponse>
  /** Update the content anon row for the given content (Content.id). */
  contentAnonUpdate?: Maybe<ContentAnonUpdateResponse>
  /** Creates a new content asset reference */
  contentAssetReferenceCreate: ContentAssetReferenceMutationResponse
  /** Deletes an existing content asset reference */
  contentAssetReferenceDelete: ContentAssetReferenceMutationResponse
  /** Create a new piece of content */
  contentCreate?: Maybe<ContentCreateResponse>
  /** Create an unpublished es/de/fr variant from English via DeepL, or fill empty fields on an existing variant without overwriting copy */
  contentCreateLanguageTranslation?: Maybe<ContentCreateResponse>
  /** Create one content list criteria */
  contentListCriteriaCreate?: Maybe<ContentListCriteriaMutationResponse>
  /** Delete one content list criteria */
  contentListCriteriaDelete?: Maybe<ContentListCriteriaMutationResponse>
  /** Create one content provider */
  contentProviderCreateByContentId?: Maybe<ContentProviderMutationResponse>
  /** Delete one content provider */
  contentProviderDeleteByContentId?: Maybe<ContentProviderMutationResponse>
  /** Update one content provider */
  contentProviderUpdateByContentId?: Maybe<ContentProviderMutationResponse>
  /** Create a content reference */
  contentReferenceCreate: ContentReferenceCreateResponse
  /**
   * Create many content references
   * - Does not error if references already exist
   */
  contentReferenceCreateMany: ContentReferenceCreateManyResponse
  /** Delete a content reference */
  contentReferenceDelete: ContentReferenceDeleteResponse
  /**
   * Select content rows matching where and publish thin content_update events (republish: true)
   * for downstream sync (VA, Recombee, search). Does not enrich payloads in-process.
   * Live runs error if matchCount exceeds the configured ceiling; use dryRun to inspect counts first.
   * Chunk large catalogues by type or id range. Future: async worker for full-catalogue runs.
   */
  contentRepublish: ContentRepublishResponse
  /** Update a single piece of content */
  contentUpdate?: Maybe<ContentUpdateResponse>
  /** Mark an entire course as complete */
  courseMarkComplete: UserStateProgressCourse
  /** Mark a course module as complete */
  courseModuleMarkComplete: UserStateProgressCourseModule
  /** Reset a course (removes all progress, preserves completion count) */
  courseReset: UserStateProgressCourse
  /** Start a course (marks first video as in progress) */
  courseStart: UserStateProgressCourse
  createApiKey: ApiKeyMutationResponse
  /** Create a billing account */
  createBillingAccount: BillingAccount
  /** Create a billing discount */
  createBillingDiscount?: Maybe<BillingDiscount>
  /** Create a billingInvoice */
  createBillingInvoice?: Maybe<BillingInvoice>
  /** Create a billingOneTimePurchase */
  createBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** Create a billingPayment */
  createBillingPayment?: Maybe<BillingPayment>
  /** Create a billingPaymentMethod */
  createBillingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** Create a billing plan grid */
  createBillingPlanGrid?: Maybe<BillingPlanGrid>
  /** Create billingProduct */
  createBillingProduct?: Maybe<BillingProduct>
  /** Create a billingProductChangeLog */
  createBillingProductChangeLog?: Maybe<BillingProductChangeLog>
  /** Create billingProvider */
  createBillingProvider?: Maybe<BillingProvider>
  /** Create billingProviderCurrency */
  createBillingProviderCurrency?: Maybe<BillingProviderCurrency>
  /** Create billingProviderProduct */
  createBillingProviderProduct?: Maybe<BillingProviderProduct>
  /** Create a plan eligibility rule */
  createBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibility>
  /** Create a billingProviderProductPricing */
  createBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>
  /** Create a billingProviderProductText */
  createBillingProviderProductText?: Maybe<BillingProviderProductText>
  /** Create a billingRefund */
  createBillingRefund?: Maybe<BillingRefund>
  /** Create a billingSubscription */
  createBillingSubscription?: Maybe<BillingSubscription>
  /** Create a billingSubscriptionOrder */
  createBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>
  /** Create a BillingSubscriptionOrderPlan */
  createBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>
  /** Create a billingSubscriptionPlan */
  createBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** Create many unique billing discount codes with the same rules */
  createBulkBillingDiscount: BillingDiscountBulk
  /** Create a new event in a feed (admin only) */
  createCommunityEvent?: Maybe<CommunityEvent>
  /** Create a community feed (admin only) */
  createCommunityFeed?: Maybe<CommunityFeed>
  /** Create a community post or comment */
  createCommunityPost?: Maybe<CommunityPost>
  /** Create a community reaction */
  createCommunityReaction?: Maybe<Scalars['Boolean']['output']>
  /** Create a new custom emoji (Admin only) */
  createCustomEmoji: CustomEmoji
  /** Create the per-action config. Not gated by rateLimit.enabled or rateLimit.verifyFingerprint. */
  createRateLimitActionConfig: RateLimitActionConfig
  /** Create an allow or block override. Not gated by rateLimit.enabled. */
  createRateLimitOverride: RateLimitOverride
  /** Run a rate-limit check for another service. Stores the check even when rateLimit.enabled is off. Uid is the authenticated caller unless input uid is set, in which case authUid is the authenticated caller. IP is the request client IP unless input clientIp is set. */
  createRateLimitRequest: RateLimitRequestResult
  /** Create a rate-limit rule. Not gated by rateLimit.enabled. */
  createRateLimitRule: RateLimitRule
  /** Create a transactions */
  createTransaction?: Maybe<Transaction>
  /** Create a userAuditLog */
  createUserAuditLog?: Maybe<UserAuditLog>
  /**
   * Create a user entitlement. Typically used by administrators or customer service to manually
   * grant access. In normal operation, entitlements are created automatically when billing events
   * are processed. Requires elevated role access.
   */
  createUserEntitlement?: Maybe<UserEntitlement>
  /** Delete the current user's banner image */
  deleteBannerImage: DeleteBannerImageResponse
  /** Delete a billing plan grid */
  deleteBillingPlanGrid?: Maybe<DeleteBillingPlanGridResponse>
  /** Delete a plan eligibility rule */
  deleteBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibilityDeleteResponse>
  /** Delete a billingProviderProductPricing */
  deleteBillingProviderProductPrice?: Maybe<BillingProviderProductPricingDeleteResponse>
  /** Delete a billingProviderProductText */
  deleteBillingProviderProductText?: Maybe<BillingProviderProductTextDeleteResponse>
  /** Delete an event (admin only) */
  deleteCommunityEvent?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community feed (admin only) */
  deleteCommunityFeed?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community post or comment */
  deleteCommunityPost?: Maybe<Scalars['Boolean']['output']>
  /** Delete a community reaction */
  deleteCommunityReaction?: Maybe<Scalars['Boolean']['output']>
  /** Delete a custom emoji (Admin only) */
  deleteCustomEmoji: Scalars['Boolean']['output']
  /** Delete a feed image (admin only) */
  deleteFeedImage: Scalars['Boolean']['output']
  /** Delete a playlist's cover photo */
  deletePlaylistCoverPhoto: DeletePlaylistCoverPhotoResponse
  /** Delete the current user's profile picture */
  deleteProfilePicture: DeleteProfilePictureResponse
  /** Delete the per-action config. Not gated by rateLimit.enabled or rateLimit.verifyFingerprint. */
  deleteRateLimitActionConfig: RateLimitDeleteResponse
  /** Delete an allow or block override. Not gated by rateLimit.enabled. */
  deleteRateLimitOverride: RateLimitDeleteResponse
  /** Delete a rate-limit rule. Not gated by rateLimit.enabled. */
  deleteRateLimitRule: RateLimitDeleteResponse
  /** Create a discount code in Shopify */
  discountCodeCreate?: Maybe<DiscountCodeCreateResponse>
  /** Reset the document embeddings worker: clear worker data; in one transaction drop rebuild tables if present and recreate empty rebuild tables from embedding_config */
  documentsWorkerReset?: Maybe<DocumentsWorkerResetResponse>
  /** Store a finished Dreamcatcher capture and return its five picked dreamscapes */
  dreamCreate: DreamRecord
  /** Interpret a stored dream and return the joined markdown */
  dreamInterpretation: DreamInterpretationPayload
  /** Create one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityCreate?: Maybe<EcommerceSkuMappingBonusEligibilityCreateResponse>
  /** Delete one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityDeleteById?: Maybe<EcommerceSkuMappingBonusEligibilityDeleteByIdResponse>
  /** Update one ecommerce sku mapping bonus eligibility */
  ecommerceSkuMappingBonusEligibilityUpdateById?: Maybe<EcommerceSkuMappingBonusEligibilityUpdateByIdResponse>
  /** Create one GAIA_BONUS ecommerce sku mapping. See EcommerceSkuMappingCreateInput for entitlement configuration. Purchasers always receive content set 222; subscription-only SKUs require contentTitleGroupIds: [] plus contentSetId and subscription timing fields. */
  ecommerceSkuMappingCreate?: Maybe<EcommerceSkuMappingCreateResponse>
  /** Update one GAIA_BONUS ecommerce sku mapping. See EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput for entitlement configuration. */
  ecommerceSkuMappingUpdateByProviderAndEcommerceSku?: Maybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse>
  /** Insert an embedding_config row (site admin only) */
  embeddingConfigCreate?: Maybe<EmbeddingConfigMutationPayload>
  /** Delete an embedding_config row by id (site admin only) */
  embeddingConfigDelete?: Maybe<EmbeddingConfigMutationPayload>
  /** Update an embedding_config row (site admin only) */
  embeddingConfigUpdate?: Maybe<EmbeddingConfigMutationPayload>
  /** Log a user interaction event */
  eventLog: EventLogResponse
  /** Flag content for moderation */
  flagCommunityContent?: Maybe<Scalars['Boolean']['output']>
  /** Hide or unhide a video from the user's watch history */
  flagWatchedVideo: FlagWatchedVideoResponse
  /** Follow a playlist */
  followPlaylist?: Maybe<Playlist>
  /** Look up a Shopify gift card by code and debit its full remaining balance */
  giftCardConsume?: Maybe<GiftCardConsumePayload>
  /** Debit an amount from a Shopify gift card by id */
  giftCardDebit?: Maybe<GiftCardDebitPayload>
  /** Store authorizations for imported checks. A check that already has an action is skipped. A missing check is listed and is not an error. At most 500 rows. */
  importRateLimitActions: RateLimitImportResult
  /** Store allow and block rows. The stored uuid is derived from sourceUuid and action, and a repeat is skipped. At most 500 rows. */
  importRateLimitOverrides: RateLimitImportResult
  /** Store velocity checks without running rules. An existing uuid is skipped. At most 500 rows. */
  importRateLimitRequests: RateLimitImportResult
  /** Invite a user into a circle by their public profile uuid (site admin, or circle admin of THAT circle — the per-feed role never travels). Idempotent for existing members; refused when the circle is full */
  inviteToCircle: CommunityFeed
  /** Join a community feed. Circle feeds enforce the member cap (maxMembers) — joining a full circle fails with 'Circle is full'; re-joining as an existing member is always a no-op success. */
  joinCommunityFeed?: Maybe<CommunityFeed>
  /** Leave a community feed */
  leaveCommunityFeed?: Maybe<CommunityFeed>
  /** Create a localization string */
  localizationStringCreate?: Maybe<LocalizationStringCreateResponse>
  /** Delete a localization string */
  localizationStringDelete?: Maybe<LocalizationStringDeleteResponse>
  /** Update a localization string */
  localizationStringUpdate?: Maybe<LocalizationStringUpdateResponse>
  /** Login a user */
  login?: Maybe<LoginRenewResponse>
  /** Mark a community feed as read up to an optional position (defaults to now). Bumps the viewer's activity/presence timestamp on every call, advances their read position monotonically, and clears unseen mention notifications. Returns the feed with fresh unread counts (null if the viewer is not a member). */
  markCommunityFeedRead?: Maybe<CommunityFeed>
  marketingAdCreate: MarketingPaidMutationResponse
  marketingAdGroupCreate: MarketingPaidMutationResponse
  marketingAdTargetingIngestTick: MarketingAdTargetingIngestTickResponse
  marketingAdUpdateUtm: MarketingPaidMutationResponse
  marketingAgentConfirm: MarketingAgentConfirmResult
  marketingAgentScore: MarketingAgentScoreResult
  marketingAgentTurn: MarketingAgentTurnResult
  marketingAirCreativeMutate: MarketingCreativeVendorResponse
  marketingAirCreativePublish: MarketingCreativeVendorResponse
  marketingCampaignAssetCreate: MarketingCampaignAssetCreateResponse
  marketingCampaignCreate: MarketingPaidMutationResponse
  marketingCampaignUpdate: MarketingPaidMutationResponse
  marketingCreativeGenerationJobDelete?: Maybe<MarketingCreativeGenerationJob>
  marketingCreativeGenerationJobStart: MarketingCreativeGenerationJob
  marketingIngestionPhaseReset: MarketingIngestionPhaseResetResponse
  marketingKeywordCreate: MarketingPaidMutationResponse
  marketingKeywordUpdate: MarketingPaidMutationResponse
  marketingLandingPageMutate: MarketingCreativeVendorResponse
  marketingMessagingCampaignUpsert: MarketingMessagingUpsertResponse
  marketingMessagingContentUpsert: MarketingMessagingContentUpsertResponse
  marketingMessagingTemplateUpsert: MarketingMessagingUpsertResponse
  marketingMessagingTriggerSend: MarketingMessagingTriggerSendResponse
  marketingReportCancel: Array<MarketingReport>
  marketingReportCreate?: Maybe<MarketingReport>
  marketingReportDelete?: Maybe<MarketingReport>
  marketingReportExclusionCreate?: Maybe<MarketingReportExclusion>
  marketingReportExclusionDelete?: Maybe<MarketingReportExclusion>
  marketingReportExclusionUpdate?: Maybe<MarketingReportExclusion>
  marketingReportRun: MarketingReportRunResponse
  marketingReportUpdate?: Maybe<MarketingReport>
  marketingResearchJobDelete?: Maybe<MarketingResearchJob>
  marketingResearchJobStart?: Maybe<MarketingResearchJob>
  marketingTrackingTemplateUpdate: MarketingPaidMutationResponse
  /** Request Glacier Bulk restore for mezzanine raw media on a stream asset */
  mediaAssetRequestMezzanineRestore: MediaAssetMezzanineRaw
  /** Create a new media item */
  mediaCreate?: Maybe<MediaCreateResponse>
  /**
   * Set Brightcove video_preview.start for Gaia feature-media videos matching where, so
   * animated hover previews skip the title card. Resolves from content.feature_media_id
   * joined to media_assets (BRIGHTCOVE_DYNAMIC_DELIVERY media streams only; Yoga
   * International excluded). Writes to the shared Brightcove account used by stage and
   * production. Safe to re-run: the PATCH is idempotent for a given start value. Live runs
   * without limit error if videoCount exceeds the ceiling; pass limit to chunk the catalogue.
   * Full-catalogue loop: start with brightcoveVideoId: { gt: "" }, limit: 500, then repeat
   * with gt set to each response lastVideoId until hasMore is false. provider_key cursor
   * order is varchar collation, not numeric.
   */
  mediaPreviewStartUpdate: MediaPreviewStartResponse
  /**
   * Approve (→ PUBLISHED) or reject the moderated item; returns the updated Comment. REJECT lands
   * on UNPUBLISHED for a comment that was live and then reported (NEEDS_REVIEW), and on REJECTED
   * otherwise; a repeat REJECT on a comment already taken down is a no-op. Writes a HUMAN ledger
   * row; moving INTO REJECTED or UNPUBLISHED notifies the author (COMMENT_REJECTED).
   */
  moderationResolve?: Maybe<Comment>
  /**
   * Override a comment to any human-owned status: PUBLISHED, UNPUBLISHED, NEEDS_REVIEW,
   * PENDING_REVIEW or REJECTED (AI_FLAGGED / AI_REJECTED are machine-owned and refused).
   * PENDING_REVIEW means "re-run AI review": a classification job is enqueued in the same
   * transaction (refused when comment moderation is not enabled and enforcing). Writes a HUMAN
   * ledger row {action: SET_STATUS, from, textHash, verdictEventId}. Moving INTO REJECTED or
   * UNPUBLISHED from any other status notifies the author (COMMENT_REJECTED); a move between those
   * two does not. Setting the current status writes no ledger row. PENDING_REVIEW on an
   * already-pending comment with no PENDING or RUNNING job enqueues a classification job.
   */
  moderationSetStatus?: Maybe<Comment>
  /** Oracle AI: Update onboarding settings for the current user */
  onboardingSettingsUpdate: OnboardingSettingsUpdateResponse
  /** Oracle AI: Submit an onboarding step and advance the flow */
  onboardingSubmit: OnboardingSubmitResponse
  /** Oracle AI: Send a message to the AI agent with tool access */
  oracleAgentChat: OracleAgentChatPayload
  /** Oracle AI: Create a new chat session */
  oracleChatSessionCreate: OracleChatSessionCreateResponse
  /** Oracle AI: Delete a chat session */
  oracleChatSessionDelete: OracleChatSessionDeleteResponse
  /** Oracle AI: Update a chat session's favorite status */
  oracleChatSessionFavorite: OracleChatSessionFavoriteResponse
  /** Oracle AI: Rename a chat session */
  oracleChatSessionRename: OracleChatSessionRenameResponse
  /** Oracle AI: Update an existing chat session */
  oracleChatSessionUpdate: OracleChatSessionUpdateResponse
  /** Oracle AI: Generate identity vibe line options from user profile data */
  oracleIdentityVibeGenerate: OracleIdentityVibeGenerateResponse
  /** Oracle AI: Select and save an identity vibe line to the user's profile */
  oracleIdentityVibeSelect: OracleIdentityVibeSelectResponse
  /** Oracle AI: Create or update a scoped LLM config set */
  oracleLlmConfigSetUpsert: OracleLlmConfigSetUpsertResponse
  /** Oracle AI: Create a new individual message */
  oracleMessageCreate: OracleMessageCreateResponse
  /** Oracle AI: Create a new message pair */
  oracleMessagePairCreate: OracleMessagePairCreateResponse
  /** Oracle AI: Delete a message pair */
  oracleMessagePairDelete: OracleMessagePairDeleteResponse
  /** Oracle AI: Regenerate the assistant response for the last turn */
  oracleMessagePairRegenerateLast: OracleMessagePairRegenerateLastResponse
  /** Oracle AI: Create a share ID for a message pair snapshot */
  oracleMessagePairShare: OracleMessagePairShareResponse
  /** Oracle AI: Update an existing message pair */
  oracleMessagePairUpdate: OracleMessagePairUpdateResponse
  /** Oracle AI: Update the mode of an existing message pair */
  oracleMessagePairUpdateMode: OracleMessagePairUpdateResponse
  /** Oracle AI: Select active assistant variant for a message pair */
  oracleMessagePairVariantSelect: OracleMessagePairVariantSelectResponse
  /** Oracle AI: Create a new personality */
  oraclePersonalityCreate: OraclePersonalityCreateResponse
  /** Oracle AI: Delete a personality */
  oraclePersonalityDelete: OraclePersonalityDeleteResponse
  /** Oracle AI: Update an existing personality */
  oraclePersonalityUpdate: OraclePersonalityUpdateResponse
  /** Oracle AI: Save a playlist directly (no agent loop) */
  oraclePlaylistSave: OraclePlaylistSaveResponse
  /** Oracle AI: Create a Prompt Library category */
  oraclePromptLibraryCategoryCreate: OraclePromptLibraryCategoryMutationResponse
  /** Oracle AI: Update a Prompt Library category */
  oraclePromptLibraryCategoryUpdate: OraclePromptLibraryCategoryMutationResponse
  /** Oracle AI: Create a Prompt Library prompt */
  oraclePromptLibraryPromptCreate: OraclePromptLibraryPromptMutationResponse
  /** Oracle AI: Update a Prompt Library prompt */
  oraclePromptLibraryPromptUpdate: OraclePromptLibraryPromptMutationResponse
  /** Oracle AI: Create a Prompt Library theme */
  oraclePromptLibraryThemeCreate: OraclePromptLibraryThemeMutationResponse
  /** Oracle AI: Update a Prompt Library theme */
  oraclePromptLibraryThemeUpdate: OraclePromptLibraryThemeMutationResponse
  /** Oracle AI: Submit thumbs up/down feedback for a search result turn */
  oracleSearchFeedback: OracleSearchFeedbackResponse
  /** Pin a post to the top of its feed (admin or feed moderator) */
  pinCommunityPost?: Maybe<CommunityPost>
  playbackCompanionCreate?: Maybe<PlaybackCompanionMutationPayload>
  playbackCompanionDelete?: Maybe<PlaybackCompanionDeleteResponse>
  playbackCompanionUpdate?: Maybe<PlaybackCompanionMutationPayload>
  /** Create one playlist */
  playlistCreate?: Maybe<PlaylistCreateResponse>
  /** Create one playlist item */
  playlistCreatePlaylistItem?: Maybe<PlaylistCreatePlaylistItemResponse>
  /** Create a playlist with items in a single operation */
  playlistCreateWithItems?: Maybe<PlaylistCreateWithItemsResponse>
  /** Delete one playlist */
  playlistDelete?: Maybe<PlaylistDeleteResponse>
  /** Delete one playlist item */
  playlistDeletePlaylistItem?: Maybe<PlaylistDeletePlaylistItemResponse>
  /** Update one playlist item */
  playlistUpdatePlaylistItem?: Maybe<PlaylistUpdatePlaylistItemResponse>
  /** Create a new PM Screen */
  pmScreenCreate: PmScreenCreateResponse
  /** Delete a PM Screen */
  pmScreenDelete: PmScreenDeleteResponse
  /** Update an existing PM Screen */
  pmScreenUpdate: PmScreenUpdateResponse
  /** Create a new PM Section */
  pmSectionCreate: PmSectionCreateResponse
  /** Delete a PM Section */
  pmSectionDelete: PmSectionDeleteResponse
  /** Update an existing PM Section */
  pmSectionUpdate: PmSectionUpdateResponse
  publishingAgentConfirm: PublishingAgentConfirmResult
  publishingAgentScore: PublishingAgentScoreResult
  publishingAgentTurn: PublishingAgentTurnResult
  /** Record whether work after a check succeeded. Writes the action even when rateLimit.enabled is off, including when the stored check would have been denied. */
  recordRateLimitAction: RecordRateLimitActionResult
  /** Remove a member from a community feed (site admin, or circle admin removing a plain member of their circle) */
  removeCommunityFeedMember?: Maybe<CommunityFeed>
  /** Remove a user's moderator role from a feed (admin only) */
  removeFeedModerator?: Maybe<Scalars['Boolean']['output']>
  /** Renew a user authorization token provided using authorization header */
  renew?: Maybe<LoginRenewResponse>
  /** Reorder the authenticated member's custom (user-N) playlists. System playlists (favorites, watch later, offline, etc.) are ignored if included. Omitted custom playlists are appended at the bottom in their current order. */
  reorderPlaylists?: Maybe<ReorderPlaylistsResponse>
  /** Request AI moderation analysis on content (admin or feed moderator) */
  requestAiModeration?: Maybe<Scalars['Boolean']['output']>
  /** Request a presigned URL for uploading a profile banner image */
  requestBannerImageUpload: BannerImageUploadRequest
  /** Request a presigned URL for uploading a playlist cover photo */
  requestPlaylistCoverPhotoUpload: PlaylistCoverPhotoUploadRequest
  /** Request a presigned URL for uploading a profile picture */
  requestProfilePictureUpload: ProfilePictureUploadRequest
  /** Resolve a moderation report (admin or feed moderator) */
  resolveCommunityModeration?: Maybe<CommunityModerationReport>
  revokeApiKey: ApiKeyMutationResponse
  /** RSVP to an event */
  rsvpToCommunityEvent?: Maybe<CommunityEventRegistrationSummary>
  s3UpsertNdjson?: Maybe<S3UpsertNdjsonResult>
  /** Thumbs feedback on an overview turn (the Brooklyn-native successor to oracleSearchFeedback). */
  searchOverviewFeedback?: Maybe<SearchOverviewFeedbackResponse>
  /** Sync billingProviderProducts with source system */
  syncBillingProviderProducts?: Maybe<SyncBillingProviderProductsResponse>
  transcriptChunkLookupProjectCreate: TranscriptChunkLookupProject
  transcriptChunkLookupProjectDelete: Scalars['Boolean']['output']
  transcriptChunkLookupProjectRequestRawExport: TranscriptChunkLookupProject
  transcriptChunkLookupProjectUpdate: TranscriptChunkLookupProject
  transcriptChunkSessionCreate: TranscriptChunkSession
  transcriptChunkSessionDelete: Scalars['Boolean']['output']
  transcriptChunkSessionSetVisibility: TranscriptChunkSession
  /** Unfollow a playlist */
  unfollowPlaylist?: Maybe<Playlist>
  /** Unpin a post from its feed (admin or feed moderator) */
  unpinCommunityPost?: Maybe<CommunityPost>
  /** Update a billing account */
  updateBillingAccount: BillingAccount
  /** Update a billing discount */
  updateBillingDiscount?: Maybe<BillingDiscount>
  /** Update a billingInvoice */
  updateBillingInvoice?: Maybe<BillingInvoice>
  /** Update a billingOneTimePurchase */
  updateBillingOneTimePurchase?: Maybe<BillingOneTimePurchase>
  /** Update a billingPayment */
  updateBillingPayment?: Maybe<BillingPayment>
  /** Update a billingPaymentMethod */
  updateBillingPaymentMethod?: Maybe<BillingPaymentMethod>
  /** Update a billing plan grid */
  updateBillingPlanGrid?: Maybe<BillingPlanGrid>
  /** Update billingProduct */
  updateBillingProduct?: Maybe<BillingProduct>
  /** Update billingProvider */
  updateBillingProvider?: Maybe<BillingProvider>
  /** Update billingProviderCurrency */
  updateBillingProviderCurrency?: Maybe<BillingProviderCurrency>
  /** Update billingProviderProduct */
  updateBillingProviderProduct?: Maybe<BillingProviderProduct>
  /** Update a plan eligibility rule */
  updateBillingProviderProductEligibility?: Maybe<BillingProviderProductEligibility>
  /** Update a billingProviderProductPricing */
  updateBillingProviderProductPrice?: Maybe<BillingProviderProductPricing>
  /** Update a billingProviderProductText */
  updateBillingProviderProductText?: Maybe<BillingProviderProductText>
  /** Update a billingRefund */
  updateBillingRefund?: Maybe<BillingRefund>
  /** Update a billingSubscription */
  updateBillingSubscription?: Maybe<BillingSubscription>
  /** Update a billingSubscriptionOrder */
  updateBillingSubscriptionOrder?: Maybe<BillingSubscriptionOrder>
  /** Update a BillingSubscriptionOrderPlan */
  updateBillingSubscriptionOrderPlan?: Maybe<BillingSubscriptionOrderPlan>
  /** Update a billingSubscriptionPlan */
  updateBillingSubscriptionPlan?: Maybe<BillingSubscriptionPlan>
  /** Update all billing discounts in a bulk create batch */
  updateBulkBillingDiscount: BillingDiscountBulk
  /** Update an existing event (admin only) */
  updateCommunityEvent?: Maybe<CommunityEvent>
  /** Update a community feed (admin only) */
  updateCommunityFeed?: Maybe<CommunityFeed>
  /** Update a member's role in a community feed (admin only) */
  updateCommunityFeedMemberRole?: Maybe<Scalars['Boolean']['output']>
  /** Update a community post or comment */
  updateCommunityPost?: Maybe<CommunityPost>
  /** Update network-wide allowed reactions (admin only) */
  updateCommunityReactionSettings?: Maybe<Scalars['Boolean']['output']>
  /** Update a custom emoji (Admin only) */
  updateCustomEmoji: CustomEmoji
  /** Update allowed reactions for a specific feed (admin only) */
  updateFeedAllowedReactions?: Maybe<CommunityFeed>
  /** Update a playlist's name and/or description */
  updatePlaylist?: Maybe<PlaylistUpdateResponse>
  /** Update the visibility of a playlist */
  updatePlaylistVisibility?: Maybe<PlaylistUpdateVisibilityResponse>
  /** Update the per-action config. Not gated by rateLimit.enabled or rateLimit.verifyFingerprint. */
  updateRateLimitActionConfig: RateLimitActionConfig
  /** Update an allow or block override. Not gated by rateLimit.enabled. */
  updateRateLimitOverride: RateLimitOverride
  /** Update a rate-limit rule. Not gated by rateLimit.enabled. */
  updateRateLimitRule: RateLimitRule
  /** Update a raw event */
  updateRawEvent?: Maybe<RawEvent>
  /** Update a transactions */
  updateTransaction?: Maybe<Transaction>
  /** Update a userAuditLog */
  updateUserAuditLog?: Maybe<UserAuditLog>
  /**
   * Update a user entitlement. Can modify start/end dates, content set, or other fields.
   * Used for extending access, changing content sets, or correcting entitlement data.
   * Requires elevated role access.
   */
  updateUserEntitlement?: Maybe<UserEntitlement>
  /** Upload or update a feed image (admin only) */
  uploadFeedImage: FeedImageUploadResult
  /** Update the current user's profile info (username, names, name visibility) */
  userInfoUpdate: UserInfoUpdateResponse
  /** Update a profile's first and last name (account owner only) */
  userInfoUpdateProfile: UserInfoUpdateResponse
  /** Replace or merge roles on an account owner. Does not edit UserRole row fields. */
  userInfoUpdateRoles: UserInfoUpdateResponse
  /** Creates or updates learner level rows. Any authenticated user may call; rows are keyed to the JWT user unless an elevated role supplies uid on each input item. */
  userLearnerLevelCreateOrUpdate: UserLearnerLevelMutationResult
  userLearnerLevelDelete: UserLearnerLevelDeleteResult
  /** Create one user meta tag row */
  userMetaTagCreate?: Maybe<UserMetaTagCreateResponse>
  /**
   * Create many user meta tags for one source (upsert semantics).
   * Removes stale rows for the same source and uids not included in the input.
   */
  userMetaTagCreateMany?: Maybe<UserMetaTagCreateManyResponse>
  /** Delete one user meta tag row by id */
  userMetaTagDelete?: Maybe<UserMetaTagDeleteResponse>
  /** Resolve and persist the best available rainbow category defaults for one user */
  userMetaTagEnsureDefaults?: Maybe<UserMetaTagEnsureDefaultsResponse>
  /** Resolve defaults for many users (same resolution order as userMetaTagEnsureDefaults) */
  userMetaTagEnsureDefaultsMany: Array<UserMetaTagEnsureDefaultsResponse>
  /**
   * Create or update user metadata entries. Site admins may write any rows; a
   * regular authenticated viewer may write ONLY their own uid's preference-type
   * rows, with row-count/value-size guards (enforced in the resolver, so the
   * directive gates authentication only).
   */
  userMetadataCreateOrUpdate: UserMetadataMutationResult
  /** Admin: update any user's profile by UID */
  userProfileAdminUpdate?: Maybe<UserProfileUpdateResponse>
  /** Follow a user */
  userProfileFollow?: Maybe<UserProfileFollowResponse>
  /** Unfollow a user */
  userProfileUnfollow?: Maybe<UserProfileFollowResponse>
  /** Update the current user's profile (creates on first use) */
  userProfileUpdate?: Maybe<UserProfileUpdateResponse>
  /** Create or update user state entries */
  userStateCreateOrUpdate: Array<UserState>
  /** Delete a user state entry */
  userStateDelete: Scalars['Boolean']['output']
  /** Create one worker */
  workerCreate: WorkerMutationResponse
  /** Delete one worker the id or name in the input is used to select the worker */
  workerDelete: WorkerMutationResponse
  /** Update one worker */
  workerUpdate: WorkerMutationResponse
}

/** Oracle AI: Root mutation operations */
export type MutationAddCommunityFeedMemberArgs = {
  feedId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAgentEnhancementsHubCreateArgs = {
  input: AgentEnhancementsHubCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAgentEnhancementsHubResolveEnhancementArgs = {
  input: AgentEnhancementsHubResolveEnhancementInput
}

/** Oracle AI: Root mutation operations */
export type MutationAgentEnhancementsHubUpdateArgs = {
  input: AgentEnhancementsHubUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAiGuideChatArgs = {
  input: AiGuideChatInput
}

/** Oracle AI: Root mutation operations */
export type MutationAmbassadorLeadsUploadNdJsonToS3Args = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  s3Params: AmbassadorLeadsS3Input
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

/** Oracle AI: Root mutation operations */
export type MutationAssetDeleteArgs = {
  input: AssetDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationAssignFeedModeratorArgs = {
  feedId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAssignToCircleArgs = {
  rainbowCategoryKey: Scalars['Int']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAttachClipCaptionsFromBrightcovePlaylistArgs = {
  defaults: ClipImportSharedDefaultsInput
  onlyBrightcoveVideoIds?: InputMaybe<Array<Scalars['String']['input']>>
  playlistId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAttachClipPostersFromBrightcovePlaylistArgs = {
  defaults: ClipImportSharedDefaultsInput
  onlyBrightcoveVideoIds?: InputMaybe<Array<Scalars['String']['input']>>
  playlistId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleCreateArgs = {
  authRole: AuthRoleCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleDeleteArgs = {
  authRole: AuthRoleDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthRoleUpdateArgs = {
  authRole: AuthRoleUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthScopeCreateArgs = {
  authScope: AuthScopeCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthScopeDeleteArgs = {
  authScope: AuthScopeDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationAuthScopeUpdateArgs = {
  authScope: AuthScopeUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingCheckoutRequestAttributionParamCreateArgs = {
  param: BillingCheckoutRequestAttributionParamCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingCheckoutRequestAttributionParamDeleteArgs = {
  param: BillingCheckoutRequestAttributionParamDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingCheckoutRequestAttributionParamUpdateArgs = {
  param: BillingCheckoutRequestAttributionParamUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingCreateEventArgs = {
  input: BillingEventCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationBillingUpdateEventArgs = {
  input: BillingEventUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCancelRsvpToCommunityEventArgs = {
  eventId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetCreateArgs = {
  input: ChannelPromptSetCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetReplaceSectionsArgs = {
  input: ChannelPromptSetReplaceSectionsInput
}

/** Oracle AI: Root mutation operations */
export type MutationChannelPromptSetUpdateStatusArgs = {
  input: ChannelPromptSetStatusInput
}

/** Oracle AI: Root mutation operations */
export type MutationClipCreateArgs = {
  clip: ClipCreateInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationClipImportFromBrightcovePlaylistArgs = {
  defaults: ClipImportSharedDefaultsInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
  importTextTracks?: InputMaybe<Scalars['Boolean']['input']>
  onlyBrightcoveVideoIds?: InputMaybe<Array<Scalars['String']['input']>>
  perVideoParentOverrides?: InputMaybe<Array<ClipImportPerVideoParentInput>>
  playlistId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationClipImportFromSocialManifestArgs = {
  defaults: ClipImportSharedDefaultsInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
  retryFailedIngests?: InputMaybe<Scalars['Boolean']['input']>
  rows: Array<ClipSocialManifestRowInput>
}

/** Oracle AI: Root mutation operations */
export type MutationClipSocialStageCompleteArgs = {
  items: Array<ClipSocialStageCompleteItemInput>
}

/** Oracle AI: Root mutation operations */
export type MutationClipSocialStagePrepareArgs = {
  input: ClipSocialStagePrepareInput
}

/** Oracle AI: Root mutation operations */
export type MutationCommentCreateArgs = {
  input: CommentCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCommentDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCommentReactionCreateArgs = {
  id: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCommentReactionDeleteArgs = {
  id: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCommentReportArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCommentUpdateArgs = {
  input: CommentUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationConfirmBannerImageUploadArgs = {
  imageExtension: Scalars['String']['input']
  imageUuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationConfirmPlaylistCoverPhotoUploadArgs = {
  imageExtension: Scalars['String']['input']
  imageUuid: Scalars['ID']['input']
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationConfirmProfilePictureUploadArgs = {
  imageExtension: Scalars['String']['input']
  imageUuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationConsumeDiscountArgs = {
  input: ConsumeDiscountInput
}

/** Oracle AI: Root mutation operations */
export type MutationConsumeRateLimitTokenArgs = {
  input: ConsumeRateLimitTokenInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAnonCreateArgs = {
  input: ContentAnonCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAnonDeleteArgs = {
  input: ContentAnonDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAnonUpdateArgs = {
  input: ContentAnonUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceCreateArgs = {
  contentAssetReference: ContentAssetReferenceCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentAssetReferenceDeleteArgs = {
  contentAssetReference: ContentAssetReferenceDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentCreateArgs = {
  content: ContentInput
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationContentCreateLanguageTranslationArgs = {
  contentId: Scalars['Int']['input']
  contentType: Scalars['String']['input']
  language: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaCreateArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentListCriteriaDeleteArgs = {
  contentListCriteria?: InputMaybe<ContentListCriteriaDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderCreateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderCreateByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderDeleteByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderDeleteByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentProviderUpdateByContentIdArgs = {
  contentProvider?: InputMaybe<ContentProviderUpdateByContentIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateArgs = {
  contentReference?: InputMaybe<ContentReferenceCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceCreateManyArgs = {
  contentReferences: Array<ContentReferenceCreateInput>
  deleteOmittedReferences?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationContentReferenceDeleteArgs = {
  contentReference?: InputMaybe<ContentReferenceDeleteInput>
}

/** Oracle AI: Root mutation operations */
export type MutationContentRepublishArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>
  where: ContentRepublishWhereInput
}

/** Oracle AI: Root mutation operations */
export type MutationContentUpdateArgs = {
  content?: InputMaybe<ContentInput>
  generatePath?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCourseMarkCompleteArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseModuleMarkCompleteArgs = {
  courseModuleTitleGroupId: Scalars['String']['input']
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseResetArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCourseStartArgs = {
  courseTitleGroupId: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingDiscountArgs = {
  input: CreateBillingDiscountInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingInvoiceArgs = {
  input: BillingInvoiceCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentArgs = {
  input: BillingPaymentCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingPlanGridArgs = {
  input?: InputMaybe<CreateBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductArgs = {
  input: CreateBillingProductInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProductChangeLogArgs = {
  input: BillingProductChangeLogInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderArgs = {
  input: CreateBillingProviderInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderCurrencyArgs = {
  billingProviderCurrency: BillingProviderCurrencyInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductArgs = {
  billingProviderProduct: BillingProviderProductInput
  billingProviderProductPrices?: InputMaybe<Array<InputMaybe<BillingProviderProductPriceInput>>>
  billingProviderProductText?: InputMaybe<Array<InputMaybe<BillingProviderProductTextInput>>>
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductEligibilityArgs = {
  input: CreateBillingProviderProductEligibilityInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingCreateInput
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingRefundArgs = {
  input: BillingRefundCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionArgs = {
  input: BillingSubscriptionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateBulkBillingDiscountArgs = {
  input: CreateBulkBillingDiscountInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityEventArgs = {
  feedId: Scalars['ID']['input']
  input: CreateCommunityEventInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  feedType?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug?: InputMaybe<Scalars['String']['input']>
  topicContentId?: InputMaybe<Scalars['Int']['input']>
  visibility?: InputMaybe<FeedVisibility>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityPostArgs = {
  content: Scalars['String']['input']
  feedId: Scalars['ID']['input']
  metadata?: InputMaybe<Scalars['JSON']['input']>
  parentId?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCommunityReactionArgs = {
  postId: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationCreateCustomEmojiArgs = {
  input: CreateCustomEmojiInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateRateLimitActionConfigArgs = {
  input: CreateRateLimitActionConfigInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateRateLimitOverrideArgs = {
  input: CreateRateLimitOverrideInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateRateLimitRequestArgs = {
  input: CreateRateLimitRequestInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateRateLimitRuleArgs = {
  input: CreateRateLimitRuleInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateTransactionArgs = {
  input: TransactionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateUserAuditLogArgs = {
  input: UserAuditLogCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationCreateUserEntitlementArgs = {
  input: UserEntitlementCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingPlanGridArgs = {
  input?: InputMaybe<DeleteBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductEligibilityArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductPriceArgs = {
  id: Scalars['ID']['input']
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteBillingProviderProductTextArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityEventArgs = {
  eventId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityFeedArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityPostArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCommunityReactionArgs = {
  postId: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteCustomEmojiArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteFeedImageArgs = {
  feedId: Scalars['ID']['input']
  imageType: FeedImageType
}

/** Oracle AI: Root mutation operations */
export type MutationDeletePlaylistCoverPhotoArgs = {
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteRateLimitActionConfigArgs = {
  uuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteRateLimitOverrideArgs = {
  uuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDeleteRateLimitRuleArgs = {
  uuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationDiscountCodeCreateArgs = {
  input: DiscountCodeCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationDreamCreateArgs = {
  input: DreamCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationDreamInterpretationArgs = {
  input: DreamInterpretationInput
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityCreateArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityDeleteByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityDeleteByIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingBonusEligibilityUpdateByIdArgs = {
  ecommerceSkuMappingBonusEligibility?: InputMaybe<EcommerceSkuMappingBonusEligibilityUpdateByIdInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingCreateArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingCreateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEcommerceSkuMappingUpdateByProviderAndEcommerceSkuArgs = {
  ecommerceSkuMapping?: InputMaybe<EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput>
}

/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigCreateArgs = {
  input: EmbeddingConfigCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationEmbeddingConfigUpdateArgs = {
  input: EmbeddingConfigUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationEventLogArgs = {
  input: EventLogInput
}

/** Oracle AI: Root mutation operations */
export type MutationFlagCommunityContentArgs = {
  contentId: Scalars['ID']['input']
  reason?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationFlagWatchedVideoArgs = {
  hiddenByUser: Scalars['Boolean']['input']
  videoId: Scalars['Int']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationFollowPlaylistArgs = {
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationGiftCardConsumeArgs = {
  giftCardCode: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationGiftCardDebitArgs = {
  amount: Scalars['String']['input']
  giftCardId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationImportRateLimitActionsArgs = {
  actions: Array<ImportRateLimitActionInput>
}

/** Oracle AI: Root mutation operations */
export type MutationImportRateLimitOverridesArgs = {
  overrides: Array<ImportRateLimitOverrideInput>
}

/** Oracle AI: Root mutation operations */
export type MutationImportRateLimitRequestsArgs = {
  requests: Array<ImportRateLimitRequestInput>
}

/** Oracle AI: Root mutation operations */
export type MutationInviteToCircleArgs = {
  feedId: Scalars['ID']['input']
  userUuid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationJoinCommunityFeedArgs = {
  feedId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationLeaveCommunityFeedArgs = {
  feedId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationLocalizationStringCreateArgs = {
  input: LocalizationStringCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationLocalizationStringDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationLocalizationStringUpdateArgs = {
  input: LocalizationStringUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationLoginArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  cookie?: InputMaybe<LoginRenewCookieInput>
  device?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  password?: InputMaybe<Scalars['String']['input']>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationMarkCommunityFeedReadArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>
  feedId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAdCreateArgs = {
  input: MarketingAdCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAdGroupCreateArgs = {
  input: MarketingAdGroupCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAdTargetingIngestTickArgs = {
  input: MarketingAdTargetingIngestTickInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAdUpdateUtmArgs = {
  input: MarketingAdUpdateUtmInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAgentConfirmArgs = {
  input: MarketingAgentConfirmInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAgentScoreArgs = {
  input: MarketingAgentScoreInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAgentTurnArgs = {
  input: MarketingAgentTurnInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAirCreativeMutateArgs = {
  input: MarketingAirCreativeMutateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingAirCreativePublishArgs = {
  input: MarketingAirCreativePublishInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingCampaignAssetCreateArgs = {
  input: MarketingCampaignAssetCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingCampaignCreateArgs = {
  input: MarketingCampaignCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingCampaignUpdateArgs = {
  input: MarketingCampaignUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingCreativeGenerationJobDeleteArgs = {
  input: MarketingCreativeGenerationJobDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingCreativeGenerationJobStartArgs = {
  input: MarketingCreativeGenerationJobStartInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingIngestionPhaseResetArgs = {
  input: MarketingIngestionPhaseResetInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingKeywordCreateArgs = {
  input: MarketingKeywordCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingKeywordUpdateArgs = {
  input: MarketingKeywordUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingLandingPageMutateArgs = {
  input: MarketingLandingPageMutateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingMessagingCampaignUpsertArgs = {
  input: MarketingMessagingCampaignUpsertInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingMessagingContentUpsertArgs = {
  input: MarketingMessagingContentUpsertInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingMessagingTemplateUpsertArgs = {
  input: MarketingMessagingTemplateUpsertInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingMessagingTriggerSendArgs = {
  input: MarketingMessagingTriggerSendInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportCancelArgs = {
  input: MarketingReportCancelInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportCreateArgs = {
  input: MarketingReportCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportDeleteArgs = {
  input: MarketingReportDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportExclusionCreateArgs = {
  input: MarketingReportExclusionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportExclusionDeleteArgs = {
  input: MarketingReportExclusionDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportExclusionUpdateArgs = {
  input: MarketingReportExclusionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportRunArgs = {
  input: MarketingReportRunInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingReportUpdateArgs = {
  input: MarketingReportUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingResearchJobDeleteArgs = {
  input: MarketingResearchJobDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingResearchJobStartArgs = {
  input: MarketingResearchJobStartInput
}

/** Oracle AI: Root mutation operations */
export type MutationMarketingTrackingTemplateUpdateArgs = {
  input: MarketingTrackingTemplateUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationMediaAssetRequestMezzanineRestoreArgs = {
  mediaAssetId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationMediaCreateArgs = {
  media: MediaInput
}

/** Oracle AI: Root mutation operations */
export type MutationMediaPreviewStartUpdateArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  startSeconds: Scalars['Int']['input']
  where: MediaPreviewStartWhereInput
}

/** Oracle AI: Root mutation operations */
export type MutationModerationResolveArgs = {
  action: ModerationResolveAction
  itemId: Scalars['ID']['input']
  surface: ModerationSurface
}

/** Oracle AI: Root mutation operations */
export type MutationModerationSetStatusArgs = {
  itemId: Scalars['ID']['input']
  status: CommentStatus
  surface: ModerationSurface
}

/** Oracle AI: Root mutation operations */
export type MutationOnboardingSettingsUpdateArgs = {
  input: OnboardingSettingsUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOnboardingSubmitArgs = {
  input: OnboardingSubmitInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionCreateArgs = {
  input: OracleChatSessionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionFavoriteArgs = {
  input: OracleChatSessionFavoriteInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionRenameArgs = {
  input: OracleChatSessionRenameInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleChatSessionUpdateArgs = {
  input: OracleChatSessionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleIdentityVibeGenerateArgs = {
  input?: InputMaybe<OracleIdentityVibeGenerateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationOracleIdentityVibeSelectArgs = {
  input: OracleIdentityVibeSelectInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleLlmConfigSetUpsertArgs = {
  input: OracleLlmConfigSetUpsertInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessageCreateArgs = {
  input: OracleMessageCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairCreateArgs = {
  input: OracleMessagePairCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairRegenerateLastArgs = {
  input: OracleMessagePairRegenerateLastInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairShareArgs = {
  input: OracleMessagePairShareInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateArgs = {
  id: Scalars['ID']['input']
  input: OracleMessagePairUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairUpdateModeArgs = {
  id: Scalars['ID']['input']
  mode: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOracleMessagePairVariantSelectArgs = {
  input: OracleMessagePairVariantSelectInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityCreateArgs = {
  input: OraclePersonalityCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePersonalityUpdateArgs = {
  input: OraclePersonalityUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePlaylistSaveArgs = {
  input: OraclePlaylistSaveInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryCategoryCreateArgs = {
  input: OraclePromptLibraryCategoryCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryCategoryUpdateArgs = {
  input: OraclePromptLibraryCategoryUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryPromptCreateArgs = {
  input: OraclePromptLibraryPromptCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryPromptUpdateArgs = {
  input: OraclePromptLibraryPromptUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryThemeCreateArgs = {
  input: OraclePromptLibraryThemeCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOraclePromptLibraryThemeUpdateArgs = {
  input: OraclePromptLibraryThemeUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationOracleSearchFeedbackArgs = {
  input: OracleSearchFeedbackInput
}

/** Oracle AI: Root mutation operations */
export type MutationPinCommunityPostArgs = {
  postId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPlaybackCompanionCreateArgs = {
  input: PlaybackCompanionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPlaybackCompanionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPlaybackCompanionUpdateArgs = {
  input: PlaybackCompanionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreateArgs = {
  playlist?: InputMaybe<PlaylistCreatePlaylistInput>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreatePlaylistItemArgs = {
  createPlaylistIfNotExist?: InputMaybe<Scalars['Boolean']['input']>
  playlist?: InputMaybe<PlaylistCreatePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistCreatePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistCreateWithItemsArgs = {
  items: Array<PlaylistCreateWithItemsItemInput>
  playlist?: InputMaybe<PlaylistCreatePlaylistInput>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeleteArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistInput>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistDeletePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistDeletePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistDeletePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPlaylistUpdatePlaylistItemArgs = {
  playlist?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistInput>
  playlistItem?: InputMaybe<PlaylistUpdatePlaylistItemPlaylistItemInput>
  reorderPlaylist?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenCreateArgs = {
  pmScreen: PmScreenCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPmScreenUpdateArgs = {
  pmScreen: PmScreenUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionCreateArgs = {
  pmSection: PmSectionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationPmSectionUpdateArgs = {
  pmSection: PmSectionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationPublishingAgentConfirmArgs = {
  input: PublishingAgentConfirmInput
}

/** Oracle AI: Root mutation operations */
export type MutationPublishingAgentScoreArgs = {
  input: PublishingAgentScoreInput
}

/** Oracle AI: Root mutation operations */
export type MutationPublishingAgentTurnArgs = {
  input: PublishingAgentTurnInput
}

/** Oracle AI: Root mutation operations */
export type MutationRecordRateLimitActionArgs = {
  input: RecordRateLimitActionInput
}

/** Oracle AI: Root mutation operations */
export type MutationRemoveCommunityFeedMemberArgs = {
  feedId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRemoveFeedModeratorArgs = {
  feedId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRenewArgs = {
  clientAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  cookie?: InputMaybe<LoginRenewCookieInput>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  logUserAccountOutOfAllDevices?: InputMaybe<Scalars['Boolean']['input']>
  logUserOutOfAllDevices?: InputMaybe<Scalars['Boolean']['input']>
  refreshToken?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationReorderPlaylistsArgs = {
  playlistIds: Array<Scalars['ID']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationRequestAiModerationArgs = {
  contentId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRequestBannerImageUploadArgs = {
  fileExtension: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRequestPlaylistCoverPhotoUploadArgs = {
  fileExtension: Scalars['String']['input']
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRequestProfilePictureUploadArgs = {
  fileExtension: Scalars['String']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationResolveCommunityModerationArgs = {
  action: ModerationAction
  note?: InputMaybe<Scalars['String']['input']>
  reportId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationRsvpToCommunityEventArgs = {
  eventId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationS3UpsertNdjsonArgs = {
  s3UpsertNdjsonInput: S3UpsertNdjsonInput
}

/** Oracle AI: Root mutation operations */
export type MutationSearchOverviewFeedbackArgs = {
  thumbsValue: Scalars['String']['input']
  turnId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkLookupProjectCreateArgs = {
  input: TranscriptChunkLookupProjectCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkLookupProjectDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkLookupProjectRequestRawExportArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>
  projectId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkLookupProjectUpdateArgs = {
  id: Scalars['ID']['input']
  input: TranscriptChunkLookupProjectUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkSessionCreateArgs = {
  input: TranscriptChunkSessionCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkSessionDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationTranscriptChunkSessionSetVisibilityArgs = {
  id: Scalars['ID']['input']
  isPublic: Scalars['Boolean']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUnfollowPlaylistArgs = {
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUnpinCommunityPostArgs = {
  postId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingAccountArgs = {
  input?: InputMaybe<BillingAccountUpdateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingDiscountArgs = {
  input: UpdateBillingDiscountInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingInvoiceArgs = {
  input: BillingInvoiceUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingOneTimePurchaseArgs = {
  input: BillingOneTimePurchaseUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentArgs = {
  input: BillingPaymentUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPaymentMethodArgs = {
  input: BillingPaymentMethodUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingPlanGridArgs = {
  input?: InputMaybe<UpdateBillingPlanGridInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProductArgs = {
  input: UpdateBillingProductInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderArgs = {
  input: UpdateBillingProviderInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderCurrencyArgs = {
  input: BillingProviderCurrencyUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductArgs = {
  createBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductPricingCreateInput>>
  >
  createBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductTextCreateInput>>
  >
  deleteBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductDeleteByIdInput>>
  >
  deleteBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductDeleteByIdInput>>
  >
  input: BillingProviderProductUpdateInput
  skipProviderSync?: InputMaybe<Scalars['Boolean']['input']>
  updateBillingProviderProductPrices?: InputMaybe<
    Array<InputMaybe<BillingProviderProductPricingUpdateInput>>
  >
  updateBillingProviderProductText?: InputMaybe<
    Array<InputMaybe<BillingProviderProductTextUpdateInput>>
  >
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductEligibilityArgs = {
  input: UpdateBillingProviderProductEligibilityInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductPriceArgs = {
  input: BillingProviderProductPricingUpdateInput
  updateProvider?: InputMaybe<Scalars['Boolean']['input']>
  updateRelatedBillingProviderProducts?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingProviderProductTextArgs = {
  input: BillingProviderProductTextUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingRefundArgs = {
  input: BillingRefundUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionArgs = {
  input: BillingSubscriptionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderArgs = {
  input: BillingSubscriptionOrderUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionOrderPlanArgs = {
  input: BillingSubscriptionOrderPlanUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBillingSubscriptionPlanArgs = {
  input: BillingSubscriptionPlanUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateBulkBillingDiscountArgs = {
  input: UpdateBulkBillingDiscountInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityEventArgs = {
  eventId: Scalars['ID']['input']
  input: UpdateCommunityEventInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  feedType?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<FeedVisibility>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityFeedMemberRoleArgs = {
  feedId: Scalars['ID']['input']
  roleType: FeedRoleType
  userId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityPostArgs = {
  content?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCommunityReactionSettingsArgs = {
  allowedReactions: Array<Scalars['String']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateCustomEmojiArgs = {
  input: UpdateCustomEmojiInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateFeedAllowedReactionsArgs = {
  allowedReactions: Array<Scalars['String']['input']>
  feedId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdatePlaylistArgs = {
  input: PlaylistUpdateInput
  playlistId: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUpdatePlaylistVisibilityArgs = {
  playlistId: Scalars['ID']['input']
  visibility: PlaylistVisibility
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateRateLimitActionConfigArgs = {
  input: UpdateRateLimitActionConfigInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateRateLimitOverrideArgs = {
  input: UpdateRateLimitOverrideInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateRateLimitRuleArgs = {
  input: UpdateRateLimitRuleInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateRawEventArgs = {
  input: RawEventUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateTransactionArgs = {
  input: TransactionUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateUserAuditLogArgs = {
  input: UserAuditLogUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUpdateUserEntitlementArgs = {
  input: UserEntitlementUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUploadFeedImageArgs = {
  input: UploadFeedImageInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserInfoUpdateArgs = {
  input: UserInfoUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserInfoUpdateProfileArgs = {
  input: UserInfoUpdateProfileInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserInfoUpdateRolesArgs = {
  input: UserInfoUpdateRolesInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserLearnerLevelCreateOrUpdateArgs = {
  input: Array<UserLearnerLevelInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserLearnerLevelDeleteArgs = {
  tagContentContentId: Scalars['Int']['input']
  uid: Scalars['Int']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetaTagCreateArgs = {
  input: UserMetaTagCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetaTagCreateManyArgs = {
  source: UserMetaTagSource
  tags: Array<UserMetaTagCreateManyTagInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetaTagDeleteArgs = {
  id: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetaTagEnsureDefaultsArgs = {
  uid: Scalars['Int']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetaTagEnsureDefaultsManyArgs = {
  uids: Array<Scalars['Int']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationUserMetadataCreateOrUpdateArgs = {
  input: Array<UserMetadataInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserProfileAdminUpdateArgs = {
  input: UserProfileUpdateInput
  uid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserProfileFollowArgs = {
  uid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserProfileUnfollowArgs = {
  uid: Scalars['ID']['input']
}

/** Oracle AI: Root mutation operations */
export type MutationUserProfileUpdateArgs = {
  input: UserProfileUpdateInput
}

/** Oracle AI: Root mutation operations */
export type MutationUserStateCreateOrUpdateArgs = {
  input: Array<UserStateInput>
}

/** Oracle AI: Root mutation operations */
export type MutationUserStateDeleteArgs = {
  parentContentTitleGroupId: Scalars['String']['input']
  progressItemId: Scalars['String']['input']
  progressItemType: UserStateProgressItemType
  userUid?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerCreateArgs = {
  worker: WorkerCreateInput
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerDeleteArgs = {
  worker: WorkerDeleteInput
}

/** Oracle AI: Root mutation operations */
export type MutationWorkerUpdateArgs = {
  create?: InputMaybe<Scalars['Boolean']['input']>
  worker: WorkerUpdateInput
}

/** Response for user subscriptions list */
export type NotificationsSubscriptionsListResponse = {
  __typename?: 'NotificationsSubscriptionsListResponse'
  /** Total count matching the filter */
  count?: Maybe<Scalars['Int']['output']>
  /** List of user subscriptions (user → content relationships) */
  notificationsSubscriptions: Array<UserSubscriptionRow>
}

/** Boolean filter */
export type NotificationsSubscriptionsListWhereBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** ID filter */
export type NotificationsSubscriptionsListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Where input for user subscriptions list */
export type NotificationsSubscriptionsListWhereInput = {
  /** Filter by content ID */
  contentId?: InputMaybe<NotificationsSubscriptionsListWhereIntInput>
  /** Filter by content type */
  contentType?: InputMaybe<NotificationsSubscriptionsListWhereStringInput>
  /** Filter by subscriber row ID */
  id?: InputMaybe<NotificationsSubscriptionsListWhereIdInput>
  /** Filter by inactive status */
  inactive?: InputMaybe<NotificationsSubscriptionsListWhereBooleanInput>
  /** Filter by subscription type (teacher, series, host) */
  type?: InputMaybe<NotificationsSubscriptionsListWhereStringInput>
  /** Filter by user UID */
  uid?: InputMaybe<NotificationsSubscriptionsListWhereIntInput>
}

/** Int filter */
export type NotificationsSubscriptionsListWhereIntInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** String filter */
export type NotificationsSubscriptionsListWhereStringInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Oracle AI: Input for nudge and suggestion search */
export type NudgeAndSuggestionInput = {
  lowWeightCategories: Array<Scalars['String']['input']>
  queries: Array<Scalars['String']['input']>
  userFeedIds: Array<Scalars['String']['input']>
}

/** Oracle AI: Nudge and suggestion result */
export type NudgeAndSuggestionResult = {
  __typename?: 'NudgeAndSuggestionResult'
  nudgePost?: Maybe<NudgePost>
  pickedPost?: Maybe<PickedPost>
  suggestedFeed?: Maybe<SuggestedFeed>
}

/** Oracle AI: A post from an unjoined feed for nudging */
export type NudgePost = {
  __typename?: 'NudgePost'
  feedId: Scalars['String']['output']
  feedName: Scalars['String']['output']
  feedSlug: Scalars['String']['output']
  headline: Scalars['String']['output']
  postId: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** OAuth2/OIDC client */
export type OAuthClient = {
  __typename?: 'OAuthClient'
  /** Unique OAuth2 client identifier */
  clientId?: Maybe<Scalars['String']['output']>
  /** Human-readable client name */
  clientName?: Maybe<Scalars['String']['output']>
  /** Client homepage URL */
  clientUri?: Maybe<Scalars['String']['output']>
  /** Array of contact email addresses */
  contacts?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Array of supported grant types */
  grantTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The primary identifier for this record (UUID v4) */
  id?: Maybe<Scalars['ID']['output']>
  /** Client logo URL */
  logoUri?: Maybe<Scalars['String']['output']>
  /** Privacy policy URI */
  policyUri?: Maybe<Scalars['String']['output']>
  /** Array of allowed redirect URIs */
  redirectUris?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Array of supported response types */
  responseTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Default scopes for the client */
  scope?: Maybe<Scalars['String']['output']>
  /** Authentication method for token endpoint */
  tokenEndpointAuthMethod?: Maybe<Scalars['String']['output']>
  /** Terms of service URI */
  tosUri?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** OAuth client list response */
export type OAuthClientListResponse = {
  __typename?: 'OAuthClientListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** A list of OAuth clients */
  oauthClients?: Maybe<Array<Maybe<OAuthClient>>>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
}

/** OAuth client clientId type where input type */
export type OAuthClientListWhereClientIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** OAuth client id type where input type */
export type OAuthClientListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** OAuth client where conditions to filter rows */
export type OAuthClientListWhereInput = {
  /** The clientId field where clause */
  clientId?: InputMaybe<OAuthClientListWhereClientIdInput>
  /** The id field where clause */
  id?: InputMaybe<OAuthClientListWhereIdInput>
}

/** One joinable circle offered by discovery (final onboarding screen + nav menu) — beta 2: one option per open roster circle */
export type OnboardingCircleOption = {
  __typename?: 'OnboardingCircleOption'
  /** Circle capacity — the member count at which the circle is full */
  capacity: Scalars['Int']['output']
  /** The circle's own one-sentence purpose statement */
  description: Scalars['String']['output']
  /** Current member count of the circle */
  memberCount: Scalars['Int']['output']
  /** The circle's own display name */
  name: Scalars['String']['output']
  /** The circle's roster key (mixed rooms 11-92, tenured rooms >= 100; legacy category keys 1-9 during the transition) — the assignToCircle input */
  rainbowCategoryKey: Scalars['Int']['output']
}

export type OnboardingSettings = {
  __typename?: 'OnboardingSettings'
  /** Birth city */
  birthCity?: Maybe<Scalars['String']['output']>
  /** Birth date (MM/DD/YYYY) */
  birthDate?: Maybe<Scalars['String']['output']>
  /** Birth state */
  birthState?: Maybe<Scalars['String']['output']>
  /** Birth time (24hr HH:MM) */
  birthTime?: Maybe<Scalars['String']['output']>
  /** Interest topic keys */
  interestTopics?: Maybe<Array<Scalars['String']['output']>>
  /** Answers for 'make it interesting' section */
  interestingAnswers?: Maybe<InterestingAnswers>
  /** Life goals */
  lifeGoals?: Maybe<Scalars['String']['output']>
  /** Life journey */
  lifeJourney?: Maybe<Scalars['String']['output']>
  /** Preferred response style */
  responseStyle?: Maybe<Scalars['String']['output']>
  /** Return to last conversation when true */
  returnLastConversation: Scalars['Boolean']['output']
  /** Freeform text the user wants to share */
  shareAnything?: Maybe<Scalars['String']['output']>
  /** Whether the persona-select dialog should be shown (true when it has never been shown) */
  shouldShowPersonaSelect: Scalars['Boolean']['output']
}

export type OnboardingSettingsUpdateInput = {
  /** Have you had an alien encounter? */
  alienEncounter?: InputMaybe<Scalars['Boolean']['input']>
  /** Do you think we're alone in the universe? */
  aloneInUniverse?: InputMaybe<Scalars['Boolean']['input']>
  /** If a spacecraft landed in front of you, would you approach it? */
  approachSpacecraft?: InputMaybe<Scalars['Boolean']['input']>
  /** Birth city */
  birthCity?: InputMaybe<Scalars['String']['input']>
  /** Birth date (MM/DD/YYYY) */
  birthDate?: InputMaybe<Scalars['String']['input']>
  /** Birth state */
  birthState?: InputMaybe<Scalars['String']['input']>
  /** Birth time (24hr HH:MM) */
  birthTime?: InputMaybe<Scalars['String']['input']>
  /** Do you think deja vu is a clue or a glitch? (true=yes) */
  dejaVuBelief?: InputMaybe<Scalars['Boolean']['input']>
  /** Interest topic keys */
  interestTopics?: InputMaybe<Array<Scalars['String']['input']>>
  /** Would you describe yourself as intuitive? */
  isIntuitive?: InputMaybe<Scalars['Boolean']['input']>
  /** Life goals */
  lifeGoals?: InputMaybe<Scalars['String']['input']>
  /** Life journey */
  lifeJourney?: InputMaybe<Scalars['String']['input']>
  /** When true, records that the persona-select dialog was shown (sets personaSelectLastShown to now) */
  personaSelectShown?: InputMaybe<Scalars['Boolean']['input']>
  /** Preferred response style */
  responseStyle?: InputMaybe<Scalars['String']['input']>
  /** Return to last conversation when true */
  returnLastConversation?: InputMaybe<Scalars['Boolean']['input']>
  /** Freeform text the user wants to share */
  shareAnything?: InputMaybe<Scalars['String']['input']>
}

export type OnboardingSettingsUpdateResponse = {
  __typename?: 'OnboardingSettingsUpdateResponse'
  /** Errors, if any */
  errors: Array<Scalars['String']['output']>
  /** Whether the update succeeded */
  success: Scalars['Boolean']['output']
}

export type OnboardingState = {
  __typename?: 'OnboardingState'
  /** Whether onboarding is active for this request */
  active: Scalars['Boolean']['output']
  /** Whether the user can skip onboarding at this step */
  allowSkip: Scalars['Boolean']['output']
  /** Optional choices */
  choices?: Maybe<Array<Scalars['String']['output']>>
  /** Whether onboarding is completed for the user */
  completed: Scalars['Boolean']['output']
  /** Question to ask */
  question?: Maybe<Scalars['String']['output']>
  /** Current onboarding step */
  step?: Maybe<Scalars['Int']['output']>
}

export type OnboardingSubmitInput = {
  /** Chat session id for the onboarding session */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** Step 4: interest topics */
  interestTopics?: InputMaybe<Array<Scalars['String']['input']>>
  /** Step 2: preferred name */
  preferredName?: InputMaybe<Scalars['String']['input']>
  /** Step 3: preferred response style */
  responseStyle?: InputMaybe<Scalars['String']['input']>
  /** Skip onboarding and proceed to normal chat */
  skip?: Scalars['Boolean']['input']
  /** Step 1 choice: start onboarding (true) or skip (false) */
  startOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  /** Current onboarding step being submitted */
  step: Scalars['Int']['input']
  /** Step 2: confirm existing name */
  useExistingName?: InputMaybe<Scalars['Boolean']['input']>
}

export type OnboardingSubmitResponse = {
  __typename?: 'OnboardingSubmitResponse'
  /** Errors, if any */
  errors: Array<Scalars['String']['output']>
  /** Updated onboarding state */
  state?: Maybe<OnboardingState>
  /** Whether the update succeeded */
  success: Scalars['Boolean']['output']
}

export type OracleAgentChatHistoryInput = {
  /** Maximum number of message pairs to include in chat history (0-30) */
  limit?: Scalars['Int']['input']
}

export type OracleAgentChatInput = {
  /** Optional acquisition intent metadata from the client. Backend sanitizes and stores a normalized subset. */
  acquisitionIntent?: InputMaybe<Scalars['JSON']['input']>
  /** Channel hint used to select policy/tooling and enforce role-gated access. Examples: 'default', 'video_guide', 'internal', 'search'. If omitted, defaults to 'default'.  */
  chatChannel?: InputMaybe<Scalars['String']['input']>
  /** ID of the chat session to continue, if any */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: InputMaybe<Scalars['String']['input']>
  /** The current playback time in seconds when the message was sent. */
  currentTimeSeconds?: InputMaybe<Scalars['Float']['input']>
  /** Optional custom instruction prompt for internal workflows. Ignored outside internal-only channels. */
  customPrompt?: InputMaybe<Scalars['String']['input']>
  /** If true, ask LLM to generate gaia:// deep links for native apps */
  deepLinks?: InputMaybe<Scalars['Boolean']['input']>
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: InputMaybe<Scalars['String']['input']>
  /** Chat history configuration */
  history?: InputMaybe<OracleAgentChatHistoryInput>
  /** Whether the video is currently paused when the message was sent. */
  isPaused?: InputMaybe<Scalars['Boolean']['input']>
  /** Preferred response language (supported: en, fr, de, es) */
  language?: InputMaybe<Scalars['String']['input']>
  /** The temperature for the language model (default: 0.7) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Long-term memory for the agent */
  longTermMemory?: InputMaybe<Scalars['String']['input']>
  /** The maximum number of context documents to use */
  maxContextDocs?: InputMaybe<Scalars['Int']['input']>
  /** The maximum number of iterations for the agent */
  maxIterations?: InputMaybe<Scalars['Int']['input']>
  /** The user's message to the agent */
  message: Scalars['String']['input']
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The name of the language model to use */
  modelName?: InputMaybe<Scalars['String']['input']>
  /** ID of the personality to use for the chat */
  personalityId: Scalars['ID']['input']
  /** User's timezone for rate limit calculations */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type OracleAgentChatPayload = {
  __typename?: 'OracleAgentChatPayload'
  /** The normalized channel actually used by the backend */
  chatChannel?: Maybe<Scalars['String']['output']>
  /** The ID of the chat session */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** Generic signals for frontend workflow decisions */
  clientSignals?: Maybe<Array<ClientSignal>>
  /** A list of documents retrieved by the agent */
  documents: Array<OracleDocument>
  /** Any error message that occurred */
  error?: Maybe<Scalars['String']['output']>
  /** A list of structured errors. */
  errorInfo: Array<AppError>
  /** A list of any errors that occurred */
  errors: Array<Scalars['String']['output']>
  /** The total execution time of the agent chat */
  executionTime: Scalars['Float']['output']
  /** Current rate limit status for the user */
  rateLimitStatus?: Maybe<RateLimitInfo>
  /** Section-level success/failure metadata for response modules. */
  sectionStatus?: Maybe<Scalars['JSON']['output']>
  /** The generated title for the chat session */
  sessionTitle?: Maybe<Scalars['String']['output']>
  /** Whether the agent chat was successful */
  success: Scalars['Boolean']['output']
  /** The agent's response text */
  text: Scalars['String']['output']
}

export type OracleAgentChatSubscriptionPayload = {
  __typename?: 'OracleAgentChatSubscriptionPayload'
  /** The normalized channel actually used by the backend (sent with final message). */
  chatChannel?: Maybe<Scalars['String']['output']>
  /** The session ID for the chat. */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** Generic signals for frontend workflow decisions (sent with final message). */
  clientSignals?: Maybe<Array<ClientSignal>>
  /** Documents retrieved by the agent. */
  documents?: Maybe<Array<OracleDocument>>
  /** An error message if something went wrong. */
  error?: Maybe<Scalars['String']['output']>
  /** A list of structured errors. */
  errorInfo: Array<AppError>
  /** A list of error messages. */
  errors: Array<Scalars['String']['output']>
  /** Total execution time (sent with final message). */
  executionTime?: Maybe<Scalars['Float']['output']>
  /** Flag to indicate the final message in the stream. */
  isFinal: Scalars['Boolean']['output']
  /** The message pair ID for this interaction. */
  messagePairId?: Maybe<Scalars['ID']['output']>
  /** Current rate limit status for the user (sent with final message). */
  rateLimitStatus?: Maybe<RateLimitInfo>
  /** Section-level success/failure metadata for response modules. */
  sectionStatus?: Maybe<Scalars['JSON']['output']>
  /** The generated title for the session (sent with final message). */
  sessionTitle?: Maybe<Scalars['String']['output']>
  /** Oracle AI: User-facing loading phrases while the response is preparing (e.g. ['Levitating', 'Tuning in']). No trailing ellipsis — frontend may animate one. Frontend may rotate through these and retain unused labels for later turns. */
  statusLabels?: Maybe<Array<Scalars['String']['output']>>
  /** Indicates if the event was successful. */
  success: Scalars['Boolean']['output']
  /** A chunk of the agent's response text. */
  textChunk?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Standard operators for boolean filtering */
export type OracleBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Oracle document payload for component rendering. */
export type OracleCardDocument = {
  __typename?: 'OracleCardDocument'
  /** Resolve the back image URL for the referenced collection. Localized art follows the chat request language (en, es, fr, de). */
  backImageUrl?: Maybe<Scalars['String']['output']>
  collectionId?: Maybe<Scalars['ID']['output']>
  collectionKey?: Maybe<Scalars['String']['output']>
  objects: Array<OracleDocumentObject>
  pullId: Scalars['ID']['output']
  pulledAt?: Maybe<Scalars['String']['output']>
  readingId: Scalars['ID']['output']
}

/** Session-scoped oracle cards state for UI decisions. */
export type OracleCardsFeatureState = {
  __typename?: 'OracleCardsFeatureState'
  activeReadingHasPull: Scalars['Boolean']['output']
  activeReadingId?: Maybe<Scalars['ID']['output']>
  canPullCard: Scalars['Boolean']['output']
  canStartReading: Scalars['Boolean']['output']
  chatSessionId?: Maybe<Scalars['ID']['output']>
  hasActiveReading: Scalars['Boolean']['output']
  hasSession: Scalars['Boolean']['output']
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
  lastUsedSessionId?: Maybe<Scalars['ID']['output']>
}

/** Oracle AI: A chat session between user and AI */
export type OracleChatSession = {
  __typename?: 'OracleChatSession'
  /** Frontend chat channel label. Backed by the chat session's session_type column (for example: default, oracle_cards, onboarding). */
  chatChannel: Scalars['String']['output']
  /** The content ID this session is associated with (null for regular conversations) */
  contentId?: Maybe<Scalars['String']['output']>
  /** Timestamp of when the chat session was created */
  createdAt: Scalars['DateTime']['output']
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int']['output']
  /** Whether the user has marked this chat session as a favorite. */
  favorite: Scalars['Boolean']['output']
  /** Timestamp when the favorite status was last updated */
  favoriteUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The feature media ID this session is associated with (null for regular conversations) */
  featureMediaId?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the chat session */
  id: Scalars['ID']['output']
  /** Whether this chat session is the onboarding session */
  isOnboarding: Scalars['Boolean']['output']
  /** Month scoping key for channel sessions (for example divination); null for regular chat sessions. */
  monthKey?: Maybe<Scalars['String']['output']>
  /** The name (LLM-defined or user-defined) for the chat session */
  name: Scalars['String']['output']
  /** The personalities FK for this session */
  personalityId: Scalars['ID']['output']
  /** Timestamp of when the chat session was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** User information for this chat session */
  userInfo: UserInfo
  /** The user info UUID */
  userInfoUuid: Scalars['ID']['output']
}

/** Oracle AI: Input for creating a new chat session */
export type OracleChatSessionCreateInput = {
  /** The name for the chat session */
  name: Scalars['String']['input']
  /** The personality ID to use for this session */
  personalityId: Scalars['ID']['input']
}

/** Oracle AI: Response envelope for chat session creation */
export type OracleChatSessionCreateResponse = {
  __typename?: 'OracleChatSessionCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for chat session deletion */
export type OracleChatSessionDeleteResponse = {
  __typename?: 'OracleChatSessionDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for updating chat session favorite status */
export type OracleChatSessionFavoriteInput = {
  /** The new favorite status for the chat session */
  favorite: Scalars['Boolean']['input']
  /** The ID of the chat session to update */
  id: Scalars['ID']['input']
}

/** Oracle AI: Response envelope for chat session favorite update */
export type OracleChatSessionFavoriteResponse = {
  __typename?: 'OracleChatSessionFavoriteResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Chat session list response */
export type OracleChatSessionListResponse = {
  __typename?: 'OracleChatSessionListResponse'
  /** The total number of chat sessions available. */
  count: Scalars['Int']['output']
  /** The number of chat sessions returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned chat sessions. */
  offset: Scalars['Int']['output']
  /** A list of chat sessions. */
  oracleChatSessions: Array<OracleChatSession>
}

/** Oracle AI: Filtering options for chat session lists */
export type OracleChatSessionListWhere = {
  /** Filter by content ID */
  contentId?: InputMaybe<OracleStringFilterInput>
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by favorite status */
  favorite?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by feature media ID */
  featureMediaId?: InputMaybe<OracleStringFilterInput>
  /** Filter by chat session ID */
  id?: InputMaybe<OracleUuidFilterInput>
  /** Filter by chat session name */
  name?: InputMaybe<OracleStringFilterInput>
  /** Filter by personality ID */
  personalityId?: InputMaybe<OracleIntFilterInput>
  /** Filter by session type / chat channel (e.g. default, playlist_generator) */
  sessionType?: InputMaybe<OracleStringFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by user info UUID */
  userInfoUuid?: InputMaybe<OracleUuidFilterInput>
}

/** Oracle AI: Input for renaming a chat session */
export type OracleChatSessionRenameInput = {
  /** The ID of the chat session to rename */
  id: Scalars['ID']['input']
  /** The new name/title for the chat session */
  name: Scalars['String']['input']
}

/** Oracle AI: Response envelope for chat session rename */
export type OracleChatSessionRenameResponse = {
  __typename?: 'OracleChatSessionRenameResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for updating an existing chat session */
export type OracleChatSessionUpdateInput = {
  /** The ID of the chat session to update */
  id: Scalars['ID']['input']
  /** The new user message to append to the session */
  userMessage: Scalars['String']['input']
}

/** Oracle AI: Response envelope for chat session update */
export type OracleChatSessionUpdateResponse = {
  __typename?: 'OracleChatSessionUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated chat session, if successful */
  oracleChatSession?: Maybe<OracleChatSession>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for transcript chunk semantic search */
export type OracleChunkSemanticSearchInput = {
  /** Candidate pool size before MMR rerank. Required ≥ limit when rankingMode is MMR; if omitted, defaults to max(20, limit * 5). */
  fetchK?: InputMaybe<Scalars['Int']['input']>
  languageCode: OracleChunkSemanticSearchLanguageCode
  limit?: Scalars['Int']['input']
  /** MMR lambda (relevance vs diversity). Used when rankingMode is MMR; defaults to 0.5. */
  mmrLambda?: InputMaybe<Scalars['Float']['input']>
  prompt: Scalars['String']['input']
  rankingMode?: OracleChunkSemanticSearchRankingMode
}

/** Oracle AI: Supported language codes for chunk vector tables */
export enum OracleChunkSemanticSearchLanguageCode {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
}

/** Oracle AI: Chunk search ranking strategy */
export enum OracleChunkSemanticSearchRankingMode {
  Mmr = 'MMR',
  Similarity = 'SIMILARITY',
}

/** Oracle AI: A video content result with federation resolver */
export type OracleContentResult = {
  __typename?: 'OracleContentResult'
  /** Brooklyn Content primary key (federation key) */
  brooklynId: Scalars['Int']['output']
  /** Federated Content entity from Brooklyn */
  content: Content
  /** Brooklyn contentId (D6 nid) */
  contentId: Scalars['Int']['output']
  /** Content type (video for v1) */
  contentType: Scalars['String']['output']
  /** Relevance score */
  score: Scalars['Float']['output']
  /** Content title */
  title: Scalars['String']['output']
}

/** Oracle AI: Standard operators for datetime filtering */
export type OracleDateTimeFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>
  gt?: InputMaybe<Scalars['DateTime']['input']>
  gte?: InputMaybe<Scalars['DateTime']['input']>
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>
  lt?: InputMaybe<Scalars['DateTime']['input']>
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Schema for document containing text content and metadata */
export type OracleDocument = {
  __typename?: 'OracleDocument'
  /** Sequential id for recommendation component tags */
  componentId: Scalars['String']['output']
  /** Component type for rich rendering */
  componentType: Scalars['String']['output']
  /** Reference to the federated Content entity for accessing thumbnails and media */
  content?: Maybe<Content>
  /** Content ID (not unique). Tarot components use sentinel 0. */
  contentId: Scalars['Int']['output']
  contentLink?: Maybe<ContentLinkDocument>
  contentType: Scalars['String']['output']
  /** Off-session pull history gallery (poster); not used for active reading flows. */
  divinationPullHistory?: Maybe<DivinationPullHistoryDocument>
  documentText: Scalars['String']['output']
  /** Primary key for federation with Content service */
  documentsId: Scalars['String']['output']
  embedding: Array<Scalars['Float']['output']>
  horoscope?: Maybe<HoroscopeCardDocument>
  language: Scalars['String']['output']
  link: Scalars['String']['output']
  oracle?: Maybe<OracleCardDocument>
  path: Scalars['String']['output']
  /** Reference to the federated Playlist entity for accessing playlist data */
  playlist?: Maybe<Playlist>
  /** Brooklyn playlist ID for federated Playlist resolution */
  playlistId?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  seriesTitle: Scalars['String']['output']
  tarot?: Maybe<TarotDocument>
  tarotSummary?: Maybe<TarotSummaryDocument>
  title: Scalars['String']['output']
  writer: Scalars['String']['output']
}

/** Divination object reference in an oracle document. */
export type OracleDocumentObject = {
  __typename?: 'OracleDocumentObject'
  /** Localized display name for this divination object. Follows the chat request language (en, es, fr, de). */
  displayName?: Maybe<Scalars['String']['output']>
  /** Resolve the front image URL for this divination object. Localized art follows the chat request language (en, es, fr, de). */
  frontImageUrl?: Maybe<Scalars['String']['output']>
  /** Localized insight copy for this object. Follows the chat request language (en, es, fr, de). */
  insight: Scalars['String']['output']
  /** Localized invite copy for this object. Follows the chat request language (en, es, fr, de). */
  invite: Scalars['String']['output']
  objectId: Scalars['ID']['output']
  objectKey?: Maybe<Scalars['String']['output']>
  position: Scalars['String']['output']
}

export type OracleHealth = {
  __typename?: 'OracleHealth'
  success: Scalars['Boolean']['output']
}

export type OracleHealthResponse = {
  __typename?: 'OracleHealthResponse'
  errors: Array<Scalars['String']['output']>
  health?: Maybe<OracleHealth>
  success: Scalars['Boolean']['output']
}

/** Same shape as the AI service filter. Accepted on the list and ignored. */
export type OracleIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Oracle AI: AI-generated identity vibe */
export type OracleIdentityVibe = {
  __typename?: 'OracleIdentityVibe'
  /** Description of this vibe */
  description?: Maybe<Scalars['String']['output']>
  /** When this vibe was assigned to the user */
  generatedAt: Scalars['DateTime']['output']
  /** Vibe catalog ID */
  id: Scalars['ID']['output']
  /** The identity vibe line sentence */
  vibe: Scalars['String']['output']
}

/** Oracle AI: Optional input for identity vibe generation */
export type OracleIdentityVibeGenerateInput = {
  /** Language code for vibe generation (en, de, es, fr). Defaults to en when omitted. */
  language?: InputMaybe<Scalars['String']['input']>
  /** Up to 5 prior lines to treat as forbidden when regenerating (max 60 characters each) */
  previousVibeLines?: InputMaybe<Array<Scalars['String']['input']>>
  /** Optional vibe quiz answers from the profile flow (energy, feels true, shaping) */
  vibeQuiz?: InputMaybe<OracleVibeQuizInput>
}

/** Oracle AI: Response from identity vibe line generation */
export type OracleIdentityVibeGenerateResponse = {
  __typename?: 'OracleIdentityVibeGenerateResponse'
  errors?: Maybe<Array<Scalars['String']['output']>>
  success: Scalars['Boolean']['output']
  /** Generated vibe line options */
  vibeLines: Array<Scalars['String']['output']>
}

/** Oracle AI: Input for selecting an identity vibe line */
export type OracleIdentityVibeSelectInput = {
  /** The selected vibe line text */
  vibeLine: Scalars['String']['input']
}

/** Oracle AI: Response from selecting an identity vibe line */
export type OracleIdentityVibeSelectResponse = {
  __typename?: 'OracleIdentityVibeSelectResponse'
  errors?: Maybe<Array<Scalars['String']['output']>>
  oracleIdentityVibe?: Maybe<OracleIdentityVibe>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Standard operators for integer filtering */
export type OracleIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
}

export type OracleLlmConfigSet = {
  __typename?: 'OracleLLMConfigSet'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  status: Scalars['String']['output']
  useCaseConfigs: Array<OracleLlmUseCaseConfig>
}

export type OracleLlmConfigSetListResponse = {
  __typename?: 'OracleLLMConfigSetListResponse'
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  llmConfigSets: Array<OracleLlmConfigSet>
  offset: Scalars['Int']['output']
}

export type OracleLlmConfigSetUpsertInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  key: Scalars['String']['input']
  name: Scalars['String']['input']
  status?: InputMaybe<Scalars['String']['input']>
  useCaseConfigs?: Array<OracleLlmUseCaseConfigInput>
}

export type OracleLlmConfigSetUpsertResponse = {
  __typename?: 'OracleLLMConfigSetUpsertResponse'
  errors: Array<Scalars['String']['output']>
  llmConfigSet?: Maybe<OracleLlmConfigSet>
  success: Scalars['Boolean']['output']
}

export type OracleLlmUseCaseConfig = {
  __typename?: 'OracleLLMUseCaseConfig'
  frequencyPenalty?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  maxTokens?: Maybe<Scalars['Int']['output']>
  modelName: Scalars['String']['output']
  provider?: Maybe<Scalars['String']['output']>
  temperature?: Maybe<Scalars['Float']['output']>
  useCase: Scalars['String']['output']
}

export type OracleLlmUseCaseConfigInput = {
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  maxTokens?: InputMaybe<Scalars['Int']['input']>
  modelName: Scalars['String']['input']
  provider?: InputMaybe<Scalars['String']['input']>
  temperature?: InputMaybe<Scalars['Float']['input']>
  useCase: Scalars['String']['input']
}

/** Oracle AI: Individual message in a conversation */
export type OracleMessage = {
  __typename?: 'OracleMessage'
  /** The parent chat session ID for this message */
  chatSessionId: Scalars['ID']['output']
  /** The actual text content of the message */
  content: Scalars['String']['output']
  /** Timestamp of when the message was created */
  createdAt: Scalars['DateTime']['output']
  /** Derived unique identifier for the message (since they don't have separate DB IDs) */
  id: Scalars['String']['output']
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String']['output']
  /** The user ID for user messages, null for assistant messages */
  userId?: Maybe<Scalars['ID']['output']>
}

/** Oracle AI: Input for creating a new message */
export type OracleMessageCreateInput = {
  /** The chat session ID to which this message belongs */
  chatSessionId: Scalars['ID']['input']
  /** The text content of the message */
  content: Scalars['String']['input']
  /** The role of the message author, e.g., "user" or "assistant" */
  role: Scalars['String']['input']
  /** The user ID for the message, if applicable */
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Response envelope for message creation */
export type OracleMessageCreateResponse = {
  __typename?: 'OracleMessageCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created message, if successful */
  oracleMessage?: Maybe<OracleMessage>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Message list response */
export type OracleMessageListResponse = {
  __typename?: 'OracleMessageListResponse'
  /** The total number of messages available. */
  count: Scalars['Int']['output']
  /** The number of messages returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned messages. */
  offset: Scalars['Int']['output']
  /** A list of messages. */
  oracleMessages: Array<OracleMessage>
}

/** Oracle AI: Filtering options for message lists */
export type OracleMessageListWhere = {
  /** Filter by chat session ID */
  chatSessionId?: InputMaybe<OracleUuidFilterInput>
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by message role */
  role?: InputMaybe<OracleStringFilterInput>
  /** Filter by user ID */
  userId?: InputMaybe<OracleUuidFilterInput>
}

/** Oracle AI: A pair of user and assistant messages */
export type OracleMessagePair = {
  __typename?: 'OracleMessagePair'
  /** Active assistant response variant id */
  activeVariantId?: Maybe<Scalars['ID']['output']>
  /** The chat_sessions FK for this message pair */
  chatSessionId: Scalars['ID']['output']
  /** Timestamp of when the message pair was created */
  createdAt: Scalars['DateTime']['output']
  /** Document metadata used to render links/components */
  documentMetadata?: Maybe<Scalars['JSON']['output']>
  /** Documents referenced by this assistant message */
  documents: Array<OracleDocument>
  /** Auto-incrementing unique identifier for export operations */
  exportIndex: Scalars['Int']['output']
  /** Unique identifier for the message pair */
  id: Scalars['ID']['output']
  /** Request language for this message pair (en, es, fr, de) */
  language: Scalars['String']['output']
  /** The LLM used to generate the oracle response */
  llmName: Scalars['String']['output']
  /** The sentiment of the message */
  messageSentiment?: Maybe<Scalars['String']['output']>
  /** The topic of the message */
  messageTopic?: Maybe<Scalars['String']['output']>
  /** Communication mode ('text' or 'voice') */
  mode: Scalars['String']['output']
  /** The assistant's message in the pair */
  oracleMessage: OracleMessage
  /** Assistant response variants for this message pair */
  oracleMessageVariants: Array<OracleMessagePairVariant>
  /** User's thumbs up/down rating of the oracle response ('up', 'down', or 'none') */
  thumbsValue: Scalars['String']['output']
  /** Stable 0-based turn index within the chat session (null for legacy rows) */
  turnIndex?: Maybe<Scalars['Int']['output']>
  /** Timestamp of when the message pair was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** The user info UUID */
  userInfoUuid: Scalars['ID']['output']
  /** The user's message in the pair */
  userMessage: OracleMessage
}

/** Oracle AI: Input for creating a new message pair */
export type OracleMessagePairCreateInput = {
  /** The chat session ID for this message pair */
  chatSessionId: Scalars['ID']['input']
  /** The name of the LLM that generated the response */
  llmName: Scalars['String']['input']
  /** The sentiment of the message */
  messageSentiment?: InputMaybe<Scalars['String']['input']>
  /** The topic of the message */
  messageTopic?: InputMaybe<Scalars['String']['input']>
  /** Communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The assistant's response text */
  oracleMessage: Scalars['String']['input']
  /** The user info UUID for the user message */
  userInfoUuid: Scalars['ID']['input']
  /** The user's message text */
  userMessage: Scalars['String']['input']
}

/** Oracle AI: Response envelope for message pair creation */
export type OracleMessagePairCreateResponse = {
  __typename?: 'OracleMessagePairCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for message pair deletion */
export type OracleMessagePairDeleteResponse = {
  __typename?: 'OracleMessagePairDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Message pair list response */
export type OracleMessagePairListResponse = {
  __typename?: 'OracleMessagePairListResponse'
  /** The total number of message pairs available. */
  count: Scalars['Int']['output']
  /** The number of message pairs returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned message pairs. */
  offset: Scalars['Int']['output']
  /** A list of message pairs. */
  oracleMessagePairs: Array<OracleMessagePair>
}

/** Oracle AI: Filtering options for message pair lists */
export type OracleMessagePairListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by message pair ID */
  id?: InputMaybe<OracleUuidFilterInput>
  /** Filter by LLM name */
  llmName?: InputMaybe<OracleStringFilterInput>
  /** Filter by communication mode ('text' or 'voice') */
  mode?: InputMaybe<OracleStringFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

/** Oracle AI: Input for regenerating the last message pair turn */
export type OracleMessagePairRegenerateLastInput = {
  /** Chat session ID whose latest turn should be regenerated */
  chatSessionId: Scalars['ID']['input']
  /** Optional context document cap for regeneration */
  maxContextDocs?: InputMaybe<Scalars['Int']['input']>
  /** Optional max iterations for regeneration */
  maxIterations?: InputMaybe<Scalars['Int']['input']>
  /** Optional mode override ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** Optional model override for regeneration */
  modelName?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for last-turn regenerate mutation */
export type OracleMessagePairRegenerateLastResponse = {
  __typename?: 'OracleMessagePairRegenerateLastResponse'
  /** Active variant selected after regeneration */
  activeVariant?: Maybe<OracleMessagePairVariant>
  /** List of mutation errors */
  errors: Array<Scalars['String']['output']>
  /** Updated message pair with active regenerated response */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates mutation success */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for creating a message-pair share link */
export type OracleMessagePairShareInput = {
  /** The message pair ID to snapshot and share */
  messagePairId: Scalars['ID']['input']
  /** Optional variant ID to snapshot for this message pair */
  variantId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Envelope response for message-pair sharing */
export type OracleMessagePairShareResponse = {
  __typename?: 'OracleMessagePairShareResponse'
  /** Errors from share creation */
  errors: Array<Scalars['String']['output']>
  /** Public share path for this message pair */
  path?: Maybe<Scalars['String']['output']>
  /** Public share ID for this message pair */
  shareId?: Maybe<Scalars['ID']['output']>
  /** Whether share creation succeeded */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for updating an existing message pair */
export type OracleMessagePairUpdateInput = {
  /** The updated LLM name */
  llmName?: InputMaybe<Scalars['String']['input']>
  /** The updated message sentiment */
  messageSentiment?: InputMaybe<Scalars['String']['input']>
  /** The updated message topic */
  messageTopic?: InputMaybe<Scalars['String']['input']>
  /** The updated communication mode ('text' or 'voice') */
  mode?: InputMaybe<Scalars['String']['input']>
  /** The updated assistant message text */
  oracleMessage?: InputMaybe<Scalars['String']['input']>
  /** The updated thumbs up/down value ('up', 'down', or 'none') */
  thumbsValue?: InputMaybe<Scalars['String']['input']>
  /** The updated user message text */
  userMessage?: InputMaybe<Scalars['String']['input']>
  /** Optional assistant variant ID to target for thumbs updates */
  variantId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Response envelope for message pair update */
export type OracleMessagePairUpdateResponse = {
  __typename?: 'OracleMessagePairUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated message pair, if successful */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Assistant response variant for a message pair */
export type OracleMessagePairVariant = {
  __typename?: 'OracleMessagePairVariant'
  /** Creation time for this variant */
  createdAt: Scalars['DateTime']['output']
  /** Variant identifier */
  id: Scalars['ID']['output']
  /** True when this is the active variant */
  isActive: Scalars['Boolean']['output']
  /** LLM used to generate this variant */
  llmName: Scalars['String']['output']
  /** Parent message pair identifier */
  messagePairId: Scalars['ID']['output']
  /** Assistant response for this variant */
  oracleMessage: OracleMessage
  /** User's thumbs up/down rating for this variant ('up', 'down', or 'none') */
  thumbsValue: Scalars['String']['output']
  /** Updated time for this variant */
  updatedAt: Scalars['DateTime']['output']
  /** 0-based variant index for this message pair */
  variantIndex: Scalars['Int']['output']
}

/** Oracle AI: Input for selecting the active assistant response variant */
export type OracleMessagePairVariantSelectInput = {
  /** Parent message pair identifier */
  messagePairId: Scalars['ID']['input']
  /** Variant to set active; defaults to original variant (index 0) when omitted */
  variantId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Response envelope for variant selection mutation */
export type OracleMessagePairVariantSelectResponse = {
  __typename?: 'OracleMessagePairVariantSelectResponse'
  /** Variant now active for this message pair */
  activeVariant?: Maybe<OracleMessagePairVariant>
  /** List of mutation errors */
  errors: Array<Scalars['String']['output']>
  /** Updated message pair after active variant switch */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Indicates mutation success */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: AI personality configuration */
export type OraclePersonality = {
  __typename?: 'OraclePersonality'
  /** Timestamp of when the personality was created */
  createdAt: Scalars['DateTime']['output']
  /** Display name for the personality shown on the frontend */
  displayName?: Maybe<Scalars['String']['output']>
  /** Whether this personality is enabled and available for use */
  enabled: Scalars['Boolean']['output']
  /** List of enabled tools for the personality */
  enabledTools: Array<Scalars['String']['output']>
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: Maybe<Scalars['String']['output']>
  /** Unique identifier for the personality */
  id: Scalars['ID']['output']
  /** Whether this is the default personality */
  isDefault: Scalars['Boolean']['output']
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String']['output']
  /** Scoped LLM config bindings for this personality */
  llmConfigBindings: Array<OraclePersonalityLlmConfigBinding>
  /** ID of active default scoped LLM config set for this personality */
  llmDefaultConfigSetId?: Maybe<Scalars['ID']['output']>
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: Maybe<Scalars['Int']['output']>
  /** LLM model name for this personality */
  llmModel: Scalars['String']['output']
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: Maybe<Scalars['JSON']['output']>
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature: Scalars['Float']['output']
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: Maybe<Scalars['ID']['output']>
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: Maybe<Scalars['String']['output']>
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: Maybe<Scalars['Float']['output']>
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: Maybe<Scalars['String']['output']>
  /** System message that defines the personality's behavior */
  systemMessage: Scalars['String']['output']
  /** Timestamp of when the personality was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown: Scalars['Boolean']['output']
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter: Scalars['Boolean']['output']
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: Maybe<Scalars['Float']['output']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: Maybe<Scalars['String']['output']>
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: Maybe<Scalars['Float']['output']>
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Input for creating a new personality */
export type OraclePersonalityCreateInput = {
  /** Display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** List of enabled tools for the personality */
  enabledTools?: Array<Scalars['String']['input']>
  /** Custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']['input']>
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** Short string key for the personality (e.g., wisdom-keeper) */
  key: Scalars['String']['input']
  /** Optional channel-specific LLM config set bindings */
  llmChannelConfigSetBindings?: InputMaybe<Array<OraclePersonalityLlmChannelBindingInput>>
  /** When true, removes the default scoped LLM config binding for this personality */
  llmClearDefaultConfigBinding?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional LLM config set ID to bind as default for this personality */
  llmDefaultConfigSetId?: InputMaybe<Scalars['ID']['input']>
  /** Frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']['input']>
  /** LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']['input']>
  /** Provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']['input']>
  /** LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Soft reference to another personality by ID that serves as its parent */
  parentId?: InputMaybe<Scalars['ID']['input']>
  /** Frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']['input']>
  /** System message that defines the personalities behavior */
  systemMessage: Scalars['String']['input']
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown?: InputMaybe<Scalars['Boolean']['input']>
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']['input']>
  /** Frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** Custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for personality creation */
export type OraclePersonalityCreateResponse = {
  __typename?: 'OraclePersonalityCreateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The created personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Response envelope for personality deletion */
export type OraclePersonalityDeleteResponse = {
  __typename?: 'OraclePersonalityDeleteResponse'
  /** True if the deletion was successful, otherwise False */
  deleted?: Maybe<Scalars['Boolean']['output']>
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

export type OraclePersonalityLlmChannelBindingInput = {
  channel: Scalars['String']['input']
  configSetId: Scalars['ID']['input']
  enabled?: Scalars['Boolean']['input']
  priority?: Scalars['Int']['input']
}

export type OraclePersonalityLlmConfigBinding = {
  __typename?: 'OraclePersonalityLLMConfigBinding'
  configSetId: Scalars['ID']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  priority: Scalars['Int']['output']
  scopeKey?: Maybe<Scalars['String']['output']>
  scopeType: Scalars['String']['output']
}

/** Oracle AI: Personality list response */
export type OraclePersonalityListResponse = {
  __typename?: 'OraclePersonalityListResponse'
  /** The total number of personalities available. */
  count: Scalars['Int']['output']
  /** The number of personalities returned in this response. */
  limit: Scalars['Int']['output']
  /** The starting point of the returned personalities. */
  offset: Scalars['Int']['output']
  /** A list of personalities. */
  oraclePersonalities: Array<OraclePersonality>
}

/** Oracle AI: Filtering options for personality lists */
export type OraclePersonalityListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by enabled status */
  enabled?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by enabled tools */
  enabledTools?: InputMaybe<OracleStringFilterInput>
  /** Filter by personality ID */
  id?: InputMaybe<OracleIntFilterInput>
  /** Filter by default status */
  isDefault?: InputMaybe<OracleBooleanFilterInput>
  /** Filter by personality key */
  key?: InputMaybe<OracleStringFilterInput>
  /** Filter by parent personality ID */
  parentId?: InputMaybe<OracleIntFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

/** Oracle AI: Input for updating an existing personality */
export type OraclePersonalityUpdateInput = {
  /** New display name for the personality shown on the frontend */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Whether this personality is enabled and available for use */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** New list of enabled tools for the personality */
  enabledTools?: InputMaybe<Array<Scalars['String']['input']>>
  /** New custom prompt for history summarization (Phase 0.5) */
  historySummarizationPrompt?: InputMaybe<Scalars['String']['input']>
  /** ID of the personality to update */
  id: Scalars['ID']['input']
  /** Set as the default personality. Setting this to true will automatically unset any existing default personality. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** New key for the personality */
  key?: InputMaybe<Scalars['String']['input']>
  /** Optional channel-scoped LLM config set binding updates */
  llmChannelConfigSetBindings?: InputMaybe<Array<OraclePersonalityLlmChannelBindingInput>>
  /** When true, removes the default scoped LLM config binding for this personality */
  llmClearDefaultConfigBinding?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional default LLM config set ID for this personality */
  llmDefaultConfigSetId?: InputMaybe<Scalars['ID']['input']>
  /** New frequency penalty for LLM token generation */
  llmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** New maximum tokens for LLM responses */
  llmMaxTokens?: InputMaybe<Scalars['Int']['input']>
  /** New LLM model name for this personality */
  llmModel?: InputMaybe<Scalars['String']['input']>
  /** New provider-specific parameters for LLM configuration (JSON object) */
  llmProviderKwargs?: InputMaybe<Scalars['JSON']['input']>
  /** New LLM temperature setting (0.0 to 1.0) */
  llmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New parent ID for the personality */
  parentId?: InputMaybe<Scalars['ID']['input']>
  /** New frequency penalty for the planner phase LLM token generation */
  plannerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future orchestration phase (currently unused). */
  plannerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** New LLM temperature setting for the planner phase (0.0 to 1.0) */
  plannerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New custom system prompt for the planner phase (Phase 1.5) */
  plannerSystemPrompt?: InputMaybe<Scalars['String']['input']>
  /** New system message for the personality */
  systemMessage?: InputMaybe<Scalars['String']['input']>
  /** Whether to emit component markdown tags instead of links */
  useComponentMarkdown?: InputMaybe<Scalars['Boolean']['input']>
  /** Reserved toggle for future multi-phase orchestration (currently unused). */
  usePlannerWriter?: InputMaybe<Scalars['Boolean']['input']>
  /** New frequency penalty for the writer phase LLM token generation */
  writerLlmFrequencyPenalty?: InputMaybe<Scalars['Float']['input']>
  /** Reserved model name for future response phase (currently unused). */
  writerLlmModel?: InputMaybe<Scalars['String']['input']>
  /** New LLM temperature setting for the writer phase (0.0 to 1.0) */
  writerLlmTemperature?: InputMaybe<Scalars['Float']['input']>
  /** New custom system prompt for the writer phase (Phase 2) */
  writerSystemPrompt?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Response envelope for personality update */
export type OraclePersonalityUpdateResponse = {
  __typename?: 'OraclePersonalityUpdateResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** The updated personality, if successful */
  oraclePersonality?: Maybe<OraclePersonality>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Input for generating a playlist */
export type OraclePlaylistGenerateInput = {
  /** Viewing intent */
  intent?: Scalars['String']['input']
  /** Language code (e.g. en, de, es) */
  language?: Scalars['String']['input']
  /** User mood */
  mood?: Scalars['String']['input']
}

/** Oracle AI: Result of playlist generation */
export type OraclePlaylistGenerateResult = {
  __typename?: 'OraclePlaylistGenerateResult'
  /** Video recommendations */
  documents: Array<OracleDocument>
  errors: Array<Scalars['String']['output']>
  /** Seconds */
  executionTime: Scalars['Float']['output']
  success: Scalars['Boolean']['output']
  /** AI-generated narrative text */
  text: Scalars['String']['output']
}

/** Oracle AI: A playlist result with federation resolver */
export type OraclePlaylistResult = {
  __typename?: 'OraclePlaylistResult'
  /** Brooklyn playlist UUID */
  id: Scalars['String']['output']
  /** Federated Playlist entity from Brooklyn */
  playlist: Playlist
  /** Relevance score */
  score: Scalars['Float']['output']
  /** Playlist title */
  title: Scalars['String']['output']
}

/** Oracle AI: Input for saving a playlist */
export type OraclePlaylistSaveInput = {
  /** Ordered list of content IDs to add */
  contentIds: Array<Scalars['Int']['input']>
  /** Content type (default: video) */
  contentType?: Scalars['String']['input']
  /** A short description capturing the playlist's mood, theme, or intent */
  description?: Scalars['String']['input']
  /** Name for the new playlist */
  playlistName: Scalars['String']['input']
}

/** Oracle AI: Response for playlist save */
export type OraclePlaylistSaveResponse = {
  __typename?: 'OraclePlaylistSaveResponse'
  /** A list of errors that occurred during the mutation */
  errors: Array<Scalars['String']['output']>
  /** Number of items successfully added to the playlist */
  itemsAdded: Scalars['Int']['output']
  /** The ID of the created playlist */
  playlistId?: Maybe<Scalars['String']['output']>
  /** The name of the created playlist */
  playlistName?: Maybe<Scalars['String']['output']>
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output']
}

/** Oracle AI: A member profile result with federation resolver */
export type OracleProfileResult = {
  __typename?: 'OracleProfileResult'
  /** User bio */
  bio: Scalars['String']['output']
  /** User interest labels */
  interests: Array<Scalars['String']['output']>
  /** Federated UserProfile entity from Brooklyn */
  profile: UserProfile
  /** Relevance score */
  score: Scalars['Float']['output']
  /** User UID */
  uid: Scalars['String']['output']
  /** Username */
  username: Scalars['String']['output']
}

/** Oracle AI: Action a Prompt Library tile can offer */
export type OraclePromptLibraryAction = {
  /** Localized CTA label for the action */
  buttonText: Scalars['String']['output']
}

/** Oracle AI: Input for a Prompt Library action */
export type OraclePromptLibraryActionInput = {
  buttonText?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
  channel?: InputMaybe<OraclePromptLibraryChannel>
  mode?: InputMaybe<OraclePromptLibraryMode>
  type: OraclePromptLibraryActionType
}

/** Oracle AI: Prompt Library tile action type */
export enum OraclePromptLibraryActionType {
  Prompt = 'PROMPT',
  Resume = 'RESUME',
}

/** Oracle AI: Admin view of a Prompt Library action */
export type OraclePromptLibraryAdminAction = {
  __typename?: 'OraclePromptLibraryAdminAction'
  buttonTextDe: Scalars['String']['output']
  buttonTextEn: Scalars['String']['output']
  buttonTextEs: Scalars['String']['output']
  buttonTextFr: Scalars['String']['output']
  channel?: Maybe<OraclePromptLibraryChannel>
  mode?: Maybe<OraclePromptLibraryMode>
  type: OraclePromptLibraryActionType
}

/** Oracle AI: Admin view of a Prompt Library category */
export type OraclePromptLibraryAdminCategory = {
  __typename?: 'OraclePromptLibraryAdminCategory'
  audience: OraclePromptLibraryAudience
  createdAt: Scalars['DateTime']['output']
  descriptionDe: Scalars['String']['output']
  descriptionEn: Scalars['String']['output']
  descriptionEs: Scalars['String']['output']
  descriptionFr: Scalars['String']['output']
  displayStyle: OraclePromptLibraryDisplayStyle
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  nameDe: Scalars['String']['output']
  nameEn: Scalars['String']['output']
  nameEs: Scalars['String']['output']
  nameFr: Scalars['String']['output']
  published: Scalars['Boolean']['output']
  sortOrder: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Paginated admin categories */
export type OraclePromptLibraryAdminCategoryListResponse = {
  __typename?: 'OraclePromptLibraryAdminCategoryListResponse'
  categories: Array<OraclePromptLibraryAdminCategory>
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

/** Oracle AI: Admin category list filters */
export type OraclePromptLibraryAdminCategoryListWhere = {
  audience?: InputMaybe<OraclePromptLibraryAudienceFilterInput>
  key?: InputMaybe<OraclePromptLibraryStringEqFilterInput>
  published?: InputMaybe<OracleBooleanFilterInput>
}

/** Oracle AI: Admin view of a Prompt Library prompt */
export type OraclePromptLibraryAdminPrompt = {
  __typename?: 'OraclePromptLibraryAdminPrompt'
  actions: Array<OraclePromptLibraryAdminAction>
  categoryIds: Array<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  descriptionDe: Scalars['String']['output']
  descriptionEn: Scalars['String']['output']
  descriptionEs: Scalars['String']['output']
  descriptionFr: Scalars['String']['output']
  headlineDe: Scalars['String']['output']
  headlineEn: Scalars['String']['output']
  headlineEs: Scalars['String']['output']
  headlineFr: Scalars['String']['output']
  id: Scalars['ID']['output']
  instruction: Scalars['String']['output']
  published: Scalars['Boolean']['output']
  themeId?: Maybe<Scalars['ID']['output']>
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Paginated admin prompts */
export type OraclePromptLibraryAdminPromptListResponse = {
  __typename?: 'OraclePromptLibraryAdminPromptListResponse'
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  prompts: Array<OraclePromptLibraryAdminPrompt>
}

/** Oracle AI: Admin prompt list filters */
export type OraclePromptLibraryAdminPromptListWhere = {
  categoryId?: InputMaybe<OraclePromptLibraryIdFilterInput>
  published?: InputMaybe<OracleBooleanFilterInput>
  themeId?: InputMaybe<OraclePromptLibraryIdFilterInput>
}

/** Oracle AI: Admin view of a Prompt Library theme */
export type OraclePromptLibraryAdminTheme = {
  __typename?: 'OraclePromptLibraryAdminTheme'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  labelDe: Scalars['String']['output']
  labelEn: Scalars['String']['output']
  labelEs: Scalars['String']['output']
  labelFr: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

/** Oracle AI: Paginated admin themes */
export type OraclePromptLibraryAdminThemeListResponse = {
  __typename?: 'OraclePromptLibraryAdminThemeListResponse'
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  themes: Array<OraclePromptLibraryAdminTheme>
}

/** Oracle AI: Catalog partition for Prompt Library categories. Not an authorization boundary: any authenticated client may request INTERNAL. */
export enum OraclePromptLibraryAudience {
  Internal = 'INTERNAL',
  Member = 'MEMBER',
}

/** Oracle AI: Audience equality filter */
export type OraclePromptLibraryAudienceFilterInput = {
  eq?: InputMaybe<OraclePromptLibraryAudience>
}

/** Oracle AI: A Prompt Library category */
export type OraclePromptLibraryCategory = {
  __typename?: 'OraclePromptLibraryCategory'
  /** Localized category description */
  description: Scalars['String']['output']
  /** Client rendering style for this category */
  displayStyle: OraclePromptLibraryDisplayStyle
  id: Scalars['ID']['output']
  /** Localized category name */
  name: Scalars['String']['output']
  /** Total published prompts in this category */
  promptCount: Scalars['Int']['output']
  /** Oracle AI: Paginated prompts in this category */
  promptList: OraclePromptLibraryPromptListResponse
}

/** Oracle AI: A Prompt Library category */
export type OraclePromptLibraryCategoryPromptListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  salt: Scalars['String']['input']
}

/** Oracle AI: Create a Prompt Library category */
export type OraclePromptLibraryCategoryCreateInput = {
  audience?: OraclePromptLibraryAudience
  description?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
  displayStyle?: OraclePromptLibraryDisplayStyle
  key: Scalars['String']['input']
  name?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
  published?: Scalars['Boolean']['input']
  sortOrder?: Scalars['Int']['input']
}

/** Oracle AI: Paginated Prompt Library categories */
export type OraclePromptLibraryCategoryListResponse = {
  __typename?: 'OraclePromptLibraryCategoryListResponse'
  categories: Array<OraclePromptLibraryCategory>
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

/** Oracle AI: Category mutation response */
export type OraclePromptLibraryCategoryMutationResponse = {
  __typename?: 'OraclePromptLibraryCategoryMutationResponse'
  category?: Maybe<OraclePromptLibraryAdminCategory>
  errors: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Update a Prompt Library category */
export type OraclePromptLibraryCategoryUpdateInput = {
  audience?: InputMaybe<OraclePromptLibraryAudience>
  description?: InputMaybe<OraclePromptLibraryLocalizedStringUpdateInput>
  displayStyle?: InputMaybe<OraclePromptLibraryDisplayStyle>
  id: Scalars['ID']['input']
  key?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<OraclePromptLibraryLocalizedStringUpdateInput>
  published?: InputMaybe<Scalars['Boolean']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Chat channel for a Prompt Library action */
export enum OraclePromptLibraryChannel {
  Default = 'DEFAULT',
  Horoscope = 'HOROSCOPE',
  OracleCards = 'ORACLE_CARDS',
  Tarot = 'TAROT',
}

/** Oracle AI: Client rendering style for a Prompt Library category */
export enum OraclePromptLibraryDisplayStyle {
  Condensed = 'CONDENSED',
  Expanded = 'EXPANDED',
}

/** Oracle AI: Discoverable Prompt Library display style option */
export type OraclePromptLibraryDisplayStyleOption = {
  __typename?: 'OraclePromptLibraryDisplayStyleOption'
  style: OraclePromptLibraryDisplayStyle
  /** Persisted integer stored on the category */
  value: Scalars['Int']['output']
}

/** Oracle AI: ID operators for Prompt Library admin lists. Separate from OracleIDFilterInput because seed questions already register that GraphQL name on a different class. */
export type OraclePromptLibraryIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Oracle AI: Localized string bag (blank locales allowed) */
export type OraclePromptLibraryLocalizedStringInput = {
  de?: Scalars['String']['input']
  en?: Scalars['String']['input']
  es?: Scalars['String']['input']
  fr?: Scalars['String']['input']
}

/** Oracle AI: Partial localized string update (null field = leave unchanged; empty string = clear) */
export type OraclePromptLibraryLocalizedStringUpdateInput = {
  de?: InputMaybe<Scalars['String']['input']>
  en?: InputMaybe<Scalars['String']['input']>
  es?: InputMaybe<Scalars['String']['input']>
  fr?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Input mode for a Prompt Library action */
export enum OraclePromptLibraryMode {
  Text = 'TEXT',
  Voice = 'VOICE',
}

/** Oracle AI: A Prompt Library prompt tile */
export type OraclePromptLibraryPrompt = {
  __typename?: 'OraclePromptLibraryPrompt'
  /** One or more actions the client may offer */
  actions: Array<OraclePromptLibraryAction>
  /** Localized description */
  description: Scalars['String']['output']
  /** Localized headline */
  headline: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** Localized theme eyebrow label */
  theme: Scalars['String']['output']
}

/** Oracle AI: Start a new chat from a library prompt */
export type OraclePromptLibraryPromptAction = OraclePromptLibraryAction & {
  __typename?: 'OraclePromptLibraryPromptAction'
  /** Localized CTA label for the action */
  buttonText: Scalars['String']['output']
  /** Chat channel for the new conversation */
  channel: OraclePromptLibraryChannel
  /** Ready-to-send chat message: <Gaia action="prompt" promptId="..." text="..." /> */
  input: Scalars['String']['output']
  /** text or voice mode for the conversation */
  mode: OraclePromptLibraryMode
  /** Prompt id sent as <Gaia action="prompt" promptId=... /> */
  promptId: Scalars['ID']['output']
}

/** Oracle AI: Create a Prompt Library prompt */
export type OraclePromptLibraryPromptCreateInput = {
  actions?: InputMaybe<Array<OraclePromptLibraryActionInput>>
  categoryIds: Array<Scalars['ID']['input']>
  description?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
  headline?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
  instruction?: Scalars['String']['input']
  published?: Scalars['Boolean']['input']
  themeId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Paginated Prompt Library prompts */
export type OraclePromptLibraryPromptListResponse = {
  __typename?: 'OraclePromptLibraryPromptListResponse'
  count: Scalars['Int']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  prompts: Array<OraclePromptLibraryPrompt>
  /** Client salt echoed for stable ordering continuity */
  salt: Scalars['String']['output']
}

/** Oracle AI: Prompt mutation response */
export type OraclePromptLibraryPromptMutationResponse = {
  __typename?: 'OraclePromptLibraryPromptMutationResponse'
  errors: Array<Scalars['String']['output']>
  prompt?: Maybe<OraclePromptLibraryAdminPrompt>
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Update a Prompt Library prompt */
export type OraclePromptLibraryPromptUpdateInput = {
  actions?: InputMaybe<Array<OraclePromptLibraryActionInput>>
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>
  description?: InputMaybe<OraclePromptLibraryLocalizedStringUpdateInput>
  headline?: InputMaybe<OraclePromptLibraryLocalizedStringUpdateInput>
  id: Scalars['ID']['input']
  instruction?: InputMaybe<Scalars['String']['input']>
  published?: InputMaybe<Scalars['Boolean']['input']>
  themeId?: InputMaybe<Scalars['ID']['input']>
}

/** Oracle AI: Resume an existing conversation */
export type OraclePromptLibraryResumeAction = OraclePromptLibraryAction & {
  __typename?: 'OraclePromptLibraryResumeAction'
  /** Localized CTA label for the action */
  buttonText: Scalars['String']['output']
  /** Most recently messaged chat session for this action's channel; null when the member has no eligible session */
  chatSessionId?: Maybe<Scalars['ID']['output']>
}

/** Oracle AI: String equality filter */
export type OraclePromptLibraryStringEqFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>
}

/** Oracle AI: Create a Prompt Library theme */
export type OraclePromptLibraryThemeCreateInput = {
  label?: InputMaybe<OraclePromptLibraryLocalizedStringInput>
}

/** Oracle AI: Theme mutation response */
export type OraclePromptLibraryThemeMutationResponse = {
  __typename?: 'OraclePromptLibraryThemeMutationResponse'
  errors: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  theme?: Maybe<OraclePromptLibraryAdminTheme>
}

/** Oracle AI: Update a Prompt Library theme */
export type OraclePromptLibraryThemeUpdateInput = {
  id: Scalars['ID']['input']
  label?: InputMaybe<OraclePromptLibraryLocalizedStringUpdateInput>
}

/** Oracle AI: Input for search feedback (thumbs up/down) */
export type OracleSearchFeedbackInput = {
  /** Feedback value: 'up', 'down', or 'none' */
  thumbsValue: Scalars['String']['input']
  /** Turn ID from the streaming search payload */
  turnId: Scalars['ID']['input']
}

/** Oracle AI: Response for search feedback mutation */
export type OracleSearchFeedbackResponse = {
  __typename?: 'OracleSearchFeedbackResponse'
  errors: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  thumbsValue?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Input for agent-powered oracle search */
export type OracleSearchInput = {
  /** Language preference */
  language?: Scalars['String']['input']
  /** Max results per type */
  limit?: Scalars['Int']['input']
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int']['input']
  /** Previous AI text for refinement context */
  previousResponse?: InputMaybe<Scalars['String']['input']>
  query: Scalars['String']['input']
  /** Optional follow-up refinement */
  refinement?: InputMaybe<Scalars['String']['input']>
  /** What to search: 'playlist', 'content', 'profile', etc. */
  types?: Array<Scalars['String']['input']>
}

/** Oracle AI: Agent-powered search result */
export type OracleSearchResult = {
  __typename?: 'OracleSearchResult'
  /** Video content results */
  content: Array<OracleContentResult>
  /** AI message for the content/videos tab */
  contentText: Scalars['String']['output']
  errors: Array<Scalars['String']['output']>
  /** Total search execution time in seconds */
  executionTime: Scalars['Float']['output']
  /** AI message for the playlists tab */
  playlistText: Scalars['String']['output']
  /** Playlist results */
  playlists: Array<OraclePlaylistResult>
  /** AI message for the profiles/authors tab */
  profileText: Scalars['String']['output']
  /** Member profile results */
  profiles: Array<OracleProfileResult>
  success: Scalars['Boolean']['output']
  /** AI-generated recommendation text (generic fallback) */
  text: Scalars['String']['output']
}

/** Oracle AI: Input for streaming search */
export type OracleSearchStreamInput = {
  /** Session ID from previous search for refinement. Omit for fresh search. */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** Language preference */
  language?: Scalars['String']['input']
  /** Max results per type */
  limit?: Scalars['Int']['input']
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int']['input']
  query: Scalars['String']['input']
  /** What to search: 'playlist', 'content', 'profile', etc. */
  types?: Array<Scalars['String']['input']>
}

/** Oracle AI: Streaming search subscription payload */
export type OracleSearchSubscriptionPayload = {
  __typename?: 'OracleSearchSubscriptionPayload'
  /** Search session ID for refinement and feedback */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  contentResults?: Maybe<Array<OracleContentResult>>
  /** Chip-decision id for this turn's served slate (AI-502 reward join). Echo it back as previousDecisionId on the refinement triggered by a chip tap. */
  decisionId?: Maybe<Scalars['ID']['output']>
  errors: Array<Scalars['String']['output']>
  executionTime?: Maybe<Scalars['Float']['output']>
  isFinal: Scalars['Boolean']['output']
  playlistResults?: Maybe<Array<OraclePlaylistResult>>
  profileResults?: Maybe<Array<OracleProfileResult>>
  refinementSuggestions?: Maybe<Array<Scalars['String']['output']>>
  /** Oracle AI: Status key for stage-based loading feedback (e.g. 'searching', 'generating') */
  statusText?: Maybe<Scalars['String']['output']>
  /** Oracle AI: Typed refinement suggestions with classification and structured attributes */
  structuredRefinements?: Maybe<Array<RefinementSuggestion>>
  success: Scalars['Boolean']['output']
  textChunk?: Maybe<Scalars['String']['output']>
  /** Turn ID for submitting feedback via oracleSearchFeedback mutation */
  turnId?: Maybe<Scalars['ID']['output']>
}

/** Oracle AI: Public shared assistant message */
export type OracleSharedAssistantMessage = {
  __typename?: 'OracleSharedAssistantMessage'
  /** Snapshot of the assistant message */
  content: Scalars['String']['output']
}

/** Oracle AI: Public shared message pair snapshot */
export type OracleSharedMessagePair = {
  __typename?: 'OracleSharedMessagePair'
  createdAt: Scalars['DateTime']['output']
  /** Full snapshot document metadata for rich component rendering */
  documentMetadata?: Maybe<Scalars['JSON']['output']>
  documents: Array<OracleDocument>
  /** Public CDN URL for the share Open Graph image */
  ogImageUrl?: Maybe<Scalars['String']['output']>
  oracleMessage: OracleSharedAssistantMessage
  personalityDisplayName?: Maybe<Scalars['String']['output']>
  personalityKey: Scalars['String']['output']
  userMessage: OracleSharedUserMessage
}

/** Oracle AI: Public shared user message */
export type OracleSharedUserMessage = {
  __typename?: 'OracleSharedUserMessage'
  /** Snapshot of the user's message */
  content: Scalars['String']['output']
}

/** Oracle AI: Standard operators for string filtering */
export type OracleStringFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  neq?: InputMaybe<Scalars['String']['input']>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Same shape as the AI service filter. Accepted on the list and ignored. */
export type OracleTagsFilterInput = {
  /** Filter questions that contain all of the specified tags */
  contains?: InputMaybe<Array<Scalars['String']['input']>>
  /** Filter questions that contain any of the specified tags */
  overlap?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Oracle AI: A transcript segment hit from chunk semantic search */
export type OracleTranscriptChunk = {
  __typename?: 'OracleTranscriptChunk'
  contentId: Scalars['String']['output']
  endTimecode: Scalars['String']['output']
  featureMediaId: Scalars['String']['output']
  startTimecode: Scalars['String']['output']
}

/** Oracle AI: Standard operators for UUID filtering */
export type OracleUuidFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>
  in?: InputMaybe<Array<Scalars['UUID']['input']>>
}

/** Oracle AI: Vibe quiz selections (canonical English strings from the client) */
export type OracleVibeQuizInput = {
  /** Up to 2 energy adjectives (e.g. Grounded, Curious); max 160 characters per value */
  energy?: InputMaybe<Array<Scalars['String']['input']>>
  /** Up to 2 'feels true' phrases; max 160 characters per value */
  feelsTrue?: InputMaybe<Array<Scalars['String']['input']>>
  /** Up to 2 shaping-day activity labels; max 160 characters per value */
  shapingDays?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Oracle AI: Curated list of visualizers for site admins. */
export type OracleVisualizerCatalog = {
  __typename?: 'OracleVisualizerCatalog'
  /** Ordered visualizer entries. */
  entries: Array<OracleVisualizerCatalogEntry>
}

/** Oracle AI: A single entry in the admin visualizer catalog. */
export type OracleVisualizerCatalogEntry = {
  __typename?: 'OracleVisualizerCatalogEntry'
  /** Optional longer description or tooltip copy. */
  description: Scalars['String']['output']
  /** Stable identifier for menus and analytics. */
  id: Scalars['ID']['output']
  /** Which visualizer family this entry belongs to. */
  kind: OracleVisualizerKind
  /** Path relative to the Oracle origin (e.g. /api/visualizer/plotly/...); combine with the service base URL to open a new tab. */
  launchPath: Scalars['String']['output']
  /** Short label for submenu UI. */
  title: Scalars['String']['output']
}

/** Oracle AI: Kind of curated visualizer entry. */
export enum OracleVisualizerKind {
  Dash = 'DASH',
  EmbeddingProjector = 'EMBEDDING_PROJECTOR',
  Plotly = 'PLOTLY',
}

/** PM List - A curated list of content items (videos, series, people, tags, etc.) that can be associated with PM Sections. Lists are used primarily in 'content-list' section types where each list becomes a tab. Lists contain ordered content items that are displayed together. */
export type PmList = {
  __typename?: 'PMList'
  /** Administrative title used in admin interfaces to identify this list. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Description displayed to end users. User-facing description explaining what the list contains. Used for additional context when displaying the list. */
  description?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the list's language */
  language: Scalars['String']['output']
  /** Array of content type/content id objects that make up this list. Each item specifies a content type (e.g., 'video', 'series', 'person') and content ID. Items are displayed in the order they appear in this array. Example: [{type: 'series', id: '123'}, {type: 'video', id: '456'}] represents a list with one series followed by one video. */
  listItems: Array<PmListItem>
  /** Title displayed to end users. User-facing title for the list (e.g., 'Featured Videos', 'Popular Series'). Used when the list is displayed as a tab or section header. */
  title?: Maybe<Scalars['String']['output']>
  /** List type string constant that determines what kind of content the list contains. Valid types: 'content' (mix of videos and series from content model), 'content-people' (people/instructors from content model), 'content-tags' (tags from content model), 'portals' (user portals), 'people' (legacy people list type). The type affects how listItems are resolved and displayed. */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** PM List Item */
export type PmListItem = {
  __typename?: 'PMListItem'
  /** The asset linked to this list item (resolved from image.asset) */
  asset?: Maybe<Asset>
  /** The child list id */
  childListId?: Maybe<Scalars['String']['output']>
  /** The content id */
  id?: Maybe<Scalars['String']['output']>
  /** The image linked to this list item (resolved from imageId) */
  image?: Maybe<Image>
  /**
   * The image id (for legacy people lists). Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']['output']>
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** The content title (computed) */
  title?: Maybe<Scalars['String']['output']>
  /** The content type */
  type?: Maybe<Scalars['String']['output']>
}

/** PM List list response */
export type PmListListResponse = {
  __typename?: 'PMListListResponse'
  /** The total number of PM Lists matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM List */
  pmLists: Array<PmList>
}

/** PM List where admin title input type */
export type PmListWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM List where id input type */
export type PmListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM List where conditions to filter rows */
export type PmListWhereInput = {
  /** The admin title field where clause */
  adminTitle?: InputMaybe<PmListWhereAdminTitleInput>
  /** The id field where clause */
  id?: InputMaybe<PmListWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmListWhereLanguageInput>
  /** The type field where clause */
  type?: InputMaybe<PmListWhereTypeInput>
}

/** PM List where language input type */
export type PmListWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM List where type input type */
export type PmListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreen = {
  __typename?: 'PMScreen'
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the screen's language */
  language: Scalars['String']['output']
  /**
   * PM Sections which are children of this PM Screen. Returns all sections belonging to this screen.
   * Sections can be personalized based on user context, filtered by content properties, and filtered by enabled status.
   * The hierarchy is: PMScreen → PMSection → PMList.
   * @see pmScreenPersonalized resolver for more details
   */
  pmSections: Array<PmSection>
  /** Screen type string constant that identifies the screen/page. Common types: 'member-home' (main member landing page, automatically upgraded to v2), 'member-home-v2' (member home version 2), 'member-home-v4' (member home version 4 with experiments), 'centers' (centers/communities page). Used to fetch the correct screen configuration for a given page in the app. */
  screenType: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
}

/** PM Screen - A screen/page in the application that contains multiple PM Sections. Screens define the overall page structure (e.g., member home page, centers page). Each screen has multiple sections that are displayed in order. Examples: 'member-home' (main member landing page), 'member-home-v2'/'member-home-v4' (updated versions), 'centers' (centers/communities page). */
export type PmScreenPmSectionsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** PM Screen create input */
export type PmScreenCreateInput = {
  /** Two letter language code */
  language: Scalars['String']['input']
  /** Screen type string constant */
  screenType: Scalars['String']['input']
}

/** PM Screen create response */
export type PmScreenCreateResponse = {
  __typename?: 'PMScreenCreateResponse'
  /** The created PM Screen */
  pmScreen: PmScreen
  /** Whether the creation was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen delete response */
export type PmScreenDeleteResponse = {
  __typename?: 'PMScreenDeleteResponse'
  /** The deleted PM Screen */
  pmScreen: PmScreen
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen list response */
export type PmScreenListResponse = {
  __typename?: 'PMScreenListResponse'
  /** The total number of PM Screens matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM Screen */
  pmScreens: Array<PmScreen>
}

/** PM Screen personalized response */
export type PmScreenPersonalizedResponse = {
  __typename?: 'PMScreenPersonalizedResponse'
  /** The personalized PM Screen null when the screen is not found */
  pmScreen?: Maybe<PmScreen>
  /**
   * The screen type for the personalized screen, this is infered screen type from the requested args
   * e.g. the value used to get the pmScreen
   */
  screenType: Scalars['String']['output']
}

/** PM Screen update input */
export type PmScreenUpdateInput = {
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']['input']>
  /** Screen type string constant */
  screenType?: InputMaybe<Scalars['String']['input']>
}

/** PM Screen update response */
export type PmScreenUpdateResponse = {
  __typename?: 'PMScreenUpdateResponse'
  /** The updated PM Screen */
  pmScreen: PmScreen
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
}

/** PM Screen where id input type */
export type PmScreenWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Screen where conditions to filter rows */
export type PmScreenWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PmScreenWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmScreenWhereLanguageInput>
  /** The screen type field where clause */
  screenType?: InputMaybe<PmScreenWhereScreenTypeInput>
}

/** PM Screen where language input type */
export type PmScreenWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Screen where screen type input type */
export type PmScreenWhereScreenTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSection = {
  __typename?: 'PMSection'
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** The personalized and rendered version of this section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
  app?: Maybe<PmSectionApp>
  /** PM section availability of client attributes. Integer value: 1 = ALLOW_WITH (section only visible if request has matching client attributes), 2 = BLOCKED_WITH (section hidden if request has matching client attributes), 3 = NO_RESTRICTIONS (default, no client attribute filtering). Works in combination with clientAttributes array. */
  availabilityClientAttributes: Scalars['Int']['output']
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC. Client attributes identify the app/platform making the request (e.g., 'app-provider-gaia', 'app-web', 'app-tv-android', 'app-mobile-ios'). Used to restrict section visibility to specific platforms. Must be ordered alphabetically. */
  clientAttributes: Array<Scalars['String']['output']>
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Section is hidden when not enabled. When false, the section will not appear on the screen even if it exists. */
  enabled: Scalars['Boolean']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String']['output']
  /** Section placement order within a screen. Lower numbers appear first. Sections are sorted by this field when displayed. Used to control the vertical order of sections on a screen (e.g., header section might be order 1, featured content order 2, etc.). */
  order?: Maybe<Scalars['Int']['output']>
  /** PM Lists associated with this section. Used primarily by 'content-list' section types where each list becomes a tab. Lists are linked to sections through the pm_section_pm_list join table. Returns curated lists of content items (videos, series, people, tags, etc.) that belong to this section. */
  pmList: Array<PmList>
  /** The PM Screen that is the parent for this section. Resolves to the full PMScreen object containing this section. */
  pmScreen?: Maybe<PmScreen>
  /** The Screen this Section belongs to. Foreign key reference to the PMScreen that contains this section. */
  pmScreenId?: Maybe<Scalars['ID']['output']>
  /** The provider for the data of this section. Used when section content comes from external recommendation systems. Valid values: 'personalize' (AWS Personalize recommendations), 'pine' (Pine/SLR recommendation system). When null, section uses static or computed content. */
  provider?: Maybe<Scalars['String']['output']>
  /** The key that can be used to access the data for this provider. This is a provider-specific identifier used to fetch recommendations. For 'personalize' provider, this might be a campaign ID. For 'pine' provider, this might be a placement key. Used in combination with the provider field. */
  providerKey?: Maybe<Scalars['String']['output']>
  /** Section type string constant that determines the section's behavior and data structure. Common types: 'content-list' (curated lists with tabs), 'continue-watching' (user watch history), 'placement' (personalized recommendations), 'header' (screen header with image), 'recommended-content' (AI recommendations), 'most-popular' (popular content), 'courses' (course listings). See types.js for complete list. */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Array of visibility rule objects that control when this section is shown to users. Rules can check user login status, subscriptions, content watched, test groups, etc. Sections are only visible if all rules pass (or are inverted). */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionAppArgs = {
  LASpotlightOption?: InputMaybe<Scalars['Boolean']['input']>
  LASpotlightTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>
  disableMerchImpressionCount?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  usePGV?: InputMaybe<Scalars['Boolean']['input']>
  useRandom?: InputMaybe<Scalars['Boolean']['input']>
}

/** PM Section - A content section that appears on a PM Screen. Sections define what content is displayed and how it's organized. Examples: content-list sections display curated lists of videos/series, continue-watching sections show user's watch history, placement sections show personalized recommendations. */
export type PmSectionPmListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** PM Section App - A personalized and rendered version of a PM Section for use in applications. This includes processed data with tabs, personalization, and all computed fields from getSection. */
export type PmSectionApp = {
  __typename?: 'PMSectionApp'
  /** Administrative title used in admin interfaces to identify this section. Not displayed to end users. */
  adminTitle: Scalars['String']['output']
  /** PM section availability of client attributes */
  availabilityClientAttributes: Scalars['Int']['output']
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes: Array<Scalars['String']['output']>
  /** The date the row was created */
  createdAt: Scalars['DateTime']['output']
  /** Section-specific app data object with personalization and computed fields. The structure varies by section type. */
  data?: Maybe<PmSectionAppData>
  /** Section is hidden when not enabled */
  enabled: Scalars['Boolean']['output']
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** Two letter language code (e.g., 'en', 'es', 'fr') for the section's language */
  language: Scalars['String']['output']
  /** Section placement order within a screen */
  order?: Maybe<Scalars['Int']['output']>
  /** The Screen this Section belongs to */
  pmScreenId?: Maybe<Scalars['ID']['output']>
  /** The base PM Section model data for this app-rendered section */
  pmSection?: Maybe<PmSection>
  /** The provider for the data of this section */
  provider?: Maybe<Scalars['String']['output']>
  /** The key that can be used to access the data for this provider */
  providerKey?: Maybe<Scalars['String']['output']>
  /** Section type string constant that determines the section's behavior and data structure */
  type: Scalars['String']['output']
  /** The date the row was last updated */
  updatedAt: Scalars['DateTime']['output']
  /** Array of visibility rule objects that control when this section is shown to users */
  visibility?: Maybe<Array<PmSectionVisibilityRule>>
}

/** PM Section App Data union type - The data structure varies by section type. PMSectionAppDataPlacement for 'placement' sections (personalized recommendations), PMSectionAppDataContinueWatching for 'continue-watching'/'continue-watching-only'/'continue-watching-v3' sections, PMSectionAppDataContentList for 'content-list' sections (curated lists with tabs), PMSectionAppDataHeaderSection for 'header' sections (screen headers with images), PMSectionAppDataMemberHomeFirstTouch for 'member-home-first-touch' (first member home rails). */
export type PmSectionAppData =
  | PmSectionAppDataContentList
  | PmSectionAppDataContinueWatching
  | PmSectionAppDataHeaderSection
  | PmSectionAppDataMemberHomeFirstTouch
  | PmSectionAppDataPlacement

/** PM Section App Data Content Item */
export type PmSectionAppDataContentItem = {
  __typename?: 'PMSectionAppDataContentItem'
  /** The label */
  label?: Maybe<Scalars['String']['output']>
  /** The list id */
  listId: Scalars['ID']['output']
}

/** PM Section App Data for Content List types */
export type PmSectionAppDataContentList = {
  __typename?: 'PMSectionAppDataContentList'
  /** Array of content items with listId and label */
  content?: Maybe<Array<PmSectionAppDataContentItem>>
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The display mode */
  displayMode?: Maybe<Scalars['String']['output']>
  /** Enable content preferences filtering */
  enableContentPreferencesFiltering?: Maybe<Scalars['Boolean']['output']>
  /** Enable user hidden content */
  enableUserHiddenContent?: Maybe<Scalars['Boolean']['output']>
  /** The footer data */
  footer?: Maybe<PmSectionAppDataFooter>
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>
  /** Hide watched content */
  hideWatched?: Maybe<Scalars['Boolean']['output']>
  /** Log section visibility */
  logSectionVisibility?: Maybe<Scalars['Boolean']['output']>
  /** Recombee recommendation id for this section. For single-row sections this matches the row. For multi-row sections this is only the first row's id; prefer tabContent.recommId. This field will be removed in a future update. */
  recommId?: Maybe<Scalars['String']['output']>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The sort order */
  sortOrder?: Maybe<Scalars['String']['output']>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
  /** The per-platform view all link targets configured in the CMS */
  viewAllLink?: Maybe<PmSectionAppDataViewAllLink>
}

/** PM Section App Data for Continue Watching type */
export type PmSectionAppDataContinueWatching = {
  __typename?: 'PMSectionAppDataContinueWatching'
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The description */
  description?: Maybe<Scalars['String']['output']>
  /** The header data */
  header?: Maybe<PmSectionAppDataHeader>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
  /** The title */
  title?: Maybe<Scalars['String']['output']>
  /** The per-platform view all link targets configured in the CMS */
  viewAllLink?: Maybe<PmSectionAppDataViewAllLink>
}

/** PM Section App Data Footer */
export type PmSectionAppDataFooter = {
  __typename?: 'PMSectionAppDataFooter'
  /** The text for the footer of the section */
  label?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data Header */
export type PmSectionAppDataHeader = {
  __typename?: 'PMSectionAppDataHeader'
  /** The text for the header of the section */
  label?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data for Header section type */
export type PmSectionAppDataHeaderSection = {
  __typename?: 'PMSectionAppDataHeaderSection'
  /** The asset linked to this header section (resolved from image.asset) */
  asset?: Maybe<Asset>
  /** The description from the associated pmList */
  description?: Maybe<Scalars['String']['output']>
  /** The image linked to this header section (resolved from imageId) */
  image?: Maybe<Image>
  /**
   * The image id. Deprecated: use asset field instead.
   * @deprecated Use asset field instead
   */
  imageId?: Maybe<Scalars['String']['output']>
  /**
   * The image URL (computed). Deprecated: use asset.renderUrl instead.
   * @deprecated Use asset.renderUrl instead
   */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** The title from the associated pmList */
  title?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data for member-home-first-touch (CMS copy + personalized tabs; RFY prefers Recombee with embeddings fallback) */
export type PmSectionAppDataMemberHomeFirstTouch = {
  __typename?: 'PMSectionAppDataMemberHomeFirstTouch'
  /** Context for analytics (member-home-first-touch) */
  contextType?: Maybe<Scalars['String']['output']>
  /** CMS body copy / secondary line */
  description?: Maybe<Scalars['String']['output']>
  /** CMS display mode (e.g. generic, course, series, ai-focused) */
  displayMode?: Maybe<Scalars['String']['output']>
  /** Recombee recommendation id when the RFY slot was filled from Recombee (omitted when embeddings fallback was used). Prefer tabContent.recommId on each tile for attribution. */
  recommId?: Maybe<Scalars['String']['output']>
  /** Two personalized rails: first is continue-watching (single top item), second is recommended-for-you (Recombee when available, otherwise embedding-based recs). */
  tabs: Array<PmSectionAppDataMemberHomeFirstTouchTab>
  /** CMS headline */
  title?: Maybe<Scalars['String']['output']>
}

/** Tab row for member-home-first-touch: each row is a fixed UI slot with stable identifiers for clients. */
export type PmSectionAppDataMemberHomeFirstTouchTab = {
  __typename?: 'PMSectionAppDataMemberHomeFirstTouchTab'
  tabContent: Array<PmSectionAppTabContent>
  /** Localized tab heading */
  tabLabel?: Maybe<Scalars['String']['output']>
  /** Slot id for the client, e.g. continue-watching, watch-next-episode, recommended-for-you, next-step, todays-practice */
  tabType?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data for Placement type */
export type PmSectionAppDataPlacement = {
  __typename?: 'PMSectionAppDataPlacement'
  /** The context for the section to be used in event reporting */
  contextType?: Maybe<Scalars['String']['output']>
  /** The placement name */
  placement?: Maybe<Scalars['String']['output']>
  /** Recombee recommendation id for this section. Prefer tabContent.recommId on each tile for attribution. */
  recommId?: Maybe<Scalars['String']['output']>
  /** The render data which determines how the section will be displayed */
  render?: Maybe<PmSectionAppDataRender>
  /** The tabs data (complex computed structure) */
  tabs: Array<PmSectionAppDataTab>
}

/** PM Section App Data Render */
export type PmSectionAppDataRender = {
  __typename?: 'PMSectionAppDataRender'
  /** The background to render */
  background?: Maybe<Scalars['String']['output']>
  /** A link to the content */
  link?: Maybe<Scalars['String']['output']>
  /** The display width */
  tileCount?: Maybe<Scalars['String']['output']>
  /** The render type */
  type?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab */
export type PmSectionAppDataTab = {
  __typename?: 'PMSectionAppDataTab'
  /** The merchandising event ID */
  merchEventId?: Maybe<Scalars['ID']['output']>
  /** The type of payload (merchandising-content, featured-content-impression, etc.) */
  payloadType?: Maybe<Scalars['String']['output']>
  /** The recommendation score at tab level */
  pineScore?: Maybe<Scalars['Float']['output']>
  /** The source in pine for the score at tab level */
  pineSource?: Maybe<Scalars['String']['output']>
  /** The campaign slug for tracking */
  slug?: Maybe<Scalars['String']['output']>
  /** The tab content */
  tabContent: Array<PmSectionAppTabContent>
  /** The tab label */
  tabLabel?: Maybe<Scalars['String']['output']>
  /** The view mode for content display */
  viewMode?: Maybe<Scalars['String']['output']>
}

/** PM Section App Data View All Link - Per-platform view all link targets configured in the CMS */
export type PmSectionAppDataViewAllLink = {
  __typename?: 'PMSectionAppDataViewAllLink'
  /** The view all link target for native app clients */
  app?: Maybe<PmSectionAppDataViewAllLinkTarget>
  /** The view all link target for web clients */
  web?: Maybe<PmSectionAppDataViewAllLinkTarget>
}

/** PM Section App Data View All Link Target - A per-platform destination for the section's view all link */
export type PmSectionAppDataViewAllLinkTarget = {
  __typename?: 'PMSectionAppDataViewAllLinkTarget'
  /** The label for the view all link e.g. 'View All' */
  label?: Maybe<Scalars['String']['output']>
  /** The destination for the view all link e.g. '/browse/meditation' */
  url?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab Content */
export type PmSectionAppTabContent = {
  __typename?: 'PMSectionAppTabContent'
  /** The content for this tab */
  content?: Maybe<Array<Maybe<Content>>>
  /** The content ID */
  contentId?: Maybe<Scalars['ID']['output']>
  /** The content type */
  contentType?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: milliseconds until event start; 0 when live or no upcoming session */
  countdown?: Maybe<Scalars['Int']['output']>
  /** Live Access spotlight: session covering now */
  currentSession?: Maybe<LiveAccessSpotlightSessionSummary>
  /** Live Access spotlight: body text */
  description?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: desktop background image URL */
  desktopBackgroundUrl?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: long event description */
  eventDescriptionLong?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: live event id */
  eventId?: Maybe<Scalars['ID']['output']>
  /** Live Access spotlight: event type e.g. LIVE, AMA */
  eventType?: Maybe<Scalars['String']['output']>
  /** The content label */
  label?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: manual/stream live flag from track */
  liveStreamActive?: Maybe<Scalars['Boolean']['output']>
  /** Live Access spotlight: hero/background image URL */
  mobileBackgroundUrl?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: mobile CTA label */
  mobileButtonText?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: mobile body copy */
  mobileDescription?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: mobile header copy */
  mobileHeader?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: large mobile spotlight image URL */
  mobileImageLargeUrl?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: small mobile spotlight image URL */
  mobileImageSmallUrl?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: mobile subheader copy */
  mobileSubHeader?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: next session after current */
  nextSession?: Maybe<LiveAccessSpotlightSessionSummary>
  /** The recommendation score */
  pineScore?: Maybe<Scalars['Float']['output']>
  /** The source in pine for the score */
  pineSource?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: playback URL for stream */
  playbackUrl?: Maybe<Scalars['String']['output']>
  /** Recombee recommendation id for the row this item belongs to. Use this for per-row/per-tile attribution instead of section-level data.recommId. */
  recommId?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: event route path */
  route?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: first track schedule (REST `tracks[0].schedule`) */
  schedule?: Maybe<Array<LiveAccessSpotlightSessionSummary>>
  /** The seed question if this is a seed question e.g. type 'prompt' */
  seedQuestion?: Maybe<SeedQuestion>
  /** Live Access spotlight: ms remaining in current session when live */
  sessionTimeRemaining?: Maybe<Scalars['Int']['output']>
  /** Live Access spotlight: primary speaker display name */
  speakerName?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: spotlight row id (REST payload `id`) */
  spotlightId?: Maybe<Scalars['ID']['output']>
  /** Live Access spotlight: subtitle */
  subTitle?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: main heading */
  title?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: TV/fullscreen background URL */
  tvBackgroundUrl?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: TV thumbnail URL */
  tvThumbnailUrl?: Maybe<Scalars['String']['output']>
  /**
   * The type of tab content (e.g., 'chat', 'prompt')
   * NOTE: this will only be present for seed questions.
   */
  type?: Maybe<PmSectionAppTabContentType>
  /** Vertical clip thumbnail URL (9:16 crop from parent Poster CVR) for Moments Member Home row */
  verticalThumbnailUrl?: Maybe<Scalars['String']['output']>
  /** The video taste segment */
  videoTasteSegment?: Maybe<Scalars['String']['output']>
  /** Live Access spotlight: webview URL */
  webviewUrl?: Maybe<Scalars['String']['output']>
}

/** PM Section App Tab Content */
export type PmSectionAppTabContentContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export enum PmSectionAppTabContentType {
  /** chat */
  Chat = 'CHAT',
  /** prompt */
  Prompt = 'PROMPT',
}

/** PM Section create input */
export type PmSectionCreateInput = {
  /** Administrative title */
  adminTitle: Scalars['String']['input']
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']['input']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']['input']>>
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Two letter language code */
  language: Scalars['String']['input']
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']['input']>
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']['input']>
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']['input']>
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']['input']>
  /** Section type string constant */
  type: Scalars['String']['input']
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>
}

/** PM Section create response */
export type PmSectionCreateResponse = {
  __typename?: 'PMSectionCreateResponse'
  /** The created PM Section */
  pmSection: PmSection
  /** Whether the creation was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section delete response */
export type PmSectionDeleteResponse = {
  __typename?: 'PMSectionDeleteResponse'
  /** The deleted PM Section */
  pmSection: PmSection
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section filter input */
export type PmSectionFilterInput = {
  /** The language to filter the rows by */
  language?: InputMaybe<Scalars['String']['input']>
  /** The type to filter the rows by */
  type?: InputMaybe<Scalars['String']['input']>
}

/** PM Section list response */
export type PmSectionListResponse = {
  __typename?: 'PMSectionListResponse'
  /** The total number of PM Sections matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit: Scalars['Int']['output']
  /** The offset used in the query */
  offset: Scalars['Int']['output']
  /** A list of PM Section */
  pmSections: Array<PmSection>
}

/** PM Section update input */
export type PmSectionUpdateInput = {
  /** Administrative title */
  adminTitle?: InputMaybe<Scalars['String']['input']>
  /** PM section availability of client attributes such as no restrictions, only with or blocked with */
  availabilityClientAttributes?: InputMaybe<Scalars['Int']['input']>
  /** The client attributes to apply in combination with availability_client_attributes ordered ASC */
  clientAttributes?: InputMaybe<Array<Scalars['String']['input']>>
  /** JSON object specific to this section type */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** Section is hidden when not enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** Two letter language code */
  language?: InputMaybe<Scalars['String']['input']>
  /** Section placement order within a screen */
  order?: InputMaybe<Scalars['Int']['input']>
  /** The Screen this Section belongs to */
  pmScreenId?: InputMaybe<Scalars['ID']['input']>
  /** The provider for the data of this section e.g. personalize */
  provider?: InputMaybe<Scalars['String']['input']>
  /** The key that can be used to access the data for this provider */
  providerKey?: InputMaybe<Scalars['String']['input']>
  /** Section type string constant */
  type?: InputMaybe<Scalars['String']['input']>
  /** Array of visibility rule objects */
  visibility?: InputMaybe<Array<PmSectionVisibilityRuleInput>>
}

/** PM Section update response */
export type PmSectionUpdateResponse = {
  __typename?: 'PMSectionUpdateResponse'
  /** The updated PM Section */
  pmSection: PmSection
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
}

/** PM Section Visibility Rule */
export type PmSectionVisibilityRule = {
  __typename?: 'PMSectionVisibilityRule'
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: Maybe<Array<PmSectionVisibilityRuleContent>>
  /** Whether to invert the rule */
  inverse?: Maybe<Scalars['Boolean']['output']>
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: Maybe<Array<Scalars['Int']['output']>>
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: Maybe<Scalars['Int']['output']>
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType
}

/** PM Section Visibility Rule Content */
export type PmSectionVisibilityRuleContent = {
  __typename?: 'PMSectionVisibilityRuleContent'
  /** The content ID */
  contentId: Scalars['Int']['output']
  /** The content type */
  contentType: Scalars['String']['output']
}

/** PM Section Visibility Rule Content Input */
export type PmSectionVisibilityRuleContentInput = {
  /** The content ID */
  contentId: Scalars['Int']['input']
  /** The content type */
  contentType: Scalars['String']['input']
}

/** PM Section Visibility Rule Input */
export type PmSectionVisibilityRuleInput = {
  /** Array of content items (required for user-following, user-has-watched, content-impression types) */
  content?: InputMaybe<Array<PmSectionVisibilityRuleContentInput>>
  /** Whether to invert the rule */
  inverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Array of subscription option IDs (required for user-entitlement type) */
  subscriptions?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Threshold value (required for user-view-count, my-series-min-items, followed-series-min-items types) */
  threshold?: InputMaybe<Scalars['Int']['input']>
  /** The visibility rule type */
  type: PmSectionVisibilityRuleType
}

/** PM Section Visibility Rule Type */
export enum PmSectionVisibilityRuleType {
  /** Content impression rule */
  ContentImpression = 'CONTENT_IMPRESSION',
  /** FMTV only rule */
  FmtvOnly = 'FMTV_ONLY',
  /** Followed series minimum items rule */
  FollowedSeriesMinItems = 'FOLLOWED_SERIES_MIN_ITEMS',
  /** User must be logged in */
  LoggedIn = 'LOGGED_IN',
  /** My series minimum items rule */
  MySeriesMinItems = 'MY_SERIES_MIN_ITEMS',
  /** User must have onboarded terms */
  OnboardUserTerms = 'ONBOARD_USER_TERMS',
  /** Tenure rules */
  Tenure = 'TENURE',
  /** UBS rules */
  Ubs = 'UBS',
  /** User entitlement rule */
  UserEntitlement = 'USER_ENTITLEMENT',
  /** User following rule */
  UserFollowing = 'USER_FOLLOWING',
  /** User has watched rule */
  UserHasWatched = 'USER_HAS_WATCHED',
  /** User RC terms rule */
  UserRcTerms = 'USER_RC_TERMS',
  /** User test group rule */
  UserTestGroup = 'USER_TEST_GROUP',
  /** User view count rule */
  UserViewCount = 'USER_VIEW_COUNT',
  /** VTS rules */
  Vts = 'VTS',
}

/** PM Section where admin title input type */
export type PmSectionWhereAdminTitleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where availability client attributes input type */
export type PmSectionWhereAvailabilityClientAttributesInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** PM Section where client attributes input type */
export type PmSectionWhereClientAttributesInput = {
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where enabled input type */
export type PmSectionWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
}

/** PM Section where id input type */
export type PmSectionWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Section where conditions to filter rows */
export type PmSectionWhereInput = {
  /** The enabled field where clause */
  enabled?: InputMaybe<PmSectionWhereEnabledInput>
  /** The id field where clause */
  id?: InputMaybe<PmSectionWhereIdInput>
  /** The language field where clause */
  language?: InputMaybe<PmSectionWhereLanguageInput>
  /** The pm screen id field where clause */
  pmScreenId?: InputMaybe<PmSectionWherePmScreenIdInput>
  /** The type field where clause */
  type?: InputMaybe<PmSectionWhereTypeInput>
}

/** PM Section where language input type */
export type PmSectionWhereLanguageInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where order input type */
export type PmSectionWhereOrderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** PM Section where pm screen id input type */
export type PmSectionWherePmScreenIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PM Section where provider input type */
export type PmSectionWhereProviderInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where provider key input type */
export type PmSectionWhereProviderKeyInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** PM Section where type input type */
export type PmSectionWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Pagination information for cursor-based pagination */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** Cursor for the last item in the result set */
  endCursor?: Maybe<Scalars['String']['output']>
  /** Whether there are more results available */
  hasNextPage: Scalars['Boolean']['output']
  /** Whether there are previous results available */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>
  /** Cursor for the first item in the result set */
  startCursor?: Maybe<Scalars['String']['output']>
}

/** Path resolution and optional SEO meta */
export type PathInfo = {
  __typename?: 'PathInfo'
  absolute?: Maybe<Scalars['Boolean']['output']>
  /** Content for this path. Prefer `language` for translation selection (same pattern as Content.contentSeries). */
  content?: Maybe<Content>
  contentType?: Maybe<Scalars['String']['output']>
  filter?: Maybe<Scalars['String']['output']>
  filterSet?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['Int']['output']>
  meta?: Maybe<PathInfoMeta>
  path?: Maybe<Scalars['String']['output']>
  redirectType?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  type: PathInfoType
  url?: Maybe<Scalars['String']['output']>
  vocabulary?: Maybe<Scalars['String']['output']>
  vocabularyId?: Maybe<Scalars['Int']['output']>
}

/** Path resolution and optional SEO meta */
export type PathInfoContentArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** SEO and Open Graph meta for a resolved path */
export type PathInfoMeta = {
  __typename?: 'PathInfoMeta'
  /** CMS canonical URL when set */
  canonicalUrl?: Maybe<Scalars['String']['output']>
  /** Meta description */
  description?: Maybe<Scalars['String']['output']>
  /** SEO keywords */
  keywords?: Maybe<Scalars['String']['output']>
  ogDescription?: Maybe<Scalars['String']['output']>
  ogImage?: Maybe<Scalars['String']['output']>
  ogImageHeight?: Maybe<Scalars['Int']['output']>
  ogImageWidth?: Maybe<Scalars['Int']['output']>
  ogTitle?: Maybe<Scalars['String']['output']>
  ogType?: Maybe<Scalars['String']['output']>
  /** Relative path for og:url */
  ogUrl?: Maybe<Scalars['String']['output']>
  robotsNoFollow?: Maybe<Scalars['Boolean']['output']>
  robotsNoIndex?: Maybe<Scalars['Boolean']['output']>
  /** Page title (SEO title or display title) */
  title?: Maybe<Scalars['String']['output']>
  twitterDescription?: Maybe<Scalars['String']['output']>
  twitterImage?: Maybe<Scalars['String']['output']>
  twitterTitle?: Maybe<Scalars['String']['output']>
}

export enum PathInfoType {
  Category = 'category',
  ClassicFacet = 'classicFacet',
  Home = 'home',
  Node = 'node',
  Redirect = 'redirect',
  Subcategory = 'subcategory',
  Unknown = 'unknown',
}

/** Path redirect */
export type PathRedirect = {
  __typename?: 'PathRedirect'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The fragment to append to the redirect path */
  fragment?: Maybe<Scalars['String']['output']>
  /** The full URL for the redirect destination path (includes query & fragment) */
  fullUrl?: Maybe<Scalars['String']['output']>
  /** The primary key for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The query to append to the redirect path */
  query?: Maybe<Scalars['String']['output']>
  /** The redirect destination path */
  redirect?: Maybe<Scalars['String']['output']>
  /** The path to match */
  source?: Maybe<Scalars['String']['output']>
  /** The content associated with this path redirect by source path */
  sourceContent?: Maybe<Array<Maybe<Content>>>
  /** The HTTP response code (301 or 302) */
  type?: Maybe<Scalars['Int']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Path redirect list response */
export type PathRedirectListResponse = {
  __typename?: 'PathRedirectListResponse'
  /** A list of content reference */
  pathRedirects?: Maybe<Array<Maybe<PathRedirect>>>
  /** Total matching rows (separate count query) */
  total?: Maybe<Scalars['Int']['output']>
}

/** Content path redirect type where input type */
export type PathRedirectWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Path redirect where conditions to filter rows */
export type PathRedirectWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<PathRedirectWhereIdInput>
  /** The source field where clause */
  source?: InputMaybe<PathRedirectWhereSourceInput>
}

/** Path redirect id where input type */
export type PathRedirectWhereSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Payment Method Type */
export enum PaymentMethodType {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  GooglePay = 'GooglePay',
  PayPal = 'PayPal',
}

/** Oracle AI: A high-engagement post from a followed topic */
export type PickedPost = {
  __typename?: 'PickedPost'
  author: Scalars['String']['output']
  id: Scalars['String']['output']
  reactionsCount: Scalars['Int']['output']
  repliesCount: Scalars['Int']['output']
  snippet: Scalars['String']['output']
  timeAgo: Scalars['String']['output']
  title: Scalars['String']['output']
  topic: Scalars['String']['output']
  topicSlug: Scalars['String']['output']
}

/** How countries list applies for Country eligibility rule */
export enum PlanEligibilityCountryOperator {
  /** Request country ISO must be in countries */
  In = 'IN',
  /** Request country ISO must not be in countries */
  NotIn = 'NOT_IN',
}

/** Numeric comparison operator for Lifetime Value and Tenure rules */
export enum PlanEligibilityNumericOperator {
  /** Greater than */
  Gt = 'GT',
  /** Greater than or equal */
  Gte = 'GTE',
  /** Less than */
  Lt = 'LT',
  /** Less than or equal */
  Lte = 'LTE',
}

/** Plan eligibility page */
export enum PlanEligibilityPage {
  /** Checkout (sign up) */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange',
}

/** Plan eligibility rule type */
export enum PlanEligibilityRuleType {
  /** Request country (geo) allowlist or blocklist */
  Country = 'Country',
  /** Lifetime value condition */
  LifetimeValue = 'LifetimeValue',
  /** Max number of purchases (sign up or plan change into this plan) */
  MaxPurchases = 'MaxPurchases',
  /** Months since last purchase of this plan */
  MonthsSinceLastPurchase = 'MonthsSinceLastPurchase',
  /** Current plan category must be in list */
  PlanCategory = 'PlanCategory',
  /** SKU-based rule (ecommerce and/or plan SKUs) */
  Sku = 'SKU',
  /** Tenure (days entitled) condition */
  Tenure = 'Tenure',
}

/** Plan eligibility rule scope */
export enum PlanEligibilityScope {
  /** Both checkout and plan change */
  All = 'all',
  /** Checkout (sign up) */
  Checkout = 'checkout',
  /** Plan change */
  PlanChange = 'planChange',
}

/** Plan Grid Device Type */
export enum PlanGridDeviceType {
  /** Desktop */
  Desktop = 'Desktop',
  /** Mobile */
  Mobile = 'Mobile',
}

export type PlaybackCompanion = {
  __typename?: 'PlaybackCompanion'
  contentFilter?: Maybe<Scalars['JSON']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  enabled: Scalars['Boolean']['output']
  endsAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  /** Federated Media entity (resolve via mediaId) */
  media?: Maybe<Media>
  mediaId: Scalars['ID']['output']
  priority: Scalars['Int']['output']
  role: CompanionRole
  startsAt: Scalars['DateTime']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PlaybackCompanionCreateInput = {
  contentFilter?: InputMaybe<Scalars['JSON']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  endsAt: Scalars['DateTime']['input']
  label: Scalars['String']['input']
  mediaId: Scalars['ID']['input']
  priority?: InputMaybe<Scalars['Int']['input']>
  role: CompanionRole
  startsAt: Scalars['DateTime']['input']
}

export type PlaybackCompanionDeleteResponse = {
  __typename?: 'PlaybackCompanionDeleteResponse'
  success: Scalars['Boolean']['output']
}

export type PlaybackCompanionMutationPayload = {
  __typename?: 'PlaybackCompanionMutationPayload'
  playbackCompanion?: Maybe<PlaybackCompanion>
  success: Scalars['Boolean']['output']
}

/** Member-facing companion pointer returned at play time */
export type PlaybackCompanionRef = {
  __typename?: 'PlaybackCompanionRef'
  id: Scalars['ID']['output']
  /** Federated Media entity (resolve via mediaId) */
  media?: Maybe<Media>
  mediaId: Scalars['ID']['output']
  role: CompanionRole
}

export type PlaybackCompanionUpdateInput = {
  contentFilter?: InputMaybe<Scalars['JSON']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  endsAt?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['ID']['input']
  label?: InputMaybe<Scalars['String']['input']>
  mediaId?: InputMaybe<Scalars['ID']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  role?: InputMaybe<CompanionRole>
  startsAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Playback companion schedule timestamp where clause */
export type PlaybackCompanionWhereDateTimeInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Playback companion enabled where clause */
export type PlaybackCompanionWhereEnabledInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Playback companion where conditions to filter rows */
export type PlaybackCompanionWhereInput = {
  enabled?: InputMaybe<PlaybackCompanionWhereEnabledInput>
  endsAt?: InputMaybe<PlaybackCompanionWhereDateTimeInput>
  label?: InputMaybe<PlaybackCompanionWhereLabelInput>
  role?: InputMaybe<PlaybackCompanionWhereRoleInput>
  startsAt?: InputMaybe<PlaybackCompanionWhereDateTimeInput>
}

/** Playback companion label where clause */
export type PlaybackCompanionWhereLabelInput = {
  /** Is the value a case-insensitive substring of the field */
  ilike?: InputMaybe<Scalars['String']['input']>
}

/** Playback companion role where clause */
export type PlaybackCompanionWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<CompanionRole>
}

export type PlaybackCompanionsListResponse = {
  __typename?: 'PlaybackCompanionsListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  playbackCompanions?: Maybe<Array<Maybe<PlaybackCompanion>>>
}

/** Supported playcount language keys */
export enum PlaycountLanguage {
  All = 'all',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
}

/** Playlist row */
export type Playlist = {
  __typename?: 'Playlist'
  /** Cover photo URL */
  coverPhoto?: Maybe<PlaylistCoverPhoto>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Optional user-written description */
  description?: Maybe<Scalars['String']['output']>
  /** Number of users following this playlist */
  followerCount?: Maybe<Scalars['Int']['output']>
  /** The primary identifier for this playlist record */
  id?: Maybe<Scalars['ID']['output']>
  /** Whether the authenticated user follows this playlist */
  isFollowing?: Maybe<Scalars['Boolean']['output']>
  /** Total number of items in the playlist */
  itemCount?: Maybe<Scalars['Int']['output']>
  /** Member-defined display order; higher number = first/top, 0 = last */
  playlistIndex?: Maybe<Scalars['Int']['output']>
  /** The playlist items linked to this playlist */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
  /** The playlist name */
  playlistName?: Maybe<Scalars['String']['output']>
  /** Playlist type (default | offline | yoga | custom) */
  playlistType?: Maybe<Scalars['String']['output']>
  /** User id of the playlist */
  uid?: Maybe<Scalars['ID']['output']>
  /** Last change to the playlist row, or the last time an item was added, removed, or moved to a new position (a same-position move does not bump this value) */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The playlist creator's community profile (null if no profile or visibility restricted) */
  userProfile?: Maybe<UserProfile>
  /** The playlist visibility level */
  visibility?: Maybe<PlaylistVisibility>
}

/** Playlist cover photo with URL */
export type PlaylistCoverPhoto = {
  __typename?: 'PlaylistCoverPhoto'
  /** Full-size URL */
  url: Scalars['String']['output']
}

/** Response from requesting a playlist cover photo upload */
export type PlaylistCoverPhotoUploadRequest = {
  __typename?: 'PlaylistCoverPhotoUploadRequest'
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output']
  /** UUID for the pending image */
  imageUuid: Scalars['ID']['output']
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String']['output']
}

/** Response from confirming a playlist cover photo upload */
export type PlaylistCoverPhotoUploadResponse = {
  __typename?: 'PlaylistCoverPhotoUploadResponse'
  /** The cover photo URL */
  coverPhoto?: Maybe<PlaylistCoverPhoto>
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean']['output']
}

/** Playlist create playlist input */
export type PlaylistCreatePlaylistInput = {
  /** Optional description for the playlist */
  description?: InputMaybe<Scalars['String']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist data */
export type PlaylistCreatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist item data */
export type PlaylistCreatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']['input']>
}

/** Repsonse when creating a playlist item */
export type PlaylistCreatePlaylistItemResponse = {
  __typename?: 'PlaylistCreatePlaylistItemResponse'
  /** The playlist for the created playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was created */
  playlistItem?: Maybe<PlaylistItem>
}

/** Repsonse when creating a playlist item */
export type PlaylistCreateResponse = {
  __typename?: 'PlaylistCreateResponse'
  /** The playlist that was created */
  playlist?: Maybe<Playlist>
}

/** Item input for bulk playlist creation */
export type PlaylistCreateWithItemsItemInput = {
  /** Content id for this playlist item */
  contentId: Scalars['Int']['input']
  /** Content type for this playlist item, defaults to video */
  contentType?: InputMaybe<Scalars['String']['input']>
}

/** Response when creating a playlist with items */
export type PlaylistCreateWithItemsResponse = {
  __typename?: 'PlaylistCreateWithItemsResponse'
  /** The playlist that was created */
  playlist?: Maybe<Playlist>
  /** The playlist items that were created */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
}

/** Playlist delete playlist input */
export type PlaylistDeletePlaylistInput = {
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist delete a playlist item input playlist data */
export type PlaylistDeletePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist item to delete */
export type PlaylistDeletePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Repsonse when deleting a playlist item */
export type PlaylistDeletePlaylistItemResponse = {
  __typename?: 'PlaylistDeletePlaylistItemResponse'
  /** The playlist for the deleted playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was deleted */
  playlistItem?: Maybe<PlaylistItem>
}

/** Repsonse when creating a playlist item */
export type PlaylistDeleteResponse = {
  __typename?: 'PlaylistDeleteResponse'
  /** The playlist that was deleted */
  playlist?: Maybe<Playlist>
}

/** Engagement data for a playlist */
export type PlaylistEngagement = {
  __typename?: 'PlaylistEngagement'
  /** Number of users following this playlist */
  followerCount: Scalars['Int']['output']
  /** The playlist ID */
  playlistId: Scalars['ID']['output']
}

/** Playlist follow row for bulk export */
export type PlaylistFollowRow = {
  __typename?: 'PlaylistFollowRow'
  /** When the follow was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The UID of the follower */
  followerUid: Scalars['Int']['output']
  /** The primary key */
  id: Scalars['ID']['output']
  /** The UUID of the followed playlist */
  playlistId: Scalars['ID']['output']
}

/** Cursor-based connection for followed playlists */
export type PlaylistFollowedConnection = {
  __typename?: 'PlaylistFollowedConnection'
  /** List of playlist edges */
  edges: Array<PlaylistFollowedEdge>
  /** Pagination information */
  pageInfo: PageInfo
  /** Total count of followed playlists */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A single followed playlist edge */
export type PlaylistFollowedEdge = {
  __typename?: 'PlaylistFollowedEdge'
  /** Cursor for this edge */
  cursor: Scalars['String']['output']
  /** When the user followed this playlist */
  followedAt: Scalars['DateTime']['output']
  /** The playlist node */
  node: Playlist
}

/** Response for bulk playlist follows list */
export type PlaylistFollowsListResponse = {
  __typename?: 'PlaylistFollowsListResponse'
  /** Total count matching the filter */
  count?: Maybe<Scalars['Int']['output']>
  /** List of playlist follow relationships */
  playlistFollows: Array<PlaylistFollowRow>
}

/** ID filter for playlist follows list */
export type PlaylistFollowsListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Where input for bulk playlist follows list */
export type PlaylistFollowsListWhereInput = {
  /** Filter by follower UID */
  followerUid?: InputMaybe<PlaylistFollowsListWhereIntInput>
  /** Filter by follow row ID */
  id?: InputMaybe<PlaylistFollowsListWhereIdInput>
  /** Filter by playlist ID */
  playlistId?: InputMaybe<PlaylistFollowsListWhereStringInput>
}

/** Int filter for playlist follows list */
export type PlaylistFollowsListWhereIntInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** String filter for playlist follows list */
export type PlaylistFollowsListWhereStringInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** PlaylistItem row */
export type PlaylistItem = {
  __typename?: 'PlaylistItem'
  /** The playlist items content */
  content?: Maybe<Array<Maybe<Content>>>
  /** Content content id for this playlist item */
  contentId?: Maybe<Scalars['Int']['output']>
  /** Content content type (video | series) */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The playlist linked to this playlist item */
  playlist?: Maybe<Playlist>
  /** ID for the playlist this item is tied to */
  playlistId?: Maybe<Scalars['ID']['output']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: Maybe<Scalars['Int']['output']>
  /** A human readable id that is identifies the content in a title group */
  titleGroupId?: Maybe<Scalars['String']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** PlaylistItem row */
export type PlaylistItemContentArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Playlist item list input to match by playlist */
export type PlaylistItemListPlaylistInput = {
  /** The playlist id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name when creating a playlist */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** PlaylistItem asset response */
export type PlaylistItemListResponse = {
  __typename?: 'PlaylistItemListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of playlistItem */
  playlistItems?: Maybe<Array<Maybe<PlaylistItem>>>
}

/** The where clause for a playlistItem id field */
export type PlaylistItemWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value not equal to the field */
  ne?: InputMaybe<Scalars['ID']['input']>
}

/** The where conditions to filter rows */
export type PlaylistItemWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistItemWhereIdInput>
}

/** Playlist asset response */
export type PlaylistListResponse = {
  __typename?: 'PlaylistListResponse'
  /** Total rows matching the filters the caller is allowed to see (post visibility/system-type gating; uses a slower count query) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of playlist */
  playlists?: Maybe<Array<Maybe<Playlist>>>
}

/** A reason why a playlist was matched for the user */
export type PlaylistMatchReason = {
  __typename?: 'PlaylistMatchReason'
  /** Human-readable label (teacher name, center name, etc.) */
  label: Scalars['String']['output']
  /** Category of the match signal */
  type: PlaylistMatchType
  /** Contribution weight of this signal to the overall score */
  weight: Scalars['Float']['output']
}

/** Category of playlist match signal */
export enum PlaylistMatchType {
  /** Playlist contains videos in centers the user frequents */
  CenterOverlap = 'CENTER_OVERLAP',
  /** Playlist aligns with the user's interest tags */
  InterestOverlap = 'INTEREST_OVERLAP',
  /** Popular playlist (cold start fallback) */
  Popular = 'POPULAR',
  /** Playlist content semantically matches the query */
  SemanticMatch = 'SEMANTIC_MATCH',
  /** Playlist is followed by users the current user also follows */
  SocialCoFollow = 'SOCIAL_CO_FOLLOW',
  /** Playlist was created by a user the current user follows */
  SocialCreator = 'SOCIAL_CREATOR',
  /** Playlist contains videos by teachers the user watches */
  TeacherOverlap = 'TEACHER_OVERLAP',
  /** Playlist name/content matches the text query */
  TextMatch = 'TEXT_MATCH',
}

/** Cursor-based connection for playlist search results */
export type PlaylistSearchConnection = {
  __typename?: 'PlaylistSearchConnection'
  /** List of playlist edges */
  edges: Array<PlaylistSearchEdge>
  /** Pagination information */
  pageInfo: PageInfo
  /** Total count of matching playlists */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** A single playlist search result edge */
export type PlaylistSearchEdge = {
  __typename?: 'PlaylistSearchEdge'
  /** Cursor for this edge */
  cursor: Scalars['String']['output']
  /** The playlist node */
  node: Playlist
}

/** Sort order for playlist search results */
export enum PlaylistSearchOrder {
  /** Sort alphabetically by name */
  Alphabetical = 'ALPHABETICAL',
  /** Sort by newest first */
  Newest = 'NEWEST',
  /** Sort by recently updated (adding, removing, or moving an item counts as an update) */
  RecentlyUpdated = 'RECENTLY_UPDATED',
  /** Sort by relevance to the search query (default) */
  Relevance = 'RELEVANCE',
}

export type PlaylistSearchResponse = {
  __typename?: 'PlaylistSearchResponse'
  /** For overview stream subscription. */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** Parallel array — match reasons per playlist (for section headers). */
  playlistMatchReasons?: Maybe<Array<Maybe<Array<PlaylistMatchReason>>>>
  /** Ordered playlist UUIDs in ranked order. Frontend hydrates via playlistList. */
  playlistResultIds: Array<Scalars['ID']['output']>
  /** Parallel array — score per playlist. */
  playlistScores: Array<Scalars['Float']['output']>
  totalCount: Scalars['Int']['output']
}

/** Input for updating a playlist's metadata */
export type PlaylistUpdateInput = {
  /** New description (max 5000 chars) */
  description?: InputMaybe<Scalars['String']['input']>
  /** New playlist name (max 64 chars) */
  playlistName?: InputMaybe<Scalars['String']['input']>
}

/** Playlist update a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistInput = {
  /** The primary key */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The playlist name */
  playlistName?: InputMaybe<Scalars['String']['input']>
  /** The playlist type */
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** Playlist create a playlist item input playlist data */
export type PlaylistUpdatePlaylistItemPlaylistItemInput = {
  /** Content content id for this playlist item */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Content content type for this playlist item */
  contentType?: InputMaybe<Scalars['String']['input']>
  /** The playlist item id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The position of the item in the playlist, the highest number is the start of the playlist with zero being the last item */
  playlistPosition?: InputMaybe<Scalars['Int']['input']>
}

/** Repsonse when updating a playlist item */
export type PlaylistUpdatePlaylistItemResponse = {
  __typename?: 'PlaylistUpdatePlaylistItemResponse'
  /** The playlist for the updated playlist item */
  playlist?: Maybe<Playlist>
  /** The playlist item which was updated */
  playlistItem?: Maybe<PlaylistItem>
}

/** Response when updating a playlist */
export type PlaylistUpdateResponse = {
  __typename?: 'PlaylistUpdateResponse'
  /** The updated playlist */
  playlist?: Maybe<Playlist>
}

/** Response when updating playlist visibility */
export type PlaylistUpdateVisibilityResponse = {
  __typename?: 'PlaylistUpdateVisibilityResponse'
  /** The playlist with updated visibility */
  playlist?: Maybe<Playlist>
}

/** Playlist visibility level */
export enum PlaylistVisibility {
  /** Playlist is searchable but owner is hidden */
  Anonymous = 'ANONYMOUS',
  /** Playlist is not searchable, only visible to owner */
  Private = 'PRIVATE',
  /** Playlist is searchable and shows author with profile link */
  Public = 'PUBLIC',
}

/** The where clause for a playlist id field */
export type PlaylistWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where conditions to filter rows */
export type PlaylistWhereInput = {
  /** The id */
  id?: InputMaybe<PlaylistWhereIdInput>
  /** The number of items in the playlist */
  itemCount?: InputMaybe<PlaylistWhereItemCountInput>
  /** The playlist name */
  playlistName?: InputMaybe<PlaylistWherePlaylistNameInput>
  /** The uid */
  uid?: InputMaybe<PlaylistWhereUidInput>
}

/** The where clause for a playlist item count field */
export type PlaylistWhereItemCountInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** The where clause for a playlist playlist name field */
export type PlaylistWherePlaylistNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Exclude rows where the value is in the list */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** The where clause for a playlist uid field */
export type PlaylistWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** A popular onboarding topic ranked by video reference count */
export type PopularTopic = {
  __typename?: 'PopularTopic'
  /** The content ID of the center tag */
  contentId: Scalars['Int']['output']
  /** The display title of the center tag */
  title: Scalars['String']['output']
  /** The title group ID of the center tag */
  titleGroupId: Scalars['String']['output']
  /** The number of unique published videos referencing this tag */
  videoRefCount: Scalars['Int']['output']
}

/** Response wrapper for the popularTopics query */
export type PopularTopicsResponse = {
  __typename?: 'PopularTopicsResponse'
  /** Length of topics in this response (equals topics.length; not a pre-limit total) */
  count: Scalars['Int']['output']
  /** The list of popular topics */
  topics: Array<PopularTopic>
}

/** Live engagement data for a community post (used by AI service for ranking) */
export type PostEngagement = {
  __typename?: 'PostEngagement'
  /** Username of the post author */
  authorUsername: Scalars['String']['output']
  /** When the post was created (ISO 8601) */
  createdAt: Scalars['String']['output']
  /** The post UUID */
  postId: Scalars['ID']['output']
  /** Total count of all reactions (REACTED + LIKED) */
  reactionsCount: Scalars['Int']['output']
  /** Total count of direct replies/comments */
  repliesCount: Scalars['Int']['output']
}

/** Aggregated reaction data for a single emoji */
export type PostReactionSummary = {
  __typename?: 'PostReactionSummary'
  /** Number of users who reacted with this emoji */
  count: Scalars['Int']['output']
  /** Whether the current user has reacted with this emoji */
  reacted: Scalars['Boolean']['output']
  /** The reaction emoji or custom key (e.g., '❤️' or 'gaia_earth') */
  reaction: Scalars['String']['output']
}

/** Product Change Log Entity Name */
export enum ProductChangeLogEntityName {
  /** Bonus */
  Bonus = 'Bonus',
  /** Bonus Campaign */
  BonusCampaign = 'BonusCampaign',
  /** BillingBulkDiscount */
  BulkDiscount = 'BulkDiscount',
  /** BillingDiscount */
  Discount = 'Discount',
  /** BillingProviderProduct */
  Plan = 'Plan',
  /** BillingPlanGrid */
  PlanGrid = 'PlanGrid',
  /** BillingProviderProductPricing */
  Price = 'Price',
  /** BillingProduct */
  Product = 'Product',
  /** BillingProvider */
  Provider = 'Provider',
  /** BillingProviderProductText */
  Text = 'Text',
}

/** Product Change Log Type */
export enum ProductChangeLogType {
  /** Create */
  Create = 'Create',
  /** Delete */
  Delete = 'Delete',
  /** Update */
  Update = 'Update',
}

/** Product Platform */
export enum ProductPlatform {
  /** Gaia */
  Gaia = 'Gaia',
  /** Yoga International */
  YogaInternational = 'YogaInternational',
}

/** Profile banner image with URL */
export type ProfileBannerImage = {
  __typename?: 'ProfileBannerImage'
  /** Full-size banner URL */
  url: Scalars['String']['output']
}

/** Profile picture with predefined size variants (signed imgix URLs) */
export type ProfilePicture = {
  __typename?: 'ProfilePicture'
  /** 190x266 profile card */
  card: Scalars['String']['output']
  /** 28x28 thumbnail */
  small: Scalars['String']['output']
  /** Full-size signed imgix URL */
  url: Scalars['String']['output']
}

/** Response from requesting a profile picture upload */
export type ProfilePictureUploadRequest = {
  __typename?: 'ProfilePictureUploadRequest'
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output']
  /** UUID for the pending image */
  imageUuid: Scalars['ID']['output']
  /** Presigned S3 PUT URL */
  uploadUrl: Scalars['String']['output']
}

/** Response from confirming a profile picture upload */
export type ProfilePictureUploadResponse = {
  __typename?: 'ProfilePictureUploadResponse'
  /** The profile picture URLs */
  profilePicture?: Maybe<ProfilePicture>
  /** Whether the upload was confirmed successfully */
  success: Scalars['Boolean']['output']
}

/** Profile picture URLs */
export type ProfilePictureUrls = {
  __typename?: 'ProfilePictureUrls'
  /** Profile picture URL in HDTV 190x266 size */
  hdtv_190x266?: Maybe<Scalars['String']['output']>
  /** Profile picture URL in small 28x28 size */
  small_28x28?: Maybe<Scalars['String']['output']>
}

/** Profile-level visibility */
export enum ProfileVisibility {
  Private = 'private',
  Public = 'public',
}

/** Provider Product Language */
export enum ProviderProductLanguage {
  /** German */
  De = 'de',
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
}

/** Provider Product Primary Stakeholder */
export enum ProviderProductPrimaryStakeholder {
  /** Marketing stakeholder */
  Marketing = 'marketing',
  /** Product stakeholder */
  Product = 'product',
}

/** Provider Product Term Type */
export enum ProviderProductTermType {
  /** day */
  Day = 'day',
  /** month */
  Month = 'month',
  /** week */
  Week = 'week',
  /** year */
  Year = 'year',
}

/** Provider Product Type */
export enum ProviderProductType {
  /** Course */
  Course = 'Course',
  /** Gift */
  Gift = 'Gift',
  /** Recurring subscription product */
  Recurring = 'Recurring',
}

/** Which app or PayPal brand a 2nd-party subscription belongs to. Apple: Gaia vs Yoga International. PayPal: MYO vs FMTV. Other providers leave platform null. */
export enum ProviderSubscriptionPlatform {
  /** FMTV (Gaia) PayPal */
  Fmtv = 'FMTV',
  /** Gaia */
  Gaia = 'Gaia',
  /** MYO (Yoga International) PayPal */
  Myo = 'MYO',
  /** Yoga International */
  YogaInternational = 'YogaInternational',
}

export enum PublishingAgentConfirmDecision {
  No = 'NO',
  Yes = 'YES',
}

export type PublishingAgentConfirmInput = {
  decision: PublishingAgentConfirmDecision
  sessionId: Scalars['String']['input']
}

export type PublishingAgentConfirmResult = {
  __typename?: 'PublishingAgentConfirmResult'
  cleared: Scalars['Boolean']['output']
  pendingMutation?: Maybe<PublishingAgentPendingMutation>
  resultText?: Maybe<Scalars['String']['output']>
  sessionId: Scalars['String']['output']
}

export type PublishingAgentMessage = {
  __typename?: 'PublishingAgentMessage'
  role: Scalars['String']['output']
  text: Scalars['String']['output']
}

export type PublishingAgentPendingMutation = {
  __typename?: 'PublishingAgentPendingMutation'
  proposedAt?: Maybe<Scalars['String']['output']>
  severity?: Maybe<Scalars['String']['output']>
  summary: Scalars['String']['output']
  toolName: Scalars['String']['output']
}

export type PublishingAgentScoreInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  labels?: InputMaybe<Array<Scalars['String']['input']>>
  score: Scalars['String']['input']
  sessionId: Scalars['String']['input']
}

export type PublishingAgentScoreResult = {
  __typename?: 'PublishingAgentScoreResult'
  accepted: Scalars['Boolean']['output']
}

export type PublishingAgentSession = {
  __typename?: 'PublishingAgentSession'
  activePacks: Array<Scalars['String']['output']>
  lastText?: Maybe<Scalars['String']['output']>
  messages: Array<PublishingAgentMessage>
  pendingMutation?: Maybe<PublishingAgentPendingMutation>
  sessionId: Scalars['String']['output']
}

export type PublishingAgentTurnInput = {
  message: Scalars['String']['input']
  sessionId: Scalars['String']['input']
}

export type PublishingAgentTurnResult = {
  __typename?: 'PublishingAgentTurnResult'
  activePacks: Array<Scalars['String']['output']>
  pendingMutation?: Maybe<PublishingAgentPendingMutation>
  sessionId: Scalars['String']['output']
  status: Scalars['String']['output']
  text: Scalars['String']['output']
}

export type Query = {
  __typename?: 'Query'
  _empty?: Maybe<Scalars['String']['output']>
  agentEnhancementsHubList: AgentEnhancementsHubListResponse
  aiSearchPlaylists: SearchPlaylistsResponse
  /** Generate a coherent, ordered playlist from a free-text prompt */
  alchemizePlaylist: AlchemizePlaylistResult
  /** Get a list of Ambassador lead */
  ambassadorLeadsCount: AmbassadorLeadsCountResponse
  /** Get a list of Ambassador lead */
  ambassadorLeadsList?: Maybe<AmbassadorLeadsListResponse>
  apiKeyList?: Maybe<ApiKeyListResponse>
  /** Get a list of assetProviders */
  assetProvidersList?: Maybe<AssetProvidersListResponse>
  /** Get a list of assets */
  assetsList?: Maybe<AssetsListResponse>
  /** Get a list of userInfo reference */
  authRoleList?: Maybe<AuthRoleListResponse>
  /**
   * Check scope tokens for OAuth/API use: each entry is split on spaces like the OAuth2 `scope` parameter.
   * Allowed values match OIDC built-ins (`openid`, `profile`, `email`, `offline_access`) or `auth_scope.name` rows.
   * Public read (no auth); does not grant access by itself.
   */
  authScopeCheck: AuthScopeCheckResponse
  authScopeList?: Maybe<AuthScopeListResponse>
  /**
   * Same behavior as GET /v1/authentication/check: returns the authenticated principal and applies optional
   * `requiredRoles` / `requiredScopes` / `requiredScopesAnd` / `enableScopeChecks` predicates via
   * `reqAuthorizationRoleIsAllowed` (see `docs/scopes-roles-and-authentication.md`).
   *
   * The field uses `@auth(enableScopeChecks: false)` so registry scope policy is driven only by resolver arguments,
   * matching the REST endpoint (not the directive’s default-deny layer). Implemented by `resolveAuthenticationCheck` in `server/authentication/index.ts`.
   */
  authenticationCheck: AuthenticationCheckPayload
  /** Get a list of billing accounts */
  billingAccountList: BillingAccountListResponse
  /** Checkout counts grouped by an allowlisted attribution param name. */
  billingCheckoutAttributionMetrics: BillingCheckoutAttributionMetricsResponse
  /** Paginated attribution param rows joined to the parent checkout. */
  billingCheckoutRequestAttributionParamList?: Maybe<BillingCheckoutRequestAttributionParamListResponse>
  /** Paginated marketing-safe checkout request rows. */
  billingCheckoutRequestList?: Maybe<BillingCheckoutRequestListResponse>
  /** Trial-to-paid metrics by attribution param. Paid events are RENEWAL only; SIGNUP is start-only. */
  billingCheckoutTrialToPaidMetrics: BillingCheckoutTrialToPaidMetricsResponse
  /** Get a bulk discount create batch by id (admin) */
  billingDiscountBulk?: Maybe<BillingDiscountBulk>
  billingDiscountEligible?: Maybe<BillingDiscountEligibilityResult>
  /** List billing discounts (admin). Filter by code, enabled, sku, active. */
  billingDiscountList?: Maybe<BillingDiscountListResponse>
  /**
   * Get a count of billing events. Useful for understanding payment activity volume
   * without loading all event data. Use where filters to count specific event types,
   * payment providers, or time periods.
   */
  billingEventCount: BillingEventCountResponse
  /**
   * Get a list of billing events. Use this to analyze a user's payment history and
   * determine their current payment state.
   *
   * Best Practices for Payment State Analysis:
   * 1. Filter by uid to get events for a specific user
   * 2. Filter by source if user has multiple payment providers
   * 3. Order by txnDate DESC to get most recent events first
   * 4. Filter by txnType to focus on specific event types (e.g., "payment", "renewal")
   * 5. Use limit to focus on recent events (most recent 10-20 events often sufficient)
   *
   * Example queries:
   * - Recent successful payments: where: { uid: { eq: "123" } }, order: [["txnDate", "DESC"]]
   * - Payment failures: where: { uid: { eq: "123" }, txnType: { eq: "payment" } }
   * - Specific provider: where: { uid: { eq: "123" }, source: { eq: "google" } }
   */
  billingEventList?: Maybe<BillingEventListResponse>
  /** Get a list of billingInvoice */
  billingInvoiceList?: Maybe<BillingInvoiceListResponse>
  /** Get a list of BillingOneTimePurchases */
  billingOneTimePurchaseList?: Maybe<BillingOneTimePurchaseListResponse>
  /** Get a list of billingPayments */
  billingPaymentList?: Maybe<BillingPaymentListResponse>
  /** Get a list of billingProviderProductPricing */
  billingPaymentMethodList?: Maybe<BillingPaymentMethodListResponse>
  /** Get a list of billingPlanGrids */
  billingPlanGridList?: Maybe<BillingPlanGridListResponse>
  /** Get a list of billingProducts */
  billingProductChangeLogList?: Maybe<BillingProductChangeLogListResponse>
  /** Get a list of unique users who made billing product changes */
  billingProductChangeLogUsers?: Maybe<BillingProductChangeLogUserListResponse>
  /** Get a list of billingProducts */
  billingProductList?: Maybe<BillingProductListResponse>
  /** Get a list of billingProviderCurrency */
  billingProviderCurrencyList?: Maybe<BillingProviderCurrencyListResponse>
  /** Get a list of billingProviders */
  billingProviderList?: Maybe<BillingProviderListResponse>
  /** Check eligibility for a plan on a given page (checkout or planChange). Optional customer JWT for user-specific rules. */
  billingProviderProductEligibility?: Maybe<BillingProviderProductEligibilityResult>
  /** List eligibility rules (admin). Filter by plan, scope, rule type, enabled. */
  billingProviderProductEligibilityList?: Maybe<BillingProviderProductEligibilityListResponse>
  /** Get a list of billingProviderProducts */
  billingProviderProductList?: Maybe<BillingProviderProductListResponse>
  /** Get a list of billingProviderProductPricing */
  billingProviderProductPricingList?: Maybe<BillingProviderProductPricingListResponse>
  /** Get a list of billingProviderProductText reference */
  billingProviderProductTextList?: Maybe<BillingProviderProductTextListResponse>
  billingProviderProductTextTranslate?: Maybe<BillingProviderProductTextTranslateResponse>
  /** Verify billingProviderProductTexts */
  billingProviderProductTextVerify?: Maybe<Array<Maybe<BillingProviderProductTextVerifyError>>>
  /** Get a list of billingRefunds */
  billingRefundList?: Maybe<BillingRefundListResponse>
  /** Get a list of user accounts */
  billingSubscriptionList?: Maybe<BillingSubscriptionListResponse>
  /** Get a list of billingSubscriptionOrders */
  billingSubscriptionOrderList?: Maybe<BillingSubscriptionOrderListResponse>
  /** Get a list of user accounts */
  billingSubscriptionOrderPlanList?: Maybe<BillingSubscriptionOrderPlanListResponse>
  /** Get a list of billingSubscriptionPlans */
  billingSubscriptionPlanList?: Maybe<BillingSubscriptionPlanListResponse>
  /** @deprecated Use marketingMessagingCampaignEngagementDayList */
  brazeCampaignEngagementDayList?: Maybe<BrazeCampaignEngagementDayListResponse>
  /** @deprecated Use marketingMessagingCampaignList */
  brazeCampaignList?: Maybe<BrazeCampaignListResponse>
  /** Load Braze profile attributes for a member by user_info uuid (email resolved server-side) */
  brazeUserProfileAttributes: BrazeUserProfileAttributesResult
  /** @deprecated Use marketingMessagingAccountList */
  brazeWorkspaceList?: Maybe<BrazeWorkspaceListResponse>
  /** List bulk discount create batches (admin). Filter by id, uuid, description, quantity. */
  bulkDiscountList?: Maybe<BulkDiscountListResponse>
  /** Oracle AI: List channel prompt sets */
  channelPromptSetList: ChannelPromptSetListResponse
  /** Feed-scoped invite search. There is no mode argument: the server DERIVES how wide the search is from the caller's own role, so a client can never ask for more than it is entitled to. A site admin, or a circle admin of THAT feed, gets the account-wide search — the named searchType (name, email or username) across ALL accounts, including private-visibility profiles and accounts with no community profile, with emails populated. A plain member of THAT feed, or a feed moderator of THAT feed, gets the member-facing search — PUBLIC profiles matching the display name, NAME only, emails always null. Anyone else is refused. Existing feed members are always excluded in both. The role plus the feed scoping are jointly what license the wide reach; without both this would be a general user-enumeration endpoint */
  circleInviteSearch: CircleInviteCandidateConnection
  /** The viewer's top-3 rainbow-category circle options for the final onboarding screen (full or unseeded circles omitted; empty list = hide the offer) */
  circlesForOnboarding: Array<OnboardingCircleOption>
  /** CMS playlist videos for admin import preview, including whether each Brightcove id already has an ms_clip in Gaia. Omit offset/limit to return the full playlist; pass both to fetch a slice (AP-19127). */
  clipBrightcovePlaylistVideos: ClipBrightcovePlaylistVideosResponse
  /**
   * Returns published vertical clips with their parent video context (clip-vert).
   *
   * sortOrder:
   * - RANDOM (default): unordered eligible clips
   * - PERSONALIZE: personalized swipe feed for the viewer; falls back to RANDOM if personalization fails
   *
   * Pagination for PERSONALIZE: pass the previous response's recommId to get the next batch without
   * repeating prior items. Do not send firstWhere with recommId (pin is session-start only).
   *
   * firstWhere: when set on the first page (no recommId), that clip is returned first if eligible
   * (published, clip-vert, content policy); remaining slots come from the active sort strategy.
   * firstWhere does not filter the rest of the feed. Invalid with recommId.
   */
  clipList?: Maybe<ClipListResponse>
  /** Validate social manifest parents and inspect Brightcove/Gaia state before import (AP-19166). */
  clipSocialManifestPreview: Array<ClipSocialManifestPreviewRow>
  /** Get a list of comments */
  commentList?: Maybe<CommentsListResponse>
  /**
   * The members who reacted to one comment with one emoji.
   *
   * A root query taking a single (comment, reaction) pair rather than a field on
   * `CommentReactionSummary`, and that is the point: as a field, a client could select it for every
   * comment on a 100-comment page and turn the hot path into hundreds of queries. CO-645 folded the
   * summaries into one grouped aggregate precisely to avoid that, and a field here would hand the
   * cost straight back. Asking for one comment at a time makes the regression impossible to express.
   *
   * No `totalCount` — `CommentReactionSummary.count` already carries it, and the client holds the
   * summary before it ever opens this list.
   *
   * ⚠️ Private profiles ARE listed. They appear as the public shell CO-644 established — display
   * name and avatar, nothing more — because the comment itself already shows a private author that
   * way, and listing a commenter while hiding a reactor would be incoherent. Field-level privacy is
   * enforced by `UserProfile`, not by omitting the row. This deliberately diverges from
   * `communityReactionParticipants`, which filters `profile_visibility != 'private'`; that filter
   * predates CO-642 making new profiles default to private, so on comments it would hide nearly
   * everyone who has reacted.
   *
   * Returns an empty connection, never an error, for a comment the caller cannot see — a held
   * comment must not leak its reactors, and must not confirm its own existence either.
   */
  commentReactionParticipants: UserProfileConnection
  /** Get a single community event by ID */
  communityEvent?: Maybe<CommunityEvent>
  /** Get calendar invite (ICS format) */
  communityEventCalendarInvite: Scalars['String']['output']
  /** List events in a feed */
  communityEventsByFeed: CommunityEventConnection
  /** Get a single community feed by ID */
  communityFeed?: Maybe<CommunityFeed>
  /** Get a list of community feeds with cursor-based pagination */
  communityFeedList: CommunityFeedConnection
  /** Get all members in a community feed */
  communityFeedMembers: CommunityFeedMemberConnection
  /** Get community leaderboard */
  communityLeaderboard: Array<CommunityLeaderboardEntry>
  /** Get moderation queue (admin only) */
  communityModerationQueue: CommunityModerationReportConnection
  /** Get a single community post by ID */
  communityPost?: Maybe<CommunityPost>
  /** Bulk post engagement data for AI service ranking — returns reactions, replies, author, and created date for given post IDs */
  communityPostEngagement: Array<PostEngagement>
  /** Get a list of community posts with cursor-based pagination */
  communityPostList: CommunityPostConnection
  /** Bulk community posts for AI service ingestion — returns all posts across all feeds without membership filtering */
  communityPostsForIngest: CommunityPostConnection
  /** Get the list of users who reacted with a specific emoji */
  communityReactionParticipants: UserProfileConnection
  /** Bulk community replies for AI service ingestion — returns comments/replies across all feeds without membership filtering */
  communityRepliesForIngest: CommunityPostConnection
  /** Search community content */
  communitySearch: CommunityPostConnection
  /** Active playback companions for a title (video only). Omit role to return the winner per role. */
  companions: Array<PlaybackCompanionRef>
  /** Fetch AI-generated summary and transcript metadata by media asset or content and language. */
  contentAIMetadata?: Maybe<MediaAssetAiMetadata>
  /** Get a list of Content analytic */
  contentAnalyticsList?: Maybe<ContentAnalyticsListResponse>
  /** Get a list of content asset reference types */
  contentAssetReferenceTypesList?: Maybe<ContentAssetReferenceTypesListResponse>
  /** Get a list of content asset reference types */
  contentAssetReferencesList?: Maybe<ContentAssetReferencesListResponse>
  /** Get a list of content reference */
  contentFilterList?: Maybe<ContentFilterListResponse>
  /** Get a list of content reference */
  contentFilterSetList?: Maybe<ContentFilterSetListResponse>
  /** Get a list of content reference */
  contentList?: Maybe<ContentListResponse>
  /** Get a list of content reference */
  contentListCriteriaList?: Maybe<ContentListCriteriaListResponse>
  /** Get a list of content reference */
  contentPolicyList?: Maybe<ContentPolicyListResponse>
  /** Get a list of content reference */
  contentProviderList?: Maybe<ContentProviderListResponse>
  /** Get a list of content reference types */
  contentReferenceTypesList?: Maybe<ContentReferenceTypesListResponse>
  /** Get a list of content references allowed */
  contentReferencesAllowedList?: Maybe<ContentReferencesAllowedResponse>
  /** Get a list of content reference */
  contentReferencesList?: Maybe<ContentReferencesListResponse>
  /** Get a list of media */
  contentSearchList?: Maybe<ContentSearchListResponse>
  /** Get a list of userInfo reference */
  contentSetList?: Maybe<ContentSetListResponse>
  /** Continue-watching plus tag-based Recombee recommendations. Requires authentication. */
  continueWatchingTaggedRecs?: Maybe<ContinueWatchingTaggedRecs>
  /** Get all profiles in the current authenticated user's account */
  currentAccountProfiles: Array<AccountMemberProfile>
  /** Get a custom emoji by ID or key */
  customEmoji?: Maybe<CustomEmoji>
  /** List all custom emojis */
  customEmojiList: Array<CustomEmoji>
  /** Get demographics data for an email address */
  demographics?: Maybe<DemographicsResponse>
  /** Fetch a divination collection by id. */
  divinationCollection?: Maybe<DivinationCollection>
  /** Fetch a divination collection by type and collection key. */
  divinationCollectionByKey?: Maybe<DivinationCollection>
  /** Fetch a collection and all objects by type and collection key. */
  divinationCollectionObjectsByKey?: Maybe<DivinationCollectionObjects>
  /** Fetch all divination collections for a type. */
  divinationCollectionsByType: Array<DivinationCollection>
  /** Fetch bundled divination feature state for tarot/oracle/horoscope. */
  divinationFeatureState: DivinationFeatureStates
  /** Fetch a divination object by id. */
  divinationObject?: Maybe<DivinationObject>
  /** Latest tarot reading for an oracle chat session. Members can only read sessions they own; reading an arbitrary session requires a privileged role plus the explicit gaia:oracle:read-all scope (e.g. the Braze Connected Content service token) — empty scopes alone are not enough. When recipientUuid is supplied, the session must belong to that user for every caller including privileged read-all tokens. Unauthenticated or wrong-scope callers error like any @auth field; an authenticated caller without cross-user access resolves null for a session that is missing, holds no tarot reading, or is not theirs - the same null in every case, so session existence is never leaked. */
  divinationReading?: Maybe<DivinationReading>
  /** Feature-scoped seed-question list */
  divinationSeedQuestionList: SeedQuestionListResponse
  /** Oracle AI: Distinct front-image keys for divination objects this user has pulled, ordered by most recent pull (newest first). Optional `type` selects tarot (default) or oracle card readings. */
  divinationUniquePulledCardImageKeyList: Array<Scalars['String']['output']>
  /**
   * List **`document_abstracts`** via Knex **`documentAbstractListByPaginated`** / **`documentAbstractCount`** (same idea as **`embeddingConfigsList`**).
   *
   * **`query`:** When non-empty after trim, the text is embedded with the **`document_abstracts`** embedding config (**`documentQueryEmbedding`**), then rows are ranked by pgvector **cosine distance** (`<=>`) on **`summary_embedding`** (**`documentAbstractListByCosineSimilarity`**). Optional **`where`** applies before ranking. **`order`** is ignored in this mode; use **`limit`** / **`offset`** on the ranked list.
   *
   * **`useMaster`:** Read from primary when true (e.g. post-mutation consistency).
   */
  documentAbstractList?: Maybe<DocumentAbstractListResponse>
  /**
   * List **`document_embeddings`** rows with `where` / `order` / pagination. Use for operational queries and precise metadata filters.
   *
   * **`query`:** When non-empty after trim, the text is embedded via the same path as **`documentQueryEmbedding`** / **`Content.relatedDocumentEmbeddings`** (`documentQueryEmbedding` loader with the live **`document_embeddings`** embedding config), then rows are ranked by pgvector **cosine distance** (`<=>`) against each chunk's stored vector. Optional **`where`** scopes rows before ranking (same filters as the non-semantic list). **`order`** in this mode sorts the ranked window (default **`[['score','ASC']]`** — best match first; **`score`** matches **`DocumentEmbedding.queryRelevance`**). Use **`limit`** / **`offset`** on that ordered list.
   *
   * **List mode (no `query`):** When **`order`** is omitted, it defaults to **`[['documentsId','ASC'],['documentNumber','ASC']]`**.
   *
   * **MCP hint:** For content-scoped chunk retrieval, use **`Content.relatedDocumentEmbeddings`** with **`query`**. Use this list for admin-style global or metadata-filtered semantic search over **`document_embeddings`**.
   */
  documentEmbeddingsList?: Maybe<DocumentEmbeddingsListResponse>
  /** Generate multiple queries from a single input query */
  documentMultiQuery?: Maybe<DocumentMultiQueryResponse>
  /** Generate an embedding using a query; model is resolved from embedding_config for the given key */
  documentQueryEmbedding?: Maybe<DocumentQueryEmbeddingResponse>
  /** Using natural language run chains against documents embedding data to get answers */
  documentsCallChain?: Maybe<Array<Maybe<DocumentCallChainResponse>>>
  /** List documents filter by where clauses */
  documentsList?: Maybe<DocumentsListResponse>
  /** Next Top and Bottom dreamscapes for this client dream */
  dreamNextImagePair: DreamNextImagePair
  /**
   * Returns a personalized page layout for the authenticated user.
   * The layout is a list of typed blocks that the frontend renders
   * via a block registry.
   */
  dynamicLayout: DynamicLayoutResponse
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingBonusEligibilitiesList: EcommerceSkuMappingBonusEligibilitiesListResponse
  /** Get a list of ecommerce sku mappings */
  ecommerceSkuMappingsList: EcommerceSkuMappingsListResponse
  /** List embedding configuration rows with optional filters (site admin only) */
  embeddingConfigsList?: Maybe<EmbeddingConfigsListResponse>
  entityRecognition: EntityRecognitionResult
  /** Alias of divinationSeedQuestionList */
  featureSeedQuestionList: SeedQuestionListResponse
  /** Get playlists followed by a user with cursor-based pagination */
  followedPlaylists: PlaylistFollowedConnection
  /**
   * Get exchange rates for a list of currency pairs.
   * If a pair is missing from the database or has a stale rate, a fresh rate is
   * fetched from the CurrencyLayer service and the database is updated before returning.
   */
  forexRatesList?: Maybe<Array<Maybe<ForexRate>>>
  /** Look up a Shopify gift card by code (balance and status) */
  giftCardByCode?: Maybe<GiftCardDetails>
  /**
   * Enrich content IDs with graph context (centers, teachers, cowatch, adjacent domains).
   * Mode 2 of GraphRAG — for when content is already known and relationship context is needed.
   */
  graphEnrich: Array<GraphEnrichResult>
  /** Single-hop neighbor traversal from a starting entity. edgeTypes is required to force indexed access. */
  graphNeighbors: GraphNeighborResponse
  /** Look up a single graph node by entity identity */
  graphNode?: Maybe<GraphNode>
  /** Two-hop path traversal: start -[hop1]-> intermediate -[hop2]-> terminal. Results grouped by terminal node with aggregated weight. */
  graphPath: GraphPathResponse
  /**
   * Lightweight graph-powered content search for agent tools (GraphRAG).
   * Entity recognition + graph traversal + semantic search + RRF merge.
   * No overview, no chips, no session management.
   */
  graphSearch: Array<GraphSearchResult>
  /** Get a list of image content relationships */
  imageContentRelationshipsList?: Maybe<ImageContentRelationshipsListResponse>
  /** Get a list of image content relationships */
  imageContentRelationshipsListByContent?: Maybe<ImageContentRelationshipsListResponse>
  /** Get a list of images */
  imagesList?: Maybe<ImagesListResponse>
  /** Oracle AI: List available interest topic options */
  interestTopicOptions: Array<InterestTopicOption>
  /** Check if a profile is visible to a viewer. Used by video-analytics for Option B (public profile watch history). Viewer must be the authenticated user. */
  isProfileVisibleToViewer: Scalars['Boolean']['output']
  /** Distinct job names on localization strings, sorted ascending */
  localizationStringJobNameList: Array<Scalars['String']['output']>
  /** Get a list of localization strings */
  localizationStringList?: Maybe<LocalizationStringListResponse>
  marketingAdAccountList: MarketingAdAccountListResponse
  marketingAdGroupList: MarketingAdGroupListResponse
  marketingAdList: MarketingAdListResponse
  marketingAdTargetingList: MarketingAdTargetingListResponse
  marketingAdTargetingReferenceList: MarketingAdTargetingReferenceListResponse
  marketingAgentSession: MarketingAgentSession
  marketingAirCreativeGet: MarketingCreativeVendorResponse
  marketingAirCreativeGetDeliveryUrl: MarketingCreativeVendorResponse
  marketingAirCreativeList: MarketingCreativeVendorResponse
  marketingAnalyticsEvaluateThreshold: MarketingAnalyticsThresholdResult
  marketingAnalyticsList: MarketingAnalyticsResult
  marketingAnalyticsReportTask: MarketingAnalyticsReportTaskResult
  marketingCampaignAssetList: MarketingCampaignAssetListResponse
  marketingCampaignList: MarketingCampaignListResponse
  marketingCampaignListPerformance: MarketingCampaignPerformanceResponse
  marketingCampaignSearch: MarketingCampaignSearchResponse
  marketingConversionPipelineHealthGet: MarketingConversionPipelineHealth
  marketingConversionValueGet: MarketingConversionValueResult
  marketingCreativeGenerationJobGet?: Maybe<MarketingCreativeGenerationJob>
  marketingCreativeGenerationJobList: MarketingCreativeGenerationJobListResponse
  marketingKeywordList: MarketingKeywordListResponse
  marketingLandingPageGet: MarketingCreativeVendorResponse
  marketingMemberDaySnapshotList: MarketingMemberDaySnapshotListResult
  marketingMemberPaymentProfileGet: MarketingMemberPaymentProfileResult
  marketingMessagingAccountList?: Maybe<MarketingMessagingAccountListResponse>
  marketingMessagingCampaignEngagementDayList?: Maybe<MarketingMessagingCampaignEngagementDayListResponse>
  marketingMessagingCampaignGet: MarketingMessagingCampaignGetResponse
  marketingMessagingCampaignList?: Maybe<MarketingMessagingCampaignListResponse>
  marketingMessagingCampaignPerformanceList: MarketingMessagingCampaignPerformanceListResponse
  marketingMessagingTemplateGet: MarketingMessagingTemplateGetResponse
  marketingMessagingTemplateList: MarketingMessagingTemplateListResponse
  marketingMetricDayList: MarketingMetricDayListResponse
  marketingOperatorRecommendationList: MarketingOperatorRecommendationListResponse
  marketingPulseGet: MarketingPulse
  marketingReportExclusionGet?: Maybe<MarketingReportExclusion>
  marketingReportExclusionList: MarketingReportExclusionListResponse
  marketingReportExplain: MarketingReportExplanation
  marketingReportGet?: Maybe<MarketingReport>
  marketingReportList: MarketingReportListResponse
  marketingReportStatusList: Array<MarketingReportStatusSummary>
  marketingResearchJobGet?: Maybe<MarketingResearchJob>
  marketingResearchJobList: MarketingResearchJobListResponse
  marketingTranslateContent: MarketingCreativeVendorResponse
  /** Presigned download URL for mezzanine MP4 (on demand) */
  mediaAssetMezzanineDownload: MediaAssetMezzanineDownload
  /** Mezzanine raw media availability for a stream asset (HeadObject; no presign) */
  mediaAssetMezzanineRaw: MediaAssetMezzanineRaw
  /** Get a list of media assets */
  mediaAssetsList?: Maybe<MediaAssetListResponse>
  /** Get a list of media */
  mediaList?: Maybe<MediaListResponse>
  /**
   * Human-vs-AI disagreements for calibration. Each applicable LLM verdict (one that actually set
   * the comment's status) is paired with the FIRST human decision — PUBLISHED, REJECTED or
   * UNPUBLISHED — that answered that verdict on the same text (recorded on the human ledger row as
   * `verdictEventId`); interim human statuses and decisions on edited text are not pairs, and a
   * re-classified edit starts a new pair. `since` windows on the verdict's time (facets are a
   * cohort: "of verdicts issued since X, how many did a human overturn"). Items are newest human
   * decision first. Human decisions recorded before this field existed are not paired.
   */
  moderationOverrides: ModerationOverrideConnection
  /**
   * The moderation review queue. Default (no status) = AI_FLAGGED (the comments the AI held for review).
   * Filter by a single `status`, or a `statuses` list for a combined "needs moderation" view
   * (e.g. AI_FLAGGED + PENDING_REVIEW + NEEDS_REVIEW); `statuses` takes precedence over `status`.
   * Also filter by `containerId` (the video/circle the comment is on — `comments.content_id`),
   * author, or a single item id. The `itemId` filter is the moderated item's own id (a comment id),
   * not the container it is on. The ledger filters (`source`, `category`, `minTopScore`) restrict
   * the set before pagination, so `total` is the size of the filtered set.
   */
  moderationQueue: ModerationQueueConnection
  /** Get all feeds the authenticated user is a member of with cursor-based pagination */
  myCommunityFeeds: CommunityFeedConnection
  /** Bulk list of user-to-content subscriptions (teacher/series/host follows) for graph ingestion */
  notificationsSubscriptionsList: NotificationsSubscriptionsListResponse
  /** Oracle AI: Find cross-topic nudge post and feed suggestion */
  nudgeAndSuggestion: NudgeAndSuggestionResult
  /** Get a list of OAuth clients (admin only) */
  oauthClientList?: Maybe<OAuthClientListResponse>
  /** Oracle AI: Get current onboarding settings for the user */
  onboardingSettings: OnboardingSettings
  /** Oracle AI: Get onboarding state for the current user */
  onboardingState: OnboardingState
  /** Oracle AI: Get a chat session by ID */
  oracleChatSession?: Maybe<OracleChatSession>
  /**
   * Oracle AI: Get chat sessions with optional filtering
   *
   *         Available ordering fields:
   *         - createdAt: Order by chat session creation time
   *         - updatedAt: Order by chat session last update time
   *         - name: Order by chat session name
   *         - id: Order by chat session ID
   *         - exportIndex: Order by export index
   *         - activityUpdatedAt: Order by most recent message activity (COALESCE of latest message created_at, fallback to session created_at)
   *
   *         Order format: [["fieldName", "ASC|DESC"], ...]
   *         Example: [["activityUpdatedAt", "DESC"], ["name", "ASC"]]
   */
  oracleChatSessionList: OracleChatSessionListResponse
  /** Oracle AI: Semantic search over transcript chunks (VTT) by language */
  oracleChunkSemanticSearch: Array<OracleTranscriptChunk>
  /** Oracle AI: Get server health status and version information */
  oracleHealth: OracleHealthResponse
  /** Oracle AI: List scoped LLM config sets */
  oracleLlmConfigSetList: OracleLlmConfigSetListResponse
  /** Oracle AI: Get individual messages, optionally filtered by chat session */
  oracleMessageList: OracleMessageListResponse
  /** Oracle AI: Get a message pair by ID */
  oracleMessagePair?: Maybe<OracleMessagePair>
  /** Oracle AI: Get message pairs with optional filtering */
  oracleMessagePairList: OracleMessagePairListResponse
  /** Oracle AI: Get assistant variants for a message pair */
  oracleMessagePairVariants: Array<OracleMessagePairVariant>
  /** Oracle AI: Get all personalities */
  oraclePersonalityList: OraclePersonalityListResponse
  /** Oracle AI: Generate a personalized playlist (no session) */
  oraclePlaylistGenerate: OraclePlaylistGenerateResult
  /** Oracle AI: Admin fetch of a Prompt Library category */
  oraclePromptLibraryAdminCategory?: Maybe<OraclePromptLibraryAdminCategory>
  /** Oracle AI: Admin list of Prompt Library categories */
  oraclePromptLibraryAdminCategoryList: OraclePromptLibraryAdminCategoryListResponse
  /** Oracle AI: Admin fetch of a Prompt Library prompt (includes instruction) */
  oraclePromptLibraryAdminPrompt?: Maybe<OraclePromptLibraryAdminPrompt>
  /** Oracle AI: Admin list of Prompt Library prompts */
  oraclePromptLibraryAdminPromptList: OraclePromptLibraryAdminPromptListResponse
  /** Oracle AI: Admin fetch of a Prompt Library theme */
  oraclePromptLibraryAdminTheme?: Maybe<OraclePromptLibraryAdminTheme>
  /** Oracle AI: Admin list of Prompt Library themes */
  oraclePromptLibraryAdminThemeList: OraclePromptLibraryAdminThemeListResponse
  /** Oracle AI: Fetch a single Prompt Library category by id. audience is a catalog partition, not an authorization check. */
  oraclePromptLibraryCategory?: Maybe<OraclePromptLibraryCategory>
  /** Oracle AI: Paginated Prompt Library categories. audience is a catalog partition, not an authorization check. */
  oraclePromptLibraryCategoryList: OraclePromptLibraryCategoryListResponse
  /** Oracle AI: Discoverable Prompt Library category display styles */
  oraclePromptLibraryDisplayStyleList: Array<OraclePromptLibraryDisplayStyleOption>
  /** Oracle AI: Personalized search powered by the AI agent */
  oracleSearch: OracleSearchResult
  /** Oracle AI: Public read access for a shared message pair snapshot */
  oracleSharedMessagePair?: Maybe<OracleSharedMessagePair>
  /** Oracle AI: Curated visualizer catalog for site admins (launch paths under /api/visualizer). */
  oracleVisualizerCatalog: OracleVisualizerCatalog
  /** Resolve a site path to routing data and SEO meta */
  pathInfo: PathInfo
  /** Get a list of content reference */
  pathRedirectList?: Maybe<PathRedirectListResponse>
  playbackCompanionsList?: Maybe<PlaybackCompanionsListResponse>
  /** Bulk playlist engagement data for AI service ranking */
  playlistEngagement: Array<PlaylistEngagement>
  /** Bulk list of playlist follow relationships for knowledge graph ingestion */
  playlistFollowsList: PlaylistFollowsListResponse
  /** Get a list of PlaylistItem */
  playlistItemList?: Maybe<PlaylistItemListResponse>
  /** Get a list of Playlist */
  playlistList?: Maybe<PlaylistListResponse>
  /** Search public/anonymous playlists by name or description using full-text search */
  playlistSearch: PlaylistSearchConnection
  /** Find public/anonymous playlists containing given content IDs (for AI search) */
  playlistsByContentIds: Array<ContentPlaylistMapping>
  /** Get a list of PM Lists */
  pmListList?: Maybe<PmListListResponse>
  /** Get a list of PM Screens */
  pmScreenList?: Maybe<PmScreenListResponse>
  /**
   * Get a personalized PM Screen considering the request which is used in application
   * UI to display the correct screen
   */
  pmScreenPersonalized: PmScreenPersonalizedResponse
  /** Get a list of PM Sections */
  pmSectionList?: Maybe<PmSectionListResponse>
  /** Get popular onboarding topics ranked by video reference count. Requires authentication; any authenticated user may call this query. */
  popularTopics?: Maybe<PopularTopicsResponse>
  /** Get a standardized subscription summary for a user from a single 2nd-party billing provider (receipt-based stores, or PayPal events) */
  providerSubscription?: Maybe<SecondPartyProviderSubscription>
  publishingAgentSession: PublishingAgentSession
  /** List per-action Fingerprint signal switches (site admin only) */
  rateLimitActionConfigList?: Maybe<RateLimitActionConfigListResponse>
  /** List recorded rate-limit actions (site admin only) */
  rateLimitActionList?: Maybe<RateLimitActionListResponse>
  /** List allow and block overrides (site admin only) */
  rateLimitOverrideList?: Maybe<RateLimitOverrideListResponse>
  /** List rate-limit checks (site admin only) */
  rateLimitRequestList?: Maybe<RateLimitRequestListResponse>
  /** List rate-limit rules (site admin only) */
  rateLimitRuleList?: Maybe<RateLimitRuleListResponse>
  /** Oracle AI: Get current rate limit status for the user */
  rateLimitStatus: RateLimitInfo
  /** Get a list of raw events */
  rawEventList?: Maybe<RawEventListResponse>
  /** Get personalized content recommendations for a user, powered by Recombee. Designed for external channel integrations like Braze email campaigns. Target user is optional: pass at most one of uid or uuid; if both are omitted, the authenticated user is used. */
  recommendationList: RecommendationResponse
  relatedBillingProviderProductList?: Maybe<BillingProviderProductListResponse>
  /**
   * Primary content search query. Returns ranked content results (videos, series).
   * No @auth — anonymous users can search (matches old REST search behavior).
   * Personalization gracefully degrades when uid is absent.
   */
  search: SearchContentResponse
  /** Search message pairs by text content */
  searchMessagePairs: ConversationSearchResponse
  /**
   * Playlist search and discovery.
   * Empty query = personalized discovery via knowledge graph.
   * With query = entity recognition + graph + trigram search.
   * Returns ranked playlist IDs — frontend hydrates via playlistList.
   */
  searchPlaylists: PlaylistSearchResponse
  /**
   * The AP-19220 header-dropdown suggestion columns. uid comes from the
   * authenticated context — no user ever reads another user's history.
   */
  searchSuggestions?: Maybe<SearchSuggestionsResponse>
  /** Session facts for seed-question action rows. Brooklyn calls this with the client's chatSessionId. */
  seedQuestionActionVisibility?: Maybe<SeedQuestionActionVisibility>
  /** General seed-question list */
  seedQuestionList: SeedQuestionListResponse
  /** Oracle AI: Multi-table semantic search for carousel candidates */
  semanticSearchCarousel: SemanticSearchCarouselResult
  /** List influencer / worker job runs */
  socialsInfluencerJobRunList?: Maybe<SocialsInfluencerJobRunListResponse>
  /** List spider content rows */
  socialsSpiderContentList?: Maybe<SocialsSpiderContentListResponse>
  /** List spider content metrics snapshots */
  socialsSpiderContentMetricsList?: Maybe<SocialsSpiderContentMetricsListResponse>
  /** List spider Apify jobs */
  socialsSpiderJobsList?: Maybe<SocialsSpiderJobsListResponse>
  /** List spider keywords */
  socialsSpiderKeywordsList?: Maybe<SocialsSpiderKeywordsListResponse>
  /** Get a list of testarossa subjects */
  testarossaSubjectsList?: Maybe<TestarossaSubjectsListResponse>
  /** Get a list of testarossaUsers */
  testarossaUsersList?: Maybe<TestarossaUsersListResponse>
  /** Get a count of transactions */
  transactionCount: TransactionCountResponse
  /** Get a list of transactions */
  transactionList?: Maybe<TransactionListResponse>
  transcriptChunkLookupProject?: Maybe<TranscriptChunkLookupProject>
  transcriptChunkLookupProjectList: Array<TranscriptChunkLookupProject>
  transcriptChunkLookupProjectRawExportBundle: TranscriptChunkRawExportBundle
  /** Unauthenticated seed chips for the WordPress Highlights sampler. */
  transcriptChunkSamplerSeeds: Array<TranscriptChunkSamplerSeed>
  /**
   * Semantic search over timed transcript chunks (`document_embeddings` where chunk_kind = transcript_timed).
   * MEMBER purpose: subscription SKUs 253/280/290 or elevated roles. CHUNK_LOOKUP: elevated roles only.
   */
  transcriptChunkSearch: TranscriptChunkSearchResult
  /** Unauthenticated sampler search. Input is seedQuestionId only (no freeform prompt). */
  transcriptChunkSearchAnonSampler: TranscriptChunkSamplerSearchResult
  transcriptChunkSessionGet?: Maybe<TranscriptChunkSession>
  transcriptChunkSessionList: TranscriptChunkSessionListResult
  /** Get a list of user accounts */
  userAccountList?: Maybe<UserAccountListResponse>
  /** Get a list of userAuditLogs */
  userAuditLogList?: Maybe<UserAuditLogListResponse>
  /** Get a list of billingPlanGrids for a user */
  userBillingPlanGridList?: Maybe<UserBillingPlanGridListResponse>
  /** Get a list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilitiesList: UserEcommerceSkuMappingBonusEligibilitiesListResponse
  /**
   * Get a list of user entitlements. Returns entitlements based on the provided filters.
   * Access is restricted to users with elevated roles (SITE_ADMIN, CUSTOMER_SERVICE, CUSTOMER_SERVICE_MANAGER)
   * or users accessing their own entitlements (or entitlements for their account).
   */
  userEntitlementList?: Maybe<UserEntitlementListResponse>
  /** Bulk list of user follow relationships for knowledge graph ingestion */
  userFollowsList?: Maybe<UserFollowsListResponse>
  /** Get a list of user history events */
  userHistoryEventsList?: Maybe<UserHistoryEventsListResponse>
  /** Get a list of user history which is partitioned by uid consider the userHistory argument with a uid value for better performance */
  userHistoryList?: Maybe<UserHistoryListResponse>
  /** User info for the user currently making this request */
  userInfoCurrent?: Maybe<UserInfoCurrentResponse>
  /** Get a list of userInfo reference */
  userInfoList?: Maybe<UserInfoListResponse>
  /**
   * Get public user profiles by UIDs or UUIDs.
   * Requires authentication. Returns limited public fields for any users.
   * Designed for features where user profiles need to be displayed publicly.
   *
   * Maximum 100 users per request for performance.
   * Uses DataLoader batching for efficient database queries.
   *
   * Example use cases:
   * - Fetch authors for a list of posts
   * - Fetch participants who reacted to content
   * - Display user profile pages
   */
  userInfoPublic: Array<UserInfoPublic>
  /** Get a paginated list of users who have demographic metadata */
  userInfoWithMetadata: UserInfoWithMetadataResponse
  /** Get a list of user media positions */
  userMediaPositionList?: Maybe<UserMediaPositionListResponse>
  /** Get a list of user meta tags */
  userMetaTagList?: Maybe<UserMetaTagListResponse>
  /** List user ids in user_meta that lack expiry-level rainbow category tags (admin backfill) */
  userMetaTagMissingRainbowDefaultsList?: Maybe<UserMetaTagMissingRainbowDefaultsListResponse>
  /**
   * Get the user metadata entries for a user. Site admins may read any uid's
   * full row set; a regular authenticated viewer may read ONLY their own uid,
   * scoped to preference-type rows (the self-service carve-out — the
   * admin-vs-self rule is enforced in the resolver, so the directive gates
   * authentication only).
   */
  userMetadataList: Array<UserMetadata>
  /** Get a user profile by UID (requires auth, respects visibility) */
  userProfileByUid?: Maybe<UserProfile>
  /** Get a user profile by UUID (authenticated) */
  userProfileByUuid?: Maybe<UserProfile>
  /** Get paginated list of mutual follows (connections) for a user */
  userProfileConnections?: Maybe<UserFollowConnection>
  /** Get mutual connections of a user by UUID */
  userProfileConnectionsByUuid?: Maybe<UserFollowConnection>
  /**
   * The members the signed-in viewer and this profile are **both** connected to.
   *
   * Viewer-relative, unlike `userProfileConnectionsByUuid`, which returns the profile's own
   * connections and ignores who is asking. The viewer is excluded from their own result: if the two
   * are connected to each other, the viewer is a party to that relationship rather than someone they
   * share. Returns the people whose number `UserProfile.connectionsInCommon` reports.
   */
  userProfileConnectionsInCommonByUuid?: Maybe<UserFollowConnection>
  /** Get the current authenticated user's profile */
  userProfileCurrent?: Maybe<UserProfile>
  /** Get paginated list of followers for a user */
  userProfileFollowers?: Maybe<UserFollowConnection>
  /** Get followers of a user by UUID */
  userProfileFollowersByUuid?: Maybe<UserFollowConnection>
  /** Get paginated list of users a user follows */
  userProfileFollowing?: Maybe<UserFollowConnection>
  /** Get users followed by a user, by UUID */
  userProfileFollowingByUuid?: Maybe<UserFollowConnection>
  /** Get a public user profile by UID (no authentication required, respects visibility settings) */
  userProfilePublic?: Maybe<UserProfile>
  /** Get a public user profile by UUID (no authentication required, respects visibility) */
  userProfilePublicByUuid?: Maybe<UserProfile>
  /**
   * Resolve several profiles at once, for a surface that lists people rather than showing one.
   *
   * Visibility is unchanged from `userProfileByUid`: a profile the viewer may not see is simply
   * absent from the result, as is a uid with no profile row. The result is therefore NOT positional
   * and may be shorter than `uids` — match on `uid`, never on index.
   *
   * Exists because a household's profiles each have their own uid, so naming all of them took one
   * round trip per person, and a document whose shape depends on how many profiles an account has
   * cannot be generated by a client that compiles static queries.
   */
  userProfilesByUids: Array<UserProfile>
  /** Bulk user profiles for AI service ingestion — returns all public profiles with cursor pagination */
  userProfilesForIngest: UserProfileIngestConnection
  /** Get a list of userInfo reference */
  userRoleList?: Maybe<UserRoleListResponse>
  /** Get a list of user state entries */
  userStateList?: Maybe<UserStateListResponse>
  /** Get a list of user state entries filtered by parent content title group id */
  userStateListByParent?: Maybe<UserStateListResponse>
  /** Get course progress for the current user */
  userStateProgressCourse?: Maybe<UserStateProgressCourseListResponse>
  /** Get all available user tag options for topic selection */
  userTagOptionsList: Array<UserTagOption>
  /** List media */
  videoAnalyticsMediaList?: Maybe<VideoAnalyticsMediaListResponse>
  /** List video */
  videoAnalyticsVideoList?: Maybe<VideoAnalyticsVideoListResponse>
  /** Generate an on-demand summary for watched video content. */
  videoAutoSummary?: Maybe<VideoAutoSummaryPayload>
  /** Generate contextual prompt suggestions scoped to a specific concept-dense moment in a video. Unlike videoPromptSuggestions (which considers all captions up to a timestamp), this focuses only on the transcript within the moment's time window and uses the concept label to generate targeted, educational prompts. */
  videoConceptMomentPrompts?: Maybe<VideoConceptMomentPromptsPayload>
  /** Summarize a specific concept-dense moment in a video transcript. */
  videoConceptMomentSummary?: Maybe<VideoConceptMomentSummaryPayload>
  /** Identify conceptually dense moments in a video for toast nudge triggers. */
  videoConceptMoments?: Maybe<VideoConceptMomentsPayload>
  /** Generate contextual prompt suggestions for watched video content. */
  videoPromptSuggestions?: Maybe<VideoPromptSuggestionsPayload>
  viewerGeoLocation?: Maybe<ViewerGeoLocation>
  /** Get a list of Content analytic */
  voteList?: Maybe<VotesListResponse>
  /** Bulk export of watch history for graph ingestion. Partition-aligned UID range scan. */
  watchHistoryBulk: WatchHistoryBulkResponse
  /** Bulk export of watch history by specific UIDs. Used by graph backfill with auth-driven user discovery. */
  watchHistoryBulkByUids: WatchHistoryBulkResponse
  /** Watches by a single user from a timestamp, optionally bounded by a window — for search chip-outcome / reward attribution. Returns rows where last_played >= sinceTs (and < sinceTs + windowSecs when provided) and watched_sum >= minWatchedSum, joined to the published primary-language video for videoId/seriesId. */
  watchesByUid: WatchHistoryBulkResponse
  /** Get a list of workers */
  workersList: WorkerListResponse
}

export type QueryAgentEnhancementsHubListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryAiSearchPlaylistsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  playlistLimit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
  topContentIds: Array<Scalars['Int']['input']>
  topContentScores: Array<Scalars['Float']['input']>
}

export type QueryAlchemizePlaylistArgs = {
  input: AlchemizePlaylistInput
}

export type QueryAmbassadorLeadsCountArgs = {
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

export type QueryAmbassadorLeadsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AmbassadorLeadsWhereInput>
}

export type QueryApiKeyListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ApiKeyListWhereInput>
}

export type QueryAssetProvidersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AssetProviderWhereInput>
}

export type QueryAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AssetWhereInput>
}

export type QueryAuthRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AuthRoleListWhereInput>
}

export type QueryAuthScopeCheckArgs = {
  scopes: Array<Scalars['String']['input']>
}

export type QueryAuthScopeListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<AuthScopeListWhereInput>
}

export type QueryAuthenticationCheckArgs = {
  enableScopeChecks?: InputMaybe<Scalars['Boolean']['input']>
  requiredRoles?: InputMaybe<Array<Role>>
  requiredScopes?: InputMaybe<Array<Scalars['String']['input']>>
  requiredScopesAnd?: InputMaybe<Array<Scalars['String']['input']>>
}

export type QueryBillingAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingAccountListWhereInput>
}

export type QueryBillingCheckoutAttributionMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  where: BillingCheckoutAttributionMetricsWhereInput
}

export type QueryBillingCheckoutRequestAttributionParamListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereInput>
}

export type QueryBillingCheckoutRequestListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingCheckoutRequestListWhereInput>
}

export type QueryBillingCheckoutTrialToPaidMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  where: BillingCheckoutAttributionMetricsWhereInput
}

export type QueryBillingDiscountBulkArgs = {
  id: Scalars['ID']['input']
}

export type QueryBillingDiscountEligibleArgs = {
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  consumeGiftCard?: InputMaybe<Scalars['Boolean']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountCode: Scalars['String']['input']
  language: Scalars['String']['input']
  page: PlanEligibilityPage
  sku?: InputMaybe<Scalars['String']['input']>
}

export type QueryBillingDiscountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<BillingDiscountListWhereInput>
}

export type QueryBillingEventCountArgs = {
  where?: InputMaybe<BillingEventListWhereInput>
}

export type QueryBillingEventListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingEventListWhereInput>
}

export type QueryBillingInvoiceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingInvoiceListWhereInput>
}

export type QueryBillingOneTimePurchaseListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingOneTimePurchaseListWhereInput>
}

export type QueryBillingPaymentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPaymentListWhereInput>
}

export type QueryBillingPaymentMethodListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPaymentMethodListWhereInput>
}

export type QueryBillingPlanGridListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingPlanGridListWhereInput>
}

export type QueryBillingProductChangeLogListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProductChangeLogListWhereInput>
}

export type QueryBillingProductChangeLogUsersArgs = {
  where?: InputMaybe<BillingProductChangeLogListWhereInput>
}

export type QueryBillingProductListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProductListWhereInput>
}

export type QueryBillingProviderCurrencyListArgs = {
  billingProvider?: InputMaybe<BillingProviderCurrencyListBillingProviderInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderCurrencyListWhereInput>
}

export type QueryBillingProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderListWhereInput>
}

export type QueryBillingProviderProductEligibilityArgs = {
  billingProviderProductId?: InputMaybe<Scalars['ID']['input']>
  earlyConversion?: InputMaybe<Scalars['Boolean']['input']>
  page: PlanEligibilityPage
  sku?: InputMaybe<Scalars['String']['input']>
  userInfoUuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryBillingProviderProductEligibilityListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderProductEligibilityListWhereInput>
}

export type QueryBillingProviderProductListArgs = {
  billingProduct?: InputMaybe<BillingProviderProductListBillingProductInput>
  billingProvider?: InputMaybe<BillingProviderProductListBillingProviderInput>
  currency?: InputMaybe<Scalars['String']['input']>
  deviceType?: InputMaybe<PlanGridDeviceType>
  language?: InputMaybe<ProviderProductLanguage>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  page?: InputMaybe<Scalars['String']['input']>
  planGrid?: InputMaybe<Scalars['Boolean']['input']>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<BillingProviderProductListWhereInput>
}

export type QueryBillingProviderProductPricingListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderProductPricingListWhereInput>
}

export type QueryBillingProviderProductTextListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingProviderProductTextListWhereInput>
}

export type QueryBillingProviderProductTextTranslateArgs = {
  input?: InputMaybe<BillingProviderProductTextTranslateInput>
  translationOptions?: InputMaybe<BillingProviderProductTextTranslationOptionsInput>
}

export type QueryBillingProviderProductTextVerifyArgs = {
  where?: InputMaybe<BillingProviderProductTextVerifyWhereInput>
}

export type QueryBillingRefundListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingRefundListWhereInput>
}

export type QueryBillingSubscriptionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionListWhereInput>
}

export type QueryBillingSubscriptionOrderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionOrderListWhereInput>
}

export type QueryBillingSubscriptionOrderPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionOrderPlanListWhereInput>
}

export type QueryBillingSubscriptionPlanListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingSubscriptionPlanListWhereInput>
}

export type QueryBrazeCampaignEngagementDayListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryBrazeCampaignListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryBrazeUserProfileAttributesArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>
  uuid: Scalars['ID']['input']
}

export type QueryBrazeWorkspaceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryBulkDiscountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<BulkDiscountListWhereInput>
}

export type QueryChannelPromptSetListArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  status?: InputMaybe<ChannelPromptStatus>
  useMaster?: Scalars['Boolean']['input']
}

export type QueryCircleInviteSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId: Scalars['ID']['input']
  first?: InputMaybe<Scalars['Int']['input']>
  matchType?: InputMaybe<CircleInviteMatchType>
  query: Scalars['String']['input']
  searchType?: InputMaybe<CircleInviteSearchType>
}

export type QueryClipBrightcovePlaylistVideosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  playlistId: Scalars['String']['input']
}

export type QueryClipListArgs = {
  firstWhere?: InputMaybe<ClipListFirstWhereInput>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  recommId?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<ClipListSortOrder>
}

export type QueryClipSocialManifestPreviewArgs = {
  language?: Scalars['String']['input']
  rows: Array<ClipSocialManifestRowInput>
}

export type QueryCommentListArgs = {
  content?: InputMaybe<Array<InputMaybe<CommentContentFilter>>>
  depthType?: InputMaybe<CommentDepthType>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CommentWhereInput>
}

export type QueryCommentReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  commentId: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  reaction: Scalars['String']['input']
}

export type QueryCommunityEventArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityEventCalendarInviteArgs = {
  eventId: Scalars['ID']['input']
}

export type QueryCommunityEventsByFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId: Scalars['ID']['input']
  filter?: InputMaybe<EventListFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCommunityFeedArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityFeedListArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedType?: InputMaybe<Scalars['String']['input']>
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

export type QueryCommunityFeedMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId: Scalars['ID']['input']
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCommunityLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  timeWindow?: InputMaybe<LeaderboardTimeWindow>
}

export type QueryCommunityModerationQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryCommunityPostArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityPostEngagementArgs = {
  postIds: Array<Scalars['ID']['input']>
}

export type QueryCommunityPostListArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CommunityPostOrderBy>
  parentId?: InputMaybe<Scalars['ID']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  reverse?: InputMaybe<Scalars['Boolean']['input']>
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryCommunityPostsForIngestArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCommunityReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  postId: Scalars['ID']['input']
  reaction: Scalars['String']['input']
}

export type QueryCommunityRepliesForIngestArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  feedId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  since?: InputMaybe<Scalars['DateTime']['input']>
}

export type QueryCommunitySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QueryCompanionsArgs = {
  contentId: Scalars['Int']['input']
  contentType: Scalars['String']['input']
  role?: InputMaybe<CompanionRole>
}

export type QueryContentAiMetadataArgs = {
  input: ContentAiMetadataInput
}

export type QueryContentAnalyticsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAnalyticWhereInput>
}

export type QueryContentAssetReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAssetReferenceTypeWhereInput>
}

export type QueryContentAssetReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentAssetReferenceWhereInput>
}

export type QueryContentFilterListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentFilterWhereInput>
}

export type QueryContentFilterSetListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentFilterSetWhereInput>
}

export type QueryContentListArgs = {
  applyContentPolicy?: InputMaybe<Scalars['Boolean']['input']>
  contentProviders?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>
  contentProvidersNot?: InputMaybe<Array<InputMaybe<ContentContentProviderFilterInput>>>
  contentReferencesFrom?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>
  contentReferencesFromEvery?: InputMaybe<
    Array<InputMaybe<ContentContentReferencesFromFilterInput>>
  >
  contentReferencesFromNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesFromFilterInput>>>
  contentReferencesTo?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  contentSearchLegs?: InputMaybe<Array<ContentSearchLeg>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  listCriteria?: InputMaybe<Array<InputMaybe<ContentListCriteriaCriteriaItemInput>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  publishedAtDateHasExpired?: InputMaybe<Scalars['Boolean']['input']>
  publishedState?: InputMaybe<ContentFilterPublishedState>
  references?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  referencesEvery?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  referencesNot?: InputMaybe<Array<InputMaybe<ContentContentReferencesToFilterInput>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentWhereInput>
}

export type QueryContentListCriteriaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentListCriteriaWhereInput>
}

export type QueryContentPolicyListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentPolicyWhereInput>
}

export type QueryContentProviderListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<ContentProviderWhereInput>
}

export type QueryContentReferenceTypesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentReferenceTypesWhereInput>
}

export type QueryContentReferencesAllowedListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentReferencesAllowedWhereInput>
}

export type QueryContentReferencesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  publishedState?: InputMaybe<ContentFilterPublishedState>
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  where?: InputMaybe<ContentReferencesWhereInput>
}

export type QueryContentSearchListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentSearchWhereInput>
}

export type QueryContentSetListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ContentSetListWhereInput>
}

export type QueryContinueWatchingTaggedRecsArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryCustomEmojiArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  key?: InputMaybe<Scalars['String']['input']>
}

export type QueryCustomEmojiListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryDemographicsArgs = {
  email: Scalars['String']['input']
}

export type QueryDivinationCollectionArgs = {
  id: Scalars['ID']['input']
  language?: Scalars['String']['input']
}

export type QueryDivinationCollectionByKeyArgs = {
  collectionKey: Scalars['String']['input']
  language?: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type QueryDivinationCollectionObjectsByKeyArgs = {
  collectionKey: Scalars['String']['input']
  language?: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type QueryDivinationCollectionsByTypeArgs = {
  language?: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type QueryDivinationFeatureStateArgs = {
  horoscopeChatSessionId?: InputMaybe<Scalars['ID']['input']>
  oracleChatSessionId?: InputMaybe<Scalars['ID']['input']>
  tarotChatSessionId?: InputMaybe<Scalars['ID']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryDivinationObjectArgs = {
  id: Scalars['ID']['input']
  language?: Scalars['String']['input']
}

export type QueryDivinationReadingArgs = {
  chatSessionId: Scalars['ID']['input']
  recipientUuid?: InputMaybe<Scalars['ID']['input']>
}

export type QueryDivinationSeedQuestionListArgs = {
  category?: InputMaybe<SeedQuestionCategory>
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  distributedCategories?: InputMaybe<Array<SeedQuestionCategory>>
  feature: SeedQuestionFeature
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  randomized?: InputMaybe<Scalars['Boolean']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryDivinationUniquePulledCardImageKeyListArgs = {
  type?: InputMaybe<DivinationUniqueDrawReadingType>
}

export type QueryDocumentAbstractListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  query?: InputMaybe<Scalars['String']['input']>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<DocumentAbstractWhereInput>
}

export type QueryDocumentEmbeddingsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  query?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<DocumentEmbeddingWhereInput>
}

export type QueryDocumentMultiQueryArgs = {
  query?: InputMaybe<Scalars['String']['input']>
  queryCount?: InputMaybe<Scalars['Int']['input']>
}

export type QueryDocumentQueryEmbeddingArgs = {
  embeddingConfigKey?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

export type QueryDocumentsCallChainArgs = {
  steps?: InputMaybe<Array<InputMaybe<DocumentCallChainStepInput>>>
}

export type QueryDocumentsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<DocumentWhereInput>
}

export type QueryDreamNextImagePairArgs = {
  input: DreamNextImagePairInput
}

export type QueryDynamicLayoutArgs = {
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  route: Scalars['String']['input']
}

export type QueryEcommerceSkuMappingBonusEligibilitiesListArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<EcommerceSkuMappingBonusEligibilitiesWhereInput>
}

export type QueryEcommerceSkuMappingsListArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchString?: InputMaybe<Scalars['String']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  where?: InputMaybe<EcommerceSkuMappingsWhereInput>
}

export type QueryEmbeddingConfigsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<EmbeddingConfigsWhereInput>
}

export type QueryEntityRecognitionArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  query: Scalars['String']['input']
}

export type QueryFeatureSeedQuestionListArgs = {
  category?: InputMaybe<SeedQuestionCategory>
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  distributedCategories?: InputMaybe<Array<SeedQuestionCategory>>
  feature: SeedQuestionFeature
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  randomized?: InputMaybe<Scalars['Boolean']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryFollowedPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryForexRatesListArgs = {
  pairs: Array<ForexRatePairInput>
}

export type QueryGiftCardByCodeArgs = {
  giftCardCode: Scalars['String']['input']
}

export type QueryGraphEnrichArgs = {
  contentIds: Array<Scalars['Int']['input']>
  language?: InputMaybe<Scalars['String']['input']>
}

export type QueryGraphNeighborsArgs = {
  direction?: InputMaybe<GraphDirection>
  edgeTypes: Array<Scalars['String']['input']>
  entityId: Scalars['String']['input']
  entityType: GraphEntityType
  limit?: InputMaybe<Scalars['Int']['input']>
  minWeight?: InputMaybe<Scalars['Float']['input']>
  neighborEntityTypes?: InputMaybe<Array<GraphEntityType>>
  offset?: InputMaybe<Scalars['Int']['input']>
  sortByWeight?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryGraphNodeArgs = {
  entityId: Scalars['String']['input']
  entityType: GraphEntityType
}

export type QueryGraphPathArgs = {
  entityId: Scalars['String']['input']
  entityType: GraphEntityType
  hop1Direction?: InputMaybe<GraphDirection>
  hop1EdgeTypes: Array<Scalars['String']['input']>
  hop2Direction?: InputMaybe<GraphDirection>
  hop2EdgeTypes: Array<Scalars['String']['input']>
  intermediateEntityTypes?: InputMaybe<Array<GraphEntityType>>
  limit?: InputMaybe<Scalars['Int']['input']>
  minPathWeight?: InputMaybe<Scalars['Float']['input']>
  terminalEntityTypes?: InputMaybe<Array<GraphEntityType>>
}

export type QueryGraphSearchArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QueryImageContentRelationshipsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ImageContentRelationshipWhereInput>
}

export type QueryImageContentRelationshipsListByContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ImageContentRelationshipByContentInput>>>
}

export type QueryImagesListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<ImageWhereInput>
}

export type QueryIsProfileVisibleToViewerArgs = {
  profileUid: Scalars['ID']['input']
  viewerUid: Scalars['ID']['input']
}

export type QueryLocalizationStringListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<LocalizationStringWhereInput>
}

export type QueryMarketingAdAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingAdGroupListArgs = {
  input?: InputMaybe<MarketingPaidStructureListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingAdListArgs = {
  input?: InputMaybe<MarketingPaidStructureListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingAdTargetingListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingAdTargetingReferenceListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingAgentSessionArgs = {
  sessionId: Scalars['String']['input']
}

export type QueryMarketingAirCreativeGetArgs = {
  assetId: Scalars['String']['input']
}

export type QueryMarketingAirCreativeGetDeliveryUrlArgs = {
  assetId: Scalars['String']['input']
  versionId?: InputMaybe<Scalars['String']['input']>
}

export type QueryMarketingAirCreativeListArgs = {
  input: MarketingAirCreativeListInput
}

export type QueryMarketingAnalyticsEvaluateThresholdArgs = {
  input: MarketingAnalyticsThresholdInput
}

export type QueryMarketingAnalyticsListArgs = {
  input: MarketingAnalyticsInput
}

export type QueryMarketingAnalyticsReportTaskArgs = {
  input: MarketingAnalyticsReportTaskInput
}

export type QueryMarketingCampaignAssetListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingCampaignListArgs = {
  input?: InputMaybe<MarketingPaidStructureListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingCampaignListPerformanceArgs = {
  input: MarketingCampaignPerformanceInput
}

export type QueryMarketingCampaignSearchArgs = {
  input: MarketingCampaignSearchInput
}

export type QueryMarketingConversionPipelineHealthGetArgs = {
  runMpPing?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryMarketingConversionValueGetArgs = {
  input: MarketingConversionValueInput
}

export type QueryMarketingCreativeGenerationJobGetArgs = {
  id: Scalars['ID']['input']
}

export type QueryMarketingCreativeGenerationJobListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingKeywordListArgs = {
  input?: InputMaybe<MarketingKeywordListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingLandingPageGetArgs = {
  input: MarketingLandingPageGetInput
}

export type QueryMarketingMemberDaySnapshotListArgs = {
  input: MarketingMemberDaySnapshotListInput
}

export type QueryMarketingMemberPaymentProfileGetArgs = {
  uid: Scalars['Int']['input']
}

export type QueryMarketingMessagingAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingMessagingCampaignEngagementDayListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingMessagingCampaignGetArgs = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  channel: Scalars['String']['input']
  emailId?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
}

export type QueryMarketingMessagingCampaignListArgs = {
  channel?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  platform?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingMessagingCampaignPerformanceListArgs = {
  aspect?: InputMaybe<Scalars['String']['input']>
  channel: Scalars['String']['input']
  endDate?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform: Scalars['String']['input']
  reportKind?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type QueryMarketingMessagingTemplateGetArgs = {
  channel: Scalars['String']['input']
  emailTemplateId?: InputMaybe<Scalars['String']['input']>
  platform: Scalars['String']['input']
  templateId?: InputMaybe<Scalars['String']['input']>
}

export type QueryMarketingMessagingTemplateListArgs = {
  channel: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform: Scalars['String']['input']
}

export type QueryMarketingMetricDayListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingOperatorRecommendationListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingPulseGetArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type QueryMarketingReportExclusionGetArgs = {
  id: Scalars['ID']['input']
}

export type QueryMarketingReportExclusionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingReportGetArgs = {
  id: Scalars['ID']['input']
}

export type QueryMarketingReportListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingReportStatusListArgs = {
  kind?: InputMaybe<MarketingReportKind>
  reportDate: Scalars['DateTime']['input']
}

export type QueryMarketingResearchJobGetArgs = {
  id: Scalars['ID']['input']
}

export type QueryMarketingResearchJobListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  where?: InputMaybe<Scalars['JSON']['input']>
}

export type QueryMarketingTranslateContentArgs = {
  input: MarketingTranslateContentInput
}

export type QueryMediaAssetMezzanineDownloadArgs = {
  mediaAssetId: Scalars['ID']['input']
}

export type QueryMediaAssetMezzanineRawArgs = {
  mediaAssetId: Scalars['ID']['input']
}

export type QueryMediaAssetsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<MediaAssetWhereInput>
}

export type QueryMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<MediaWhereInput>
}

export type QueryModerationOverridesArgs = {
  category?: InputMaybe<ModerationCategory>
  direction?: InputMaybe<ModerationOverrideDirection>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  since?: InputMaybe<Scalars['DateTime']['input']>
  surface?: InputMaybe<ModerationSurface>
}

export type QueryModerationQueueArgs = {
  authorUid?: InputMaybe<Scalars['Int']['input']>
  category?: InputMaybe<ModerationCategory>
  containerId?: InputMaybe<Scalars['ID']['input']>
  itemId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  minTopScore?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  source?: InputMaybe<ModerationSource>
  status?: InputMaybe<CommentStatus>
  statuses?: InputMaybe<Array<CommentStatus>>
  surface?: InputMaybe<ModerationSurface>
}

export type QueryMyCommunityFeedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryNotificationsSubscriptionsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<NotificationsSubscriptionsListWhereInput>
}

export type QueryNudgeAndSuggestionArgs = {
  input: NudgeAndSuggestionInput
}

export type QueryOauthClientListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<OAuthClientListWhereInput>
}

export type QueryOnboardingStateArgs = {
  chatChannel?: InputMaybe<Scalars['String']['input']>
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryOracleChatSessionArgs = {
  id: Scalars['ID']['input']
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
}

export type QueryOracleChatSessionListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  personalityId?: InputMaybe<Scalars['ID']['input']>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleChatSessionListWhere>
}

export type QueryOracleChunkSemanticSearchArgs = {
  input: OracleChunkSemanticSearchInput
}

export type QueryOracleLlmConfigSetListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
}

export type QueryOracleMessageListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleMessageListWhere>
}

export type QueryOracleMessagePairArgs = {
  id: Scalars['ID']['input']
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
}

export type QueryOracleMessagePairListArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OracleMessagePairListWhere>
}

export type QueryOracleMessagePairVariantsArgs = {
  messagePairId: Scalars['ID']['input']
}

export type QueryOraclePersonalityListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  order?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  queryOptions?: InputMaybe<QueryOptions>
  useMaster?: Scalars['Boolean']['input']
  where?: InputMaybe<OraclePersonalityListWhere>
}

export type QueryOraclePlaylistGenerateArgs = {
  input: OraclePlaylistGenerateInput
}

export type QueryOraclePromptLibraryAdminCategoryArgs = {
  id: Scalars['ID']['input']
}

export type QueryOraclePromptLibraryAdminCategoryListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<OraclePromptLibraryAdminCategoryListWhere>
}

export type QueryOraclePromptLibraryAdminPromptArgs = {
  id: Scalars['ID']['input']
}

export type QueryOraclePromptLibraryAdminPromptListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<OraclePromptLibraryAdminPromptListWhere>
}

export type QueryOraclePromptLibraryAdminThemeArgs = {
  id: Scalars['ID']['input']
}

export type QueryOraclePromptLibraryAdminThemeListArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
}

export type QueryOraclePromptLibraryCategoryArgs = {
  audience?: OraclePromptLibraryAudience
  id: Scalars['ID']['input']
  language?: Scalars['String']['input']
}

export type QueryOraclePromptLibraryCategoryListArgs = {
  audience?: OraclePromptLibraryAudience
  language?: Scalars['String']['input']
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
}

export type QueryOracleSearchArgs = {
  input: OracleSearchInput
}

export type QueryOracleSharedMessagePairArgs = {
  shareId: Scalars['ID']['input']
}

export type QueryPathInfoArgs = {
  filterSet?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  path: Scalars['String']['input']
}

export type QueryPathRedirectListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PathRedirectWhereInput>
}

export type QueryPlaybackCompanionsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PlaybackCompanionWhereInput>
}

export type QueryPlaylistEngagementArgs = {
  playlistIds: Array<Scalars['ID']['input']>
}

export type QueryPlaylistFollowsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PlaylistFollowsListWhereInput>
}

export type QueryPlaylistItemListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  playlists?: InputMaybe<Array<InputMaybe<PlaylistItemListPlaylistInput>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PlaylistItemWhereInput>
}

export type QueryPlaylistListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  visibility?: InputMaybe<Array<InputMaybe<PlaylistVisibility>>>
  where?: InputMaybe<PlaylistWhereInput>
}

export type QueryPlaylistSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<PlaylistSearchOrder>
  query: Scalars['String']['input']
  uid?: InputMaybe<Scalars['ID']['input']>
  visibility?: InputMaybe<Array<InputMaybe<PlaylistVisibility>>>
}

export type QueryPlaylistsByContentIdsArgs = {
  contentIds: Array<Scalars['Int']['input']>
  excludeCurrentUser?: InputMaybe<Scalars['Boolean']['input']>
  playlistLimit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPmListListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmListWhereInput>
}

export type QueryPmScreenListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmScreenWhereInput>
}

export type QueryPmScreenPersonalizedArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  contentListFullCheckLimit?: InputMaybe<Scalars['Int']['input']>
  contentNot?: InputMaybe<Array<InputMaybe<ContentNotFilterInput>>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  screenType: Scalars['String']['input']
}

export type QueryPmSectionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<PmSectionWhereInput>
}

export type QueryPopularTopicsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryProviderSubscriptionArgs = {
  platform?: InputMaybe<ProviderSubscriptionPlatform>
  provider: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type QueryPublishingAgentSessionArgs = {
  sessionId: Scalars['String']['input']
}

export type QueryRateLimitActionConfigListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<RateLimitActionConfigListWhereInput>
}

export type QueryRateLimitActionListArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  where?: InputMaybe<RateLimitActionListWhereInput>
}

export type QueryRateLimitOverrideListArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  where?: InputMaybe<RateLimitOverrideListWhereInput>
}

export type QueryRateLimitRequestListArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  where?: InputMaybe<RateLimitRequestListWhereInput>
}

export type QueryRateLimitRuleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<RateLimitRuleListWhereInput>
}

export type QueryRateLimitStatusArgs = {
  mode?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QueryRawEventListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<RawEventListWhereInput>
}

export type QueryRecommendationListArgs = {
  clientAttributes?: InputMaybe<Array<Scalars['String']['input']>>
  country?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  scenario: Scalars['String']['input']
  uid?: InputMaybe<Scalars['Int']['input']>
  uuid?: InputMaybe<Scalars['ID']['input']>
}

export type QueryRelatedBillingProviderProductListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  providerSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuerySearchArgs = {
  contentLimit?: InputMaybe<Scalars['Int']['input']>
  contentOffset?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<SearchFilters>
  language?: InputMaybe<Scalars['String']['input']>
  previousChipTexts?: InputMaybe<Array<Scalars['String']['input']>>
  previousContentCenters?: InputMaybe<Scalars['String']['input']>
  previousContentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  previousQuery?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['ID']['input']>
  skipOverview?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<SearchSort>
}

export type QuerySearchMessagePairsArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  query: Scalars['String']['input']
}

export type QuerySearchPlaylistsArgs = {
  filters?: InputMaybe<SearchFilters>
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  previousChipTexts?: InputMaybe<Array<Scalars['String']['input']>>
  previousContentCenters?: InputMaybe<Array<Scalars['String']['input']>>
  previousPlaylistIds?: InputMaybe<Array<Scalars['ID']['input']>>
  previousQuery?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['ID']['input']>
  skipOverview?: InputMaybe<Scalars['Boolean']['input']>
}

export type QuerySearchSuggestionsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QuerySeedQuestionActionVisibilityArgs = {
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  feature: SeedQuestionFeature
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type QuerySeedQuestionListArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  personalized?: InputMaybe<SeedQuestionPersonalization>
  randomized?: InputMaybe<Scalars['Boolean']['input']>
  userMetaTags?: InputMaybe<Array<SeedQuestionUserMetaTagInput>>
  where?: InputMaybe<SeedQuestionListWhere>
}

export type QuerySemanticSearchCarouselArgs = {
  input: SemanticSearchCarouselInput
}

export type QuerySocialsInfluencerJobRunListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsInfluencerJobRunWhereInput>
}

export type QuerySocialsSpiderContentListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsSpiderContentWhereInput>
}

export type QuerySocialsSpiderContentMetricsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsSpiderContentMetricsWhereInput>
}

export type QuerySocialsSpiderJobsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsSpiderJobsWhereInput>
}

export type QuerySocialsSpiderKeywordsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsSpiderKeywordsWhereInput>
}

export type QueryTestarossaSubjectsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TestarossaSubjectsListWhereInput>
}

export type QueryTestarossaUsersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TestarossaUsersListWhereInput>
}

export type QueryTransactionCountArgs = {
  where?: InputMaybe<TransactionListWhereInput>
}

export type QueryTransactionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<TransactionListWhereInput>
}

export type QueryTranscriptChunkLookupProjectArgs = {
  id: Scalars['ID']['input']
}

export type QueryTranscriptChunkLookupProjectListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryTranscriptChunkLookupProjectRawExportBundleArgs = {
  projectId: Scalars['ID']['input']
}

export type QueryTranscriptChunkSamplerSeedsArgs = {
  contentId?: InputMaybe<Scalars['Int']['input']>
  contentType?: InputMaybe<Scalars['String']['input']>
  language?: TranscriptChunkSearchLanguage
  limit?: InputMaybe<Scalars['Int']['input']>
  seedQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryTranscriptChunkSearchArgs = {
  input: TranscriptChunkSearchInput
}

export type QueryTranscriptChunkSearchAnonSamplerArgs = {
  input: TranscriptChunkSamplerSearchInput
}

export type QueryTranscriptChunkSessionGetArgs = {
  id: Scalars['ID']['input']
}

export type QueryTranscriptChunkSessionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryUserAccountListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserAccountListWhereInput>
}

export type QueryUserAuditLogListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserAuditLogListWhereInput>
}

export type QueryUserBillingPlanGridListArgs = {
  where?: InputMaybe<UserBillingPlanGridListWhereInput>
}

export type QueryUserEcommerceSkuMappingBonusEligibilitiesListArgs = {
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  planSku?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userUuid?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  where?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>
}

export type QueryUserEntitlementListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserEntitlementListWhereInput>
}

export type QueryUserFollowsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserFollowsListWhereInput>
}

export type QueryUserHistoryEventsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserHistoryEventsListWhereInput>
}

export type QueryUserHistoryListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userHistory?: InputMaybe<Array<InputMaybe<UserHistoryFilterInput>>>
  where?: InputMaybe<UserHistoryListWhereInput>
}

export type QueryUserInfoListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserInfoListWhereInput>
}

export type QueryUserInfoPublicArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  uuids?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryUserInfoWithMetadataArgs = {
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}

export type QueryUserMediaPositionListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  publishedMediaOnly?: InputMaybe<Scalars['Boolean']['input']>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserMediaPositionListWhereInput>
}

export type QueryUserMetaTagListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  userMetaTags?: InputMaybe<Array<UserMetaTagFilterInput>>
  where?: InputMaybe<UserMetaTagWhereInput>
}

export type QueryUserMetaTagMissingRainbowDefaultsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  uidGt?: InputMaybe<Scalars['Int']['input']>
}

export type QueryUserMetadataListArgs = {
  uid: Scalars['Int']['input']
}

export type QueryUserProfileByUidArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryUserProfileByUuidArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfileConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryUserProfileConnectionsByUuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfileConnectionsInCommonByUuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfileCurrentArgs = {
  language?: InputMaybe<Scalars['String']['input']>
}

export type QueryUserProfileFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryUserProfileFollowersByUuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfileFollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryUserProfileFollowingByUuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfilePublicArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  uid: Scalars['ID']['input']
}

export type QueryUserProfilePublicByUuidArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  uuid: Scalars['ID']['input']
}

export type QueryUserProfilesByUidsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  uids: Array<Scalars['ID']['input']>
}

export type QueryUserProfilesForIngestArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryUserRoleListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<UserRoleListWhereInput>
}

export type QueryUserStateListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserStateWhereInput>
}

export type QueryUserStateListByParentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  parentContentTitleGroupId: Scalars['String']['input']
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<UserStateWhereInput>
}

export type QueryUserStateProgressCourseArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  state?: InputMaybe<UserStateCourse>
}

export type QueryUserTagOptionsListArgs = {
  language?: InputMaybe<Scalars['String']['input']>
}

export type QueryVideoAnalyticsMediaListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<VideoAnalyticsMediaListWhereInput>
}

export type QueryVideoAnalyticsVideoListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<VideoAnalyticsVideoListWhereInput>
}

export type QueryVideoAutoSummaryArgs = {
  input: VideoAutoSummaryInput
}

export type QueryVideoConceptMomentPromptsArgs = {
  input: VideoConceptMomentPromptsInput
}

export type QueryVideoConceptMomentSummaryArgs = {
  input: VideoConceptMomentSummaryInput
}

export type QueryVideoConceptMomentsArgs = {
  input: VideoConceptMomentsInput
}

export type QueryVideoPromptSuggestionsArgs = {
  input: VideoPromptSuggestionsInput
}

export type QueryVoteListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  userCurrent?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<VoteWhereInput>
}

export type QueryWatchHistoryBulkArgs = {
  lastPlayedAfter?: InputMaybe<Scalars['BigInt']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  minCompletionPercent?: InputMaybe<Scalars['Float']['input']>
  minWatchedCount?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  uidGte: Scalars['Int']['input']
  uidLt: Scalars['Int']['input']
}

export type QueryWatchHistoryBulkByUidsArgs = {
  lastPlayedAfter?: InputMaybe<Scalars['BigInt']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  minCompletionPercent?: InputMaybe<Scalars['Float']['input']>
  minWatchedCount?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  uids: Array<Scalars['Int']['input']>
}

export type QueryWatchesByUidArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  minWatchedSum?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sinceTs: Scalars['BigInt']['input']
  uid: Scalars['Int']['input']
  windowSecs?: InputMaybe<Scalars['Int']['input']>
}

export type QueryWorkersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<WorkerWhereInput>
}

export type QueryOptions = {
  useMaster?: Scalars['Boolean']['input']
}

/** Work recorded against a passing rate-limit token */
export type RateLimitAction = {
  __typename?: 'RateLimitAction'
  /** Action name. Must match the request that issued the token. */
  action: Scalars['String']['output']
  /** x-client-attributes header, comma-separated */
  clientAttributes?: Maybe<Scalars['String']['output']>
  /** Client IP copied from the check or the caller */
  clientIp?: Maybe<Scalars['String']['output']>
  /** When the work was recorded */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Error name or message when success is false */
  failureReason?: Maybe<Scalars['String']['output']>
  /** FingerprintJS visitor id copied from the check or the record input */
  fingerprintId?: Maybe<Scalars['String']['output']>
  /** Primary key */
  id: Scalars['ID']['output']
  /** Token from the passing check. One action row per token. */
  rateLimitRequestUuid: Scalars['ID']['output']
  /** True when the protected work succeeded. False when it threw. */
  success: Scalars['Boolean']['output']
  /** User id copied from the check, or from the caller when recording */
  uid?: Maybe<Scalars['Int']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User-Agent header */
  userAgent?: Maybe<Scalars['String']['output']>
  /** Action row id */
  uuid: Scalars['ID']['output']
}

/** Per-action rate-limit config. Fingerprint switches stay off until set. bypass keeps the action in observe mode while the master switch is on. */
export type RateLimitActionConfig = {
  __typename?: 'RateLimitActionConfig'
  /** Action this config applies to, such as LOGIN */
  action: Scalars['String']['output']
  /** Deny when the Fingerprint event bot field is bad. not_detected and good pass. A missing bot field skips this check. */
  badBot: Scalars['Boolean']['output']
  /** Deny when the Fingerprint event tampering field is true. A missing tampering field skips this check. */
  browserTampering: Scalars['Boolean']['output']
  /** When true, this action is stored but not denied, even if the master switch is on. */
  bypass: Scalars['Boolean']['output']
  /** Keys that may consume a token once each. Empty allows the default key only. */
  consumptionKeys: Array<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Primary key */
  id: Scalars['ID']['output']
  /** Deny when the Fingerprint event ip_blocklist email_spam or attack_source is true. A missing ip_blocklist skips this check. */
  ipBlocklist: Scalars['Boolean']['output']
  /** When true, checks for this action must pass tokenConsumption or they are rejected */
  tokenConsumption: Scalars['Boolean']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Action config row id */
  uuid: Scalars['ID']['output']
}

/** Page of per-action Fingerprint signal switches */
export type RateLimitActionConfigListResponse = {
  __typename?: 'RateLimitActionConfigListResponse'
  /** Total number of rows found */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Fingerprint checks matching the filter */
  rateLimitActionConfigs?: Maybe<Array<Maybe<RateLimitActionConfig>>>
}

/** Filters for per-action Fingerprint signal switches */
export type RateLimitActionConfigListWhereInput = {
  /** The action field where clause */
  action?: InputMaybe<RateLimitWhereStringInput>
  /** The badBot field where clause */
  badBot?: InputMaybe<RateLimitWhereBooleanInput>
  /** The browserTampering field where clause */
  browserTampering?: InputMaybe<RateLimitWhereBooleanInput>
  /** The bypass field where clause */
  bypass?: InputMaybe<RateLimitWhereBooleanInput>
  /** The id field where clause */
  id?: InputMaybe<RateLimitWhereIdInput>
  /** The ipBlocklist field where clause */
  ipBlocklist?: InputMaybe<RateLimitWhereBooleanInput>
  /** The tokenConsumption field where clause */
  tokenConsumption?: InputMaybe<RateLimitWhereBooleanInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<RateLimitWhereUuidInput>
}

/** Page of recorded rate-limit actions */
export type RateLimitActionListResponse = {
  __typename?: 'RateLimitActionListResponse'
  /** Total number of rows found */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Actions matching the filter */
  rateLimitActions?: Maybe<Array<Maybe<RateLimitAction>>>
}

/** Filters for recorded rate-limit actions */
export type RateLimitActionListWhereInput = {
  /** The action field where clause */
  action?: InputMaybe<RateLimitWhereStringInput>
  /** The clientIp field where clause */
  clientIp?: InputMaybe<RateLimitWhereStringInput>
  /** The createdAt field where clause */
  createdAt?: InputMaybe<RateLimitWhereDateTimeInput>
  /** The fingerprintId field where clause */
  fingerprintId?: InputMaybe<RateLimitWhereStringInput>
  /** The id field where clause */
  id?: InputMaybe<RateLimitWhereIdInput>
  /** The rateLimitRequestUuid field where clause */
  rateLimitRequestUuid?: InputMaybe<RateLimitWhereUuidInput>
  /** The success field where clause */
  success?: InputMaybe<RateLimitWhereBooleanInput>
  /** The uid field where clause */
  uid?: InputMaybe<RateLimitWhereIntInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<RateLimitWhereUuidInput>
}

/** How a rule reduces matching rows */
export enum RateLimitAggregate {
  /** Count matching rows */
  Count = 'count',
  /** Count unique uid or IP values */
  Distinct = 'distinct',
}

/** What a rule counts */
export enum RateLimitCountSource {
  /** Count recorded actions */
  Action = 'action',
  /** Count checks and recorded actions together */
  Both = 'both',
  /** Count rate-limit checks */
  Request = 'request',
}

/** Result of deleting a rate-limit rule, action config, or override */
export type RateLimitDeleteResponse = {
  __typename?: 'RateLimitDeleteResponse'
  /** True when the row was removed */
  success: Scalars['Boolean']['output']
}

/** Identity a rule counts. Omit on a rule to apply the same limit to each present identity. */
export enum RateLimitDimension {
  /** FingerprintJS visitor id */
  Fingerprint = 'fingerprint',
  /** Client IP */
  Ip = 'ip',
  /** User id */
  Uid = 'uid',
}

/** Value a distinct rule counts */
export enum RateLimitDistinctDimension {
  /** Client IP */
  Ip = 'ip',
  /** User id */
  Uid = 'uid',
}

/** How a rule selects history rows */
export enum RateLimitHistoryMatch {
  /** Match the rule dimension, or each present identity when dimension is null */
  Dimension = 'dimension',
  /** One set of rows whose fingerprint or user matches. IP does not select the row. */
  FingerprintOrUid = 'fingerprint_or_uid',
}

/** Counts from a velocity-check import. Skipped rows were already stored. Missing request uuids had no check yet. */
export type RateLimitImportResult = {
  __typename?: 'RateLimitImportResult'
  /** Rows inserted by this call */
  inserted: Scalars['Int']['output']
  /** Action rows whose check was not imported yet */
  missing: Array<Scalars['ID']['output']>
  /** Rows already stored, left unchanged */
  skipped: Scalars['Int']['output']
}

export type RateLimitInfo = {
  __typename?: 'RateLimitInfo'
  /** Type of rate limit: 'daily' or 'lifetime' */
  limitType?: Maybe<Scalars['String']['output']>
  /** The mode this rate limit applies to ('text', 'voice', or null for all) */
  mode?: Maybe<Scalars['String']['output']>
  /** Whether the user is currently rate limited */
  rateLimited: Scalars['Boolean']['output']
  /** Number of remaining interactions allowed today */
  remainingInteractions: Scalars['Int']['output']
  /** Total number of interactions today */
  totalInteractions: Scalars['Int']['output']
}

/** Which rows inside the window count */
export enum RateLimitOutcome {
  /** Rows whose success is false */
  Failure = 'failure',
  /** Rows whose success is true */
  Success = 'success',
  /** Every row */
  Total = 'total',
}

/** Allow or block row. Failed rules can also insert a block when blockMinutesOnFailure is set. */
export type RateLimitOverride = {
  __typename?: 'RateLimitOverride'
  /** Action this row applies to. Null matches every action. */
  action?: Maybe<Scalars['String']['output']>
  /** True when enabled and the window contains now. Both dates empty means no time limit. When both are set, start is inclusive and end is exclusive. */
  active: Scalars['Boolean']['output']
  /** When true, a block row matches clientIp. Allow rows ignore this. */
  blockIp: Scalars['Boolean']['output']
  /** Client IP this row matches. A block matches IP only when blockIp is true. */
  clientIp?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Optional note for why this row exists */
  description?: Maybe<Scalars['String']['output']>
  /** False rows are ignored */
  enabled: Scalars['Boolean']['output']
  /** When the override ends. Required when startAt is set. The row matches only while now is inside this inclusive range. */
  endAt?: Maybe<Scalars['DateTime']['output']>
  /** FingerprintJS visitor id this row matches */
  fingerprintId?: Maybe<Scalars['String']['output']>
  /** Primary key */
  id: Scalars['ID']['output']
  /** allow skips rules. block denies before rules run. */
  overrideType: RateLimitOverrideType
  /** When the override starts. Empty means no time limit. Required when endAt is set. */
  startAt?: Maybe<Scalars['DateTime']['output']>
  /** User id this row matches */
  uid?: Maybe<Scalars['Int']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User-Agent this block matches. Exact after trim, capped at 1024 characters. Null when the row does not match a user agent. */
  userAgent?: Maybe<Scalars['String']['output']>
  /** Override row id */
  uuid: Scalars['ID']['output']
}

/** Page of allow and block overrides */
export type RateLimitOverrideListResponse = {
  __typename?: 'RateLimitOverrideListResponse'
  /** Total number of rows found */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Overrides matching the filter */
  rateLimitOverrides?: Maybe<Array<Maybe<RateLimitOverride>>>
}

/** Filters for allow and block rows */
export type RateLimitOverrideListWhereInput = {
  /** The action field where clause */
  action?: InputMaybe<RateLimitWhereStringInput>
  /** The active field where clause. Derived from enabled and the current window. */
  active?: InputMaybe<RateLimitWhereBooleanInput>
  /** The clientIp field where clause */
  clientIp?: InputMaybe<RateLimitWhereStringInput>
  /** The description field where clause */
  description?: InputMaybe<RateLimitWhereStringInput>
  /** The enabled field where clause */
  enabled?: InputMaybe<RateLimitWhereBooleanInput>
  /** The fingerprintId field where clause */
  fingerprintId?: InputMaybe<RateLimitWhereStringInput>
  /** The id field where clause */
  id?: InputMaybe<RateLimitWhereIdInput>
  /** The overrideType field where clause */
  overrideType?: InputMaybe<RateLimitOverrideWhereTypeInput>
  /** The uid field where clause */
  uid?: InputMaybe<RateLimitWhereIntInput>
  /** The userAgent field where clause */
  userAgent?: InputMaybe<RateLimitWhereStringInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<RateLimitWhereUuidInput>
}

/** Allow or block override */
export enum RateLimitOverrideType {
  /** Skip rules for a matching identity */
  Allow = 'allow',
  /** Deny a matching identity before rules run */
  Block = 'block',
}

/** Allow or block override filter */
export type RateLimitOverrideWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitOverrideType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitOverrideType>>>
}

/** A rate-limit check attempt. A passing check exposes uuid as a token. */
export type RateLimitRequest = {
  __typename?: 'RateLimitRequest'
  /** Action this check applies to, such as LOGIN or LOGIN_CODE_CREATE */
  action: Scalars['String']['output']
  /** True when an allow override skipped the rules */
  allowlisted: Scalars['Boolean']['output']
  /** Authenticated caller. Set when a JWT created a login code for someone else. Null when the caller is the counted user or the request was anonymous. */
  authUid?: Maybe<Scalars['Int']['output']>
  /** True when a block override denied the check */
  blocklisted: Scalars['Boolean']['output']
  /** True when rateLimit.enabled was off for this check. The row still stores the real decision. */
  bypassed: Scalars['Boolean']['output']
  /** x-client-attributes header, comma-separated */
  clientAttributes?: Maybe<Scalars['String']['output']>
  /** Client IP from the request. This is the leftmost X-Forwarded-For entry. */
  clientIp?: Maybe<Scalars['String']['output']>
  /** Map of consumption key to the time that key was consumed */
  consumedAt?: Maybe<Scalars['JSON']['output']>
  /** When the check was recorded */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Count, including this attempt, that exceeded the rule */
  failureAmount?: Maybe<Scalars['Int']['output']>
  /** Identity the failing rule counted: uid, ip, or fingerprint */
  failureDimension?: Maybe<Scalars['String']['output']>
  /** Rule that denied the check */
  failureRuleId?: Maybe<Scalars['Int']['output']>
  /** Why FingerprintJS denied the check: bad_bot, ip_blocklist, browser_tampering, or invalid_visitor. Null when the check was not denied for a fingerprint reason. */
  fingerprintFailure?: Maybe<Scalars['String']['output']>
  /** FingerprintJS visitor id when the caller sent one */
  fingerprintId?: Maybe<Scalars['String']['output']>
  /** Primary key */
  id: Scalars['ID']['output']
  /** True when FingerprintJS denied the check. An API outage does not set this. */
  invalidFingerprint: Scalars['Boolean']['output']
  /** Override that allowed or blocked this check. Null when no override applied. */
  rateLimitOverrideId?: Maybe<Scalars['Int']['output']>
  /** True when the check passed and uuid can be used as a token */
  success: Scalars['Boolean']['output']
  /** True when this check opts into returning the same unconsumed token on a later check for the same action and identity. */
  tokenConsumption: Scalars['Boolean']['output']
  /** User id when the check is tied to an account. Null when only IP or fingerprint is known. For login-code create this is the person the code is for. */
  uid?: Maybe<Scalars['Int']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User-Agent header */
  userAgent?: Maybe<Scalars['String']['output']>
  /** Check id. This is the token when success is true. */
  uuid: Scalars['ID']['output']
}

/** Page of rate-limit checks */
export type RateLimitRequestListResponse = {
  __typename?: 'RateLimitRequestListResponse'
  /** Total number of rows found */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Checks matching the filter */
  rateLimitRequests?: Maybe<Array<Maybe<RateLimitRequest>>>
}

/** Filters for rate-limit checks */
export type RateLimitRequestListWhereInput = {
  /** The action field where clause */
  action?: InputMaybe<RateLimitWhereStringInput>
  /** The allowlisted field where clause */
  allowlisted?: InputMaybe<RateLimitWhereBooleanInput>
  /** The authUid field where clause */
  authUid?: InputMaybe<RateLimitWhereIntInput>
  /** The blocklisted field where clause */
  blocklisted?: InputMaybe<RateLimitWhereBooleanInput>
  /** The bypassed field where clause */
  bypassed?: InputMaybe<RateLimitWhereBooleanInput>
  /** The clientIp field where clause */
  clientIp?: InputMaybe<RateLimitWhereStringInput>
  /** The createdAt field where clause */
  createdAt?: InputMaybe<RateLimitWhereDateTimeInput>
  /** The failureDimension field where clause */
  failureDimension?: InputMaybe<RateLimitWhereStringInput>
  /** The failureRuleId field where clause */
  failureRuleId?: InputMaybe<RateLimitWhereIntInput>
  /** The fingerprintFailure field where clause */
  fingerprintFailure?: InputMaybe<RateLimitWhereStringInput>
  /** The fingerprintId field where clause */
  fingerprintId?: InputMaybe<RateLimitWhereStringInput>
  /** The id field where clause */
  id?: InputMaybe<RateLimitWhereIdInput>
  /** The invalidFingerprint field where clause */
  invalidFingerprint?: InputMaybe<RateLimitWhereBooleanInput>
  /** The rateLimitOverrideId field where clause */
  rateLimitOverrideId?: InputMaybe<RateLimitWhereIntInput>
  /** The success field where clause */
  success?: InputMaybe<RateLimitWhereBooleanInput>
  /** The tokenConsumption field where clause */
  tokenConsumption?: InputMaybe<RateLimitWhereBooleanInput>
  /** The uid field where clause */
  uid?: InputMaybe<RateLimitWhereIntInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<RateLimitWhereUuidInput>
}

/** Result of createRateLimitRequest. The check row is always stored. rateLimit.enabled only controls denial. */
export type RateLimitRequestResult = {
  __typename?: 'RateLimitRequestResult'
  /** True when rateLimit.enabled is off. The check was stored and the caller should proceed, then record and consume. */
  bypassed?: Maybe<Scalars['Boolean']['output']>
  /** The check row, including a would-be denial while bypassed is true. */
  request?: Maybe<RateLimitRequest>
  /** True when the caller may proceed. Also true when bypassed is true, including when the stored check would have been denied. */
  success: Scalars['Boolean']['output']
  /** Token to pass to record and consume. Set when a check row was stored and the caller may proceed. Null when enforcement denied the check. */
  token?: Maybe<Scalars['ID']['output']>
}

/** A stacked window for one action. Rules are evaluated in memory after one history fetch. */
export type RateLimitRule = {
  __typename?: 'RateLimitRule'
  /** Action this rule applies to, such as LOGIN */
  action: Scalars['String']['output']
  /** count totals rows. distinct totals unique uid or IP values. */
  aggregate: RateLimitAggregate
  /** When true, that block override has no action and matches every action */
  blockAllActionsOnFailure: Scalars['Boolean']['output']
  /** When set, a failed check writes a block override that lasts this many minutes */
  blockMinutesOnFailure?: Maybe<Scalars['Int']['output']>
  /** Action whose history this rule counts. Null counts this rule's action. */
  countAction?: Maybe<Scalars['String']['output']>
  /** request counts checks. action counts completed work. both counts both. */
  countSource: RateLimitCountSource
  /** When the rule was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** uid, ip, or fingerprint. Null applies the limit to each present identity on its own. */
  dimension?: Maybe<RateLimitDimension>
  /** ip or uid. Required when aggregate is distinct. Null on a count rule. */
  distinctDimension?: Maybe<RateLimitDistinctDimension>
  /** False rows are ignored */
  enabled: Scalars['Boolean']['output']
  /** dimension filters each identity. fingerprint_or_uid is one shared fingerprint-or-user set. */
  historyMatch: RateLimitHistoryMatch
  /** Primary key */
  id: Scalars['ID']['output']
  /** Maximum inside the window. A request total of this action includes the current attempt. */
  limit: Scalars['Int']['output']
  /** total, success, or failure */
  outcome: RateLimitOutcome
  /** When true, a failed check writes a block with no start and no end */
  permanentBlockOnFailure: Scalars['Boolean']['output']
  /** Minutes, Hours, or Days */
  timeUnit: RateLimitTimeUnit
  /** Window length */
  timeValue: Scalars['Int']['output']
  /** When the rule was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Rule id */
  uuid: Scalars['ID']['output']
}

/** Page of rate-limit rules */
export type RateLimitRuleListResponse = {
  __typename?: 'RateLimitRuleListResponse'
  /** Total number of rows found */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** Rules matching the filter */
  rateLimitRules?: Maybe<Array<Maybe<RateLimitRule>>>
}

/** Filters for rate-limit rules */
export type RateLimitRuleListWhereInput = {
  /** The action field where clause */
  action?: InputMaybe<RateLimitWhereStringInput>
  /** The aggregate field where clause */
  aggregate?: InputMaybe<RateLimitRuleWhereAggregateInput>
  /** The countAction field where clause */
  countAction?: InputMaybe<RateLimitWhereStringInput>
  /** The countSource field where clause */
  countSource?: InputMaybe<RateLimitRuleWhereCountSourceInput>
  /** The dimension field where clause */
  dimension?: InputMaybe<RateLimitRuleWhereDimensionInput>
  /** The distinctDimension field where clause */
  distinctDimension?: InputMaybe<RateLimitRuleWhereDistinctDimensionInput>
  /** The enabled field where clause */
  enabled?: InputMaybe<RateLimitWhereBooleanInput>
  /** The historyMatch field where clause */
  historyMatch?: InputMaybe<RateLimitRuleWhereHistoryMatchInput>
  /** The id field where clause */
  id?: InputMaybe<RateLimitWhereIdInput>
  /** The limit field where clause */
  limit?: InputMaybe<RateLimitWhereIntInput>
  /** The outcome field where clause */
  outcome?: InputMaybe<RateLimitRuleWhereOutcomeInput>
  /** The permanentBlockOnFailure field where clause */
  permanentBlockOnFailure?: InputMaybe<RateLimitWhereBooleanInput>
  /** The timeUnit field where clause */
  timeUnit?: InputMaybe<RateLimitRuleWhereTimeUnitInput>
  /** The timeValue field where clause */
  timeValue?: InputMaybe<RateLimitWhereIntInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<RateLimitWhereUuidInput>
}

/** Aggregate filter */
export type RateLimitRuleWhereAggregateInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitAggregate>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitAggregate>>>
}

/** Count source filter */
export type RateLimitRuleWhereCountSourceInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitCountSource>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitCountSource>>>
}

/** Dimension filter */
export type RateLimitRuleWhereDimensionInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitDimension>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitDimension>>>
}

/** Distinct dimension filter */
export type RateLimitRuleWhereDistinctDimensionInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitDistinctDimension>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitDistinctDimension>>>
}

/** History match filter */
export type RateLimitRuleWhereHistoryMatchInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitHistoryMatch>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitHistoryMatch>>>
}

/** Outcome filter */
export type RateLimitRuleWhereOutcomeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitOutcome>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitOutcome>>>
}

/** Time unit filter */
export type RateLimitRuleWhereTimeUnitInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<RateLimitTimeUnit>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<RateLimitTimeUnit>>>
}

/** Window length unit */
export enum RateLimitTimeUnit {
  /** Days */
  Days = 'Days',
  /** Hours */
  Hours = 'Hours',
  /** Minutes */
  Minutes = 'Minutes',
}

/** Boolean filter */
export type RateLimitWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Time filter for createdAt */
export type RateLimitWhereDateTimeInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Id filter. Equality and range. */
export type RateLimitWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Integer filter */
export type RateLimitWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** String filter */
export type RateLimitWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Uuid filter */
export type RateLimitWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Raw events */
export type RawEvent = {
  __typename?: 'RawEvent'
  /** The number of attempts */
  attempts?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The error level */
  errorLevel?: Maybe<Scalars['Int']['output']>
  /** Whether failed event has been resolved manually */
  errorResolvedManually?: Maybe<Scalars['Boolean']['output']>
  /** Link to event */
  eventUuid?: Maybe<Scalars['ID']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The new run time for the event */
  nextRunTime?: Maybe<Scalars['DateTime']['output']>
  /** The event payload from the provider */
  payload?: Maybe<Scalars['String']['output']>
  /** When true the raw event was processed */
  processed?: Maybe<Scalars['Boolean']['output']>
  /** The processing error */
  processingError?: Maybe<Scalars['String']['output']>
  /** The event source */
  source?: Maybe<Scalars['String']['output']>
  /** The transaction type */
  txnType?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Raw event policy list response */
export type RawEventListResponse = {
  __typename?: 'RawEventListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of raw events */
  rawEvents?: Maybe<Array<Maybe<RawEvent>>>
}

/** Raw event id type where input type */
export type RawEventListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Raw event policy where conditions to filter rows */
export type RawEventListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<RawEventListWhereIdInput>
}

export type RawEventUpdateInput = {
  /** Number of attempts made to process this source */
  attempts?: InputMaybe<Scalars['Int']['input']>
  /** Timestamp when this source was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Error level; e.g., 'info', 'warn', 'error' for this source */
  errorLevel?: InputMaybe<Scalars['Int']['input']>
  /** Whether an error was resolved manually for this source */
  errorResolvedManually?: InputMaybe<Scalars['Boolean']['input']>
  /** Unique identifier for the event associated with this source (if applicable) */
  eventUuid?: InputMaybe<Scalars['String']['input']>
  /** Unique identifier for the source (e.g., a database or file ID) */
  id: Scalars['Int']['input']
  /** Scheduled timestamp for the next run of this source */
  nextRunTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Payload data of the event */
  payload?: InputMaybe<Scalars['String']['input']>
  /** Whether the source has been processed successfully */
  processed?: InputMaybe<Scalars['Boolean']['input']>
  /** Detailed error message associated with processing errors for this source */
  processingError?: InputMaybe<Scalars['String']['input']>
  /** Source of the raw event */
  source?: InputMaybe<Scalars['String']['input']>
  /** Type of transaction associated with this source */
  txnType?: InputMaybe<Scalars['String']['input']>
  /** Timestamp when this source was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export enum RawExportStatus {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  PendingRestore = 'PENDING_RESTORE',
  Ready = 'READY',
}

/** Oracle AI: Top co-watch neighbor of the member's most recent watch */
export type RecencyBridgeInput = {
  /** Bridge content ID */
  contentId: Scalars['Int']['input']
  /** Bridge content title */
  title?: Scalars['String']['input']
  /** Co-viewer count */
  weight?: Scalars['Float']['input']
}

/** Oracle AI: A center the member has recently been active in */
export type RecencyCenterInput = {
  /** Center ID */
  centerId: Scalars['Int']['input']
  /** Center display name */
  centerName?: Scalars['String']['input']
  /** Recent watches rolled up to this center */
  watchCount?: Scalars['Int']['input']
}

/** Oracle AI: A recently watched item from the member's real-time WATCHED graph */
export type RecencyWatchedInput = {
  /** Watch completion fraction (0-1) */
  completion?: Scalars['Float']['input']
  /** Watched content ID */
  contentId: Scalars['Int']['input']
  /** Recency bucket: today, yesterday, this_week, earlier */
  timeframe?: Scalars['String']['input']
  /** Watched content title */
  title?: Scalars['String']['input']
}

export type RecognizedEntity = {
  __typename?: 'RecognizedEntity'
  confidence: Scalars['Float']['output']
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  entityType: Scalars['String']['output']
  matchType: Scalars['String']['output']
  name: Scalars['String']['output']
  titleGroupId: Scalars['String']['output']
}

/** Response wrapper for the recommendationList query */
export type RecommendationResponse = {
  __typename?: 'RecommendationResponse'
  /** The number of items returned */
  count: Scalars['Int']['output']
  /** The list of recommended content */
  items: Array<Content>
  /** The Recombee recommendation ID for attribution tracking */
  recommId?: Maybe<Scalars['String']['output']>
}

/** Input for recording work against a token from createRateLimitRequest */
export type RecordRateLimitActionInput = {
  /** Action name. Must match the check that issued the token. */
  action: Scalars['String']['input']
  /** Client IP to record on the action. When set, this is stored instead of the request client IP. */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** Error name or message when success is false */
  failureReason?: InputMaybe<Scalars['String']['input']>
  /** FingerprintJS visitor id. Falls back to the check, then the request header. */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** True when the protected work succeeded */
  success: Scalars['Boolean']['input']
  /** Token uuid from a passing check */
  token: Scalars['ID']['input']
  /** User id to record on the action. When set, this is used instead of the authenticated caller. */
  uid?: InputMaybe<Scalars['Int']['input']>
}

/** Result of recordRateLimitAction. The action is stored whether or not rateLimit.enabled is on. */
export type RecordRateLimitActionResult = {
  __typename?: 'RecordRateLimitActionResult'
  /** The recorded action. */
  action?: Maybe<RateLimitAction>
  /** False. Recording is not skipped when rateLimit.enabled is off. */
  bypassed: Scalars['Boolean']['output']
}

/** Oracle AI: Multi-signal refinement detection from Brooklyn's deterministic algorithm */
export type RefinementSignalsInput = {
  /** Centers from co-watch or adjacency overlap between domains */
  bridgeCenters?: Array<BridgeEntityInput>
  /** Weighted composite bridge strength between domains (0-1) */
  bridgeStrength: Scalars['Float']['input']
  /** Teachers spanning both previous and current domains */
  bridgeTeachers?: Array<BridgeEntityInput>
  /** Cosine similarity between previous and current query embeddings (0-1) */
  embeddingSimilarity: Scalars['Float']['input']
  /** Detected refinement mode: deepening, adjacent, or pivot */
  mode: Scalars['String']['input']
  /** Jaccard coefficient of query tokens (0-1) */
  tokenOverlap: Scalars['Float']['input']
}

/** Oracle AI: Structured refinement suggestion from Sage */
export type RefinementSuggestion = {
  __typename?: 'RefinementSuggestion'
  /** Content ID for similar_content / co_playlist refinement types */
  contentId?: Maybe<Scalars['Int']['output']>
  /** Duration filter value (exact DB tag, e.g. '15 Minutes') */
  duration?: Maybe<Scalars['String']['output']>
  /** Content ID for creator_explore refinement type */
  entityId?: Maybe<Scalars['Int']['output']>
  /** Level filter value (exact DB tag, e.g. 'Level 2-3') */
  level?: Maybe<Scalars['String']['output']>
  /** Search query override (omits level/duration qualifiers) */
  query?: Maybe<Scalars['String']['output']>
  /** Classification of refinement behavior */
  refinementType: RefinementType
  /** Series content ID for series_continue refinement type */
  seriesContentId?: Maybe<Scalars['Int']['output']>
  /** Standout chip flag (AI-502) — echo on clickedChip so the click event carries it */
  standout: Scalars['Boolean']['output']
  /** Standout arm: cohort_trending | new_rising | adjacent_momentum */
  standoutReason?: Maybe<Scalars['String']['output']>
  /** Standout arbitration tier: 'query' or 'fallback' */
  standoutTier?: Maybe<Scalars['String']['output']>
  /** Human-readable chip label */
  text: Scalars['String']['output']
}

/** Oracle AI: Refinement chip type classification */
export enum RefinementType {
  AdjacentTerritory = 'ADJACENT_TERRITORY',
  Content = 'CONTENT',
  CoPlaylist = 'CO_PLAYLIST',
  CreatorExplore = 'CREATOR_EXPLORE',
  FormatShift = 'FORMAT_SHIFT',
  MoodShift = 'MOOD_SHIFT',
  SeriesAdjacent = 'SERIES_ADJACENT',
  SeriesContinue = 'SERIES_CONTINUE',
  SeriesEpisode = 'SERIES_EPISODE',
  SimilarContent = 'SIMILAR_CONTENT',
  SimilarCreator = 'SIMILAR_CREATOR',
  SimilarViewers = 'SIMILAR_VIEWERS',
  TopicDeepen = 'TOPIC_DEEPEN',
  WatchBridge = 'WATCH_BRIDGE',
}

export enum RegistrationStatus {
  Cancelled = 'CANCELLED',
  None = 'NONE',
  Registered = 'REGISTERED',
}

/** Response when reordering a member's playlists */
export type ReorderPlaylistsResponse = {
  __typename?: 'ReorderPlaylistsResponse'
  /** The member's full custom-playlist set in its new display order (top first) */
  playlists: Array<Playlist>
}

export enum Role {
  Ambassador = 'AMBASSADOR',
  AmbassadorAdmin = 'AMBASSADOR_ADMIN',
  ApiClient = 'API_CLIENT',
  BillingSupport = 'BILLING_SUPPORT',
  CustomerService = 'CUSTOMER_SERVICE',
  CustomerServiceManager = 'CUSTOMER_SERVICE_MANAGER',
  Editor = 'EDITOR',
  EditorPlus = 'EDITOR_PLUS',
  FullAccessReadOnly = 'FULL_ACCESS_READ_ONLY',
  MarketingAgent = 'MARKETING_AGENT',
  MarketingHub = 'MARKETING_HUB',
  MarketingPlansManager = 'MARKETING_PLANS_MANAGER',
  ProductPlansManager = 'PRODUCT_PLANS_MANAGER',
  Qa = 'QA',
  SiteAdmin = 'SITE_ADMIN',
  User = 'USER',
  ViewContentOnly = 'VIEW_CONTENT_ONLY',
  ViewMediaOnly = 'VIEW_MEDIA_ONLY',
  WordpressArticle = 'WORDPRESS_ARTICLE',
  WordpressLp = 'WORDPRESS_LP',
  WordpressPage = 'WORDPRESS_PAGE',
}

export enum S3Acl {
  /** Private */
  Private = 'PRIVATE',
  /** Public read */
  PublicRead = 'PUBLIC_READ',
}

export type S3UpsertNdjsonInput = {
  /** The object access control policy */
  acl?: InputMaybe<S3Acl>
  /** The s3 object data */
  data: Scalars['JSON']['input']
  /** The primary identifier for this record */
  key: Scalars['ID']['input']
}

export type S3UpsertNdjsonResult = {
  __typename?: 'S3UpsertNdjsonResult'
  /** The number of objects upserted */
  count?: Maybe<Scalars['Int']['output']>
}

export type SearchAdjacentCenter = {
  __typename?: 'SearchAdjacentCenter'
  adjacencyType: Scalars['String']['output']
  centerId: Scalars['Int']['output']
  centerName: Scalars['String']['output']
  sharedContentCount: Scalars['Int']['output']
}

export type SearchContentResponse = {
  __typename?: 'SearchContentResponse'
  adjacency: Array<SearchAdjacentCenter>
  blacklistMessage?: Maybe<Scalars['String']['output']>
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /**
   * Ranked federated Content entities (same order as resultIds) — lets the client
   * hydrate tiles inline in ONE call (select the Content fields it needs, @defer the
   * heavy ones) instead of a second contentList round-trip. Additive + dormant: web
   * adopts it after the search/overview decoupling (Phase 3+). Currently populated on
   * the main retrieval path; the graph-chip / discovery branches resolve to [] until
   * their row ids are wired. Entitlement/progress/images resolve on the Content
   * entity (single source of truth) — search never re-implements policy.
   */
  content: Array<Content>
  contentTotalCount: Scalars['Int']['output']
  entities: Array<SearchEntity>
  /** Hero image URLs parallel to resultIds — same order, null for missing. Enables frontend LCP preload without hydration round-trip. */
  heroImageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  intentSignal: SearchIntentSignal
  /**
   * Stable, search-scoped id minted per call and returned on every response. The
   * SearchImpression -> click join key, independent of chatSessionId (which the
   * search/overview decoupling nulls on the new-web search path). AP-19485 joins on this.
   */
  queryId: Scalars['ID']['output']
  /** Ordered titleGroupIds (contentId-contentType) in ranked order. Frontend passes to contentList for tile hydration. */
  resultIds: Array<Scalars['String']['output']>
  topContentIds: Array<Scalars['Int']['output']>
  topContentScores: Array<Scalars['Float']['output']>
}

export type SearchContentResult = {
  __typename?: 'SearchContentResult'
  channel: Scalars['String']['output']
  /** Tile data resolved via federation — frontend selects content { ... } fields. */
  content?: Maybe<Content>
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  id: Scalars['ID']['output']
  personalizationBoost: Scalars['Float']['output']
  /** Sort columns — cached with merge results for zero-DB sort changes. */
  publishedAtDate?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  sortPopular?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type SearchEntity = {
  __typename?: 'SearchEntity'
  confidence: Scalars['Float']['output']
  contentId: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  entityType: Scalars['String']['output']
  matchType: Scalars['String']['output']
  name: Scalars['String']['output']
  titleGroupId: Scalars['String']['output']
}

export type SearchFilters = {
  contentId?: InputMaybe<Scalars['Int']['input']>
  duration?: InputMaybe<Scalars['String']['input']>
  entityId?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  refinementType?: InputMaybe<SearchRefinementType>
  seriesContentId?: InputMaybe<Scalars['Int']['input']>
  sourceContentIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type SearchIntentSignal = {
  __typename?: 'SearchIntentSignal'
  classification: Scalars['String']['output']
  reason: Scalars['String']['output']
  requiresLlm: Scalars['Boolean']['output']
}

/** Oracle AI: Center adjacency relationship from Brooklyn */
export type SearchOverviewAdjacencyInput = {
  /** Adjacency relationship type */
  adjacencyType?: Scalars['String']['input']
  /** Content center ID */
  centerId: Scalars['Int']['input']
  /** Content center display name */
  centerName: Scalars['String']['input']
  /** Number of shared content items */
  sharedContentCount?: Scalars['Int']['input']
}

/** The tapped chip's identity, echoed by the client on a chip-tap refinement (reward-join groundwork). */
export type SearchOverviewClickedChipInput = {
  contentId?: InputMaybe<Scalars['Int']['input']>
  duration?: InputMaybe<Scalars['String']['input']>
  entityId?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  /** Refinement query the chip carries (parity with ai-service / the client payload). */
  query?: InputMaybe<Scalars['String']['input']>
  refinementType: Scalars['String']['input']
  seriesContentId?: InputMaybe<Scalars['Int']['input']>
  standout?: InputMaybe<Scalars['Boolean']['input']>
  standoutReason?: InputMaybe<Scalars['String']['input']>
  standoutTier?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
}

/** Oracle AI: Pre-ranked content result from Brooklyn */
export type SearchOverviewContentInput = {
  /** Center names this content is tagged with */
  centers?: Array<Scalars['String']['input']>
  /** Search channel that produced this result */
  channel?: Scalars['String']['input']
  /** D6 content nid */
  contentId: Scalars['Int']['input']
  /** Content type */
  contentType?: Scalars['String']['input']
  /** Duration category (e.g. 15-30 min) */
  duration?: Scalars['String']['input']
  /** Centers from knowledge graph traversal */
  graphCenters?: Array<GraphEntityInput>
  /** Series from knowledge graph traversal */
  graphSeries?: Array<GraphSeriesEntityInput>
  /** Teachers from knowledge graph traversal */
  graphTeachers?: Array<GraphEntityInput>
  /** Brooklyn Content primary key */
  id: Scalars['ID']['input']
  /** Primary instructor/teacher name */
  instructor?: Scalars['String']['input']
  /** Difficulty level (e.g. Beginner, Intermediate) */
  level?: Scalars['String']['input']
  /** Personalization score boost applied */
  personalizationBoost?: Scalars['Float']['input']
  /** Brooklyn relevance score */
  score?: Scalars['Float']['input']
  /** Series title if part of a series */
  seriesTitle?: Scalars['String']['input']
  /** Content title */
  title?: Scalars['String']['input']
  /** Top co-watched content from ALSO_WATCHED graph edges */
  topCowatch?: InputMaybe<GraphCowatchInput>
  /** Topic names this content is tagged with */
  topics?: Array<Scalars['String']['input']>
}

/** Oracle AI: Entity match from Brooklyn's entity recognition */
export type SearchOverviewEntityInput = {
  /** Match confidence 0-1 */
  confidence?: Scalars['Float']['input']
  /** Associated content ID if applicable */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Entity type: person, series, topic, etc. */
  entityType: Scalars['String']['input']
  /** Match type: exact, fuzzy, partial */
  matchType?: Scalars['String']['input']
  /** Matched entity name */
  name: Scalars['String']['input']
}

/** Oracle AI: Entity metadata from Brooklyn content graph */
export type SearchOverviewEntityMetadataInput = {
  /** Entity content ID */
  contentId: Scalars['Int']['input']
  /** Entity type: series, person */
  entityType: Scalars['String']['input']
  /** Episode count for series entities */
  episodeCount?: InputMaybe<Scalars['Int']['input']>
  /** Role breakdown for person entities */
  roles?: Array<SearchOverviewEntityRoleInput>
  /** Season count for series entities */
  seasonCount?: InputMaybe<Scalars['Int']['input']>
  /** Total content count for person entities */
  totalContent?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: Creator role breakdown from content_references */
export type SearchOverviewEntityRoleInput = {
  /** Number of content items with this role */
  count?: Scalars['Int']['input']
  /** Role type: yoga-teacher, interview-host, etc. */
  type: Scalars['String']['input']
}

export type SearchOverviewFeedbackResponse = {
  __typename?: 'SearchOverviewFeedbackResponse'
  success: Scalars['Boolean']['output']
}

/** Oracle AI: Intent classification from Brooklyn */
export type SearchOverviewIntentInput = {
  /** Intent type: navigate, navigate_topic, specific, vague, explore */
  classification: Scalars['String']['input']
  /** Human-readable reason for classification */
  reason?: Scalars['String']['input']
  /** Whether Brooklyn flagged this for LLM processing */
  requiresLlm?: Scalars['Boolean']['input']
}

/** Oracle AI: The member's cross-session search journey — what they've already explored */
export type SearchOverviewJourneyInput = {
  /** Topics the member has already explored (recent queries + watched top centers) */
  exploredTopics?: Array<Scalars['String']['input']>
  /** The member's recent search queries */
  recentQueries?: Array<Scalars['String']['input']>
}

/** Oracle AI: Pre-ranked playlist result from Brooklyn */
export type SearchOverviewPlaylistInput = {
  /** Fraction of playlist items in the top matched center/topic (0-1) */
  centerCoverage?: InputMaybe<Scalars['Float']['input']>
  /** Public playlist creator display name (empty for anonymous/private) */
  creatorDisplayName?: Scalars['String']['input']
  /** Top centers in playlist from graph enrichment */
  graphCenters?: Array<Scalars['String']['input']>
  /** Durations in playlist (e.g. 30 Minutes) */
  graphDurations?: Array<Scalars['String']['input']>
  /** Focus areas in playlist (e.g. Core Strength) */
  graphFocuses?: Array<Scalars['String']['input']>
  /** Genres in playlist (e.g. Documentary) */
  graphGenres?: Array<Scalars['String']['input']>
  /** Difficulty levels in playlist (e.g. Beginner) */
  graphLevels?: Array<Scalars['String']['input']>
  /** Practice styles in playlist (e.g. Vinyasa, Hatha) */
  graphStyles?: Array<Scalars['String']['input']>
  /** Top teachers in playlist from graph enrichment */
  graphTeachers?: Array<Scalars['String']['input']>
  /** Top primary browse categories in playlist */
  graphTopicCenters?: Array<Scalars['String']['input']>
  /** Total items in playlist */
  itemCount?: Scalars['Int']['input']
  /** Number of matched content items in playlist */
  matchedContentCount?: Scalars['Int']['input']
  /** Brooklyn playlist UUID */
  playlistId: Scalars['String']['input']
  /** Playlist display name */
  playlistName?: Scalars['String']['input']
  /** Relevance score */
  score?: Scalars['Float']['input']
  /** Fraction of playlist items by the top matched teacher (0-1) */
  teacherCoverage?: InputMaybe<Scalars['Float']['input']>
  /** Playlist visibility: public, anonymous, or private */
  visibility?: Scalars['String']['input']
}

/** Oracle AI: Profile result from Brooklyn */
export type SearchOverviewProfileInput = {
  /** User bio */
  bio?: InputMaybe<Scalars['String']['input']>
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** User location */
  location?: InputMaybe<Scalars['String']['input']>
  /** Relevance score */
  score?: Scalars['Float']['input']
  /** User UID */
  uid: Scalars['String']['input']
}

/** Oracle AI: Member's real-time recency signals from the WATCHED graph — recent watches, active centers, next-step bridge */
export type SearchOverviewRecencyInput = {
  /** Top co-watch neighbor of the most recent watch */
  bridge?: InputMaybe<RecencyBridgeInput>
  /** Recently active centers (max 3) */
  recentCenters?: Array<RecencyCenterInput>
  /** Recently watched items, most-recent-first (max 5) */
  recentWatched?: Array<RecencyWatchedInput>
  /** Whether recent watching shares a center with this search (Brooklyn-computed). False suppresses the 'Since you watched' opener; absent defaults to true (pre-gate Brooklyn). */
  relevantToQuery?: Scalars['Boolean']['input']
}

/** A served refinement chip on the overview stream's final payload (mirrors the ai-service RefinementSuggestion shape). */
export type SearchOverviewRefinement = {
  __typename?: 'SearchOverviewRefinement'
  /** Content ID for similar_content / co_playlist refinement types */
  contentId?: Maybe<Scalars['Int']['output']>
  /** Duration filter value (exact DB tag, e.g. '15 Minutes') */
  duration?: Maybe<Scalars['String']['output']>
  /** Content ID for creator_explore refinement type */
  entityId?: Maybe<Scalars['Int']['output']>
  /** Level filter value (exact DB tag, e.g. 'Level 2-3') */
  level?: Maybe<Scalars['String']['output']>
  /** Search query override (omits level/duration qualifiers) */
  query?: Maybe<Scalars['String']['output']>
  /** Classification of refinement behavior */
  refinementType: SearchRefinementType
  /** Series content ID for series_continue refinement type */
  seriesContentId?: Maybe<Scalars['Int']['output']>
  /** Standout chip flag — echo on clickedChip so the click carries it */
  standout: Scalars['Boolean']['output']
  /** Standout arm: cohort_trending | new_rising | adjacent_momentum */
  standoutReason?: Maybe<Scalars['String']['output']>
  /** Standout arbitration tier: 'query' or 'fallback' */
  standoutTier?: Maybe<Scalars['String']['output']>
  /** Human-readable chip label */
  text: Scalars['String']['output']
}

/** Oracle AI: Input for Brooklyn-powered search overview streaming */
export type SearchOverviewStreamInput = {
  /** Center adjacency relationships */
  adjacency?: Array<SearchOverviewAdjacencyInput>
  /** Refinement types Brooklyn confirmed have underlying data — constrains chip generation */
  availableRefinements?: Array<Scalars['String']['input']>
  /** Chat session ID from context seeding. When provided without Brooklyn context fields, context is loaded from the stored session turn. */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** The chip the member tapped to trigger this refinement turn (full identity, AI-502 reward join). Presence marks the turn as a chip click; supersedes the bare refinementType field. */
  clickedChip?: InputMaybe<SelectedChipInput>
  /** Pre-ranked content results from Brooklyn */
  content?: Array<SearchOverviewContentInput>
  /** Recognized entities from Brooklyn */
  entities?: Array<SearchOverviewEntityInput>
  /** Entity metadata from Brooklyn content graph (series structure, creator roles) */
  entityMetadata?: Array<SearchOverviewEntityMetadataInput>
  /** Brooklyn's intent classification. Optional when chatSessionId is provided (loaded from DB). */
  intent?: InputMaybe<SearchOverviewIntentInput>
  /** Cross-session journey: what the member already explored, so the overview builds forward instead of restating */
  journey?: InputMaybe<SearchOverviewJourneyInput>
  /** Language preference */
  language?: Scalars['String']['input']
  /** Personality to use (Sage default) */
  personalityId?: Scalars['Int']['input']
  /** Pre-ranked playlist results from Brooklyn */
  playlists?: Array<SearchOverviewPlaylistInput>
  /** decisionId from the prior turn's final payload — the exact join key from this click back to the served slate. */
  previousDecisionId?: InputMaybe<Scalars['ID']['input']>
  /** Profile results from Brooklyn */
  profiles?: Array<SearchOverviewProfileInput>
  /** The user's search query */
  query: Scalars['String']['input']
  /** Real-time recency signals from the WATCHED graph — where the member is right now. Absent for cold users. */
  recency?: InputMaybe<SearchOverviewRecencyInput>
  /** Multi-signal refinement detection from Brooklyn: mode (deepening/adjacent/pivot), bridge strength, bridge entities */
  refinementSignals?: InputMaybe<RefinementSignalsInput>
  /** Type of refinement chip clicked: topic_deepen, adjacent_territory, creator_explore, format_shift, mood_shift, series_continue, similar_viewers */
  refinementType?: InputMaybe<Scalars['String']['input']>
  /** Pre-selected refinement chips from Brooklyn's deterministic algorithm. LLM weaves these into prose. */
  selectedChips?: Array<SelectedChipInput>
  /** Session ID for refinement continuity. 'new' or omit for fresh search. */
  sessionId?: InputMaybe<Scalars['ID']['input']>
  /** User's computed graph profile (TOP_TEACHER, TOP_CENTER) for personalized overview */
  userGraphProfile?: InputMaybe<UserGraphProfileInput>
  /** User's computed skill level per center from watch history */
  userLevelContext?: Array<SearchOverviewUserLevelInput>
}

/** One event on the overview stream (mirrors the ai-service subscription payload field-for-field, so the client flip is a document swap). */
export type SearchOverviewStreamPayload = {
  __typename?: 'SearchOverviewStreamPayload'
  /** Search session ID for refinement and feedback */
  chatSessionId?: Maybe<Scalars['ID']['output']>
  /** Chip-decision id for this turn's served slate (null until the measurement log follows the channel) */
  decisionId?: Maybe<Scalars['ID']['output']>
  errors: Array<Scalars['String']['output']>
  executionTime?: Maybe<Scalars['Float']['output']>
  isFinal: Scalars['Boolean']['output']
  refinementSuggestions?: Maybe<Array<Scalars['String']['output']>>
  /**
   * Free-text-refine handshake (derive path): the agent-resolved search queries for
   * this turn, echoed on the FIRST payload so the client fires its tile `search`
   * with the same queries → tiles == narration on one shared retrieval set.
   */
  resolvedSearchQueries?: Maybe<Array<Scalars['String']['output']>>
  /** Status key for stage-based loading feedback (e.g. 'personalizing', 'generating') */
  statusText?: Maybe<Scalars['String']['output']>
  /** Typed refinement suggestions with classification and structured attributes */
  structuredRefinements?: Maybe<Array<SearchOverviewRefinement>>
  success: Scalars['Boolean']['output']
  textChunk?: Maybe<Scalars['String']['output']>
  /** Turn ID for submitting feedback via searchOverviewFeedback */
  turnId?: Maybe<Scalars['ID']['output']>
}

export type SearchOverviewStreamSubscribeInput = {
  /**
   * Chat session id. OPTIONAL under the decoupling: omit it on a conversation's
   * first subscribe and the server mints one and returns it in the first payload
   * (AI-Guide pattern); thread it back on refines. Legacy (stored-turn) clients
   * still send it. An unknown id is ignored — the server mints a fresh one.
   */
  chatSessionId?: InputMaybe<Scalars['ID']['input']>
  /** The tapped chip when this turn came from a chip tap */
  clickedChip?: InputMaybe<SearchOverviewClickedChipInput>
  /** Derive path: page size for the derived retrieval (defaults to the search default). */
  contentLimit?: InputMaybe<Scalars['Int']['input']>
  /** Derive path: page offset for the derived retrieval. */
  contentOffset?: InputMaybe<Scalars['Int']['input']>
  /**
   * Select the derive path (search/overview decoupling Phase 2): the subscription
   * builds its own context via the shared retrieval strategy instead of reading a
   * search-seeded turn. Gated by features.search.overviewDeriveEnabled; omit (or
   * false) for the legacy stored-turn path.
   */
  deriveContext?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Attribution echo: the content ids the client actually displayed for this turn.
   * On discovery/refine the derive may re-run retrieval and drift from the tiles;
   * echoing the displayed ids keeps turn.content_ids aligned with what was shown.
   */
  displayedContentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Derive path: the search filters (chip refinements, level/duration). Feeds the shared retrieval strategy. */
  filters?: InputMaybe<SearchFilters>
  language?: InputMaybe<Scalars['String']['input']>
  /** Derive path: chip texts already served this conversation (cross-session dedup). */
  previousChipTexts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Derive path: prior-turn content centers (refinement context). */
  previousContentCenters?: InputMaybe<Scalars['String']['input']>
  /** Derive path: prior-turn content ids (adjacency / 'more like what you saw'). */
  previousContentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** The decision id the tapped chip was served under */
  previousDecisionId?: InputMaybe<Scalars['ID']['input']>
  /** Derive path: the prior turn's raw query (free-text refine resolution). */
  previousQuery?: InputMaybe<Scalars['String']['input']>
  /** The user's search query */
  query: Scalars['String']['input']
}

/** Oracle AI: User's computed skill level per center from watch history */
export type SearchOverviewUserLevelInput = {
  /** Highest level with sufficient completions */
  recommendedLevel: Scalars['String']['input']
  /** Level reference type: yoga-level, fitness-level */
  refType: Scalars['String']['input']
  /** One level above recommended */
  stretchLevel: Scalars['String']['input']
}

export type SearchPlaylistResult = {
  __typename?: 'SearchPlaylistResult'
  creatorDisplayName?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  itemCount?: Maybe<Scalars['Int']['output']>
  matchReasons?: Maybe<Array<PlaylistMatchReason>>
  matchedContentCount?: Maybe<Scalars['Int']['output']>
  playlist: Playlist
  playlistId: Scalars['ID']['output']
  playlistName: Scalars['String']['output']
  previewContentTitles?: Maybe<Array<Scalars['String']['output']>>
  previewThumbnailUrls?: Maybe<Array<Scalars['String']['output']>>
  score: Scalars['Float']['output']
  textRelevance?: Maybe<Scalars['Float']['output']>
  titleRelevance?: Maybe<Scalars['Float']['output']>
}

export type SearchPlaylistsResponse = {
  __typename?: 'SearchPlaylistsResponse'
  playlistTotalCount: Scalars['Int']['output']
  playlists: Array<SearchPlaylistResult>
}

export enum SearchRefinementType {
  AdjacentTerritory = 'adjacent_territory',
  CoPlaylist = 'co_playlist',
  Content = 'content',
  CreatorExplore = 'creator_explore',
  CuratorExplore = 'curator_explore',
  FormatShift = 'format_shift',
  MoodShift = 'mood_shift',
  PlaylistByLevel = 'playlist_by_level',
  PlaylistByStyle = 'playlist_by_style',
  PlaylistDeepDive = 'playlist_deep_dive',
  SeriesAdjacent = 'series_adjacent',
  SeriesContinue = 'series_continue',
  SeriesEpisode = 'series_episode',
  SimilarContent = 'similar_content',
  SimilarCreator = 'similar_creator',
  SimilarViewers = 'similar_viewers',
  TopicDeepen = 'topic_deepen',
  WatchBridge = 'watch_bridge',
}

export enum SearchSort {
  AZ = 'A_Z',
  DateAdded = 'DATE_ADDED',
  Popularity = 'POPULARITY',
  Relevance = 'RELEVANCE',
}

/**
 * One tappable dropdown suggestion. `text` carries the display/query string
 * (recommended items may be template-phrased, e.g. "Explore Sacred Geometry");
 * entityType/entityId identify the underlying graph node (recommended only).
 */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion'
  entityId?: Maybe<Scalars['String']['output']>
  /** "center" | "person" | "video" (recommended only) */
  entityType?: Maybe<Scalars['String']['output']>
  kind: SearchSuggestionKind
  /** Recommendation provenance (recommended only): adjacent_center | similar_teacher | trending | profile. Null on v1/kill-switch items and the other columns. */
  source?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
}

/** Suggestion category — the FE treats each differently (AP-19220 header dropdown). */
export enum SearchSuggestionKind {
  Entity = 'ENTITY',
  Keyword = 'KEYWORD',
  Semantic = 'SEMANTIC',
}

export type SearchSuggestionsResponse = {
  __typename?: 'SearchSuggestionsResponse'
  /** The user's own recent searches, newest-first, case-insensitive distinct. */
  history: Array<SearchSuggestion>
  /** Top queries across all members (popular_searches rollup, rolling 7d). Question-shaped items carry kind SEMANTIC; the rest KEYWORD. */
  popular: Array<SearchSuggestion>
  /** Personalized graph-profile suggestions — empty for day-one users (FE fills from popular). */
  recommended: Array<SearchSuggestion>
}

/** Standardized, provider-agnostic subscription details derived from a 2nd-party provider's last receipt. When a receipt exists but the user has no matching billing events, a partial object is returned (receipt-derived fields populated; status/paidThroughDate/nextBillAmount null) rather than null. */
export type SecondPartyProviderSubscription = {
  __typename?: 'SecondPartyProviderSubscription'
  /** The product the subscription will auto-renew into */
  autoRenewProductId?: Maybe<Scalars['String']['output']>
  /** Whether the subscription is set to auto-renew (only populated for providers whose receipt exposes it) */
  autoRenewStatus?: Maybe<Scalars['Boolean']['output']>
  /** The billing-account identifier for this subscription — Amazon: the receipt's provider_user_id; Google: the purchase token; PayPal: the recurring payment id; otherwise the receipt/transaction id */
  billingAccountId?: Maybe<Scalars['ID']['output']>
  /** Serialized as YYYY-MM-DD. The store receipt's own cancel/expiry date when not auto-renewing (apple/roku/amazon/google), the receipt cancel_date column (google fallback), else the last CANCEL event */
  cancelDate?: Maybe<Scalars['Date']['output']>
  /** ISO 4217 currency code of the subscription price, upper-cased (populated where resolvable — Apple/Roku/Google from the store receipt, Amazon from the billing_provider_currency catalog by storefront country, PayPal from events) */
  currency?: Maybe<Scalars['String']['output']>
  /** Serialized as YYYY-MM-DD. The subscription version's end/expiry — Apple's last-transaction expiresDate, Roku's expirationDate, Amazon's renewalDate, Google's lineItems[0].expiryTime, PayPal's event end_date. Used for the panel's Plan End Date. */
  endDate?: Maybe<Scalars['Date']['output']>
  /** The provider environment, e.g. sandbox/production (only populated where applicable) */
  environment?: Maybe<Scalars['String']['output']>
  /** The next renewing charge — Amazon from the billing_provider_product_pricing catalog, Google from lineItems[0].autoRenewingPlan.recurringPrice; 0 when the subscription is not set to auto-renew; otherwise the last billing event's next_bill_amount (PayPal may fall back to amount) */
  nextBillAmount?: Maybe<Scalars['Float']['output']>
  /** Alias of paidThroughDate, named to match the existing Zuora panel's field */
  nextReviewDate?: Maybe<Scalars['Date']['output']>
  /** Serialized as YYYY-MM-DD. For Apple/Roku/Amazon/Google the store receipt's renewal/expiry date (null when the subscription is not set to auto-renew); otherwise the user's last billing event. */
  paidThroughDate?: Maybe<Scalars['Date']['output']>
  /** Human-readable plan name, enriched from the billing_provider_product/billing_product catalog by planSku */
  planName?: Maybe<Scalars['String']['output']>
  /** The provider's own plan/product identifier */
  planSku?: Maybe<Scalars['String']['output']>
  /** The app/brand this subscription belongs to — Apple: Gaia vs Yoga International; PayPal: MYO vs FMTV; null for other providers or when unresolved */
  platform?: Maybe<ProviderSubscriptionPlatform>
  /** The provider name (internal source key, e.g. itunes, amazon, roku, google, paypal — not apple) */
  provider?: Maybe<Scalars['String']['output']>
  /** Serialized as YYYY-MM-DD. The subscription's start — Apple/Roku's originalPurchaseDate, Amazon's purchaseDate, Google's startTime, PayPal's event start_date. */
  startDate?: Maybe<Scalars['Date']['output']>
  /** For Apple/Roku/Google, the live subscription status from the store (App Store `status` / Roku `purchaseStatus` / Google `subscriptionState`, lowercased). For Amazon/PayPal (no live store status) and every other provider, sourced from the user's last billing event (events table). Null when a receipt exists but nothing could be resolved. */
  status?: Maybe<Scalars['String']['output']>
  /** The provider's subscription identifier — Apple's originalTransactionId, Roku's OriginalTransactionId, Amazon's receiptId, Google's latestOrderId, PayPal's recurring payment id */
  subscriptionId?: Maybe<Scalars['ID']['output']>
  /** Alias of subscriptionId, named to match the existing Zuora panel's field */
  subscriptionNumber?: Maybe<Scalars['ID']['output']>
  /** The user this subscription belongs to */
  userInfo?: Maybe<UserInfo>
}

/** A seed question. Brooklyn owns the entity fields. */
export type SeedQuestion = {
  __typename?: 'SeedQuestion'
  /** When the question was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Oracle id */
  id: Scalars['ID']['output']
  /** Language code */
  language?: Maybe<Scalars['String']['output']>
  /** Question text */
  question: Scalars['String']['output']
  /** Action, priority, and display text rebuilt for existing clients */
  tags: Array<Scalars['String']['output']>
  /** When the question was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Session facts Brooklyn uses to show or hide seed-question action rows. */
export type SeedQuestionActionVisibility = {
  __typename?: 'SeedQuestionActionVisibility'
  cardTag?: Maybe<Scalars['String']['output']>
  hasActiveReading?: Maybe<Scalars['Boolean']['output']>
  oraclePulledToday?: Maybe<Scalars['Boolean']['output']>
  pullCount?: Maybe<Scalars['Int']['output']>
}

/** Editorial category slice */
export enum SeedQuestionCategory {
  General = 'GENERAL',
  LoveRelationships = 'LOVE_RELATIONSHIPS',
  NonPractice = 'NON_PRACTICE',
  PersonalDevelopment = 'PERSONAL_DEVELOPMENT',
  PracticeBreathwork = 'PRACTICE_BREATHWORK',
  PracticeMeditation = 'PRACTICE_MEDITATION',
  PracticeYoga = 'PRACTICE_YOGA',
  WorkMoney = 'WORK_MONEY',
}

/** Feature scope for divination seed-question lists. Values match the AI service enum. */
export enum SeedQuestionFeature {
  Alchemize = 'ALCHEMIZE',
  Horoscope = 'HOROSCOPE',
  OracleCards = 'ORACLE_CARDS',
  Tarot = 'TAROT',
}

/** Paginated seed questions */
export type SeedQuestionListResponse = {
  __typename?: 'SeedQuestionListResponse'
  /** Number of questions before paging */
  count: Scalars['Int']['output']
  /** Applied limit */
  limit: Scalars['Int']['output']
  /** Applied offset */
  offset: Scalars['Int']['output']
  /** Matching questions */
  seedQuestions: Array<SeedQuestion>
  /** Rainbow tags used for personalization. Empty when personalization is off. */
  userMetaTags: Array<UserMetaTag>
}

/** Same shape as the AI service SeedQuestionListWhere input. The list accepts it and ignores it. */
export type SeedQuestionListWhere = {
  /** Filter by creation timestamp */
  createdAt?: InputMaybe<OracleDateTimeFilterInput>
  /** Filter by seed question ID */
  id?: InputMaybe<OracleIdFilterInput>
  /** Filter by language code */
  language?: InputMaybe<OracleStringFilterInput>
  /** Filter by question text */
  question?: InputMaybe<OracleStringFilterInput>
  /** Filter by tags using overlap operation */
  tags?: InputMaybe<OracleTagsFilterInput>
  /** Filter by update timestamp */
  updatedAt?: InputMaybe<OracleDateTimeFilterInput>
}

/** Rainbow personalization for the general pool */
export enum SeedQuestionPersonalization {
  RainbowCategory_10 = 'RAINBOW_CATEGORY_10',
}

/** Rainbow meta tag passed by the caller */
export type SeedQuestionUserMetaTagInput = {
  /** Meta tag name, without the RC: prefix */
  name: Scalars['String']['input']
}

/** Oracle AI: Pre-selected refinement chip from Brooklyn's deterministic algorithm */
export type SelectedChipInput = {
  /** Content ID for series_episode (specific episode) */
  contentId?: InputMaybe<Scalars['Int']['input']>
  /** Duration for format_shift (e.g. '30 Minutes') */
  duration?: InputMaybe<Scalars['String']['input']>
  /** Graph edge-type provenance (AI-502 M1 D8): which computed/graph edges sourced this chip (e.g. ALSO_WATCHED, TRENDING_IN_24H). Stamped by Brooklyn at context-seed; rides to the decision log so the reward loop scores edges, not just move-classes. */
  edgeTypes?: Array<Scalars['String']['input']>
  /** Entity ID for creator_explore, topic_deepen, adjacent_territory */
  entityId?: InputMaybe<Scalars['Int']['input']>
  /** Level for format_shift (e.g. 'Level 2-3') */
  level?: InputMaybe<Scalars['String']['input']>
  /** Query for format_shift/mood_shift */
  query?: InputMaybe<Scalars['String']['input']>
  /** Refinement type: series_continue, creator_explore, etc. */
  refinementType: Scalars['String']['input']
  /** Series content ID for series_continue */
  seriesContentId?: InputMaybe<Scalars['Int']['input']>
  /** Standout chip flag — community-signal 4th slot (AI-502) */
  standout?: Scalars['Boolean']['input']
  /** Standout arm: cohort_trending | new_rising | adjacent_momentum */
  standoutReason?: InputMaybe<Scalars['String']['input']>
  /** Standout arbitration tier (AI-502 enforce_v8): 'query' (query/result/adjacent centers) or 'fallback' (member TOP_CENTERS, discovery-only). Rides to the decision log for relevance telemetry. */
  standoutTier?: InputMaybe<Scalars['String']['input']>
  /** Chip display text (2-4 words) */
  text: Scalars['String']['input']
}

/** Oracle AI: A semantic search candidate */
export type SemanticSearchCandidate = {
  __typename?: 'SemanticSearchCandidate'
  candidateId: Scalars['String']['output']
  itemType: Scalars['String']['output']
  metadata: Scalars['JSON']['output']
  score: Scalars['Float']['output']
  title?: Maybe<Scalars['String']['output']>
}

/** Oracle AI: Input for semantic carousel search */
export type SemanticSearchCarouselInput = {
  language?: Scalars['String']['input']
  limits: Scalars['JSON']['input']
  queries: Array<Scalars['String']['input']>
  types: Array<Scalars['String']['input']>
}

/** Oracle AI: Semantic carousel search result */
export type SemanticSearchCarouselResult = {
  __typename?: 'SemanticSearchCarouselResult'
  candidates: Array<SemanticSearchCandidate>
}

/** Server status */
export type ServerStatus = {
  __typename?: 'ServerStatus'
  success: Scalars['Boolean']['output']
}

/** SKU rule: whether customer must have or must not have purchased */
export enum SkuCheckType {
  HasNotPurchased = 'HAS_NOT_PURCHASED',
  HasPurchased = 'HAS_PURCHASED',
}

/** SKU rule: AND or OR between ecommerce and plan SKU criteria */
export enum SkuOperator {
  And = 'AND',
  Or = 'OR',
}

/** Worker job run ledger row */
export type SocialsInfluencerJobRun = {
  __typename?: 'SocialsInfluencerJobRun'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  jobName?: Maybe<Scalars['String']['output']>
  output?: Maybe<Scalars['JSON']['output']>
  platform?: Maybe<Scalars['String']['output']>
  startedAt?: Maybe<Scalars['DateTime']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type SocialsInfluencerJobRunListResponse = {
  __typename?: 'SocialsInfluencerJobRunListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Maybe<SocialsInfluencerJobRun>>>
}

/** Where filters for influencer job runs */
export type SocialsInfluencerJobRunWhereInput = {
  id?: InputMaybe<SocialsWhereIdInput>
  jobName?: InputMaybe<SocialsWhereStringInput>
  platform?: InputMaybe<SocialsWhereStringInput>
  status?: InputMaybe<SocialsWhereStringInput>
}

/** Scraped social post in the spider corpus */
export type SocialsSpiderContent = {
  __typename?: 'SocialsSpiderContent'
  authorProfile?: Maybe<Scalars['JSON']['output']>
  authorSourceId?: Maybe<Scalars['String']['output']>
  authorUsername?: Maybe<Scalars['String']['output']>
  contentMetadata?: Maybe<Scalars['JSON']['output']>
  contentText?: Maybe<Scalars['String']['output']>
  contentType?: Maybe<Scalars['String']['output']>
  crawledAt?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  destinationUrl?: Maybe<Scalars['String']['output']>
  discoveryMode?: Maybe<Scalars['String']['output']>
  durationSeconds?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['ID']['output']>
  keywordRelevanceScore?: Maybe<Scalars['Float']['output']>
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  language?: Maybe<Scalars['String']['output']>
  /** Most recent metrics snapshot by capturedAt */
  latestMetrics?: Maybe<SocialsSpiderContentMetrics>
  /** Paginated metrics snapshots for this content */
  metrics?: Maybe<SocialsSpiderContentMetricsListResponse>
  metricsLastCapturedAt?: Maybe<Scalars['DateTime']['output']>
  metricsSnapshotCount?: Maybe<Scalars['Int']['output']>
  parentSourceId?: Maybe<Scalars['String']['output']>
  platformCategory?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  source?: Maybe<Scalars['String']['output']>
  sourceId?: Maybe<Scalars['String']['output']>
  thumbnailUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

/** Scraped social post in the spider corpus */
export type SocialsSpiderContentMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  useMaster?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<SocialsSpiderContentMetricsWhereInput>
}

export type SocialsSpiderContentListResponse = {
  __typename?: 'SocialsSpiderContentListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Maybe<SocialsSpiderContent>>>
}

/** Engagement metrics snapshot for spider content */
export type SocialsSpiderContentMetrics = {
  __typename?: 'SocialsSpiderContentMetrics'
  capturedAt?: Maybe<Scalars['DateTime']['output']>
  clicks?: Maybe<Scalars['String']['output']>
  collectedBy?: Maybe<Scalars['String']['output']>
  comments?: Maybe<Scalars['String']['output']>
  contentId?: Maybe<Scalars['ID']['output']>
  hoursSincePublish?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['ID']['output']>
  impressions?: Maybe<Scalars['String']['output']>
  likes?: Maybe<Scalars['String']['output']>
  outboundClicks?: Maybe<Scalars['String']['output']>
  quotes?: Maybe<Scalars['String']['output']>
  raw?: Maybe<Scalars['JSON']['output']>
  saves?: Maybe<Scalars['String']['output']>
  shares?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  waveLabel?: Maybe<Scalars['String']['output']>
  weightedEngagement?: Maybe<Scalars['String']['output']>
}

export type SocialsSpiderContentMetricsListResponse = {
  __typename?: 'SocialsSpiderContentMetricsListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Maybe<SocialsSpiderContentMetrics>>>
}

/** Where filters for spider content metrics */
export type SocialsSpiderContentMetricsWhereInput = {
  capturedAt?: InputMaybe<SocialsWhereDateTimeInput>
  contentId?: InputMaybe<SocialsWhereIdInput>
  id?: InputMaybe<SocialsWhereIdInput>
  source?: InputMaybe<SocialsWhereStringInput>
  waveLabel?: InputMaybe<SocialsWhereStringInput>
}

/** Where filters for spider content */
export type SocialsSpiderContentWhereInput = {
  authorUsername?: InputMaybe<SocialsWhereStringInput>
  contentType?: InputMaybe<SocialsWhereStringInput>
  discoveryMode?: InputMaybe<SocialsWhereStringInput>
  id?: InputMaybe<SocialsWhereIdInput>
  keywords?: InputMaybe<SocialsWhereStringListInput>
  language?: InputMaybe<SocialsWhereStringInput>
  publishedAt?: InputMaybe<SocialsWhereDateTimeInput>
  source?: InputMaybe<SocialsWhereStringInput>
  sourceId?: InputMaybe<SocialsWhereStringInput>
}

/** Apify scrape job ledger row */
export type SocialsSpiderJobs = {
  __typename?: 'SocialsSpiderJobs'
  actorName?: Maybe<Scalars['String']['output']>
  apifyRunId?: Maybe<Scalars['String']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  inputConfig?: Maybe<Scalars['JSON']['output']>
  itemsScraped?: Maybe<Scalars['Int']['output']>
  startedAt?: Maybe<Scalars['DateTime']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type SocialsSpiderJobsListResponse = {
  __typename?: 'SocialsSpiderJobsListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Maybe<SocialsSpiderJobs>>>
}

/** Where filters for spider jobs */
export type SocialsSpiderJobsWhereInput = {
  actorName?: InputMaybe<SocialsWhereStringInput>
  apifyRunId?: InputMaybe<SocialsWhereStringInput>
  id?: InputMaybe<SocialsWhereIdInput>
  status?: InputMaybe<SocialsWhereStringInput>
}

/** Global keyword watchlist row */
export type SocialsSpiderKeywords = {
  __typename?: 'SocialsSpiderKeywords'
  category?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  keyword?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SocialsSpiderKeywordsListResponse = {
  __typename?: 'SocialsSpiderKeywordsListResponse'
  count?: Maybe<Scalars['Int']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  rows?: Maybe<Array<Maybe<SocialsSpiderKeywords>>>
}

/** Where filters for spider keywords */
export type SocialsSpiderKeywordsWhereInput = {
  category?: InputMaybe<SocialsWhereStringInput>
  id?: InputMaybe<SocialsWhereIdInput>
  isActive?: InputMaybe<SocialsWhereBooleanInput>
  keyword?: InputMaybe<SocialsWhereStringInput>
  priority?: InputMaybe<SocialsWhereIntInput>
}

/** Socials where clause for a boolean field */
export type SocialsWhereBooleanInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** Socials where clause for a DateTime field */
export type SocialsWhereDateTimeInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Greater than */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Less than */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Less than or equal */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** Socials where clause for a float field */
export type SocialsWhereFloatInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['Float']['input']>
  /** Greater than */
  gt?: InputMaybe<Scalars['Float']['input']>
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Float']['input']>
  /** Less than */
  lt?: InputMaybe<Scalars['Float']['input']>
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Float']['input']>
}

/** Socials where clause for an id field */
export type SocialsWhereIdInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** In list */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Not equal */
  ne?: InputMaybe<Scalars['ID']['input']>
}

/** Socials where clause for an int field */
export type SocialsWhereIntInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Greater than */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** In list */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Less than */
  lt?: InputMaybe<Scalars['Int']['input']>
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Int']['input']>
  /** Not equal */
  ne?: InputMaybe<Scalars['Int']['input']>
}

/** Socials where clause for a string field */
export type SocialsWhereStringInput = {
  /** Equal */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['String']['input']>
  /** SQL ILIKE */
  ilike?: InputMaybe<Scalars['String']['input']>
  /** In list */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** SQL LIKE */
  like?: InputMaybe<Scalars['String']['input']>
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>
  /** Less than or equal */
  lte?: InputMaybe<Scalars['String']['input']>
  /** Not equal */
  ne?: InputMaybe<Scalars['String']['input']>
}

/** Socials where clause for a string array field */
export type SocialsWhereStringListInput = {
  /** Array contains */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Array overlap */
  overlap?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Oracle AI: Root subscription operations */
export type Subscription = {
  __typename?: 'Subscription'
  /**
   * Dark AI Guide chat stream. Federation-safe name while AI Service owns
   * oracleAgentChat. Authentication is enforced in the resolver. LLM turns still
   * require `agent_channels.default` enabled (seeded only in test).
   */
  aiGuideChat?: Maybe<AiGuideChatEvent>
  /** Stream a markdown interpretation for a stored dream */
  dreamInterpretation?: Maybe<DreamInterpretationEvent>
  /** Oracle AI: Send a message to the AI agent and stream the response */
  oracleAgentChat: OracleAgentChatSubscriptionPayload
  /** Oracle AI: Subscribe to real-time health status updates */
  oracleHealth: OracleHealth
  /** Oracle AI: Stream a personalized overview for Brooklyn's pre-ranked search results */
  oracleSearchOverviewStream: OracleSearchSubscriptionPayload
  /** Oracle AI: Stream personalized search results */
  oracleSearchStream: OracleSearchSubscriptionPayload
  /**
   * Stream a personalized overview for pre-ranked search results (the Brooklyn-native
   * successor to ai-service's oracleSearchOverviewStream). Authentication is enforced in
   * the resolver — an unauthenticated subscribe receives a failure payload, which the
   * client treats as non-fatal (tiles render without the overview).
   */
  searchOverviewStream?: Maybe<SearchOverviewStreamPayload>
  /** Subscribe to server status updates */
  serverStatusAuthentication?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusBrooklyn?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusTestarossa?: Maybe<ServerStatus>
  /** Subscribe to server status updates */
  serverStatusVideoAnalytics?: Maybe<ServerStatus>
  /**
   * Subscribe to text-to-speech audio streaming
   * (this is a test at this time and not for production use)
   */
  textToSpeech?: Maybe<TextToSpeechAudioChunk>
}

/** Oracle AI: Root subscription operations */
export type SubscriptionAiGuideChatArgs = {
  input: AiGuideChatInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionDreamInterpretationArgs = {
  input: DreamInterpretationInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleAgentChatArgs = {
  input: OracleAgentChatInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleHealthArgs = {
  intervalMilliseconds?: Scalars['Int']['input']
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleSearchOverviewStreamArgs = {
  input: SearchOverviewStreamInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionOracleSearchStreamArgs = {
  input: OracleSearchStreamInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionSearchOverviewStreamArgs = {
  input: SearchOverviewStreamSubscribeInput
}

/** Oracle AI: Root subscription operations */
export type SubscriptionTextToSpeechArgs = {
  encoding?: InputMaybe<TextToSpeechAudioEncoding>
  language?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
}

/** Billing Subscription Order Plan Action */
export enum SubscriptionOrderPlanAction {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
}

/** Provider Product Type */
export enum SubscriptionOrderType {
  Cancel = 'CANCEL',
  /** PLAN CHANGE */
  Comp = 'COMP',
  Pause = 'PAUSE',
  Signup = 'SIGNUP',
}

/** Billing Subscription price override reason */
export enum SubscriptionPriceOverrideReason {
  /** Legacy FMTV Price */
  CurrencyOverridePricing = 'CurrencyOverridePricing',
  LatinAmericanPricing = 'LatinAmericanPricing',
  LegacyOfferPricing = 'LegacyOfferPricing',
  PromoCodePricing = 'PromoCodePricing',
}

export enum SubscriptionPricingReplacementType {
  /** Future plan */
  FuturePlan = 'futurePlan',
  /** Next plan */
  NextPlan = 'nextPlan',
  /** None */
  None = 'none',
  /** Current plan */
  Plan = 'plan',
}

/** Billing Subscription Status */
export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Lapsed = 'Lapsed',
  Paused = 'Paused',
  Pending = 'Pending',
  Suspended = 'Suspended',
}

/** Oracle AI: A suggested feed to explore */
export type SuggestedFeed = {
  __typename?: 'SuggestedFeed'
  category: Scalars['String']['output']
  feedName: Scalars['String']['output']
  feedSlug: Scalars['String']['output']
  memberCount: Scalars['Int']['output']
  reason: Scalars['String']['output']
}

/** Sync Billing Provider Products Response */
export type SyncBillingProviderProductsResponse = {
  __typename?: 'SyncBillingProviderProductsResponse'
  /** The created or updated billingProviderProductPrices */
  billingProviderProductPrices?: Maybe<Array<Maybe<BillingProviderProductPricing>>>
  /** The updated billingProviderProducts */
  billingProviderProducts?: Maybe<Array<Maybe<BillingProviderProduct>>>
  /** The deleted billingProviderProductPrices */
  deletedBillingProviderProductPrices?: Maybe<Array<Maybe<DeletedBillingProviderProductPricing>>>
}

/** Tarot document payload for component rendering. */
export type TarotDocument = {
  __typename?: 'TarotDocument'
  acceptedQuestion: Scalars['String']['output']
  /** Resolve the back image URL for the referenced collection. Localized art follows the chat request language (en, es, fr, de). */
  backImageUrl?: Maybe<Scalars['String']['output']>
  collectionId?: Maybe<Scalars['ID']['output']>
  collectionKey?: Maybe<Scalars['String']['output']>
  objects: Array<TarotDocumentObject>
  pullId: Scalars['ID']['output']
  pulledAt?: Maybe<Scalars['String']['output']>
  readingId: Scalars['ID']['output']
  spread?: Maybe<Scalars['String']['output']>
}

/** Divination object reference in a tarot document. */
export type TarotDocumentObject = {
  __typename?: 'TarotDocumentObject'
  /** Localized display name for this divination object. Follows the chat request language (en, es, fr, de). */
  displayName?: Maybe<Scalars['String']['output']>
  /** Resolve the front image URL for this divination object. Localized art follows the chat request language (en, es, fr, de). */
  frontImageUrl?: Maybe<Scalars['String']['output']>
  objectId: Scalars['ID']['output']
  objectKey?: Maybe<Scalars['String']['output']>
  position: Scalars['String']['output']
  reversed?: Maybe<Scalars['Boolean']['output']>
}

/** Session-scoped tarot state for UI decisions. */
export type TarotFeatureState = {
  __typename?: 'TarotFeatureState'
  activeReadingHasPull: Scalars['Boolean']['output']
  activeReadingId?: Maybe<Scalars['ID']['output']>
  badQuestionOriginal?: Maybe<Scalars['String']['output']>
  badQuestionRephrasedQuestions: Array<Scalars['String']['output']>
  canPullCard: Scalars['Boolean']['output']
  canStartReading: Scalars['Boolean']['output']
  chatSessionId?: Maybe<Scalars['ID']['output']>
  hasActiveReading: Scalars['Boolean']['output']
  hasSession: Scalars['Boolean']['output']
  isInBadQuestionState: Scalars['Boolean']['output']
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
  lastUsedSessionId?: Maybe<Scalars['ID']['output']>
}

/** Tarot summary document payload for component rendering. */
export type TarotSummaryDocument = {
  __typename?: 'TarotSummaryDocument'
  analytics?: Maybe<Scalars['JSON']['output']>
  /** Resolve the back image URL for the referenced collection. Localized art follows the chat request language (en, es, fr, de). */
  backImageUrl?: Maybe<Scalars['String']['output']>
  collectionId?: Maybe<Scalars['ID']['output']>
  collectionKey?: Maybe<Scalars['String']['output']>
  objects: Array<TarotDocumentObject>
  pullCount?: Maybe<Scalars['Int']['output']>
  question?: Maybe<Scalars['String']['output']>
  readingId: Scalars['ID']['output']
  spread?: Maybe<Scalars['String']['output']>
}

/** TestarossaSubject row */
export type TestarossaSubject = {
  __typename?: 'TestarossaSubject'
  /** The campaign linked to this testarossa subject */
  campaignUuid?: Maybe<Scalars['ID']['output']>
  /** The campaign version */
  campaignVersion?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The testarossa subject status */
  status?: Maybe<TestarossaSubjectStatus>
  /** The user linked to this testarossa subject */
  testarossaUser?: Maybe<TestarossaUser>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this testarossa subject */
  userUuid?: Maybe<Scalars['ID']['output']>
  /** The primary key */
  uuid: Scalars['ID']['output']
  /** State related to a campaign testarossa subject */
  variables?: Maybe<Scalars['JSON']['output']>
  /** The variation linked to this testarossa subject */
  variationUuid?: Maybe<Scalars['ID']['output']>
}

/** A testarossa subject status */
export enum TestarossaSubjectStatus {
  Active = 'active',
  Excluded = 'excluded',
  Inactive = 'inactive',
}

/** Testarossa subjects list response */
export type TestarossaSubjectsListResponse = {
  __typename?: 'TestarossaSubjectsListResponse'
  /** A list of testarossaSubjects */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>
}

/** The where conditions to filter rows */
export type TestarossaSubjectsListWhereInput = {
  uuid?: InputMaybe<TestarossaSubjectsListWhereUuidInput>
}

/** The where clause for a testarossa subject uuid field */
export type TestarossaSubjectsListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Testarossa user row */
export type TestarossaUser = {
  __typename?: 'TestarossaUser'
  /** The testarossaUser access level */
  accessLevel?: Maybe<TestarossaUserAccessLevel>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The user uid */
  drupalUserId?: Maybe<Scalars['ID']['output']>
  /** The subjects linked to this testarossaUser */
  testarossaSubjects?: Maybe<Array<Maybe<TestarossaSubject>>>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  uuid: Scalars['ID']['output']
}

/** A testarossaUser access level */
export enum TestarossaUserAccessLevel {
  Manage = 'manage',
  None = 'none',
  Read = 'read',
  Write = 'write',
}

/** Testarossa user list response */
export type TestarossaUsersListResponse = {
  __typename?: 'TestarossaUsersListResponse'
  /** A list of testarossaUsers */
  testarossaUsers?: Maybe<Array<Maybe<TestarossaUser>>>
}

/** The where conditions to filter rows */
export type TestarossaUsersListWhereInput = {
  uuid?: InputMaybe<TestarossaUsersListWhereUuidInput>
}

/** The where clause for a testarossaUser uuid field */
export type TestarossaUsersListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Text-to-speech audio chunk for streaming */
export type TextToSpeechAudioChunk = {
  __typename?: 'TextToSpeechAudioChunk'
  /** Base64 encoded audio data */
  data: Scalars['String']['output']
  /** Audio encoding type */
  encoding: TextToSpeechAudioEncoding
  /** Error message if an error occurred during processing */
  error?: Maybe<Scalars['String']['output']>
  /** Whether this is the final chunk */
  isFinal: Scalars['Boolean']['output']
  /** Subscription ID for filtering (internal use) */
  subscriptionId: Scalars['String']['output']
}

/**
 * Text-to-speech audio encoding types
 * Constants defined in: lib/services/speech/encodings.js
 */
export enum TextToSpeechAudioEncoding {
  /** Linear PCM 16-bit encoding (AUDIO_ENCODING_LINEAR16) */
  Linear16 = 'LINEAR16',
  /** OGG Opus encoding (AUDIO_ENCODING_OGG_OPUS) */
  OggOpus = 'OGG_OPUS',
}

/** Transactions */
export type Transaction = {
  __typename?: 'Transaction'
  /** The ccLast4 of the transaction */
  ccLast4?: Maybe<Scalars['String']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The entitledAt of the transaction */
  entitledAt?: Maybe<Scalars['DateTime']['output']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: Maybe<Scalars['Int']['output']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: Maybe<Scalars['DateTime']['output']>
  /** The errorCode of the transaction */
  errorCode?: Maybe<Scalars['String']['output']>
  /** The eventUuid of the transaction */
  eventUuid?: Maybe<Scalars['ID']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The isDone of the transaction */
  isDone?: Maybe<Scalars['Boolean']['output']>
  /** The isEntitled flag of the transaction */
  isEntitled?: Maybe<Scalars['Boolean']['output']>
  /** The isValid flag of the transaction */
  isValid?: Maybe<Scalars['Boolean']['output']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: Maybe<Scalars['DateTime']['output']>
  /** The processedAt of the transaction */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** The providerData response of the transaction */
  providerData?: Maybe<Scalars['JSON']['output']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: Maybe<Scalars['String']['output']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: Maybe<Scalars['String']['output']>
  /** The providerName of the transaction */
  providerName?: Maybe<Scalars['String']['output']>
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: Maybe<Scalars['String']['output']>
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: Maybe<Scalars['String']['output']>
  /** The providerProductCode of the transaction */
  providerProductCode?: Maybe<Scalars['String']['output']>
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: Maybe<Scalars['String']['output']>
  /** The providerTxnDt of the transaction */
  providerTxnDt?: Maybe<Scalars['DateTime']['output']>
  /** The providerTxnId of the transaction */
  providerTxnId?: Maybe<Scalars['String']['output']>
  /** The providerTxnType of the transaction */
  providerTxnType?: Maybe<Scalars['String']['output']>
  /** The updateStatus of the transaction */
  updateStatus?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user UID of the transaction */
  userId?: Maybe<Scalars['ID']['output']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
  /** The validatedAt of the transaction */
  validatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TransactionCountResponse = {
  __typename?: 'TransactionCountResponse'
  /** The count of rows */
  count: Scalars['Int']['output']
}

/** TransactionCreateInput */
export type TransactionCreateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']['input']>
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']['input']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The eventUuid of the transaction */
  eventUuid: Scalars['String']['input']
  /** The isDone of the transaction */
  isDone: Scalars['Boolean']['input']
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']['input']>
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']['input']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerName of the transaction */
  providerName: Scalars['String']['input']
  /** The providerParentTxnId of the transaction */
  providerParentTxnId: Scalars['String']['input']
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerProductCode of the transaction */
  providerProductCode: Scalars['String']['input']
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnDt of the transaction */
  providerTxnDt: Scalars['DateTime']['input']
  /** The providerTxnId of the transaction */
  providerTxnId: Scalars['String']['input']
  /** The providerTxnType of the transaction */
  providerTxnType: Scalars['String']['input']
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']['input']>
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']['input']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

/** Transaction policy list response */
export type TransactionListResponse = {
  __typename?: 'TransactionListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user accounts */
  transactions?: Maybe<Array<Maybe<Transaction>>>
}

/** Transaction list where Date input type */
export type TransactionListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** Transaction ID or UUID type where input type */
export type TransactionListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Transaction where conditions to filter rows */
export type TransactionListWhereInput = {
  /** The eventUuid field where clause */
  eventUuid?: InputMaybe<TransactionListWhereIdInput>
  /** The id field where clause */
  id?: InputMaybe<TransactionListWhereIdInput>
  /** The providerName field where clause */
  providerName?: InputMaybe<TransactionListWhereStringInput>
  /** The providerTxnDt field where clause */
  providerTxnDt?: InputMaybe<TransactionListWhereDateInput>
  /** The providerTxnId field where clause */
  providerTxnId?: InputMaybe<TransactionListWhereStringInput>
}

/** Transaction where input type string */
export type TransactionListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** TransactionUpdateInput */
export type TransactionUpdateInput = {
  /** The ccLast4 of the transaction */
  ccLast4?: InputMaybe<Scalars['String']['input']>
  /** The entitledAt of the transaction */
  entitledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The entitlementContentSet of the transaction */
  entitlementContentSet?: InputMaybe<Scalars['Int']['input']>
  /** The entitlementEnd of the transaction */
  entitlementEnd?: InputMaybe<Scalars['DateTime']['input']>
  /** The errorCode of the transaction */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** The eventUuid of the transaction */
  eventUuid?: InputMaybe<Scalars['String']['input']>
  /** The primary identifier for this record */
  id: Scalars['ID']['input']
  /** The isDone of the transaction */
  isDone?: InputMaybe<Scalars['Boolean']['input']>
  /** The isEntitled flag of the transaction */
  isEntitled?: InputMaybe<Scalars['Boolean']['input']>
  /** The isValid flag of the transaction */
  isValid?: InputMaybe<Scalars['Boolean']['input']>
  /** The lastPolledAt of the transaction */
  lastPolledAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The processedAt of the transaction */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerData response of the transaction */
  providerData?: InputMaybe<Scalars['JSON']['input']>
  /** The providerGatewayTxnId of the transaction */
  providerGatewayTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerInvoiceNumber of the transaction */
  providerInvoiceNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerName of the transaction */
  providerName?: InputMaybe<Scalars['String']['input']>
  /** The providerParentTxnId of the transaction */
  providerParentTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerPaymentNumber of the transaction */
  providerPaymentNumber?: InputMaybe<Scalars['String']['input']>
  /** The providerProductCode of the transaction */
  providerProductCode?: InputMaybe<Scalars['String']['input']>
  /** The providerRecurringPaymentId of the transaction */
  providerRecurringPaymentId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnDt of the transaction */
  providerTxnDt?: InputMaybe<Scalars['DateTime']['input']>
  /** The providerTxnId of the transaction */
  providerTxnId?: InputMaybe<Scalars['String']['input']>
  /** The providerTxnType of the transaction */
  providerTxnType?: InputMaybe<Scalars['String']['input']>
  /** The updateStatus of the transaction */
  updateStatus?: InputMaybe<Scalars['Int']['input']>
  /** The user UID of the transaction */
  userId?: InputMaybe<Scalars['ID']['input']>
  /** The userInfoUuid of the transaction */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
  /** The validatedAt of the transaction */
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type TranscriptChunkLookupProject = {
  __typename?: 'TranscriptChunkLookupProject'
  clips: Array<TranscriptChunkLookupProjectClip>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isOwner: Scalars['Boolean']['output']
  lastSearchContext?: Maybe<TranscriptChunkLookupProjectSearchContext>
  name: Scalars['String']['output']
  rawExportExpiresAt?: Maybe<Scalars['DateTime']['output']>
  rawExportReadyAt?: Maybe<Scalars['DateTime']['output']>
  rawExportRequestedAt?: Maybe<Scalars['DateTime']['output']>
  rawExportStatus?: Maybe<RawExportStatus>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TranscriptChunkLookupProjectClip = {
  __typename?: 'TranscriptChunkLookupProjectClip'
  addedAt: Scalars['String']['output']
  contentPath?: Maybe<Scalars['String']['output']>
  contentRowId: Scalars['ID']['output']
  contentTitle?: Maybe<Scalars['String']['output']>
  endTimecode: Scalars['String']['output']
  featureMediaId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  isLicensed?: Maybe<Scalars['Boolean']['output']>
  lemonadeContentId?: Maybe<Scalars['Int']['output']>
  matchedText?: Maybe<Scalars['String']['output']>
  originalEndTimecode: Scalars['String']['output']
  originalStartTimecode: Scalars['String']['output']
  searchLanguage?: Maybe<TranscriptChunkSearchLanguage>
  seriesTitle?: Maybe<Scalars['String']['output']>
  startTimecode: Scalars['String']['output']
  transcriptText?: Maybe<Scalars['String']['output']>
}

export type TranscriptChunkLookupProjectClipInput = {
  addedAt?: InputMaybe<Scalars['String']['input']>
  contentPath?: InputMaybe<Scalars['String']['input']>
  contentRowId: Scalars['ID']['input']
  contentTitle?: InputMaybe<Scalars['String']['input']>
  endTimecode: Scalars['String']['input']
  featureMediaId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  isLicensed?: InputMaybe<Scalars['Boolean']['input']>
  lemonadeContentId?: InputMaybe<Scalars['Int']['input']>
  matchedText?: InputMaybe<Scalars['String']['input']>
  originalEndTimecode?: InputMaybe<Scalars['String']['input']>
  originalStartTimecode?: InputMaybe<Scalars['String']['input']>
  searchLanguage?: InputMaybe<TranscriptChunkSearchLanguage>
  seriesTitle?: InputMaybe<Scalars['String']['input']>
  startTimecode: Scalars['String']['input']
  transcriptText?: InputMaybe<Scalars['String']['input']>
}

export type TranscriptChunkLookupProjectCreateInput = {
  clips?: InputMaybe<Array<TranscriptChunkLookupProjectClipInput>>
  lastSearchContext?: InputMaybe<TranscriptChunkLookupProjectSearchContextInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type TranscriptChunkLookupProjectSearchContext = {
  __typename?: 'TranscriptChunkLookupProjectSearchContext'
  language?: Maybe<Scalars['String']['output']>
  prompt?: Maybe<Scalars['String']['output']>
}

export type TranscriptChunkLookupProjectSearchContextInput = {
  language?: InputMaybe<Scalars['String']['input']>
  prompt?: InputMaybe<Scalars['String']['input']>
}

export type TranscriptChunkLookupProjectUpdateInput = {
  clips?: InputMaybe<Array<TranscriptChunkLookupProjectClipInput>>
  lastSearchContext?: InputMaybe<TranscriptChunkLookupProjectSearchContextInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum TranscriptChunkRawAvailability {
  Available = 'AVAILABLE',
  GlacierNeedsRestore = 'GLACIER_NEEDS_RESTORE',
  GlacierRestoring = 'GLACIER_RESTORING',
  NotFound = 'NOT_FOUND',
  UnsupportedProvider = 'UNSUPPORTED_PROVIDER',
}

export type TranscriptChunkRawExportBundle = {
  __typename?: 'TranscriptChunkRawExportBundle'
  presignExpiresAt: Scalars['DateTime']['output']
  project: TranscriptChunkLookupProject
  sources: Array<TranscriptChunkRawExportSource>
}

export type TranscriptChunkRawExportSource = {
  __typename?: 'TranscriptChunkRawExportSource'
  availability: TranscriptChunkRawAvailability
  contentId?: Maybe<Scalars['String']['output']>
  downloadUrl?: Maybe<Scalars['String']['output']>
  downloadUrlExpiresAt?: Maybe<Scalars['DateTime']['output']>
  featureMediaId: Scalars['ID']['output']
  fileName?: Maybe<Scalars['String']['output']>
  s3Uri?: Maybe<Scalars['String']['output']>
}

export type TranscriptChunkSamplerClip = {
  __typename?: 'TranscriptChunkSamplerClip'
  clipPlaybackUrl: Scalars['String']['output']
  contentRowId: Scalars['ID']['output']
  endSec: Scalars['Float']['output']
  excerpt?: Maybe<Scalars['String']['output']>
  startSec: Scalars['Float']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type TranscriptChunkSamplerSearchInput = {
  language?: TranscriptChunkSearchLanguage
  seedQuestionId: Scalars['ID']['input']
}

export type TranscriptChunkSamplerSearchResult = {
  __typename?: 'TranscriptChunkSamplerSearchResult'
  clips: Array<TranscriptChunkSamplerClip>
  language: TranscriptChunkSearchLanguage
  resultId: Scalars['ID']['output']
  seedQuestionId: Scalars['ID']['output']
  summary?: Maybe<Scalars['String']['output']>
  teasers: Array<TranscriptChunkSamplerTeaser>
}

export type TranscriptChunkSamplerSeed = {
  __typename?: 'TranscriptChunkSamplerSeed'
  id: Scalars['ID']['output']
  question: Scalars['String']['output']
}

export type TranscriptChunkSamplerTeaser = {
  __typename?: 'TranscriptChunkSamplerTeaser'
  contentRowId: Scalars['ID']['output']
  excerpt?: Maybe<Scalars['String']['output']>
  keyartUrl?: Maybe<Scalars['String']['output']>
  playable: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
}

export enum TranscriptChunkSearchCurationMode {
  BestMatches = 'BEST_MATCHES',
  DeepDive = 'DEEP_DIVE',
  LearningPath = 'LEARNING_PATH',
  SurveyJourney = 'SURVEY_JOURNEY',
  VariedFocus = 'VARIED_FOCUS',
  WideLens = 'WIDE_LENS',
}

export type TranscriptChunkSearchFilter = {
  /** Restrict to content in a content center (the center tag's numeric content_id). Matched via content_reference_types.type = 'centers'. */
  centerContentId?: InputMaybe<Scalars['Int']['input']>
  /** Restrict to videos whose catalog content_id is in this list. */
  contentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Person appearing in content (content_id of a person row). Matched via content_references (host, guest, teacher, instructor). */
  personContentId?: InputMaybe<Scalars['Int']['input']>
  /** Restrict to content published within a rolling window. Omit or use ANY for no date restriction. */
  publishedAge?: InputMaybe<TranscriptChunkSearchPublishedAge>
  /** Used with seriesContentId: restrict to a specific season number. */
  seasonNumber?: InputMaybe<Scalars['Int']['input']>
  /** Restrict to episodes in a series (the series' numeric content_id). Matched via content_reference_types.type = 'series'. */
  seriesContentId?: InputMaybe<Scalars['Int']['input']>
}

export type TranscriptChunkSearchFilterDisplaySnapshot = {
  __typename?: 'TranscriptChunkSearchFilterDisplaySnapshot'
  bundle?: Maybe<Scalars['String']['output']>
  contentIds?: Maybe<Array<Scalars['Int']['output']>>
  contentType?: Maybe<Scalars['String']['output']>
  scope: Scalars['String']['output']
  seasonNumber?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
  titles?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TranscriptChunkSearchFilterSnapshot = {
  __typename?: 'TranscriptChunkSearchFilterSnapshot'
  centerContentId?: Maybe<Scalars['Int']['output']>
  contentIds?: Maybe<Array<Scalars['Int']['output']>>
  personContentId?: Maybe<Scalars['Int']['output']>
  publishedAge?: Maybe<TranscriptChunkSearchPublishedAge>
  seasonNumber?: Maybe<Scalars['Int']['output']>
  seriesContentId?: Maybe<Scalars['Int']['output']>
}

export type TranscriptChunkSearchInput = {
  curationMode?: TranscriptChunkSearchCurationMode
  filter?: InputMaybe<TranscriptChunkSearchFilter>
  language: TranscriptChunkSearchLanguage
  maxResults?: Scalars['Int']['input']
  /** When true, return at most one span per parent video, backfilling from lower-ranked candidates to reach maxResults. */
  oneSpanPerVideo?: InputMaybe<Scalars['Boolean']['input']>
  prompt: Scalars['String']['input']
  purpose?: TranscriptChunkSearchPurpose
}

export enum TranscriptChunkSearchLanguage {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
}

export enum TranscriptChunkSearchPublishedAge {
  Any = 'ANY',
  Past_2Years = 'PAST_2_YEARS',
  Past_3Months = 'PAST_3_MONTHS',
  Past_3Years = 'PAST_3_YEARS',
  Past_5Years = 'PAST_5_YEARS',
  Past_6Months = 'PAST_6_MONTHS',
  PastMonth = 'PAST_MONTH',
  PastYear = 'PAST_YEAR',
}

export enum TranscriptChunkSearchPurpose {
  /** Anonymous WordPress sampler: seed chips only, 5 teasers / 2 clip-window plays. */
  AnonSampler = 'ANON_SAMPLER',
  /** Internal admin lookup: forced BEST_MATCHES, max 100 spans. */
  ChunkLookup = 'CHUNK_LOOKUP',
  /** Member-facing highlights: curation presets, max 20 spans. */
  Member = 'MEMBER',
}

export type TranscriptChunkSearchResult = {
  __typename?: 'TranscriptChunkSearchResult'
  language: TranscriptChunkSearchLanguage
  resultId: Scalars['ID']['output']
  spans: Array<TranscriptChunkSpan>
  /** LLM-generated summary (2–4 sentences). Null unless the client selects this field. */
  summary?: Maybe<Scalars['String']['output']>
}

export type TranscriptChunkSearchSnapshot = {
  __typename?: 'TranscriptChunkSearchSnapshot'
  curationMode: TranscriptChunkSearchCurationMode
  filter?: Maybe<TranscriptChunkSearchFilterSnapshot>
  filterDisplay?: Maybe<TranscriptChunkSearchFilterDisplaySnapshot>
  language: TranscriptChunkSearchLanguage
  maxResults: Scalars['Int']['output']
  oneSpanPerVideo?: Maybe<Scalars['Boolean']['output']>
  prompt: Scalars['String']['output']
}

export type TranscriptChunkSession = {
  __typename?: 'TranscriptChunkSession'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isOwner: Scalars['Boolean']['output']
  isPublic: Scalars['Boolean']['output']
  searchInput: TranscriptChunkSearchSnapshot
  spans: Array<TranscriptChunkSpan>
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TranscriptChunkSessionCreateInput = {
  filterDisplay?: InputMaybe<TranscriptChunkSessionFilterDisplayInput>
  searchInput: TranscriptChunkSearchInput
  spans: Array<TranscriptChunkSessionSpanInput>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TranscriptChunkSessionFilterDisplayInput = {
  bundle?: InputMaybe<Scalars['String']['input']>
  contentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  contentType?: InputMaybe<Scalars['String']['input']>
  scope: Scalars['String']['input']
  seasonNumber?: InputMaybe<Scalars['Int']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type TranscriptChunkSessionListItem = {
  __typename?: 'TranscriptChunkSessionListItem'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isPublic: Scalars['Boolean']['output']
  searchInput: TranscriptChunkSearchSnapshot
  spanCount: Scalars['Int']['output']
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TranscriptChunkSessionListResult = {
  __typename?: 'TranscriptChunkSessionListResult'
  sessions: Array<TranscriptChunkSessionListItem>
  totalCount: Scalars['Int']['output']
}

export type TranscriptChunkSessionSpanInput = {
  contentRowId: Scalars['ID']['input']
  endTimecode: Scalars['String']['input']
  featureMediaId: Scalars['ID']['input']
  matchedText?: InputMaybe<Scalars['String']['input']>
  startTimecode: Scalars['String']['input']
  transcriptText?: InputMaybe<Scalars['String']['input']>
}

export type TranscriptChunkSpan = {
  __typename?: 'TranscriptChunkSpan'
  content?: Maybe<Content>
  /** Content primary key (Content.id). Parent for federation field content { ... }. */
  contentRowId: Scalars['ID']['output']
  endTimecode: Scalars['String']['output']
  featureMedia?: Maybe<Media>
  featureMediaId: Scalars['String']['output']
  matchedText?: Maybe<Scalars['String']['output']>
  /** True when the current viewer may play this clip (search results are pre-filtered; sessions re-check viewer entitlements). */
  playbackAllowed: Scalars['Boolean']['output']
  relevanceScore?: Maybe<Scalars['Float']['output']>
  startTimecode: Scalars['String']['output']
  transcriptText?: Maybe<Scalars['String']['output']>
}

/** Translation formality options */
export enum TranslationFormality {
  /** Default formality */
  Default = 'default',
  /** Less formal */
  Less = 'less',
  /** More formal */
  More = 'more',
  /** Prefer less formal but not enforced strictly */
  PreferLess = 'prefer_less',
  /** Prefer more formal but not enforced strictly */
  PreferMore = 'prefer_more',
}

/** Translation model options */
export enum TranslationModel {
  /** Optimized for fastest response time */
  LatencyOptimized = 'latency_optimized',
  /** Prefer quality model but not enforced strictly */
  PreferQualityOptimized = 'prefer_quality_optimized',
  /** Optimized for quality */
  QualityOptimized = 'quality_optimized',
}

export enum User_Info_Status {
  /** The user is allowed accss */
  Active = 'active',
  /** The user is denied access */
  Blocked = 'blocked',
}

/** Update billing discount input */
export type UpdateBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount code */
  code?: InputMaybe<Scalars['String']['input']>
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>
  /** Human-readable description for admins */
  description?: InputMaybe<Scalars['String']['input']>
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing discount id */
  id: Scalars['ID']['input']
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>
  /** Lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The discount lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>
  /** When set, discount applies only to plans whose billing product belongs to this platform */
  platform?: InputMaybe<ProductPlatform>
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The discount tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The discount tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>
}

/** Update input for Billing Plan Grid */
export type UpdateBillingPlanGridInput = {
  /** The billing plan grid billing product id in */
  billingProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing product id not in */
  billingProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id in */
  billingProviderProductIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid billing provider product id not in */
  billingProviderProductIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** The billing plan grid country in */
  countryIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid country not in */
  countryNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency in */
  currencyIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid currency not in */
  currencyNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether this plan grid is the default for the given page */
  defaultPageGrid?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing plan grid device type in */
  deviceTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid device type not in */
  deviceTypeNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Whether the billing plan grid is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing plan grid end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The best value plan in the plan grid for existing members */
  existingMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for existing members */
  existingMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']['input']>
  /** The second plan in the plan grid for existing members */
  existingMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for existing members */
  existingMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for existing members */
  existingMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid id */
  id: Scalars['ID']['input']
  /** The billing plan grid language in */
  languageIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid language not in */
  languageNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing plan grid lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The billing plan grid lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The best value plan in the plan grid for new members */
  newMemberBestValueBillingProviderProductId?: InputMaybe<Scalars['Int']['input']>
  /** The first plan in the plan grid for new members */
  newMemberBillingProviderProductId1?: InputMaybe<Scalars['Int']['input']>
  /** The second plan in the plan grid for new members */
  newMemberBillingProviderProductId2?: InputMaybe<Scalars['Int']['input']>
  /** The third plan in the plan grid for new members */
  newMemberBillingProviderProductId3?: InputMaybe<Scalars['Int']['input']>
  /** The fourth plan in the plan grid for new members */
  newMemberBillingProviderProductId4?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid page */
  page?: InputMaybe<Scalars['String']['input']>
  /** The billing plan grid priority */
  priority?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The billing plan grid tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The billing plan grid tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing plan grid variant name */
  variantName?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating an eligibility rule */
export type UpdateBillingProviderProductEligibilityInput = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  countryOperator?: InputMaybe<PlanEligibilityCountryOperator>
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['ID']['input']
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  maxPurchases?: InputMaybe<Scalars['Int']['input']>
  monthsSinceLastPurchase?: InputMaybe<Scalars['Int']['input']>
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  planSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ruleType?: InputMaybe<PlanEligibilityRuleType>
  scope?: InputMaybe<PlanEligibilityScope>
  skuCheckType?: InputMaybe<SkuCheckType>
  skuOperator?: InputMaybe<SkuOperator>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  tenure?: InputMaybe<Scalars['Int']['input']>
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
}

/** Update all billing discounts in a bulk create batch */
export type UpdateBulkBillingDiscountInput = {
  /** The billing discount allowed for plan change */
  allowedForPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount amount discount */
  amountDiscount?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount available count */
  availableCount?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount billing cycles */
  billingCycles?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount countries */
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount countries operator */
  countriesOperator?: InputMaybe<InNotInOperator>
  /** The billing discount currencies */
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount currencies operator */
  currenciesOperator?: InputMaybe<InNotInOperator>
  /** Human-readable description for admins (applied to the bulk batch and each discount) */
  description?: InputMaybe<Scalars['String']['input']>
  /** The billing discount ecommerce SKUs */
  ecommerceSkus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount ecommerce SKUs operator */
  ecommerceSkusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** The billing discount end date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The bulk discount batch id */
  id: Scalars['ID']['input']
  /** The billing discount languages */
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount languages operator */
  languagesOperator?: InputMaybe<InNotInOperator>
  /** Lifetime value threshold in USD */
  lifetimeValue?: InputMaybe<Scalars['Float']['input']>
  /** The discount lifetime value operator */
  lifetimeValueOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** The billing discount minimum price */
  minimumPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount minimum trial segment price */
  minimumTrialSegmentPrice?: InputMaybe<Scalars['JSON']['input']>
  /** The billing discount percentage discount */
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>
  /** The billing discount plan categories */
  planCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount plan categories operator */
  planCategoriesOperator?: InputMaybe<InNotInOperator>
  /** When set, discount applies only to plans whose billing product belongs to this platform */
  platform?: InputMaybe<ProductPlatform>
  /** The billing discount redemptions per user */
  redemptionsPerUser?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount redemptions per user months */
  redemptionsPerUserMonths?: InputMaybe<Scalars['Int']['input']>
  /** The billing discount SKUs */
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The billing discount SKUs operator */
  skusOperator?: InputMaybe<InNotInOperator>
  /** The billing discount start date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The discount tenure threshold in days */
  tenure?: InputMaybe<Scalars['Int']['input']>
  /** The discount tenure operator */
  tenureOperator?: InputMaybe<PlanEligibilityNumericOperator>
  /** When set, only these user_info.uid values may redeem the discount */
  uids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>
}

/** Input for updating an existing event */
export type UpdateCommunityEventInput = {
  /** Maximum attendees */
  capacity?: InputMaybe<Scalars['Int']['input']>
  /** Event description */
  content?: InputMaybe<Scalars['String']['input']>
  /** Event end date and time */
  endTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Event locations (replaces existing) */
  locations?: InputMaybe<Array<CommunityEventLocationInput>>
  /** Reminder settings */
  reminderSettings?: InputMaybe<CommunityEventReminderSettingsInput>
  /** Event start date and time */
  startTime?: InputMaybe<Scalars['DateTime']['input']>
  /** Event status */
  status?: InputMaybe<CommunityEventStatus>
  /** IANA timezone */
  timeZone?: InputMaybe<Scalars['String']['input']>
  /** Event title */
  title?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a custom emoji */
export type UpdateCustomEmojiInput = {
  /** Whether the emoji should be active */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** The ID of the emoji to update */
  id: Scalars['ID']['input']
  /** The new display name */
  name?: InputMaybe<Scalars['String']['input']>
}

/** Fields to change on an action config. Omitted booleans stay as they are. */
export type UpdateRateLimitActionConfigInput = {
  /** Action this config applies to. Must stay unique. */
  action?: InputMaybe<Scalars['String']['input']>
  /** Deny when the Fingerprint event bot field is bad */
  badBot?: InputMaybe<Scalars['Boolean']['input']>
  /** Deny when the Fingerprint event tampering field is true */
  browserTampering?: InputMaybe<Scalars['Boolean']['input']>
  /** Store checks for this action without denying them */
  bypass?: InputMaybe<Scalars['Boolean']['input']>
  /** Keys that may consume a token once each. Omitted leaves the list. Empty allows the default key only. */
  consumptionKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Deny when the Fingerprint event ip_blocklist email_spam or attack_source is true */
  ipBlocklist?: InputMaybe<Scalars['Boolean']['input']>
  /** When true, checks for this action must pass tokenConsumption. Omitted leaves it unchanged. */
  tokenConsumption?: InputMaybe<Scalars['Boolean']['input']>
  /** Action config row uuid */
  uuid: Scalars['ID']['input']
}

/** Fields to change on an allow or block row */
export type UpdateRateLimitOverrideInput = {
  /** Action this row applies to. Null matches every action. */
  action?: InputMaybe<Scalars['String']['input']>
  /** When true, a block row matches clientIp */
  blockIp?: InputMaybe<Scalars['Boolean']['input']>
  /** Client IP this row matches */
  clientIp?: InputMaybe<Scalars['String']['input']>
  /** Optional note for why this row exists. Null clears it. */
  description?: InputMaybe<Scalars['String']['input']>
  /** False rows are ignored */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the override ends. Null clears it. startAt is required when this is set. */
  endAt?: InputMaybe<Scalars['DateTime']['input']>
  /** FingerprintJS visitor id this row matches */
  fingerprintId?: InputMaybe<Scalars['String']['input']>
  /** When the override starts. Null clears it. endAt is required when this is set. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>
  /** User id this row matches */
  uid?: InputMaybe<Scalars['Int']['input']>
  /** User-Agent this block matches. Null clears it. Only valid on a block. */
  userAgent?: InputMaybe<Scalars['String']['input']>
  /** List row uuid */
  uuid: Scalars['ID']['input']
}

/** Fields to change on a rate-limit rule */
export type UpdateRateLimitRuleInput = {
  /** Action this rule applies to */
  action?: InputMaybe<Scalars['String']['input']>
  /** count or distinct. */
  aggregate?: InputMaybe<RateLimitAggregate>
  /** When true, the automatic block matches every action */
  blockAllActionsOnFailure?: InputMaybe<Scalars['Boolean']['input']>
  /** Minutes a failed check stays blocked. Null clears it. */
  blockMinutesOnFailure?: InputMaybe<Scalars['Int']['input']>
  /** Action whose history this rule counts. Null counts this rule's action. */
  countAction?: InputMaybe<Scalars['String']['input']>
  /** request counts checks. action counts completed work. both counts both. */
  countSource?: InputMaybe<RateLimitCountSource>
  /** uid, ip, or fingerprint. Null applies the limit to each present identity. */
  dimension?: InputMaybe<RateLimitDimension>
  /** ip or uid. Null clears it. Required when aggregate is distinct. */
  distinctDimension?: InputMaybe<RateLimitDistinctDimension>
  /** False rows are ignored */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** dimension or fingerprint_or_uid. */
  historyMatch?: InputMaybe<RateLimitHistoryMatch>
  /** Maximum count inside the window, including the current attempt */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** total, success, or failure */
  outcome?: InputMaybe<RateLimitOutcome>
  /** When true, a failed check writes a block with no start and no end. Cannot be combined with blockMinutesOnFailure. */
  permanentBlockOnFailure?: InputMaybe<Scalars['Boolean']['input']>
  /** Minutes, Hours, or Days */
  timeUnit?: InputMaybe<RateLimitTimeUnit>
  /** Window length. Must be greater than 0. */
  timeValue?: InputMaybe<Scalars['Int']['input']>
  /** Rule uuid */
  uuid: Scalars['ID']['input']
}

/** Input for uploading a feed image */
export type UploadFeedImageInput = {
  /** The feed ID (UUID) */
  feedId: Scalars['ID']['input']
  /** Base64-encoded image file (or data URL) */
  fileData: Scalars['String']['input']
  /** The image type (profile or banner) */
  imageType: FeedImageType
  /** MIME type of the image (e.g., 'image/png', 'image/jpeg') */
  mimeType: Scalars['String']['input']
}

/** User accounts */
export type UserAccount = {
  __typename?: 'UserAccount'
  /** The account owner uid */
  accountOwnerUid?: Maybe<Scalars['ID']['output']>
  /** The account owner uuid */
  accountOwnerUuid?: Maybe<Scalars['ID']['output']>
  /** The current authentication group id all ids less than this value are invalid */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User info associated with this account as the account owner */
  userInfoByAccountOwner?: Maybe<UserInfo>
}

/** User account policy list response */
export type UserAccountListResponse = {
  __typename?: 'UserAccountListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user accounts */
  userAccounts?: Maybe<Array<Maybe<UserAccount>>>
}

/** User account id type where input type */
export type UserAccountListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User account policy where conditions to filter rows */
export type UserAccountListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserAccountListWhereIdInput>
}

/** User Audit Log */
export type UserAuditLog = {
  __typename?: 'UserAuditLog'
  /** The audit category of user audit */
  auditCategory?: Maybe<AuditCategoryType>
  /** The billing provider Id of user audit */
  billingProviderId?: Maybe<Scalars['ID']['output']>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** When effective date of user audit */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>
  /** The external account Id of user audit */
  externalAccountId?: Maybe<Scalars['String']['output']>
  /** The audit field name of user audit */
  fieldName?: Maybe<AuditFieldName>
  /** The id of the user audit */
  id?: Maybe<Scalars['ID']['output']>
  /** New data value of user audit */
  newValue?: Maybe<Scalars['String']['output']>
  /** The performed by user uuid of user audit */
  performedByUuid?: Maybe<Scalars['ID']['output']>
  /** Previous data value of user audit */
  previousValue?: Maybe<Scalars['String']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info uuid of user audit */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** Create input for User Audit Log */
export type UserAuditLogCreateInput = {
  /** The auditCategory of the user audit log */
  auditCategory: AuditCategoryType
  /** The billingProviderId of the user audit log */
  billingProviderId: Scalars['ID']['input']
  /** The effectiveDate of the user audit log */
  effectiveDate: Scalars['DateTime']['input']
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']['input']>
  /** The fieldName of the user audit log */
  fieldName: AuditFieldName
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']['input']>
  /** The performedByUuid of the user audit log */
  performedByUuid: Scalars['ID']['input']
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']['input']>
  /** The userInfoUuid of the user audit log */
  userInfoUuid: Scalars['ID']['input']
}

/** User Audit Log list response */
export type UserAuditLogListResponse = {
  __typename?: 'UserAuditLogListResponse'
  userAuditLogs?: Maybe<Array<Maybe<UserAuditLog>>>
}

/** User Audit Log boolean where input type */
export type UserAuditLogListWhereBooleanInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** User Audit Log list where Date input type */
export type UserAuditLogListWhereDateInput = {
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['Date']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['Date']['input']>
}

/** User Audit Log where type input field Name */
export type UserAuditLogListWhereFieldNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditFieldName>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditFieldName>>>
}

/** User Audit Log list id where input type */
export type UserAuditLogListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User Audit Log list where input type */
export type UserAuditLogListWhereInput = {
  /** The auditCategory field where clause */
  auditCategory?: InputMaybe<UserAuditLogListWhereTypeInput>
  /** The userAuditLog billingProviderId field where clause */
  billingProviderId?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog effectiveDate field where clause */
  effectiveDate?: InputMaybe<UserAuditLogListWhereDateInput>
  /** The fieldName field where clause */
  fieldName?: InputMaybe<UserAuditLogListWhereFieldNameInput>
  /** The userAuditLog id field where clause */
  id?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog performedByUuid field where clause */
  performedByUuid?: InputMaybe<UserAuditLogListWhereIdInput>
  /** The userAuditLog userInfoUuid field where clause */
  userInfoUuid?: InputMaybe<UserAuditLogListWhereIdInput>
}

/** User Audit Log string where input type */
export type UserAuditLogListWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** User Audit Log where type input type */
export type UserAuditLogListWhereTypeInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<AuditCategoryType>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<AuditCategoryType>>>
}

/** Update input for User Audit Log */
export type UserAuditLogUpdateInput = {
  /** The auditCategory of the user audit log */
  auditCategory?: InputMaybe<AuditCategoryType>
  /** The billingProviderId of the user audit log */
  billingProviderId?: InputMaybe<Scalars['ID']['input']>
  /** The effectiveDate of the user audit log */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The externalAccountId of the user audit log */
  externalAccountId?: InputMaybe<Scalars['String']['input']>
  /** The fieldName of the user audit log */
  fieldName?: InputMaybe<AuditFieldName>
  /** The identifier for the user audit log */
  id: Scalars['ID']['input']
  /** The newValue of the user audit log */
  newValue?: InputMaybe<Scalars['String']['input']>
  /** The performedByUuid of the user audit log */
  performedByUuid?: InputMaybe<Scalars['ID']['input']>
  /** The previousValue of the user audit log */
  previousValue?: InputMaybe<Scalars['String']['input']>
  /** The userInfoUuid of the user audit log */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** User specific billing plan grid */
export type UserBillingPlanGrid = {
  __typename?: 'UserBillingPlanGrid'
  /** The matching user specific billing plan grid */
  billingPlanGrid?: Maybe<BillingPlanGrid>
  /** The device type requested */
  deviceType?: Maybe<PlanGridDeviceType>
}

/** User specific billing plan grid list response */
export type UserBillingPlanGridListResponse = {
  __typename?: 'UserBillingPlanGridListResponse'
  userBillingPlanGrids?: Maybe<Array<Maybe<UserBillingPlanGrid>>>
}

/** User Billing Plan Grid list where input type */
export type UserBillingPlanGridListWhereInput = {
  /** The filter for the billing plan grid device type */
  deviceType: BillingPlanGridListWhereDeviceTypeInput
  /** The filter for the billing plan grid language */
  language: ProviderProductLanguage
  /** The filter for the billing plan grid page */
  page: Scalars['String']['input']
}

/** User Ecommerce Sku Mapping Bonus Eligibilities list response */
export type UserEcommerceSkuMappingBonusEligibilitiesListResponse = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibilitiesListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of ecommerce sku mappings */
  userEcommerceSkuMappingBonusEligibilities?: Maybe<
    Array<Maybe<UserEcommerceSkuMappingBonusEligibility>>
  >
}

/** User Ecommerce Sku Mapping where input type */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User User Ecommerce Sku Mapping Bonus Eligibilities where conditions to filter rows */
export type UserEcommerceSkuMappingBonusEligibilitiesWhereInput = {
  /** The UserEcommerceSkuMappingBonusEligibilities id field where clause */
  id?: InputMaybe<UserEcommerceSkuMappingBonusEligibilitiesWhereIdInput>
}

/** User Ecommerce Sku Mapping Bonus Eligibility */
export type UserEcommerceSkuMappingBonusEligibility = {
  __typename?: 'UserEcommerceSkuMappingBonusEligibility'
  /** The Billing Provider Product Text for the item */
  billingProviderProductTextLocalized?: Maybe<Scalars['String']['output']>
  /** The Billing Provider Product Text Language for the item */
  billingProviderProductTextLocalizedLanguage?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The campaign id */
  ecommerceSkuMappingBonusEligibilitiesId?: Maybe<Scalars['Int']['output']>
  /** The campaigns */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
  /** The unique id for the given record */
  id?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user uuid for the given record */
  userUuid?: Maybe<Scalars['String']['output']>
}

/**
 * User entitlement represents access rights to a content set for a user or account.
 *
 * Entitlements define what content a user can access and when. They are time-based with start and end dates.
 * An entitlement is considered "active" when the current time is between the start and end dates.
 *
 * Entitlement Types:
 * - User-specific entitlement: userInfoUuid is set, userAccountUuid is null. Applies only to that specific user.
 * - Account-level entitlement: Both userInfoUuid and userAccountUuid are set. Applies to all users in that account.
 *   Account-level entitlements are typically owned by the account owner but accessible by all account members.
 *
 * Entitlements are typically created or updated when billing events are processed (payments, renewals, etc.).
 * The eventId field links back to the billing event that created this entitlement.
 *
 * The reason field describes why the entitlement was created/changed (e.g., "payment", "trial", "gift", etc.).
 * The effectiveChangeDate tracks when the entitlement was last modified.
 *
 * State Information:
 * - Active: current time >= start AND (end is null OR current time <= end)
 * - Expired: current time > end (if end is set)
 * - Future: current time < start
 */
export type UserEntitlement = {
  __typename?: 'UserEntitlement'
  /** Content set for this entitlement. Defines what content this entitlement grants access to. */
  contentSet?: Maybe<ContentSet>
  /**
   * The content set ID that this entitlement grants access to. Content sets define groups of content
   * (videos, courses, etc.) that users can access.
   */
  contentSetId?: Maybe<Scalars['Int']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * Ecommerce SKU (Stock Keeping Unit) identifier for the product that granted this entitlement.
   * Used to link entitlements to specific products in ecommerce systems.
   */
  ecommerceSku?: Maybe<Scalars['String']['output']>
  /**
   * An Ecommerce SKU Mapping associated with this entitlement. Links the ecommerce SKU
   * to product information and pricing details.
   */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
  /**
   * Ecommerce SKU Provider name (e.g., "google", "apple", "paypal"). Identifies which
   * ecommerce system the SKU belongs to.
   */
  ecommerceSkuProvider?: Maybe<Scalars['String']['output']>
  /**
   * The date when the entitlement was last changed. Tracks when modifications were made to
   * this entitlement record.
   */
  effectiveChangeDate?: Maybe<Scalars['DateTime']['output']>
  /**
   * The timestamp for when the entitlement ends (Unix timestamp converted to DateTime).
   * If null, the entitlement has no expiration. The entitlement expires at this time.
   */
  end?: Maybe<Scalars['DateTime']['output']>
  /**
   * Additional event data stored as JSON. Contains provider-specific information about
   * the event that created this entitlement.
   */
  eventData?: Maybe<Scalars['JSON']['output']>
  /**
   * The event ID linking to the billing event that created or updated this entitlement.
   * This connects the entitlement to the payment transaction that granted access.
   */
  eventId?: Maybe<Scalars['ID']['output']>
  /** The primary key (auto-incrementing integer) */
  id?: Maybe<Scalars['ID']['output']>
  /**
   * The reason that caused the entitlement change. Common values: "payment", "trial", "gift",
   * "renewal", "cancellation", etc. Describes the business logic that created this entitlement.
   */
  reason?: Maybe<Scalars['String']['output']>
  /**
   * The timestamp for when the entitlement starts (Unix timestamp converted to DateTime).
   * The entitlement becomes active at this time.
   */
  start?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * User account for this entitlement. Only set if this is an account-level entitlement
   * (userAccountUuid is not null).
   */
  userAccount?: Maybe<UserAccount>
  /**
   * The user account uuid the entitlement applies to. If set, this is an account-level entitlement
   * that applies to all users in that account. If null, this is a user-specific entitlement.
   */
  userAccountUuid?: Maybe<Scalars['ID']['output']>
  /**
   * User info for this entitlement. Always set, identifies the user associated with this entitlement.
   * For account-level entitlements, this is typically the account owner.
   */
  userInfo?: Maybe<UserInfo>
  /**
   * The identifier for the user associated with this record. This is always set and identifies
   * the user who owns or is directly associated with this entitlement.
   */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** UserEntitlementCreateInput */
export type UserEntitlementCreateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId: Scalars['Int']['input']
  /** The date the row was created */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  /** Ecommerce SKU */
  ecommerceSku?: InputMaybe<Scalars['String']['input']>
  /** Ecommerce SKU Provider */
  ecommerceSkuProvider?: InputMaybe<Scalars['String']['input']>
  /** The date when the entitlement was changed */
  effectiveChangeDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']['input']>
  /** The event data */
  eventData?: InputMaybe<Scalars['JSON']['input']>
  /** The event id */
  eventId?: InputMaybe<Scalars['ID']['input']>
  /** The event that cause the entitlement change */
  reason?: InputMaybe<Scalars['String']['input']>
  /** The timestamp for the entitlement start */
  start: Scalars['DateTime']['input']
  /** The user account uuid the entitlement applies to */
  userAccountUuid?: InputMaybe<Scalars['ID']['input']>
  /** The identifier for the user associated with this record */
  userInfoUuid: Scalars['ID']['input']
}

/** User entitlement data */
export type UserEntitlementEventData = {
  __typename?: 'UserEntitlementEventData'
  /** There are no fields defined on this object it needs to be implmented */
  _empty?: Maybe<Scalars['String']['output']>
}

/** User info policy list response */
export type UserEntitlementListResponse = {
  __typename?: 'UserEntitlementListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of userInfo reference */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>
}

/** User entitlement id where input type */
export type UserEntitlementListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User info policy where conditions to filter rows */
export type UserEntitlementListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserEntitlementListWhereIdInput>
  /** The user account uuid field where clause */
  userAccountUuid?: InputMaybe<UserEntitlementListWhereUserAccountUuidInput>
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserEntitlementListWhereUserInfoUuidInput>
}

/** User entitlement user account uuid where input type */
export type UserEntitlementListWhereUserAccountUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User entitlement user info uuid where input type */
export type UserEntitlementListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** UserEntitlementUpdateInput */
export type UserEntitlementUpdateInput = {
  /** The content the entitlement is allowed to access */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** The timestamp for the entitlement end */
  end?: InputMaybe<Scalars['DateTime']['input']>
  /** The identifier for the user entitlement record */
  id: Scalars['ID']['input']
  /** The timestamp for the entitlement start */
  start?: InputMaybe<Scalars['DateTime']['input']>
  /** The identifier for the user associated with this record */
  userInfoUuid?: InputMaybe<Scalars['ID']['input']>
}

/** A paginated connection of follow relationships */
export type UserFollowConnection = {
  __typename?: 'UserFollowConnection'
  /** The edges */
  edges: Array<UserFollowEdge>
  /** Pagination info */
  pageInfo: UserProfilePageInfo
  /** Total count from denormalized column */
  totalCount: Scalars['Int']['output']
}

/** An edge in a follow connection */
export type UserFollowEdge = {
  __typename?: 'UserFollowEdge'
  /** Cursor for pagination */
  cursor: Scalars['String']['output']
  /** When the follow was created */
  followedAt: Scalars['DateTime']['output']
  /** The user profile */
  node: UserProfile
}

/** User follow row for bulk export */
export type UserFollowRow = {
  __typename?: 'UserFollowRow'
  /** When the follow was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The UID of the followed user */
  followedUid: Scalars['Int']['output']
  /** The UID of the follower */
  followerUid: Scalars['Int']['output']
  /** The primary key */
  id: Scalars['ID']['output']
}

/** Response for bulk user follows list */
export type UserFollowsListResponse = {
  __typename?: 'UserFollowsListResponse'
  /** Total count matching the filter */
  count?: Maybe<Scalars['Int']['output']>
  /** List of follow relationships */
  userFollows: Array<UserFollowRow>
}

/** ID filter for user follows list */
export type UserFollowsListWhereIdInput = {
  eq?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Where input for bulk user follows list */
export type UserFollowsListWhereInput = {
  /** Filter by followed UID */
  followedUid?: InputMaybe<UserFollowsListWhereIntInput>
  /** Filter by follower UID */
  followerUid?: InputMaybe<UserFollowsListWhereIntInput>
  /** Filter by follow row ID */
  id?: InputMaybe<UserFollowsListWhereIdInput>
}

/** Int filter for user follows list */
export type UserFollowsListWhereIntInput = {
  eq?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
}

/** Oracle AI: User's computed graph profile (TOP_TEACHER, TOP_CENTER) */
export type UserGraphProfileInput = {
  /** User's top interest centers/topics */
  topCenters?: Array<UserGraphSignalInput>
  /** User's most-watched teachers */
  topTeachers?: Array<UserGraphSignalInput>
}

/** Oracle AI: User's graph profile signals from watch history */
export type UserGraphSignalInput = {
  /** Catalog entity ID */
  entityId: Scalars['String']['input']
  /** Teacher or center name */
  name: Scalars['String']['input']
  /** Watch count (TOP_TEACHER) or interest weight (TOP_CENTER) */
  weight: Scalars['Float']['input']
}

/** User history row */
export type UserHistory = {
  __typename?: 'UserHistory'
  /** A uuid representing a unique anonymous user */
  anonymousUuid?: Maybe<Scalars['ID']['output']>
  /** A bit value as int identifying bad data within a record. */
  bad?: Maybe<Scalars['Int']['output']>
  /** The error code, if any, returned by the Brightcove server. */
  bcCode?: Maybe<Scalars['Int']['output']>
  /** The error message, if any, returned by the Brightcove server. */
  bcMsg?: Maybe<Scalars['String']['output']>
  /** The language of text captions if being viewed and not default. */
  capLang?: Maybe<Scalars['String']['output']>
  /** The {users}.uid claimed by the client for these statistics. */
  clientUid?: Maybe<Scalars['String']['output']>
  /** The course.nid from the video analytics media linked to this record (if any) */
  courseId?: Maybe<Scalars['ID']['output']>
  /** The recommId of the Recombee row */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Sums of various time intervals (in seconds) from event array */
  eventSumsArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** A non-media {node}.nid that references this media. */
  extraNid?: Maybe<Scalars['ID']['output']>
  /** Array of watched counts (6 seconds per count, 30 seconds per entry) */
  histogramArray?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** in ms) that is used to inc. the view count in each histogram bucket. */
  histogramInterval?: Maybe<Scalars['Int']['output']>
  /** s) that is used to inc. the view count in each histogram bucket. */
  histogramResolution?: Maybe<Scalars['Int']['output']>
  /** Hostname of the user who created the record. */
  hostname?: Maybe<Scalars['String']['output']>
  /** The primary identifier for this history record.UserHistory */
  id?: Maybe<Scalars['ID']['output']>
  /** A bit value as int identifying ignore data within a record. */
  ign?: Maybe<Scalars['Int']['output']>
  /** The error code, if any, returned by the Irdeto license server. */
  irdetoCode?: Maybe<Scalars['Int']['output']>
  /** The error message, if any, returned by the Irdeto license server. */
  irdetoMsg?: Maybe<Scalars['String']['output']>
  /** in ms) of the last event in the event array table. */
  lastEventTimestamp?: Maybe<Scalars['String']['output']>
  /** The most recent time the {node} has been viewed. */
  lastPlayed?: Maybe<Scalars['Int']['output']>
  /** The url of the page the media was played on. */
  location?: Maybe<Scalars['String']['output']>
  /** The media linked to this user history */
  media?: Maybe<Media>
  /** The media {node}.nid for these statistics. */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The language of the media being played. */
  mediaLang?: Maybe<Scalars['String']['output']>
  /** The Unix timestamp when media first started to play. */
  playStartedAt?: Maybe<Scalars['Int']['output']>
  /** The player type (string) that is used by analytics for this record. */
  playerType?: Maybe<Scalars['String']['output']>
  /** The time code in seconds when this video was last playing. */
  position?: Maybe<Scalars['Int']['output']>
  /** Auto generated field from sequelize */
  recommId?: Maybe<Scalars['String']['output']>
  /** A flag indicating this record has already been reported for play counts. */
  reportedCount?: Maybe<Scalars['Int']['output']>
  /** The language of text subtitles if being viewed and not default. */
  subLang?: Maybe<Scalars['String']['output']>
  /** The player type (string) that was used for this record. */
  type?: Maybe<Scalars['String']['output']>
  /** The {users}.uid for these statistics. */
  uid?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The HTTP User-Agent string of the request that created the record. */
  userAgent?: Maybe<Scalars['String']['output']>
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>
  /** The current user media position for this record */
  userMediaPosition?: Maybe<UserMediaPosition>
  /** The future primary identifier for this history record */
  uuid?: Maybe<Scalars['ID']['output']>
  /** The current record version identifier. */
  ver?: Maybe<Scalars['Int']['output']>
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>
  /** The region/country where the video was viewed (based on IP address). */
  viewRegion?: Maybe<Scalars['String']['output']>
  /** The elapsed seconds of the video played. */
  watched?: Maybe<Scalars['Int']['output']>
  /** The elapsed seconds the user has watched the video. */
  watchedPeriod?: Maybe<Scalars['Int']['output']>
}

/** User history row */
export type UserHistoryUserHistoryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User history event row */
export type UserHistoryEvent = {
  __typename?: 'UserHistoryEvent'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The index of the event */
  idx?: Maybe<Scalars['ID']['output']>
  /** Optional value specifying the kind of event. */
  kind?: Maybe<Scalars['String']['output']>
  /** Optional language (used with subtitle and caption events) */
  lang?: Maybe<Scalars['String']['output']>
  /** The name of the event. */
  name?: Maybe<Scalars['String']['output']>
  /** The current resume position at the moment of this event */
  position?: Maybe<Scalars['Int']['output']>
  /** The event moment (in ms) since year 0 */
  timestamp?: Maybe<Scalars['String']['output']>
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user history linked to this event */
  userHistory?: Maybe<UserHistory>
  /** The foreign key for the user history table */
  userHistoryId?: Maybe<Scalars['ID']['output']>
}

/** User history list response */
export type UserHistoryEventsListResponse = {
  __typename?: 'UserHistoryEventsListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user history events */
  userHistoryEvents?: Maybe<Array<Maybe<UserHistoryEvent>>>
}

/** User history list where clause for idx */
export type UserHistoryEventsListWhereIdxInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history list where clause */
export type UserHistoryEventsListWhereInput = {
  /** Filter by the idx field */
  idx?: InputMaybe<UserHistoryEventsListWhereIdxInput>
  /** Filter by the id field */
  userHistoryId?: InputMaybe<UserHistoryEventsListWhereUserHistoryIdInput>
}

/** User history list where clause for user history id */
export type UserHistoryEventsListWhereUserHistoryIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value before the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value before or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history input for array filtering */
export type UserHistoryFilterInput = {
  /** The id of the user history record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The uid of the user history record */
  uid?: InputMaybe<Scalars['ID']['input']>
  /** The uuid of the user history record */
  uuid?: InputMaybe<Scalars['ID']['input']>
}

/** User history list response */
export type UserHistoryListResponse = {
  __typename?: 'UserHistoryListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user history */
  userHistory?: Maybe<Array<Maybe<UserHistory>>>
}

/** User history list where clause for hidden by user (from user media position) */
export type UserHistoryListWhereHiddenByUserInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** User history list where clause for id */
export type UserHistoryListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User history list where clause */
export type UserHistoryListWhereInput = {
  /** Filter by the hidden by user flag from user media position */
  hiddenByUser?: InputMaybe<UserHistoryListWhereHiddenByUserInput>
  /** Filter by the id field */
  id?: InputMaybe<UserHistoryListWhereIdInput>
  /** Filter by the media id field */
  mediaId?: InputMaybe<UserHistoryListWhereMediaIdInput>
  /** Filter by the user uid field */
  uid?: InputMaybe<UserHistoryListWhereUidInput>
  /** Filter by the updated at field */
  updatedAt?: InputMaybe<UserHistoryListWhereUpdatedAtInput>
  /** Filter by the uuid field */
  uuid?: InputMaybe<UserHistoryListWhereUuidInput>
}

/** User history list where clause for media id */
export type UserHistoryListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User history list where clause for user uid */
export type UserHistoryListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User history list where clause for updated at */
export type UserHistoryListWhereUpdatedAtInput = {
  /** Is the value equal to the date */
  eq?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than the date */
  gt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value greater than or equal to the date */
  gte?: InputMaybe<Scalars['DateTime']['input']>
  /** Are the values in the date range */
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  /** Is the value before the date */
  lt?: InputMaybe<Scalars['DateTime']['input']>
  /** Is the value before or equal to the date */
  lte?: InputMaybe<Scalars['DateTime']['input']>
}

/** User history list where clause for uuid */
export type UserHistoryListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User information */
export type UserInfo = {
  __typename?: 'UserInfo'
  /** Where the user was acquired from */
  acquisitionSource?: Maybe<Scalars['String']['output']>
  /** Average AI Chat sessions per week over the last 4 weeks (28 days). A session is defined as an OracleChatSession record (conversation thread). Calculation: (total oracle_chat_sessions in last 28 days) / 4. Returns 0.0 if no chat sessions in time period, null on error. Example: 12 sessions in last 28 days = 3.0 sessions/week */
  aiChatUsageFrequency?: Maybe<Scalars['Float']['output']>
  /** Total number of AI Guide interactions (lifetime count). An interaction is any user message sent to AI Guide (message pair). This is a cumulative lifetime counter, NOT time-bounded. Returns 0 if user has never used AI Guide, null on error. */
  aiGuideInteractionCount?: Maybe<Scalars['Int']['output']>
  /**
   * Current authentication group_id. Authentication groups are used for security and session management.
   * All authentication tokens with a group_id less than this value are invalid. Used to invalidate
   * all sessions when security events occur (password change, account compromise, etc.).
   */
  authenticationGroupId?: Maybe<Scalars['Int']['output']>
  /** External ID for referencing user billing information */
  billingAccountId?: Maybe<Scalars['String']['output']>
  /** Additional external Number for referencing user billing information */
  billingAccountNumber?: Maybe<Scalars['String']['output']>
  /** Attribution params for checkouts owned by this user. */
  billingCheckoutRequestAttributionParams?: Maybe<
    Array<Maybe<BillingCheckoutRequestAttributionParam>>
  >
  /** Checkout requests owned by this user (user_info_uuid). */
  billingCheckoutRequests?: Maybe<Array<Maybe<BillingCheckoutRequest>>>
  /**
   * User billing events associated to this user. Billing events are payment events sent from payment providers
   * (Google Play, Apple App Store, PayPal, Amazon, Adyen, Zuora, etc.) when transactions occur.
   *
   * These raw events represent the complete payment history and are used to:
   * - Create and update user entitlements (access rights)
   * - Track payment history and subscription lifecycle
   * - Calculate financial metrics (see billingEventsOverview)
   * - Determine current payment state and subscription status
   *
   * Understanding Payment State:
   * To determine if a user has active payments, examine the billingEvents:
   * 1. Filter events by paymentStatus="completed" (successful payments only)
   * 2. Check paidThroughDate: if in the future, user has paid access
   * 3. Look for recent "payment" or "renewal" events (not cancelled/refunded)
   * 4. Check endDate/expiresDate to see if subscription is still active
   * 5. Review errorCode for any payment failures that may affect access
   *
   * Payment State Indicators:
   * - Active Payment: Recent event with paymentStatus="completed" AND paidThroughDate in future
   * - Payment Issue: paymentStatus="failed" or "pending" OR errorCode is set
   * - Cancelled: Recent "cancellation" event (but may still have access until paidThroughDate)
   * - Refunded: Recent "refund" event (entitlements may be revoked)
   * - Trial: isTrialPeriod=true (may convert to paid subscription)
   *
   * Events are linked to this user via the uid field. Query with where filters to analyze
   * specific payment providers, transaction types, or time periods.
   */
  billingEvents?: Maybe<Array<Maybe<BillingEvent>>>
  /**
   * The overview of all billing events for this user, providing aggregated financial metrics.
   * Includes profit calculations (gross, net, tax), loss totals, and currency information.
   * Useful for understanding the user's overall payment history and financial status.
   */
  billingEventsOverview?: Maybe<BillingEventsOverview>
  /** A biographical description of the user */
  bio?: Maybe<Scalars['String']['output']>
  /** Users birthday */
  birthday?: Maybe<Scalars['String']['output']>
  /**
   * The datetime of when the user is locked out until. If set and in the future, the user
   * is temporarily blocked. If null or in the past, the user is not blocked (unless status is 'blocked').
   * Used for temporary account locks after failed login attempts.
   */
  blockedUntil?: Maybe<Scalars['String']['output']>
  /**
   * The number of consecutive failed login attempts. Used for security purposes to detect
   * potential brute force attacks. Typically resets after successful login or after blockedUntil expires.
   */
  consecutiveFailedLoginAttempts?: Maybe<Scalars['Int']['output']>
  /** Get course progress for this user */
  courseProgress?: Maybe<UserStateProgressCourseListResponse>
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Source service from which user was created */
  creationSource?: Maybe<Scalars['String']['output']>
  /** Count of unique days with video viewership in the last 7 days. Only counts days with qualified views (15+ seconds watched). Counts distinct calendar days where user had any qualified video watch activity. Returns 0 if no qualified viewership in the time period. Example: User watched videos on Mon, Wed, Fri = 3 days */
  daysWithViewershipLast7Days?: Maybe<Scalars['Int']['output']>
  /** The user email */
  email?: Maybe<Scalars['String']['output']>
  /** Indicates email registered in both Gaia and an external system */
  emailRegisteredExternally?: Maybe<Scalars['Boolean']['output']>
  /** User engagement cohort based on video viewing frequency in last 7 days. Calculated from daysWithViewershipLast7Days: DAU (6-7 days), WAU (2-5 days), MAU (0-1 days). Used for PostHog A/B testing to track cohort migration and measure engagement improvements. */
  engagementCohort?: Maybe<Scalars['String']['output']>
  /** First name of the user */
  firstName?: Maybe<Scalars['String']['output']>
  /** External ID for referencing user billing information for FMTV PayPal recurring */
  fmtvPayPalRecurringId?: Maybe<Scalars['String']['output']>
  /** External ID for referencing FMTV user information */
  fmtvUserId?: Maybe<Scalars['Int']['output']>
  /**
   * True when this user has no entitlement rows with NULL ecommerce_sku.
   * Empty or missing entitlement list is treated as eligible (zero NULL-SKU rows).
   */
  freeTrialEligible?: Maybe<Scalars['Boolean']['output']>
  /** Full name of the user */
  fullName?: Maybe<Scalars['String']['output']>
  /** gcsi uuid for this user */
  gcsiUserUuid?: Maybe<Scalars['String']['output']>
  /** A list of user languages in priority order i.e. index 0 is their primary language */
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']['output']>
  /** Learner level scores for this user (own user, customer service, or site admin) */
  learnerLevels: Array<UserLearnerLevel>
  /** The USD lifetime value of the user */
  lifetimeValue?: Maybe<Scalars['Float']['output']>
  /** The comma-separated city and state where the user is located */
  location?: Maybe<Scalars['String']['output']>
  /** Median minutes watched per week over the last 4 weeks (28 days). Only includes qualified views (15+ seconds watched). Calculates watch time for each of the 4 weeks from qualified views, then returns the median value. Returns 0.0 if no qualified watch time in the time period. Example: Week totals [120, 45, 90, 60] = median 75.0 minutes */
  medianWatchTimePerWeek?: Maybe<Scalars['Float']['output']>
  /** Optional member support notes about the user */
  memberSupportNotes?: Maybe<Scalars['String']['output']>
  /** External ID for referencing user billing information for MYO PayPal recurring */
  myoPayPalRecurringId?: Maybe<Scalars['String']['output']>
  /** User setting for app tracking transparency and 3rd party data sharing */
  optOutOfDataSharing?: Maybe<Scalars['Boolean']['output']>
  /** A playlist associated with this user */
  playlist?: Maybe<Playlist>
  /** Braze-hosted email preference center URL for the signed-in user only (via getPreferenceCenterUrlForUser). Null if unauthenticated, not this user, Braze is unavailable, or the feature is not configured. Treat as sensitive. */
  preferenceCenterUrl?: Maybe<Scalars['String']['output']>
  /** Profile picture URLs in different sizes (ready to use in frontend) */
  profilePicture?: Maybe<ProfilePictureUrls>
  /** UUID for referencing user profile image */
  profilePictureUuid?: Maybe<Scalars['ID']['output']>
  /** Computed target readability grade level for personalized content. Based on education level and reading interests from user demographics. Returns values: grade_8, grade_9, grade_10, grade_11, or grade_12. Defaults to grade_8 if no demographic data available. */
  readabilityLevel?: Maybe<Scalars['String']['output']>
  /** Personalized seed questions based on the user's rainbow categories */
  seedQuestions: Array<SeedQuestion>
  /**
   * The status of the user. 'active' means the user can access the system.
   * 'blocked' means the user is denied access, potentially until blockedUntil date.
   */
  status?: Maybe<User_Info_Status>
  /** The user id */
  uid?: Maybe<Scalars['ID']['output']>
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * User account associated with this user. If this user is a profile, this is the account they belong to.
   * If this user is an account owner, this is the account they own. If null, user is standalone.
   */
  userAccount?: Maybe<UserAccount>
  /** UUID for referencing the UserAccount this user belongs to. If null, user is standalone or is an account owner */
  userAccountId?: Maybe<Scalars['ID']['output']>
  /**
   * User entitlements linked to this user. Entitlements represent access rights to content sets.
   *
   * Entitlements can be:
   * - User-specific: Only apply to this specific user (userAccountUuid is null)
   * - Account-level: Apply to all users in the account (userAccountUuid is set)
   *
   * When userAccount=true, returns entitlements from the account owner (for profiles to access owner's entitlements).
   * When active=true, filters to entitlements where current time is between start and end dates.
   *
   * Entitlements are typically created from billing events when payments are processed.
   */
  userEntitlements?: Maybe<Array<Maybe<UserEntitlement>>>
  /**
   * User entitlements which are currently active, filtered by user account. This is the recommended field
   * for applications and third parties that need to check current entitlement status.
   *
   * Returns active entitlements from the account owner if this user belongs to an account, otherwise
   * returns active entitlements for this user directly.
   */
  userEntitlementsActiveByUserAccount?: Maybe<Array<Maybe<UserEntitlement>>>
  /** The user history records for this user */
  userHistory: Array<UserHistory>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMediaPositions: Array<UserMediaPosition>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  userMetaTags: Array<UserMetaTag>
  /** The user metadata entries for this user */
  userMetadata: Array<UserMetadata>
  /** The user roles associated with this user */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
  /**
   * Days the user has been entitled (has had active access). For account owners, calculated from their entitlements.
   * For profiles, calculated from profile creation date. For frozen users, extracted from email pattern.
   */
  userTenureDays?: Maybe<Scalars['Int']['output']>
  /** The unique username for the user */
  username?: Maybe<Scalars['String']['output']>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
  /** Video completion rate as a ratio (0.0 to 1.0). Calculated as: (completed videos) / (qualified started videos) over last 30 days. Only counts qualified views (15+ seconds watched). Completed = watchedSum/duration >= 0.80 (80%). Returns 0.0 if no qualified videos watched in the time period. Example: 5 completions out of 30 qualified videos = 0.167 (16.7%) */
  videoCompletionRate?: Maybe<Scalars['Float']['output']>
  /** Count of unique videos watched in the last 7 days. Only counts qualified views (15+ seconds watched). Counts distinct contentId values from user's watch history where lastPlayed is within 7 days. Returns 0 if no qualified videos watched in the time period. */
  videosLast7Days?: Maybe<Scalars['Int']['output']>
  /** The user media positions for this user e.g. the resume position and statistics for use video playback */
  votes: Array<Vote>
  /** External ID for referencing Yoga International user information */
  yogaInternationalUserId?: Maybe<Scalars['String']['output']>
}

/** User information */
export type UserInfoBillingCheckoutRequestAttributionParamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingCheckoutRequestAttributionParamListWhereInput>
}

/** User information */
export type UserInfoBillingCheckoutRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  where?: InputMaybe<BillingCheckoutRequestListWhereInput>
}

/** User information */
export type UserInfoBillingEventsArgs = {
  where?: InputMaybe<BillingEventListWhereInput>
}

/** User information */
export type UserInfoCourseProgressArgs = {
  courseTitleGroupIds?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  state?: InputMaybe<UserStateCourse>
}

/** User information */
export type UserInfoLearnerLevelsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
  origin?: InputMaybe<Scalars['String']['input']>
  tagContentContentId?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoPlaylistArgs = {
  playlistType?: InputMaybe<Scalars['String']['input']>
}

/** User information */
export type UserInfoSeedQuestionsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserEntitlementsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  userAccount?: InputMaybe<Scalars['Boolean']['input']>
}

/** User information */
export type UserInfoUserEntitlementsActiveByUserAccountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** User information */
export type UserInfoUserMediaPositionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** User information */
export type UserInfoUserMetaTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** User information */
export type UserInfoUserMetadataArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
}

/** User information */
export type UserInfoVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>
}

/** Request information for the current user */
export type UserInfoCurrentAuthenticationResponse = {
  __typename?: 'UserInfoCurrentAuthenticationResponse'
  /** The client attributes assigned during authentication creation */
  clientAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The country assigned during authentication creation */
  country?: Maybe<Scalars['String']['output']>
  /** The roles assigned during authentication creation */
  roles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The subscriptions assigned during authentication creation */
  subscriptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The user uuid */
  uuid?: Maybe<Scalars['ID']['output']>
}

/** Request information for the current user */
export type UserInfoCurrentRequestResponse = {
  __typename?: 'UserInfoCurrentRequestResponse'
  /** The request country */
  country?: Maybe<Scalars['String']['output']>
}

/** User info for the user currently making this request response */
export type UserInfoCurrentResponse = {
  __typename?: 'UserInfoCurrentResponse'
  /** The authentication information */
  authentication?: Maybe<UserInfoCurrentAuthenticationResponse>
  /** The request information for the current user */
  request?: Maybe<UserInfoCurrentRequestResponse>
  /** User info for the user currently making this request */
  userInfo?: Maybe<UserInfo>
}

/** User info policy list response */
export type UserInfoListResponse = {
  __typename?: 'UserInfoListResponse'
  /** A list of userInfo reference */
  userInfo?: Maybe<Array<Maybe<UserInfo>>>
}

/** User info billing account id type where input type */
export type UserInfoListWhereBillingAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info billing account number type where input type */
export type UserInfoListWhereBillingAccountNumberInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info user account id type where input type */
export type UserInfoListWhereEmailInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info policy where conditions to filter rows */
export type UserInfoListWhereInput = {
  /** The billing account id field where clause */
  billingAccountId?: InputMaybe<UserInfoListWhereBillingAccountIdInput>
  /** The billing account number field where clause */
  billingAccountNumber?: InputMaybe<UserInfoListWhereBillingAccountNumberInput>
  /** The email field where clause */
  email?: InputMaybe<UserInfoListWhereEmailInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserInfoListWhereUidInput>
  /** The user account id field where clause */
  userAccountId?: InputMaybe<UserInfoListWhereUserAccountIdInput>
  /** The uuid field where clause */
  uuid?: InputMaybe<UserInfoListWhereUuidInput>
  /** The yoga international user id field where clause */
  yogaInternationalUserId?: InputMaybe<UserInfoListWhereYogaInternationalUserIdInput>
}

/** User info uid type where input type */
export type UserInfoListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info user account id type where input type */
export type UserInfoListWhereUserAccountIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info uuid type where input type */
export type UserInfoListWhereUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User info yoga international user id type where input type */
export type UserInfoListWhereYogaInternationalUserIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/**
 * Public user profile safe for public display.
 * Returns minimal identity fields for any user.
 * Requires authentication but can view any user's public profile.
 * Brooklyn extends this type with avatar (profile picture) and displayName via federation.
 */
export type UserInfoPublic = {
  __typename?: 'UserInfoPublic'
  /** Public username */
  username?: Maybe<Scalars['String']['output']>
  /** User UUID */
  uuid: Scalars['ID']['output']
}

/** How userInfoUpdateRoles applies the submitted role ids */
export enum UserInfoRoleUpdateMode {
  /** The submitted ids are added. Existing roles stay. */
  Merge = 'MERGE',
  /** The submitted ids become the user's role set. Omitted roles are removed. */
  Replace = 'REPLACE',
}

/** Input for updating user info fields */
export type UserInfoUpdateInput = {
  /** Update first name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Update last name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Update name visibility (public or private) */
  nameVisibility?: InputMaybe<Scalars['String']['input']>
  /** Update username */
  username?: InputMaybe<Scalars['String']['input']>
}

/** Input for account owner to update a profile's first and last name */
export type UserInfoUpdateProfileInput = {
  /** Update first name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Update last name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** UUID of the profile to update (must be a profile in the requester's account) */
  profileUuid: Scalars['ID']['input']
}

/** Response from userInfoUpdate mutation */
export type UserInfoUpdateResponse = {
  __typename?: 'UserInfoUpdateResponse'
  /** Whether the update was successful */
  success: Scalars['Boolean']['output']
  /** The updated user info */
  userInfo?: Maybe<UserInfo>
}

/** Input for replacing or merging roles on an account owner */
export type UserInfoUpdateRolesInput = {
  /** REPLACE sets the role set. MERGE adds roles without removing others. */
  mode: UserInfoRoleUpdateMode
  /** Role ids. Duplicates are ignored. Authenticated-user is always kept. */
  roles: Array<Scalars['Int']['input']>
  /** UUID of the account owner whose roles are updated */
  userInfoUuid: Scalars['ID']['input']
}

/** User info with metadata response */
export type UserInfoWithMetadataResponse = {
  __typename?: 'UserInfoWithMetadataResponse'
  /** Total count of users with demographic metadata */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user info */
  userInfo: Array<UserInfo>
}

/** Learner level score for a user on a tag topic */
export type UserLearnerLevel = {
  __typename?: 'UserLearnerLevel'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Source of the score e.g. onboarding-v5 */
  origin: Scalars['String']['output']
  /** Score 1-10 */
  score: Scalars['Int']['output']
  /** Tag content content_id */
  tagContentContentId: Scalars['Int']['output']
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type UserLearnerLevelDeleteResult = {
  __typename?: 'UserLearnerLevelDeleteResult'
  deleted: Scalars['Int']['output']
}

/** Input for creating or updating learner level rows. For most callers the effective user id comes from the JWT; see uid field. */
export type UserLearnerLevelInput = {
  origin: Scalars['String']['input']
  score: Scalars['Int']['input']
  tagContentContentId: Scalars['Int']['input']
  /** Optional user id. Only editor, editor-plus, and site-admin may set this to write for another user. For all other authenticated callers the value is ignored and the JWT user id is used. */
  uid?: InputMaybe<Scalars['Int']['input']>
}

export type UserLearnerLevelMutationResult = {
  __typename?: 'UserLearnerLevelMutationResult'
  created: Scalars['Int']['output']
  updated: Scalars['Int']['output']
  userLearnerLevels: Array<UserLearnerLevel>
}

/** User media position row */
export type UserMediaPosition = {
  __typename?: 'UserMediaPosition'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** User has hidden this media from their watch history when true */
  hiddenByUser?: Maybe<Scalars['Boolean']['output']>
  /** User has hidden this media from showing up in Continue Watching */
  hiddenFromContinue?: Maybe<Scalars['Boolean']['output']>
  /** The most recent time the media has been played. */
  lastPlayed?: Maybe<Scalars['BigInt']['output']>
  /** The media linked from this user media position */
  media?: Maybe<Media>
  /** The node nid that was played. */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The time offset (in seconds) when this media was last playing (resume point). */
  position?: Maybe<Scalars['BigInt']['output']>
  /** The time this video was last searched by this user (in seconds) */
  searchedTime?: Maybe<Scalars['Int']['output']>
  /** The users uid that played the node nid. */
  uid?: Maybe<Scalars['ID']['output']>
  /** The date the row was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user connected this this user history */
  userInfo?: Maybe<UserInfo>
  /** The video analytics media for this record */
  videoAnalyticsMedia?: Maybe<VideoAnalyticsMedia>
  /** The video analytics video for this record */
  videoAnalyticsVideo?: Maybe<VideoAnalyticsVideo>
  /** The total number of views of this media by this user. */
  watchedCount?: Maybe<Scalars['Int']['output']>
  /** The total seconds watched of all views of this media by this user. */
  watchedSum?: Maybe<Scalars['BigInt']['output']>
}

/** User media position list response */
export type UserMediaPositionListResponse = {
  __typename?: 'UserMediaPositionListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user media positions */
  userMediaPositions?: Maybe<Array<Maybe<UserMediaPosition>>>
}

/** Filter by hidden_by_user flag */
export type UserMediaPositionListWhereHiddenByUserInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Boolean']['input']>
}

/** User media position list where clause */
export type UserMediaPositionListWhereInput = {
  /** Filter by hidden_by_user flag */
  hiddenByUser?: InputMaybe<UserMediaPositionListWhereHiddenByUserInput>
  /** Filter by last_played timestamp */
  lastPlayed?: InputMaybe<UserMediaPositionListWhereLastPlayedInput>
  /** Filter by media id */
  mediaId?: InputMaybe<UserMediaPositionListWhereMediaIdInput>
  /** Filter by user uid */
  uid?: InputMaybe<UserMediaPositionListWhereUidInput>
  /** Filter by watched_sum seconds */
  watchedSum?: InputMaybe<UserMediaPositionListWhereWatchedSumInput>
}

/** Filter by last_played timestamp */
export type UserMediaPositionListWhereLastPlayedInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['BigInt']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['BigInt']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['BigInt']['input']>
}

/** User media position list where clause for media id */
export type UserMediaPositionListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User media position list where clause for user uid */
export type UserMediaPositionListWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Filter by watched_sum seconds */
export type UserMediaPositionListWhereWatchedSumInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['BigInt']['input']>
  /** Is the value greater than the field */
  gt?: InputMaybe<Scalars['BigInt']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['BigInt']['input']>
}

/** User meta tags */
export type UserMetaTag = {
  __typename?: 'UserMetaTag'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key for this record */
  id: Scalars['ID']['output']
  /** The numeric key for tag name i.e. 2 */
  key: Scalars['Int']['output']
  /** The tag name i.e. 'transformation' */
  name: Scalars['String']['output']
  /** The number of seconds a user could have watched for engaged views in this category/segment */
  potentialSeconds: Scalars['Int']['output']
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source: Scalars['String']['output']
  /** The type of meta tag (UBS, RC, TOPIC) */
  tagType: Scalars['String']['output']
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user linked to this user meta tag */
  userInfo?: Maybe<UserInfo>
  /** The number of engaged views (where a user has watched more than 25% of a video) */
  viewCount: Scalars['Int']['output']
  /** The number of seconds watched for engaged views (> 25%) only */
  viewSeconds: Scalars['Int']['output']
  /** A fractional value indicating the percentage of all engaged for tag within the type */
  weight?: Maybe<Scalars['Float']['output']>
}

/** Input to create one user meta tag */
export type UserMetaTagCreateInput = {
  /** The numeric key for the tag */
  key: Scalars['Int']['input']
  /** The tag name */
  name: Scalars['String']['input']
  /** Potential engaged seconds */
  potentialSeconds?: InputMaybe<Scalars['Int']['input']>
  /** The source of this data */
  source: Scalars['String']['input']
  /** The type of meta tag */
  tagType: Scalars['String']['input']
  /** The user id */
  uid: Scalars['Int']['input']
  /** Engaged view count */
  viewCount?: InputMaybe<Scalars['Int']['input']>
  /** Engaged view seconds */
  viewSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Engagement weight */
  weight?: InputMaybe<Scalars['Float']['input']>
}

/** Response for userMetaTagCreateMany */
export type UserMetaTagCreateManyResponse = {
  __typename?: 'UserMetaTagCreateManyResponse'
  /** Upserted tag count */
  count: Scalars['Int']['output']
  /** Removed stale rows for the same source and uids */
  deleted: Scalars['Int']['output']
  /** Tags after create many */
  userMetaTags: Array<UserMetaTag>
}

/** One tag row for userMetaTagCreateMany */
export type UserMetaTagCreateManyTagInput = {
  /** The numeric key for the tag */
  key: Scalars['Int']['input']
  /** The tag name */
  name: Scalars['String']['input']
  /** Potential engaged seconds */
  potentialSeconds?: InputMaybe<Scalars['Int']['input']>
  /** The type of meta tag */
  type: Scalars['String']['input']
  /** The user id */
  uid: Scalars['Int']['input']
  /** Engaged view count */
  viewCount?: InputMaybe<Scalars['Int']['input']>
  /** Engaged view seconds */
  viewSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Engagement weight */
  weight?: InputMaybe<Scalars['Float']['input']>
}

/** Response for userMetaTagCreate */
export type UserMetaTagCreateResponse = {
  __typename?: 'UserMetaTagCreateResponse'
  /** The created user meta tag */
  userMetaTag?: Maybe<UserMetaTag>
}

/** How rainbow category defaults were resolved for a user */
export enum UserMetaTagDefaultResolution {
  /** Skip-onboarding DEFAULT rows were already persisted */
  AlreadyDefault = 'ALREADY_DEFAULT',
  /** Merged partial VA or cold-start rows into COMPUTED */
  ComputedFromTags = 'COMPUTED_FROM_TAGS',
  /** User already has expiry-level RC from VA, cold-start, or computed sources */
  ExistingRainbowCategories = 'EXISTING_RAINBOW_CATEGORIES',
  /** Derived from user_meta featured content impression */
  ImpressionColdStart = 'IMPRESSION_COLD_START',
  /** Derived from stored user_onboard terms */
  OnboardColdStart = 'ONBOARD_COLD_START',
  /** Hardcoded skip-onboarding DEFAULT when no other signal exists */
  SkipOnboardingFallback = 'SKIP_ONBOARDING_FALLBACK',
}

/** Response for userMetaTagDelete */
export type UserMetaTagDeleteResponse = {
  __typename?: 'UserMetaTagDeleteResponse'
  /** The deleted user meta tag id */
  id?: Maybe<Scalars['ID']['output']>
}

/** Response for userMetaTagEnsureDefaults */
export type UserMetaTagEnsureDefaultsResponse = {
  __typename?: 'UserMetaTagEnsureDefaultsResponse'
  /** True when this call wrote or recomputed tags */
  persisted: Scalars['Boolean']['output']
  /** How defaults were resolved */
  resolution: UserMetaTagDefaultResolution
  /** The user id */
  uid: Scalars['Int']['output']
  /** Rainbow category tags after ensure (computed or DEFAULT depending on resolution) */
  userMetaTags: Array<UserMetaTag>
}

/** User meta tag filter input type */
export type UserMetaTagFilterInput = {
  /** The numeric key for tag name i.e. 2 */
  key?: InputMaybe<Scalars['Int']['input']>
  /** The source of this data (VA, Brooklyn, ColdStart) */
  source?: InputMaybe<Scalars['String']['input']>
  /** The type of meta tag (UBS, RC, TOPIC) */
  type?: InputMaybe<Scalars['String']['input']>
  /** The user id */
  uid?: InputMaybe<Scalars['Int']['input']>
}

/** User meta tag list response */
export type UserMetaTagListResponse = {
  __typename?: 'UserMetaTagListResponse'
  /** The total count when requested */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user meta tags */
  userMetaTags: Array<UserMetaTag>
}

/** Users lacking expiry-level rainbow category tags (for backfill) */
export type UserMetaTagMissingRainbowDefaultsListResponse = {
  __typename?: 'UserMetaTagMissingRainbowDefaultsListResponse'
  /** Total matching users when count is requested */
  count?: Maybe<Scalars['Int']['output']>
  /** Cursor for next page (last uid in this page when paginating by uidGt) */
  lastUid?: Maybe<Scalars['Int']['output']>
  /** Applied limit */
  limit?: Maybe<Scalars['Int']['output']>
  /** Applied offset */
  offset?: Maybe<Scalars['Int']['output']>
  /** User ids missing RC defaults */
  uids: Array<Scalars['Int']['output']>
}

/** Known user meta tag sources for batch writes */
export enum UserMetaTagSource {
  /** Computed merge of VA and cold-start */
  Cc = 'CC',
  /** Cold start from featured content impression */
  CsIm = 'CS_IM',
  /** Cold start from onboarding */
  CsOb = 'CS_OB',
  /** Cold start from UTM */
  CsUtm = 'CS_UTM',
  /** Skip-onboarding default seed */
  Default = 'DEFAULT',
  /** Video analytics watch history */
  Va = 'VA',
}

/** User meta tag where conditions to filter rows */
export type UserMetaTagWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserMetaTagWhereIntInput>
  /** The key field where clause */
  key?: InputMaybe<UserMetaTagWhereIntInput>
  /** The name field where clause */
  name?: InputMaybe<UserMetaTagWhereStringInput>
  /** The source field where clause */
  source?: InputMaybe<UserMetaTagWhereStringInput>
  /** The tag_type field where clause */
  tagType?: InputMaybe<UserMetaTagWhereStringInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserMetaTagWhereIntInput>
}

/** User meta tag id where input type */
export type UserMetaTagWhereIntInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User meta tag id where input type */
export type UserMetaTagWhereStringInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User metadata entry */
export type UserMetadata = {
  __typename?: 'UserMetadata'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The export index for this record */
  exportIndex: Scalars['Int']['output']
  /** The metadata name */
  name: Scalars['String']['output']
  /** The metadata type */
  type: Scalars['String']['output']
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The metadata value */
  value?: Maybe<Scalars['String']['output']>
}

/** User metadata input */
export type UserMetadataInput = {
  /** The metadata name */
  name: Scalars['String']['input']
  /** The metadata type */
  type: Scalars['String']['input']
  /** The user id */
  uid: Scalars['Int']['input']
  /** The metadata value */
  value?: InputMaybe<Scalars['String']['input']>
}

/** User metadata mutation response */
export type UserMetadataMutationResult = {
  __typename?: 'UserMetadataMutationResult'
  /** The total number of rows created */
  created: Scalars['Int']['output']
  /** The total number of rows updated */
  updated: Scalars['Int']['output']
  /** The resulting user metadata rows */
  userMetadata: Array<UserMetadata>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfile = {
  __typename?: 'UserProfile'
  /** User's chosen identity archetype */
  archetype?: Maybe<Scalars['String']['output']>
  /** Archetype field visibility */
  archetypeVisibility?: Maybe<FieldVisibility>
  /** Profile picture (resolved from user_profiles.profile_picture_s3_key) */
  avatar?: Maybe<ProfilePicture>
  /** Profile banner image */
  bannerImage?: Maybe<ProfileBannerImage>
  /** Short bio */
  bio?: Maybe<Scalars['String']['output']>
  /** Bio field visibility */
  bioVisibility?: Maybe<FieldVisibility>
  /** Birth day of month, 1-31. Authoritative. */
  birthDay?: Maybe<Scalars['Int']['output']>
  /** Birth month, 1-12. Authoritative. */
  birthMonth?: Maybe<Scalars['Int']['output']>
  /** Birthday as an ISO date string. DERIVED from birthMonth/birthDay using a sentinel year of 2000 — the year is not the member's and never was. Prefer birthMonth/birthDay. */
  birthday?: Maybe<Scalars['String']['output']>
  /** Birthday field visibility */
  birthdayVisibility?: Maybe<FieldVisibility>
  /** Denormalized mutual-follow (connection) count */
  connectionCount?: Maybe<Scalars['Int']['output']>
  /** Number of connections the requesting member and this member share. Null when unauthenticated or viewing your own profile; 0 when there are none. A connection is a two-way follow, so this is the intersection of the two sets, not either connectionCount. */
  connectionsInCommon?: Maybe<Scalars['Int']['output']>
  /** Date the profile was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Visibility of the user's Currently Watching list. Persisted owner intent; the video-analytics subgraph will consume it via @requires to gate UserProfile.inProgress. */
  currentlyWatchingVisibility?: Maybe<FieldVisibility>
  /** User-editable display name (defaults to username, null if no profile row exists) */
  displayName?: Maybe<Scalars['String']['output']>
  /** User's Favorites system playlist (null when hidden by visibility/cascade) */
  favorites?: Maybe<Playlist>
  /** Denormalized follower count */
  followerCount?: Maybe<Scalars['Int']['output']>
  /** Denormalized following count */
  followingCount?: Maybe<Scalars['Int']['output']>
  /** AI-generated identity vibe for this user */
  identityVibe?: Maybe<OracleIdentityVibe>
  /** In-progress videos for this user's profile. Shows recent videos with watch progress. Only visible when profile is public or viewer has permission. */
  inProgress: Array<UserMediaPosition>
  /** Whether this profile is the environment's circle facilitator (Sage) persona — false when the facilitator is not provisioned */
  isCircleFacilitator: Scalars['Boolean']['output']
  /** City/region location */
  location?: Maybe<Scalars['String']['output']>
  /** Location field visibility */
  locationVisibility?: Maybe<FieldVisibility>
  /**
   * Date the member's Gaia account was created, from the auth user row.
   * This is the value behind "Member since" — createdAt below is the community
   * profile row, which for most members was provisioned long after they joined.
   * Gated by memberSinceVisibility.
   */
  memberSince?: Maybe<Scalars['DateTime']['output']>
  /** Member-since field visibility */
  memberSinceVisibility?: Maybe<FieldVisibility>
  /** Profile visibility setting */
  profileVisibility?: Maybe<ProfileVisibility>
  /** Recent videos watched by this user. Only visible when profile is public or viewer has permission. */
  recentVideos: Array<UserHistory>
  /** Short member-set status line, shown beside the display name. Follows profileVisibility. */
  status?: Maybe<Scalars['String']['output']>
  /** Top genres / rainbow categories (from user meta tags). Only present when profile is visible. */
  topGenres: Array<UserProfileTopGenre>
  /** Selected onboarding centers (from user_profiles.center_content_ids) */
  topics?: Maybe<Array<Maybe<UserProfileTag>>>
  /** Topics field visibility */
  topicsVisibility?: Maybe<FieldVisibility>
  /** User UID */
  uid: Scalars['ID']['output']
  /** Date the profile was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** User UUID (privacy-safe public identifier) */
  uuid: Scalars['ID']['output']
  /** Count of unique videos watched in the last 7 days. Only visible when profile is public or viewer has permission. */
  videosLast7Days?: Maybe<Scalars['Int']['output']>
  /** Viewer-relative context */
  viewerContext?: Maybe<UserProfileViewerContext>
  /** Watch history for this user's profile, filterable by completion status. Only visible when profile is public or viewer has permission. */
  watchHistory: Array<UserMediaPosition>
  /** Visibility of the user's full Watch History. Persisted owner intent; the video-analytics subgraph will consume it via @requires to gate UserProfile.watchHistory. */
  watchHistoryVisibility?: Maybe<FieldVisibility>
  /** User's Watch Later system playlist (null when hidden by visibility/cascade) */
  watchLater?: Maybe<Playlist>
  /** User's journey description */
  yourJourney?: Maybe<Scalars['String']['output']>
  /** Your-journey field visibility */
  yourJourneyVisibility?: Maybe<FieldVisibility>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileInProgressArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileRecentVideosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileTopGenresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileTopicsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
}

/** User profile from Brooklyn, extended by AI service with identity vibe */
export type UserProfileWatchHistoryArgs = {
  filter?: InputMaybe<WatchHistoryFilter>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Connection type for UserProfile pagination */
export type UserProfileConnection = {
  __typename?: 'UserProfileConnection'
  /** List of user edges */
  edges: Array<UserProfileEdge>
  /** Pagination information */
  pageInfo: PageInfo
}

/** Edge type for UserProfile pagination */
export type UserProfileEdge = {
  __typename?: 'UserProfileEdge'
  /** Cursor for this edge */
  cursor: Scalars['String']['output']
  /** The user node */
  node: UserProfile
}

/** Response from following or unfollowing a user */
export type UserProfileFollowResponse = {
  __typename?: 'UserProfileFollowResponse'
  /** The profile of the followed/unfollowed user */
  profile?: Maybe<UserProfile>
}

/** A paginated connection for user profile ingestion */
export type UserProfileIngestConnection = {
  __typename?: 'UserProfileIngestConnection'
  /** The edges */
  edges: Array<UserProfileIngestEdge>
  /** Pagination info */
  pageInfo: UserProfilePageInfo
}

/** An edge in a user profile ingest connection */
export type UserProfileIngestEdge = {
  __typename?: 'UserProfileIngestEdge'
  /** Cursor for pagination */
  cursor: Scalars['String']['output']
  /** The user profile */
  node: UserProfile
}

/** Pagination info */
export type UserProfilePageInfo = {
  __typename?: 'UserProfilePageInfo'
  /** Cursor for the last edge */
  endCursor?: Maybe<Scalars['String']['output']>
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean']['output']
}

/** A selected onboarding center (centers-bundle tag; contentId matches popularTopics) */
export type UserProfileTag = {
  __typename?: 'UserProfileTag'
  /** English center tag content_id (stored value; aligns with popularTopics.contentId) */
  contentId: Scalars['Int']['output']
  /** Display title (localized when language arg differs from en) */
  title: Scalars['String']['output']
  /** Title group of the center tag */
  titleGroupId: Scalars['String']['output']
}

/** Top genre / rainbow category for profile (from user meta tags, visibility follows profile) */
export type UserProfileTopGenre = {
  __typename?: 'UserProfileTopGenre'
  /** Cleaned name with numbered prefix and RC suffix stripped (e.g. '3 - Meditation RC' → 'Meditation') */
  cleanName: Scalars['String']['output']
  /** Display name e.g. Meditation & Mindfulness */
  name: Scalars['String']['output']
  /** Engaged view count */
  viewCount?: Maybe<Scalars['Int']['output']>
  /** Weight within type (0–1) */
  weight?: Maybe<Scalars['Float']['output']>
}

/** Input for updating a user profile */
export type UserProfileUpdateInput = {
  /** Identity archetype (max 256 chars) */
  archetype?: InputMaybe<Scalars['String']['input']>
  /** Archetype field visibility */
  archetypeVisibility?: InputMaybe<FieldVisibility>
  /** Short bio (max 500 characters) */
  bio?: InputMaybe<Scalars['String']['input']>
  /** Bio field visibility */
  bioVisibility?: InputMaybe<FieldVisibility>
  /** Birth day of month, 1-31. Send with birthMonth. */
  birthDay?: InputMaybe<Scalars['Int']['input']>
  /** Birth month, 1-12. Send with birthDay. */
  birthMonth?: InputMaybe<Scalars['Int']['input']>
  /** Birthday as an ISO date. Accepted for compatibility — the year is discarded and only month and day are stored. Prefer birthMonth/birthDay. */
  birthday?: InputMaybe<Scalars['String']['input']>
  /** Birthday field visibility */
  birthdayVisibility?: InputMaybe<FieldVisibility>
  /** Center tag content IDs from popularTopics (English rows), max 5, order preserved; omit to leave unchanged */
  centerContentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Currently-watching list visibility (forced to private when profile is private) */
  currentlyWatchingVisibility?: InputMaybe<FieldVisibility>
  /** Display name (max 64 characters) */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** City/region location (max 128 characters) */
  location?: InputMaybe<Scalars['String']['input']>
  /** Location field visibility */
  locationVisibility?: InputMaybe<FieldVisibility>
  /** Member-since field visibility */
  memberSinceVisibility?: InputMaybe<FieldVisibility>
  /** Profile visibility */
  profileVisibility?: InputMaybe<ProfileVisibility>
  /** Short status line (max 100 chars) */
  status?: InputMaybe<Scalars['String']['input']>
  /** Topics field visibility */
  topicsVisibility?: InputMaybe<FieldVisibility>
  /** Watch history visibility (forced to private when profile is private) */
  watchHistoryVisibility?: InputMaybe<FieldVisibility>
  /** Journey description (max 100 chars) */
  yourJourney?: InputMaybe<Scalars['String']['input']>
  /** Your-journey field visibility */
  yourJourneyVisibility?: InputMaybe<FieldVisibility>
}

/** Response from updating a user profile */
export type UserProfileUpdateResponse = {
  __typename?: 'UserProfileUpdateResponse'
  /** The updated user profile */
  profile?: Maybe<UserProfile>
}

/** Viewer-relative context for a user profile */
export type UserProfileViewerContext = {
  __typename?: 'UserProfileViewerContext'
  /** Does this profile follow the viewer */
  isFollowedBy: Scalars['Boolean']['output']
  /** Does the viewer follow this profile */
  isFollowing: Scalars['Boolean']['output']
  /** Is the viewer the owner of this profile */
  isOwner: Scalars['Boolean']['output']
  /**
   * True when this profile is private to the viewer: identity only — display name, avatar and
   * banner — with every content field withheld. Render the private state from this rather than
   * inferring it, because the underlying rule also turns on circle membership and admin role.
   */
  isRestricted: Scalars['Boolean']['output']
  /** Visibility level for the viewer: owner, member, public */
  visibilityLevel: Scalars['String']['output']
}

/** User role */
export type UserRole = {
  __typename?: 'UserRole'
  /** The auth role associated with this record */
  authRole?: Maybe<AuthRole>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary key */
  id?: Maybe<Scalars['ID']['output']>
  /** The auth role id */
  role?: Maybe<Scalars['ID']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info associated with this record */
  userInfo?: Maybe<UserInfo>
  /** The identifier for the user associated with this record */
  userInfoUuid?: Maybe<Scalars['ID']['output']>
}

/** User role list response */
export type UserRoleListResponse = {
  __typename?: 'UserRoleListResponse'
  /** Total number of rows found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of userInfo reference */
  userRoles?: Maybe<Array<Maybe<UserRole>>>
}

/** User role id where input type */
export type UserRoleListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User role where conditions to filter rows */
export type UserRoleListWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserRoleListWhereIdInput>
  /** The user role role file where clause */
  role?: InputMaybe<UserRoleListWhereRoleInput>
  /** The user info uuid field where clause */
  userInfoUuid?: InputMaybe<UserRoleListWhereUserInfoUuidInput>
}

/** User role user role where input type */
export type UserRoleListWhereRoleInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User role user user info uuid where input type */
export type UserRoleListWhereUserInfoUuidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** User state entry for tracking progress */
export type UserState = {
  __typename?: 'UserState'
  /** When the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String']['output']
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String']['output']
  /** The type of progress item */
  progressItemType: UserStateProgressItemType
  /** The state of the progress item */
  state: UserStateState
  /** The user id */
  uid: Scalars['Int']['output']
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum UserStateCourse {
  /** The course is complete */
  Complete = 'COMPLETE',
  /** The course is in progress */
  InProgress = 'IN_PROGRESS',
  /** The course has not been started */
  NotStarted = 'NOT_STARTED',
}

/** User state input */
export type UserStateInput = {
  /** The parent content title group id (course) */
  parentContentTitleGroupId: Scalars['String']['input']
  /** The id of the progress item. For videos, this should be the contentTitleGroupId. For assets, this should be the asset UUID. */
  progressItemId: Scalars['String']['input']
  /** The type of progress item */
  progressItemType: UserStateProgressItemType
  /** The state of the progress item */
  state: UserStateState
  /** The user id (admin only, defaults to current user) */
  userUid?: InputMaybe<Scalars['Int']['input']>
}

/** User state list response */
export type UserStateListResponse = {
  __typename?: 'UserStateListResponse'
  /** The total number of user state entries matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of user state entries */
  userState: Array<UserState>
}

/** Course metrics */
export type UserStateMetricsCourse = {
  __typename?: 'UserStateMetricsCourse'
  /** Number of completed videos */
  completedItems: Scalars['Int']['output']
  /** Number of completed modules */
  completedModules: Scalars['Int']['output']
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float']['output']
  /** Percentage of modules completed (0.0 to 100.0) */
  percentageModulesComplete: Scalars['Float']['output']
  /** Total number of videos in the course */
  totalItems: Scalars['Int']['output']
  /** Total number of modules in the course */
  totalModules: Scalars['Int']['output']
}

/** Course module metrics */
export type UserStateMetricsCourseModule = {
  __typename?: 'UserStateMetricsCourseModule'
  /** Number of completed videos */
  completedItems: Scalars['Int']['output']
  /** Percentage of items completed (0.0 to 100.0) */
  percentageItemsComplete: Scalars['Float']['output']
  /** Total number of videos in the module */
  totalItems: Scalars['Int']['output']
}

/** Course progress */
export type UserStateProgressCourse = {
  __typename?: 'UserStateProgressCourse'
  /** The number of times the course has been completed */
  completionCount: Scalars['Int']['output']
  /** The course title group id */
  courseTitleGroupId: Scalars['String']['output']
  /** The course metrics */
  metrics: UserStateMetricsCourse
  /** The current state of the course. If the course has production_status of 'active-production', this will return IN_PROGRESS instead of COMPLETE even when all videos are complete. */
  state: UserStateCourse
}

/** Course item progress */
export type UserStateProgressCourseItem = {
  __typename?: 'UserStateProgressCourseItem'
  /** The asset (if item is an asset) */
  asset?: Maybe<Asset>
  /** The content (if item is a video) */
  content?: Maybe<Content>
  /** The item id (video or asset id) */
  itemId: Scalars['String']['output']
  /** The type of item */
  itemType: UserStateProgressItemType
  /** The current state of the item */
  state: UserStateState
}

/** Course progress list response */
export type UserStateProgressCourseListResponse = {
  __typename?: 'UserStateProgressCourseListResponse'
  /** The total number of course progress entries matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** A list of course progress entries */
  courseProgress: Array<UserStateProgressCourse>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
}

/** Course module progress */
export type UserStateProgressCourseModule = {
  __typename?: 'UserStateProgressCourseModule'
  /** The module title group id */
  courseModuleTitleGroupId: Scalars['String']['output']
  /** The module metrics */
  metrics: UserStateMetricsCourseModule
  /** The module content */
  module?: Maybe<Content>
  /** The current state of the module */
  state: UserStateCourse
}

export enum UserStateProgressItemType {
  /** An asset progress item */
  Asset = 'ASSET',
  /** A video progress item */
  Video = 'VIDEO',
}

export enum UserStateState {
  /** The item is complete */
  Complete = 'COMPLETE',
  /** The item is in progress */
  InProgress = 'IN_PROGRESS',
}

/** User state where id input type */
export type UserStateWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User state where conditions to filter rows */
export type UserStateWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<UserStateWhereIdInput>
  /** The uid field where clause */
  uid?: InputMaybe<UserStateWhereUidInput>
}

/** User state where uid input type */
export type UserStateWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** User-to-content subscription (user follows a teacher/series/host for notifications) */
export type UserSubscriptionRow = {
  __typename?: 'UserSubscriptionRow'
  /** The associated content ID (teacher/series content_id) */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content title */
  contentTitle?: Maybe<Scalars['String']['output']>
  /** The associated content type */
  contentType?: Maybe<Scalars['String']['output']>
  /** The subscriber row ID */
  id: Scalars['ID']['output']
  /** Whether the subscription is inactive (unfollowed) */
  inactive?: Maybe<Scalars['Boolean']['output']>
  /** The subscription type (teacher, series, host) */
  type: Scalars['String']['output']
  /** The user UID who subscribed */
  uid: Scalars['Int']['output']
}

export type UserTagOption = {
  __typename?: 'UserTagOption'
  /** Category grouping */
  category?: Maybe<Scalars['String']['output']>
  /** Tag option ID */
  id: Scalars['ID']['output']
  /** Translated display label */
  label: Scalars['String']['output']
  /** Internal tag name */
  tag: Scalars['String']['output']
}

/** Video analytics media row */
export type VideoAnalyticsMedia = {
  __typename?: 'VideoAnalyticsMedia'
  /** Engaged play count in the last 1 day */
  count1d?: Maybe<Scalars['Int']['output']>
  /** Engaged play count in the last 3 days */
  count3d?: Maybe<Scalars['Int']['output']>
  /** Engaged play count in the last 7 days */
  count7d?: Maybe<Scalars['Int']['output']>
  /** Lifetime engaged play count */
  countTotal?: Maybe<Scalars['Int']['output']>
  /** The course.nid referenced in this video that contains this media */
  courseId?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The total length of this media (in seconds) */
  duration?: Maybe<Scalars['Int']['output']>
  /** Is this media a feature (true) or a preview (false) */
  isFeature?: Maybe<Scalars['Boolean']['output']>
  /** flag indicating the media has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** qualified string identifier for the media */
  lemonadeContentId?: Maybe<Scalars['String']['output']>
  /** The media linked from this video analytics media */
  media?: Maybe<Media>
  /** VideoAnalyticsMedia creation date */
  mediaCreated?: Maybe<Scalars['String']['output']>
  /** The feature_nid */
  mediaId?: Maybe<Scalars['String']['output']>
  /** update to the media */
  mediaUpdated?: Maybe<Scalars['DateTime']['output']>
  /** The series.nid referenced in this video that contains this media */
  seriesId?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Video analytics media row */
export type VideoAnalyticsMediaCount1dArgs = {
  language?: InputMaybe<PlaycountLanguage>
}

/** Video analytics media row */
export type VideoAnalyticsMediaCount3dArgs = {
  language?: InputMaybe<PlaycountLanguage>
}

/** Video analytics media row */
export type VideoAnalyticsMediaCount7dArgs = {
  language?: InputMaybe<PlaycountLanguage>
}

/** Video analytics media row */
export type VideoAnalyticsMediaCountTotalArgs = {
  language?: InputMaybe<PlaycountLanguage>
}

/** Video analytics media list response */
export type VideoAnalyticsMediaListResponse = {
  __typename?: 'VideoAnalyticsMediaListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of media */
  videoAnalyticsMedia?: Maybe<Array<Maybe<VideoAnalyticsMedia>>>
}

/** Video analytics media list where clause for the course id */
export type VideoAnalyticsMediaListWhereCourseIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Video analytics media list where clause for the id */
export type VideoAnalyticsMediaListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Video analytics media list where clause */
export type VideoAnalyticsMediaListWhereInput = {
  /** Filter by course id */
  courseId?: InputMaybe<VideoAnalyticsMediaListWhereCourseIdInput>
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsMediaListWhereIdInput>
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsMediaListWhereSeriesIdInput>
}

/** Video analytics media list where clause for the series id */
export type VideoAnalyticsMediaListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['Int']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['Int']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

/** Video analytics video row */
export type VideoAnalyticsVideo = {
  __typename?: 'VideoAnalyticsVideo'
  /** The course.nid referenced in this video */
  courseId?: Maybe<Scalars['ID']['output']>
  /** Auto generated field from sequelize */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** A flag indicating the video has been published */
  isPublished?: Maybe<Scalars['Boolean']['output']>
  /** The language of the video content */
  language: Scalars['String']['output']
  /** The media linked from this video analytics video */
  media?: Maybe<Media>
  /** The feature.nid referenced in this video */
  mediaId?: Maybe<Scalars['ID']['output']>
  /** The content ID of the next episode in the series */
  nextEpisodeContentId?: Maybe<Scalars['ID']['output']>
  /** The publication date of the next episode in the series */
  nextEpisodePublishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** Status of the next episode in the series */
  nextEpisodeStatus?: Maybe<Scalars['String']['output']>
  /** The preview.nid referenced in this video */
  previewId?: Maybe<Scalars['ID']['output']>
  /** The primary language of the video content */
  primaryLanguage: Scalars['String']['output']
  /** The publication date of the video */
  publishedAtDate?: Maybe<Scalars['DateTime']['output']>
  /** The rainbow category (name) this video belongs to */
  rainbowCategory?: Maybe<Scalars['String']['output']>
  /** The rainbow category (key) this video belongs to */
  rainbowKey?: Maybe<Scalars['Int']['output']>
  /** The series.nid referenced in this video */
  seriesId?: Maybe<Scalars['ID']['output']>
  /** The title for this video */
  title?: Maybe<Scalars['String']['output']>
  /** The array of topics this video belongs to */
  topics?: Maybe<Array<Maybe<VideoAnalyticsVideoTopics>>>
  /** The UBS segment (key) this video belongs to */
  ubsKey?: Maybe<Scalars['Int']['output']>
  /** The UBS segment (name) this video belongs to */
  ubsSegment?: Maybe<Scalars['String']['output']>
  /** Auto generated field from sequelize */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** VideoAnalyticsVideo creation date */
  videoCreated?: Maybe<Scalars['String']['output']>
  /** The video.nid */
  videoId: Scalars['ID']['output']
  /** Last update to the video */
  videoUpdated?: Maybe<Scalars['DateTime']['output']>
}

/** Video analytics video list response */
export type VideoAnalyticsVideoListResponse = {
  __typename?: 'VideoAnalyticsVideoListResponse'
  /** Total number of rows of content found (uses a slower count query for list) */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit applied to the rows */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset applied to the rows */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of videos */
  videoAnalyticsVideos?: Maybe<Array<Maybe<VideoAnalyticsVideo>>>
}

/** Video analytics video list where clause for the course id */
export type VideoAnalyticsVideoListWhereCourseIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video list where clause for the id */
export type VideoAnalyticsVideoListWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video list where clause */
export type VideoAnalyticsVideoListWhereInput = {
  /** Filter by course id */
  courseId?: InputMaybe<VideoAnalyticsVideoListWhereCourseIdInput>
  /** Filter by media id */
  mediaId?: InputMaybe<VideoAnalyticsVideoListWhereMediaIdInput>
  /** Filter by series id */
  seriesId?: InputMaybe<VideoAnalyticsVideoListWhereSeriesIdInput>
  /** Filter by video id */
  videoId?: InputMaybe<VideoAnalyticsVideoListWhereIdInput>
}

/** Video analytics video list where clause for the media id */
export type VideoAnalyticsVideoListWhereMediaIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video list where clause for the series id */
export type VideoAnalyticsVideoListWhereSeriesIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Video analytics video row topics */
export type VideoAnalyticsVideoTopics = {
  __typename?: 'VideoAnalyticsVideoTopics'
  /** The topic key (content id) */
  key?: Maybe<Scalars['Int']['output']>
  /** The topic title */
  title?: Maybe<Scalars['String']['output']>
}

/** Input payload for requesting a video auto summary. */
export type VideoAutoSummaryInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Language code for generated summary (en, es, de, fr). Defaults to en. */
  language?: Scalars['String']['input']
  /** Playback position in seconds; captions up to this timestamp are summarized. */
  pausedAtSeconds: Scalars['Float']['input']
}

/** Summary result for the watched portion of a video. */
export type VideoAutoSummaryPayload = {
  __typename?: 'VideoAutoSummaryPayload'
  /** Number of caption segments included in the summary. */
  captionCount: Scalars['Int']['output']
  /** Server timestamp when the summary was generated. */
  generatedAt: Scalars['DateTime']['output']
  /** Timestamp of the final caption considered (ISO or HH:MM:SS string). */
  lastCaptionTime?: Maybe<Scalars['String']['output']>
  /** LLM generated summary text. */
  summary: Scalars['String']['output']
}

/** A conceptually dense moment identified in a video. */
export type VideoConceptMoment = {
  __typename?: 'VideoConceptMoment'
  /** Short label describing the key concept in this moment. */
  conceptLabel: Scalars['String']['output']
  /** Normalized density score (0-1) indicating conceptual density. */
  densityScore: Scalars['Float']['output']
  /** End position in seconds. */
  endSeconds: Scalars['Float']['output']
  /** End timecode (HH:MM:SS) of the concept moment. */
  endTimecode: Scalars['String']['output']
  /** Start position in seconds. */
  startSeconds: Scalars['Float']['output']
  /** Start timecode (HH:MM:SS) of the concept moment. */
  startTimecode: Scalars['String']['output']
}

/** Input payload for requesting concept moment prompt suggestions. */
export type VideoConceptMomentPromptsInput = {
  /** The concept label from the moment (e.g. 'DNA Activation') — used to focus prompt generation. */
  conceptLabel: Scalars['String']['input']
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** End of the concept moment window in seconds (from videoConceptMoments response). */
  endSeconds: Scalars['Float']['input']
  /** Previously shown/clicked prompt texts to exclude from results. */
  excludePrompts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Language code for generated prompts (en, es, de, fr). Defaults to en. */
  language?: Scalars['String']['input']
  /** Start of the concept moment window in seconds (from videoConceptMoments response). */
  startSeconds: Scalars['Float']['input']
}

/** Result payload for concept moment prompt suggestions. */
export type VideoConceptMomentPromptsPayload = {
  __typename?: 'VideoConceptMomentPromptsPayload'
  /** The concept label these prompts were generated for. */
  conceptLabel: Scalars['String']['output']
  /** Server timestamp when prompts were generated. */
  generatedAt: Scalars['DateTime']['output']
  /** List of suggested prompts scoped to this concept moment. */
  prompts: Array<VideoPromptSuggestion>
}

/** Input payload for requesting a concept moment summary. */
export type VideoConceptMomentSummaryInput = {
  /** Concept label from the moment (used to focus the summary). */
  conceptLabel: Scalars['String']['input']
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** End of the dense section in seconds (from videoConceptMoments response). */
  endSeconds: Scalars['Float']['input']
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Language code for the generated summary (en, es, de, fr). Defaults to en. */
  language?: Scalars['String']['input']
  /** Start of the dense section in seconds (from videoConceptMoments response). */
  startSeconds: Scalars['Float']['input']
}

/** Summary of a specific concept moment in a video. */
export type VideoConceptMomentSummaryPayload = {
  __typename?: 'VideoConceptMomentSummaryPayload'
  /** Number of transcript segments included in the summary. */
  captionCount: Scalars['Int']['output']
  /** The concept label that was summarized. */
  conceptLabel: Scalars['String']['output']
  /** End timecode (HH:MM:SS) of the summarized section. */
  endTimecode: Scalars['String']['output']
  /** Server timestamp when the summary was generated. */
  generatedAt: Scalars['DateTime']['output']
  /** Start timecode (HH:MM:SS) of the summarized section. */
  startTimecode: Scalars['String']['output']
  /** LLM-generated summary of the concept moment. */
  summary: Scalars['String']['output']
}

/** Input payload for requesting video concept moments. */
export type VideoConceptMomentsInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Language code for generated concept labels (en, es, de, fr). Defaults to en. */
  language?: Scalars['String']['input']
  /** Maximum number of concept moments to return. Set to 0 to auto-compute from video duration. */
  maxMoments?: Scalars['Int']['input']
}

/** Result payload for video concept moments analysis. */
export type VideoConceptMomentsPayload = {
  __typename?: 'VideoConceptMomentsPayload'
  /** Whether the result was served from cache. */
  fromCache: Scalars['Boolean']['output']
  /** Server timestamp when the moments were generated or retrieved from cache. */
  generatedAt: Scalars['DateTime']['output']
  /** List of identified concept moments, ordered by timecode. */
  moments: Array<VideoConceptMoment>
  /** Status indicating why no moments were returned. Null when moments are present. Values: NO_TRANSCRIPT, INSUFFICIENT_SPEECH, NO_DENSE_MOMENTS. */
  status?: Maybe<Scalars['String']['output']>
  /** Estimated video duration in seconds based on last chunk timecode, or null if unavailable. */
  videoDurationEstimate?: Maybe<Scalars['Float']['output']>
}

/** Single prompt suggestion with metadata. */
export type VideoPromptSuggestion = {
  __typename?: 'VideoPromptSuggestion'
  /** The focus area or topic of the suggestion. */
  focus: Scalars['String']['output']
  /** The suggested prompt/question text. */
  prompt: Scalars['String']['output']
  /** Explanation of why this suggestion was made. */
  rationale: Scalars['String']['output']
}

/** Input payload for requesting video prompt suggestions. */
export type VideoPromptSuggestionsInput = {
  /** Oracle content identifier. */
  contentId: Scalars['String']['input']
  /** Playback position in seconds; captions up to this timestamp are considered. */
  currentTimeSeconds: Scalars['Float']['input']
  /** Optional list of prompt texts to exclude from results (e.g., previously shown prompts). */
  excludePrompts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Feature media identifier. */
  featureMediaId: Scalars['String']['input']
  /** Language code for generated prompts (en, es, de, fr). Defaults to en. */
  language?: Scalars['String']['input']
}

/** Result payload for video prompt suggestions. */
export type VideoPromptSuggestionsPayload = {
  __typename?: 'VideoPromptSuggestionsPayload'
  /** Number of chunk segments actually included in the context excerpt. */
  contextChunksUsed: Scalars['Int']['output']
  /** End timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageEndTimecode?: Maybe<Scalars['String']['output']>
  /** Start timecode (HH:MM:SS) of the context coverage, or null if unavailable. */
  coverageStartTimecode?: Maybe<Scalars['String']['output']>
  /** Server timestamp when the suggestions were generated. */
  generatedAt: Scalars['DateTime']['output']
  /** List of suggested prompts/questions. */
  suggestions: Array<VideoPromptSuggestion>
  /** Total number of chunk segments considered from the database. */
  totalChunksConsidered: Scalars['Int']['output']
}

export type ViewerGeoLocation = {
  __typename?: 'ViewerGeoLocation'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode: Scalars['String']['output']
  formattedLocation?: Maybe<Scalars['String']['output']>
  region?: Maybe<Scalars['String']['output']>
}

/** Content analytic */
export type Vote = {
  __typename?: 'Vote'
  /** The content linked to this vote */
  content?: Maybe<Array<Maybe<Content>>>
  /** The id of the content */
  contentId?: Maybe<Scalars['Int']['output']>
  /** The content type for the content id */
  contentType?: Maybe<Scalars['String']['output']>
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id?: Maybe<Scalars['ID']['output']>
  /** The id of the user */
  uid?: Maybe<Scalars['Int']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** The user info linked to this vote */
  userInfo?: Maybe<UserInfo>
  /** The vote direction */
  voteDirection?: Maybe<VoteDirection>
}

/** Content analytic */
export type VoteContentArgs = {
  content?: InputMaybe<Array<InputMaybe<ContentFilterInput>>>
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum VoteDirection {
  /** This is a down vote */
  Down = 'DOWN',
  /** This is a love vote */
  Love = 'LOVE',
  /** This is an up vote */
  Up = 'UP',
}

/** Content analytic where id input type */
export type VoteWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content analytic where conditions to filter rows */
export type VoteWhereInput = {
  /** The id field where clause */
  id?: InputMaybe<VoteWhereIdInput>
  /** The id field where clause */
  uid?: InputMaybe<VoteWhereUidInput>
}

/** Content analytic where uid input type */
export type VoteWhereUidInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Content analytic list response */
export type VotesListResponse = {
  __typename?: 'VotesListResponse'
  /** The total number of votes matching the query */
  count?: Maybe<Scalars['Int']['output']>
  /** The limit used in the query */
  limit?: Maybe<Scalars['Int']['output']>
  /** The offset used in the query */
  offset?: Maybe<Scalars['Int']['output']>
  /** A list of Content analytic */
  votes?: Maybe<Array<Maybe<Vote>>>
}

/** Response for watch history bulk export */
export type WatchHistoryBulkResponse = {
  __typename?: 'WatchHistoryBulkResponse'
  /** List of watch history rows */
  rows: Array<WatchHistoryBulkRow>
}

/** Watch history row for graph bulk export — flat, no nested joins */
export type WatchHistoryBulkRow = {
  __typename?: 'WatchHistoryBulkRow'
  /** Media duration in seconds */
  duration?: Maybe<Scalars['Int']['output']>
  /** Unix timestamp of most recent play */
  lastPlayed?: Maybe<Scalars['BigInt']['output']>
  /** Media ID (VA-level identifier) */
  mediaId: Scalars['ID']['output']
  /** Resume position in seconds */
  position?: Maybe<Scalars['BigInt']['output']>
  /** Series ID if part of a series */
  seriesId?: Maybe<Scalars['Int']['output']>
  /** User UID */
  uid: Scalars['ID']['output']
  /** Content video ID (Brooklyn content_id) */
  videoId?: Maybe<Scalars['Int']['output']>
  /** Number of times watched */
  watchedCount?: Maybe<Scalars['Int']['output']>
  /** Total seconds watched across all views */
  watchedSum?: Maybe<Scalars['BigInt']['output']>
}

/** Filter for watch history completion status */
export enum WatchHistoryFilter {
  /** All watch history */
  All = 'ALL',
  /** Only completed videos (watched_sum/duration >= 80%) */
  Completed = 'COMPLETED',
  /** Only in-progress videos (watched_sum/duration < 80%) */
  InProgress = 'IN_PROGRESS',
}

/** Worker */
export type Worker = {
  __typename?: 'Worker'
  /** The date the row was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Additional data the the worker would need to maintain proper state */
  data?: Maybe<Scalars['JSON']['output']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** When the worker last stopped or went idle */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The primary identifier for this record */
  id: Scalars['ID']['output']
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: Maybe<Scalars['String']['output']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: Maybe<Scalars['DateTime']['output']>
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: Maybe<Scalars['String']['output']>
  /** The human readable name of the worker */
  name: Scalars['String']['output']
  /** The run state of the worker */
  runState?: Maybe<WorkerState>
  /** When the woker last started */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** The date the row was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/** Worker create input */
export type WorkerCreateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']['input']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: InputMaybe<Scalars['String']['input']>
  /** The worker name */
  name: Scalars['String']['input']
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Worker delete input */
export type WorkerDeleteInput = {
  /** The worker id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The worker name */
  name?: InputMaybe<Scalars['String']['input']>
}

/** Worker response */
export type WorkerListResponse = {
  __typename?: 'WorkerListResponse'
  /** A list of workers */
  workers?: Maybe<Array<Maybe<Worker>>>
}

/** Worker mutation response */
export type WorkerMutationResponse = {
  __typename?: 'WorkerMutationResponse'
  /** When true mutation was successful */
  success?: Maybe<Scalars['Boolean']['output']>
  /** The worker which was mutated */
  worker?: Maybe<Worker>
}

export enum WorkerState {
  /** The worker is idle */
  Idle = 'IDLE',
  /** The worker is running */
  Running = 'RUNNING',
  /** The worker is stopped */
  Stopped = 'STOPPED',
}

/** Worker update input */
export type WorkerUpdateInput = {
  /** Additional data the the worker would need to maintain proper state */
  data?: InputMaybe<Scalars['JSON']['input']>
  /** When true the worker is allowed to run when false it shoudl not do any work */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When the worker last stopped or went idle */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** The primary identifier for this record */
  id?: InputMaybe<Scalars['ID']['input']>
  /** The last value processed by this worker, an example could be an db offset or id for the last row processed */
  lastProcessedValue?: InputMaybe<Scalars['String']['input']>
  /** When the worker lock expires or null if there is no lock */
  lockExpiresDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Identifier of the process holding the lock (e.g. pod name) */
  lockHolder?: InputMaybe<Scalars['String']['input']>
  /** The worker name */
  name?: InputMaybe<Scalars['String']['input']>
  /** The run state of the worker */
  runState?: InputMaybe<WorkerState>
  /** When the woker last started */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** The where clause for a worker id field */
export type WorkerWhereIdInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than to the field */
  gt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value greater than or equal to the field */
  gte?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** Is the value less than to the field */
  lt?: InputMaybe<Scalars['ID']['input']>
  /** Is the value less than or equal to the field */
  lte?: InputMaybe<Scalars['ID']['input']>
}

/** Worker where input */
export type WorkerWhereInput = {
  /** Worker where id clause */
  id?: InputMaybe<WorkerWhereIdInput>
  /** Worker where name clause */
  name?: InputMaybe<WorkerWhereNameInput>
}

/** The where clause for a worker name field */
export type WorkerWhereNameInput = {
  /** Is the value equal to the field */
  eq?: InputMaybe<Scalars['ID']['input']>
  /** Are the values in the field */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type CreateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId: Scalars['Int']['input']
  /** The name of the billing Product */
  name: Scalars['String']['input']
  /** The name of the billing product platform */
  platform: ProductPlatform
}

export type CreateBillingProviderInput = {
  /** The name of the billing provider */
  name: BillingProviderName
  /** Whether the billing provider has subscription management */
  subscriptionManagement: Scalars['Boolean']['input']
}

/** Repsonse when creating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityCreateResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityCreateResponse'
  /** The ecommerce sku mapping bonus eligibility that was created */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Repsonse when deleting an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityDeleteByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityDeleteByIdResponse'
  /** The ecommerce sku mapping bonus eligibility that was deleted */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Repsonse when updating an ecommerce sku mapping bonus eligibility item */
export type EcommerceSkuMappingBonusEligibilityUpdateByIdResponse = {
  __typename?: 'ecommerceSkuMappingBonusEligibilityUpdateByIdResponse'
  /** The ecommerce sku mapping bonus eligibility that was updated */
  ecommerceSkuMappingBonusEligibility?: Maybe<EcommerceSkuMappingBonusEligibility>
}

/** Response when creating an ecommerce sku mapping */
export type EcommerceSkuMappingCreateResponse = {
  __typename?: 'ecommerceSkuMappingCreateResponse'
  /** The ecommerce sku mapping that was created */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
}

/** Response when updating an ecommerce sku mapping */
export type EcommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse = {
  __typename?: 'ecommerceSkuMappingUpdateByProviderAndEcommerceSkuResponse'
  /** The ecommerce sku mapping that was updated */
  ecommerceSkuMapping?: Maybe<EcommerceSkuMapping>
}

export type UpdateBillingProductInput = {
  /** The content set id of the billing product */
  contentSetId?: InputMaybe<Scalars['Int']['input']>
  /** The id of the billing product */
  id: Scalars['ID']['input']
  /** The name of the billing Product */
  name?: InputMaybe<Scalars['String']['input']>
  /** The name of the billing product platform */
  platform?: InputMaybe<ProductPlatform>
}

export type UpdateBillingProviderInput = {
  /** The id of the billing provider */
  id: Scalars['ID']['input']
  /** The name of the billing provider */
  name?: InputMaybe<BillingProviderName>
  /** Whether the billing provider has subscription management */
  subscriptionManagement?: InputMaybe<Scalars['Boolean']['input']>
}
